{
  "supportSession": {
    "banner": {
      "text": "You are browsing as support for {workspace} — ends in {minutes} min",
      "expired": "The support session has ended",
      "end": "End session"
    },
    "admin": {
      "open": "Open as support",
      "title": "Open workspace as support",
      "hint": "A reason is required and is recorded. The session lasts 30 minutes and every change is audited.",
      "reason": "Reason (at least 10 characters)",
      "start": "Start",
      "error": "Could not start the support session"
    }
  },
  "announcements": {
    "dismiss": "Dismiss"
  },
  "common": {
    "sampleValues": "Sample values",
    "switchLanguage": "العربية",
    "cancel": "Cancel",
    "save": "Save"
  },
  "ui": {
    "button": {
      "loading": "Loading…"
    },
    "input": {
      "showPassword": "Show password",
      "hidePassword": "Hide password"
    },
    "modal": {
      "close": "Close dialog"
    },
    "table": {
      "empty": "Nothing to show yet",
      "actions": "Actions",
      "count": "{count, plural, one {# row} other {# rows}}",
      "range": "{from}–{to} of {total}",
      "prev": "Previous",
      "next": "Next"
    },
    "toast": {
      "region": "Notifications",
      "dismiss": "Dismiss notification",
      "dismissAll": "Dismiss all"
    },
    "async": {
      "loading": "Loading…",
      "errorTitle": "This part did not load",
      "errorBody": "Check your connection and try again. If it keeps happening, send the reference below to support.",
      "reference": "Reference: {id}",
      "retry": "Try again"
    },
    "help": {
      "label": "Help"
    },
    "filter": {
      "label": "Filter",
      "clearAll": "Clear all",
      "remove": "Remove {label}"
    },
    "menu": {
      "more": "More"
    },
    "banner": {
      "dismiss": "Dismiss"
    }
  },
  "dashboard": {
    "b29b": {
      "auth": {
        "brand": "Wato"
      },
      "legal": {
        "agree": "By creating an account you agree to the {terms} and {privacy}.",
        "privacy": "Privacy Policy",
        "terms": "Terms"
      },
      "assistant": {
        "tabs": "Assistant sections",
        "chat": "Chat",
        "summaries": "Summaries",
        "questions": "Questions",
        "proposals": "Suggestions"
      },
      "home": {
        "reports": "Reports"
      }
    },
    "catalogConnect": {
      "oneClick": {
        "noProducts": "No products yet — add them from the Products tab.",
        "title": "Create and connect your catalog automatically",
        "lead": "One click: we create a catalog in your Meta account, link it to your number, turn on the shop icon and cart, and send your products.",
        "cta": "Auto-connect",
        "running": "Connecting your catalog...",
        "done": "Your catalog is connected.",
        "doneReused": "Your existing catalog was reused and connected.",
        "orPick": "I already have a catalog",
        "pickLead": "Pick the catalog to connect to this number.",
        "pickLoading": "Looking for your catalogs...",
        "pickEmpty": "No catalogs were found for this account.",
        "pickLabel": "Your catalogs",
        "pickCta": "Connect catalog",
        "advanced": "Advanced method",
        "permissionTitle": "The number needs the catalog permission",
        "permissionBody": "Reconnect the number and grant the catalog management permission so we can create and link the catalog for you.",
        "reconnectCta": "Reconnect the number",
        "noBusiness": "We could not find the Meta business that owns this number. Reconnect the number and select your business."
      },
      "title": "Connect your Meta catalog",
      "lead": "Five short steps, done once. Each step shows what is finished and what is still missing.",
      "progress": "{done} of {total} steps complete",
      "stepLabel": "Step {step}",
      "status": {
        "done": "Done",
        "todo": "To do",
        "blocked": "Blocked"
      },
      "blocked": {
        "after": "Finish step {step} first.",
        "intro": "You cannot finish the connection from here yet."
      },
      "cta": {
        "channels": "Open channels",
        "billing": "View plans",
        "connectChannel": "Connect a number",
        "checkAgain": "Check again",
        "retry": "Try again"
      },
      "channel": {
        "title": "The official WhatsApp channel is connected",
        "why": "Catalogs only work on an official WhatsApp Business number, not on a number linked by scanning a code.",
        "done": "Connected number: {name}",
        "todo": "No official WhatsApp number is connected yet."
      },
      "metaCatalog": {
        "title": "The catalog exists in your Meta Business account",
        "why": "Your products live in a catalog in Meta Commerce Manager. Create it there, then let Wato manage it.",
        "how1": "Open Commerce Manager in your Meta Business account and create a catalog.",
        "how2": "Reconnect your number and tick the catalog permission when Meta asks.",
        "how3": "Or generate an access token with the catalog permission in Meta and give it to us.",
        "found": "Catalogs found in your Meta account: {count}",
        "none": "No catalog was found in your Meta account yet.",
        "checking": "Checking your Meta account…"
      },
      "choose": {
        "title": "Choose the catalog",
        "why": "Pick the catalog this number shows to customers. One catalog per number.",
        "channelLabel": "Number to connect",
        "catalogLabel": "Catalog to connect",
        "loading": "Loading the catalogs from your Meta account…",
        "empty": "There is no catalog to choose from yet. Create one in Commerce Manager (step 2), then check again.",
        "selected": "Selected catalog: {name}",
        "alreadyLinked": "This number is already linked to: {name}",
        "noFreeNumber": "Every connected number already has a catalog."
      },
      "link": {
        "title": "Link the catalog and sync your products",
        "why": "Linking connects the catalog to your number. Then pick a product source and sync.",
        "cta": "Link now",
        "done": "Linked: {name}",
        "source": "Products come from: {mode}",
        "syncCta": "Sync products",
        "syncDone": "Sync finished: {count} products sent to Meta.",
        "syncFailed": "The sync did not finish. Open the product list below to see why.",
        "syncStarted": "The sync started. Follow its progress in the product list below.",
        "elsewhere": "Choose the product source and add your products in the catalog card below.",
        "currency": "Confirm the currency notice below to finish linking."
      },
      "customers": {
        "title": "Send your products in the chat",
        "why": "Once linked, customers open your shop from the chat and you can send a product or the full list.",
        "done": "The shop icon is showing in the chat header. You can send products from chat flows and the inbox.",
        "todo": "The shop icon is hidden in the chat header, so customers cannot open your catalog yet.",
        "cta": "Shop icon"
      },
      "preview": {
        "businessName": "Your shop",
        "caption": "Illustrative example: a product message with a button that opens your catalog.",
        "customer": "Do you have the black abaya?",
        "product": "Yes! Black abaya, 250 SAR. Tap below to see more.",
        "button1": "View catalog",
        "button2": "Add to cart"
      },
      "intro": {
        "title": "How the Meta catalog works",
        "what": "A Meta catalog is your product list, kept with Meta. Your products show up inside WhatsApp, so customers can browse and order without leaving the chat.",
        "when": "Use it when you sell products and want customers to see photos and prices right in the conversation.",
        "step1": "Connect your official WhatsApp number.",
        "step2": "Create a catalog in Meta Commerce Manager and pick it here.",
        "step3": "Link it, sync your products, then send them in the chat."
      }
    },
    "orderNotifications": {
      "intro": {
        "what": "An automatic WhatsApp message sent to your customer each time their order changes status, for example “Your order has shipped”. It needs a connected store.",
        "when": "Use it so customers see where their order is without having to ask you.",
        "step1": "Connect your store, so every new order and status change reaches Wato.",
        "step2": "Turn on the statuses you want and write each message, or use the suggested text. The order number fills in by itself.",
        "step3": "Choose an approved message template so the message still arrives after 24 hours without a reply from the customer, then save."
      },
      "strip": {
        "title": "What happens now?",
        "storeLabel": "Store",
        "storeLoading": "Checking your store connection…",
        "storeConnected": "Connected: {name}",
        "storeNone": "No store is connected yet.",
        "storeUnknown": "A connected store tells Wato when an order changes status. Open the store connections page to see whether yours is connected.",
        "storeManage": "Store connections",
        "statusesLabel": "Statuses turned on",
        "statusesCount": "{value} of {total}",
        "statusesNone": "None yet, so customers get no automatic message.",
        "reachLabel": "Customers who have not written for 24 hours",
        "reachAll": "They still get the message: every turned-on status has a template.",
        "reachMissing": "They will not get these statuses, which have no template: {value}."
      },
      "blocked": {
        "title": "Connect a store to start",
        "reason": "Order notifications are triggered by your store: when an order is confirmed or shipped, Wato messages the customer. Until a store is connected nothing can trigger them, so the settings below are shown for preview only.",
        "cta": "Connect a store"
      },
      "cards": {
        "title": "Messages by order status",
        "lead": "Each card below is one moment in an order. Turn it on, write what the customer should read, and check the preview next to it."
      },
      "card": {
        "whenLabel": "When is it sent?",
        "enable": "Send this message",
        "message": "Message to the customer",
        "useSuggested": "Use suggested text",
        "noContent": "This status is on but has no message and no template, so nothing will be sent."
      },
      "when": {
        "confirmed": "When the order is confirmed.",
        "processing": "When you start preparing the order.",
        "shipped": "When the order is shipped and on its way.",
        "delivered": "When the order is delivered.",
        "cancelled": "When the order is cancelled.",
        "refunded": "When the order is refunded.",
        "cod_confirmation": "Right after a cash-on-delivery order, to ask the customer to confirm it."
      },
      "suggested": {
        "confirmed": "Thank you! Your order [reference] is confirmed and we are preparing it.",
        "processing": "Your order [reference] is being prepared. We will let you know when it ships.",
        "shipped": "Good news: your order [reference] has shipped and is on its way.",
        "delivered": "Your order [reference] was delivered. We hope you enjoy it!",
        "cancelled": "Your order [reference] has been cancelled. Write to us if you need any help.",
        "refunded": "Your order [reference] has been refunded. The money may take a few days to reach you.",
        "cod_confirmation": "Hello! To prepare your order [reference], please confirm that you want it with cash on delivery."
      },
      "variables": {
        "title": "Add details that fill in automatically",
        "hint": "Tap one to insert it where your cursor is. When the message is sent, it is replaced with the real order data.",
        "reference": {
          "label": "Order number",
          "hint": "The order number, for example 1001."
        },
        "status": {
          "label": "Order status",
          "hint": "The order status as a readable word in the customer's language, for example shipped."
        },
        "customerName": {
          "label": "Customer name",
          "hint": "The customer's name; a friendly word is used when we do not have it."
        },
        "trackingUrl": {
          "label": "Tracking link",
          "hint": "Filled in only when the carrier provides tracking; otherwise it stays empty."
        }
      },
      "picker": {
        "label": "Message template (for customers outside the 24-hour window)",
        "none": "None — send plain text",
        "savedUnknown": "Saved template (not in the list)",
        "why": "Why a template? WhatsApp allows plain text only within 24 hours of the customer last writing to you. After that, Wato can send this order message only if an approved template is selected here (it receives the order number as '{{'1'}}'). With no template the message is skipped.",
        "hintNone": "Without a template, only customers who wrote to you in the last 24 hours get this message.",
        "hintTemplate": "Customers who wrote in the last 24 hours get your text; everyone else gets the template.",
        "notApproved": "The saved template is not approved any more, so WhatsApp may refuse to deliver it. Choose another one.",
        "loadFailed": "Your templates could not be loaded. The saved choice is kept.",
        "noApproved": "You have no approved templates yet. Create one, wait for WhatsApp to approve it, then choose it here.",
        "manage": "Manage message templates",
        "loading": "Loading your templates…"
      },
      "preview": {
        "businessName": "Your store",
        "captionText": "Illustrative example with sample order {value}: what a customer inside the 24-hour window receives.",
        "captionTemplate": "Illustrative example with sample order {value}: the selected template is what the customer receives.",
        "empty": "Your message appears here as you type."
      }
    },
    "formsRedesign": {
      "subtitle": "A form is a short questionnaire the customer fills in inside WhatsApp itself, so you receive their details neatly organised instead of scattered messages.",
      "intro": {
        "what": "A questionnaire filled in inside WhatsApp itself, such as a delivery address, a booking or a rating. The customer opens it from a button in the conversation and fills it in, and you receive the details organised.",
        "when": "Use it when you need several pieces of information from the customer at once, instead of asking one question after another in messages.",
        "step1": "Pick a ready-made form below or start with a blank one, then edit its questions.",
        "step2": "Publish the form: it does not work for customers before it is published.",
        "step3": "Add it to a chat flow with the \"WhatsApp form\" node so the customer gets a button that opens it, and find the answers under the \"Responses\" button next to the form.",
        "button": "Fill in the form",
        "journeyCaption": "The customer taps \"Fill in the form\", the questionnaire opens inside WhatsApp, and after sending they get a confirmation message.",
        "screenLabel": "The questionnaire that opens for the customer",
        "mock": {
          "title": "Book an appointment",
          "field1": "Full name",
          "value1": "Sara",
          "field2": "Service",
          "value2": "Consultation",
          "field3": "Appointment",
          "value3": "Sunday evening",
          "submit": "Send"
        }
      },
      "channel": {
        "title": "Before you start",
        "official": "Forms run only on the official WhatsApp channel (the WhatsApp Cloud API). WhatsApp channels linked by scanning a code from the phone do not run forms.",
        "publish": "A form needs to be published before it works: while it is a \"Draft\", customers cannot see it.",
        "bindSelectLabel": "Form channel",
        "bindSelectHint": "The form is sent and published through this channel. Only official WhatsApp (Cloud API) channels appear here.",
        "bindSelectPlaceholder": "Choose a channel",
        "bindSelectNone": "No channel",
        "bindSaved": "The form's channel was saved.",
        "bindBlockedTitle": "Connect an official WhatsApp channel first",
        "bindBlockedBody": "Forms cannot be published without an official WhatsApp (Cloud API) channel. Channels linked by scanning a code do not run forms.",
        "bindBlockedCta": "Go to channels",
        "bindNotBound": "This form is not linked to a WhatsApp channel yet, so it cannot be published. Choose a channel in the form settings, then publish again.",
        "bindNotBoundCta": "Settings",
        "bindNotBoundNoChannelCta": "Connect a channel",
        "bindPickerLabel": "Link this form to an official channel",
        "bindPickerConfirm": "Link and publish"
      },
      "starters": {
        "listLabel": "Ready-made forms",
        "useNamed": "Use this form: {value}",
        "created": "The form was created as a draft. Open it to edit its questions, then publish it.",
        "purposeGeneric": "A ready-made form whose questions you can edit.",
        "purpose": {
          "lead_form": "Collects the details of someone interested in your services: name, phone, email and what they are after.",
          "booking": "The customer books an appointment: enters their details and picks the service, date and time slot.",
          "delivery_address": "The customer writes the delivery address: recipient name, area, street and notes.",
          "feedback_csat": "The customer rates their experience from excellent to very poor and explains what went wrong.",
          "return_request": "The customer asks to return an item: order number, reason and photos of the item.",
          "warranty_registration": "The customer registers a product warranty: product name, serial number and purchase date.",
          "return_exchange": "The customer chooses a return or an exchange, gives the reason and attaches photos of the item.",
          "kyc_documents": "The customer sends their details and a photo of their ID or commercial registration, with their consent.",
          "quote_request": "The customer asks for a price quote: what they need and the quantity, with spec files and photos.",
          "product_order": "The customer picks catalog products and quantities, chooses delivery or pickup and confirms the order in the chat.",
          "event_registration": "People register for an event, workshop or course: attendee details, which session, how many seats.",
          "job_application": "Applicants send their details, the role they want, experience and a CV, ready for you to review.",
          "trip_booking": "The customer books a trip: destination, date and number of travellers, and you review the request."
        }
      },
      "list": {
        "title": "Your forms",
        "lastEdited": "Last edited: {value}",
        "draftHint": "Draft: customers cannot see it until you publish it."
      },
      "empty": {
        "title": "You have not created any form yet",
        "what": "A form is a questionnaire the customer fills in inside WhatsApp, and the answers reach you organised in one place.",
        "step1": "Pick a ready-made form such as a delivery address, booking or rating, or start with a blank one.",
        "step2": "Edit the questions as you like, then publish the form.",
        "step3": "Add it to a chat flow with the \"WhatsApp form\" node, and follow the answers from this page.",
        "cta": "Start with a form"
      }
    },
    "loyalty": {
      "b29b": {
        "emptyLine": "Find a customer to see their points and redeem or adjust them.",
        "pointsIssued": "Points given",
        "rewardsPaid": "Rewards paid",
        "contestPlaceholder": "Choose a contest"
      },
      "nav": "Loyalty & rewards",
      "title": "Loyalty & rewards",
      "subtitle": "Points grow with each purchase. Check a balance, reward, or run a draw.",
      "intro": {
        "title": "How loyalty works",
        "what": "Each purchase earns points to spend on a reward, such as a discount code. You can adjust points and run a draw.",
        "when": "Use it to bring customers back: reward repeat buyers, thank someone who recommended a friend, or run a prize draw.",
        "step1": "Search for a customer and open their points.",
        "step2": "Redeem a reward for them, or add or remove points with a reason.",
        "step3": "Share their referral link, or run a draw when a contest has ended.",
        "businessName": "Your store",
        "caption": "Example: a customer asks for their points and gets a reward code.",
        "msg1": "How many points do I have?",
        "msg2": "You have 120 points. A 15 SAR discount costs 100 points.",
        "msg3": "Your code is LOY-7F3A. Use it on your next order.",
        "msg3Button": "Use the code"
      },
      "find": {
        "label": "Find a customer",
        "hint": "Type a name or phone number.",
        "button": "Search",
        "noResults": "No customer matches this search.",
        "unnamed": "Customer without a name",
        "choose": "Open"
      },
      "empty": {
        "title": "Pick a customer to start",
        "what": "Search for a customer to see their points.",
        "step1": "Search by name or phone number.",
        "step2": "Open the customer to see their points.",
        "step3": "Redeem a reward, adjust points or create their referral link."
      },
      "wallet": {
        "title": "Points of {name}",
        "explainer": "Points are earned from purchases. They are not money: a reward turns points into a discount code.",
        "balance": "{points} points",
        "refresh": "Refresh"
      },
      "redeem": {
        "title": "Redeem a reward",
        "explainer": "Spend the customer's points on one of your rewards. They receive a discount code. This takes the points off their balance.",
        "rewardLabel": "Reward code",
        "rewardHint": "The reward id you set in your loyalty settings.",
        "button": "Redeem",
        "success": "Done. Code {code} gives a discount of {amount}. The customer now has {points} points."
      },
      "adjust": {
        "title": "Add or remove points",
        "explainer": "Use this to fix a mistake or say thank you. Every change needs a reason and is saved in the history of the wallet.",
        "amountLabel": "Points",
        "amountHint": "A positive number adds points, a negative number removes them.",
        "reasonLabel": "Reason",
        "button": "Save change",
        "success": "Saved. The customer now has {points} points."
      },
      "referral": {
        "title": "Referral link",
        "explainer": "A friend who orders through this customer's link earns them points. Each customer keeps the same link.",
        "button": "Create the link",
        "codeLabel": "Referral code",
        "copy": "Copy code",
        "copied": "Copied"
      },
      "draw": {
        "title": "Prize draw",
        "explainer": "Pick the winners of a contest after its entry period has ended. The result is final and recorded, so check the number of entrants first.",
        "contestLabel": "Contest",
        "contestHint": "Pick the contest to draw from.",
        "entrantsLabel": "Number of entrants",
        "entrantsHint": "Enter the entrant count to avoid an accidental draw.",
        "warning": "A draw cannot be repeated.",
        "button": "Run the draw",
        "success": "Draw complete. {count, plural, =0 {No winners} one {# winner} other {# winners}}."
      },
      "activity": {
        "title": "Done in this session",
        "explainer": "Your recent actions on this page. Reload the page and this list starts again; the points themselves are always saved.",
        "empty": "Nothing yet. Redeem, adjust or draw and it will show here.",
        "redeem": "Reward redeemed for {name}: code {code}",
        "adjust": "Points changed for {name}: {amount}",
        "referral": "Referral link created for {name}",
        "draw": "Draw run for contest {contest}"
      },
      "errors": {
        "REWARD_NOT_FOUND": "This reward does not exist. Check the reward code.",
        "INSUFFICIENT_BALANCE": "The customer does not have enough points for this reward.",
        "STALE_BALANCE": "Their points changed. The balance has been refreshed, please try again.",
        "REASON_REQUIRED": "Write a reason for the change.",
        "INVALID_AMOUNT": "Enter a whole number of points other than zero.",
        "INVALID_INPUT": "Some of the details are missing or not valid.",
        "DRAW_CONFIRMATION_MISMATCH": "The number you typed does not match the entrants. Check it and try again.",
        "ALREADY_DRAWN": "This contest was already drawn. A draw cannot be repeated.",
        "CONTEST_NOT_FOUND": "This contest does not exist. Check the contest id.",
        "CONTEST_CLOSED": "The entry period of this contest is still open. Draw after it ends.",
        "NO_ENTRANTS": "Nobody entered this contest, so there is nobody to draw.",
        "REFERRAL_CODE_NOT_FOUND": "This referral code was not found."
      },
      "blocked": {
        "noAccess": {
          "title": "You cannot use loyalty yet",
          "reason": "Your role does not allow changing loyalty points. Ask the workspace owner to give you edit access.",
          "cta": "See team roles"
        },
        "contests": {
          "title": "Prize draws are not available",
          "reason": "Contests are switched off for this workspace, or are waiting for a review. Prize draws stay locked until that is done.",
          "cta": "Open workspace settings"
        }
      }
    },
    "sequencesRedesign": {
      "subtitle": "A sequence is a set of messages sent automatically over several days after an event, such as a purchase. For example: day 0 a welcome, day 2 a reminder, day 7 an offer.",
      "newSequence": "New sequence",
      "pickPrompt": "Select a sequence on the list to edit its messages, see how your contact will receive them and check the results.",
      "list": {
        "label": "Your sequences",
        "enrolled": "Enrolled",
        "active": "Active",
        "completed": "Completed",
        "exited": "Exited",
        "sent": "Sent",
        "steps": "{count, plural, =0 {No messages yet} one {# message} other {# messages}}"
      },
      "empty": {
        "title": "Send messages automatically over several days",
        "what": "A sequence is a set of messages that go out on their own after an event, such as a purchase. For example: day 0 a welcome, day 2 a reminder, day 7 an offer.",
        "step1": "Create a sequence and give it a name.",
        "step2": "Write each message and choose how many days to wait before it is sent.",
        "step3": "Mark it ready. Contacts who join it, for example from a chat flow, start receiving the messages."
      },
      "modal": {
        "title": "New sequence",
        "description": "Name it now. You will write the messages in the next step.",
        "channelLabel": "Send from",
        "channelOption": "{name} ({kind})",
        "kindQr": "WhatsApp QR",
        "kindCloud": "Official WhatsApp (Cloud API)",
        "reEnrollLabel": "If the same contact joins again",
        "reEnroll": {
          "never": "Do not start it again",
          "after_completion": "Start again only after they finished it",
          "always": "Start again every time they join"
        },
        "exitHint": "Later you can choose when a contact leaves the sequence, for example when they reply.",
        "creating": "Creating…",
        "cancel": "Cancel"
      },
      "detail": {
        "tabsLabel": "Sequence sections",
        "tabSteps": "Steps",
        "tabExit": "Exit conditions",
        "tabResults": "Results",
        "pause": "Pause",
        "resume": "Resume",
        "savedNote": "Saved.",
        "readyNote": "Ready. Contacts who join now receive these messages.",
        "pausedNote": "Paused. No messages go out until you resume.",
        "createTemplateCta": "Create an approved template",
        "noApprovedTemplates": "This official WhatsApp channel has no approved template yet. Every step needs one as its fallback when the 24-hour window is closed.",
        "notReady": {
          "NO_STEPS": "Add at least one step before marking the sequence ready.",
          "EMPTY_CONTENT": "A step has no content. Write the message or attach media, then save.",
          "NO_TEMPLATE_FALLBACK": "The official WhatsApp channel needs an approved fallback template on every step, used when the 24-hour window is closed. Pick a fallback template on the flagged step.",
          "TEMPLATE_NOT_APPROVED": "A step's fallback template is not approved by WhatsApp yet. Wait for approval or choose an approved template.",
          "IMPORT_NEEDS_REVIEW": "An imported step needs your review first. Check the flagged step, then save.",
          "QR_UNSUPPORTED_STEP": "QR channels support text and media steps only. Change the flagged step's type.",
          "generic": "The sequence is not ready yet. Review the flagged steps and try again."
        },
        "statusHint": {
          "draft": "Not sending yet. Press “Mark ready” when your messages are written.",
          "ready": "Sending: contacts who join receive these messages.",
          "paused": "Paused: no messages are sent until you resume.",
          "archived": "Archived: this sequence no longer sends."
        },
        "exitIntro": "A contact leaves the sequence, and receives no more of its messages, as soon as one of the options below happens.",
        "noResults": "No contact has joined yet. Results appear once contacts start joining."
      },
      "step": {
        "dayChip": "Day {day}",
        "delayLabel": "Wait before sending",
        "amountLabel": "Amount",
        "unitLabel": "Unit",
        "unitMinutes": "Minutes",
        "unitHours": "Hours",
        "unitDays": "Days",
        "delayFirstNow": "Sent as soon as the contact joins",
        "delayFirstMinutes": "After {count, plural, one {# minute} other {# minutes}} from joining",
        "delayFirstHours": "After {count, plural, one {# hour} other {# hours}} from joining",
        "delayFirstDays": "After {count, plural, one {# day} other {# days}} from joining",
        "delayNextNow": "Sent right after the previous message",
        "delayNextMinutes": "After {count, plural, one {# minute} other {# minutes}} from the previous message",
        "delayNextHours": "After {count, plural, one {# hour} other {# hours}} from the previous message",
        "delayNextDays": "After {count, plural, one {# day} other {# days}} from the previous message",
        "emptyHint": "No messages yet. Add the first one: it is sent as soon as the contact joins, unless you set a wait.",
        "qrSkipped": "A QR channel cannot send this type of step, so it will be skipped.",
        "qrNoTemplate": "A QR channel sends your message as written, so no template is needed."
      },
      "join": {
        "title": "How do contacts join?",
        "body": "Add the “Sequence subscribe” step to a chat flow: every contact who reaches it joins this sequence. A sequence only sends once it is marked ready.",
        "triggers": "Also joins automatically: {list}",
        "triggerLabel": "when label {value} is added",
        "triggerEvent": "when the event {value} happens"
      },
      "channelNote": {
        "title": "Which channels can send a sequence?",
        "thisChannel": "This sequence sends through: {kind}.",
        "qr": "WhatsApp QR channel: text and media messages. Steps with buttons are skipped.",
        "cloud": "Official WhatsApp channel (Cloud API): text, media and buttons. A message goes out as you wrote it inside the 24-hour window after the contact last wrote to you. Outside that window the approved template you pick for the step is sent instead, so every step needs one before the sequence can be marked ready."
      },
      "preview": {
        "title": "What your contact will see",
        "caption": "The whole sequence as one conversation. It updates as you type; nothing needs saving.",
        "day": "Day {day}",
        "emptyText": "(No text written yet)",
        "media": "(Image, video or file)",
        "noSteps": "Add a message to see how the conversation will look."
      }
    },
    "services": {
      "proposedLabel": "(proposed — pending finance sign-off)",
      "catalog": {
        "heading": "Professional services",
        "purchase": "Request",
        "empty": "No service packages are available yet."
      },
      "request": {
        "heading": "Request a service",
        "package": "Package",
        "notes": "Notes and context",
        "contactTime": "Preferred contact time",
        "submit": "Send",
        "submitted": "Request received. Our team will contact you within the stated SLA.",
        "error": "We could not complete the request. Your card was not charged."
      },
      "upsell": {
        "title": "Want a hand getting set up?",
        "setup_stalled": "Your setup checklist has been open for a while. Our team can finish it with you.",
        "health_low": "Your workspace health could be better. A managed plan keeps your flows and broadcasts on track.",
        "cta": "See service packages",
        "dismiss": "Not now"
      }
    },
    "title": "Wato — Dashboard",
    "hello": "Hello",
    "greeting": "Welcome back, {name}",
    "nav": {
      "skipToContent": "Skip to main content",
      "typeLabels": {
        "restaurant": {
          "contacts": "Customers",
          "bookings": "Table booking",
          "products": "Menu",
          "orders": "Orders"
        },
        "clinic": {
          "contacts": "Patients",
          "bookings": "Appointments",
          "services": "Specialties",
          "staff": "Doctors"
        },
        "salon": {
          "contacts": "Customers",
          "bookings": "Appointments",
          "services": "Services",
          "staff": "Staff"
        },
        "car_workshop": {
          "contacts": "Customers",
          "bookings": "Service appointments",
          "services": "Services",
          "staff": "Technicians",
          "orders": "Work orders"
        },
        "real_estate": {
          "contacts": "Leads",
          "pipeline": "Follow leads",
          "bookings": "Viewings",
          "staff": "Agents"
        },
        "travel": {
          "contacts": "Travelers",
          "bookings": "Trip bookings",
          "services": "Trips"
        },
        "retail_shop": {
          "contacts": "Customers",
          "orders": "Orders"
        }
      },
      "label": "Main navigation",
      "more": "More",
      "roleNote": "Other areas need a higher role. Ask your workspace owner or admin to change your role.",
      "shellHintAbout": "About this",
      "shellHintClose": "Close",
      "shellHintAutomation": "Shows whether automatic replies and flows are running. Click it to pause or resume automation.",
      "shellHintWallet": "Your prepaid balance, used for paid WhatsApp messages. Click to open billing and top up.",
      "shellHintPlan": "Your current plan and how much of its limits you have used this month. Click to open billing.",
      "shellHintSearch": "Jump to any page or action by typing its name. Shortcut: Ctrl+K.",
      "shellHintHelp": "Take a short guided tour of this page, or open the Help Center for step-by-step guides.",
      "helpMenu": "Help",
      "helpCenter": "Open the Help Center",
      "helpAboutHeading": "What is in the top bar?",
      "helpAboutSearch": "Search",
      "helpAboutAutomation": "Auto-replies",
      "helpAboutUsage": "Plan usage",
      "helpAboutWallet": "Wallet",
      "avatarMenu": "Account menu",
      "usageAndWallet": "Wallet",
      "groupContacts": "Customers",
      "groupAutomation": "Auto-replies",
      "groupSell": "Store",
      "groupBookings": "Bookings",
      "groupMarketing": "Marketing",
      "groupAi": "AI",
      "groupAnalytics": "Reports",
      "groupSettings": "Settings",
      "taskReply": "Customers",
      "taskAutomate": "AI & automation",
      "taskSell": "Store",
      "taskBookings": "Bookings",
      "taskNumbers": "Reports",
      "setAccount": "Account",
      "setTeam": "Team",
      "setHelp": "Help",
      "advanced": "Advanced",
      "sectionMore": "More",
      "mode": {
        "simple": "Simple view",
        "advanced": "Advanced view",
        "hint": "Advanced view shows the rarely used pages in the menu"
      },
      "forms": "Data forms",
      "aiAgents": "AI assistant",
      "testConsole": "Try the assistant",
      "byok": "AI key",
      "entryPoints": "Start links",
      "sales": "Sales reports",
      "orderLifecycle": "Order messages",
      "reconciliation": "Payment reconciliation",
      "migration": "Migration",
      "quotes": "Quote settings",
      "openMenu": "Open menu",
      "closeMenu": "Close menu",
      "hideSidebar": "Hide sidebar",
      "showSidebar": "Show sidebar",
      "settingsGear": "Settings",
      "mobileLabel": "Mobile navigation",
      "inbox": "Inbox",
      "conversations": "Conversations",
      "groups": "Groups",
      "contacts": "All customers",
      "broadcasts": "Broadcasts",
      "settings": "Settings",
      "home": "Home",
      "workspaceSettingsShort": "Settings",
      "workspaceSettings": "Workspace settings",
      "groupCustomers": "Customers",
      "groupSales": "Sales",
      "deals": "Deals",
      "autoReplies": "Auto messages",
      "orderNotifications": "Order notifications",
      "recipes": "Ready solutions",
      "productsCatalog": "Products & catalog",
      "metaCatalog": "Meta catalog",
      "orders": "Orders",
      "quotesMenu": "Quotes",
      "payments": "Payments",
      "bookingsList": "All bookings",
      "messageTemplates": "Templates",
      "vouchers": "Discount codes",
      "marketplace": "Marketplace",
      "marketplaceSubmit": "Submit a template",
      "analyticsOverview": "Overview",
      "n8nTemplates": "Integrations",
      "locked": {
        "metaCatalog": "Requires a Meta Business connection",
        "plan": "Not in your plan"
      },
      "winback": "Win-back",
      "sectionTabs": "Section pages",
      "quoteSettings": "Quote settings",
      "section": {
        "daily": "Every day",
        "grow": "Grow sales",
        "more": "More tools",
        "moreShow": "Show more tools",
        "moreHide": "Hide more tools"
      },
      "showAll": "Show all features",
      "showFewer": "Show fewer features",
      "core": {
        "conversations": "Chats",
        "channels": "Connect WhatsApp",
        "templates": "Message templates",
        "flows": "Chat flows",
        "store": "Products"
      },
      "sectionGroup": {
        "ai": "AI assistant",
        "replies": "Chat flows",
        "messages": "Messages & forms"
      },
      "b29b": {
        "campaigns": "Campaigns",
        "growth": "Get customers"
      }
    },
    "automationOverview": {
      "title": "How automation works",
      "lead": "Automation in Wato is six tools, each with a different job. Read the cards below to see how they differ, preview an example customer conversation for each, then open the one that fits.",
      "intro": {
        "autoReplies": {
          "title": "How auto-replies work",
          "step1": "Pick the kind of reply: first message, outside hours, or a message that isn't understood.",
          "step2": "Write the reply text and choose how often it is sent.",
          "step3": "Switch the reply on and save."
        },
        "recipes": {
          "title": "How ready recipes work",
          "step1": "Choose a recipe that fits what you want, such as a welcome message or an abandoned cart.",
          "step2": "Press “Use template” to create a ready-made flow.",
          "step3": "Review the message, then publish it and switch it on."
        }
      },
      "channelNote": "Note: chat flows, forms and templates need the official WhatsApp Cloud API channel. WhatsApp channels linked with a QR code only run the AI agent, the inbox, broadcasts and sequences.",
      "cardsLabel": "Automation tools",
      "openNamed": "Open {name}",
      "decide": {
        "title": "What do I want to do?",
        "arrow": "→",
        "autoReplies": "Greet new customers",
        "flows": "Ask questions and collect answers",
        "sequences": "Follow up after a purchase over several days",
        "orders": "Tell customers their order status",
        "forms": "Collect an address or booking details inside WhatsApp",
        "recipes": "Start fast from a ready template"
      },
      "cards": {
        "autoReplies": {
          "what": "A fixed reply sent automatically at a specific moment: a customer's first message, outside working hours, or a message that isn't understood.",
          "when": "Use it to greet new customers, tell them your opening hours, and guide them when their message isn't understood.",
          "businessName": "Rose Garden",
          "caption": "Example: a fixed welcome reply to a new customer's first message.",
          "m1": "Hello",
          "m2": "Hi there! How can I help you?"
        },
        "flows": {
          "what": "A conversation built from steps: it asks the customer a question, shows buttons, saves the answer, then continues or hands over to a person.",
          "when": "Use it for bookings, taking orders and qualifying new leads.",
          "businessName": "Rose Salon",
          "caption": "Example: question → buttons → save the answer → hand over to a person.",
          "m1": "Welcome! What would you like?",
          "b1": "Book an appointment",
          "b2": "Prices",
          "m2": "Book an appointment",
          "m3": "What is your name?",
          "m4": "Sara",
          "m5": "Thanks, Sara! I'm handing you over to one of our team now."
        },
        "sequences": {
          "what": "Messages sent automatically over several days after an event, such as a purchase or sign-up.",
          "when": "Use it to follow up after a purchase or send reminders: a welcome on day 0, a reminder on day 2, an offer on day 7.",
          "businessName": "Rose Garden",
          "caption": "Example: three messages over seven days after a purchase.",
          "day0": "Day 0",
          "day2": "Day 2",
          "day7": "Day 7",
          "m1": "Hi Sara! Thanks for your order from Rose Garden.",
          "m2": "How did the bouquet arrive? We would love to hear what you think.",
          "m3": "A gift from us: 10% off your next order.",
          "b3": "Shop now"
        },
        "orders": {
          "what": "An automatic message the customer receives each time their order status changes, for a store connected to Wato.",
          "when": "Use it to keep customers informed: order confirmed, then shipped, then delivered.",
          "businessName": "Rose Garden",
          "caption": "Example: notifications the customer receives as their order progresses.",
          "m1": "We received your order #123. Thank you!",
          "m2": "Your order #123 has shipped and is on its way.",
          "b2": "Track order",
          "m3": "Your order #123 has been delivered. We hope you love it!"
        },
        "forms": {
          "what": "A form the customer fills in inside WhatsApp itself, without leaving the conversation.",
          "when": "Use it to collect a delivery address, booking details, or a rating after the service.",
          "businessName": "Rose Garden",
          "caption": "Example: the customer opens the delivery form and fills it in inside WhatsApp.",
          "m1": "Please fill in the delivery form to complete your order.",
          "b1": "Open form",
          "m2": "Address: Riyadh, Al Nakheel district",
          "m3": "Thanks! We received your address and will ship your order soon."
        },
        "recipes": {
          "what": "One button creates a ready-made flow or reply so you can start quickly.",
          "when": "Use it when you don't want to start from scratch: pick a recipe, edit the message, then switch it on.",
          "businessName": "Rose Garden",
          "caption": "Example: the “Welcome message” recipe creates this reply with one click.",
          "m1": "Hello",
          "m2": "Welcome to Rose Garden! Choose what suits you:",
          "b2a": "Orders",
          "b2b": "Prices"
        }
      }
    },
    "sellOverview": {
      "channelNote": "Note: sending products, carts and buttons inside a chat needs the official WhatsApp Cloud API channel. WhatsApp channels linked with a QR code only run the AI agent, the inbox, broadcasts and sequences.",
      "cards": {
        "connect": {
          "name": "Connect your store",
          "what": "Link your online store (Salla, Zid, Shopify or your own system) so Wato can read your products and orders by itself.",
          "when": "Do it once at the start, if your products already live on a store platform.",
          "note": "No store platform? You can still upload your products from a CSV file, or add them by hand in your Meta catalog (step 3)."
        },
        "products": {
          "name": "Your products",
          "what": "The list of what you sell: names, prices, stock and categories. It comes from your connected store or from a CSV file.",
          "when": "Check it after connecting, and whenever you want to confirm a price or a product before sharing it."
        },
        "catalog": {
          "name": "Meta catalog",
          "what": "A copy of your products kept inside WhatsApp, so customers can browse them and receive each product as a card in the chat.",
          "when": "Set it up when you want to send products and carts inside chats, not only text."
        },
        "chat": {
          "name": "Send products in the chat",
          "what": "While you talk to a customer, pick a product and send it as a card with an add-to-cart button. The customer fills the cart and sends you the order.",
          "when": "Use it whenever a customer asks what you have, or you want to suggest something."
        },
        "orders": {
          "name": "Orders",
          "what": "Every order that reaches you from WhatsApp, with its status, so you can confirm it, prepare it and keep the customer informed.",
          "when": "Open it every day to see new orders and move each one to the next status."
        },
        "money": {
          "name": "Payments and price quotes",
          "what": "Payments compares what your payment gateway recorded with the payments in Wato and lists any difference for you to review. A price quote is an offer with prices that you send a customer before they buy.",
          "when": "Use payments to review differences after customers pay, and quotes when a customer needs a price first.",
          "note": "Today the quotes area only has a settings page (number prefix, validity, terms). You create each quote from the customer panel inside a conversation; there is no list of quotes yet."
        }
      },
      "decide": {
        "title": "What do I want to do?",
        "arrow": "→",
        "then": "then",
        "and": "and",
        "sellStore": "Sell my store's products on WhatsApp",
        "fixProducts": "See or check my product list",
        "sendProduct": "Send a customer a product",
        "trackOrder": "Follow an order",
        "quote": "Send a price quote",
        "checkPayment": "Check a customer's payment"
      },
      "chats": {
        "product": {
          "businessName": "Rose Garden",
          "caption": "What your customer sees when you send a product.",
          "m1": "Hi, do you have red rose bouquets?",
          "m2": "Yes! Red rose bouquet, SAR 120. Tap below to add it to your cart.",
          "b1": "Add to cart",
          "b2": "View catalog",
          "m3": "I added it to my cart.",
          "m4": "Order #1042 received: 1 red rose bouquet, total SAR 120. We will tell you when it ships."
        },
        "order": {
          "businessName": "Rose Garden",
          "caption": "Keeping the customer informed as an order moves forward.",
          "m1": "Your order #1042 is confirmed and we are preparing it now.",
          "m2": "When will it arrive?",
          "m3": "It ships today and reaches you within 2 days."
        },
        "quote": {
          "businessName": "Rose Garden",
          "caption": "A quote the customer receives before buying.",
          "m1": "Price quote no. 7: 20 red rose bouquets, total SAR 2,400, valid for 7 days.",
          "m2": "Thank you, I accept the quote.",
          "m3": "Great! We will confirm your order shortly."
        }
      },
      "intro": {
        "store": {
          "title": "How the products and catalog area works",
          "what": "This is where your products live: connect your store, check the product list, follow orders and keep your WhatsApp catalog in sync.",
          "when": "Use it when you start selling, or when a product, price or stock level looks wrong.",
          "step1": "Connect your store (or import a CSV file) in the Connections tab.",
          "step2": "Check your products in the Products tab.",
          "step3": "Sync them to your WhatsApp catalog from the Catalog tab."
        },
        "orders": {
          "title": "How orders work",
          "what": "Every order that reaches you from WhatsApp, with its status and any payment waiting for your review.",
          "when": "Open it every day to confirm new orders and move each one to the next status.",
          "step1": "Open a new order to see what the customer chose.",
          "step2": "Review any payment waiting for approval, then confirm the order.",
          "step3": "Move the order to the next status as you prepare and ship it."
        },
        "quotes": {
          "title": "How price quotes work",
          "what": "A quote is an offer with prices that you send a customer before they buy. You create it from the customer panel inside a conversation; this page only sets the defaults.",
          "when": "Use it for larger or custom orders where the customer needs a price first.",
          "step1": "Set the number prefix, the validity days and the reminder days below.",
          "step2": "Add your standard terms and save.",
          "step3": "Create quotes from the customer panel in any conversation."
        },
        "payments": {
          "title": "How payment checking works",
          "what": "This page compares what your payment gateway recorded with the payments in Wato and lists any difference for you to review.",
          "when": "Open it when a customer says they paid but the order shows unpaid, or once a week as a routine check.",
          "step1": "Look at the open items in the list.",
          "step2": "Compare the gateway status with the status in Wato.",
          "step3": "Mark each item as resolved once you have checked it."
        },
        "connections": {
          "title": "How store connections work",
          "what": "Connecting links your online store to Wato so your products and orders come in by themselves.",
          "when": "Do it once at the start, or again if you change store platform or the sync stops.",
          "step1": "Pick your platform: Salla, Zid, Shopify, your own API or a CSV file.",
          "step2": "Follow the short steps on screen to approve the connection.",
          "step3": "Open the connection to see its sync health and match your fields."
        }
      }
    },
    "inbox": {
      "redesign": {
        "filterBar": {
          "tabWaiting": "Waiting",
          "label": "Conversation filters",
          "tabsLabel": "Quick views",
          "viewsButton": "Views",
          "filterButton": "Filter",
          "moreViews": "More",
          "displaySection": "Display settings",
          "channelSection": "Channel",
          "viewsPanel": "Choose a view",
          "readyMade": "Ready-made views",
          "channelLabel": "Filter by channel",
          "activeCount": "{count, plural, one {# active filter} other {# active filters}}",
          "unreadCount": "Unread: {count}",
          "chipsLabel": "Active filters",
          "clear": "Clear",
          "removeChip": "Remove filter: {value}",
          "chipView": "View: {value}",
          "chipStatus": "Status: {value}",
          "chipAssignee": "Assignee: {value}",
          "chipChannel": "Channel: {value}",
          "chipUnread": "Unread only",
          "saveHint": "Save these filters to reuse them from the Views menu.",
          "chipWaiting": "Waiting over 1 hour for a reply",
          "chipLabel": "Label filter"
        },
        "noSelection": {
          "what": "Every customer message lands here, shared with your whole team.",
          "openFirst": "Open the first conversation",
          "step1": "Pick a conversation from the list.",
          "step2": "Reply from the composer, or assign it to a teammate.",
          "step3": "Close it once the issue is solved."
        },
        "noConversations": {
          "title": "No conversations yet",
          "what": "No conversations yet.",
          "step1": "Connect a channel, such as your WhatsApp number.",
          "step2": "Or open the test phone and send yourself a test message.",
          "step3": "Customer replies then show up here in real time.",
          "channelsCta": "Connect a channel",
          "testPhoneCta": "Try the test phone",
          "qrHint": "WhatsApp only sends old chats once, when a number is first linked. Send or receive a message to see the chat here, or relink the number to import recent chats."
        },
        "noResults": {
          "title": "No conversations match",
          "what": "No results.",
          "clear": "Clear"
        },
        "panel": {
          "hide": "Hide details"
        },
        "intro": {
          "title": "How the inbox works",
          "what": "All your customer chats in one place.",
          "when": "Use filters to narrow the list for a moment, and save the ones you repeat as a view you can reopen in one click from the Views menu.",
          "step1": "Start with the quick tabs: All, Mine, Unassigned or Closed.",
          "step2": "Open Filters to narrow by status, channel, assignee or unread.",
          "step3": "Happy with a combination? Save it as a view and reuse it from Views.",
          "chat": {
            "businessName": "Noor Store",
            "caption": "A customer asks about an order and the team replies from the inbox.",
            "customer1": "Hi, where is my order #1024?",
            "team1": "Hello Sara! It shipped today and will reach you tomorrow.",
            "customer2": "Great, thank you!"
          }
        }
      }
    },
    "contacts": {
      "title": "Customers",
      "count": "{count, plural, =0 {No customers} one {# customer} other {# customers}}",
      "search": "Search customers",
      "searchPlaceholder": "Name or phone number",
      "add": "Add customer",
      "tableCaption": "Customer list",
      "columns": {
        "name": "Name",
        "phone": "Phone",
        "lastSeen": "Last message",
        "messages": "Messages"
      },
      "form": {
        "name": "Full name",
        "phone": "WhatsApp number",
        "phoneHint": "Include the country code, for example 966",
        "nameRequired": "Enter a name before saving"
      },
      "saved": "Customer saved",
      "savedDetail": "{name} was added to your customers."
    },
    "lastSeen": "{minutes, plural, one {# minute ago} other {# minutes ago}}",
    "errors": {
      "notInPlanTitle": "Not included in your plan",
      "notInPlanBody": "This feature isn't available on your current plan.",
      "moduleOffTitle": "This feature is turned off",
      "moduleOffBody": "This section is switched off for your workspace. An owner or admin can turn it on from Settings → Features.",
      "moduleOffAction": "Open features",
      "upgrade": "Upgrade plan",
      "forbiddenTitle": "You don't have access",
      "forbiddenBody": "Ask your workspace admin for access to this.",
      "forbiddenRole": "Ask your workspace admin — the {role} role is needed.",
      "rateLimitedTitle": "Too many requests",
      "rateLimitedBody": "Please wait {seconds, number} seconds and try again.",
      "rateLimitedBodyNoWait": "Please wait a moment and try again.",
      "offlineTitle": "You're offline",
      "offlineBody": "We couldn't reach Wato. Check your connection and try again.",
      "serverTitle": "Something went wrong on our side",
      "serverBody": "This isn't your fault. Try again in a moment.",
      "notFoundTitle": "Not found",
      "notFoundBody": "We couldn't find what you were looking for.",
      "genericTitle": "Something went wrong",
      "requestId": "Reference: {id}",
      "retry": "Try again",
      "invalidBody": "The change could not be saved because some data is invalid. Check the fields and try again.",
      "conflictBody": "This data was changed elsewhere. Refresh the page and try again.",
      "sequenceNotReadyBody": "This sequence is not ready yet. Open it and press “Mark ready” first.",
      "sessionExpiredBody": "Your session has expired. Sign in again to continue."
    },
    "shell": {
      "signOut": "Sign out",
      "loading": "Loading…",
      "loadError": "We couldn't load this page.",
      "retry": "Try again",
      "notFoundTitle": "Page not found",
      "notFoundBody": "The page you're looking for doesn't exist or you don't have access to it.",
      "backHome": "Back to home",
      "theme": "Theme",
      "themeLight": "Light",
      "themeDark": "Dark",
      "darkMode": "Dark mode",
      "lightMode": "Light mode",
      "themeSystem": "Match device",
      "listLoading": "Loading the list…"
    },
    "switcher": {
      "label": "Switch workspace",
      "current": "Current workspace",
      "list": "Your workspaces",
      "create": "Create workspace",
      "owner": "Owner"
    },
    "overview": {
      "subtitle": "How your business is doing and what needs you right now.",
      "period": {
        "label": "Period",
        "today": "Today",
        "week": "7 days",
        "month": "30 days"
      },
      "section": {
        "conversationsChart": "New conversations per day",
        "salesChart": "Sales per day",
        "busyHours": "Busiest hours",
        "team": "Team",
        "topProducts": "Top products",
        "topLabels": "Top labels this week",
        "channels": "Channel health"
      },
      "chart": {
        "day": "Day",
        "total": "Total",
        "orders": "Orders",
        "sales": "Sales",
        "conversationsSummary": "{total, plural, one {# new conversation} other {# new conversations}} over {days} days. Busiest day: {date} with {max}.",
        "salesSummary": "{total} in sales over {days} days. Best day: {date} with {max}.",
        "busyHint": "Incoming messages by weekday and hour, in your workspace time. Darker means busier.",
        "busySummary": "Busiest time: {day} at {hour}:00 with {count} messages."
      },
      "team": {
        "member": "Team member",
        "handled": "Conversations handled",
        "replies": "Replies",
        "firstResponse": "Median first response",
        "openNow": "Open now"
      },
      "products": {
        "name": "Product",
        "quantity": "Sold",
        "revenue": "Revenue"
      },
      "labels": {
        "count": "{count, plural, one {# contact} other {# contacts}}"
      },
      "channel": {
        "connected": "Connected",
        "degraded": "Needs a look",
        "disconnected": "Disconnected",
        "manage": "Manage channels"
      }
    },
    "home": {
      "growthCard": {
        "title": "Contacts growth",
        "month": "Month",
        "new": "New contacts",
        "lost": "Opted out",
        "net": "Net change",
        "trend": "Daily trend for {month}",
        "dayLabel": "{date}: {created} new, {lost} opted out",
        "unavailable": "Contacts growth isn't available right now.",
        "loading": "Loading…",
        "empty": "No new or opted-out contacts this month."
      },
      "quickActions": {
        "title": "Quick actions",
        "newBroadcast": "New broadcast",
        "openInbox": "Open inbox",
        "newFlow": "New chat flow",
        "trainAi": "Train AI",
        "connectChannel": "Connect channel"
      },
      "aiStatus": {
        "title": "AI status",
        "agents": "AI agents",
        "agentsOn": "{on} of {total} on",
        "noAgents": "No AI agents yet",
        "sources": "Knowledge sources",
        "lastTraining": "Last training",
        "never": "Not trained yet",
        "open": "Open AI",
        "unavailable": "AI status isn't available right now."
      },
      "welcome": "Welcome to {name}",
      "empty": "Nothing here yet. Finish setup to start.",
      "kpi": {
        "title": "Today at a glance",
        "conversationsToday": "Conversations today",
        "firstResponse": "First response time",
        "openUnassigned": "Open conversations",
        "openUnassignedValue": "{open} open · {unassigned} unassigned",
        "unassignedNote": "{unassigned} of them not yet assigned to an agent",
        "emptyGuidance": "Connect a WhatsApp number to start receiving conversations here.",
        "openOnlyValue": "{open} open",
        "conversationsUnit": "{count, plural, one {# conversation} other {# conversations}}",
        "aiResolution": "AI resolution rate",
        "revenue": "Revenue via WhatsApp",
        "recoveredCarts": "Recovered carts",
        "recoveredCartsNote": "Not tracked yet",
        "wallet": "Wallet balance",
        "channelHealth": "Channel health",
        "channelsOk": "{ok} of {total} connected",
        "noChannels": "No channels yet",
        "minutes": "{value} min",
        "unavailable": "Unavailable",
        "retry": "Retry",
        "openInbox": "Open inbox"
      },
      "active": "Today's activity at a glance.",
      "nextStep": {
        "heading": "Your next step",
        "remaining": "Other steps",
        "progress": "{done} of {total}",
        "buildFlow": {
          "title": "Build a flow for official WhatsApp",
          "body": "Your official channel is ready. Build a flow with buttons, lists and forms to reply automatically.",
          "cta": "Build a flow"
        },
        "complete": "All set. Your setup is complete.",
        "inbox": {
          "title": "Answer your customers",
          "body": "Open the inbox to read new messages and reply.",
          "cta": "Open the inbox"
        }
      },
      "profile": {
        "title": "Your business today",
        "open": "Open",
        "empty": "Nothing to show yet. Open the page to get started.",
        "unavailable": "Numbers are not available right now.",
        "card": {
          "unread_chats": "Open chats",
          "ai_handoffs": "Handed to a person",
          "orders_today": "Orders today",
          "abandoned_carts": "Open carts",
          "quotes_waiting": "Quotes waiting for a reply",
          "balances_due": "Amounts owed to you",
          "payments_today": "Payments today",
          "bookings_today": "Bookings today",
          "tables_tonight": "Tables tonight",
          "no_shows": "No-shows, last 7 days",
          "trips_this_month": "Upcoming trips",
          "deposits_waiting": "Deposits waiting",
          "documents_missing": "Missing documents",
          "new_leads": "New leads",
          "viewings_this_week": "Viewings this week",
          "deals_open": "Open deals"
        },
        "detail": {
          "revenue": "Sales today: {amount}",
          "noShowRate": "No-show rate: {percent}",
          "unanswered": "Waiting over 1 hour for a reply: {count}",
          "firstResponse": "Typical first reply: {duration}",
          "accepted": "Accepted in the last 30 days: {count}",
          "sentQuotes": "Sent in the last 30 days: {count}",
          "ungroundedPrice": "Stopped by the price check: {count}",
          "openChats": "Open chats: {count}",
          "durationSeconds": "{count} sec",
          "durationMinutes": "{count} min",
          "durationHours": "{count} h"
        }
      },
      "today": {
        "attention": "Needs your attention",
        "waiting": "Chats waiting",
        "newOrders": "New orders",
        "bookingsToday": "Bookings today",
        "create": "Quick create",
        "createCampaign": "Campaign",
        "createProduct": "Product",
        "createReply": "Auto-reply",
        "createContact": "Contact",
        "recent": "Recent chats",
        "allChats": "All chats",
        "noChats": "No chats yet",
        "aiOn": "On",
        "aiOff": "Off",
        "aiReplied": "Replied by the assistant"
      },
      "b29": {
        "reminders": {
          "title": "Today's follow-ups",
          "open": "Open",
          "done": "Done",
          "snooze": "Snooze 1 day",
          "error": "Could not update the reminder.",
          "overdue": "Overdue"
        }
      }
    },
    "auth": {
      "email": "Email address",
      "password": "Password",
      "or": "or",
      "backToLogin": "Back to sign in",
      "genericError": "Something went wrong. Please try again.",
      "networkError": "We couldn't reach Wato. Check your connection and try again.",
      "errorCodes": {
        "APP_INSTALL_NOT_STORE_SOURCED": "This store was not connected through the Salla app store. Install the Wato app from the Salla app store, then try again.",
        "AUTH_EMAIL_UNVERIFIED": "Verify your email first. We sent you a link when you signed up; open it, then try again.",
        "CHANNEL_ALREADY_CONNECTED": "This WhatsApp number is already connected to a workspace."
      },
      "login": {
        "title": "Sign in to Wato",
        "subtitle": "Welcome back. Sign in to manage your conversations.",
        "rememberMe": "Keep me signed in for 30 days",
        "submit": "Sign in",
        "forgot": "Forgot your password?",
        "noAccount": "New to Wato?",
        "createAccount": "Create an account",
        "google": "Google",
        "emailVerified": "Your email is verified. Sign in to continue.",
        "passwordChanged": "Your password was changed. Sign in with your new password.",
        "whatsapp": "WhatsApp",
        "emailRequired": "Enter your email address.",
        "passwordRequired": "Enter your password.",
        "errorNext": "Check your email and password and try again. Forgot it? Use \"Forgot your password?\" below."
      },
      "signup": {
        "title": "Create your Wato account",
        "subtitle": "Start with a free trial. No card needed.",
        "businessName": "Business name",
        "country": "Country",
        "industry": "Industry",
        "teamSize": "Team size",
        "primaryGoal": "What do you want to do first?",
        "preferredLanguage": "Preferred language",
        "passwordHint": "At least 10 characters. Avoid a password you use elsewhere.",
        "submit": "Create account",
        "haveAccount": "Already have an account?",
        "signedInTitle": "You're already signed in",
        "signedInAs": "You're signed in as {email}.",
        "signedInHint": "Sign out to create a new account, or add another workspace to this account.",
        "goToApp": "Open workspace",
        "createWorkspace": "New workspace",
        "signIn": "Sign in",
        "countries": {
          "SA": "Saudi Arabia",
          "BH": "Bahrain",
          "AE": "United Arab Emirates",
          "KW": "Kuwait",
          "OM": "Oman",
          "QA": "Qatar"
        },
        "industries": {
          "retail": "Retail",
          "ecommerce": "E-commerce",
          "food_beverage": "Food & beverage",
          "health_beauty": "Health & beauty",
          "education": "Education",
          "real_estate": "Real estate",
          "automotive": "Automotive",
          "travel_hospitality": "Travel & hospitality",
          "professional_services": "Professional services",
          "other": "Other"
        },
        "teamSizes": {
          "solo": "Just me",
          "small": "2–5 people",
          "medium": "6–20 people",
          "large": "21–50 people",
          "xlarge": "More than 50"
        },
        "goals": {
          "sales": "Sell on WhatsApp",
          "support": "Support customers",
          "bookings": "Take bookings",
          "marketing": "Run marketing campaigns"
        },
        "languages": {
          "ar": "Arabic",
          "en": "English"
        },
        "moreInfo": "More about your business (optional)",
        "moreInfoHint": "You can skip this and change it later.",
        "emailInvalid": "Enter a valid email, like name@example.com.",
        "passwordShort": "Your password needs at least 10 characters. Add a few more.",
        "businessNameRequired": "Enter your business name.",
        "errorNext": "Check the details above and try again. If you already have an account, sign in or reset your password."
      },
      "verify": {
        "title": "Check your email",
        "sent": "We sent a verification link to your email address. Open it to activate your account.",
        "errorTitle": "We couldn't verify your email",
        "resendTitle": "Didn't get the email?",
        "resendSubmit": "Resend",
        "resendDone": "If an account needs verification, a new link is on its way."
      },
      "twoFactor": {
        "title": "Two-step verification",
        "subtitle": "Enter the 6-digit code from your authenticator app.",
        "backupSubtitle": "Enter one of the backup codes you saved when you set up two-step verification.",
        "code": "Authentication code",
        "backupCode": "Backup code",
        "useBackup": "Use a backup code instead",
        "useCode": "Use an authenticator code",
        "submit": "Verify"
      },
      "setup": {
        "title": "Set up two-step verification",
        "intro": "Protect your account with a code from an authenticator app each time you sign in.",
        "required": "Two-step verification is required for your account (because of your role or workspace policy). Set it up to continue.",
        "start": "Start setup",
        "scan": "Scan this QR code with an authenticator app, such as Google Authenticator or Microsoft Authenticator.",
        "qrAlt": "QR code for your authenticator app",
        "manualKey": "Can't scan? Enter this key in the app instead:",
        "code": "6-digit code from the app",
        "confirm": "Turn on",
        "backupTitle": "Save your backup codes",
        "backupBody": "Each code works once if you lose access to your authenticator app. Keep them somewhere safe — they won't be shown again.",
        "backupListLabel": "Backup codes",
        "backupAck": "I have saved my backup codes",
        "continue": "Continue",
        "alreadyEnabled": "Two-step verification is already on for your account."
      },
      "reset": {
        "requestTitle": "Reset your password",
        "requestBody": "Enter your account email and we'll send you a reset link.",
        "requestSubmit": "Send link",
        "requestDone": "If an account exists for that address, a reset link is on its way. It expires in 30 minutes.",
        "confirmTitle": "Choose a new password",
        "newPassword": "New password",
        "confirmSubmit": "Save",
        "signedOutEverywhere": "After the change you'll be signed out on all devices."
      },
      "phoneOtp": {
        "title": "Sign in with WhatsApp",
        "subtitle": "We'll send a one-time code to the WhatsApp number linked to your account.",
        "phone": "WhatsApp number (with country code)",
        "send": "Send code",
        "sent": "If this number is linked to an account, a code is on its way. It expires in a few minutes.",
        "code": "6-digit code",
        "verify": "Verify",
        "resend": "Resend",
        "useEmail": "Use email instead",
        "invalid": "That code is not correct.",
        "used": "That code was already used. Request a new one.",
        "expired": "That code has expired. Request a new one.",
        "cooldown": "Too many codes requested. Try again in {seconds} seconds."
      },
      "addPhoneLogin": {
        "title": "Phone sign-in",
        "subtitle": "Add a WhatsApp number so you can sign in with a one-time code.",
        "phone": "WhatsApp number (with country code)",
        "send": "Send verification code",
        "code": "6-digit code",
        "verify": "Verify",
        "done": "Phone sign-in is on for this number.",
        "sent": "We sent a code to your WhatsApp."
      }
    },
    "workspace": {
      "create": {
        "title": "Create your workspace",
        "subtitle": "A workspace holds your channels, contacts, team and billing.",
        "name": "Workspace name",
        "nameHint": "Usually your business or brand name.",
        "country": "Country",
        "countryHint": "Sets your billing currency, which can't be changed later, and your default timezone.",
        "summary": "Billing currency {currency} · timezone {timezone}",
        "submit": "Create workspace",
        "countries": {
          "SA": "Saudi Arabia",
          "BH": "Bahrain"
        }
      }
    },
    "onboarding": {
      "title": "Set up your workspace",
      "progressLabel": "Setup progress",
      "stepOf": "Step {step} of {total}",
      "steps": {
        "method": "Connection method",
        "connect": "Connect WhatsApp",
        "starterPack": "Starter pack",
        "testMessage": "Test message",
        "inviteTeam": "Invite your team"
      },
      "status": {
        "current": "Current step",
        "complete": "Done",
        "locked": "Coming soon"
      },
      "method": {
        "legend": "How will you connect WhatsApp?",
        "intro": "You can add the other type later. Choose one to continue.",
        "cloudTitle": "Official — WhatsApp Cloud API",
        "cloudDescription": "All chatbot features: flows, buttons, lists, templates, forms and catalog. Needs a Meta business account.",
        "qrTitle": "WhatsApp QR code",
        "qrDescription": "Link an existing WhatsApp number by scanning a QR code. Runs one AI agent with the team inbox — no flows, buttons or templates.",
        "qrNote": "Unofficial connection: WhatsApp may restrict the number.",
        "required": "Choose a connection method to continue.",
        "names": {
          "cloud": "Official (Cloud API)",
          "qr": "WhatsApp QR"
        }
      },
      "locked": {
        "connect": "Connecting your {method} number arrives in an upcoming release. Your choice is saved.",
        "starterPack": "Pick an industry starter pack with a welcome menu, FAQ, human handoff and opt-out flow.",
        "testMessage": "Send a test message to your own phone to check that everything works.",
        "inviteTeam": "Invite teammates and give each one a role."
      },
      "starterPack": {
        "intro": "Pick your industry. We will pre-load a welcome menu, FAQ, human handoff and opt-out flow as drafts. Nothing is published.",
        "legend": "Industry",
        "preview": "What will be created",
        "flows": "Flow drafts",
        "labels": "Labels",
        "fields": "Custom fields",
        "welcomeReply": "A disabled welcome auto-reply you can review",
        "templates": "Suggested templates",
        "use": "Use pack",
        "skip": "Skip",
        "applying": "Setting up...",
        "created": "Your starter pack is ready",
        "alreadyApplied": "This pack was already added. Nothing was duplicated.",
        "draftStatus": "Draft",
        "openFlows": "Open the Flow Builder",
        "continue": "Continue",
        "loadFailed": "Could not load the starter packs."
      },
      "testMessage": {
        "intro": "We'll send a short test message to your own WhatsApp number through the channel you connected.",
        "phone": "Your phone number",
        "phoneHint": "International format, e.g. +966501234567",
        "phoneInvalid": "This phone number is not valid. Use international format with the country code, e.g. +966501234567.",
        "phoneRejected": "This number was rejected. Check the country code and digits, then try again.",
        "send": "Send test message",
        "sendAgain": "Send again",
        "retry": "Retry",
        "success": "Test message delivered. Your channel works.",
        "failed": "The test message was not delivered: {reason}",
        "timeout": "No delivery confirmation within 10 seconds.",
        "unknownReason": "Unknown error."
      },
      "next": "Next",
      "back": "Back",
      "goToDashboard": "Go to dashboard",
      "ownerOnly": "Only the workspace owner can change the setup.",
      "packs": {
        "title": "Vertical packs",
        "install": "Install pack",
        "review": "Review what will be created",
        "confirm": "Create as drafts",
        "draftNote": "Everything is created as a draft. Nothing goes live until you activate it.",
        "updateAvailable": "Update available",
        "updateTitle": "Review pack update",
        "updateNote": "Updates are never applied automatically. Items you edited are marked and need your decision.",
        "customized": "Edited by you",
        "uninstall": "Uninstall",
        "uninstallNote": "Removes the AI agent and labels going forward. Your conversations, orders and bookings are kept.",
        "type": {
          "flow": "Chat flows",
          "template": "Templates",
          "ai_agent": "AI agents",
          "label": "Labels",
          "form": "Forms"
        },
        "status": {
          "added": "New",
          "changed": "Changed",
          "removed": "Removed in new version",
          "unchanged": "Unchanged"
        }
      },
      "businessType": {
        "legend": "What kind of business do you run?",
        "onlineStore": {
          "title": "Online store",
          "description": "Orders, order status and abandoned-cart follow-up."
        },
        "clinic": {
          "title": "Clinic",
          "description": "Doctor booking, intake form and visit reminders."
        },
        "restaurant": {
          "title": "Restaurant",
          "description": "Menu, orders and delivery or pickup."
        },
        "services": {
          "title": "Services",
          "description": "Appointment booking, quotes and reminders."
        },
        "salon": {
          "title": "Salon",
          "description": "Appointment booking, stylists and reminders."
        },
        "realEstate": {
          "title": "Real estate",
          "description": "Property inquiries and viewing requests."
        },
        "carWorkshop": {
          "title": "Car workshop",
          "description": "Service appointments and car status updates."
        },
        "general": {
          "title": "Other business",
          "description": "General replies that suit any business."
        },
        "travel": {
          "title": "Travel and tourism",
          "description": "Trips with dates and seats, traveler bookings, deposits and payments."
        },
        "retailShop": {
          "title": "Shop or wholesale",
          "description": "Quotes, a balance for each customer and payments from the chat."
        },
        "familyLegend": "What field is your business in?",
        "specialtyLegend": "What is your specialty?",
        "specialtyBack": "Change field",
        "family": {
          "commerce": {
            "title": "Shop and store",
            "description": "Sell products from an online store or a shop."
          },
          "food": {
            "title": "Restaurant and cafe",
            "description": "Menu, delivery and pickup orders."
          },
          "appointments": {
            "title": "Bookings and appointments",
            "description": "Clinic, salon, workshop or any service by appointment."
          },
          "travel": {
            "title": "Travel and tourism",
            "description": "Trips with dates and seats, and traveler bookings."
          },
          "real_estate": {
            "title": "Real estate",
            "description": "Leads, viewings and deals."
          },
          "general": {
            "title": "Other business",
            "description": "General replies that suit any business."
          }
        }
      }
    },
    "settings": {
      "workspace": {
        "title": "Workspace settings",
        "readOnly": "Only the workspace owner can change these settings.",
        "general": "General",
        "name": "Workspace name",
        "slug": "Workspace address",
        "slugHint": "Lowercase English letters, numbers and hyphens.",
        "language": "Default language",
        "timezone": "Timezone",
        "timezoneHint": "From your country. Change it if your team is elsewhere.",
        "dateFormat": "Date format",
        "dateFormatHint": "Used for schedules, quiet hours and billing history.",
        "dateFormats": {
          "dmy": "Day/Month/Year",
          "mdy": "Month/Day/Year",
          "ymd": "Year-Month-Day"
        },
        "country": "Country",
        "currency": "Billing currency",
        "business": "Business details",
        "businessHint": "Shown on quotes and invoices.",
        "legalName": "Legal business name",
        "vat": "VAT number",
        "vatHint": "15 digits.",
        "cr": "Commercial registration (CR) number",
        "address": "Address",
        "line1": "Street address",
        "line2": "Building or unit (optional)",
        "city": "City",
        "region": "Region or governorate",
        "postalCode": "Postal code",
        "logo": "Logo",
        "logoHint": "PNG or JPEG, up to 256 KB.",
        "logoUpload": "Upload logo",
        "logoAlt": "{name} logo",
        "logoNone": "No logo yet",
        "logoSaved": "Logo updated",
        "security": "Security",
        "enforce2fa": "Require 2-step verification for all",
        "enforce2faHint": "Members without it must set it up before seeing data.",
        "enforce2faNeedsOwner": "Turn on 2-step verification for your account first.",
        "setUp2fa": "Set up two-step verification",
        "save": "Save changes",
        "saved": "Workspace settings saved",
        "danger": "Delete workspace",
        "dangerBody": "Every member loses access to this workspace and its data.",
        "deleteButton": "Delete workspace",
        "deleteTitle": "Delete {name}?",
        "deleteBody": "Type the workspace address to confirm.",
        "deleteLabel": "Workspace address",
        "deleted": "Workspace deleted",
        "languages": {
          "ar": "Arabic",
          "en": "English"
        },
        "channelsSection": "Channels",
        "channelsHint": "Settings that apply to every WhatsApp number in this workspace.",
        "typingIndicator": "Typing indicator and read receipts",
        "typingIndicatorHint": "While an automated or AI reply is being prepared for an inbound message.",
        "showAllSection": "Show all features",
        "advancedSection": "Advanced",
        "advancedHint": "Rarely needed, such as single sign-on.",
        "showAllHint": "This option is just for you, on this browser.",
        "showAll": "Show all features",
        "showAllLocked": "Your admin set this to show only features for your business.",
        "showAllLockedOn": "Your admin set this to show every feature.",
        "fieldErrors": {
          "name": "Enter the workspace name.",
          "slug": "Use 2 to 40 characters: lowercase letters, digits and hyphens.",
          "vatNumber": "The tax number is not valid. A Saudi VAT number is 15 digits, starting and ending with 3.",
          "crNumber": "The commercial registration number is not valid.",
          "postalCode": "The postal code is not valid.",
          "other": "This field is not valid."
        },
        "logoInvalidType": "This file type is not supported. Choose a PNG or JPEG image.",
        "logoTooLarge": "The logo is larger than 256 KB. Choose a smaller image.",
        "logoPreviewTitle": "How it looks on your documents",
        "logoPreviewHint": "Preview of the header on quotes and statements.",
        "logoPreviewDoc": "Quote / Statement",
        "businessTypeSection": "Business type",
        "businessTypeHint": "Set by the Wato team. Ask them to change it if your business changed."
      }
    },
    "legal": {
      "title": "Legal agreements",
      "intro": "Please review and accept each document to continue.",
      "accept": "I have read and accept the {document}",
      "docs": {
        "terms-of-service": "Terms of Service",
        "privacy-policy": "Privacy Policy",
        "acceptable-use-policy": "Acceptable Use Policy"
      },
      "viewEn": "English",
      "viewAr": "العربية",
      "missing": "Tick every document to continue.",
      "gateTitle": "We updated our terms",
      "gateIntro": "A material change was published. Accept the updated documents to keep using your workspace.",
      "gateAccept": "Accept and continue",
      "version": "Version {version}"
    },
    "privacy": {
      "title": "Privacy actions",
      "export": "Export contact data",
      "erase": "Request erasure",
      "exportDone": "Export ready. The download link expires in 24 hours.",
      "confirmErase": "Erase {name}? Conversations and CRM data will be permanently erased or anonymized. This cannot be undone.",
      "financialNote": "Payment and invoice records are kept for the statutory minimum and are not erased.",
      "erasePending": "Erasure request submitted."
    },
    "dpa": {
      "title": "Data Processing Agreement",
      "intro": "This standard DPA governs how we process personal data on your behalf.",
      "clausesTitle": "Standard clauses",
      "clause1": "We process personal data only on your documented instructions.",
      "clause2": "Everyone authorized to process the data is bound by confidentiality.",
      "clause3": "We apply appropriate technical and organizational security measures.",
      "clause4": "We assist you in answering data-subject requests (export and erasure).",
      "clause5": "We delete or return personal data at the end of the service, subject to statutory retention.",
      "retentionTitle": "Retention and the erasure exception",
      "retentionBody": "Payment and invoice records are retained for 10 years as required by regulation. An erasure request still erases conversation, CRM and analytics data, but financial and payment records are retained for the statutory minimum — including while a payment dispute or invoice is unresolved.",
      "subprocessorsTitle": "Sub-processors",
      "subprocessorsIntro": "We use the following categories of sub-processors. The current list is published with our legal documents.",
      "sp": {
        "meta": "Meta (WhatsApp Business Platform)",
        "ai": "AI model providers",
        "tap": "Tap Payments (payment processing)",
        "contabo": "Contabo (hosting)",
        "comms": "Email and SMS providers"
      }
    },
    "impersonationBanner": "Super Admin {admin} is viewing as {user} — {mode}",
    "maintenanceBanner": "Maintenance in progress — the workspace is read-only.",
    "flows": {
      "list": {
        "newFlow": "New chat flow",
        "aiDraft": {
          "button": "With AI",
          "title": "Create a flow with AI",
          "description": "Tell us what the flow should do. The AI prepares a draft. You review it and publish it yourself.",
          "label": "What should the flow do?",
          "placeholder": "Example: welcome the customer and show three buttons: Prices, Delivery, Talk to an agent",
          "submit": "Create draft",
          "working": "Preparing the draft…",
          "cancel": "Cancel",
          "note": "Nothing is published. You can ask for changes in the assistant chat after the draft opens."
        },
        "aiPatch": {
          "title": "Edit with a sentence",
          "placeholder": "Example: add a thank-you message before the end",
          "submit": "Apply",
          "working": "Editing…",
          "hint": "The AI edits this draft. You can undo it in one step.",
          "changesTitle": "What changed",
          "changesEmpty": "The AI made no changes to the flow.",
          "kind": {
            "added": "Added",
            "removed": "Removed",
            "modified": "Edited"
          },
          "needs": {
            "team": "Choose a team for the handoff step",
            "user": "Choose a user for the handoff step"
          },
          "close": "Close",
          "undoHint": "Press Undo to go back.",
          "errors": {
            "credits": "Your AI balance is low or used up. Top up the wallet to keep using AI.",
            "invalid": "The AI could not apply that change. Try describing it more simply.",
            "invalidReason": "Problem: {reason}",
            "reasonNoStart": "The flow start is not connected to any step.",
            "reasonMissing": "The change refers to a step or link that does not exist.",
            "reasonNotAllowed": "The AI used a step type that is not allowed here.",
            "reasonOther": "The AI's change did not produce a valid flow.",
            "technical": "Technical details",
            "paused": "AI is paused for this workspace.",
            "rejected": "This request cannot be used. Describe only the change to the flow.",
            "conflict": "The draft changed. Wait for it to save and try again."
          }
        },
        "importOldWato": "From old Wato",
        "headerHint": "Each chat flow opens in its own editor. Create as many as you need.",
        "searchPlaceholder": "Search",
        "filtersLabel": "Filter flows",
        "noMatch": "No flows match these filters.",
        "webhook": {
          "title": "Incoming links",
          "totalCalls": "Calls received",
          "success": "Successful runs",
          "failed": "Failed runs",
          "lastReceived": "Last received",
          "never": "Never",
          "viewCalls": "Recent calls",
          "hideCalls": "Hide calls",
          "callsFor": "Last calls for {flow}",
          "colTime": "Time",
          "colStatus": "Status",
          "colPayload": "Payload",
          "colError": "Error",
          "replay": "Replay",
          "replayed": "Call replayed.",
          "noCalls": "No calls yet.",
          "status": {
            "accepted": "Started",
            "no_match": "Skipped",
            "rejected_no_contact": "No contact",
            "error": "Error"
          }
        },
        "clearFilters": "Clear all",
        "edit": "Edit",
        "colTrigger": "Starts with",
        "noTrigger": "No trigger yet",
        "needsPublish": "(starts once published)",
        "triggerMore": "+{count} more",
        "trigger": {
          "keyword": "Keyword: {value}",
          "welcome": "The first message from a contact",
          "no_match": "A message no other flow answers",
          "button_payload": "A customer taps a button",
          "ai_intent": "AI detects an intent",
          "entry_link": "Entry link or QR code",
          "ctwa_ad": "Click-to-WhatsApp ad",
          "media_received": "A file or photo arrives",
          "location_received": "A location is shared",
          "incoming_webhook": "Incoming alert from another service",
          "inbox_macro": "Inbox quick action",
          "ig_comment": "Instagram comment",
          "ig_story_mention": "Instagram story mention",
          "ig_story_reply": "Instagram story reply",
          "commerce_event": "Store event",
          "contact_event": "Contact event",
          "deal_event": "Deal event",
          "booking_event": "Booking event",
          "form_event": "Form event",
          "payment_event": "Payment event",
          "inactivity_event": "Customer goes quiet",
          "other": "Other trigger"
        },
        "conflict": {
          "badge": "Trigger conflict",
          "detail": "Published with the same trigger as {list}: each message starts only one of them (the lower priority number first), so the other may never run.",
          "loses": "\"{winner}\" wins this trigger (priority {priority}).",
          "wins": "This flow wins the trigger (priority {priority})."
        },
        "channel": {
          "badge": "Official WhatsApp only",
          "tip": "Flows run only on the official WhatsApp Cloud API channel. QR channels run only the AI agent.",
          "whatsapp": "WhatsApp (official)",
          "instagram": "Instagram",
          "both": "WhatsApp + Instagram",
          "filterLabel": "Channel",
          "filterAll": "All channels",
          "tabsLabel": "Flow channel"
        },
        "modal": {
          "title": "New chat flow",
          "startLabel": "Start from",
          "create": "Create and open",
          "creating": "Creating…",
          "channelLabel": "Which channel?"
        },
        "tags": {
          "automation-template": "Automation template",
          "template": "Template",
          "welcome": "Welcome",
          "faq": "FAQ",
          "order-status": "Order status",
          "human-handoff": "Human handoff",
          "gallery": "From the gallery",
          "starter": "Starter",
          "general": "General business",
          "retail": "Retail",
          "restaurant": "Restaurant",
          "clinic": "Clinic",
          "salon": "Salon",
          "real_estate": "Real estate",
          "car_services": "Car services"
        },
        "empty": {
          "title": "Build your first chat flow",
          "what": "A chat flow is an automated conversation that asks, shows buttons and saves answers for you.",
          "step1": "Create a flow and give it a name.",
          "step2": "Connect messages, questions and buttons on the canvas.",
          "step3": "Test it on your phone, then publish it.",
          "recipes": "Start from a ready-made recipe"
        }
      },
      "intro": {
        "title": "How chat flows work",
        "what": "A chat flow is a conversation you design step by step: it asks the customer a question, shows buttons, saves the answer, then carries on or hands the chat to a person.",
        "when": "Use it for bookings, taking orders and qualifying new leads, anything you answer the same way every time.",
        "step1": "Create a flow and give it a name, or start from a ready-made template.",
        "step2": "Open it and connect the steps on the canvas: messages, questions and buttons.",
        "step3": "Test it on your phone, then publish. Only a published flow talks to customers.",
        "chat": {
          "businessName": "Rose Salon",
          "caption": "Example: question, buttons, saved answer, then a hand-over to a person.",
          "welcome": "Welcome to Rose Salon! What would you like?",
          "button1": "Book an appointment",
          "button2": "Prices",
          "customer1": "Book an appointment",
          "ask": "Great! What is your name?",
          "customer2": "Sara",
          "handoff": "Thanks, Sara! I am handing you over to one of our team now."
        }
      }
    },
    "contactsExplained": {
      "defs": {
        "contacts": "Everyone who has messaged you or been added by you.",
        "deals": "Follow sales opportunities stage by stage."
      },
      "intro": {
        "contacts": {
          "title": "How customers work",
          "what": "A customer is anyone who messaged you on WhatsApp or was added by your team, with their name, number, labels and conversation history.",
          "when": "Open it to find a customer, tag customers with labels, or prepare the people you will message later.",
          "step1": "Search for a customer by name or number, or filter the list by a label.",
          "step2": "Tick customers to add a label, add them to a list or export them.",
          "step3": "Open any customer to see their details and conversation history.",
          "example": "Example: pick the label “VIP customers” to see who has it, then save the result as a segment in one click."
        },
        "deals": {
          "title": "How deals work",
          "what": "A deal is a sales opportunity for one customer. It shows as a card on a board of stages and moves along until it is won or lost.",
          "when": "Use it to follow open offers: who is waiting for a reply, who agreed, who backed out, and what each stage is worth.",
          "step1": "Each column is a stage, with its number of deals and total value on top.",
          "step2": "Move a card to the next stage by dragging it or from the “Move to stage” menu.",
          "step3": "When you move a deal to the lost stage, write the reason so it is saved with it.",
          "example": "Example: a deal worth 4000 riyals starts in the first stage and moves stage by stage until it closes as won or lost."
        }
      },
      "exampleLabel": "Example",
      "empty": {
        "contacts": {
          "cta": "Add your first customer",
          "step1": "Press “Add your first customer” and enter a WhatsApp number with the country code.",
          "step2": "Or import your existing customers from a CSV file in the “Import” section.",
          "step3": "Any new customer who messages you on WhatsApp is added automatically."
        }
      },
      "importIdle": {
        "title": "Before you upload the file",
        "step1": "Prepare the file: a CSV with a phone column in international format.",
        "step2": "Upload it and map the columns: phone is required, name and email are optional.",
        "step3": "Confirm consent: declare where it came from and the proof, then review the dry run before importing.",
        "consentTitle": "Consent is required to import",
        "consentBody": "Only import numbers whose owners agreed to receive your messages. The next step asks you for the source of that consent and a written proof, and you cannot continue without them.",
        "expectTitle": "What the file must contain",
        "expect1": "The first row holds the column names.",
        "expect2": "The phone column is required, written with the country code and no spaces.",
        "expect3": "The name and email columns are optional.",
        "sampleLabel": "Example of a valid file",
        "sample": "phone,name\n966500000001,Sara\n966500000002,Khaled"
      }
    },
    "aiAgents": {
      "list": {
        "title": "AI agents",
        "subtitle": "Agents that answer your customers on WhatsApp inside limits you set, and hand the chat to a person when needed.",
        "newAgent": "New agent",
        "searchLabel": "Search agents",
        "searchPlaceholder": "Agent name or type",
        "noResults": "No agent matches your search."
      },
      "card": {
        "edit": "Edit",
        "test": "Test",
        "bind": "Bind to a channel",
        "channelsLabel": "Bound channels",
        "noChannels": "Not bound to any channel",
        "draftHint": "Draft: it does not answer customers until you publish it.",
        "lastEdited": "Last edited {date}",
        "pause": "Pause",
        "activate": "Activate",
        "pausedHint": "Paused: it does not answer. The channels bound to it use their previous behaviour until you activate it again.",
        "activateFailed": "The agent could not be activated. Finish its checklist on the edit page, then try again."
      },
      "status": {
        "draft": "Draft",
        "published": "Active",
        "paused": "Paused"
      },
      "types": {
        "support_faq": "Support and FAQs",
        "sales_assistant": "Sales",
        "order_tracking": "Order tracking",
        "lead_qualification": "Lead qualification",
        "prospector_outreach": "Prospect outreach",
        "none": "No scope",
        "desc": {
          "support_faq": "Answers common customer questions from your business info, and hands the chat to a person when needed.",
          "sales_assistant": "Understands what the customer needs, suggests products and prepares a draft for a person to approve.",
          "order_tracking": "Answers order and shipping status questions, and hands the chat to a person when it cannot.",
          "lead_qualification": "Asks the customer a few short questions to see how serious they are, then passes them to your team.",
          "prospector_outreach": "Answers prospects who reply to your outreach, qualifies their interest from the campaign offer, and hands the chat to a person to book a call or on any price talk."
        }
      },
      "channel": {
        "qr": "WhatsApp (QR)",
        "cloud": "WhatsApp official",
        "other": "Channel",
        "instagram": "Instagram",
        "option": "{name} ({kind})"
      },
      "bind": {
        "title": "Bind the agent to a channel",
        "description": "The agent answers the bound channel automatically, and any earlier binding on it is replaced.",
        "channelLabel": "Channel",
        "noChannels": "You have no channels yet. Connect a WhatsApp channel first, then come back.",
        "goToChannels": "Open channels",
        "publishNote": "This agent is a draft. We publish it first, then bind it to the channel.",
        "publishFailed": "The agent could not be published because its compliance checklist is incomplete. Finish it on the edit page, then try again.",
        "confirm": "Bind agent",
        "confirmPublish": "Publish and bind",
        "working": "Binding…",
        "cancel": "Cancel",
        "openEditor": "Open the edit page",
        "notPublishedTitle": "The agent is not published yet",
        "notPublished": "A channel can only be bound to a published agent. Publish it first, then bind it.",
        "publishFirst": "Publish first",
        "cloudWindowNote": "On the official number the agent replies only within 24 hours of the customer's last message."
      },
      "intro": {
        "title": "How an AI agent works",
        "what": "An AI agent is an automated team member that answers your customers on WhatsApp about topics you choose, and hands the chat to a person when it does not know or the customer asks.",
        "when": "Use it for repeated questions such as prices, opening hours and order status, so your team can focus on chats that need a human.",
        "step1": "Pick the agent's role (sales, support or reception) and name it.",
        "step2": "Review the safety limits, then try it in a test chat that never reaches customers.",
        "step3": "Publish it and bind it to a channel. Only a published, bound agent answers customers.",
        "chat": {
          "caption": "Example: a price question, then a handoff when a discount is asked for.",
          "customer1": "How much is the monthly plan?",
          "agent1": "According to our price list, the monthly plan is 99 SAR. Want to know what it includes?",
          "customer2": "Can I get a discount if I subscribe for a full year?",
          "handoff": "Discounts are approved by one of our team. I am handing you over to them now."
        }
      },
      "empty": {
        "title": "Create your first AI agent",
        "what": "Start from a ready-made role and we prepare the agent's persona, topics and limits. You can edit all of it afterwards.",
        "step1": "Pick a role and name the agent.",
        "step2": "Review the safety limits and test the agent.",
        "step3": "Publish it and bind it to a channel.",
        "pickRole": "Pick a role to start:",
        "startBlank": "Start blank",
        "noPermission": "You do not have permission to create assistants. Ask the workspace owner."
      },
      "roles": {
        "sales": {
          "name": "Sales assistant",
          "job": "Understands what the customer needs, suggests matching products and prepares a draft cart that a person approves.",
          "example": {
            "caption": "Example: asking whether a product is in stock.",
            "customer": "Do you have oud perfume for men?",
            "reply": "Yes, we have two kinds in stock. Which do you prefer? I will prepare a draft cart for one of our team to approve."
          }
        },
        "support": {
          "name": "Support assistant",
          "job": "Answers customer questions from your own information, tracks order status and hands upset customers to a person.",
          "example": {
            "caption": "Example: asking about an order.",
            "customer": "Where is my order?",
            "reply": "Your order is on its way and arrives tomorrow. Is there anything else you need?"
          }
        },
        "receptionist": {
          "name": "Receptionist",
          "job": "Greets customers, answers opening-hours and location questions, then routes them to the right team.",
          "example": {
            "caption": "Example: asking about opening hours.",
            "customer": "When do you open today?",
            "reply": "Welcome! We are open from 9 am to 10 pm. Would you like to talk to a specific team?"
          }
        },
        "blank": {
          "name": "Start from scratch",
          "job": "An empty agent whose role and topics you write yourself, with strict safety limits."
        }
      },
      "tools": {
        "search_kb": "Search the knowledge sources",
        "order_lookup": "Look up an order's status",
        "stock_check": "Check product availability",
        "draft_cart": "Prepare a draft cart (a person approves it)",
        "escalate": "Hand the chat to a person",
        "check_order_status": "Track order status",
        "create_order": "Prepare a draft order (a person approves it)",
        "book_slot": "Book an appointment",
        "product_search": "Product search",
        "search_products": "Search store products",
        "send_product": "Send a product card",
        "send_products": "Send products to the customer (store cards)",
        "send_order_link": "Send the web order link",
        "send_booking_link": "Send the web trip booking link",
        "sheet_append_row": "Add a row to the connected Google Sheet",
        "sheet_lookup": "Look up a row in the connected Google Sheet",
        "sheet_search_rows": "Search rows in the connected Google Sheets",
        "sheet_update_row": "Update a row in a read/write Google Sheet",
        "lookup_availability": "Check live availability and prices (Google Sheet)",
        "save_lead": "Save a captured lead to the owner's Google Sheet",
        "get_my_balance": "Show the customer their own account balance (read-only)",
        "calculator": "Calculator: exact totals, VAT and discounts (read-only, uses your configured prices)",
        "estimate_quantity": "Quantity estimator: how much material and what price, from your price table",
        "current_datetime": "Tell the current date, time and weekday (business timezone)",
        "check_business_hours": "Check if the business is open now and the next opening time",
        "notify_team": "Leave an internal note for the team without handing off",
        "send_location": "Send the business location to the customer",
        "send_file": "Send one of your prepared files (PDF or image)"
      },
      "toolHints": {
        "product_search": "Finds products with price and link from your store and website"
      },
      "editor": {
        "back": "All agents",
        "notFound": "We could not find this agent. It may have been deleted.",
        "pause": "Pause agent",
        "pausedNote": "The agent is paused. Bound channels use their previous behaviour until you publish it again.",
        "channelsTitle": "Where it answers",
        "channelsDesc": "The channels this assistant answers on. A channel answers with one assistant, and this matches the “smart assistant” choice on the auto-replies page.",
        "seeAutoReplies": "Auto-replies",
        "testBanner": "This is a test chat. Nothing here is sent to customers or uses a customer's chat. Save your changes first so the test uses them.",
        "tools": {
          "title": "Tools",
          "hint": "What the agent may use in a chat. Tools from your business type are on by default; you can turn any off.",
          "fromType": "From your business type",
          "byOwner": "Added by you",
          "turnOff": "Turn off",
          "calcGroup": "Calculation tools",
          "catalogGroup": "Product and link tools",
          "connected": "Connected",
          "disconnected": "Disconnected",
          "needsSetup": "Needs setup: add a price table row",
          "turnOn": "Turn on",
          "priceTable": "Price table",
          "priceTableHint": "Used by the quantity estimator. Price is in minor units (SAR 2 dp, BHD 3 dp); coverage is m2 per unit. Missing data means the assistant hands off.",
          "addRow": "Add product",
          "removeRow": "Remove",
          "col": {
            "name": "Product",
            "unit": "Unit",
            "priceMinor": "Unit price (minor units)",
            "currency": "Currency",
            "coverage": "Coverage per unit (m2)",
            "waste": "Waste %"
          }
        },
        "priceGuardHint": "This test reply would be held for a human in live chat: it states a price that is not in your catalog or the customer's message. Fix your catalog or knowledge base so the assistant can quote it.",
        "stockGuardHint": "Live chat would hold this reply: your store shows the item out of stock.",
        "promiseGuardHint": "Live chat would hold this reply: it promises a refund, free delivery or confirms a payment.",
        "leakGuardHint": "Live chat would hold this reply: it exposes internal instructions or a secret.",
        "adviceGuardHint": "Live chat would hold this reply: it gives a medicine dose, a diagnosis or a legal ruling."
      },
      "wizard": {
        "title": "New AI agent",
        "subtitle": "Five short steps. The result is an ordinary assistant you can edit any time.",
        "backToList": "List",
        "stepsLabel": "Steps to create the agent",
        "stepOf": "Step {step} of {total}",
        "steps": {
          "role": "Your business type",
          "details": "Name, goal and tone",
          "safety": "Safety limits",
          "finish": "Test, then activate",
          "where": "Where and how it answers"
        },
        "nav": {
          "next": "Next",
          "back": "Back"
        },
        "role": {
          "legend": "Pick the type closest to your business. We fill in a ready goal that you can edit.",
          "topics": "Topics",
          "tools": "What it can do",
          "loadError": "We could not load the ready-made roles. You can start from scratch or try again.",
          "retry": "Try again",
          "pick": "Pick a role to continue."
        },
        "details": {
          "sectionBasics": "The basics",
          "sectionBehavior": "How it answers",
          "nameLabel": "Agent name",
          "nameHint": "An internal name that helps you tell agents apart. Customers do not see it.",
          "nameRequired": "Enter a name for the agent.",
          "personaLabel": "What should the assistant do?",
          "personaHint": "Write it in plain words, as you would brief a new employee. We filled it for your business type; edit it freely.",
          "topicsLabel": "Topics it answers (separate with commas)",
          "topicsHint": "The agent does not answer anything outside these topics.",
          "typeLabel": "Agent scope",
          "typeHint": "Every agent has one clear scope. There is no agent that answers everything.",
          "sectionBasicsDesc": "The name and scope that tell this AI agent apart from others.",
          "sectionBehaviorDesc": "How the agent talks and which topics it answers.",
          "typeChoose": "Choose the agent's scope",
          "toneLabel": "Tone of replies"
        },
        "safety": {
          "intro": "These limits protect your customers and your brand. You can change them later on the agent's edit page.",
          "handoffTitle": "Handoff to a person",
          "handoffBody": "The agent hands the chat to a person right away when the customer writes one of these words:",
          "confidenceTitle": "When it is not sure",
          "confidenceBody": "If the agent is less than {value}% sure of its answer, it hands the chat to a person instead of guessing.",
          "budgetTitle": "Reply limit",
          "budgetBody": "After {value} agent replies in one conversation, the chat is handed to a person.",
          "sourcesTitle": "Where answers come from",
          "strictBody": "It answers only from the knowledge sources you add. If it cannot find the answer, it hands the chat to a person.",
          "looseBody": "It answers inside its topics and uses knowledge sources when you have them.",
          "offTopicTitle": "Outside its topics",
          "offTopicHandoff": "If the customer goes outside the agent's topics, the chat goes to a person.",
          "offTopicRefuse": "If the customer goes outside the agent's topics, it politely declines.",
          "protectTitle": "Extra protection",
          "injectionBody": "It ignores any attempt to change its instructions or pull it out of its role.",
          "piiBody": "It hides personal data before the text is sent to the AI.",
          "toolsTitle": "Tools it may use",
          "moneyTitle": "A person always handles money",
          "moneyBody": "Any action that moves money (a cart, a quote, a discount or a refund) always needs a person's approval. The agent only prepares a draft and never approves anything itself."
        },
        "finish": {
          "intro": "We create the agent as a draft that does not answer customers. Test it first, then publish it and bind it to a channel.",
          "summaryName": "Name",
          "summaryRole": "Role",
          "summaryTools": "Tools",
          "createDraft": "Save as draft",
          "creating": "Creating…",
          "doneTitle": "Agent created",
          "doneBody": "We created \"{name}\" as a draft. It will not answer any customer until you publish it and bind it to a channel.",
          "tryNow": "Try it now",
          "bind": "Bind it to a channel",
          "openEditor": "Open the edit page",
          "backToList": "List",
          "activateHint": "You chose channels. Activate the assistant to start answering on them now, or test it first.",
          "activate": "Activate",
          "activated": "The assistant is active and answers on the chosen channels.",
          "seeAutoReplies": "Auto-replies"
        },
        "summary": {
          "title": "Agent summary",
          "notChosen": "Not chosen yet",
          "noName": "No name yet",
          "type": "Scope",
          "channel": "Channel",
          "channelValue": "Not bound to a channel. You bind it after creating.",
          "knowledge": "Business info",
          "knowledgeValue": "No sources yet. You add them after creating.",
          "handoff": "Handoff to a person",
          "handoffNone": "No handoff words set. It hands over when unsure.",
          "status": "Status",
          "statusValue": "Draft that does not answer customers"
        },
        "tone": {
          "friendly": {
            "title": "Friendly",
            "desc": "Warm and simple, like a good shop assistant."
          },
          "formal": {
            "title": "Formal",
            "desc": "Polite and professional."
          },
          "concise": {
            "title": "Short",
            "desc": "Straight to the point, one or two lines."
          }
        },
        "where": {
          "channelsTitle": "Which channels should it answer?",
          "channelsDesc": "Pick one or more WhatsApp numbers. You can change this later.",
          "noChannels": "No channel is connected yet.",
          "addChannel": "Connect a channel",
          "channelsHint": "A number answers with one assistant. The assistant starts answering only after you activate it.",
          "qrNote": "WhatsApp by QR: the smart assistant is the only automatic reply available here.",
          "sourcesTitle": "Which information may it use?",
          "sourcesDesc": "It answers from what you wrote about your business.",
          "noSources": "You have not added any information yet.",
          "addSource": "Add info",
          "handoffTitle": "When to hand over to a person",
          "handoffDesc": "When the customer writes one of these words, the chat goes to a team member.",
          "handoffLabel": "Hand-over words (separate with commas)",
          "handoffHint": "For example: complaint, refund, talk to a person.",
          "hoursTitle": "Working hours",
          "hoursDesc": "Outside these hours the assistant tells the customer the team will reply on the next working day.",
          "hoursAlways": "Answer all day, every day",
          "hoursFrom": "From",
          "hoursTo": "To",
          "hoursInstruction": "Working hours are {from} to {to}. Outside them tell the customer the team will reply on the next working day, then hand the chat to a person."
        },
        "describe": {
          "title": "Not sure where to start? Describe your business",
          "label": "In one or two sentences: what do you sell or offer, and what should the assistant help customers with?",
          "placeholder": "e.g. We run a perfume shop in Riyadh and customers ask about prices and delivery.",
          "draft": "Draft",
          "tooShort": "Write a little more (at least a short sentence) so we can draft it.",
          "demoNotice": "Demo mode: this draft is built from your own words only, not by a real AI. Review and edit it before you create.",
          "proposalType": "Suggested start: {type}",
          "proposalBlank": "We could not tell the type, so we suggest starting from a blank page ({type}).",
          "approveNote": "This only fills in the next steps. Nothing is created until you press Create on the last step, and you can change everything.",
          "accept": "Use draft",
          "discard": "Discard"
        }
      },
      "business": {
        "store": {
          "name": "Online store or shop",
          "job": "Answers questions about products, prices and delivery, and prepares an order draft that a person approves.",
          "example": "Example: “Do you have this in size M?”",
          "goal": "Help customers choose products, tell them prices, stock and delivery, and prepare an order draft for a team member to approve. Be polite and short.",
          "topics": "products, prices, stock, delivery, returns"
        },
        "restaurant": {
          "name": "Restaurant or café",
          "job": "Shares the menu, opening hours and location, and takes order requests for a person to confirm.",
          "example": "Example: “What time do you open, and do you deliver?”",
          "goal": "Answer questions about the menu, prices, opening hours, location and delivery, and collect order requests for a team member to confirm. Be friendly and brief.",
          "topics": "menu, prices, opening hours, location, delivery"
        },
        "clinic": {
          "name": "Clinic, salon or services by appointment",
          "job": "Answers questions about services and prices and helps the customer pick an appointment time.",
          "example": "Example: “I want to book a visit this week.”",
          "goal": "Welcome customers, explain our services and prices, and help them choose an appointment time. Never give medical advice; hand over to a person for anything beyond booking.",
          "topics": "services, prices, appointments, opening hours, location"
        },
        "support": {
          "name": "Customer support",
          "job": "Answers common questions from your own information and hands difficult cases to the team.",
          "example": "Example: “Where is my order?”",
          "goal": "Answer customers' common questions using only the information we give you. If you are not sure, or the customer is upset, hand the chat to a team member.",
          "topics": "common questions, shipping, returns, payment"
        },
        "blank": {
          "name": "Something else",
          "job": "Start from a clean page and write the goal yourself.",
          "example": "You choose what it answers."
        }
      },
      "unavailable": {
        "no_key": {
          "title": "Add an AI key to run the assistant",
          "body": "The assistant needs an AI key from an AI provider (OpenRouter, OpenAI, Anthropic or Gemini). Add your key once and it works for every assistant.",
          "cta": "Add an AI key"
        },
        "no_plan": {
          "title": "Your plan does not include this right now",
          "body": "The AI allowance of your plan is used up or not included. Upgrade the plan or top up your balance, then try again.",
          "cta": "Open billing"
        }
      },
      "runLog": {
        "title": "Assistant reply log",
        "intro": "For review only: shows the assistant's replies and the reason for each reply or handoff.",
        "empty": "No replies yet. Turns will show up here once customers write to this assistant.",
        "loading": "Loading the log...",
        "error": "Could not load the reply log.",
        "retry": "Try again",
        "col": {
          "agent": "Agent",
          "badgeTransfer": "Transfer",
          "badgeFlow": "Flow",
          "time": "Time",
          "text": "Customer message",
          "outcome": "Result",
          "reason": "Why",
          "tokens": "Tokens",
          "credits": "Credits"
        },
        "outcome": {
          "replied": "Replied",
          "refused": "Declined",
          "handoff": "Handed over",
          "offer": "Offered a person"
        },
        "reason": {
          "no_source": "Did not find the answer in the knowledge base",
          "ai_all_providers_failed": "The model could not be reached",
          "max_turns": "The chat reached the maximum number of replies",
          "offer": "Offered to hand over to a team member",
          "error_soft": "Temporary overload",
          "injection_ambiguous": "Message looked like an instruction attack",
          "unknown": "Other reason",
          "none": "-"
        }
      },
      "handoffQueue": {
        "title": "When the assistant hands over to a person",
        "intro": "The customer is told a team member will reply. The chat moves to the waiting queue in the inbox and is sent to a team by these rules, in this order.",
        "waiting": "{count, plural, =0 {No chats are waiting for a person right now.} one {# chat is waiting for a person.} other {# chats are waiting for a person.}}",
        "openInbox": "Open the inbox",
        "routeTitle": "Who gets it",
        "condIs": "{field} is {value}",
        "condIsNot": "{field} is not {value}",
        "and": "and",
        "always": "Any chat",
        "rule": "{when} → team {team} ({strategy})",
        "unknownTeam": "a deleted team",
        "fallback": "Otherwise: the chat stays in the waiting queue until someone takes it.",
        "noRules": "No routing rules yet, so every hand-over waits in the queue for someone to take it.",
        "edit": "Edit teams and routing rules"
      },
      "linkDomains": {
        "title": "Links the assistant may send",
        "help": "On WhatsApp QR the assistant only sends links from these domains, links to your own products, or links the customer wrote. Any other link is never sent: the chat goes to your team instead. Short links (bit.ly and similar) are never allowed.",
        "empty": "No domains yet. Add your website in settings or add a website to the knowledge base.",
        "source": {
          "website": "Your website",
          "knowledge": "Knowledge base",
          "wato": "Issued by Wato (quotes, statements, payment pages)"
        }
      },
      "replyRate": {
        "title": "Reply limit per customer",
        "label": "Most AI replies to one customer in 10 minutes",
        "help": "If a customer (or an automatic sender) goes past this number, the assistant stops replying and hands the chat to your team with a short note. Test chat is not counted.",
        "save": "Save",
        "saved": "Saved",
        "noAccess": "Only an owner or admin can change this."
      },
      "voice": {
        "title": "Voice notes",
        "toggle": "Understand voice notes from customers",
        "cost": "Voice notes use your daily voice limit. Today: {used} of {budget} minutes used. Once the limit is reached, voice notes are not turned into text until tomorrow.",
        "noAccess": "Only an owner or admin can change this."
      },
      "recommended": {
        "title": "Recommended for your business type",
        "hint": "A ready assistant for your kind of business. You see what it can do first, then create it as a draft and edit anything.",
        "qrOnly": "Works on your WhatsApp numbers. It always hands over to your team when needed.",
        "create": "Create assistant"
      },
      "graph": {
        "title": "Agents map",
        "b29": {
          "port": {
            "model": "Model",
            "memory": "Memory",
            "kb": "Knowledge",
            "tools": "Tools"
          },
          "add": {
            "kb": "Add knowledge",
            "tools": "Add tool"
          },
          "unbound": "Not connected",
          "panel": {
            "name": "Name",
            "save": "Save",
            "usedBy": "Used by",
            "unbind": "Disconnect",
            "snippetLabel": {
              "tone": "Tone",
              "short": "Short replies",
              "handoff": "Handoff"
            },
            "snippet": {
              "tone": "Reply in a friendly, polite tone.",
              "short": "Keep replies short: two sentences at most.",
              "handoff": "If you are not sure, hand the chat over to a team member."
            }
          }
        },
        "b29b": {
          "portTeam": "Helper agents",
          "addTeam": "Add a helper agent",
          "linkChannel": "Link to a channel",
          "fitAll": "Show all",
          "helper": {
            "title": "Pick a helper agent",
            "none": "No agent available.",
            "inactive": "Not published"
          },
          "error": {
            "self": "An agent can't be its own helper.",
            "cycle": "This makes a circle between agents.",
            "depth": "Handover goes 2 levels at most."
          },
          "try": "Try",
          "copy": "Copy",
          "range": {
            "today": "Today",
            "7d": "7 days"
          },
          "alert": {
            "channel_disconnected": {
              "text": "This channel is disconnected, so no messages reach the agent.",
              "fix": "Open channels"
            },
            "kb_empty": {
              "text": "This information is empty, the agent has nothing to read.",
              "fix": "Open it"
            },
            "tool_not_connected": {
              "text": "This tool is off, so the agent can't use it.",
              "fix": "Open the tool"
            },
            "sub_agent_inactive": {
              "text": "This helper agent isn't published, so it won't get any chat.",
              "fix": "Open the agent"
            },
            "agent_no_channel": {
              "text": "This agent isn't linked to a channel.",
              "fix": "Link to a channel"
            }
          },
          "drawer": {
            "title": "Try the agent",
            "close": "Close",
            "replyTime": "Reply in {time}",
            "noSend": "Test only. Nothing reaches a customer."
          },
          "trace": {
            "title": "Trace a conversation",
            "search": "Customer name or phone",
            "none": "No steps found for this conversation.",
            "noMatch": "No conversation found.",
            "knowledge": "Read: {title}",
            "handoff": "{from} → {to}",
            "outcome": {
              "replied": "Replied",
              "refused": "Refused",
              "handoff": "Handed to a person"
            }
          },
          "staffPanel": {
            "title": "Human team"
          }
        },
        "open": "Agents map",
        "back": "Agents",
        "newAgent": "New agent",
        "quickAgent": "Quick agent",
        "attachTool": "Attach tool",
        "autoLayout": "Auto layout",
        "addMenu": "Add",
        "removeLink": "Remove link",
        "labelField": "When to use",
        "labelSave": "Save",
        "defaultLabel": "When the customer asks for this",
        "noAccess": "You don't have access to AI agents.",
        "readOnly": "View only",
        "loadFailed": "Couldn't load the map",
        "retry": "Retry",
        "linkNotAllowed": "These two can't be linked.",
        "linkLimit": "At most 8 links per agent.",
        "linkExists": "Already linked.",
        "linkFailed": "Couldn't save the change.",
        "empty": "No agents yet",
        "legendTitle": "How to link",
        "connectHint": "Drag from a dot to another node to link them.",
        "kind": {
          "channel": "Channel",
          "agent": "Agent",
          "tool": "Tool",
          "staff": "Team",
          "kb": "Information",
          "customTool": "External API"
        },
        "edge": {
          "assignment": "Answers on",
          "delegation": "Hands off to",
          "tool": "Uses",
          "handoff": "Human handoff",
          "knowledge": "Reads"
        },
        "tools": {
          "knowledge": "Knowledge",
          "catalog": "Catalog",
          "orders": "Orders",
          "booking": "Booking",
          "sheet": "Sheet"
        },
        "status": {
          "published": "Active",
          "draft": "Draft"
        },
        "panel": {
          "title": "Agent",
          "scope": "Scope",
          "status": "Status",
          "channels": "Channels",
          "tools": "Tools",
          "team": "Hands off to",
          "staff": "Human teams",
          "none": "None",
          "openEditor": "Open full editor",
          "close": "Close"
        },
        "list": {
          "channels": "Channels",
          "agents": "Agents",
          "answers": "Answers on",
          "handoffs": "Hands off to",
          "uses": "Uses",
          "staff": "Human handoff"
        },
        "createAgent": "New agent",
        "createTool": "Tool",
        "createInfo": "New information",
        "createChannel": "Link a channel",
        "createTeam": "Human team",
        "map": {
          "label": "Map",
          "openMap": "Open its map",
          "editorLink": "Its map",
          "channelTitle": "Link a channel to the agent",
          "teamTitle": "Hand off to a human team",
          "pickChannel": "Channel",
          "pickTeam": "Team",
          "pickAgent": "Agent",
          "nothingLeft": "Nothing available to add.",
          "confirm": "Add"
        },
        "link": "Link",
        "linkKbLimit": "At most 20 information sources per agent.",
        "kbKind": {
          "text": "Text",
          "faq": "Questions",
          "url": "Link",
          "website": "Website",
          "file": "File",
          "product": "Product"
        },
        "toolDesc": {
          "knowledge": "Looks up answers in your information.",
          "catalog": "Finds and shows your products.",
          "orders": "Checks an order and sends its link.",
          "booking": "Shows free times and sends a booking link.",
          "sheet": "Reads and saves rows in your sheet."
        },
        "dialog": {
          "cancel": "Cancel",
          "close": "Close",
          "agentTitle": "New agent",
          "agentName": "Agent name",
          "agentType": "What it does",
          "agentCreate": "Create agent",
          "openWizard": "Open the full wizard",
          "toolTitle": "Add a tool",
          "toolHint": "Pick a tool to put on the map.",
          "toolLinked": "It will also be linked to {name}.",
          "infoTitle": "New information",
          "infoName": "Title",
          "infoText": "Text",
          "infoUrl": "Link",
          "infoTabText": "Text",
          "infoTabUrl": "Link",
          "infoSave": "Save",
          "infoLinked": "It will also be linked to {name}."
        },
        "links": {
          "title": "Links",
          "channels": "Channels",
          "tools": "Tools",
          "info": "Information",
          "noChannels": "No channels yet.",
          "noInfo": "No information yet.",
          "moveConfirm": "This channel already answers with {name}. Move it to this agent?",
          "move": "Move",
          "keep": "Keep",
          "custom": "External API tools",
          "noCustom": "No external API tools yet."
        },
        "channelPanel": {
          "title": "Channel",
          "agent": "Agent",
          "none": "None"
        },
        "custom": {
          "option": "External API tool",
          "optionDesc": "Let the agent call your own web service, like a price or stock lookup.",
          "title": "New external API tool",
          "editTitle": "External API tool",
          "linked": "It will also be linked to {name}.",
          "name": "Tool name",
          "description": "When should the agent use it?",
          "method": "Method",
          "url": "Address (https)",
          "urlHint": "You can put a value from the agent in the address by writing the input name in curly braces. Declare the input below first.",
          "headers": "Headers",
          "headerName": "Header name",
          "headerValue": "Header value",
          "saved": "Saved",
          "savedHint": "Saved. Leave the value empty to keep it.",
          "addHeader": "Add header",
          "params": "Inputs the agent fills in",
          "paramName": "Input name",
          "paramType": "Type",
          "typeString": "Text",
          "typeNumber": "Number",
          "paramDescription": "What is it?",
          "paramRequired": "Required",
          "addParam": "Add input",
          "remove": "Remove",
          "enabled": "Active",
          "save": "Save",
          "delete": "Delete tool",
          "test": "Try it",
          "run": "Try",
          "status": "Status: {status}",
          "off": "Off",
          "limit": "An agent can use up to 8 external API tools."
        }
      }
    },
    "autoReplies": {
      "title": "Auto messages",
      "lead": "Choose how the system replies to your customers, then edit the messages under advanced settings.",
      "summary": "{count} of {total} replies are on",
      "channel": {
        "whatsapp_cloud": "WhatsApp (official)",
        "whatsapp_waha": "WhatsApp (QR code)",
        "other": "Channel",
        "numbered": "{name} ({value})"
      },
      "replies": {
        "title": "Your auto-replies",
        "lead": "Pick a reply from the list to edit its text and preview it.",
        "listLabel": "List of replies",
        "scopeHint": "Leave “All channels” for one reply everywhere, or pick a channel to customise its reply.",
        "hint": "Tap a reply to edit it. Use the switch to turn it on or off.",
        "edit": "Edit",
        "noText": "No text yet",
        "inactive": "Not sent in this mode"
      },
      "group": {
        "basic": "Replies to new messages",
        "keywords": "Keyword replies",
        "basicHint": "Sent when a new message arrives.",
        "count": "{count} of {total} on",
        "keywordsHint": "Sent when the customer types a specific word such as “menu” or “agent”."
      },
      "status": {
        "on": "On",
        "off": "Off",
        "unsaved": "Unsaved changes"
      },
      "switchLabel": "Turn on: {name}",
      "strip": {
        "on": "{count} on",
        "off": "{count} off"
      },
      "when": {
        "welcome": "When a customer sends you their first message.",
        "away_message": "When a customer writes outside your working hours (once every 12 hours, also on QR).",
        "no_match": "When Wato does not understand a message and no flow matches it.",
        "get_started": "When a customer taps Get started or arrives from an ad or a link.",
        "location_received": "When a customer shares a location and no flow is waiting for it.",
        "main_menu": "When a customer types “menu”.",
        "back_to_bot": "When a customer types “bot” after being handed to a person.",
        "language_switch": "When a customer types “arabic” or “english”.",
        "talk_to_human": "When a customer types “agent” during business hours.",
        "talk_to_human_off_hours": "When a customer types “agent” outside business hours.",
        "unsubscribe": "When a customer types “stop” to unsubscribe.",
        "resubscribe": "When a customer types “start” to subscribe again.",
        "order_confirm": "When a customer types “confirm order”. Off until you turn it on. It only sends your reply; it does not change the order.",
        "order_cancel": "When a customer types “cancel order”. Off until you turn it on. It only sends your reply; it does not cancel the order."
      },
      "sample": {
        "welcome": "Hello",
        "away_message": "Are you open?",
        "no_match": "I want something else",
        "get_started": "Get started",
        "location_received": "Here is my location",
        "main_menu": "menu",
        "back_to_bot": "bot",
        "language_switch": "english",
        "talk_to_human": "agent",
        "talk_to_human_off_hours": "agent",
        "unsubscribe": "stop",
        "resubscribe": "start",
        "order_confirm": "confirm order",
        "order_cancel": "cancel order"
      },
      "editor": {
        "flow": {
          "label": "Run a flow instead of the text",
          "none": "Send the text only",
          "missing": "Flow no longer available",
          "hint": "Cloud API only. WhatsApp QR channels keep sending the text; if the flow cannot start, the text is sent."
        },
        "sheet": {
          "label": "Also add a row to a Google Sheet",
          "spreadsheetId": "Spreadsheet ID (from the sheet link)",
          "sheetName": "Tab name",
          "name": "Column for contact name",
          "phone": "Column for phone",
          "message": "Column for message",
          "time": "Column for time",
          "hint": "Needs Google connected in Integrations. If it is not connected, the reply is still sent."
        },
        "whenLabel": "When is it sent?",
        "languageHint": "The Arabic text goes to customers writing in Arabic and the English text to those writing in English. If you leave one empty, the other is sent.",
        "firesInBasic": "Works when the channel is in “Chat flows” mode.",
        "firesInKeyword": "Works in “Chat flows” and “AI agent” modes, and does not work in “No automatic reply”.",
        "inactiveTitle": "This reply is not being sent right now",
        "inactiveBody": "Your channel's current mode does not send it. Change the mode in the card above.",
        "emptyWarning": "This reply is on but its text is empty, so nothing will be sent.",
        "rule": {
          "welcome": "Sent only once per customer, on their first message.",
          "away_message": "Sent once per customer every 12 hours, never to groups, never right after a team member replied."
        },
        "exampleLabel": "Example:",
        "useExample": "Use this example"
      },
      "example": {
        "welcome": "Welcome! Thanks for contacting us. How can we help you?",
        "away_message": "We are closed right now. We received your message and will reply as soon as we are back.",
        "no_match": "Sorry, I did not understand your message. Type “menu” to see the options or “agent” to talk to a person."
      },
      "hours": {
        "title": "Business hours",
        "explain": "Out of hours = outside the hours set here. Edit your hours so Wato knows when to send this reply.",
        "toggle": "Show and edit business hours"
      },
      "idle": {
        "title": "All new-message replies are off",
        "body": "Start with the welcome reply: a short message Wato greets every new customer with.",
        "cta": "Set up the welcome reply"
      },
      "preview": {
        "business": "Your store",
        "empty": "You have not written the reply yet. What your customer receives will appear here.",
        "captionOn": "As received by a customer writing in English.",
        "captionOff": "This reply is off, so the customer will not get it right now. This is how it will look once turned on."
      },
      "advanced": {
        "title": "Advanced settings",
        "hint": "Reply texts, chat flows, keywords and more."
      },
      "menuHealth": {
        "title": "Customers who write something unknown get no answer",
        "body": "Your official WhatsApp number has no main menu to fall back on, so messages that match no keyword get silence. Add a starter menu with buttons for services, location and talking to staff — you can edit it afterwards.",
        "action": "Add starter menu",
        "installing": "Adding…",
        "done": "Starter menu added and published"
      }
    },
    "templatesGuide": {
      "intro": {
        "what": "A message template is a message you write once and Meta approves. It is the only kind of message you can send to a customer after 24 hours have passed since their last message.",
        "when": "Use it for order updates, reminders and offers to customers who have not written to you today."
      },
      "empty": {
        "title": "You have no message templates yet",
        "what": "Without an approved message template you cannot message customers after the 24-hour window.",
        "step1": "Create a message template, or import one from the gallery.",
        "step2": "Submit it to Meta for review.",
        "step3": "When it shows Approved, use it in a broadcast or a sequence.",
        "cta": "Create a message template",
        "noPermission": "You do not have permission to create message templates. Ask the workspace owner to give you the templates permission."
      },
      "blocked": {
        "noChannelTitle": "Message templates need an official number",
        "noChannelReason": "Message templates are not available on QR channels: only an official WhatsApp Cloud number can send them, because Meta does not review messages sent through QR.",
        "noChannelCta": "Connect an official number",
        "forbiddenTitle": "You cannot view message templates",
        "forbiddenReason": "Your role does not include viewing message templates.",
        "forbiddenCta": "See who can change roles"
      },
      "library": {
        "emptyTitle": "The library has nothing for this number",
        "emptyReason": "Meta returned no ready templates for this channel right now.",
        "emptyCta": "Write your own message template"
      }
    },
    "marketplaceGuide": {
      "intro": {
        "title": "What is the marketplace?",
        "what": "The marketplace has ready-made packs from Wato and partners that you can install in one click.",
        "when": "Use it when you want a complete working setup instead of building each part yourself.",
        "step1": "Pick a pack and read what it includes.",
        "step2": "Install it. It arrives as a separate draft; your current work is not touched.",
        "step3": "Review it and use it.",
        "businessName": "Rose Garden",
        "caption": "Example: after installing an abandoned-cart pack, this is what your customer receives.",
        "msg1": "Hello Sara, you left 2 items in your cart. Want to finish your order?",
        "msg1Button": "Complete my order",
        "msg2": "Yes please",
        "time1": "10:02",
        "time2": "10:05"
      },
      "empty": {
        "title": "No packs have been published yet",
        "what": "When a pack is published it appears here. Meanwhile you can write your own message template or start from the Meta library.",
        "cta": "Go to my message templates"
      },
      "error": {
        "title": "The marketplace could not be loaded",
        "reason": "The connection to the marketplace failed. Nothing was installed.",
        "cta": "Try again"
      }
    },
    "guarantee": {
      "b29b": {
        "point1": "We measure how many chats your assistant answers on its own.",
        "point2": "Period: your first 30 days live.",
        "point3": "If the share stays under the target, you can claim a refund of the first month."
      },
      "nav": "Results guarantee",
      "title": "Results guarantee",
      "subtitle": "Track your first 30 days against the guarantee and claim your refund if the target is missed.",
      "intro": {
        "title": "How the results guarantee works",
        "what": "If your assistant does not handle enough customer conversations on its own during your first 30 days, you can claim a refund of your first month.",
        "when": "Use this page to join the guarantee, follow your progress and claim the refund when it is offered.",
        "step1": "Join the guarantee in your first billing cycle.",
        "step2": "Your assistant answers customers and we measure the share it handles on its own.",
        "step3": "If the target is missed, choose a refund to your card or a wallet credit.",
        "businessName": "Your store",
        "caption": "What a customer sees while the assistant handles the chat on its own.",
        "msg1": "Hello, do you deliver to Riyadh?",
        "msg2": "Yes, we deliver to Riyadh within 2 days. Would you like to order?",
        "time": "10:02"
      },
      "what": {
        "title": "What the guarantee covers"
      },
      "conditions": {
        "title": "Conditions",
        "c1": "You must join in your first billing cycle, and only once.",
        "c2": "Your assistant must be live: an active chat flow or AI agent, a verified number and business hours.",
        "c3": "The target is {threshold}% of conversations handled automatically over {days} days.",
        "c4": "You can pause automation for at most {cap} days. More than that voids the guarantee.",
        "c5": "The refund goes to your original payment method or to your wallet, your choice."
      },
      "status": {
        "title": "Your claim status",
        "day": "Day {day} of 30",
        "rate": "Handled automatically: {rate}% of the {threshold}% target",
        "paused": "{days} paused days are excluded"
      },
      "state": {
        "notEnrolled": {
          "title": "You have not joined the guarantee",
          "reason": "Joining is one time only and must happen in your first billing cycle.",
          "cta": "Join"
        },
        "inProgress": {
          "title": "Your window is running",
          "reason": "Not eligible yet: you can claim only if the target is missed when the 30 days end. {days} days left.",
          "cta": "Improve your automation"
        },
        "evaluating": {
          "title": "We are measuring your result",
          "reason": "The 30 days have ended. The result will appear here within a day.",
          "cta": "Open the billing page"
        },
        "claimable": {
          "title": "You are eligible for a refund",
          "reason": "The target was missed in your first 30 days. Choose how you want the refund.",
          "original": "Refund",
          "wallet": "Wallet credit"
        },
        "refunded": {
          "title": "Refund issued",
          "reason": "The claim window is closed: your refund was issued.",
          "cta": "Open the billing page"
        },
        "met": {
          "title": "Target reached",
          "reason": "No claim is needed: your assistant reached the target, so the guarantee is complete.",
          "cta": "See your analytics"
        },
        "voided": {
          "title": "The guarantee no longer applies",
          "reason": "Automation was paused for more than the allowed days, or the conditions were not met.",
          "cta": "Contact support"
        },
        "closed": {
          "title": "The claim window is closed",
          "reason": "Joining is only possible in your first billing cycle, and that cycle has ended.",
          "cta": "Open the billing page"
        }
      },
      "history": {
        "title": "History",
        "empty": "Nothing yet. Events appear here once you join.",
        "windowRunning": "Window running: day {day} of 30",
        "outcome": {
          "met_threshold": "Target reached",
          "refunded": "Refund issued",
          "voided_ineligible": "Guarantee voided",
          "notice_sent": "Refund offered: waiting for your choice"
        }
      },
      "actions": {
        "joined": "You joined the guarantee.",
        "chosen": "Your refund choice was recorded.",
        "error": "Could not complete the action. Try again.",
        "errors": {
          "not_first_cycle": "Joining is only possible in your first billing cycle.",
          "already_opted_in": "You already joined the guarantee.",
          "not_ready": "Your assistant is not live yet, so the guarantee cannot start.",
          "no_refund_due": "There is no refund due on your account.",
          "no_tracking": "Join the guarantee first.",
          "guarantee_disabled": "The guarantee is not available right now.",
          "invalid_choice": "Choose a valid refund method."
        }
      },
      "forbidden": "You do not have access to billing, so you cannot see the guarantee.",
      "viewDetails": "Claims and details"
    },
    "support": {
      "title": "Support",
      "subtitle": "Send us a request and follow our replies here. You will also see the answer in this page, not only by email.",
      "helpLink": "Contact support",
      "intro": {
        "title": "How support works",
        "what": "Write to the Wato team about a problem or a question, and follow the status of every request in one place.",
        "when": "Use it when something does not work as expected, a payment or channel looks wrong, or you need help setting up.",
        "step1": "Write a short subject and pick the topic closest to your request.",
        "step2": "Describe what happened and what you expected.",
        "step3": "Follow the replies on the request page and answer from there.",
        "businessName": "Wato support",
        "caption": "An example of a request and our reply",
        "msg1": "My WhatsApp number shows as disconnected since this morning.",
        "msg2": "Thanks for writing. We checked the channel and sent you the steps to reconnect it. Tell us if it still fails."
      },
      "expect": {
        "title": "What to expect",
        "time": "We reply within one working day, usually sooner. Urgent payment problems are handled first.",
        "include": "Please include: what you were doing, what you saw on screen, and the time it happened.",
        "noSecrets": "Do not write passwords or card numbers in a request."
      },
      "form": {
        "title": "New request",
        "subject": "Subject",
        "category": "Topic",
        "message": "Details",
        "messageHint": "For example: I sent a broadcast at 10:00 and it stayed on sending.",
        "submit": "Send request"
      },
      "category": {
        "billing": "Plan and payments",
        "channels": "WhatsApp channels",
        "ai": "AI agent",
        "other": "Something else"
      },
      "status": {
        "open": "Received",
        "pending": "We are working on it",
        "resolved": "Resolved",
        "escalated": "Escalated to a specialist"
      },
      "list": {
        "title": "Your requests"
      },
      "empty": {
        "title": "You have not sent any request yet",
        "what": "When you send a request it appears here with its status, and our replies show up on the request page."
      },
      "thread": {
        "back": "Back to support",
        "status": "Status: {status}",
        "label": "Conversation",
        "you": "You",
        "staff": "Wato support",
        "replyLabel": "Your reply",
        "send": "Send reply"
      }
    },
    "winback": {
      "title": "Win-back",
      "subtitle": "Win-back is a polite message to customers who bought from you before but have not ordered for a while. The system finds them and drafts a message for each one. Nothing is sent until a team member reads it and approves it.",
      "who": "Who gets a message: only customers who bought before, have been inactive for the dormancy period, have not re-ordered since, and have agreed to receive messages.",
      "approval": "Who approves: people do, always. Every message waits here for your approval and you can edit its wording first.",
      "contactLabel": "Customer {name}",
      "intro": {
        "title": "How win-back works",
        "what": "Win-back brings back customers who stopped ordering, with one friendly message and no pressure.",
        "when": "Use it when you want to re-engage past customers without messaging everyone yourself.",
        "step1": "The system finds customers who have not ordered for a while.",
        "step2": "It drafts a short message for each one and lists it here.",
        "step3": "You edit if you like, then approve. Only approved messages are sent.",
        "businessName": "Your store",
        "caption": "Example of what your customer receives after you approve.",
        "msg1": "Hi Sara, we miss you! It has been a while since your last order. Here is 10% off your next one.",
        "customerReply": "Thanks! Can I see the new arrivals?",
        "msg2": "Of course, here they are. Tell us if you need any help."
      },
      "empty": {
        "title": "No win-back drafts waiting",
        "what": "When customers go quiet, the system drafts a message for each one and it appears here for your approval.",
        "step1": "Customers who have not ordered for a while are found automatically.",
        "step2": "A draft message is prepared for each one.",
        "step3": "You review and approve before anything is sent."
      },
      "locked": {
        "title": "Win-back is not in your plan",
        "reason": "Your current plan does not include AI-drafted outbound messages, so win-back cannot run.",
        "cta": "See plans"
      },
      "noChannel": {
        "title": "Connect the official WhatsApp channel first",
        "reason": "Win-back messages are sent with approved templates, which need the official WhatsApp Cloud API channel. A QR channel cannot send them.",
        "cta": "Connect a channel"
      }
    },
    "verticalPacks": {
      "nav": "Ready solutions: industry setups",
      "page": {
        "title": "Ready for your business",
        "subtitle": "A setup is a ready bundle for your type of business (salon, clinic, restaurant…): chat flows, message templates, forms and an AI agent. Everything is added as drafts, so nothing is sent until you review and turn it on."
      },
      "intro": {
        "title": "What are ready industry setups?",
        "what": "A ready setup adds the chat flows, message templates, forms and AI agent that businesses like yours usually need.",
        "when": "Use it when you are starting out or opening a new type of service, instead of building each piece from scratch.",
        "step1": "Pick the setup that matches your business and read what it adds.",
        "step2": "Confirm the installation. Everything arrives as a draft and your own work is never overwritten.",
        "step3": "Review each draft, edit it, then turn it on when you are happy.",
        "businessName": "Rose Salon",
        "caption": "Example of a booking chat that a salon setup prepares for you.",
        "msg1": "Welcome to Rose Salon! What would you like to book?",
        "msg2": "A haircut tomorrow evening.",
        "msg3": "We have 6:00 PM and 7:30 PM. Pick one:",
        "msg3Button": "6:00 PM"
      },
      "empty": {
        "title": "No ready setups available yet",
        "what": "When setups for your industry are published they will appear here, with exactly what each one adds."
      },
      "card": {
        "version": "Version {version}",
        "includesTitle": "What it adds",
        "includes": "What {name} adds",
        "draftsNote": "Added as drafts. Your own work is never changed.",
        "install": "Install",
        "uninstall": "Uninstall"
      },
      "status": {
        "installed": "Installed",
        "available": "Not installed"
      },
      "types": {
        "flow": "{count, plural, one {Chat flow} other {Chat flows}}",
        "template": "{count, plural, one {Message template} other {Message templates}}",
        "form": "{count, plural, one {Form} other {Forms}}",
        "ai_agent": "{count, plural, one {AI agent} other {AI agents}}",
        "label": "{count, plural, one {Label} other {Labels}}"
      },
      "confirm": {
        "installTitle": "Install “{name}”?",
        "uninstallTitle": "Uninstall “{name}”?",
        "installNote": "These items will be added to your workspace as drafts. Nothing is turned on or sent, and nothing you built is changed. If a name already exists, a number is added to the new one.",
        "uninstallNote": "Only the items below that belong to the setup are removed. Past conversations, orders and bookings are never touched.",
        "willAdd": "Will be added",
        "willRemove": "Will be removed",
        "willKeep": "Will stay as your own items",
        "nothingRemoved": "Nothing will be removed.",
        "installAction": "Install as drafts",
        "uninstallAction": "Uninstall",
        "cancel": "Cancel"
      },
      "installed": "“{name}” was installed. Review the drafts and turn them on when ready.",
      "uninstalled": "“{name}” was uninstalled.",
      "blocked": {
        "planTitle": "Your plan does not include ready setups",
        "planReason": "Upgrade your plan to install ready industry setups.",
        "planCta": "See plans",
        "noChannelReason": "Connect a WhatsApp channel first so the setup has somewhere to work.",
        "noChannelCta": "Connect a channel"
      }
    },
    "carts": {
      "title": "Carts",
      "subtitle": "Carts your team started in chat that are still waiting for the customer.",
      "tabs": {
        "pending": "Pending",
        "abandoned": "Abandoned"
      },
      "col": {
        "customer": "Customer",
        "items": "Items",
        "total": "Total",
        "age": "Age",
        "actions": "Actions"
      },
      "emptyHidden": "{count} empty carts hidden (opened in a chat but no products added).",
      "unknownCustomer": "Unknown customer",
      "itemsCount": "{count} items",
      "ageHours": "{count} h ago",
      "ageDays": "{count} d ago",
      "reviewDiscount": "Review discount",
      "openChat": "Open inbox",
      "abandonedNote": "These carts were sent to the customer but never paid. Reminders go out automatically; nothing is sent from this page.",
      "reminderSettings": "Reminder settings",
      "intro": {
        "title": "How carts and reminders work",
        "what": "A cart is a list of products you prepared for a customer in chat. It is abandoned when you sent it, the customer did not pay, and the waiting time you chose has passed.",
        "when": "When a cart becomes abandoned, WATO sends the customer up to a few friendly reminders, spaced out as you set. Reminders stop as soon as the customer pays or cancels. They only go through the official WhatsApp Cloud API channel, inside quiet hours and opt-out rules.",
        "step1": "You send a cart to the customer from the chat.",
        "step2": "If the customer does not pay, the cart moves to Abandoned after your waiting time.",
        "step3": "WATO reminds the customer. Any discount still needs a person to approve it.",
        "businessName": "Rose Garden",
        "caption": "What the customer receives for an abandoned cart",
        "msg1": "Your cart is ready: 2 items, SAR 240.00. Pay here when you like.",
        "time1": "Day 0",
        "msg2": "Thanks, I will check.",
        "time2": "Day 0",
        "msg3": "Hi! Your cart is still waiting for you. Want to complete your order?",
        "msg3Button": "Pay now",
        "time3": "Day 1"
      },
      "empty": {
        "pending": {
          "title": "No pending carts",
          "body": "When you prepare a cart for a customer in chat, it appears here until it is paid."
        },
        "abandoned": {
          "title": "No abandoned carts",
          "body": "Carts the customer did not pay after your waiting time will show up here, and WATO reminds the customer."
        }
      },
      "blocked": {
        "noStore": {
          "title": "No store connected",
          "body": "Connect your store so products can be added to carts.",
          "cta": "Connect a store"
        },
        "noCloud": {
          "title": "No official WhatsApp channel",
          "body": "Cart reminders are sent only through the official WhatsApp Cloud API channel. Channels linked with a QR code cannot send them.",
          "cta": "Open channels"
        }
      },
      "partial": {
        "title": "Some details could not be loaded",
        "body": "Missing: {list}. The carts below are still accurate.",
        "retry": "Try again",
        "parts": {
          "contacts": "some customer names",
          "store": "store status",
          "channels": "channel status"
        }
      }
    },
    "knowledgeIntro": {
      "knowledge": {
        "title": "How the knowledge base works",
        "what": "The knowledge base is the information you add about your business (text, questions and answers, links and files). The AI agent looks things up there so it answers customers with what you wrote.",
        "when": "Add your prices, opening hours, shipping and return policies, and anything customers often ask. If the agent cannot find the answer in your sources it does not guess; it hands the chat to a person.",
        "step1": "Add a source: write text or questions and answers, add a link or your website, or upload a file.",
        "step2": "Wait until the source status is “Ready”, then try a question in the test search to see which passages the agent will rely on.",
        "step3": "Review the questions the agent handed to a person, and add what your knowledge base is missing so it can answer them next time.",
        "businessName": "Rose Garden",
        "caption": "Example: an answer taken from the “Shipping and delivery” page of the knowledge base, then a handoff when the answer is not there.",
        "msg1": "Do you deliver to Jeddah? How long does it take?",
        "time1": "10:02",
        "msg2": "Yes, we deliver to Jeddah within two to three working days, and delivery is free for orders over 200 SAR.",
        "time2": "10:02",
        "msg3": "Can I change the delivery address after I pay?",
        "time3": "10:03",
        "msg4": "I could not find that in the store's information, so I am handing you over to one of our team to continue with you.",
        "time4": "10:03"
      },
      "testConsole": {
        "title": "How the test console works",
        "what": "The test console is a practice chat with your agent that uses its current instructions and knowledge base. Nothing from it reaches real customers and no credits are charged.",
        "when": "Try the agent after changing its instructions or adding knowledge sources and before you publish it, and check that it answers from your sources and hands the chat to a person when it does not know.",
        "step1": "Pick the agent you want to test.",
        "step2": "Type a question the way your customer would, and check that the answer comes from the knowledge base or that the agent hands the chat to a person.",
        "step3": "Run the adversarial probes for your business template, and adjust the instructions or sources if a result is not what you expected.",
        "businessName": "Rose Garden",
        "caption": "Example: a question answered from the knowledge base, then a request the agent cannot answer, which it hands to a person.",
        "msg1": "When are you open on Friday?",
        "time1": "10:02",
        "msg2": "We are open on Friday from 4 PM to 11 PM, according to the opening hours in the knowledge base.",
        "time2": "10:02",
        "msg3": "I want to return a bouquet I bought yesterday.",
        "time3": "10:03",
        "msg4": "Return requests are reviewed by one of our team. I am handing you over to them now.",
        "time4": "10:03"
      }
    },
    "analyticsIntro": {
      "commerce": {
        "title": "How to read the sales numbers",
        "what": "This page shows how many carts and quotes you sent to customers on WhatsApp, how many ended in a paid order, and how much you sold each day.",
        "when": "Open it after a campaign or offer to see whether it produced sales, or when you notice many carts but few paid orders.",
        "step1": "Pick the date range at the top.",
        "step2": "In the sales funnel, carts created are the ones you sent to customers, quotes sent are price quotes, paid orders are what customers actually paid for, and the conversion rate beside each stage is the share that moved on from the stage before it.",
        "step3": "In the daily table, total sales is the sum of paid orders, average order value is total sales divided by the number of orders, and customer lifetime value is what a customer spends with you on average over time."
      },
      "templates": {
        "title": "How to read template performance",
        "what": "This page compares the WhatsApp message templates you sent: how many arrived, how many were read, how many customers engaged with, and what they cost.",
        "when": "Use it to see which template deserves to keep going and which needs a change or a stop before your next campaign.",
        "step1": "Pick the date range, and you can narrow the list to one template category.",
        "step2": "Sent is the number of messages sent, delivered is what reached the customer's phone, read is what the customer opened, replied is what the customer answered, clicked is what the customer tapped a button or link in, and converted is what led to an order.",
        "step3": "Cost is what you paid for these messages; compare it with converted to see which template gives you a better result for less."
      },
      "leaderboard": {
        "title": "How to read the agent leaderboard",
        "what": "This board ranks your team by how fast they reply, customer satisfaction, quotes and revenue in the chosen period, and it stays off until you turn it on.",
        "when": "Use it in regular team reviews and to motivate the team, not to judge a person from a single number.",
        "step1": "Turn the board on if it is off, then pick the date range.",
        "step2": "First reply is the average time before the agent answers the customer, resolution time is the average time until the chat is closed, and customer satisfaction is the average rating customers give the agent.",
        "step3": "Quotes sent are the price quotes the agent sent, accepted are the ones customers approved, and attributed revenue is the sales from paid orders that came from their quotes."
      },
      "entryPoints": {
        "title": "How to read entry points",
        "what": "This page shows where your customers came to WhatsApp from, such as click-to-WhatsApp ads and other sources, and how much they paid.",
        "when": "Use it to see which campaign brings customers who actually buy, not just messages, and put your budget there.",
        "step1": "Pick the date range, then group the results by campaign or by source.",
        "step2": "Contacts are the people who started a new chat with you from this entry point, paid orders are what they paid for, and revenue is the total amount paid.",
        "step3": "A campaign has ad sets and ads under it; compare revenue between ads to see which is worth keeping, and you can export the results to a file."
      }
    },
    "developerIntro": {
      "apiKeys": {
        "title": "How API keys work",
        "what": "An API key is a private password that lets another system, such as your website or store, work with your WATO account without anyone signing in.",
        "when": "Create one when a developer or a tool you use needs to read or send data in WATO, for example to add contacts from your website or to send verification codes.",
        "step1": "Select New API key, give it a name, and choose only the access each module needs: read, or read and write.",
        "step2": "Copy the key straight away. It is shown in full only once, so keep it somewhere safe and never send it in a chat or an email.",
        "step3": "If a key leaks or is no longer needed, revoke it and the system using it stops working immediately. Or use Rotate to swap it for a new one while the old one keeps working for a short while."
      },
      "otp": {
        "title": "How WhatsApp sign-in codes work",
        "what": "A one-time code (OTP) is a short code your customer types to prove the phone number is theirs, for example when signing in or confirming an order. WATO sends it on WhatsApp and falls back to SMS if WhatsApp cannot deliver it.",
        "when": "You need it if your website or app signs customers in with their phone number and you want the code to reach them where they already read their messages. This page shows how many codes you sent, how many were verified and what they cost.",
        "step1": "Create an API key that allows OTP, from the API keys page.",
        "step2": "Your developer asks WATO to send a code to the customer's number, then checks the code the customer typed.",
        "step3": "Come back here for the numbers: sent, verified, failed, SMS fallbacks and spend. Each code is billed, and WhatsApp and SMS have different prices."
      },
      "webhooks": {
        "title": "How webhooks work",
        "what": "A webhook is an automatic message between two systems. An incoming webhook lets another system start a flow in WATO; an outgoing one tells your own system when something happens in WATO, such as a new message or a paid order.",
        "when": "Use them when you want your website, your customer system or a tool such as n8n or Zapier to react to WATO events, or when you want to start a flow from outside WATO.",
        "step1": "For incoming, create a webhook, pick the flow it starts and give the signed URL to the other system. For outgoing, enter your system's address and choose the events you want.",
        "step2": "Copy the secret as soon as it appears. It is shown only once, and you use it to check that each event really came from WATO.",
        "step3": "Send a test event, then follow the delivery log. Every event is signed, and if your system does not answer, WATO tries again and you can replay any event from the log."
      },
      "googleSheets": {
        "title": "How the Google Sheets connection works",
        "what": "This connects your Google account so your flows can add, update and look up rows in your spreadsheets, for example saving every new order or checking a customer's balance.",
        "when": "Connect it once before you use a Google Sheets step in a flow, or whenever you want customer data kept in a spreadsheet your team already uses.",
        "step1": "Select Connect Google Sheets and sign in to Google. You are asked to allow access to spreadsheets only.",
        "step2": "Add a Google Sheets step to a flow and choose the spreadsheet and the columns to fill.",
        "step3": "To stop, select Disconnect. Only the spreadsheet access is removed, so your Calendar and Docs connections stay as they are, and you are warned first if a published flow still uses Sheets."
      },
      "docTemplates": {
        "title": "How document templates work",
        "what": "A document template is a Google Doc with placeholders in double braces, such as the customer name or a total. WATO fills them in and creates a finished PDF for the customer, such as a quote or a booking confirmation.",
        "when": "Use it when you send the same kind of document again and again and want it to look the same every time without retyping it.",
        "step1": "Write the document in Google Docs and put a placeholder wherever a value should appear, then paste its link here and select Add template.",
        "step2": "Choose where each placeholder gets its value: the contact, a cart, a quote, a booking or a custom field, and confirm each suggestion.",
        "step3": "Once the template shows Ready to use, WATO fills in the values for each customer and creates the PDF."
      },
      "automations": {
        "title": "How automation templates work",
        "what": "These are ready-made n8n workflows that connect WATO with other tools, for example sending contacts to a Google Sheet or sending a WhatsApp message when your store gets an order.",
        "when": "Start here when you want to link WATO to another tool without building the workflow from scratch. Zapier and Make connect through webhooks instead.",
        "step1": "Choose a template and read which access it needs.",
        "step2": "Select Import to n8n and the workflow is copied into your n8n account.",
        "step3": "Open it in n8n, add your own credentials for the other tool, test it and turn it on."
      },
      "credentials": {
        "title": "How stored credentials work",
        "what": "This is the safe where WATO keeps the keys and connections you added, such as your email provider, Google Contacts and email-marketing tools, and it shows what uses each one.",
        "when": "Open it to check what is connected, to set up the email provider that sends notifications, or to cut off a key you no longer trust.",
        "step1": "Review the list. Each item shows what uses it and when it was last used.",
        "step2": "Add or change a connection in its own section. Secrets are stored encrypted and are never shown again after you save, so keep your own copy.",
        "step3": "To remove access, revoke the credential. You are warned if something still depends on it."
      },
      "customApi": {
        "title": "How to connect a custom REST store",
        "what": "If your store runs on your own system rather than a ready-made platform, you can connect it through its REST API so WATO can read your products and orders.",
        "when": "You need it when your developer can give you the store's API address and a key. If you have no API, import your products from a CSV file instead.",
        "step1": "Enter the store's API address and key, and the header name if it is not the standard one. The key is stored encrypted and never shown again.",
        "step2": "Run the connection test. You cannot activate until it passes, and changing any field means testing again.",
        "step3": "Activate the connection, then copy the store id and the signing secret into your store so it can send order events to WATO."
      },
      "customCsv": {
        "title": "How to import products from a CSV file",
        "what": "A CSV file is a spreadsheet saved as a simple text file. Importing it fills your WATO catalog with your products, with no store platform needed.",
        "when": "Use it when your products live in a spreadsheet or your store has no API. A store imported from a file does not sync by itself, so upload a new file whenever prices or stock change.",
        "step1": "Choose your file and the price currency, then match your columns to SKU, name and price (required) and the optional fields.",
        "step2": "Check the preview: how many products will be added, changed or removed, and which rows have problems and will be skipped.",
        "step3": "Select Import products. When you upload again, choose Merge by SKU to keep your other products, or Replace to remove products missing from the file."
      },
      "collisions": {
        "title": "How SKU collisions work",
        "what": "A SKU is the unique code of a product. A collision happens when the same SKU arrives from more than one connected store, so WATO cannot tell which product to use.",
        "when": "Check this page after you connect another store or import a file, so that each SKU points to one product only.",
        "step1": "Open a collision and compare the products that share the SKU: each one's name, the connection it came from and its price.",
        "step2": "Select Keep this one on the correct product.",
        "step3": "The chosen product is marked Kept and the collision counts as resolved."
      },
      "widget": {
        "title": "How the website chat widget works",
        "what": "The widget is a small chat button you add to your website. When a visitor taps it, WhatsApp opens with a ready message to your business, so website visitors become real WhatsApp conversations.",
        "when": "Use it if you have a website and want visitors to reach you without hunting for your number. It can show a different greeting outside your working hours.",
        "step1": "Enter your WhatsApp number, display name, logo, colors and greeting.",
        "step2": "Save your changes, then copy the embed snippet.",
        "step3": "Paste the single tag into your website before the closing body tag. On a computer it can show a QR code or open WhatsApp Web inside the page.",
        "businessName": "Rose Garden",
        "caption": "A visitor taps the widget and their first message arrives",
        "msg1": "Hi, I found you on your website. Do you deliver to Riyadh?",
        "time1": "10:02",
        "msg2": "Welcome! Thanks for reaching out from our website. Yes, we deliver across Riyadh. What would you like to order?",
        "time2": "10:03"
      },
      "shortLinks": {
        "title": "How short links and QR codes work",
        "what": "A short link is a short web address that opens a WhatsApp chat with your business, with a first message already typed. A QR code does the same when a customer scans it with their phone.",
        "when": "Use them where a long link will not fit: print, packaging, shop windows, social media profiles and ads. Each link counts its clicks, so you see where customers come from.",
        "step1": "Enter your WhatsApp number and the message to pre-fill, and optionally a custom name and an expiry date.",
        "step2": "Create the link and share it, or download its QR code to print.",
        "step3": "Follow the list to see how many times each link was used. When a customer scans or taps, the chat opens with your message ready to send.",
        "businessName": "Rose Garden",
        "caption": "A customer scans your QR code and their first message arrives",
        "msg1": "Hi, I scanned your code. I would like to see your offers.",
        "time1": "10:02",
        "msg2": "Welcome! Thanks for scanning. Here are this week's offers. Tell me what you would like.",
        "time2": "10:03"
      },
      "overview": {
        "title": "How to read the analytics overview",
        "what": "This page sums up your WhatsApp activity for the period you choose: new conversations, messages sent and received, how much was handled automatically, what it cost and the revenue that came through chat.",
        "when": "Open it for a weekly or monthly check on how busy you are and what it costs, and to spot a quiet or unusually expensive period.",
        "step1": "Pick the dates at the top and, if you want, a single channel.",
        "step2": "Read the cards: new, still open and closed conversations, then messages and the automation rate.",
        "step3": "Check the cost cards for AI and Meta (the Meta figure is an estimate), then the daily table to see which day changed."
      },
      "payments": {
        "title": "How to read payment link results",
        "what": "This page follows the payment links you sent to customers: how many were created, how many were opened and how many were paid, and how long customers take to pay.",
        "when": "Use it to see whether customers are paying, and to find out why when many links are opened but few are paid.",
        "step1": "Pick the date range at the top.",
        "step2": "In the link numbers, created, opened and paid show how many links reached each stage, and the open rate and paid rate show their share of the stage before.",
        "step3": "In the failure reasons table, see why payments failed, so you can fix the cause or send a fresh link."
      },
      "vouchers": {
        "title": "How voucher pools work",
        "what": "A voucher pool is a list of ready codes, such as discount or gift codes, that your flows hand out automatically, one code per customer.",
        "when": "Use it when you have a limited set of codes from a partner or a campaign and every customer should get a different one.",
        "step1": "Create a pool and give it a clear name.",
        "step2": "Upload a CSV file of codes. The page tells you how many codes were added and how many were skipped.",
        "step3": "Use the pool in a flow, watch the remaining count and add more codes before it runs out."
      },
      "automationSettings": {
        "title": "How automation settings work",
        "what": "This page controls the automatic messages WATO sends for your store, such as order updates, cash-on-delivery confirmation, abandoned-cart reminders, failed-payment retries and review requests.",
        "when": "Open it to turn an automation on or off, to change how long WATO waits, or to change the message it sends.",
        "step1": "Find the automation and turn it on or off. Turning it off cancels reminders that are already scheduled.",
        "step2": "Set the timing: the hours before the first reminder, the hours between reminders and the maximum number of reminders.",
        "step3": "Choose the message: free text inside the 24-hour window and an approved template outside it, then save."
      }
    },
    "bookingsIntro": {
      "list": {
        "title": "How bookings work",
        "what": "Every appointment your customers book on WhatsApp, or that you add with New booking, appears here, as a table or as a day or week calendar, with its service, staff member and status.",
        "when": "Use it to follow today's appointments, change a booking's status, or drag a confirmed booking to another time. The customer receives a WhatsApp message with the new details.",
        "step1": "Add your services and staff first.",
        "step2": "A customer picks a slot and WATO confirms the booking in the chat.",
        "step3": "Follow the booking here or move it to another time.",
        "businessName": "Noor Salon",
        "caption": "What the customer receives about their booking",
        "msg1": "Your booking is confirmed: Haircut with Sara, Sunday at 5:00 PM.",
        "time1": "10:02",
        "msg2": "Great, thank you!",
        "time2": "10:03",
        "msg3": "Your booking was moved to Sunday at 6:00 PM. See you then.",
        "time3": "10:30"
      },
      "services": {
        "title": "How services work",
        "what": "A service is something customers can book from you, such as a haircut or a consultation, with its price, duration and capacity per slot.",
        "when": "Add your services before you accept bookings. You can also let a service be sold in carts and quotes.",
        "step1": "Press New service and enter the name, price and duration.",
        "step2": "Set the capacity per slot and the buffer after it.",
        "step3": "Save it, then assign it to the staff who deliver it."
      },
      "staff": {
        "title": "How staff work",
        "what": "A staff member is a person who delivers your services. Each one has weekly working hours and a list of services.",
        "when": "Add staff so customers only see slots when someone is free. Connect a Google Calendar so confirmed bookings appear there and outside events block slots.",
        "step1": "Add the staff member's name.",
        "step2": "Set the weekly working hours. You can split a day into shifts.",
        "step3": "Choose the services this person can deliver."
      },
      "waitlist": {
        "title": "How the waitlist works",
        "what": "When a customer asks for a slot that is already full, they join the waitlist in the order they asked. This page shows each entry and its status.",
        "when": "When a booking is cancelled, WATO messages the next person in line. They have limited time to reply, and if they do not, the slot passes to the next person.",
        "step1": "A customer asks for a full slot and joins the list.",
        "step2": "A booking is cancelled and the first in line is notified.",
        "step3": "If they confirm in time the booking is made, otherwise it moves to the next one.",
        "businessName": "Noor Salon",
        "caption": "What a waitlisted customer receives when a slot opens",
        "msg1": "Good news! A slot opened up for Haircut on Sunday at 5:00 PM. Reply YES soon to book it before it goes to the next person.",
        "time1": "14:20",
        "msg2": "Yes",
        "time2": "14:22",
        "msg3": "Done, your booking is confirmed. See you then!",
        "time3": "14:22"
      },
      "settings": {
        "title": "How booking settings work",
        "what": "These are the defaults for all your services: business hours, how far ahead customers can book, the buffer between bookings and the capacity per slot.",
        "when": "Set them once before you take bookings. Any service can override them further down.",
        "step1": "Set your business hours.",
        "step2": "Choose how far ahead customers can book and the buffer between bookings.",
        "step3": "Save, then override a service only if it differs from the rest."
      },
      "empty": {
        "list": {
          "body": "When customers book on WhatsApp, their appointments appear here, and you can also add one yourself with the New booking button. Add a service first so they have something to book."
        },
        "services": {
          "body": "Add your first service so customers can start booking it."
        },
        "staff": {
          "body": "Add the people who deliver your services, with their working hours."
        },
        "waitlist": {
          "body": "When a slot is full, customers who ask for it wait here and are notified as soon as it opens."
        }
      }
    },
    "campaignsIntro": {
      "title": "How broadcasts work",
      "what": "A broadcast sends one message to many contacts at once, to a segment or a list, after a pre-flight check and a cost preview.",
      "when": "Use it for offers, announcements and reminders. Only eligible contacts receive it, and opt-outs, quiet hours and frequency caps are respected.",
      "step1": "Choose the audience: a segment, a list or all contacts.",
      "step2": "Write the message or pick an approved template.",
      "step3": "Check the audience and the cost, then send.",
      "businessName": "Rose Garden",
      "caption": "What the customer receives from a broadcast",
      "msg1": "Spring offer! 20% off all bouquets until Friday. Reply to this message to order.",
      "msg1Button": "Order now",
      "time1": "10:00",
      "msg2": "I want two bouquets please.",
      "time2": "10:04",
      "msg3": "Great choice! We will confirm your order in a moment.",
      "time3": "10:05"
    },
    "settingsIntro": {
      "workspace": {
        "title": "How workspace settings work",
        "what": "Workspace settings hold the basics of your business in WATO: its name, logo, language and time zone, the business details shown on quotes and invoices, your business hours and how people sign in.",
        "when": "Open it when you first set up your workspace, or when your opening hours or time zone change, because automatic replies and reminders follow the time zone and hours you set here. Only the workspace owner can change these settings.",
        "step1": "Enter the workspace name, pick the language and time zone, and upload your logo.",
        "step2": "Add your business details (legal name, VAT number and commercial registration) so they appear on quotes and invoices.",
        "step3": "Set your business hours, turn on two-step verification for the team if you want it, then save your changes."
      },
      "team": {
        "title": "How the team page works",
        "what": "This page lists the people who can open your workspace, the role each one has and the invitations still waiting to be accepted.",
        "when": "Use it when someone joins or leaves, when a person's job changes, or when you are close to the number of seats your plan includes.",
        "step1": "Invite a person by email and pick a role for them.",
        "step2": "Watch the seats counter to see how many people your plan allows.",
        "step3": "Change a role or remove a member when their job changes, so each person sees only what they need. The role is what decides who can see money and who can approve it."
      },
      "roles": {
        "title": "How roles and permissions work",
        "what": "A role is a set of permissions that decides what a team member can see and do. WATO comes with ready roles, and you can create your own to choose exactly what each person may do.",
        "when": "Use it when you want an employee to see the chats but not the money, or when only a manager should approve discounts, quotes and refunds. The AI only prepares these; the approval always comes from a person whose role allows it.",
        "step1": "Open a built-in role to read what it allows. Built-in roles can be viewed but not changed.",
        "step2": "Create a custom role and tick its permissions, including who can see money and who can approve it.",
        "step3": "Give the role to a team member from the Team page."
      },
      "approvals": {
        "title": "How approvals work",
        "what": "Some actions that involve money wait here until a person with permission approves them: carts, quotes, discounts and refunds. The AI can prepare them, but it never approves them itself.",
        "when": "Check this page when a request is waiting for you, or when a customer is waiting for a discount or a refund.",
        "step1": "Open a pending request and read what was asked for.",
        "step2": "Approve it or reject it, and write a note when you reject so the requester knows why.",
        "step3": "You cannot approve your own request; another person whose role allows it has to do that."
      },
      "teams": {
        "title": "How teams and routing work",
        "what": "A team is a group of your agents. WATO sends each new chat to the right team and then to one person in it, using the assignment strategy you choose and the team's working hours.",
        "when": "Use it when more than one person answers customers, for example sales and support, or one team per branch, so no chat waits without an owner or piles up on one person. It is available on higher plans.",
        "step1": "Create a team and add the people who answer its chats.",
        "step2": "Pick how chats are shared: by hand, in turn, or to whoever has the fewest open chats.",
        "step3": "Set the team's working hours and choose what happens to chats that arrive outside them: assign anyway or hold until opening."
      },
      "branches": {
        "title": "How branches work",
        "what": "A branch is one location of your business. You can scope the catalog, bookings and chat routing to a branch instead of treating the whole business as a single place.",
        "when": "Use it if you serve customers from more than one location, for example a shop in Riyadh and another in Jeddah. A business with one location can keep just the default branch. Several branches depend on your plan.",
        "step1": "Add a branch with its name in Arabic and English and its address.",
        "step2": "Deactivate a branch you stop using and activate it again if you need it. The default branch always stays active.",
        "step3": "Then pick the branch when you set up the catalog, bookings or routing."
      },
      "auditLog": {
        "title": "How the audit log works",
        "what": "The audit log is the record of who did what in your workspace: every sensitive action, with the person who did it, what it was done to and when, newest first.",
        "when": "Open it when something changed and you need to know who changed it, such as a role, a refund approval or a setting. Entries can never be edited or deleted.",
        "step1": "Filter by action, person, type of item or dates to narrow the list.",
        "step2": "Read each row: the action, who did it, what it was done to and when. System means WATO did it automatically.",
        "step3": "Export the list to a file if you need to keep it or send it to your accountant or auditor."
      },
      "billing": {
        "title": "How billing works",
        "what": "Billing shows your plan, your prepaid wallet balance and every wallet movement. The wallet pays for AI replies and other usage inside WATO.",
        "when": "Open it before you renew or change your plan, when the wallet runs low, or when you want to know what you pay and to whom. WhatsApp conversation fees are a separate charge: Meta bills you for them directly, and WATO only shows an estimate.",
        "step1": "Check your current plan and when the period ends.",
        "step2": "Keep the wallet topped up, or turn on auto-recharge, so AI replies do not stop.",
        "step3": "Read the wallet activity to see each top-up and charge, and remember that what you owe Meta is paid to Meta, not from this wallet."
      },
      "notifications": {
        "title": "How notification preferences work",
        "what": "This page decides which alerts reach you and where: inside WATO, by email or as a browser push, for inbox, billing, compliance and system alerts.",
        "when": "Open it when you get too many alerts or miss important ones, or when you want quiet hours so non-critical alerts wait. Critical alerts cannot be switched off for your role.",
        "step1": "For each kind of alert, choose the channels you want: in the app, email or browser push.",
        "step2": "Turn on a digest or set quiet hours if you prefer fewer interruptions. Quiet hours only hold back non-critical alerts.",
        "step3": "Save your preferences. If you are the owner, you can also send critical alerts and the daily digest to your WhatsApp."
      }
    },
    "helpCenter": {
      "articles": {
        "connectANumber": {
          "title": "Connect a WhatsApp number",
          "summary": "Link your WhatsApp Business number to your workspace, step by step.",
          "p1": "1. Open “Channels” in the sidebar and choose “Connect a channel”.",
          "p2": "2. Pick the official WhatsApp Cloud API option and sign in with the Facebook account tied to your business.",
          "p3": "3. Select your WhatsApp Business account and the phone number to link, then approve the permissions.",
          "p4": "4. Send a test message to confirm it works. The channel shows “Connected” once linking is complete.",
          "p5": "Note: the QR channel is for the AI Agent only; flows, buttons, templates and forms run on the official channel."
        },
        "buildYourFirstFlow": {
          "title": "Build your first flow",
          "summary": "Create an automated conversation and publish it for your customers.",
          "p1": "1. Open “Flows” and start from an industry template in the gallery, or create a new flow.",
          "p2": "2. Drag nodes onto the canvas — a trigger, a message, a question, then an end — and connect them.",
          "p3": "3. Use the simulator to try the conversation before publishing.",
          "p4": "4. Press “Publish”. Saving keeps a draft; only publishing makes the flow live, and the “Publish your first flow” checklist step completes only after publishing."
        },
        "agentCartAndQuotation": {
          "title": "Agent Cart and Quotation how-to",
          "summary": "Prepare a cart or a quotation for a customer inside the chat.",
          "p1": "1. In a conversation, open the customer panel and add products from the picker to the cart.",
          "p2": "2. Convert the cart to a quotation when needed; VAT is calculated automatically (15% KSA, 10% Bahrain).",
          "p3": "3. The AI only drafts; a team member with permission approves carts, quotes, discounts and refunds.",
          "p4": "4. After approval, send the quote or payment link to the customer and follow its status from the same chat."
        },
        "flowBuildingBasics": {
          "title": "Flow-building basics",
          "summary": "Triggers, nodes, variables and validation before publishing.",
          "p1": "Every flow starts with at least one trigger, such as a keyword or an inbound message.",
          "p2": "The editor validates the flow before publishing and lists errors and warnings; fix errors, then review warnings.",
          "p3": "Flows run on the official channel only and are never bound to the QR channel."
        },
        "billingBasics": {
          "title": "Billing and wallet basics",
          "summary": "Your plan, the wallet, invoices and VAT.",
          "p1": "Find your plan and subscription status under “Settings → Billing”.",
          "p2": "The wallet covers message fees and AI credits, and every movement is recorded in a ledger.",
          "p3": "Amounts are in SAR (2 decimals) or BHD (3 decimals), with VAT added by your business country."
        },
        "complianceBasics": {
          "title": "WhatsApp compliance basics",
          "summary": "The 24-hour reply window, and customers agreeing to (or stopping) messages.",
          "p1": "You can reply freely within 24 hours of the customer's last message; after that only approved templates can be sent.",
          "p2": "Send promotional messages only to people who opted in; opt-outs are honored in Arabic and English keywords such as “إيقاف” and STOP.",
          "p3": "Quiet hours and sending limits are applied automatically to broadcasts."
        },
        "howRagWorks": {
          "title": "How the assistant answers from your information",
          "summary": "How your AI Agent answers from your own files and cites its sources.",
          "p1": "1. Chunking: when you upload a file (PDF, DOCX, text), add a URL or FAQ pairs, we split the content into short passages (chunks) by paragraph.",
          "p2": "2. Indexing: each chunk is turned into an embedding vector and stored in the database with pgvector. A source moves through Queued → Indexing → Ready (or Failed, where you can re-index).",
          "p3": "3. Retrieval: when a customer asks something, we find the closest chunks by meaning and by keywords together and pass them to the agent as context.",
          "p4": "4. Answer with citations: the agent answers only from those chunks and shows the citation (source title and chunk number). If it finds nothing it hands the conversation to a human.",
          "p5": "Tip: use “Test search” on the Knowledge base page to see exactly which chunks the agent will use. Real answers need an AI provider key; in fake mode you will see simulated replies."
        },
        "sequences": {
          "title": "Sequences: follow up with customers over several days",
          "summary": "Timed messages that go out on their own after an event such as a purchase.",
          "imageAlt": "The Sequences page with the list of sequences and the messages in each one",
          "p1": "A sequence is a short series of messages that Wato sends automatically, spread over several days after something happens, for example after a customer buys. Each message waits its own delay before it goes out.",
          "p2": "Use it for after-sale follow-up: a welcome on day 0, a reminder or a care tip on day 2, and a special offer on day 7. Customers stay in touch with you without you messaging each one by hand.",
          "p3": "Steps: open “Sequences” in the sidebar, create a new sequence and name it, add the messages and set the delay between each one and the next, then press “Mark ready” so it starts sending. A customer who has opted out never receives the sequence.",
          "p4": "Rule: on the official channel, a message sent more than 24 hours after the customer’s last message must be an approved template, so pick templates for the day 2 and day 7 steps. On the QR channel a sequence carries text and media only, with no buttons."
        },
        "forms": {
          "title": "Forms: collect details inside WhatsApp",
          "summary": "A questionnaire the customer fills in without leaving the chat, such as an address, a booking or a rating.",
          "imageAlt": "The Forms page with the ready-made forms and the workspace’s own forms",
          "p1": "A form is a questionnaire that opens inside WhatsApp itself. The customer taps a button in the conversation and fills in the fields, and you receive the answers organised instead of scattered across messages.",
          "p2": "Use it when you need several details from the customer at once, such as a delivery address, a booking request or a satisfaction rating, instead of asking one question after another.",
          "p3": "Steps: open “Forms”, pick a ready-made form or start with a blank one and edit its questions, then publish it, because a form does not reach customers before it is published. Add it to a flow with the “WhatsApp form” node so the customer gets a button that opens it, and find the answers under the “Responses” button next to the form.",
          "p4": "Rule: forms and buttons work only on the official WhatsApp channel, not on the QR channel."
        },
        "orderNotifications": {
          "title": "Order notifications: keep customers in the loop",
          "summary": "An automatic WhatsApp message each time an order changes status, from confirmation to delivery.",
          "imageAlt": "The Order notifications page with an editable card for each order status",
          "p1": "An order notification is a WhatsApp message that Wato sends automatically whenever an order changes status, for example “Your order is confirmed”, “Your order has shipped” or “Delivered”. It needs a store connected to Wato.",
          "p2": "Use it so customers can see where their order is without asking you, which cuts the repeated questions your team has to answer.",
          "p3": "Steps: connect your store so every new order and status change reaches Wato, then open “Order notifications”, turn on the statuses you want and write each message or use the suggested text; the order number fills in by itself. Finally choose an approved message template and save.",
          "p4": "Rule: free text only goes through within 24 hours of the customer’s last message; after that only approved templates are delivered, so choose an approved template for every status you switch on."
        },
        "templates": {
          "title": "Message templates: reach customers after 24 hours",
          "summary": "A message you write once and Meta approves, so you can send it even when a day has passed since the customer last wrote.",
          "imageAlt": "The Message templates page with the templates and the approval status of each",
          "p1": "A message template is a message you write once and Meta approves. It is the only kind of message you can send to a customer more than 24 hours after their last message.",
          "p2": "Use it for order updates, reminders and offers to customers who have not written to you today.",
          "p3": "Steps: open “Message templates”, write the message and choose its category, then submit it to Meta and wait for the review decision. Once it is approved, pick it in a broadcast, a sequence or a flow.",
          "p4": "Rule: free text is allowed only inside the 24-hour window; outside it only approved templates are accepted. Choose the category that really matches the purpose of the message, because a wrong category is one of the most common reasons a template is rejected."
        },
        "campaigns": {
          "title": "Campaigns: one message to many customers",
          "summary": "Send an offer or an announcement to a segment or a list of contacts, after a pre-flight check and a cost preview.",
          "imageAlt": "The Broadcasts page with the list of campaigns and the status of each",
          "p1": "A campaign, called a broadcast in the menu, is one message you send to many contacts at once, to a segment or a list, after a pre-flight check and a cost preview.",
          "p2": "Use it for offers, announcements and reminders. Only eligible contacts receive it, and opt-outs, quiet hours and frequency caps are respected.",
          "p3": "Steps: open “Broadcasts” and create a new one, then choose the audience: a segment, a list or all contacts. Write the message or pick an approved template, check the audience and the cost, and press send.",
          "p4": "Rule: campaigns only reach contacts who agreed to receive messages. Outside the 24-hour window a campaign needs an approved template, and on the QR channel it only reaches people who have written to you before."
        },
        "bookings": {
          "title": "Bookings: your customers’ appointments in one place",
          "summary": "Every appointment a customer books on WhatsApp shows up in a table or calendar, with its service, staff member and status.",
          "imageAlt": "The Bookings page in table or calendar view with service, staff member and status for each booking",
          "p1": "Bookings are the appointments your customers make on WhatsApp. They appear in a table or in a day or week calendar, with the service, the staff member and the status of each booking.",
          "p2": "Use it if your business runs on appointments, such as clinics, salons and consultations, to follow today’s schedule, change a booking’s status or move it to another time.",
          "p3": "Steps: add your services and staff first under “Services” and “Staff”, and review “Booking settings”. A customer picks a slot and Wato confirms the booking in the chat; then you follow it under “All bookings” or drag it to another time, and the customer gets a WhatsApp message with the new details.",
          "p4": "Tip: make use of the waitlist. When a customer asks for a full slot they join it, and if a booking is cancelled Wato messages the first person in line; if they do not reply in time, the slot goes to the next one."
        },
        "channels": {
          "title": "Channels: connect your business WhatsApp number",
          "summary": "A channel is the WhatsApp number connected to Wato. Learn the difference between the official channel and the QR channel.",
          "imageAlt": "The Channels page with the connected numbers and the status of each channel",
          "p1": "A channel is the WhatsApp Business number connected to your Wato account; customer messages arrive through it and your replies go out through it. There are two kinds: the official channel, through the official WhatsApp Cloud API, and the QR channel, linked by scanning a code from your phone.",
          "p2": "Connect the official channel when you want every feature: flows, buttons, lists, templates, forms and the catalog. The QR channel is meant for the AI agent, and it also serves the shared inbox, broadcasts to people who have written to you before, text and media sequences, and opt-out handling.",
          "p3": "Steps: open “Channels” and press “Connect a channel”, choose the official WhatsApp Cloud API option and sign in with the Facebook account tied to your business, then select your WhatsApp Business account and number and approve the permissions. Send a test message; the channel shows “Connected” once linking is complete.",
          "p4": "Rule: forms, buttons, templates and flows work only on the official channel, not on the QR channel."
        },
        "aiAgents": {
          "title": "AI agents: an automated team member that answers customers",
          "summary": "An agent answers repeated questions on WhatsApp within limits you set, and hands the chat to a person when needed.",
          "imageAlt": "The AI agents page with the list of agents and the status of each",
          "p1": "An AI agent is an automated team member that answers your customers on WhatsApp about topics you choose, and hands the chat to a person when it does not know the answer or the customer asks for one.",
          "p2": "Use it for repeated questions such as prices, opening hours and order status, so your team can focus on the chats that need a human.",
          "p3": "Steps: open “AI agents” and create an agent, pick its role (sales, support or reception) and name it. Review the safety limits and try it in a test chat that never reaches customers, then publish it and bind it to a channel; only a published, bound agent answers customers.",
          "p4": "Rule: the agent is not a general-purpose chatbot; it answers inside its scope and only from your knowledge base, and hands over to a person when in doubt. Any discount, refund or quote is approved by an authorised person, because the agent only prepares the draft."
        },
        "knowledgeBase": {
          "title": "Knowledge base: what the agent relies on to answer",
          "summary": "Add your business information as text, questions and answers, links and files so the agent answers with what you wrote.",
          "imageAlt": "The Knowledge base page with the added sources and the status of each source",
          "p1": "The knowledge base is the information you add about your business, as text, questions and answers, links and files. The AI agent looks things up there so it answers customers with what you wrote.",
          "p2": "Add your prices, opening hours, shipping and return policies, and anything customers often ask. If the agent cannot find the answer in your sources it does not guess; it hands the chat to a person.",
          "p3": "Steps: open “Knowledge base” and add a source: write text or questions and answers, add a link or your website, or upload a file. Wait until the source status is “Ready”, then try a question in the test search to see which passages the agent will rely on.",
          "p4": "Tip: every now and then, review the questions the agent handed to a person and add what your knowledge base is missing so it can answer them next time. If a source shows “Failed”, re-index it."
        },
        "recipes": {
          "title": "Ready recipes: automation in one click",
          "summary": "Start from a ready-made recipe such as a welcome message or an abandoned-cart reminder instead of building a flow from scratch.",
          "imageAlt": "The Ready recipes page with the recipe cards and the Use template button",
          "p1": "A recipe is a ready-made automation, such as a welcome message or an abandoned-cart reminder. When you pick one, a ready flow is created for you, and you can edit it as you like.",
          "p2": "Use it when you want to start quickly without building a flow from scratch, or when you want a working example to learn from.",
          "p3": "Steps: open “Ready recipes” and choose a recipe that fits what you want, then press “Use template” so the flow is created for you. Review and edit the message, then publish it and switch it on.",
          "p4": "Rule: nothing reaches customers until you publish the flow and switch it on. Flows with buttons run on the official channel only, not on the QR channel."
        },
        "autoReplies": {
          "title": "Auto-replies: never leave a customer unanswered",
          "summary": "Fixed replies Wato sends by itself on a first message, outside working hours, or when it does not understand a message.",
          "imageAlt": "The Auto-replies page with the reply types and a switch for each reply",
          "p1": "An auto-reply is a fixed reply that Wato sends by itself at a specific moment, without a flow: on a customer’s first message, outside working hours, or when a message is not understood.",
          "p2": "Use it to greet new customers, tell them your opening hours, and guide them when their message is not understood, so nobody waits without an answer.",
          "p3": "Steps: open “Auto-replies” and pick the kind of reply, then write its text and choose how often it is sent, switch the reply on and save.",
          "p4": "Tip: keep the reply short and say when your team will answer, and set how often it is sent so the same customer does not get it over and over. Keep the “outside hours” reply up to date with your current working hours."
        },
        "carts": {
          "title": "Carts and reminders: win back abandoned orders",
          "summary": "When a customer leaves a cart unpaid, Wato sends friendly reminders until they pay or cancel.",
          "imageAlt": "The Carts page with the list of carts and the status of each",
          "p1": "A cart is a list of products you prepared for a customer in the chat. It becomes abandoned when you sent it, the customer did not pay, and the waiting time you chose has passed.",
          "p2": "When a cart is abandoned, Wato sends the customer up to a few friendly reminders, spaced as you set. Reminders stop as soon as the customer pays or cancels.",
          "p3": "Steps: send the cart to the customer from the chat. If they do not pay, the cart moves to “Abandoned” after the waiting time and Wato reminds them. Under “Carts” you follow the status of each cart.",
          "p4": "Rule: reminders go out through the official WhatsApp Cloud API channel only, and they respect quiet hours and opt-outs. Any discount still needs the approval of an authorised person."
        },
        "qrAiVsOfficialButtons": {
          "title": "Free AI answers on WhatsApp (QR code), buttons on WhatsApp (official)",
          "summary": "Know which channel the AI agent answers freely on and which one replies with buttons and lists only.",
          "p1": "WhatsApp (QR code) is the only channel where the AI agent replies to your customers in free text. Buttons, lists and chat flows do not run there.",
          "p2": "WhatsApp (official) replies with buttons, lists and chat flows only. It never sends a free-text AI reply to customers. This is a fixed rule, not a setting.",
          "p3": "When a customer types something the buttons do not understand on the official channel, they get what you set: your main menu with its options, or else a fixed message you wrote, or else no reply.",
          "p4": "In short: want the AI agent to answer? Bind it to a WhatsApp (QR code) number. Want buttons and lists? Use WhatsApp (official). The option to bind the AI agent to the official channel is not offered."
        },
        "liveAvailabilityTable": {
          "title": "Live availability table from a Google Sheet",
          "summary": "Connect a spreadsheet your team updates so the AI agent answers with what is available now.",
          "p1": "Some facts change every hour, such as open appointment slots or stock. Instead of retyping them, connect a Google Sheet and the AI agent reads the latest version.",
          "p2": "Steps: open “Business info”, add a live table source, paste the sheet link and share it with the address shown. Then choose the columns the AI agent may read.",
          "p3": "On each availability question the agent reads the sheet at that moment, so your customer never gets an old number. If the sheet cannot be read, it does not guess; it hands the conversation to a team member.",
          "p4": "Tip: put only what the customer may know in the sheet, never your purchase prices or private data. This works with the AI agent on WhatsApp (QR code)."
        },
        "websiteKnowledge": {
          "title": "Add your website so the AI agent learns from it",
          "summary": "Enter your website link and the AI agent reads its pages and answers from them.",
          "p1": "If your business has a website with prices and policies, you do not need to copy them by hand. Add the website link and the AI agent reads its pages.",
          "p2": "Steps: open “Business info”, choose add a link, type your website address, and wait until the status is “Ready”. Then try a question in the test search.",
          "p3": "The agent only reads your own website pages. If you change the site, read it again from the same page to pick up the changes.",
          "p4": "Tip: after reading, review what the agent understood and fix any outdated answer by adding a question and answer your team writes; it takes priority over the website."
        },
        "voiceNotesQr": {
          "title": "Voice notes on WhatsApp (QR code)",
          "summary": "How the AI agent handles a voice note a customer sends.",
          "p1": "Many customers send a voice note instead of typing. On WhatsApp (QR code) the AI agent listens to it, turns it into text and then answers.",
          "p2": "You see the text the agent understood under the voice note in the conversation, so you can check it understood the customer.",
          "p3": "If the audio is unclear or in a dialect it could not follow, the agent asks the customer to repeat or type, or hands the conversation to a team member.",
          "p4": "Note: this works on WhatsApp (QR code) only. On WhatsApp (official) the AI agent answers no one, so the voice note shows to your team to answer themselves."
        },
        "copilotEditByChat": {
          "title": "Personal copilot: change your business replies by chatting",
          "summary": "Tell it what to change in plain words and it prepares the edit for you to approve.",
          "p1": "The copilot works with you, not with your customers. Write to it, for example: “change opening hours to 9 am” or “add an answer about delivery”.",
          "p2": "It does not apply changes straight away. It shows you the edit first: what it was and what it will become. Press “Approve” to apply it, or “Reject” to keep everything as it is.",
          "p3": "You can undo the last edit after it is applied from the edit history on the same page.",
          "p4": "Tip: ask for one thing per message so the edit is clearer to review. Anything about money, such as discounts and refunds, is approved by a permitted team member."
        },
        "copilotMenuFromText": {
          "title": "Create a button menu from a description of your business",
          "summary": "Write what your business does and the copilot prepares a main menu with buttons.",
          "p1": "You do not need many steps to build the main menu. Write to the copilot, for example: “a restaurant with meals and desserts, we deliver and take bookings”.",
          "p2": "It suggests a menu of short buttons, such as: Menu, Delivery, Booking, Talk to a team member. Rename any button or remove one before saving.",
          "p3": "When you approve, the menu is saved as a draft and reaches your customers only after you publish it.",
          "p4": "Note: the button menu runs on WhatsApp (official). When a customer types something the buttons do not understand, they get this main menu."
        },
        "unmatchedQuestions": {
          "title": "Questions we could not answer",
          "summary": "A list of what customers asked that the AI agent had no answer for, so you can fill the gap quickly.",
          "p1": "Whenever a customer asks something the AI agent cannot find in your business info, the question is saved in the “Unanswered questions” list.",
          "p2": "Repeated questions show at the top with how many times they were asked, so you know what matters most to answer first.",
          "p3": "Open a question and write its answer. It is added to your business info and the agent uses it next time. You can ignore a question that is not about your business.",
          "p4": "Tip: open the list once a week. Every answer you add reduces the conversations handed to a team member."
        },
        "buttonFunnelStats": {
          "title": "Button stats: how many customers tapped and completed",
          "summary": "See which button your customers tap and where they stop.",
          "p1": "In WhatsApp (official) stats you see each button in your main menu: how many times it was shown and how many times it was tapped.",
          "p2": "You also see the customer's steps in order: who tapped “Menu”, then chose a product, then completed the order, and where they left before finishing.",
          "p3": "If a button is shown often but rarely tapped, rename it or move it up the menu. If customers stop at one step, make it shorter.",
          "p4": "Note: the numbers cover buttons on WhatsApp (official) only, since WhatsApp (QR code) does not show buttons."
        },
        "connectOfficialWhatsapp": {
          "title": "Connect official WhatsApp (embedded signup)",
          "summary": "Link your number to WhatsApp (official) through Facebook.",
          "p1": "1. Open “Channels” in the sidebar, choose “Connect a channel”, then “WhatsApp (official)”.",
          "p2": "2. Sign in with the Facebook account that manages your business. You must be an admin of the Meta business account.",
          "p3": "3. Pick the WhatsApp Business account and the phone number to link, and approve the permissions.",
          "p4": "4. Send a test message. The channel shows “Connected” when linking is done.",
          "p5": "If the number is registered in the regular WhatsApp app, remove it from the app first. If something is wrong after linking, open “Channel check” and it will tell you what to fix."
        },
        "connectQrNumber": {
          "title": "Connect a WhatsApp number by QR code",
          "summary": "Link your existing number by scanning a code, to run the AI agent.",
          "p1": "1. Open “Channels”, choose “Connect a channel”, then “WhatsApp (QR code)”.",
          "p2": "2. On your phone open WhatsApp, then Settings, then “Linked devices”, and tap “Link a device”.",
          "p3": "3. Point the camera at the code on the screen and wait a few seconds until the status is “Connected”.",
          "p4": "4. Keep the phone online. If the channel disconnects, tap “Rescan” and scan a new code.",
          "p5": "Note: WhatsApp (QR code) is for the AI agent only. Chat flows, buttons, templates and forms run on WhatsApp (official)."
        },
        "createTemplateApproval": {
          "title": "Create a message template and get it approved",
          "summary": "Write a clear template and submit it to Meta for review.",
          "p1": "1. Open “Templates” and choose “New template”.",
          "p2": "2. Pick the category: Marketing for offers, Utility for follow-ups, Authentication for login codes. The right category lowers the chance of rejection.",
          "p3": "3. Write the text in clear language, put variables between double braces with a number, and add an example for each variable.",
          "p4": "4. Choose “Submit for review”. The status becomes “Pending” and usually finishes within minutes to 24 hours.",
          "p5": "5. When the status is “Approved” you can use it in broadcasts. If it is rejected, open the template to read the reason, edit the text and resubmit.",
          "p6": "Tip: do not start or end the text with a variable, avoid shortened links, and avoid exaggerated wording."
        },
        "sendCampaignVariables": {
          "title": "Send a broadcast with variables",
          "summary": "Send an approved template to contacts with each customer’s name and details.",
          "p1": "1. Open “Broadcasts” and choose “New broadcast”.",
          "p2": "2. Pick the channel and an approved template. If you have none, create one in “Templates” first.",
          "p3": "3. Map each variable to a contact field such as the name, or type a fixed value. Check the preview for more than one customer.",
          "p4": "4. Choose the audience, review the estimated cost and warnings, then send now or schedule.",
          "p5": "Broadcasts skip contacts who opted out and respect quiet hours. A contact with no value for a variable is skipped or gets the fallback you set."
        },
        "connectInstagram": {
          "title": "Connect Instagram through Facebook and pick the page",
          "summary": "The Instagram account must be professional and linked to a Facebook page.",
          "p1": "Before you start: switch your account to a professional account (business or creator) and link it to a Facebook page you manage.",
          "p2": "1. Open “Channels”, choose “Connect a channel”, then “Instagram”.",
          "p3": "2. Sign in with Facebook and approve the permissions. Make sure the pages linked to your account are selected.",
          "p4": "3. Back in Wato you see your pages with the Instagram account for each one. Choose “Enable” next to the page you want.",
          "p5": "4. If your page is missing or says “No Instagram”, link the Instagram account to the page in the Facebook page settings and try again."
        },
        "firstAutoReply": {
          "title": "Build your first chat flow",
          "summary": "A simple chat flow that answers a customer as soon as they message you.",
          "p1": "1. Open “Chat flows” and choose “New chat flow”, or start from a ready template.",
          "p2": "2. Pick the trigger: for example “First message” or a keyword such as “price”.",
          "p3": "3. Add a “Send message” step and write the reply in simple words. Add a “Handoff” step if the customer wants a person.",
          "p4": "4. Test it in the simulator, then choose “Publish”.",
          "p5": "Note: buttons and lists run on WhatsApp (official) only."
        },
        "browserNotifications": {
          "title": "Turn on browser notifications (including Windows settings)",
          "summary": "Hear about new messages even when the page is closed.",
          "p1": "1. Open your account menu, choose “Enable notifications on this device”, and click “Allow” when the browser asks.",
          "p2": "2. If you blocked it before, click the lock icon next to the site address, set “Notifications” to “Allow”, then reload.",
          "p3": "3. On Windows: open Settings, then System, then Notifications. Make sure Notifications is on and your browser (Chrome or Edge) is enabled in the list.",
          "p4": "4. Also on Windows: turn off Do not disturb or Focus, because they hide notifications even when enabled.",
          "p5": "5. Choose “Send a test notification” and confirm it shows up."
        },
        "fixDeliveryPaymentMethod": {
          "title": "Fix delivery error 131042: add a payment method in Meta",
          "summary": "Message not delivered with code 131042? The cause is usually the payment method on your Meta account.",
          "p1": "Code 131042 means Meta could not charge for the message because the WhatsApp Business account has no valid payment method.",
          "p2": "1. Sign in to Meta Business Manager (business.facebook.com).",
          "p3": "2. Open Business settings, then WhatsApp accounts, and pick your account.",
          "p4": "3. Open Payment settings and choose “Add payment method”. Enter a valid card that has not expired.",
          "p5": "4. Go back to the conversation and resend the message. Nothing needs to change inside Wato.",
          "p6": "If the error stays after adding the card, wait a few minutes and try again, or open “Channel check” to see the account status."
        }
      },
      "guideLink": "Step-by-step guide"
    },
    "orderMessages": {
      "title": "Order messages",
      "navLabel": "Order tools",
      "navLink": "What customers receive at each status",
      "listLabel": "Statuses that send a message",
      "caption": "Example: messages a customer gets as the order moves along (sample order 1001)",
      "empty": "No order message is switched on yet, so customers get nothing automatic when an order changes status. Open the editor below and turn on the statuses you want.",
      "edit": "Edit order messages",
      "intro": {
        "title": "What customers receive at each order status",
        "what": "When an order changes status, the customer gets a WhatsApp message automatically, for example when it is confirmed, shipped or delivered.",
        "when": "Use it so customers never have to ask where their order is.",
        "step1": "Turn on the statuses you want to notify.",
        "step2": "Write the message or use the suggested text.",
        "step3": "Move an order along and the customer is told."
      },
      "blocked": {
        "title": "Order messages are not available",
        "reason": "You do not have access to the order message settings, or the store is not set up yet. Ask a workspace admin for access.",
        "cta": "Back to orders"
      }
    },
    "paymentQueue": {
      "title": "Payment approvals",
      "navLink": "Bank-transfer approvals",
      "backToOrders": "Back to orders",
      "intro": {
        "title": "Approve bank transfers",
        "what": "Customers who pay by bank transfer send a receipt. It waits here until a person checks it.",
        "when": "A person always approves money: the system only suggests a match from the receipt, it never marks an order paid by itself.",
        "step1": "Open a receipt and compare amount and reference.",
        "step2": "Approve it if it matches, the order becomes paid.",
        "step3": "Reject it with a reason if it does not match."
      },
      "blocked": {
        "title": "Payment approvals are not available",
        "reason": "You do not have access to payment approvals. Ask a workspace admin for access.",
        "cta": "Back to orders"
      }
    },
    "account": {
      "nav": "Account",
      "personalProfileLink": "Open my personal profile (name, email, phone login)",
      "title": "Account",
      "subtitle": "Manage who works in this workspace and which plan you are on.",
      "tabs": {
        "label": "Account sections",
        "members": "Members and roles",
        "plan": "Plan and prices"
      },
      "intro": {
        "title": "What is the Account area?",
        "what": "The place where the workspace owner manages the team and the subscription.",
        "when": "Use it to invite a colleague, change what they can do, or check your plan, usage and prices.",
        "step1": "Invite a member by email and pick a role.",
        "step2": "Read what each role can and cannot do before assigning it.",
        "step3": "Review your plan and usage; change plan only after you confirm."
      },
      "blocked": {
        "members": {
          "title": "You cannot manage members",
          "reason": "Your role does not include viewing the team.",
          "help": "Ask the workspace owner or an admin to change your role or to do this for you."
        },
        "plan": {
          "title": "You cannot view the plan",
          "reason": "Plan and billing details are limited to the workspace owner.",
          "help": "Ask the workspace owner to review the plan or to upgrade it."
        }
      },
      "roles": {
        "heading": "What each role can do",
        "intro": "These are the roles in this workspace. The list comes from the workspace role settings.",
        "builtinBadge": "Built-in",
        "owner": "Full control of the workspace, including billing and transferring ownership.",
        "admin": "Runs day-to-day management of the team and settings.",
        "agent": "Answers customers in the inbox.",
        "builder": "Builds automations, flows and AI agents.",
        "marketer": "Runs broadcasts, segments and campaigns.",
        "developer": "Manages API keys, webhooks and integrations.",
        "viewer": "Read-only access to reports and data.",
        "custom": "A custom role created for this workspace."
      },
      "plan": {
        "heading": "Your plan",
        "current": "Current plan",
        "none": "Free trial",
        "price": "{amount} per month",
        "status": "Status: {status}",
        "usage": "Usage this month",
        "usageUnlimited": "{used} used (no limit)",
        "usageOf": "{used} of {limit}",
        "meter": {
          "contacts": "Contacts",
          "messages": "Messages",
          "aiTokens": "AI tokens"
        },
        "compare": "Compare plans",
        "compareCaption": "Plan comparison",
        "colPlan": "Plan",
        "colPrice": "Price per month",
        "colFeatures": "Includes",
        "yours": "Your plan",
        "upgrade": "Upgrade",
        "downgrade": "Downgrade",
        "empty": "No plans are available right now.",
        "loadError": "Could not load the plans.",
        "confirmTitle": "Confirm plan change",
        "confirmUpgrade": "You are about to upgrade to {plan} at {amount} per month. Nothing changes until you confirm.",
        "confirmDowngrade": "You are about to downgrade to {plan} at {amount} per month. Some features or limits may be reduced. Nothing changes until you confirm.",
        "confirm": "Confirm change",
        "cancel": "Cancel",
        "applied": "Your plan was changed.",
        "scheduled": "The change is scheduled for the end of the billing period.",
        "requiresAction": "Complete the payment to finish the change.",
        "ownerOnly": "Only the workspace owner can change the plan.",
        "ownerHelp": "Ask the owner to make this change.",
        "support": "Plan changes are not available online. Contact support to change your plan.",
        "manageBilling": "Open billing details"
      }
    },
    "notificationsHistory": {
      "title": "Notification history",
      "subtitle": "Everything we have notified you about, newest first.",
      "prefsLink": "See notification history",
      "markAllRead": "Mark all as read",
      "filterLabel": "Filter notifications",
      "filterAll": "All",
      "filterUnread": "Unread ({count})",
      "today": "Today",
      "yesterday": "Yesterday",
      "empty": {
        "title": "No notifications yet",
        "body": "New messages, billing and compliance alerts will show up here, and stay here after you read them."
      },
      "emptyUnread": {
        "title": "Nothing unread",
        "body": "You have read everything. Switch to All to see past notifications."
      },
      "limitNote": "Showing your latest {count} notifications.",
      "blocked": {
        "title": "You cannot see notifications here",
        "reason": "Your role does not include access to this workspace's notifications. Ask a workspace admin to update your role.",
        "cta": "Open team settings"
      },
      "intro": {
        "title": "What is notification history?",
        "what": "The bell shows only your latest alerts. This page keeps every notification so you can find one you missed.",
        "when": "Use it when you want to check a billing notice, a handoff or a compliance alert from earlier this week.",
        "step1": "Open the bell and choose See all.",
        "step2": "Filter to unread or scroll by day.",
        "step3": "Select a notification to jump to the related page.",
        "businessName": "Your store",
        "caption": "Illustrative example of messages that create a notification.",
        "msg1": "New message from a customer is waiting in the inbox.",
        "msg2": "Your wallet balance is running low."
      }
    },
    "automationAnalyticsPage": {
      "title": "Automation results",
      "subtitle": "See how many automated messages went out, and how many customers read them or bought after them.",
      "tableLabel": "Results per automation",
      "stepsNote": "Each column counts the messages that reached that step, so the numbers usually get smaller the closer you get to a purchase.",
      "empty": {
        "title": "No automated messages yet",
        "body": "Once you turn on abandoned-cart reminders or failed-payment retry and messages start going out, the numbers for each step will show up here.",
        "cta": "Set up automations"
      },
      "blocked": {
        "title": "You cannot see automation results",
        "reason": "Your role does not include access to these results. Ask a workspace admin to update your role.",
        "cta": "Open team settings"
      },
      "intro": {
        "title": "What are automation results?",
        "what": "This page follows every automated message, such as abandoned-cart reminders and failed-payment retries: how many were triggered, sent, delivered, read, clicked and led to a purchase.",
        "when": "Check it to see whether your reminders really bring in sales, and whether the message text or timing needs a change.",
        "step1": "Turn on abandoned-cart reminders or failed-payment retry in the automation settings.",
        "step2": "Wait for the messages to start going out to your customers.",
        "step3": "Read the table to see where customers drop off, from sending to buying.",
        "businessName": "Your store",
        "caption": "Illustrative example of an abandoned-cart reminder and a customer who then completes the purchase.",
        "msg1": "Hi Sara, your items are still waiting in your cart. Complete your order whenever you are ready.",
        "msg1Button": "Complete your order",
        "msg2": "Thank you, I just completed my purchase.",
        "msg3": "Great, we received your order and we are getting it ready."
      }
    },
    "kbFixQueuePage": {
      "title": "Knowledge base corrections",
      "subtitle": "Corrections for wrong replies wait here for a teammate to review them before they reach the knowledge base.",
      "reviewNote": "You cannot approve a correction you wrote yourself. Another teammate reviews it.",
      "empty": {
        "title": "No corrections waiting for review",
        "body": "When the AI agent gives a wrong reply, press \"Mark as wrong\" on the reply in the conversation and write the right answer. It will show up here for your team to review. You can also add the information straight from the knowledge base.",
        "cta": "Open the knowledge base"
      },
      "blocked": {
        "title": "You cannot see knowledge base corrections",
        "reason": "Your role does not include access to AI agents in this workspace. Ask a workspace admin to update your role.",
        "cta": "Open team settings"
      },
      "intro": {
        "title": "What are knowledge base corrections?",
        "what": "When the AI agent gives your customer a wrong answer, your team flags the reply and writes the right one. The corrections wait here for a teammate to review: if they approve it, the knowledge base is updated; if they reject it, nothing changes. The AI never changes the knowledge base by itself.",
        "when": "Open it whenever your team spots a wrong reply, or check it regularly so the same mistake does not repeat with other customers.",
        "step1": "Flag the wrong reply in the conversation and write the right answer.",
        "step2": "The correction shows up here for review, with the wrong reply next to the right answer.",
        "step3": "Approve the correction to update the knowledge base, or reject it if it is not right.",
        "businessName": "Your store",
        "caption": "Illustrative example of a wrong reply about opening hours, the correction your team writes, and the right reply after it is approved.",
        "msg1": "When do you close today?",
        "msg2": "We close at 5 PM.",
        "teamNote": "Team note: we are open until 11 PM, not 5 PM",
        "msg3": "How late are you open today?",
        "msg4": "We are open from 9 AM to 11 PM."
      }
    },
    "faqMiningPage": {
      "title": "Suggested FAQs",
      "subtitle": "Questions your customers asked that the AI agent could not answer from your knowledge base. Review each one and turn it into an answer.",
      "reviewNote": "The AI never publishes an answer by itself. A teammate reviews each suggestion, edits the draft if needed, and approves it before it reaches the knowledge base.",
      "reportLink": "See top unanswered topics",
      "samples": "Questions customers asked",
      "empty": {
        "title": "No suggested FAQs yet",
        "body": "Wato groups the questions the AI agent could not answer from your knowledge base and suggests them here once enough similar questions come in. In the meantime, you can add answers straight to the knowledge base.",
        "cta": "Open the knowledge base"
      },
      "blocked": {
        "title": "You cannot see suggested FAQs",
        "reason": "Your role does not include access to AI agents in this workspace. Ask a workspace admin to update your role.",
        "cta": "Open team settings"
      },
      "intro": {
        "title": "What are suggested FAQs?",
        "what": "When a customer asks something the AI agent cannot answer from your knowledge base, Wato keeps the question. Similar questions are grouped into one suggestion, so you can see what customers ask most. Your team reviews each suggestion and, with a human decision, turns it into a knowledge base answer. The AI never publishes answers by itself.",
        "when": "Open it regularly, especially after a busy week or a new offer, to close the gaps in your knowledge base and cut down the chats handed off to your team.",
        "step1": "Check the suggestions: each one groups similar questions customers asked.",
        "step2": "Read the draft answer and edit it in Arabic and English, or write it yourself if there is no draft.",
        "step3": "Approve a suggestion to publish its answer to the knowledge base, or reject it if it does not belong there.",
        "businessName": "Your store",
        "caption": "Illustrative example of a question the AI agent could not answer, the team note that suggests adding it as an FAQ, and the answer a later customer gets.",
        "msg1": "Do you deliver to Al Khobar?",
        "msg2": "I do not have this information yet. I am passing your chat to a teammate who will reply shortly.",
        "teamNote": "Team note: add \"Delivery to Al Khobar\" as an FAQ",
        "msg3": "Is delivery available to Al Khobar?",
        "msg4": "Yes, we deliver to Al Khobar within 1 to 2 working days."
      }
    },
    "channelRouting": {
      "title": "Routing per channel",
      "explainer": "New chats on each channel go to the team chosen by the first routing rule that matches, checked in priority order.",
      "editLink": "Edit routing rules",
      "appliesRule": "Rule: {rule}",
      "toTeam": "Team {team} · {strategy}",
      "teamMissing": "Target team was deleted: edit the rule",
      "scopeChannel": "Only this channel",
      "scopeAll": "All channels",
      "conditional": "depends on other conditions",
      "moreRules": "{count, plural, one {+# more rule can apply} other {+# more rules can apply}}",
      "noRule": "No rule matches this channel, so new chats are not assigned to a team automatically.",
      "noChannels": {
        "title": "No connected channels yet",
        "body": "Connect a WhatsApp channel to see which routing rule applies to it.",
        "cta": "Connect a channel"
      },
      "blocked": {
        "title": "Routing rules are not in your plan",
        "reason": "Teams and routing rules need a plan that includes routing. Upgrade to route chats per channel.",
        "cta": "See plans"
      },
      "intro": {
        "title": "How are chats routed to teams?",
        "what": "A routing rule picks the team for a new chat based on its channel, language, label or segment.",
        "when": "Use it when sales and support use different WhatsApp numbers or languages.",
        "step1": "Create teams in Settings, Teams.",
        "step2": "Add rules in priority order.",
        "step3": "Check here which rule each channel uses.",
        "businessName": "Your store",
        "caption": "Illustrative example of a chat reaching the right team.",
        "msg1": "Hi, I want to ask about my order.",
        "msg2": "Thanks! Our support team will reply shortly."
      }
    },
    "confirmEmail": {
      "title": "Confirm your new email",
      "working": "Confirming your new email…",
      "doneTitle": "Your email was changed",
      "doneBody": "You were signed out on every device. Sign in with {email}.",
      "signIn": "Go to sign in",
      "expiredTitle": "This link has expired",
      "expiredBody": "Open your profile and ask for a new confirmation link.",
      "usedTitle": "This link was already used",
      "usedBody": "If your email is already changed, just sign in with it.",
      "invalidTitle": "This link is not valid",
      "invalidBody": "Check that you copied the whole link, or ask for a new one from your profile.",
      "inUseTitle": "That email is already taken",
      "inUseBody": "Another account now uses this address. Choose a different one from your profile.",
      "failedTitle": "We could not confirm the change",
      "failedBody": "Try again in a moment.",
      "toProfile": "Go to my profile"
    },
    "profile": {
      "title": "My profile",
      "subtitle": "Your personal sign-in details. These are separate from the workspace settings.",
      "email": "Email address",
      "emailHint": "Your sign-in email. To change it, use the form below; we confirm the new address first.",
      "language": "Interface language",
      "languageHint": "Applies to this browser.",
      "password": "Password",
      "passwordHint": "We email you a secure link to set a new password.",
      "passwordSend": "Send reset link",
      "passwordSent": "If this address has an account, a reset link is on its way.",
      "phoneLogin": "Add a phone number for sign-in",
      "hidePopups": "Hide pop-up alerts",
      "hidePopupsHint": "Info pop-ups (such as complaint or late-message alerts) will not appear on this device. Errors still show.",
      "devices": {
        "title": "Devices and login activity",
        "hint": "Browsers and phones signed in to your account. Sign out any you do not recognise.",
        "loading": "Loading your devices...",
        "retry": "Try again",
        "empty": "No active sessions.",
        "unknownDevice": "Unknown device",
        "unknown": "Unknown",
        "thisDevice": "This device",
        "ip": "IP address",
        "lastSeen": "Last active",
        "logout": "Sign out",
        "logoutAll": "Sign out all",
        "logoutAllConfirm": "This signs you out everywhere except this device. Continue?",
        "logoutAllYes": "Yes, sign them out",
        "cancel": "Cancel",
        "revoked": "That device was signed out.",
        "revokedAll": "All other devices were signed out.",
        "activityTitle": "Recent login activity",
        "activityLoading": "Loading your activity...",
        "activityEmpty": "No sign-in activity yet.",
        "kind": {
          "succeeded": "Successful sign-in",
          "failed": "Failed sign-in attempt",
          "locked": "Account temporarily locked",
          "session": "Session change"
        }
      },
      "backToWorkspace": "Back to the workspace",
      "name": "Display name",
      "nameHint": "Shown to your team in the header, member lists and activity log.",
      "namePlaceholder": "Your name",
      "nameSave": "Save name",
      "nameSaved": "Your name was saved.",
      "photo": "Profile photo",
      "photoHint": "PNG or JPEG only, up to 256 KB. Shown in the top bar.",
      "photoUpload": "Upload photo",
      "photoReplace": "Replace photo",
      "photoRemove": "Remove photo",
      "photoSaved": "Your photo was saved.",
      "photoRemoved": "Your photo was removed.",
      "photoInvalid": "This file type is not supported. Choose a PNG or JPEG image.",
      "photoTooLarge": "The photo is larger than 256 KB.",
      "nameRequired": "Enter a name.",
      "nameTooLong": "The name can be at most 80 characters.",
      "changeEmail": "Change email",
      "changeEmailHint": "We send a confirmation link to the new address. Your email changes only after you open it, and you will be signed out everywhere.",
      "newEmail": "New email address",
      "currentPassword": "Current password",
      "changeEmailSend": "Send link",
      "newEmailInvalid": "Enter a valid email address.",
      "passwordRequired": "Enter your current password.",
      "pendingEmail": "We sent the confirmation link to {email}. Open it to finish the change.",
      "pendingEmailSent": "Confirmation link sent."
    },
    "onboardingWizard": {
      "stepOf": "Step {step} of {total}",
      "progress": "Setup progress: {percent}%",
      "skip": "Skip for now",
      "back": "Back",
      "next": "Next",
      "stepType": "Business",
      "stepConnect": "Connect",
      "stepPackage": "Replies",
      "ownerOnly": "Only the workspace owner can finish setup.",
      "businessType": {
        "title": "What kind of business do you have?"
      },
      "connect": {
        "title": "Connect your WhatsApp number",
        "body": "Connect your number to start replying to customers, or try a pretend customer first without connecting anything.",
        "cta": "Connect WhatsApp",
        "demo": "Try it",
        "later": "Later",
        "official": "Official WhatsApp",
        "officialHint": "Fast and safe",
        "qr": "Scan QR code",
        "qrHint": "Use your phone"
      },
      "package": {
        "title": "Start with ready-made replies",
        "body": "We have a ready package for your business type: {type}.",
        "drafts": "Nothing is sent to customers. Everything is saved as drafts for you to review.",
        "cta": "Add package",
        "skip": "Not now"
      },
      "done": {
        "title": "You're all set",
        "body": "Your workspace is ready. Let's see what you can do today.",
        "cta": "Go to home",
        "chipChannel": "Channel",
        "chipReplies": "Replies",
        "chipDrafts": "Drafts"
      }
    },
    "pageHelp": {
      "home": {
        "title": "How does Home work?",
        "what": "Home shows what to do next in your workspace and today's numbers.",
        "when": "Start with the suggested step on the card at the top.",
        "step1": "Do the suggested step, for example connect your number or publish a flow.",
        "step2": "Next, the card moves to the following step and the numbers update."
      },
      "sell": {
        "title": "How does selling work?",
        "what": "This page lists the steps of selling on WhatsApp, from connecting your store to following payments.",
        "when": "Start with the first step that is not done yet.",
        "step1": "Open a step from its card and finish it.",
        "step2": "Next, its status turns to done and the following step is ready."
      }
    },
    "aiEval": {
      "title": "Quality tests",
      "intro": "Check the agent's answers on ready-made questions before publishing and after you change business information. Tests never message your customers.",
      "run": "Run tests",
      "running": "Running…",
      "loading": "Loading…",
      "error": "Could not load the tests.",
      "retry": "Retry",
      "agent": "Agent",
      "noAgents": "Create an agent first to try the tests.",
      "seeded": "These are starter cases. Edit them or add your own.",
      "score": "Score: {score}%",
      "summary": "{passed} of {total} passed",
      "skipped": "{count} cases skipped because of the maximum.",
      "dropped": "The score dropped from {previous}% to {score}%. Review the failing cases before publishing.",
      "allPassed": "All tests passed.",
      "pass": "Passed",
      "fail": "Failed",
      "answer": "Agent answer",
      "noAnswer": "No answer (handed to a person)",
      "caseQuestion": "Question",
      "mustContain": "Must contain (comma-separated)",
      "mustNotContain": "Must not contain (comma-separated)",
      "expectHandoff": "Answer must offer a human colleague",
      "expectAgent": "Expected agent id (optional, main or a team member)",
      "expectInteractive": "Expected buttons / list (optional)",
      "interactiveAny": "Not checked",
      "interactiveButtons": "Buttons",
      "interactiveList": "List",
      "interactiveNone": "No buttons or list",
      "add": "Add case",
      "remove": "Delete",
      "saved": "Saved",
      "saveError": "Could not save.",
      "failure": {
        "missing": "Missing: {term}",
        "forbidden": "Forbidden text appeared: {term}",
        "no_handoff_offer": "The answer did not offer a human colleague"
      },
      "empty": "No cases yet."
    },
    "moneyApprovals": {
      "pageTitle": "Approval requests",
      "pageDescription": "Discounts, refunds and bank-transfer payments waiting for a person’s OK. Staff and the smart assistant prepare them; only you decide.",
      "someone": "someone",
      "you": "you",
      "teammate": "a teammate",
      "kind": {
        "discount": "Discount",
        "refund": "Refund",
        "payment": "Bank transfer",
        "other": "Other request"
      },
      "title": {
        "cartDiscount": "{percent}% discount on a cart",
        "quoteDiscount": "{percent}% discount on quote {number}",
        "refund": "Refund: {reason}",
        "payment": "Check transfer {ref}",
        "other": "Request: {type}"
      },
      "vat": {
        "title": "Waiting now, with VAT",
        "none": "Nothing is waiting.",
        "count": "{count, plural, one {# request} other {# requests}}",
        "included": "VAT inside: {amount}",
        "unknown": "VAT not known"
      },
      "tabs": {
        "waiting": "Waiting ({count})",
        "history": "Who decided"
      },
      "filterLabel": "Show",
      "filterAll": "All",
      "empty": "Nothing waiting for your OK.",
      "historyEmpty": "No decisions yet.",
      "requestedBy": "Asked by {name} · {date}",
      "requestedByShort": "asked by {name}",
      "receivedAt": "Received {date}",
      "decidedBy": "By {name} · {date}",
      "noteShown": "Note: {note}",
      "noteLabel": "Note for this decision",
      "noteHint": "Why? (needed to reject)",
      "approve": "Approve",
      "reject": "Reject",
      "rejectNeedsNote": "Write a note to reject",
      "ownRequest": "You asked for this, so another person must decide.",
      "noPermission": "Your role cannot decide this request.",
      "approvedNotice": "Approved.",
      "rejectedNotice": "Rejected.",
      "executionFailed": "Approved, but the refund did not go through. Check the payment and try again.",
      "decision": {
        "approved": "Approved",
        "rejected": "Rejected"
      }
    },
    "builderCopilot": {
      "title": "Ask the assistant",
      "lead": "Tell the assistant what to change in your automation. It prepares a proposal; nothing changes until you press Apply.",
      "open": "Ask the assistant",
      "close": "Close",
      "placeholder": "e.g. When someone writes 'thanks', reply 'You're welcome'",
      "send": "Send",
      "thinking": "Preparing a proposal…",
      "empty": "No messages yet. Try: add a button to the main menu, or make the AI agent more formal.",
      "you": "You",
      "assistant": "Assistant",
      "apply": "Apply",
      "discard": "Discard",
      "statusPending": "Waiting for your decision",
      "statusApplied": "Applied (saved as a draft — publish it from the flow editor)",
      "statusDiscarded": "Discarded",
      "statusFailed": "Could not be applied",
      "kindFlowDraft": "Flow draft",
      "kindSystemReply": "System reply",
      "kindAgentInstructions": "AI agent instructions",
      "refusalTitle": "Not possible on a QR-code channel",
      "error": "The assistant is unavailable right now. Please try again.",
      "forbidden": "Only the owner or an admin can use the assistant.",
      "history": "Past conversations",
      "newChat": "New chat",
      "previewSimulator": "Preview in simulator",
      "statusUndone": "Undone (restored as a new draft version)",
      "kindKbEntry": "Knowledge base answer",
      "kindLiveTable": "Live table",
      "kindFlowToggle": "Flow on/off",
      "undo": "Undo this change",
      "diffTitle": "Before and after",
      "diffItem": "What",
      "diffBefore": "Before",
      "diffAfter": "After",
      "diffNone": "(nothing)",
      "diffRemoved": "(removed)",
      "refusalMoney": "Money changes need a human approver",
      "refusalAiFreeText": "No free-text AI inside official WhatsApp flows",
      "refusalFlowsEdit": "You need permission to edit flows",
      "openFlow": "Open flow"
    },
    "ownerAssistant": {
      "title": "Smart assistant",
      "close": "Close the smart assistant",
      "lead": "Ask about your business in plain language: conversations, customers, bookings and abandoned carts. The assistant prepares an action and does nothing until you press Confirm.",
      "placeholder": "Type your question, e.g. How many conversations have no reply today?",
      "send": "Send",
      "thinking": "Thinking…",
      "you": "You",
      "assistant": "Assistant",
      "errorGeneric": "The assistant could not answer. Try again in a moment.",
      "errorRateLimited": "You sent many questions in a short time. Wait a minute and try again.",
      "errorBudget": "Your plan has reached its smart assistant limit this month. Review your plan or contact support.",
      "errorForbidden": "You do not have permission to use the smart assistant. Ask the workspace owner.",
      "emptyTitle": "How can I help today?",
      "chipsLabel": "Suggested questions",
      "chips": {
        "today": "Give me today's summary",
        "waiting": "Who has been waiting for our reply the longest?",
        "team": "How did the team perform this week?",
        "questions": "What are customers asking most this week?",
        "bookings": "What are today's and tomorrow's bookings?",
        "store": "Which carts were abandoned and which products sell most?"
      },
      "shortcutHint": "Keyboard shortcut: Ctrl + J (or ⌘ + J)",
      "home": {
        "title": "Smart assistant",
        "lead": "Ask about your sales, customers and team and get an instant answer with links to the right pages.",
        "examplesLabel": "Try asking",
        "openCta": "Open"
      },
      "suggestions": {
        "title": "Today's suggestions",
        "empty": "No suggestions today.",
        "item": {
          "unanswered": {
            "text": "Conversations without a reply: {count}",
            "cta": "Review them"
          },
          "abandoned_carts": {
            "text": "Abandoned carts: {count}",
            "cta": "View carts"
          },
          "broadcast_idea": {
            "text": "Try a broadcast to your customers this week",
            "cta": "Prepare a draft"
          },
          "bookings_today": {
            "text": "Today's bookings: {count}",
            "cta": "View bookings"
          },
          "low_wallet": {
            "text": "Your messaging wallet balance is low",
            "cta": "Top up"
          }
        }
      },
      "action": {
        "confirmTitle": "Do you want to run this action?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "running": "Running…",
        "done": "Done.",
        "cancelled": "Action cancelled. Nothing changed.",
        "openPage": "Open page",
        "draftNote": "This is a draft only: nothing is sent until you review and approve it yourself.",
        "detail": {
          "title": "Title",
          "due": "Due",
          "name": "Name",
          "message": "Message",
          "conversation": "Conversation",
          "openConversation": "Open conversation",
          "assignee": "Assign to (user ID)"
        },
        "kind": {
          "assign_conversation": "Assign a conversation",
          "create_task": "Create a task",
          "draft_broadcast": "Broadcast draft"
        },
        "errors": {
          "generic": "The action could not be completed. Try again.",
          "CONVERSATION_ALREADY_ASSIGNED": "This conversation is already assigned to someone else.",
          "NO_CHANNEL": "No WhatsApp channel is connected. Connect one first.",
          "FORBIDDEN": "You do not have permission to run this action.",
          "INVALID_INPUT": "The action details are not valid. Ask the assistant to prepare it again."
        }
      }
    },
    "unmatched": {
      "title": "Questions the menu did not answer",
      "lead": "Customer messages on the official WhatsApp number that matched no keyword or button. Turn frequent ones into a keyword or button; the assistant prepares a draft for you to review.",
      "empty": "No unanswered questions yet.",
      "hint": "Messages no keyword or button matched.",
      "count": "{count}",
      "meta": "Asked {count} times · last on {date}",
      "addKeyword": "Add keyword",
      "addButton": "Add button",
      "dismiss": "Dismiss",
      "openAssistant": "Open in assistant",
      "proposed": "Draft prepared. Review and apply it in the assistant; nothing is published automatically."
    },
    "quotes": {
      "title": "Quotes",
      "subtitle": "Every price quote your team prepared, with its status and total.",
      "search": "Search by customer or quote number",
      "searchLabel": "Search quotes",
      "statusFilter": "Filter by status",
      "filter": {
        "all": "All",
        "draft": "Draft",
        "sent": "Sent",
        "accepted": "Accepted",
        "expired": "Expired",
        "converted": "Converted"
      },
      "status": {
        "draft": "Draft",
        "sent": "Sent",
        "viewed": "Sent",
        "accepted": "Accepted",
        "converted": "Converted",
        "rejected": "Declined",
        "expired": "Expired"
      },
      "col": {
        "number": "Quote",
        "customer": "Customer",
        "status": "Status",
        "total": "Total",
        "created": "Created",
        "actions": "Actions"
      },
      "unknownCustomer": "Unknown customer",
      "openQuote": "Open quote",
      "openCustomer": "Customer panel",
      "loadMore": "Show more",
      "detail": {
        "title": "Quote {number}",
        "close": "Close",
        "loading": "Loading the quote…",
        "notFound": "This quote was not found.",
        "customer": "Customer",
        "created": "Created",
        "validUntil": "Valid until",
        "noExpiry": "No expiry date",
        "items": "Items",
        "lineDescription": "Item",
        "qty": "Qty",
        "unitPrice": "Unit price",
        "vat": "VAT",
        "lineTotal": "Total",
        "customItem": "Custom item",
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "tax": "VAT",
        "total": "Total",
        "timeline": "Status timeline",
        "event": {
          "created": "Created",
          "sent": "Sent to the customer",
          "viewed": "Opened by the customer",
          "accepted": "Accepted",
          "rejected": "Declined",
          "expired": "Expired",
          "converted": "Converted to an order"
        },
        "downloadPdf": "Download PDF",
        "openConversation": "Open conversation",
        "openCustomer": "Open customer profile",
        "resend": "Resend",
        "markExpired": "Mark expired",
        "chargeAccount": "Add to account",
        "chargeHint": "Records the total as a charge on the customer account. A manager may need to approve it.",
        "chargeDone": "Added to the customer account.",
        "chargePending": "Sent for approval before it is added to the account.",
        "resent": "The quote was sent again.",
        "expiredDone": "The quote is marked expired."
      },
      "noResults": "No quotes match your search or filter.",
      "empty": {
        "title": "No quotes yet",
        "body": "Quotes you prepare for a customer from the chat panel appear here, with their status and total."
      },
      "intro": {
        "title": "How quotes work",
        "what": "A quote is a priced offer you prepare for a customer in chat. The customer can accept it from a link and you follow its status here.",
        "when": "Use quotes when the price depends on the job, such as a repair, a service visit or a property. A person on your team approves any discount before the quote is sent.",
        "step1": "Open the customer in the inbox and prepare the quote.",
        "step2": "Send it to the customer on WhatsApp.",
        "step3": "Follow it here until it is accepted or expires.",
        "businessName": "Al Noor Workshop",
        "caption": "What the customer receives",
        "msg1": "Your quote Q-00012 is ready: SAR 460.00, valid for 7 days.",
        "time1": "10:12",
        "msg2": "Looks good, I accept.",
        "time2": "10:20",
        "msg3": "Thank you. We will confirm your appointment.",
        "msg3Button": "View quote"
      }
    },
    "trips": {
      "loading": "Loading trips…",
      "col": {
        "brochure": "Brochure",
        "trip": "Trip",
        "destination": "Destination",
        "depart": "Departure",
        "price": "Adult price",
        "seats": "Seats",
        "fill": "Fill rate",
        "status": "Status",
        "actions": "Actions"
      },
      "brochureDownload": "Download brochure",
      "seatsLeft": "{left} of {total} left",
      "fillLabel": "{percent}% full",
      "status": {
        "published": "Published",
        "hidden": "Hidden",
        "full": "Full",
        "cancelled": "Cancelled"
      },
      "add": "Add trip",
      "edit": "Edit",
      "form": {
        "createTitle": "Add a trip",
        "editTitle": "Edit trip",
        "title": "Trip name",
        "destination": "Destination",
        "departOn": "Departure date",
        "returnOn": "Return date",
        "totalSeats": "Number of seats",
        "currency": "Currency",
        "currencySAR": "Saudi riyal (SAR)",
        "currencyBHD": "Bahraini dinar (BHD)",
        "priceAdult": "Adult price",
        "priceChild": "Child price",
        "priceInfant": "Infant price (no seat)",
        "deposit": "Deposit",
        "bookBy": "Book by (last day)",
        "status": "Status",
        "brochure": "Brochure (optional)",
        "brochureHint": "PDF, JPEG or PNG, up to 5 MB.",
        "brochureInvalid": "Choose a PDF, JPEG or PNG file up to 5 MB.",
        "titleAlias": "Alias (Arabic / English)",
        "titleAliasHint": "Optional name in the other language, e.g. the Arabic city name, so customers' searches find this trip.",
        "brochureUrl": "Brochure link (https)",
        "brochureUrlInvalid": "Enter a link starting with https://.",
        "required": "This field is required.",
        "returnBeforeDeparture": "The return date must not be before the departure date.",
        "deadlineAfterDeparture": "The booking deadline must not be after the departure date.",
        "seatsInvalid": "Enter a whole number of seats, at least 1.",
        "priceInvalid": "Enter a valid amount, for example 1250.50.",
        "depositTooHigh": "The deposit cannot be more than the adult price.",
        "save": "Save",
        "cancel": "Cancel"
      },
      "sync": {
        "title": "Sync from Google Sheet",
        "hint": "Keep your trips in a Google Sheet. Pick the sheet and tab, then match each column to a trip detail.",
        "sheet": "Sheet link",
        "loadTabs": "Load tabs",
        "tab": "Tab",
        "field": {
          "key": "Trip code",
          "title": "Trip name",
          "destination": "Destination",
          "depart_on": "Departure date",
          "return_on": "Return date",
          "seats": "Seats",
          "price_adult": "Adult price",
          "price_child": "Child price",
          "price_infant": "Infant price",
          "deposit": "Deposit",
          "currency": "Currency",
          "status": "Status"
        },
        "save": "Save settings",
        "now": "Sync now",
        "auto": "Your sheet is also synced automatically on the interval set above.",
        "result": "Added {created}, updated {updated}, skipped {skipped}.",
        "interval": "Auto-sync every (minutes)",
        "intervalHint": "Allowed range: {min}–{max} minutes. Values outside it are adjusted. Default: {def}.",
        "intervalNoEdit": "Only people who can edit workspace settings can change this."
      }
    },
    "tripBookings": {
      "nav": "Trip bookings",
      "title": "Trip bookings",
      "subtitle": "Every booking by stage, from inquiry to travelled.",
      "seats": "{count, plural, one {# seat} other {# seats}}",
      "markTravelled": "Mark as travelled",
      "cancel": "Cancel booking",
      "depositPending": "Deposit awaiting approval",
      "depositRequest": "Request deposit",
      "depositApprove": "Approve deposit",
      "depositReject": "Reject deposit",
      "depositApproveNote": "Approved from the trip bookings board",
      "depositRejectNote": "Rejected from the trip bookings board",
      "depositAwaiting": "Waiting for a reviewer with accounts permission",
      "depositRefresh": "Refresh decision",
      "status": {
        "expired": "Expired",
        "inquiry": "Inquiry",
        "held": "Seats held",
        "deposit_pending": "Deposit awaiting approval",
        "deposit_paid": "Deposit paid",
        "paid": "Fully paid",
        "travelled": "Travelled",
        "cancelled": "Cancelled"
      },
      "report": {
        "title": "Bookings by package",
        "package": "Package",
        "departure": "Departure",
        "all": "All",
        "csv": "Export CSV",
        "empty": "No bookings yet.",
        "travellers": "Travellers",
        "party": "{adults} adults, {children} children, {infants} infants",
        "deposit": "Deposit",
        "received": "Received",
        "rehold": "Re-hold",
        "openChat": "Open chat",
        "notReceived": "Not received",
        "markDeposit": "Deposit received",
        "confirm": "Confirm",
        "remind": "Send reminder",
        "stage": {
          "filter": "Filter by stage",
          "pending": "Pending",
          "expired": "Expired",
          "confirmed": "Confirmed",
          "inquiry": "Inquiry",
          "held": "Pending",
          "deposit_pending": "Deposit pending",
          "deposit_paid": "Deposit received",
          "paid": "Paid",
          "travelled": "Travelled",
          "cancelled": "Cancelled"
        }
      }
    },
    "getStarted": {
      "b29b": {
        "stepsLabel": "Start steps",
        "open": "Open",
        "channel": {
          "title": "Channel",
          "help": "Connect a WhatsApp number or an Instagram account so customers can message you.",
          "cta": "Connect a channel"
        },
        "assistant": {
          "title": "Assistant",
          "help": "The assistant answers customer questions from your business information and hands the chat to you when needed.",
          "cta": "Set up the assistant"
        },
        "replies": {
          "title": "Replies",
          "help": "Fixed messages sent automatically, such as a welcome and an out-of-hours reply.",
          "cta": "Set up replies"
        },
        "sell": { "title": "Selling" }
      },
      "title": "Start",
      "progress": "{done} of {total} steps done",
      "done": "Done",
      "whatsapp": {
        "title": "Connect WhatsApp",
        "body": "Link your WhatsApp Business number so you can send and receive messages.",
        "cta": "Connect WhatsApp"
      },
      "template": {
        "title": "Get a message template approved",
        "body": "A template lets you message customers first, even after 24 hours of silence.",
        "cta": "Add a template"
      },
      "flow": {
        "title": "Turn on an auto-reply",
        "body": "Build a short chat flow that answers customers for you, then publish it.",
        "cta": "Set up auto-replies"
      },
      "catalog": {
        "title": "Add your products",
        "body": "Show what you sell inside the chat so customers can ask for it.",
        "cta": "Add products"
      },
      "qrAi": {
        "title": "Optional: let AI answer from your own number",
        "body": "Connect a number by QR code and the AI assistant replies to common questions.",
        "cta": "Connect by QR code"
      }
    },
    "console": {
      "loadOlder": "Load older messages",
      "empty": {
        "title": "Nothing here yet"
      },
      "feature": {
        "ai_replies": "AI replies",
        "reply_style": "Reply style",
        "experiments": "Experiments",
        "tool_calculator": "Calculator tool",
        "tool_estimator": "Estimator tool",
        "tool_quote_draft": "Quote drafting",
        "weekly_report": "Weekly report",
        "practice_mode": "Practice mode",
        "voice": "Voice",
        "handoff_waiting_message": "Handoff waiting message",
        "flow_performance_alerts": "Flow performance alerts"
      },
      "diff": {
        "value": {
          "on": "On",
          "off": "Off"
        }
      },
      "proposal": {
        "approve": "Approve",
        "reject": "Reject",
        "error": "The proposal could not be updated. Try again.",
        "status": {
          "pending": "Waiting for you",
          "applying": "Applying",
          "applied": "Applied",
          "rejected": "Rejected",
          "expired": "Expired",
          "conflict": "Changed meanwhile",
          "failed": "Failed"
        },
        "header": "A suggestion that needs your approval",
        "now": "Now",
        "afterApproval": "After approval"
      },
      "result": {
        "applied": "Done. The change was applied and recorded in the audit log.",
        "rejected": "Rejected. Nothing was changed.",
        "expired": "This proposal expired. Ask again to get a fresh one.",
        "conflict": "The target changed after the proposal was made, so nothing was applied. Ask again.",
        "failed": "The change could not be applied. Nothing was changed."
      },
      "summary": {
        "title": "Daily summary for {date}",
        "newConversations": "New conversations",
        "aiAnswered": "Answered by the assistant",
        "handoffs": "Handed to people",
        "unanswered": "Waiting for a reply",
        "topUnanswered": "Top unanswered questions",
        "answerNow": "Answer now",
        "bookings": "New bookings",
        "pendingApprovals": "Waiting for approval",
        "budget": {
          "label": "AI credit",
          "ok": "Healthy",
          "warning": "Running low",
          "exceeded": "Used up"
        },
        "morning": "Morning summary · {time}",
        "showOlder": "Show older summaries",
        "hideOlder": "Hide older summaries",
        "topUp": "Top up credit"
      }
    },
    "packages": {
      "nav": "Packages",
      "pageTitle": "Travel packages",
      "subtitle": "Packages with photos, details and several departure dates.",
      "add": "Add package",
      "empty": "No packages yet.",
      "title": "Package name",
      "destination": "Destination",
      "description": "Description",
      "createTitle": "New package",
      "editTitle": "Edit package",
      "required": "Required",
      "photos": "Photos",
      "photoAlt": "Package photo",
      "photoRemove": "Remove",
      "photoAdd": "Add a photo",
      "photoHint": "Up to 5 photos (JPG, PNG or WebP, 4 MB each).",
      "photoInvalid": "Use a JPG, PNG or WebP photo up to 4 MB.",
      "includes": "Included",
      "excludes": "Not included",
      "linesHint": "One item per line.",
      "itinerary": "Day by day",
      "itineraryHint": "One day per line: title | details.",
      "hotel": "Hotel notes",
      "flight": "Flight notes",
      "deposit": "Deposit",
      "bookBy": "Book by",
      "departures": "Departures",
      "departuresEmpty": "No departures yet.",
      "addDeparture": "Add departure",
      "fromPrice": "From",
      "settings": "Booking settings",
      "passportWhen": "Passport / ID",
      "passportAfter": "After confirmation",
      "passportAt": "At booking",
      "holdMinutes": "Hold seats (minutes)",
      "saved": "Saved",
      "sheetSettings": "Google Sheet sync",
      "noPackage": "No package",
      "deleteDeparture": "Delete departure",
      "deletePackage": "Delete package",
      "delete": "Delete",
      "deleteTitle": "Delete?",
      "deletePackageConfirm": "Delete “{name}”, its departures and photos? This cannot be undone.",
      "deleteDepartureConfirm": "Delete this departure? This cannot be undone."
    },
    "states": {
      "noResults": "No results",
      "clearFilters": "Clear filters",
      "ordersEmpty": "No orders yet.",
      "ordersEmptyCta": "Create your first order",
      "apiKeysEmptyViewer": "No keys yet. Ask an admin to create one."
    }
  },
  "admin": {
    "breach": {
      "retry": "Try again",
      "heading": "Breach incidents",
      "error": "Could not load or save incidents.",
      "titleLabel": "Incident title",
      "create": "Log incident",
      "loading": "Loading…",
      "empty": "No incidents logged.",
      "status": {
        "detected": "Detected",
        "confirmed": "Confirmed",
        "closed": "Closed"
      },
      "window": "Regulator window: {hours} h",
      "overdue": "Overdue: the regulator-notification window has elapsed and no notification is recorded.",
      "remaining": "{hours} h left to notify the regulator",
      "confirm": "Confirm breach",
      "markTenant": "Mark tenants notified",
      "markRegulator": "Mark regulator notified"
    },
    "metaReconciliation": {
      "heading": "Meta billing reconciliation",
      "loading": "Loading…",
      "forbidden": "Only platform administrators can view reconciliation.",
      "empty": "No reconciliation runs yet.",
      "run": "Run {date}",
      "flagged": "{count} flagged",
      "clean": "Clean",
      "drill": "Show workspaces",
      "workspace": "Workspace",
      "statement": "Meta statement",
      "ledger": "Ledger",
      "drift": "Drift",
      "lines": "Statement lines: {ids}",
      "entries": "Ledger entries: {ids}",
      "retry": "Try again"
    },
    "services": {
      "heading": "Professional services board",
      "subtitle": "Move each client engagement from request to delivery. Delivery unlocks once the handover checklist is complete.",
      "loading": "Loading engagements…",
      "emptyStage": "No cards in this stage",
      "retry": "Try again",
      "error": "Something went wrong. Try again.",
      "handoverIncomplete": "The handover checklist must be 100% complete before delivery.",
      "stages": {
        "requested": "Requested",
        "scoped": "Scoped",
        "in_progress": "In progress",
        "review": "Review",
        "delivered": "Delivered"
      },
      "slaOverdue": "SLA overdue",
      "scopeConflict": "Tenant edited: {areas}",
      "followUp": "Follow-up needed",
      "checklist": "Handover {done}/{total}",
      "advance": "Next stage",
      "checklistItems": {
        "channel_connected": "Channel connected",
        "first_flow_published": "First flow published",
        "flows_published": "Flows published",
        "inbox_walkthrough": "Owner walked through inbox",
        "billing_walkthrough": "Owner walked through billing",
        "knowledge_base_populated": "Knowledge Base populated",
        "catalog_configured": "Catalog configured",
        "flows_reviewed": "Flows reviewed",
        "broadcasts_executed": "Broadcasts executed",
        "monthly_report_sent": "Monthly report sent",
        "contacts_imported": "Contacts imported",
        "templates_synced": "Templates synced",
        "number_reconnected": "Number reconnected",
        "cutover_verified": "Cutover verified",
        "handover_walkthrough": "Handover walkthrough done"
      },
      "assignPartner": "Assign to partner",
      "partnerAgencyId": "Partner agency ID",
      "payoutSplit": "Partner payout %",
      "partnerBadge": "Partner-fulfilled ({percent}%)",
      "partnerNotApproved": "That agency is not an approved implementation partner."
    },
    "servicesRevenue": {
      "heading": "Professional services revenue",
      "separateNote": "Reported separately from subscription MRR and wallet revenue.",
      "empty": "No service revenue yet.",
      "lines": "{count} purchases"
    },
    "title": "Wato — Super Admin",
    "planEditor": {
      "heading": "Plan editor",
      "loading": "Loading…",
      "forbidden": "Only platform administrators can edit plans.",
      "error": "Something went wrong. Try again.",
      "saved": "Saved.",
      "limitsHeading": "Limits",
      "limitType": "Limit type",
      "fixed": "Fixed (lifetime, never refills)",
      "periodic": "Periodic (refills every calendar month)",
      "cadenceHeading": "Cadence pricing (minor units)",
      "quarterly": "Quarterly",
      "yearly": "Yearly",
      "sar": "SAR",
      "bhd": "BHD",
      "save": "Save",
      "addOnsHeading": "Add-on catalog",
      "addOnKey": "Key",
      "addOnNameEn": "English name",
      "addOnNameAr": "Arabic name",
      "addOnModule": "Entitlement key it stacks onto",
      "addOnIncrease": "Limit increase",
      "addOnMode": "Billing mode",
      "recurring": "Recurring",
      "oneTime": "One-time",
      "addOnSave": "Save add-on",
      "retry": "Try again"
    },
    "featureFlags": {
      "heading": "Feature flags",
      "qrNewTenants": "Allow new WhatsApp QR connections for new tenants",
      "qrNewTenantsHint": "Kill switch. When off, workspaces without an existing QR channel cannot create one.",
      "loading": "Loading…",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "forbidden": "Only platform admins can change feature flags.",
      "error": "Could not load or save the flag. Try again.",
      "saved": "Saved"
    },
    "aiMonitoring": {
      "retry": "Try again",
      "engineHeading": "Engine health (webhook to first reply)",
      "engineNonAi": "Non-AI flows (budget p95 1.5 s)",
      "engineAi": "AI in the loop (budget p95 6 s)",
      "engineSamples": "Samples",
      "heading": "AI Agent monitoring",
      "agentType": "Agent type",
      "channelType": "Channel",
      "all": "All",
      "qr": "QR",
      "cloud": "Cloud API",
      "activeConversations": "Active conversations",
      "errorRate": "Error rate",
      "fallbackRate": "Fallback rate",
      "avgConfidence": "Avg confidence",
      "budgetExhaustion": "Budget exhaustions",
      "latencyP50": "Latency p50",
      "latencyP95": "Latency p95 (target < 6s)",
      "overTarget": "Over 6s target",
      "loading": "Loading…",
      "forbidden": "Only platform admins can view AI monitoring.",
      "error": "Could not load AI monitoring data."
    },
    "listingPerformance": {
      "heading": "Store listing performance",
      "forbidden": "Only platform administrators can view listing performance.",
      "error": "Could not load listing performance. Try again.",
      "empty": "No store installs recorded yet.",
      "store": "Store",
      "installs": "Installs",
      "activation": "Activation rate",
      "uninstall": "Uninstall rate",
      "trend": "Daily installs",
      "status": {
        "submitted": "Submitted",
        "approved": "Approved",
        "rejected": "Rejected — resubmit manually",
        "resubmitted": "Resubmitted"
      }
    },
    "installSource": {
      "heading": "Workspace install sources",
      "workspace": "Workspace",
      "source": "Install source",
      "direct": "Direct signup",
      "salla_app_store": "Salla App Store",
      "status": "Status",
      "billing": "Billing mode",
      "domain": "Store domain",
      "scopes": "OAuth scopes granted",
      "provisioning": "Provisioning",
      "complete": "Complete",
      "pending": "Pending",
      "failed": "Failed",
      "stalled": "Stalled",
      "refresh": "Force refresh",
      "refreshing": "Refreshing…",
      "refreshed": "Provisioning re-run",
      "empty": "No workspaces yet.",
      "error": "Could not load install sources or refresh.",
      "forbidden": "Only platform admins can view install sources.",
      "override": "Switch to platform billing",
      "overrideReason": "Reason (logged)",
      "overrideConfirm": "Confirm switch",
      "overridden": "Billing mode switched to platform billing"
    },
    "tenants": {
      "b29b": {
        "col": {
          "customer": "Customer",
          "channels": "Channels",
          "activity": "Last activity"
        },
        "test": "🧪 Test",
        "trialPlan": "Trial",
        "noPlan": "No plan",
        "healthHelp": "This customer's health has not been calculated yet.",
        "bulk": {
          "apply": "🧩 Apply features"
        },
        "menu": {
          "label": "Actions",
          "support": "Open as support",
          "type": "Change type",
          "open": "Open page",
          "suspend": "Suspend",
          "reinstate": "Reinstate",
          "terminate": "Terminate"
        },
        "confirm": {
          "cancel": "Cancel",
          "typePrompt": "Type the customer name to confirm: {name}",
          "suspend": "“{name}” will lose access to the account until you reinstate it.",
          "terminate": "“{name}” will be terminated and its data scheduled for deletion. This cannot be undone."
        }
      },
      "heading": "Tenants",
      "subtitle": "Search, review and control every customer account.",
      "loading": "Loading tenants…",
      "retry": "Try again",
      "search": "Search by name or slug",
      "status": "Status",
      "allStatuses": "All statuses",
      "sort": "Sort by",
      "sortName": "Name",
      "sortMrr": "MRR",
      "sortCreated": "Created",
      "name": "Workspace",
      "plan": "Plan",
      "mrr": "MRR",
      "empty": "No tenants match.",
      "forbidden": "Only platform administrators can manage tenants.",
      "error": "Something went wrong. Try again.",
      "reason": "Reason (required)",
      "suspend": "Suspend",
      "reinstate": "Reinstate",
      "terminate": "Terminate",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "exportOffer": "Data export offer",
      "exportDeclined": "The tenant declined a data export",
      "exportDone": "A fresh data export was generated (export id)",
      "blockedExport": "Termination is blocked: complete the data-export offer first.",
      "blockedConfirm": "Termination is blocked: the slug confirmation does not match.",
      "statuses": {
        "trial": "Trial",
        "active": "Active",
        "grace": "Grace",
        "suspended": "Suspended",
        "terminated": "Terminated"
      },
      "health": "Health",
      "sortHealth": "Health score",
      "seats": {
        "heading": "Team seats",
        "planLimit": "Plan limit",
        "override": "Override",
        "none": "none",
        "unlimited": "Unlimited",
        "seatsLabel": "Seats",
        "reasonLabel": "Reason",
        "expiresLabel": "Expires (optional)",
        "hint": "Leave Seats empty and save to return to the plan limit.",
        "save": "Save seats",
        "saved": "Seat limit saved",
        "failed": "Could not save the seat limit"
      },
      "ctl": {
        "heading": "Account control",
        "status": "Account status",
        "plan": "Plan",
        "suspend": "Suspend account",
        "reinstate": "Reactivate account",
        "reason": "Reason (required)",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "done": "Account status updated",
        "failed": "Could not update the account status",
        "supportHeading": "Support access",
        "auditHeading": "Recent actions",
        "auditNone": "No recorded actions",
        "auditFailed": "Could not load the log"
      },
      "showAllLock": {
        "heading": "\"Show all features\" option",
        "allow": "Member decides",
        "force_on": "Always show all features",
        "force_off": "Always filter by account type",
        "saved": "Saved.",
        "failed": "Could not save."
      },
      "bt": {
        "column": "Account type",
        "filter": "Filter by account type",
        "allTypes": "All types",
        "edit": "Change type",
        "select": "Select",
        "selectAll": "Select all",
        "editorHeading": "Account type",
        "typeLabel": "Account type",
        "previous": "Previous value",
        "previewShown": "Will show",
        "previewMore": "Moved to More",
        "previewHidden": "Will be hidden",
        "none": "None",
        "save": "Save",
        "close": "Close",
        "saved": "Account type saved.",
        "failed": "Could not save the account type.",
        "bulkHeading": "Apply one type to {count} selected",
        "bulkApply": "Apply to selected",
        "bulkOk": "Saved",
        "bulkFail": "Failed",
        "types": {
          "general": "General",
          "online_store": "Online store",
          "restaurant": "Restaurant / cafe",
          "clinic": "Clinic",
          "salon": "Salon / beauty",
          "services": "Services",
          "real_estate": "Real estate",
          "car_workshop": "Car workshop",
          "travel": "Travel and tourism",
          "retail_shop": "Shop or wholesale"
        }
      },
      "wallet": {
        "heading": "Adjust wallet",
        "amountLabel": "Amount in minor units (positive to add, negative to deduct)",
        "reasonLabel": "Reason",
        "hint": "Example: 5000 adds 5.000 BHD. The balance cannot go negative.",
        "confirm": "I confirm this adjustment",
        "apply": "Apply adjustment",
        "done": "Done. New balance: {amount}",
        "failed": "Could not adjust. Check the amount and that the balance is enough."
      }
    },
    "flags": {
      "heading": "Feature flags",
      "default": "On by default",
      "rollout": "Rollout",
      "killSwitch": "Kill switch",
      "revive": "Revive",
      "killed": "Killed",
      "overrides": "Overrides",
      "save": "Save",
      "reason": "Reason for the kill switch (required)",
      "forbidden": "Only platform administrators can manage feature flags.",
      "error": "Something went wrong. Try again.",
      "empty": "No feature flags yet.",
      "propagation": "A kill switch reaches every server within five minutes, without a deploy.",
      "retry": "Try again"
    },
    "impersonation": {
      "heading": "Impersonate tenant user",
      "workspace": "Workspace ID",
      "user": "User ID",
      "reason": "Reason for write access",
      "start": "Start read-only session",
      "elevate": "Elevate to read-write (60 min)",
      "end": "End session",
      "consent": "Tenant consent or support ticket found",
      "noAccess": "No tenant consent or open support ticket. A second Super Admin must sign off (break-glass).",
      "approver": "Second Super Admin ID (break-glass)",
      "blocked": "Blocked: sign-off from a different Super Admin is required.",
      "active": "Session active ({mode})",
      "error": "Could not complete the action"
    },
    "channelHealth": {
      "heading": "Channel health",
      "empty": "No channels connected",
      "status": "Status",
      "banRisk": "Ban risk",
      "error": "Could not load channel health"
    },
    "wahaFleet": {
      "capabilities": "Engine capabilities (read-only)",
      "heading": "WhatsApp QR sessions",
      "empty": "No WhatsApp QR sessions",
      "session": "Session",
      "uptime": "Uptime (s)",
      "engine": "Engine",
      "restart": "Restart",
      "rescan": "Re-scan",
      "disconnect": "Force disconnect",
      "loadError": "Could not load WhatsApp QR sessions",
      "confirm": "Confirm",
      "confirmRestart": "Restart this QR session? The client reconnects and may need a new scan.",
      "confirmRescan": "Re-scan this QR session? It is restarted and a fresh QR code is issued.",
      "confirmDisconnect": "Force-disconnect this QR session? The workspace loses its QR channel until it re-links.",
      "disconnectedMetric": "Disconnected: {down} of {total} sessions"
    },
    "dlq": {
      "heading": "Queues and dead letters",
      "explainer": "Queue health and failed jobs waiting for a decision.",
      "retryLoad": "Refresh",
      "loading": "Loading queues…",
      "empty": "No failed jobs",
      "queue": "Queue",
      "active": "Active",
      "waiting": "Waiting",
      "completed": "Completed",
      "failed": "Failed",
      "reason": "Failure reason",
      "retries": "Retries",
      "manual": "Requires manual intervention",
      "retry": "Retry",
      "discard": "Discard",
      "error": "Could not load queues",
      "noQueues": "No queues found",
      "confirm": "Confirm",
      "confirmRetry": "Retry this job? It is re-queued for processing.",
      "confirmDiscard": "Discard this job? It is removed from the queue and cannot be retried.",
      "actionError": "Could not complete the action"
    },
    "healthSignals": {
      "deliveryRate": "Delivery rate",
      "errorRate": "Error rate",
      "apiLatency": "API latency",
      "paymentStatus": "Payment status",
      "activation": "Activation"
    },
    "support": {
      "heading": "Support inbox",
      "explainer": "Customer tickets across all workspaces. Open a ticket to read the thread and reply.",
      "loading": "Loading tickets…",
      "retry": "Try again",
      "selectTicket": "Select a ticket to read the thread.",
      "emptyHint": "New tickets from workspaces will appear here.",
      "empty": "No support tickets.",
      "subject": "Subject",
      "workspace": "Workspace",
      "status": "Status",
      "channel": "Channel",
      "sla": "SLA",
      "overdue": "SLA overdue",
      "assign": "Assign to me",
      "assignedTo": "Assigned",
      "unassigned": "Unassigned",
      "open": "Open",
      "thread": "Thread",
      "reply": "Reply",
      "replyPlaceholder": "Write a reply",
      "send": "Send reply",
      "resolve": "Resolve",
      "error": "Something went wrong. Try again.",
      "statuses": {
        "open": "Open",
        "pending": "Pending",
        "resolved": "Resolved",
        "escalated": "Escalated"
      },
      "allStatuses": "All statuses",
      "staff": "Staff",
      "tenant": "Tenant"
    },
    "userOps": {
      "heading": "Users (cross-tenant)",
      "search": "Search",
      "name": "Name or email",
      "phone": "Phone (E.164)",
      "email": "Email",
      "status": "Status",
      "memberships": "Workspaces and roles",
      "noMemberships": "No workspaces",
      "reason": "Reason (required)",
      "forceReset": "Force password reset",
      "forceLogout": "Force logout",
      "disable": "Disable account",
      "empty": "No users found",
      "done": "Action completed",
      "error": "Could not complete the action"
    },
    "abuse": {
      "heading": "Abuse review queue",
      "empty": "No open abuse flags",
      "workspace": "Workspace",
      "signal": "Signal",
      "detected": "Detected",
      "dismiss": "Dismiss",
      "escalate": "Escalate to enforcement ladder",
      "hint": "Flags are for manual review only; nothing is actioned automatically.",
      "error": "Could not load or review flags",
      "signals": {
        "spam_broadcast": "Spam-pattern broadcasting",
        "bulk_import": "Bulk import abuse",
        "test_number_usage": "Excessive test-number usage",
        "api_volume": "Unusual API volume"
      }
    },
    "maintenance": {
      "heading": "Maintenance mode",
      "explainer": "Show a maintenance message to everyone or to one workspace.",
      "retryLoad": "Try again",
      "loading": "Loading…",
      "workspaceIdHint": "Enter the workspace ID to continue.",
      "scope": "Scope",
      "platform": "Platform-wide",
      "tenant": "Single workspace",
      "workspaceId": "Workspace ID",
      "message": "Banner message",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "active": "Active modes",
      "none": "Maintenance mode is off",
      "error": "Could not update maintenance mode"
    },
    "blocklists": {
      "heading": "Global blocklists",
      "type": "Type",
      "value": "Value",
      "add": "Add",
      "remove": "Remove",
      "empty": "No entries",
      "keyword": "Banned keyword",
      "phone": "Phone number",
      "template_phrase": "Template phrase",
      "error": "Could not update the blocklist",
      "subtitle": "Banned keywords, phone numbers and template phrases applied across every workspace.",
      "retry": "Try again",
      "loading": "Loading entries…",
      "valueRequired": "Enter a value to add."
    },
    "changelog": {
      "subtitle": "Publish dated updates in Arabic and English for customers to read.",
      "entries": "Published entries",
      "empty": "No entries yet. Publish the first update using the form above.",
      "loading": "Loading entries…",
      "retry": "Try again",
      "title": "Changelog",
      "error": "Could not save the changelog.",
      "category": "Category",
      "date": "Publish date",
      "titleAr": "Title (Arabic)",
      "titleEn": "Title (English)",
      "bodyAr": "Details (Arabic)",
      "bodyEn": "Details (English)",
      "publish": "Publish entry",
      "remove": "Remove",
      "categories": {
        "feature": "New feature",
        "improvement": "Improvement",
        "fix": "Fix",
        "announcement": "Announcement"
      }
    },
    "denied": {
      "title": "No access to the Super Admin console",
      "description": "This account is not a platform administrator. Sign in with an administrator account.",
      "signOut": "Sign out"
    },
    "stepUp": {
      "title": "Confirm it's you",
      "description": "This action is sensitive. Enter your authentication code to continue (valid for 10 minutes).",
      "cancel": "Cancel"
    },
    "login": {
      "title": "Super Admin sign-in",
      "email": "Email",
      "password": "Password",
      "submit": "Sign in",
      "code": "Authentication code",
      "verify": "Verify",
      "continue": "Continue",
      "codeHelp": "Enter the 6-digit code from your authenticator app.",
      "enrollHelp": "Two-factor authentication is mandatory for platform admins. Scan the QR code (or enter the key) in your authenticator app, then enter the code.",
      "backupCodes": "Two-factor is on. Save these backup codes now — they are shown only once.",
      "errors": {
        "invalid": "Wrong email or password.",
        "code": "That code is not valid. Try again.",
        "network": "Cannot reach the server. Try again.",
        "generic": "Something went wrong. Try again."
      }
    },
    "announcements": {
      "subtitle": "Send a banner, WhatsApp or email message to a chosen group of workspaces.",
      "required": "Write the banner text in both languages.",
      "sent": "Announcement created.",
      "heading": "Announcements",
      "segmentPlans": "Plans (comma-separated tiers, empty = all)",
      "segmentCountries": "Countries (comma-separated, empty = all)",
      "bannerAr": "Banner text (Arabic)",
      "bannerEn": "Banner text (English)",
      "channels": "Channels",
      "inApp": "In-app banner",
      "whatsapp": "WhatsApp",
      "email": "Email",
      "scheduledAt": "Send at (empty = now)",
      "send": "Create announcement",
      "error": "Could not create the announcement",
      "history": "Recent announcements",
      "none": "No announcements yet"
    },
    "revenue": {
      "heading": "Revenue metrics",
      "mrr": "MRR",
      "arpu": "ARPU",
      "revenueChurn": "Revenue churn",
      "logoChurn": "Logo churn",
      "failedPayments": "Failed-payment rate",
      "walletBurn": "Wallet burn trend",
      "planMix": "Plan distribution",
      "currency": "Currency",
      "day": "Day",
      "burn": "Burn",
      "topup": "Top-ups",
      "plan": "Plan",
      "count": "Workspaces",
      "error": "Could not load revenue metrics"
    },
    "auditExplorer": {
      "retry": "Try again",
      "heading": "Audit explorer",
      "severity": "Severity",
      "severityAny": "Any severity",
      "severityInfo": "Info",
      "severityWarning": "Warning",
      "severityCritical": "Critical",
      "downloadCsv": "Download CSV",
      "csvTruncated": "The export was cut at the row limit; narrow the filters.",
      "user": "User ID",
      "workspace": "Workspace ID",
      "from": "From",
      "to": "To",
      "action": "Action",
      "entityType": "Entity type",
      "entityId": "Entity ID",
      "text": "Search text",
      "search": "Search",
      "results": "Results",
      "platformEntry": "Platform",
      "when": "When",
      "actor": "Actor",
      "entity": "Entity",
      "none": "No matching audit entries",
      "error": "Could not search the audit log"
    },
    "costMonitor": {
      "heading": "AI and Meta cost monitor",
      "ai": "AI cost",
      "meta": "Meta cost",
      "workspace": "Workspace",
      "currency": "Currency",
      "outliers": "Cost outliers",
      "noOutliers": "No outliers detected",
      "reason": "Reason",
      "spike_vs_own_baseline": "Spike vs own baseline",
      "high_vs_fleet": "High vs fleet",
      "zScore": "Z-score",
      "latest": "Latest day",
      "baseline": "Baseline mean",
      "error": "Could not load cost data",
      "subtitle": "Platform-wide AI and Meta spend, with unusual workspaces flagged.",
      "retry": "Try again",
      "loading": "Loading cost data…",
      "totals": "Totals by currency"
    }
  },
  "pages": {
    "b29b": {
      "landing": {
        "channels": "On WhatsApp and Instagram",
        "menu": "Menu"
      },
      "backToWhatsapp": "Back to WhatsApp",
      "contactStore": "Contact the store on WhatsApp"
    },
    "checkout": {
      "title": "Choose how to pay",
      "order": "Order {ref}",
      "total": "Total",
      "cod": "Cash on delivery",
      "codHint": "Pay the courier when your order arrives.",
      "benefit": "BenefitPay",
      "benefitHint": "Transfer the amount below, then send the receipt photo in the WhatsApp chat.",
      "benefitPhone": "BenefitPay number",
      "benefitName": "Account name",
      "bank": "Bank transfer",
      "bankHint": "Transfer the amount to the account below, then send the receipt photo in the WhatsApp chat.",
      "bankName": "Bank",
      "bankHolder": "Account holder",
      "bankIban": "IBAN",
      "link": "Card payment link",
      "linkHint": "We will send a secure payment link in the WhatsApp chat.",
      "amount": "Amount",
      "confirm": "Confirm",
      "submitting": "Please wait...",
      "doneTitle": "Thank you!",
      "doneBody": "Go back to the WhatsApp chat - we sent you the next step there.",
      "unavailable": "This payment method is no longer available. Please pick another.",
      "alreadyChosen": "A payment method was already chosen for this order.",
      "error": "We couldn't save your payment method. Check your connection, then tap Confirm again.",
      "noMethods": "No payment methods are available. Please contact the store."
    },
    "web": {
      "back": "Back",
      "order": {
        "title": "Menu",
        "empty": "No products are available right now.",
        "other": "Other",
        "itemCount": "{count} items",
        "viewCart": "View cart ({count})",
        "minOrder": "Minimum order is {amount}",
        "addMore": "Add more",
        "cart": "Cart",
        "cartEmpty": "Your cart is empty.",
        "qty": "Quantity",
        "comment": "Note for this item (optional)",
        "add": "Add to cart",
        "remove": "Remove",
        "checkout": "Continue",
        "delivery": "Delivery",
        "pickup": "Pickup",
        "area": "Area",
        "freeAbove": "Free delivery on orders of {amount} or more.",
        "name": "Name",
        "phone": "Mobile number",
        "address": "Address",
        "notes": "Order notes (optional)",
        "payment": "Payment",
        "pay_cod": "Cash on delivery",
        "pay_link": "Payment link",
        "pay_bank_transfer": "Bank transfer",
        "pay_benefit": "BenefitPay transfer",
        "subtotal": "Subtotal",
        "deliveryFee": "Delivery fee",
        "free": "Free",
        "submit": "Place order",
        "submitting": "Sending...",
        "doneTitle": "Order received",
        "doneBody": "Thank you. Order total {total}. We sent a confirmation in your chat.",
        "problem_unavailable": "Some items are no longer available, please review your cart.",
        "problem_belowMinimum": "Your order is below the minimum order amount.",
        "problem_error": "Could not place the order, please try again.",
        "problem_priceChanged": "The price changed, please review the new total and confirm.",
        "problem_expired": "This link has expired, please ask for a new one."
      },
      "trip": {
        "title": "Trips",
        "empty": "No trips are open right now.",
        "from": "From {price}",
        "includes": "Included",
        "excludes": "Not included",
        "itinerary": "Itinerary",
        "pickDate": "Choose a departure date",
        "seatsLeft": "Seats left: {count}",
        "adults": "Adults",
        "children": "Children",
        "infants": "Infants",
        "next": "Next",
        "passportNote": "We will ask for the travellers' passport photos in the chat after booking.",
        "date": "Date",
        "travellers": "Travellers (adult/child/infant)",
        "deposit": "Deposit",
        "depositManual": "The deposit is paid manually; our team will contact you with payment instructions and confirm the booking.",
        "submit": "Confirm booking",
        "doneTitle": "Your seats are held",
        "doneBody": "Total {total}, deposit {deposit}.",
        "problem_no_seats": "There are no longer enough seats on this date.",
        "problem_unavailable": "This date is no longer available.",
        "problem_price_changed": "The price changed, please reopen the page and review the total.",
        "problem_invalid": "Please check your details and try again.",
        "problem_expired": "This link has expired, please ask for a new one.",
        "problem_error": "Could not complete the booking, please try again."
      }
    },
    "title": "Wato",
    "loading": "Loading…",
    "brandFallback": "Wato",
    "site": {
      "meta": {
        "title": "Wato — WhatsApp chatbots, team inbox and selling for Saudi & Bahrain businesses",
        "description": "Wato helps Saudi and Bahraini businesses answer customers on WhatsApp, run a shared team inbox, automate with a scoped AI agent and sell in chat — in Arabic first."
      },
      "nav": {
        "label": "Site navigation",
        "features": "Features",
        "pricing": "Pricing",
        "demo": "Book a demo",
        "contact": "Contact",
        "how": "How it works",
        "faq": "FAQ"
      },
      "hero": {
        "title": "Turn WhatsApp into your best sales and support channel",
        "subtitle": "Wato helps you reply to your customers on WhatsApp with automatic replies, and sell and take bookings right in the chat.",
        "cta": "Start free",
        "secondary": "Book a demo",
        "how": "See how it works",
        "login": "Sign in",
        "mockAlt": "Illustration of a WhatsApp conversation with a dashboard card",
        "mockBadge": "Illustrative example"
      },
      "benefits": {
        "title": "Why Wato?",
        "reply": {
          "title": "Reply to customers fast",
          "body": "All your WhatsApp messages in one place, and your team can reply together."
        },
        "auto": {
          "title": "Automatic replies",
          "body": "Common questions are answered for you, and the chat comes to you when needed."
        },
        "sell": {
          "title": "Sell and take bookings",
          "body": "Send products, prices and payment links, and arrange appointments in the same chat."
        }
      },
      "features": {
        "title": "Everything for conversations that sell",
        "inbox": {
          "title": "Shared team inbox",
          "body": "Assign, label and reply together, with notes and full customer history in one place."
        },
        "ai": {
          "title": "AI agent with a human safety net",
          "body": "Answers only from your knowledge base and hands over to a person when it is unsure."
        },
        "flows": {
          "title": "Flows, buttons and lists",
          "body": "Build guided conversations on the official WhatsApp Cloud API without code."
        },
        "sell": {
          "title": "Sell in chat",
          "body": "Share catalogue items, quotes and payment links. A person always approves the money."
        },
        "crm": {
          "title": "Light CRM",
          "body": "Contacts, tags and follow-up sequences that respect opt-in and quiet hours."
        },
        "arabic": {
          "title": "Arabic first",
          "body": "Right-to-left from the ground up, with English one tap away."
        },
        "orders": {
          "title": "Orders and manual payment approval",
          "body": "The system drafts the cart and quote; a permitted person approves the amount and confirms payment."
        },
        "broadcasts": {
          "title": "Broadcasts",
          "body": "Send campaigns to contacts who opted in, using approved templates and within your channel limits."
        },
        "qr": {
          "title": "QR quick-link (optional)",
          "body": "An optional channel that runs the AI agent only — no flows, buttons or templates."
        },
        "inboxIcon": "Inbox",
        "aiIcon": "Agent",
        "flowsIcon": "Chat flows"
      },
      "pricing": {
        "title": "Simple monthly pricing",
        "note": "Prices in SAR per month, excluding 15% VAT. Final pricing is confirmed at checkout.",
        "perMonth": "/ month",
        "from": "from",
        "cta": "Choose plan",
        "contact": "Talk to sales",
        "plan": {
          "ai_qr": "AI QR",
          "starter": "Starter",
          "growth": "Growth",
          "business": "Business",
          "enterprise": "Enterprise"
        },
        "blurb": {
          "ai_qr": "AI agent on a linked WhatsApp number — ideal for trying things out.",
          "starter": "Official WhatsApp API, inbox and broadcasts for small teams.",
          "growth": "Flows, catalogue and in-chat selling for growing teams.",
          "business": "Higher limits, integrations and advanced routing.",
          "enterprise": "Custom limits, onboarding and dedicated support."
        },
        "sample": "Sample prices, pending final approval.",
        "bhdNote": "Bahrain: {bhd}"
      },
      "demo": {
        "title": "See Wato in action",
        "body": "Book a 30-minute walkthrough with our team in Arabic or English.",
        "cta": "Book a demo",
        "whatsappText": "Hello, I would like to book a demo of Wato."
      },
      "contact": {
        "title": "Talk to us on WhatsApp",
        "body": "Questions before you start? Message us and we reply during working hours.",
        "cta": "Chat on WhatsApp",
        "whatsappText": "Hello, I have a question about Wato."
      },
      "legal": {
        "label": "Legal",
        "terms": "Terms of service",
        "privacy": "Privacy policy",
        "dataDeletion": "Data deletion",
        "dpa": "Data processing agreement",
        "aup": "Acceptable use policy"
      },
      "footer": {
        "rights": "© {year} Wato. All rights reserved.",
        "product": "Product",
        "legalTitle": "Legal",
        "tagline": "Wato: WhatsApp-first for businesses in Saudi Arabia and Bahrain."
      },
      "signup": {
        "title": "Ready to start?",
        "body": "Create your workspace in minutes. No card needed for the trial.",
        "cta": "Create your account"
      },
      "mock": {
        "business": "Rose Shop",
        "q": "Do you have red roses today?",
        "a": "Hi! Yes, we do. Want me to send the prices?",
        "q2": "Yes please",
        "cardTitle": "Today",
        "cardChats": "New conversations",
        "cardOrders": "Orders awaiting approval",
        "cardHandoff": "Handed to a person"
      },
      "how": {
        "title": "How it works",
        "subtitle": "Three steps from connecting to approving.",
        "step": "Step {n}",
        "s1": {
          "title": "Connect your channel",
          "body": "Link your official WhatsApp number (Cloud API) and set working hours and reply language.",
          "biz": "Rose Shop",
          "q": "Hello",
          "a": "Hello and welcome to Rose Shop! How can we help?",
          "caption": "Illustrative example: welcome reply"
        },
        "s2": {
          "title": "Set up replies and the AI agent",
          "body": "Build flows with buttons and lists, or turn on an AI agent that answers only from your knowledge and hands over to a person when needed.",
          "biz": "Rose Shop",
          "q": "How much is the large bouquet?",
          "a": "The large bouquet is SAR 180. Shall I hand you to a person to place the order?",
          "caption": "Illustrative example: AI agent with handoff"
        },
        "s3": {
          "title": "Run orders with your team",
          "body": "Your team works from one inbox, and a permitted person approves every cart, quote and discount before it is sent.",
          "biz": "Rose Shop",
          "q": "I'd like the large bouquet",
          "a": "Your quote is ready. A team member will approve it, then we send the payment link.",
          "caption": "Illustrative example: order awaiting approval"
        }
      },
      "faq": {
        "title": "Frequently asked questions",
        "q1": {
          "q": "Is this a general-purpose AI chatbot?",
          "a": "No. Every AI agent is limited to your knowledge and scope and hands over to a person when it is unsure."
        },
        "q2": {
          "q": "Is there a ban risk when using QR?",
          "a": "Yes. The QR channel is not the official WhatsApp channel and WhatsApp may ban numbers linked this way. That is why it is optional, AI agent only, and we recommend the official Cloud API for important business."
        },
        "q3": {
          "q": "Are broadcasts allowed?",
          "a": "Within Meta's rules: the 24-hour window, approved templates outside it, customer opt-in, quiet hours and tier limits."
        },
        "q4": {
          "q": "Who approves amounts and discounts?",
          "a": "A permitted person on your team. The AI drafts, and never approves money."
        },
        "q5": {
          "q": "Can I use Arabic and English?",
          "a": "Yes. The interface is Arabic first (right-to-left) with English one tap away."
        },
        "q6": {
          "q": "Where is my data stored?",
          "a": "We do not currently promise a specific storage location. See the privacy policy and data processing agreement for details."
        }
      },
      "jsonld": {
        "orgDescription": "WhatsApp chatbots, team inbox and in-chat selling."
      }
    },
    "subject": {
      "cart": "Your cart",
      "quote": "Your quote",
      "payment_link": "Your payment"
    },
    "expired": {
      "title": "This link has expired",
      "body": "For your security, links stop working after a while. Ask the business to send you a new one.",
      "request": "Request a new link",
      "requested": "Thanks. The business has been notified and will send you a new link.",
      "error": "We could not send your request. Please try again."
    },
    "invalid": {
      "title": "We could not open this link",
      "body": "The link looks incomplete or incorrect. Check the message you received or ask the business for a new link."
    },
    "ready": "Your secure page is ready.",
    "total": "Total",
    "items": "Items",
    "itemFallback": "Item",
    "loadError": "We could not load this page. Please try again.",
    "cart": {
      "title": "Your cart"
    },
    "quote": {
      "title": "Quote",
      "downloadPdf": "Download PDF",
      "accept": "Accept quote",
      "reject": "Decline",
      "askLabel": "Have a question?",
      "ask": "Send question",
      "accepted": "Thank you! You accepted this quote. The business will be in touch.",
      "rejected": "You declined this quote.",
      "asked": "Your question was sent to the business.",
      "closed": "This quote can no longer be answered.",
      "expiredNow": "This quote has just expired. Ask the business for a new one.",
      "subtotal": "Subtotal",
      "shipping": "Shipping",
      "vat": "VAT"
    },
    "pay": {
      "title": "Payment",
      "pay": "Pay",
      "paid": "This payment is complete. Thank you!",
      "unavailable": "This payment link is no longer available.",
      "testMode": "TEST MODE — no real money will be charged.",
      "testCheckout": {
        "title": "Test payment page",
        "body": "This is a preview of the checkout in test mode. No money will be charged.",
        "amount": "Amount",
        "description": "Description",
        "pay": "Pay (test)",
        "paid": "Test payment completed. The order will show as paid for the merchant.",
        "failed": "The test payment could not be completed. Please try again."
      },
      "payingTo": "Paying to",
      "amountDue": "Amount due",
      "summary": "Order summary",
      "secureNote": "Secure, encrypted payment. Your card details are handled by the payment gateway and never stored by us.",
      "state": {
        "paid": {
          "title": "Payment received",
          "body": "This payment is complete. Thank you!"
        },
        "expired": {
          "title": "This link has expired",
          "body": "This payment link has expired. Ask the merchant for a new one."
        },
        "failed": {
          "title": "Payment could not be completed",
          "body": "The payment did not go through and you were not charged. Contact the merchant for a new link."
        },
        "unavailable": {
          "title": "Link unavailable",
          "body": "This payment link is no longer available."
        }
      }
    },
    "shortLink": {
      "inactive": {
        "title": "This link is no longer active",
        "body": "The business has turned this link off or it has expired. Please contact them directly."
      }
    },
    "marketing": {
      "nav": {
        "label": "Main navigation",
        "home": "Home",
        "pricing": "Pricing",
        "changelog": "Changelog",
        "compare": "Compare"
      },
      "landing": {
        "title": "WhatsApp chatbots, team inbox and in-chat selling",
        "body": "Answer customers, run your team inbox, and sell inside WhatsApp — built for Saudi Arabia and Bahrain.",
        "cta": "See pricing"
      },
      "pricing": {
        "title": "Simple pricing, no bill shock",
        "subtitle": "Pick a plan, then estimate your monthly cost below.",
        "monthly": "per month",
        "yearly": "per year (2 months free)",
        "aiCredits": "AI credits / month",
        "enterprise": "Enterprise",
        "enterpriseBody": "Custom pricing for multi-branch teams, from",
        "custom": "Custom",
        "agencyTitle": "Agency plans",
        "agencyClients": "client workspaces included",
        "currency": "Currency",
        "plan": {
          "ai_qr": "AI QR",
          "starter": "Starter",
          "growth": "Growth",
          "business": "Business",
          "agency_starter": "Agency Starter",
          "agency_growth": "Agency Growth",
          "agency_scale": "Agency Scale"
        }
      },
      "calculator": {
        "title": "Cost-preview calculator",
        "plan": "Plan",
        "marketing": "Marketing messages / month",
        "utility": "Utility messages / month",
        "authentication": "Authentication messages / month",
        "aiStandard": "AI messages — standard tier / month",
        "aiEconomy": "AI messages — economy tier / month",
        "resultPlan": "Plan",
        "resultAi": "AI messages beyond included credits",
        "resultMeta": "Estimated Meta fees (billed by Meta)",
        "resultTotal": "Estimated monthly total",
        "creditsUsed": "Included AI credits used",
        "disclaimer": "Estimates only. Meta fees use indicative rates — verify in your WhatsApp Manager. AI QR has no Meta fees."
      },
      "changelog": {
        "title": "Changelog",
        "empty": "Release notes will appear here."
      },
      "compare": {
        "title": "Our AI agent vs Meta Business AI",
        "subtitle": "Meta's agent answers questions. Ours also acts on your store and calendar — with a human approving anything that involves money.",
        "capability": "Capability",
        "ours": "Wato AI agent",
        "meta": "Meta Business AI",
        "rows": {
          "dialect": {
            "label": "Arabic quality",
            "ours": "Saudi and Gulf dialect tuning, Arabic-first replies",
            "meta": "General multilingual model"
          },
          "storeData": {
            "label": "Store data",
            "ours": "Reads Salla and Zid catalogs, stock and orders",
            "meta": "Limited to what you upload to Meta"
          },
          "actions": {
            "label": "Taking action",
            "ours": "Creates draft orders, books slots, checks order status",
            "meta": "Mostly answers questions"
          },
          "approvals": {
            "label": "Money approvals",
            "ours": "A permitted human approves carts, quotes, discounts and refunds",
            "meta": "Not part of the product"
          },
          "handoff": {
            "label": "Human handoff",
            "ours": "Scoped agent, one-tap handoff to your team inbox",
            "meta": "Handoff options vary by surface"
          },
          "pricing": {
            "label": "Pricing",
            "ours": "Flat plans with AI credits and spend caps",
            "meta": "Usage-based (per token)"
          }
        },
        "note": "Comparison reflects public information at the time of writing and may change."
      }
    },
    "currency": {
      "SAR": "SAR",
      "BHD": "BHD"
    }
  },
  "payments": {
    "b29": {
      "summary": {
        "label": "Payments summary",
        "today": "Received today",
        "week": "This week",
        "pending": "Awaiting payment",
        "refunded": "Refunded"
      },
      "filter": {
        "all": "All",
        "paid": "Paid",
        "pending": "Pending",
        "failed": "Failed",
        "refunded": "Refunded"
      },
      "search": "Search by customer or reference",
      "noResults": "No payments match.",
      "row": {
        "copyReference": "Copy reference",
        "copied": "Copied"
      },
      "link": {
        "send": "Send to customer",
        "putInMessage": "Put in message",
        "copy": "Copy link",
        "copied": "Link copied",
        "sent": "Payment link sent",
        "windowClosed": "The 24-hour window is closed. Send a template first.",
        "sendFailed": "Could not send the link. Try again.",
        "payNow": "Pay now"
      }
    },
    "list": {
      "nav": "Payments",
      "title": "Payments",
      "intro": "Payments received from your customers through payment links, newest first.",
      "empty": "No payments yet",
      "emptyHint": "When a customer pays a payment link, the payment appears here. Pending links are tracked on the payment analytics page.",
      "error": "Could not load payments.",
      "status": {
        "captured": "Captured",
        "pending": "Pending",
        "failed": "Failed",
        "refunded": "Refunded",
        "partiallyRefunded": "Partially refunded"
      },
      "provider": {
        "tap": "Tap",
        "other": "Other"
      },
      "viewOrder": "View order",
      "needsReview": "Needs review"
    },
    "reconciliation": {
      "title": "Payment reconciliation",
      "intro": "Differences between the payment gateway and your records. Missed confirmations are fixed automatically; records the gateway does not confirm need your review.",
      "empty": "No discrepancies found.",
      "error": "Could not load reconciliation issues.",
      "filterOpen": "Needs review",
      "filterAll": "All",
      "kind": {
        "paid_but_not_recorded": "Paid at gateway, missing locally (fixed automatically)",
        "recorded_but_not_paid": "Recorded as paid, not confirmed by the gateway",
        "amount_mismatch": "Paid, but the gateway captured a different amount or currency"
      },
      "status": {
        "open": "Open",
        "backfilled": "Fixed automatically",
        "resolved": "Resolved"
      },
      "reference": "Gateway reference",
      "amount": "Amount",
      "detected": "Detected",
      "resolve": "Mark as resolved",
      "resolveNote": "Resolution note (optional)",
      "resolveConfirm": "Confirm",
      "resolveCancel": "Cancel",
      "resolveError": "Could not resolve this issue."
    },
    "refund": {
      "title": "Request a refund",
      "remaining": "Refundable: {amount}",
      "action": "Request refund",
      "amount": "Refund amount",
      "maxHint": "Up to {amount}",
      "reason": "Reason",
      "details": "Details (optional)",
      "reasons": {
        "customer_request": "Customer request",
        "damaged": "Damaged or defective",
        "wrong_item": "Wrong item",
        "not_delivered": "Not delivered",
        "duplicate": "Duplicate payment",
        "other": "Other (describe below)"
      },
      "approvalNotice": "This sends a request for approval. No money moves until a manager approves it.",
      "submit": "Send for approval",
      "cancel": "Cancel",
      "success": "Refund request sent for approval.",
      "orderNoPayment": "This order has no online payment to refund automatically.",
      "errors": {
        "generic": "The refund request could not be sent.",
        "overMax": "The amount is more than what is left to refund ({amount}).",
        "REFUND_FORBIDDEN": "Your role is not allowed to request refunds.",
        "WORKSPACE_FORBIDDEN": "Your role is not allowed to request refunds.",
        "REFUND_AMOUNT_INVALID": "Enter a valid refund amount.",
        "REFUND_REASON_REQUIRED": "Describe the reason.",
        "REFUND_PAYMENT_NOT_FOUND": "Payment not found.",
        "REFUND_EXCEEDS_CAPTURE": "The amount is more than what is left to refund.",
        "REFUND_NOT_CAPTURED": "This payment was not captured, so it cannot be refunded."
      },
      "execution": {
        "done": "Refund approved and issued.",
        "doneOrder": "Refund approved and issued. The order was updated.",
        "failed": "Approved, but the refund could not be issued: {reason}",
        "REFUND_FORBIDDEN": "your role may not issue refunds",
        "REFUND_CEILING_EXCEEDED": "the amount is above your refund limit",
        "REFUND_EXCEEDS_CAPTURE": "the amount is more than what is left to refund",
        "REFUND_NOT_CAPTURED": "the payment was not captured",
        "REFUND_GATEWAY_FAILED": "the payment gateway refused it",
        "other": "unexpected error"
      },
      "queue": {
        "kind": "Refund request",
        "summary": "Refund {amount} · {reason}"
      }
    },
    "manualLink": {
      "action": "Payment link",
      "amount": "Amount",
      "currency": "Currency",
      "description": "Description",
      "submit": "Create link",
      "created": "Payment link created:",
      "pending": "Amount is above the approval limit. Sent to a manager for approval.",
      "release": "Approved? Generate the link",
      "rejected": "The manager rejected this request.",
      "stillPending": "Still waiting for manager approval.",
      "error": "Could not create the payment link. Check the details and try again.",
      "noGateway": "No payment gateway is connected. Connect a payment gateway first to create payment links.",
      "noGatewayAction": "Open payment gateway settings",
      "errors": {
        "generic": "Could not create the payment link. Check the details and try again.",
        "rejected": "The manager rejected this request.",
        "stillPending": "Still waiting for manager approval.",
        "badAmount": "The amount is invalid. Enter a number above zero with the right decimals for the currency (SAR 2, BHD 3).",
        "badDescription": "A description is required (up to 200 characters).",
        "badCurrency": "This currency is not supported. Choose SAR or BHD.",
        "gatewayFailed": "The payment gateway rejected the request. Check the gateway settings and try again later.",
        "forbidden": "You do not have permission to create payment links."
      }
    }
  },
  "storybook": {
    "button": "Save changes",
    "delete": "Delete",
    "more": "More options",
    "next": "Next",
    "back": "Back",
    "inputLabel": "Business name",
    "inputPlaceholder": "e.g. Rose Bakery",
    "inputError": "This field is required",
    "passwordLabel": "Password",
    "amountLabel": "Amount",
    "modalTitle": "Archive this conversation?",
    "modalBody": "Archived conversations move out of the inbox. You can restore them at any time.",
    "modalConfirm": "Archive",
    "open": "Open dialog",
    "toastSuccess": "Changes saved",
    "toastError": "Could not send the message",
    "toastInfo": "A new version is available",
    "toastDetail": "This notice closes by itself after a few seconds.",
    "showToast": "Show notification"
  },
  "auth": {
    "errors": {
      "validation": "Check the highlighted fields and try again.",
      "passwordPolicy": "Use a password of at least {count} characters.",
      "rateLimited": "Too many attempts. Please wait a few minutes and try again.",
      "unauthenticated": "Sign in to continue.",
      "emailUnverified": "Verify your email to connect a channel",
      "accountDisabled": "This account is disabled. Contact support.",
      "tokenInvalid": "This verification link is not valid.",
      "tokenUsed": "This verification link was already used.",
      "tokenExpired": "This verification link has expired. Request a new one.",
      "oauthFailed": "Google sign-in did not complete. Please try again.",
      "oauthEmailUnverified": "Your Google account email address is not verified.",
      "passwordBreached": "This password has appeared in a known data breach. Choose a different one.",
      "invalidCredentials": "The email address or password is incorrect.",
      "loginLocked": "Too many failed sign-in attempts. Try again later or reset your password.",
      "twoFactorChallengeInvalid": "This sign-in step has expired. Sign in again.",
      "twoFactorInvalid": "That code is not valid. Try again or use a backup code.",
      "twoFactorLocked": "Too many wrong codes. Code entry is locked for 5 minutes. You can use a backup code instead.",
      "twoFactorSetupRequired": "Two-factor authentication is required for your account (because of your role or workspace policy). Set it up to continue.",
      "twoFactorAlreadyEnabled": "Two-factor authentication is already turned on.",
      "twoFactorNotPending": "Two-factor setup was not started or has expired. Start it again.",
      "sessionNotFound": "This session was not found or has already ended.",
      "originForbidden": "This request was blocked for security reasons.",
      "resetTokenInvalid": "This password reset link is not valid.",
      "resetTokenUsed": "This password reset link was already used.",
      "resetTokenExpired": "This password reset link has expired. Request a new one.",
      "workspaceNotFound": "Workspace not found.",
      "phoneInUse": "This phone number is already linked to another account.",
      "ssoRequired": "Your workspace requires single sign-on. Use your company sign-in instead.",
      "reauthFailed": "The password is not correct.",
      "emailInUse": "This email address already belongs to another account.",
      "emailChangeInvalid": "This confirmation link is not valid.",
      "emailChangeUsed": "This confirmation link was already used.",
      "emailChangeExpired": "This confirmation link has expired. Request a new one from your profile."
    },
    "actions": {
      "resendVerification": "Resend verification email"
    }
  },
  "email": {
    "common": {
      "footer": "Wato — WhatsApp inbox, chatbots and sales for your business."
    },
    "verifyEmail": {
      "subject": "Confirm your email address",
      "heading": "Welcome to Wato",
      "body": "Confirm your email address to finish setting up your account. You need to confirm it before you can connect a WhatsApp channel.",
      "action": "Confirm email",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "expiry": "The link works once and expires in {count, plural, one {# hour} other {# hours}}.",
      "ignore": "If you did not create a Wato account, you can ignore this email."
    },
    "accountExists": {
      "subject": "Sign-up attempt with your email address",
      "heading": "You already have a Wato account",
      "body": "Someone, maybe you, tried to create a new Wato account with this email address. Nothing was changed on your existing account.",
      "action": "Sign in",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "ignore": "If this was not you, no action is needed. Your password was not changed."
    },
    "passwordReset": {
      "subject": "Reset your Wato password",
      "heading": "Reset your password",
      "body": "We received a request to reset the password of your Wato account. Use the button below to choose a new one.",
      "action": "Choose a new password",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "expiry": "The link works once and expires in {count, plural, one {# minute} other {# minutes}}.",
      "ignore": "If you did not ask for this, you can ignore this email. Your password stays the same."
    },
    "emailChange": {
      "subject": "Confirm your new Wato email",
      "heading": "Confirm your new email address",
      "body": "Someone asked to use this address as the sign-in email of a Wato account. Use the button below to confirm it.",
      "action": "Confirm new email",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "expiry": "The link works once and expires in {count, plural, one {# minute} other {# minutes}}.",
      "ignore": "If this was not you, ignore this email. Nothing changes."
    },
    "emailChanged": {
      "subject": "Your Wato sign-in email was changed",
      "heading": "Your sign-in email was changed",
      "body": "The sign-in email of your Wato account was just changed to {email}, and every device was signed out.",
      "action": "Sign in",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "notYou": "If you did not do this, contact support right away."
    },
    "passwordChanged": {
      "subject": "Your Wato password was changed",
      "heading": "Your password was changed",
      "body": "The password of your Wato account was just changed, and every device was signed out.",
      "action": "Sign in",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "notYou": "If you did not do this, reset your password right away and contact support."
    },
    "invite": {
      "subject": "{inviter} invited you to {workspace} on Wato",
      "subjectNoInviter": "Invitation to join {workspace} on Wato",
      "heading": "Join {workspace} on Wato",
      "body": "{inviter} invited you to join the {workspace} workspace on Wato.",
      "bodyNoInviter": "You have been invited to join the {workspace} workspace on Wato.",
      "role": "Your role: {role}.",
      "action": "Accept invitation",
      "linkLabel": "If the button does not work, copy this link into your browser:",
      "expiry": "The invitation works once and expires in {count, plural, one {# day} other {# days}}.",
      "ignore": "If you were not expecting this invitation, you can ignore this email."
    },
    "channelDisconnected": {
      "subject": "Your WhatsApp channel disconnected",
      "heading": "WhatsApp channel disconnected",
      "body": "{sessionName} on {workspace} left WhatsApp. Messages will not send or arrive until you reconnect it.",
      "action": "Re-scan QR",
      "linkLabel": "If the button does not work, copy this link into your browser:"
    },
    "channelPaused": {
      "subject": "Your WhatsApp channel was paused",
      "heading": "WhatsApp channel paused",
      "body": "{sessionName} on {workspace} was paused after several messages failed to send in a row, to protect the number. Review it before resuming.",
      "action": "Review channel",
      "linkLabel": "If the button does not work, copy this link into your browser:"
    }
  },
  "workspace": {
    "b29b": {
      "modules": {
        "names": {
          "products": "Products",
          "services": "Services",
          "documents": "Documents (PDF and links)"
        },
        "descriptions": {
          "products": "Your product catalog.",
          "services": "Services customers can book.",
          "documents": "Quotes, invoices and receipts as PDF files or links."
        },
        "lockedOn": "Turned on by the admin",
        "dependsOn": {
          "products": "Turning products off also turns off the store and orders.",
          "services": "Turning services off also turns off bookings."
        },
        "confirmOff": "Turn it off? Things that depend on it will turn off too.",
        "confirmCta": "Turn off",
        "groups": {
          "sales": "Sales",
          "bookings": "Bookings and trips",
          "finance": "Money and documents"
        }
      },
      "currency": {
        "label": "Currency",
        "help": "Used for orders, payment links, services and reports. Old orders keep their currency.",
        "saved": "Currency saved",
        "names": {
          "BHD": "Bahraini dinar",
          "SAR": "Saudi riyal"
        },
        "catalogMismatch": "Meta catalog currency ({catalog}) differs from the workspace currency ({workspace})"
      }
    },
    "errors": {
      "validation": "Check the highlighted fields and try again.",
      "forbidden": "You don't have permission to do this in this workspace.",
      "slugTaken": "That workspace address is already taken. Choose another one.",
      "fieldLocked": "The country and billing currency can't be changed after sign-up. Contact support.",
      "limitReached": "You've reached the maximum number of workspaces you can own.",
      "ownerNotEnrolled": "Turn on two-step verification for your own account before requiring it for everyone.",
      "confirmationMismatch": "The workspace address you typed doesn't match.",
      "onboardingMethodRequired": "Choose a connection method before continuing.",
      "onboardingStepLocked": "This setup step isn't available yet.",
      "onboardingTestMessageRequired": "Send a test message to your own phone and confirm it was delivered before continuing.",
      "testMessageInvalidPhone": "Enter the phone number in international format, e.g. +966501234567.",
      "testMessageNoChannel": "Connect a WhatsApp channel before sending a test message.",
      "testMessageNotFound": "That test message was not found.",
      "logoInvalid": "Upload a PNG or JPEG image up to 256 KB.",
      "logoTooLarge": "The logo must be 256 KB or smaller.",
      "logoNotFound": "This workspace has no logo yet.",
      "pendingDeletion": "This workspace is scheduled for deletion and is read-only. Cancel the deletion to make changes.",
      "exportRequired": "Download a copy of your data, or confirm you don't need one, before deleting the workspace.",
      "exportNotFound": "This export isn't available anymore. Prepare a new one.",
      "deletionAlreadyRequested": "Deletion has already been requested for this workspace.",
      "deletionNotRequested": "This workspace isn't scheduled for deletion.",
      "deletionGraceExpired": "The 30-day restore period has ended, so the deletion can't be cancelled anymore."
    },
    "businessHours": {
      "b29b30": {
        "previewOpen": "Open now",
        "previewClosed": "Closed now",
        "previewNext": "Opens {when}"
      },
      "title": "Business hours",
      "hint": "When your team is available. Automations, routing and quiet hours follow these hours.",
      "days": {
        "sun": "Sunday",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday"
      },
      "openDay": "Open on {day}",
      "closed": "Closed",
      "opens": "Opens",
      "closes": "Closes",
      "addInterval": "Add hours",
      "removeInterval": "Remove these hours",
      "overnightHint": "If the closing time is earlier than the opening time, the hours run past midnight.",
      "statusOpen": "Open now ({time})",
      "statusClosed": "Closed now ({time})",
      "statusHoliday": "Closed today: {name}",
      "holidays": "Holidays",
      "holidaysHint": "Days you're closed. A holiday can last several days.",
      "holidayName": "Name",
      "holidayStart": "From",
      "holidayEnd": "To (optional)",
      "removeHoliday": "Remove {name}",
      "noHolidays": "No holidays yet.",
      "saved": "Business hours saved",
      "b29b": {
        "addHoliday": "Holiday",
        "holidayMenu": {
          "eidAlFitr": "Eid al-Fitr",
          "eidAlAdha": "Eid al-Adha",
          "nationalDay": "National Day",
          "custom": "Specific date"
        },
        "timezones": {
          "bahrain": "Bahrain (Manama)",
          "riyadh": "Saudi Arabia (Riyadh)",
          "dubai": "UAE (Dubai)",
          "kuwait": "Kuwait",
          "qatar": "Qatar (Doha)",
          "muscat": "Oman (Muscat)",
          "cairo": "Egypt (Cairo)",
          "amman": "Jordan (Amman)",
          "baghdad": "Iraq (Baghdad)",
          "beirut": "Lebanon (Beirut)",
          "istanbul": "Turkey (Istanbul)",
          "london": "United Kingdom (London)",
          "utc": "Universal time"
        }
      },
      "presets": {
        "eidAlFitr": "Eid al-Fitr {year} AH",
        "eidAlAdha": "Eid al-Adha {year} AH"
      }
    },
    "lifecycle": {
      "dangerBody": "Deleting starts a 30-day restore period. The workspace becomes read-only, and after 30 days it's erased permanently with all its data.",
      "stepExport": "Step 1: Keep a copy of your data",
      "exportBody": "Download a ZIP file with the workspace details, settings, business hours and team members.",
      "prepareExport": "Prepare download",
      "downloadExport": "Download ZIP ({kb} KB)",
      "exportReady": "Your copy is ready.",
      "declineExport": "I don't need a copy of the data",
      "stepConfirm": "Step 2: Confirm",
      "exportFirst": "Download your data, or confirm you don't need it, to continue.",
      "requested": "Deletion scheduled. You can cancel it within 30 days.",
      "pendingTitle": "Deletion scheduled",
      "pendingBanner": "{days, plural, =0 {This workspace will be deleted today.} one {This workspace will be deleted in # day.} other {This workspace will be deleted in # days.}} It's read-only until then.",
      "pendingBody": "The workspace and all its data will be erased on {date}.",
      "cancelDeletion": "Cancel deletion",
      "cancelled": "Deletion cancelled. The workspace is fully restored.",
      "ownerOnly": "Only an owner can cancel the deletion."
    },
    "automationSettings": {
      "title": "Automation",
      "csatOnClose": "Ask customers for a 1-5 rating when a conversation is closed (inside the 24-hour window)",
      "description": "Controls how automation behaves when your team steps in.",
      "autoPause": "Pause automation on a conversation when an agent replies manually",
      "saved": "Automation settings saved.",
      "aiSuggestedReplies": "Show AI-suggested replies to agents in the inbox",
      "aiSuggestedRepliesHint": "Each time an agent opens a conversation this makes one paid AI request, so it is off until you turn it on.",
      "googleReviewUrl": "Google review link (sent to customers who rate 4 or 5)",
      "googleReviewUrlHint": "Customers who rate above the limit below get a thank-you with this link. Leave empty to skip. Must start with https://.",
      "csatMessageAr": "Survey message in Arabic (leave empty for the default text)",
      "csatMessageEn": "Survey message in English (leave empty for the default text)",
      "csatMessageHint": "Sent when a conversation closes. Customers reply with a number from 1 to 5.",
      "csatLowScoreMax": "Reopen the conversation for a human when the rating is up to",
      "autoResume": "Let the AI resume after a human takeover:",
      "autoResumeNever": "Never (give back manually)",
      "autoResumeMinutes": "{minutes, plural, one {After # minute} other {After # minutes}}",
      "autoAssign": "Automatically assign new unassigned conversations to online agents, evenly",
      "customerMemory": "Remember durable facts about customers from closed conversations (preferences, complaints) and use them in AI replies"
    },
    "sessionExpiry": {
      "title": "Session expiry",
      "description": "Default timeouts used when a flow step or a human chat has none of its own. Leave empty to turn off.",
      "flowWait": "Flow wait expiry (minutes)",
      "flowWaitHint": "Applied to question and wait steps without their own timeout. Up to {max} minutes.",
      "humanChat": "Human chat expiry (minutes)",
      "humanChatHint": "An inactive human-assigned chat returns to automation after this long. Up to {max} minutes.",
      "save": "Save",
      "saved": "Session expiry saved.",
      "invalid": "Enter a whole number between 1 and {max}, or leave empty."
    },
    "sso": {
      "title": "Single sign-on (SSO)",
      "hint": "Let your team sign in with your company identity provider (SAML 2.0 or OpenID Connect).",
      "protocol": "Protocol",
      "saml": "SAML 2.0",
      "oidc": "OpenID Connect",
      "metadata": "IdP metadata (XML for SAML, discovery JSON for OIDC)",
      "metadataUrl": "Or metadata URL (https)",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "clientSecretKept": "Leave blank to keep the stored secret",
      "attrEmail": "Email attribute",
      "attrName": "Name attribute (optional)",
      "attrRole": "Role claim (optional)",
      "save": "Save",
      "saved": "SSO settings saved",
      "testConnection": "Test connection",
      "testOk": "Connection test succeeded",
      "testFailed": "Connection test failed. Check the metadata and client credentials.",
      "lastTested": "Last successful test: {time}",
      "notTested": "Not tested yet. Test the connection before enabling enforcement.",
      "loadFailed": "Could not load SSO settings",
      "invalid": "Invalid SSO configuration ({field}): {message}",
      "jit": "Create accounts automatically (just-in-time)",
      "jitHint": "On: people who sign in through your IdP for the first time get an account. Off: only members you already added can sign in; others see a \"contact your admin\" message.",
      "enforce": "Require SSO for this workspace",
      "enforceHint": "Members of this workspace can no longer sign in with a password.",
      "enforceLocked": "Available after a successful connection test.",
      "rolesTitle": "Role mapping",
      "rolesHint": "Map an IdP group or role claim value to a platform role. Unmatched users get the Viewer role.",
      "claimValue": "IdP claim value",
      "platformRole": "Platform role",
      "addRule": "Add rule",
      "removeRule": "Remove rule",
      "saveRules": "Save mapping",
      "rulesSaved": "Role mapping saved",
      "updateFailed": "Could not update the setting"
    },
    "signature": {
      "title": "Message signature",
      "description": "Appended to the messages you send from the inbox.",
      "text": "Signature text",
      "enabled": "Add my signature to outgoing messages",
      "save": "Save signature",
      "saved": "Signature saved"
    },
    "modules": {
      "title": "Modules",
      "hint": "Choose which parts of Wato your business uses. Your business type only suggests the defaults; your plan can still limit a module.",
      "saved": "Modules updated.",
      "suggested": "Suggested for your business type.",
      "moneyNote": "Handles money, so it stays off until you turn it on.",
      "prompt": {
        "title": "Turn on {modules}?",
        "body": "Your business type usually uses {modules}. They are off until you turn them on, so they do not show up for your team yet.",
        "cta": "Turn on {modules}",
        "later": "Not now",
        "saved": "Done. {modules} are on.",
        "names": {
          "accounts": "customer accounts",
          "quotes": "quotes"
        },
        "joiner": " and "
      },
      "enableHint": "Enable in settings",
      "hiddenTabsHint": "Some tabs are hidden because their module is off.",
      "names": {
        "accounts": "Customer accounts",
        "travel": "Travel",
        "store": "Store",
        "quotes": "Quotes",
        "tables": "Table bookings",
        "bookings": "Appointments",
        "products": "Products",
        "services": "Services",
        "documents": "Documents"
      },
      "descriptions": {
        "accounts": "Customer balances and statements; lets the AI assistant tell a customer their balance.",
        "travel": "Trips, seats and traveller documents.",
        "store": "Products, carts and orders.",
        "quotes": "Price quotes you send for approval.",
        "tables": "Restaurant table reservations.",
        "bookings": "Appointments, services and staff calendars.",
        "products": "Your product list; the store needs it.",
        "services": "Your service list; appointments need it.",
        "documents": "Invoices and order papers."
      }
    },
    "aiSession": {
      "title": "AI session",
      "description": "How the AI agent behaves inside one conversation: merging quick messages, splitting long replies and ending the session.",
      "b29b": {
        "debounceLabel": "Wait before replying",
        "splitLabel": "Split long replies",
        "expiryLabel": "Assistant comes back after",
        "debounce": { "instant": "Right away", "s2": "2 s", "s5": "5 s", "custom": "{n} s" },
        "split": { "off": "No", "paragraph": "Each paragraph", "custom": "Custom" },
        "expiry": {
          "m15": "15 min",
          "h1": "1 hour",
          "h4": "4 hours",
          "d1": "1 day",
          "manual": "Manual",
          "custom": "{n} min"
        }
      },
      "stopWords": "Stop words",
      "stopWordsHint": "Separate with commas. A customer message with one of them ends the AI session. Up to {max} words.",
      "saved": "AI session settings saved.",
      "invalid": "Check the numbers and the stop words, then try again."
    }
  },
  "channels": {
    "healthBanner": {
      "reason": {
        "disconnected": "WhatsApp channel is disconnected, so messages are not being sent or received.",
        "needsReauth": "WhatsApp rejected the connection of this number. Reconnect it so messages and media keep flowing.",
        "tokenExpired": "The WhatsApp access token has expired, so messages are not being sent or received.",
        "webhookSilent": "No messages have reached the channel for a while, although it is connected. If you expect customers to write, check the channel.",
        "qrFailed": "The QR session failed, so the AI agent cannot reply on this number.",
        "qrStopped": "The QR session was stopped, so the AI agent cannot reply on this number.",
        "threadOwnerConflict": "Another app connected to your Facebook Page owns your Instagram conversations, so replies from Wato are being rejected. Fix it in the Page messaging settings."
      },
      "cta": {
        "reconnect": "Reconnect",
        "open": "Open channels"
      },
      "dismiss": "Dismiss",
      "channelsCount": "{count} channels"
    },
    "nav": "Channels",
    "page": {
      "title": "Channels",
      "subtitle": "Connect the numbers your team sends and receives WhatsApp messages on."
    },
    "errors": {
      "qrChannelAiAgentOnly": "WhatsApp QR channels only support the AI Agent — they can't be used with flows or triggers."
    },
    "whatsappCloud": {
      "buildFlowCta": "Build a flow",
      "step1": "Press “Add Channel” and sign in with the Facebook account tied to your business.",
      "step2": "Pick your WhatsApp Business account, or create a new one.",
      "step3": "Enter the phone number and the verification code you receive. The connection finishes by itself.",
      "b29": {
        "addNumber": "＋ Add number",
        "connectTitle": "Steps to connect a new number",
        "test": "Test",
        "sendTest": "Send a test message",
        "testTitle": "Connection test",
        "hoursLine": "Reply by business hours",
        "hoursHelp": "Choose what happens inside and outside business hours for this number.",
        "tileLastMessage": "Last message",
        "tileFailed": "Failed (24h)"
      },
      "connecting": "Connecting…",
      "connected": "Connected",
      "otpFailed": "We couldn't verify that number after a few tries.",
      "startOver": "Start over",
      "signupErrors": {
        "numberTaken": "This number is on another WhatsApp account. Remove it there first.",
        "permissionDenied": "Meta refused permission. Start over and approve all permissions.",
        "noWaba": "No WhatsApp Business account was found. Start over and choose “Create a new WhatsApp Business account” in the Meta popup, or sign in with the account that owns it.",
        "noNumber": "No phone number was selected. Start over and pick or add a number in the Meta popup, then finish the verification code step.",
        "tokenExpired": "The sign-in code from Meta expired or was already used. Press “Try again” and finish the Meta popup in one go, without leaving it open.",
        "webhookNotSubscribed": "Meta did not confirm the link; nothing was connected. Try again.",
        "registerFailed": "Meta could not register the number. Nothing was connected.",
        "phoneMismatch": "This reconnect used a different number than the channel's. Choose the same number in the Meta popup, or add the other number as a new channel.",
        "noCode": "The connection was not completed. If you closed the Meta popup, press “Add Channel” again. If you declined the permissions, start over and approve all of them.",
        "noFinish": "The Meta window closed early. Press “Add Channel” again.",
        "diag": "Details: last event {event}, code received: {code}.",
        "diagYes": "yes",
        "diagNo": "no",
        "diagNoEvent": "none",
        "webhookNotSubscribedDetail": "Meta did not confirm that messages will reach us (webhook not verified). Nothing was connected. Press “Try again”; if it repeats, confirm in Meta Business settings that the app has access to this WhatsApp account, then contact support.",
        "permissionDeniedDetail": "Meta refused permission. Start over, sign in with the Facebook account that manages the business, and approve every permission shown (WhatsApp management and messaging). If you are not an admin of the Business portfolio, ask the admin to connect.",
        "numberTakenDetail": "This number is already registered on another WhatsApp account. Remove it there first (Meta Business → WhatsApp accounts → Phone numbers → Delete), or tick “Keep using the WhatsApp Business app” and connect again.",
        "noFinishDetail": "The Meta window closed but did not send the completion details, so nothing was connected. Press “Add Channel” again and finish the steps in the Meta window. If it repeats, send support a screenshot of this message.",
        "registerFailedDetail": "Meta could not register this number. Nothing was connected. Check that the number can receive SMS or calls and is not blocked, then press “Try again”.",
        "detailsToggle": "Details"
      },
      "retry": "Try again",
      "fakeSignupTitle": "Connect WhatsApp (simulated)",
      "fakeSignupHint": "Development mode: this simulates Meta's Embedded Signup with a fake business account and number.",
      "simulationBanner": "Simulation mode: no real number is connected and no real messages are sent.",
      "fakeSignupNumber": "Phone number",
      "fakeSignupConfirm": "Connect",
      "fakeSignupBlockedProd": "Simulated signup is disabled in production. Ask your administrator to configure Meta Embedded Signup.",
      "httpsRequired": "Meta's signup popup only works over HTTPS. Open the dashboard via https (e.g. vite --https with mkcert, or a tunnel) and try again.",
      "configMissing": "Meta app settings (app ID / config ID) are not configured on the server.",
      "signupTimeout": "Signup took too long (60 s). Close any Meta popup and try again.",
      "manualCta": "Manual connect",
      "manualHeading": "Advanced / manual connect",
      "manualHint": "For teams with their own Meta app. The token is sent once and never shown again.",
      "wabaId": "WhatsApp Business Account ID",
      "phoneNumberId": "Phone number ID",
      "token": "Access token",
      "manualSubmit": "Connect",
      "manualCancel": "Cancel",
      "manualConnecting": "Connecting…",
      "manualMissingScope": "The token is missing the required permission: {scope}. Add it in Meta and try again.",
      "manualInvalidToken": "That token could not be validated. Check the token and IDs.",
      "manualRequired": "Fill in all three fields.",
      "signupNotConfigured": "Official sign-up through Meta isn't set up here, so connect with your own details below.",
      "manualHelpWabaId": "Where do I find it? Meta Business Suite → WhatsApp Accounts → your account ID (digits only).",
      "manualHelpPhoneId": "Where do I find it? WhatsApp Manager → API Setup → Phone number ID (digits only, not the phone number).",
      "manualHelpToken": "Where do I find it? Business settings → System users → Generate token (permanent). Paste it as is.",
      "manualErrWabaId": "The account ID must be digits only (for example 104857392011234). Copy it again from Meta.",
      "manualErrPhoneId": "The phone number ID must be digits only (for example 109238475610293), not the phone number itself.",
      "manualErrTokenFormat": "That doesn't look like a Meta token (it is a long string with no spaces). Generate a permanent token and paste it again.",
      "manualErrLookup": "Meta could not read this number with this token. Check that the phone number ID belongs to this account and the token has access to it. Nothing was connected.",
      "manualFieldRequired": "Enter this value.",
      "manualErrTokenInvalid": "Meta rejected this token. Generate a new permanent token and paste it again."
    },
    "whatsappWaha": {
      "heading": "WhatsApp — Quick connect (QR)",
      "connectCta": "Connect via QR",
      "connecting": "Starting…",
      "scanQr": "Scan this code with WhatsApp",
      "scanQrHint": "Open WhatsApp → Linked devices → Link a device",
      "connected": "Connected",
      "linkedAs": "Linked to {name} · {number}",
      "linkedNumberOnly": "Linked number: {number}",
      "failed": "Connection failed",
      "disconnected": "Disconnected",
      "rescan": "Re-scan QR",
      "disconnect": "Disconnect",
      "genericError": "Try again",
      "automation": {
        "legend": "Automation",
        "aiAgentTitle": "Bind to AI Agent",
        "aiAgentDescription": "Let a scoped AI Agent reply on this number, with human handoff.",
        "agentPickerPlaceholder": "No AI agent yet",
        "agentLabel": "AI agent",
        "agentNone": "Select a published agent",
        "agentsEmpty": "No published AI agents yet.",
        "handoffLabel": "Handoff keywords",
        "handoffHint": "Comma-separated. Overrides the agent's own list on this number.",
        "maxRepliesLabel": "Max AI replies per conversation",
        "maxRepliesHint": "Leave empty to use the agent's own limit.",
        "delayMinLabel": "Reply delay, minimum (ms)",
        "delayMaxLabel": "Reply delay, maximum (ms)",
        "delayHint": "A random wait in this range before each AI reply, to keep pacing natural.",
        "save": "Save",
        "saved": "AI settings saved.",
        "invalidRange": "Enter valid numbers; the maximum delay must be at least the minimum (up to 60000 ms).",
        "noneTitle": "No automation / human only",
        "noneDescription": "Messages arrive in the team inbox only; nothing replies automatically.",
        "saveError": "Could not save the automation setting. Try again."
      },
      "automationSchedule": {
        "heading": "Working-hours automation",
        "description": "Choose what answers new conversations during business hours and outside them. Conversations already in progress are not interrupted.",
        "inHours": "During business hours",
        "offHours": "Outside business hours",
        "flow": "Flow",
        "aiAgent": "AI Agent",
        "none": "No automation",
        "pickFlow": "Select a flow",
        "pickAgent": "Select an AI Agent",
        "qrNote": "This number only supports an AI Agent or no automation.",
        "save": "Save schedule",
        "saved": "Schedule saved.",
        "saveError": "Could not save the schedule. Try again."
      },
      "unavailableTitle": "New QR connections are unavailable",
      "unavailableBody": "New QR (unofficial) connections are switched off for new accounts. Connect an official WhatsApp number instead."
    },
    "triggerGuard": {
      "channelLabel": "Channel",
      "blockedMessage": "Chatbot flows need the official WhatsApp API",
      "upgradeCta": "Upgrade to Cloud API",
      "save": "Save"
    },
    "riskAck": {
      "title": "Before you connect by QR",
      "summaryIntro": "QR connect works like WhatsApp Web, not the official API.",
      "bullet1": "Your number may be banned. WhatsApp can restrict or permanently ban any number it detects using an unofficial client, without warning.",
      "bullet2": "Limited features. Only one AI Agent, the team inbox, and text and media messages — no flows, buttons, templates or catalog.",
      "bullet3": "Limited messaging. You may only message people who messaged you first. Volume limits and pacing apply and cannot be switched off.",
      "bullet4": "No guarantee. The connection can drop at any time; it is excluded from any service-level commitment.",
      "recommendedAlt": "For a business number, we recommend the official WhatsApp Cloud API.",
      "checkbox1": "I understand that this channel is unofficial and that WhatsApp may ban this number permanently.",
      "checkbox2": "I accept that we are not responsible for any ban, restriction or loss of data, chats or business resulting from using this channel.",
      "checkbox3": "I confirm that I own or am authorised to use this number and that I will follow the Acceptable Use Policy, including messaging only people who contacted me first.",
      "cancel": "Use official API",
      "accept": "I accept and continue",
      "readFull": "Read full terms",
      "submitError": "Could not record your acceptance. Try again.",
      "detailsToggle": "Details and alternatives",
      "summaryFull": "Quick connect (QR) links your WhatsApp account the same way \"Linked devices\" works on WhatsApp Web. It is not the official WhatsApp Business Platform, and it is not provided, approved or supported by Meta or WhatsApp."
    },
    "selfCheck": {
      "heading": "Connection check",
      "run": "Check connection",
      "requestFailed": "Couldn't run the connection check. Try again in a moment.",
      "summary": {
        "all_good": "Everything looks good — this channel is connected and healthy.",
        "needs_attention": "Needs attention — see the items below."
      },
      "status": {
        "ok": "OK",
        "warn": "Warning",
        "fail": "Failed",
        "skipped": "Skipped"
      },
      "check": {
        "cloud_mode": "Cloud mode",
        "phone_number": "Number exists in Meta",
        "token": "Access key is valid",
        "webhook_subscription": "Message delivery from Meta is connected",
        "last_webhook": "Last incoming message",
        "last_send": "Last message sent"
      },
      "reason": {
        "unknown": "The check returned an unrecognised result.",
        "mode_real": "Connected to the real WhatsApp Cloud API.",
        "mode_fake": "The server is running in test mode, so no real WhatsApp messages are sent or received.",
        "channel_not_connected": "This channel is disconnected.",
        "credentials_unreadable": "The stored credentials can't be read.",
        "phone_connected": "The number is connected to Meta.",
        "phone_lookup_failed": "Meta didn't accept the saved token when looking up the number.",
        "phone_disconnected": "Meta reports this number as disconnected.",
        "phone_banned": "Meta reports this number as banned.",
        "phone_degraded": "The number is flagged, restricted or has a red quality rating.",
        "app_secret_missing": "Token expiry can't be checked because the Meta app secret isn't configured on the server.",
        "token_check_failed": "Meta couldn't check the token.",
        "token_invalid": "Meta says the saved token is no longer valid.",
        "token_expired": "The saved token has expired.",
        "token_expiring_soon": "The token expires in {days, plural, one {# day} other {# days}}.",
        "token_valid": "The token is valid.",
        "waba_unknown": "The WhatsApp Business Account id isn't saved for this channel, so the subscription can't be checked.",
        "subscription_check_failed": "Meta couldn't report the webhook subscription.",
        "not_subscribed": "Our app isn't subscribed to this account's webhooks, so incoming messages won't arrive.",
        "subscribed": "Our app is subscribed to this account's webhooks.",
        "no_webhook_yet": "No incoming webhook has been received for this channel yet.",
        "webhook_silent": "No webhook received for {minutes, plural, one {# minute} other {# minutes}}.",
        "webhook_recent": "Last webhook received {minutes, plural, one {# minute} other {# minutes}} ago.",
        "no_sends_yet": "No message has been sent from this channel yet.",
        "last_send_failed": "The last message failed to send.",
        "last_send_blocked": "The last message was blocked before sending.",
        "last_send_ok": "The last message was sent."
      },
      "cta": {
        "unknown": "Check the runbook",
        "mode_fake": "Switch to real mode",
        "channel_not_connected": "Reconnect the channel",
        "credentials_unreadable": "Reconnect the channel",
        "phone_lookup_failed": "Reconnect the channel",
        "phone_disconnected": "Reconnect the channel",
        "phone_banned": "Contact Meta support",
        "phone_degraded": "Review the number quality",
        "token_check_failed": "Open the runbook",
        "token_invalid": "Reconnect the channel",
        "token_expired": "Reconnect the channel",
        "token_expiring_soon": "Reconnect before it expires",
        "subscription_check_failed": "Open the runbook",
        "not_subscribed": "Open the Meta console steps",
        "no_webhook_yet": "Open the Meta console steps",
        "webhook_silent": "Open the Meta console steps",
        "last_send_failed": "Check failed sends",
        "last_send_blocked": "Check the sending rules"
      },
      "ctaHint": {
        "unknown": "Run the check again in a moment. If it keeps failing, contact support.",
        "mode_fake": "This channel is in test mode. Finish connecting your official WhatsApp number from \"Connect channel\" to send real messages.",
        "phone_banned": "the number needs an appeal in Meta Business Support",
        "phone_degraded": "WhatsApp Manager → Phone numbers",
        "token_check_failed": "The connection with Meta has expired. Reconnect the number from \"Connect channel\".",
        "subscription_check_failed": "We could not verify the number's notification subscription. Reconnect the number or contact support.",
        "not_subscribed": "The number is not subscribed to WhatsApp notifications yet. Reconnect the number to receive messages.",
        "no_webhook_yet": "We have not received any message from this number yet. Send a test message to it, then check again.",
        "webhook_silent": "Messages from this number stopped arriving. Reconnect the number or contact support.",
        "last_send_failed": "see the failed sends list",
        "last_send_blocked": "opt-in, 24-hour window or quiet hours"
      },
      "runReal": "Real test",
      "forNumber": "Connection test for {number}",
      "devDetails": "Developer details",
      "mode": {
        "real": "Server mode: real",
        "fake": "Server mode: test (no real WhatsApp traffic)"
      },
      "tokenExpires": "Token valid until {date}",
      "tokenNoExpiry": "Token does not expire",
      "lastInbound": "Last incoming message: {date}",
      "lastInboundNone": "No incoming message yet",
      "testSend": {
        "label": "Phone number for a test message (with country code)",
        "cta": "Send test",
        "sending": "Sending…",
        "pending": "Sent to Meta — waiting for delivery status.",
        "sent": "Meta accepted the message.",
        "failed": "Meta rejected the message.",
        "error": "Could not send the test message."
      }
    },
    "health": {
      "loading": "Loading health…",
      "loadError": "Couldn't load channel health.",
      "quality": "Quality",
      "tier": "Messaging tier",
      "phoneStatus": "Phone status",
      "lastWebhook": "Last message received from Meta",
      "neverWebhook": "Never",
      "failedSends": "Failed sends (24h)",
      "paymentIssue": "Warning: {count} messages failed in the last 24h because Meta has no valid payment method (131042).",
      "webhookSilent": "No webhooks received recently — check the webhook subscription in Meta.",
      "ratingGREEN": "Quality: Green",
      "ratingYELLOW": "Quality: Yellow",
      "ratingRED": "Quality: Red",
      "ratingUNKNOWN": "Quality: Unknown",
      "justNow": "just now",
      "minutesAgo": "{count} min ago",
      "hoursAgo": "{count} h ago",
      "daysAgo": "{count} d ago"
    },
    "multiNumber": {
      "heading": "Your official numbers",
      "empty": "No official numbers connected yet.",
      "unnamed": "Unnamed number",
      "unnamedInstagram": "Instagram account",
      "unnamedMessenger": "Messenger page",
      "unnamedTiktok": "TikTok account",
      "coexistenceTag": "Coexistence",
      "settingsCta": "Settings",
      "profileCta": "Business profile",
      "loading": "Loading…",
      "status": {
        "connected": "Active",
        "disconnected": "Disconnected",
        "pending": "Pending",
        "failed": "Failed"
      },
      "settings": {
        "heading": "Number settings",
        "displayName": "Display name",
        "hoursOverride": "Use custom business hours for this number",
        "hoursFollow": "When off, this number follows the workspace business hours.",
        "closed": "Closed",
        "opens": "opens",
        "closes": "closes",
        "save": "Save",
        "saved": "Number settings saved"
      },
      "colNumber": "Number",
      "colStatus": "Status"
    },
    "planLimit": {
      "title": "Number limit reached",
      "body": "Your plan allows {limit} WhatsApp numbers and you are using {current}.",
      "bodyGeneric": "Your plan's WhatsApp number limit has been reached.",
      "hint": "Upgrade your plan to connect more numbers.",
      "upgrade": "View plans",
      "dismiss": "Not now"
    },
    "coexistence": {
      "offerTitle": "This number is already registered",
      "offerBody": "It is already used on WhatsApp Business. You can connect it in Coexistence mode and keep using the WhatsApp Business app on the same number.",
      "offerCta": "Coexistence mode",
      "bannerTitle": "Coexistence mode limitations",
      "throughput": "Throughput is capped at about 20 messages per second (check Meta's current limit).",
      "syncGaps": "Some features do not sync between the WhatsApp Business app and the Cloud API, such as certain message types, read status and older chat history.",
      "keepApp": "Keep using the WhatsApp Business app on this number",
      "keepAppHint": "Connects in Coexistence mode: messages you send from the phone app also appear here."
    },
    "profile": {
      "heading": "WhatsApp business profile",
      "photo": "Profile photo",
      "photoHint": "JPEG or PNG, up to 5 MB.",
      "photoNone": "No photo",
      "photoAlt": "Current profile photo",
      "photoType": "Choose a JPEG or PNG image.",
      "photoSize": "The image must be 5 MB or smaller.",
      "about": "About",
      "description": "Description",
      "address": "Address",
      "email": "Email",
      "website1": "Website 1",
      "website2": "Website 2",
      "vertical": "Category",
      "verticals": {
        "UNDEFINED": "Not specified",
        "OTHER": "Other",
        "AUTO": "Automotive",
        "BEAUTY": "Beauty, spa and salon",
        "APPAREL": "Clothing and apparel",
        "EDU": "Education",
        "ENTERTAIN": "Entertainment",
        "EVENT_PLAN": "Event planning",
        "FINANCE": "Finance and banking",
        "GROCERY": "Grocery",
        "GOVT": "Government",
        "HOTEL": "Hotel and lodging",
        "HEALTH": "Health and medical",
        "NONPROFIT": "Non-profit",
        "PROF_SERVICES": "Professional services",
        "RETAIL": "Retail",
        "TRAVEL": "Travel and transportation",
        "RESTAURANT": "Restaurant",
        "NOT_A_BIZ": "Not a business"
      },
      "save": "Save profile",
      "saved": "Business profile saved",
      "capabilitiesLabel": "Fields this channel supports",
      "capAbout": "About",
      "capDescription": "Description",
      "capAddress": "Address",
      "capEmail": "Email",
      "capWebsites": "Websites (up to 2)",
      "capVertical": "Category",
      "capPhoto": "Photo",
      "capName": "Profile name",
      "capStatus": "Status",
      "photoDimensions": "The image must be at least 192×192 pixels.",
      "qrHeading": "WhatsApp profile (scanned number)",
      "qrHint": "Changes are sent to WhatsApp through your linked phone session. Address, email, websites and category are only available on the official API.",
      "qrName": "Profile name",
      "qrStatus": "Status (about)",
      "qrNotConnected": "Connect the number first to edit its WhatsApp profile.",
      "qrOpen": "WhatsApp profile",
      "errors": {
        "generic": "WhatsApp did not accept the profile change. Try again in a moment.",
        "invalidValue": "WhatsApp rejected one of the values. Check the lengths and formats, then save again.",
        "tokenExpired": "The connection to WhatsApp has expired. Reconnect the number, then try again.",
        "rateLimited": "Too many changes in a short time. Wait a few minutes and try again.",
        "permission": "This connection is not allowed to edit the profile. Reconnect the number and accept all permissions.",
        "photo": "WhatsApp could not use this photo. Use a square JPEG or PNG of at least 192×192 pixels.",
        "gateway": "The phone session did not accept the change. Make sure the number is connected and try again."
      }
    },
    "lifecycle": {
      "disconnectCta": "Disconnect",
      "disconnectTitle": "Disconnect this number?",
      "disconnectBody": "Wato will stop sending and receiving messages on this number.",
      "disconnectHistory": "Your conversation history stays available in read-only mode. You can reconnect the same number later.",
      "disconnectConfirm": "Disconnect number",
      "cancel": "Cancel",
      "readOnlyBadge": "Read-only",
      "readOnlyHint": "This number is disconnected. Its history is read-only until you reconnect it.",
      "reconnectCta": "Reconnect",
      "phoneMismatch": "That is a different phone number. Reconnect with the same number this channel was created for.",
      "blockedCta": "Blocked",
      "blockedHeading": "Blocked contacts",
      "blockPhoneLabel": "Phone number (with country code)",
      "blockCta": "Block",
      "unblockCta": "Unblock",
      "unblocked": "Contact unblocked",
      "notBlocked": "This contact is not blocked.",
      "channelNotConnected": "This number is not connected, so contacts cannot be blocked right now.",
      "sourceMeta": "Blocked in WhatsApp (Meta)",
      "sourceLocal": "Blocked in Wato only",
      "deleteCta": "Delete permanently",
      "deleteTitle": "Delete this number permanently?",
      "deleteBody": "The number disappears from your channels list and cannot send or receive. Its conversations stay in the inbox as history.",
      "deleteTypeLabel": "Type the number {number} to confirm",
      "deleteTypeNameLabel": "Type the number name “{name}” to confirm",
      "deleteTypeWordLabel": "Type “{word}” to confirm",
      "deleteWord": "delete",
      "deleteConfirm": "Delete number",
      "deleteMismatch": "The number you typed does not match.",
      "setDefault": "Make default",
      "defaultBadge": "Default",
      "setDefaultFailed": "Could not set the default channel. Make sure the number is connected and try again.",
      "deleteForbidden": "You do not have permission to delete or disconnect numbers. Ask the account owner.",
      "deleteNeedsDisconnect": "Disconnect the number first, then you can delete it.",
      "deleteFailed": "Could not delete the number. Try again."
    },
    "migration": {
      "title": "Move from QR to an official number",
      "entryCta": "Go official",
      "step1Title": "How the move works",
      "numberMove": "Number move: register this phone number on the official WhatsApp Cloud API. The number leaves the WhatsApp app and runs only through Wato.",
      "coexistence": "Coexistence: keep using the WhatsApp Business app on the phone while Wato uses the official API, with some limits on throughput and history sync.",
      "step2Title": "Choose the official number that receives your contacts",
      "noCloud": "You have no connected official number yet.",
      "addCloudLink": "Add an official number first",
      "step3Title": "Confirm the move",
      "contactsMove": "Your contacts will be moved to the selected official number.",
      "notCarriedTitle": "Labels and flows are not carried over yet",
      "notCarriedBody": "Contact labels and any flows will NOT be moved in this version. Recreate them on the official number after the move.",
      "next": "Next",
      "back": "Back",
      "cancel": "Cancel",
      "confirm": "Move",
      "done": "Done",
      "resultTitle": "Move finished",
      "alreadyMigrated": "These contacts had already been moved before.",
      "migratedContacts": "{count, plural, one {# contact moved} other {# contacts moved}}",
      "identityConflicts": "{count, plural, one {# identity conflict to review} other {# identity conflicts to review}}",
      "skippedLabels": "Labels: not carried over yet",
      "skippedFlows": "Flows: not carried over yet",
      "targetInvalid": "The selected official number cannot receive this migration. Pick a connected official number.",
      "conflict": "Another migration is in progress or conflicts with this one. Try again shortly.",
      "notFound": "This QR channel could not be found."
    },
    "instagram": {
      "title": "Instagram",
      "name": "Instagram",
      "description": "Connect an Instagram Professional account so direct messages arrive in your shared inbox.",
      "connect": "Connect Instagram",
      "connected": "Instagram connected.",
      "failed": "Couldn't connect Instagram. Please try again.",
      "pagesTitle": "Choose the Facebook Pages to connect",
      "pagesHint": "Each Page below is linked to an Instagram professional account. Enable the ones that should receive and answer messages.",
      "pagesEmpty": "No Pages were found for this Facebook account.",
      "pagesLoadFailed": "Couldn't load your Pages. The selection may have expired — connect again.",
      "pageNoInstagram": "No Instagram account linked to this Page",
      "pageEnable": "Enable",
      "pageDisable": "Disable",
      "pageEnabled": "Enabled",
      "pageActionFailed": "Couldn't update this Page. Please try again.",
      "pageAlreadyConnected": "This Instagram account is already connected to another workspace. Disconnect it there first.",
      "simulationBanner": "Simulation mode: no real Instagram account is connected. This lets you try the flow safely.",
      "notConfiguredTitle": "Instagram isn't set up yet",
      "notConfiguredBody": "The platform owner must add the Instagram app ID and secret from the Meta developer dashboard. Nothing you can do here will work until then.",
      "notConfiguredWho": "Ask the platform owner (the person who manages the Meta app) to finish the Instagram connection setup.",
      "statusLoadFailed": "Couldn't check the Instagram setup. Please refresh the page.",
      "reasons": {
        "declined": "You declined the permissions. Instagram needs them to receive and reply to messages — please try again and allow access.",
        "not_business": "This Instagram account is a personal account. Switch it to a Business or Creator account in the Instagram app settings, then try again.",
        "no_page": "This account isn't linked to a Facebook Page. Link a Page to the Instagram account, then try again.",
        "token_failed": "Instagram didn't accept the connection (token exchange failed). Please try again; if it keeps failing, contact the platform owner.",
        "not_configured": "Instagram isn't set up on this platform yet. Ask the platform owner to finish the setup.",
        "already_connected": "This Instagram account is already connected to another workspace. Disconnect it there first.",
        "unknown": "Couldn't connect Instagram. Please try again."
      },
      "health": {
        "tokenExpiresOn": "Connection valid until {date}",
        "tokenExpiring": "The Instagram connection expires in {days} days. It renews automatically; if renewal fails you will be asked to reconnect.",
        "needsReauth": "Instagram rejected the connection. Reconnect the account to keep receiving messages — incoming messages are kept safe meanwhile.",
        "webhooksInactive": "Instagram webhooks are not active, so new messages won't arrive.",
        "reconnect": "Reconnect",
        "threadOwner": {
          "title": "Another app owns your Instagram conversations",
          "step1": "Open your Facebook Page, then Settings, then Advanced messaging.",
          "step2": "In \"Connected apps\", remove the old app or turn off its \"Take control of conversations\".",
          "step3": "Make sure Wato has \"Take control of conversations\" turned on, then save.",
          "open": "Open Page messaging settings"
        },
        "webhooksRetry": "Retry",
        "webhooksRetried": "Webhooks are active again.",
        "webhooksRetryFailed": "Instagram still refused the webhook subscription. Check the app permissions and try again."
      },
      "message": {
        "placeholderName": "Instagram user",
        "deleted": "This message was deleted",
        "sentFromApp": "Sent from the Instagram app",
        "unsupportedAttachment": "Unsupported attachment — open it in Instagram",
        "storyReply": "Replied to your story"
      },
      "sendFailure": {
        "auth": "Instagram rejected the connection (access token expired or revoked). Reconnect the Instagram account.",
        "permission": "Instagram refused: the app does not have permission to send this message.",
        "user_unavailable": "The customer is not available on Instagram right now (account unavailable, restricted or blocked).",
        "outside_window": "Instagram only allows replies within its own window - the reply was refused by Instagram.",
        "rate_limited": "Instagram is limiting sends right now. Try again in a few minutes.",
        "invalid_request": "Instagram could not accept this message (invalid content or media).",
        "unsupported": "Instagram does not support this kind of message.",
        "temporary": "Instagram is temporarily unavailable. Try again shortly.",
        "unknown": "The message was not delivered because of an unexpected Instagram error."
      },
      "disconnect": "Disconnect",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "triggers": {
        "title": "Instagram triggers",
        "comment": "Instagram Comment",
        "story": "Instagram Story",
        "scope": "When someone comments",
        "scopePost": "On specific posts or reels",
        "scopeAccount": "On any post of this account",
        "scopeKeyword": "When a keyword appears",
        "scopeAny": "Any comment",
        "posts": "Posts and reels",
        "loadMore": "Load more",
        "noPosts": "No posts found.",
        "keywords": "Keywords",
        "keywordAdd": "Add keyword",
        "keywordRemove": "Remove {value}",
        "variants": "Public reply variants",
        "variantsHint": "One is picked at random each time to avoid spam detection.",
        "variantAdd": "Add variant",
        "variantRemove": "Remove {value}",
        "storyMention": "Story mention flow",
        "storyReply": "Story reply flow",
        "flow": "Flow",
        "flowNone": "No flow selected",
        "save": "Save",
        "windowNote": "Instagram allows one private reply per comment, within 7 days."
      },
      "engagement": {
        "toggle": "Engagement settings",
        "tabs": {
          "iceBreakers": "Ice breakers",
          "menu": "Persistent menu",
          "comments": "Comment automation"
        },
        "flow": "Flow",
        "flowNone": "No flow selected",
        "save": "Save",
        "remove": "Remove",
        "publish": "Publish",
        "published": "Published to Instagram.",
        "publishFailed": "Couldn't publish. Please try again.",
        "saveFailed": "Couldn't save. Please try again.",
        "menu": {
          "title": "Persistent menu",
          "description": "A menu that stays available in the chat. Each item starts a flow or opens a link.",
          "locale": "Language",
          "localeDefault": "All languages",
          "composerOff": "Hide the message box while the menu is shown",
          "itemTitle": "Item title",
          "itemType": "Item action",
          "typeFlow": "Start a flow",
          "typeUrl": "Open a link",
          "url": "Link (https)",
          "add": "Add menu item"
        },
        "comments": {
          "title": "Comment automation",
          "description": "Reply to comments and mentions automatically, publicly and by direct message.",
          "defaultTitle": "All posts (default rule)",
          "defaultHint": "Used on posts that have no matching rule of their own.",
          "mentionTitle": "Mentions",
          "mentionHint": "Applies when someone mentions your account.",
          "postsTitle": "Rules per post",
          "noPosts": "No posts found.",
          "loadMore": "Load more",
          "addRule": "Add rule",
          "editRule": "Edit rule",
          "active": "Active",
          "paused": "Paused",
          "enabled": "Rule is on",
          "match": "Which comments",
          "matchAny": "Any comment",
          "matchKeywords": "Only comments with keywords",
          "keywords": "Keywords",
          "keywordsHint": "Separate keywords with commas",
          "publicReplies": "Public reply variants",
          "publicRepliesHint": "One per line. One is picked at random each time.",
          "privateReply": "Direct message reply",
          "privateText": "Send a message",
          "privateFlow": "Start a flow",
          "windowNote": "Instagram allows one direct reply per comment, within 7 days."
        }
      },
      "iceBreakers": {
        "title": "Ice breakers",
        "description": "Starter questions shown on a fresh Instagram chat (up to {max}).",
        "add": "Add ice breaker",
        "limitReached": "You can add at most {max} ice breakers.",
        "question": "Question",
        "flow": "Flow entry point",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "remove": "Remove",
        "publish": "Publish",
        "statusSynced": "Synced",
        "statusError": "Sync failed",
        "statusPending": "Not published yet",
        "publishFailed": "Couldn't publish. Please try again."
      },
      "moderation": {
        "title": "Comment moderation",
        "description": "Comments containing these words are hidden automatically.",
        "keywordLabel": "Blocked word",
        "add": "Add word",
        "remove": "Remove",
        "duplicate": "This word is already in the list.",
        "empty": "No blocked words yet."
      },
      "shop": {
        "title": "Instagram Shop",
        "refresh": "Refresh",
        "loading": "Checking…",
        "loadFailed": "Could not check the setup. Try again.",
        "steps": {
          "catalog": "Connect catalog",
          "eligibility": "Product tagging eligibility",
          "test": "Try a product on yourself"
        },
        "status": {
          "ok": "Ready",
          "action": "Needs action",
          "blocked": "Blocked",
          "pending": "Not started"
        },
        "hint": {
          "no_workspace_catalog": "Link your Meta catalog from the Catalog page first.",
          "catalog_not_linked": "The catalog is not linked to the Instagram account. Link it in Meta Commerce Manager, then refresh.",
          "permission_missing": "Missing permissions. Reconnect the account and allow the catalog and shopping permissions.",
          "mode_unsupported": "This login type does not support catalogs. Connect the account through Facebook.",
          "not_eligible": "The account is not eligible for product tagging yet. See the reasons below.",
          "graph_unavailable": "Could not reach Meta right now. Try again shortly.",
          "no_products": "No approved products in the catalog. Add products and wait for Meta's review.",
          "needs_catalog_first": "Finish linking the catalog first.",
          "dm_only": "Product cards in messages are ready. Tagging products in posts needs a separate Meta permission.",
          "token_invalid": "The account connection expired or Meta revoked it. Reconnect the account.",
          "needs_recipient": "Enter the Instagram ID of an account that messaged the shop.",
          "window_closed": "More than 24 hours since their last message. Ask them to message the shop, then retry.",
          "card_invalid": "The product is missing an image or a link."
        },
        "reasonsTitle": "Reasons",
        "recipientLabel": "Recipient ID (IGSID)",
        "recipientHint": "Your own account, after it messaged the shop within the last 24 hours.",
        "send": "Send a test product",
        "sent": "Sent. Open the chat on Instagram and tap “Order here”."
      }
    },
    "badge": {
      "instagram": "Instagram",
      "messenger": "Messenger",
      "whatsapp": "WhatsApp"
    },
    "cards": {
      "label": "Channel types",
      "connect": "Set up",
      "manage": "Manage",
      "notConnected": "Not connected",
      "soon": "Not available",
      "connectedCount": "{count, plural, one {# connected} other {# connected}}{problem, plural, =0 {} other { · # need attention}}",
      "whatsappCloud": {
        "title": "WhatsApp — Official",
        "note": "Cloud API: flows, buttons, templates and the AI Agent."
      },
      "whatsappQr": {
        "title": "WhatsApp — QR",
        "note": "QR channels run the AI Agent only — no flows, buttons or templates."
      },
      "instagram": {
        "title": "Instagram",
        "note": "Reply to Instagram DMs from the shared inbox."
      },
      "sms": {
        "title": "SMS",
        "note": "SMS is used only to send fallback alerts. Two-way SMS needs a connected SMS provider, which is not available yet."
      },
      "columns": {
        "type": "Channel type",
        "status": "Status",
        "note": "About",
        "action": "Action"
      }
    },
    "qrList": {
      "heading": "Your QR numbers",
      "unnamed": "WhatsApp number (name not available yet)",
      "awaitingNumber": "Number appears after the first scan",
      "status": {
        "connected": "Connected",
        "needsScan": "Needs scan",
        "needsRescan": "Scan the code again",
        "disconnected": "Disconnected",
        "paused": "Paused",
        "failed": "Failed"
      },
      "openConversations": "Open conversations",
      "rescan": "Scan again",
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect this QR number?",
      "disconnectBody": "The session is logged out and Wato stops sending and receiving on this number. Conversation history is kept.",
      "disconnectConfirm": "Disconnect number",
      "disconnectFailed": "Could not disconnect the number. Try again.",
      "reimport": "Re-import",
      "reimportTitle": "Re-import chats for this number?",
      "reimportBody": "Pulls the recent chats this number still holds in memory since linking. Nothing is duplicated; already imported messages are skipped.",
      "reimportConfirm": "Start import",
      "reimportRunning": "Importing…",
      "reimportResult": "{count, plural, one {# new message imported} other {# new messages imported}}",
      "reimportEmpty": "No new chats in memory",
      "reimportRateLimited": "Too many attempts. Try again in a few minutes.",
      "reimportNotConnected": "Connect the number first.",
      "reimportFailed": "Re-import failed. Try again.",
      "rescanFailed": "Could not start a new scan. Try again.",
      "previous": "Previous numbers ({count})",
      "empty": "No QR numbers yet.",
      "colNumber": "Number",
      "colStatus": "Status",
      "colSettings": "Settings",
      "groups": {
        "label": "Receive group messages",
        "hint": "Each group shows as one conversation. Replies are manual only: the AI and flows never answer in groups. This feature is not official WhatsApp.",
        "error": "Could not change the setting. Please try again.",
        "forbidden": "You do not have permission to edit channels.",
        "saved": "Setting saved"
      },
      "reason": {
        "logged_out": "Logged out from the phone - scan again",
        "phone_offline": "Phone offline - reconnecting automatically",
        "needs_rescan": "Could not reconnect - scan the QR code again",
        "gateway_failed": "Connection failed - reconnecting automatically",
        "stopped": "Disconnected",
        "reconnect_exhausted": "Could not reconnect - scan the QR code again"
      },
      "lastSeen": "Last seen {time}"
    },
    "center": {
      "checkAndTest": "Check this number and send a test message",
      "title": "Channel health",
      "subtitle": "See at a glance whether your WhatsApp numbers are connected and working.",
      "loadError": "Couldn't load your channels. Try again in a moment.",
      "never": "Never",
      "unnamed": "Unnamed number",
      "rowOk": "Everything looks fine.",
      "fix": "Fix in Channels",
      "summary": {
        "ok": "All your channels are healthy.",
        "problems": "{count} channels need attention."
      },
      "empty": {
        "title": "No channel connected yet",
        "body": "Connect a WhatsApp number to start receiving messages and see its health here.",
        "cta": "Connect a channel"
      }
    },
    "connectChooser": {
      "title": "Two ways to connect WhatsApp",
      "subtitle": "Pick the one that fits. You can use both later.",
      "noScan": "The official connection goes through Meta, not by scanning a code. A QR code only appears for the quick-test number.",
      "points": {
        "who": "Best for",
        "how": "How it connects",
        "can": "You can",
        "cannot": "You cannot"
      },
      "cloud": {
        "name": "Official WhatsApp Business (Cloud API)",
        "summary": "The approved way: for real stores and teams.",
        "who": "Stores and teams that send campaigns and run full flows.",
        "how": "Sign in with Meta and pick your business number. No scanning.",
        "can": "Send campaigns and message templates, use buttons, lists, forms and the catalog, and build flows.",
        "cannot": "Use a number that is already in the normal WhatsApp app without moving it (or keeping both)."
      },
      "qr": {
        "name": "Quick test (scan a QR code)",
        "summary": "Link one phone in a minute, like WhatsApp Web.",
        "who": "Trying things out on a single phone.",
        "how": "Scan the QR code with the phone that holds the number.",
        "can": "Read and answer chats, and let the smart assistant reply automatically.",
        "cannot": "Run flows, buttons, lists, templates, forms or the catalog, or send campaigns. The phone must stay online."
      }
    },
    "tabs": {
      "label": "Channel sections",
      "whatsapp": "WhatsApp (official)",
      "qr": "WhatsApp QR",
      "instagram": "Instagram",
      "tiktok": "TikTok"
    },
    "tiktok": {
      "title": "TikTok",
      "status": "Waiting for TikTok approval",
      "body": "Receiving and answering TikTok messages needs approval from TikTok for business messaging. Once the approval is granted, you will connect your account here just like Instagram.",
      "note": "Nothing to set up until TikTok approves our app."
    },
    "sessionState": {
      "stopped": "Stopped",
      "starting": "Connecting",
      "scanQrCode": "Waiting for QR scan",
      "working": "Connected",
      "disconnected": "Reconnecting",
      "restricted": "Restricted by WhatsApp",
      "failed": "Failed - re-scan needed",
      "reconnectLoop": "Connection keeps dropping. We paused retries to protect the number."
    },
    "needsRescan": "This number needs to be linked again. Scan the QR code to continue.",
    "callEvents": {
      "received": "Incoming call",
      "missed": "Missed call",
      "rejected": "Call declined"
    },
    "callSettings": {
      "autoRejectCalls": "Decline incoming calls",
      "autoRejectCallsHint": "The AI agent cannot take calls. Decline them automatically.",
      "groupsIgnore": "Ignore WhatsApp groups",
      "groupsIgnoreHint": "On by default: group messages are not received and the AI never answers in groups.",
      "readAfterReply": "Mark chats as read after a reply",
      "readAfterReplyHint": "Off by default: chats are marked as read only after the AI or a teammate has answered.",
      "autoRejectCallsText": "Message sent after declining",
      "humanTyping": "Show typing before AI replies",
      "humanTypingHint": "Waits a short, natural time before each AI reply so it looks human.",
      "syncHistoryLimit": "Messages to import per chat after linking",
      "syncHistoryLimitHint": "0 switches the import off. Up to {max}."
    },
    "doctor": {
      "heading": "Channel doctor",
      "intro": "Checks every connected channel and tells you exactly what to fix.",
      "run": "Check channels",
      "running": "Checking…",
      "allGood": "Everything looks healthy.",
      "noChannels": "No connected channels to check.",
      "loadError": "Could not run the channel check. Try again.",
      "fixFailed": "The fix did not work. Reconnect the channel instead.",
      "fixed": "Fixed",
      "status": {
        "healthy": "Healthy",
        "warning": "Needs attention",
        "broken": "Broken"
      },
      "lastInbound": "Last message received: {date}",
      "lastOutbound": "Last message sent: {date}",
      "never": "never",
      "finding": {
        "token_invalid": "The connection to Meta is no longer valid, so messages cannot be sent or received.",
        "token_expired": "The access token has expired, so messages cannot be sent or received.",
        "token_expiring_soon": "The access token expires in {days} days.",
        "webhook_not_subscribed": "Meta is not sending new messages to your workspace.",
        "no_inbound_recent": "No message has been received for {days} days.",
        "no_outbound_recent": "No message has been sent for {days} days.",
        "number_disconnected": "The number is disconnected from WhatsApp.",
        "number_banned": "Meta has restricted this number.",
        "number_pending": "Meta is still verifying this number.",
        "quality_red": "The number quality rating is low, so sending may be limited.",
        "quality_yellow": "The number quality rating is medium. Avoid sending to people who did not ask."
      },
      "fix": {
        "reconnect": "Reconnect",
        "resubscribe_webhook": "Restore message delivery",
        "rescan_qr": "Scan the code again",
        "open_meta_manager": "Open Meta Business Manager",
        "send_test_message": "Send a test message"
      }
    },
    "manage": {
      "title": "All channels",
      "summary": {
        "connected": "Connected numbers",
        "attention": "Needs attention",
        "disconnected": "Disconnected"
      },
      "filter": {
        "label": "Filter by status",
        "all": "All",
        "connected": "Connected",
        "attention": "Needs attention",
        "disconnected": "Disconnected"
      },
      "columns": {
        "channel": "Channel",
        "type": "Type",
        "status": "Status",
        "quality": "Quality and limit",
        "lastSync": "Last sync"
      },
      "type": {
        "whatsapp_cloud": "Official",
        "whatsapp_waha": "QR",
        "instagram": "Instagram"
      },
      "status": {
        "connected": "Connected",
        "attention": "Needs attention",
        "disconnected": "Disconnected"
      },
      "never": "Never",
      "noInfo": "Not synced yet",
      "empty": "No channels match this filter.",
      "menu": {
        "edit": "Edit",
        "sync": "Sync now",
        "syncing": "Syncing...",
        "metaHome": "Open in Meta WhatsApp Manager",
        "metaPhones": "Phone numbers in Meta",
        "health": "Health check",
        "settings": "Open settings",
        "disconnect": "Disconnect"
      },
      "edit": {
        "title": "Edit channel",
        "labelField": "Name shown in Wato",
        "labelHint": "Only changes the name in Wato. Leave empty to use the name from Meta.",
        "save": "Save",
        "cancel": "Cancel",
        "profileTitle": "Business profile",
        "failed": "Could not save the name. Try again."
      },
      "syncDone": "Number info updated from Meta.",
      "syncFailed": "Could not reach Meta. Check the connection and try again.",
      "help": {
        "title": "Help: two ways to connect WhatsApp"
      }
    },
    "b29b": {
      "testNumber": "Test number",
      "testNumberWith": "Test number · {phone}",
      "pickNumber": "Choose a number"
    }
  },
  "billing": {
    "metaRates": {
      "title": "Meta message rates",
      "intro": "Per-message fees Meta charges, used for cost previews. A new rate applies from its effective date; earlier rates stay in the history.",
      "category": "Category",
      "country": "Country (or default)",
      "currency": "Currency",
      "fee": "Fee (minor units)",
      "effectiveFrom": "Effective from",
      "add": "Add rate",
      "saved": "Rate added.",
      "failed": "Could not save the rate. Check the values and try again.",
      "loadFailed": "Could not load the rate card.",
      "empty": "No rates yet. Built-in fallback rates are in use.",
      "categories": {
        "marketing": "Marketing",
        "utility": "Utility",
        "authentication": "Authentication",
        "service": "Service"
      },
      "retry": "Try again"
    },
    "sla": {
      "title": "Request an SLA service credit",
      "intro": "If your workspace had an outage that was not credited automatically, tell us when it happened. Our team reviews every claim.",
      "description": "What happened",
      "date": "Incident date and time",
      "submit": "Submit claim",
      "submitted": "Claim submitted. We will review it and credit your wallet if it qualifies.",
      "failed": "We could not submit your claim. Check the fields and try again.",
      "queue": {
        "title": "SLA credit claims",
        "empty": "No claims to review.",
        "status": "Status",
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "from": "Incident start",
        "to": "Incident end",
        "approve": "Approve and credit",
        "reject": "Reject",
        "reason": "Rejection reason",
        "failed": "The action failed. Reload and try again."
      }
    },
    "errors": {
      "validation": "Check the highlighted fields and try again.",
      "invalidCursor": "This page of wallet activity is no longer available. Reload and try again.",
      "forbidden": "You don't have permission for this billing action. Ask the workspace owner to do it or to change your role in Team.",
      "walletNotFound": "This workspace has no wallet yet.",
      "idempotencyConflict": "This request was already used for a different operation.",
      "currencyMismatch": "Your wallet uses your workspace's billing currency. It can't be changed here.",
      "insufficientBalance": "Your wallet balance is too low for this charge. Top up to continue.",
      "noSubscription": "This workspace has no subscription yet.",
      "planNotFound": "That plan does not exist.",
      "invalidPlanChange": "This plan change is not allowed right now. Pick a different plan or wait for your current change to finish.",
      "cardRequired": "Add a payment card first to continue.",
      "paymentFailed": "The card payment did not go through. Check the card and try again.",
      "budgetExceeded": "This action would exceed your monthly budget for this category. Raise the budget or wait for the next period.",
      "addOnNotFound": "That add-on does not exist.",
      "addOnAlreadyActive": "You already have this add-on.",
      "workspaceNotFound": "Workspace not found.",
      "metaMigrationInvalid": "This workspace cannot be migrated (it is already on Solution Partner billing).",
      "slaClaimNotFound": "The SLA claim was not found.",
      "slaClaimNotPending": "This SLA claim has already been reviewed.",
      "invoiceNotFound": "This invoice was not found.",
      "paymentMethodNotFound": "This saved card was not found.",
      "paymentMethodInUse": "This card is your subscription's card on file. Add another card before removing it.",
      "featureNotEntitled": "This feature is not included in your plan. Open Settings → Billing → Plans and upgrade to use it.",
      "limitReached": "You have reached your plan limit. Open Settings → Billing → Plans and upgrade, or remove items to free up space.",
      "readOnly": "Your subscription is suspended, so this workspace is read-only. Pay the outstanding balance to restore access."
    },
    "dunning": {
      "graceTitle": "We couldn't renew your subscription",
      "graceBody": "We'll retry your card automatically. Next attempt: {date}. Update your card or pay now to keep everything running.",
      "suspendedTitle": "Your subscription is suspended",
      "suspendedBody": "The workspace is read-only and your data is kept until {date}. Pay now to restore full access immediately.",
      "payNow": "Pay now",
      "paying": "Processing…",
      "paidOk": "Payment received. Full access is restored.",
      "paidPending": "The payment needs your confirmation or is still processing."
    },
    "metaMigration": {
      "heading": "Move to Solution Partner billing",
      "description": "Meta bills you directly now. After migration its fees come from your wallet: one line for Meta, one for our margin.",
      "loading": "Calculating your preview…",
      "before": "Estimated Meta spend, last {days} days (billed by Meta today)",
      "margin": "Platform margin ({percent})",
      "after": "Projected wallet cost after migration",
      "effective": "Starts on {date}",
      "pending": "Migration confirmed. Solution Partner billing starts on {date}.",
      "alreadyB": "This workspace already uses Solution Partner billing.",
      "confirm": "Confirm migration",
      "confirming": "Confirming…",
      "ownerOnly": "Only the workspace owner can change the billing mode."
    },
    "autoRecharge": {
      "heading": "Wallet auto-recharge",
      "description": "Off by default. When on, your card is charged whenever the balance drops below the limit, up to the monthly cap.",
      "enable": "Turn on auto-recharge",
      "threshold": "Recharge when balance is below",
      "amount": "Recharge amount",
      "cap": "Monthly cap",
      "capVisible": "Your card will be charged at most {amount} of wallet credit per month, plus VAT.",
      "save": "Save settings",
      "saved": "Auto-recharge settings saved.",
      "ownerOnly": "Only the workspace owner can change auto-recharge."
    },
    "addOns": {
      "heading": "Add-ons",
      "description": "Extra capacity on top of your plan. Recurring add-ons are charged pro rata now and then renew with your plan.",
      "empty": "No add-ons are available.",
      "effectLimit": "Raises the limit by {amount}",
      "effectFeature": "Unlocks the feature",
      "recurring": "Recurring, {amount} per month",
      "oneTime": "One-time, {amount}",
      "buy": "Add",
      "active": "Active",
      "pending": "Awaiting payment",
      "ownerOnly": "Only the workspace owner can buy add-ons.",
      "bought": "Add-on activated."
    },
    "cadence": {
      "heading": "Billing cadence",
      "description": "Switching reprices your plan and moves the next charge. Pay-as-you-go uses the wallet only.",
      "current": "Current cadence",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "yearly": "Yearly",
      "pay_per_use": "Pay per use",
      "switch": "Switch cadence",
      "switched": "Billing cadence updated.",
      "scheduled": "The new cadence starts at your next renewal.",
      "nextCharge": "Next card charge: {amount}",
      "ownerOnly": "Only the workspace owner can change the billing cadence."
    },
    "nav": "Billing",
    "chip": {
      "label": "Wallet",
      "ariaLabel": "Wallet balance: {amount}"
    },
    "page": {
      "title": "Billing",
      "subtitle": "Your plan, wallet balance and wallet activity.",
      "planHeading": "Current plan",
      "freeTrial": "Free trial",
      "internalPlan": "Internal plan",
      "freeTrialHint": "14-day free trial. Pick a plan below.",
      "renewsOn": "Current period ends {date}",
      "walletHeading": "Wallet",
      "walletHint": "Prepaid credit for AI replies and other usage.",
      "balance": "Balance",
      "paidToUs": "Paid to us",
      "paidToUsHint": "Your plan and wallet charges are billed by us.",
      "paidToMeta": "Paid to Meta",
      "paidToMetaHint": "WhatsApp conversation fees are billed by Meta directly, not by us. We only show an estimate.",
      "metaEstimateUnavailable": "No estimate yet",
      "exportCsv": "Export CSV",
      "ledgerHeading": "Wallet activity",
      "ledgerCaption": "Wallet activity, newest first",
      "ledgerEmpty": "No activity yet.",
      "ledgerOwnerOnly": "Wallet activity is for the owner or admins.",
      "loadMore": "Load more",
      "columns": {
        "date": "Date",
        "description": "Description",
        "amount": "Amount",
        "balance": "Balance after"
      }
    },
    "status": {
      "trialing": "Trial",
      "active": "Active",
      "grace_period": "Payment overdue",
      "suspended": "Suspended",
      "cancelled": "Cancelled"
    },
    "plans": {
      "trial": "Free trial",
      "ai_qr": "AI QR",
      "starter": "Starter",
      "growth": "Growth",
      "business": "Business",
      "enterprise": "Enterprise",
      "feature": {
        "ai_agent": "AI agent",
        "api_public": "Public programming interface",
        "api_write": "Programming interface write access",
        "bookings": "Bookings",
        "broadcasts": "Campaigns",
        "calling_enabled": "WhatsApp calling",
        "catalog_manager": "Meta catalog manager",
        "channels_whatsapp_cloud": "Official WhatsApp (Cloud API)",
        "channels_whatsapp_waha": "WhatsApp quick connect (QR)",
        "flows_builder": "Conversation flow builder",
        "forms_builder": "Form builder",
        "inbox_team": "Team inbox",
        "integrations_google": "Connections to Google services",
        "mobile_pwa": "Mobile app",
        "routing_sla": "Routing and service-level targets"
      }
    },
    "budgets": {
      "heading": "Monthly budgets",
      "description": "Monthly cap per category. Alert at 80%, optional spend blocked at 100%. Order confirmations are never blocked.",
      "ownerOnly": "Only the workspace owner can change budgets.",
      "categoryAi": "AI replies",
      "categoryBroadcasts": "Broadcasts",
      "categoryWalletTotal": "Total wallet spend",
      "limit": "Monthly limit",
      "notSet": "No limit set",
      "save": "Save budget",
      "saved": "Budget saved",
      "remove": "Remove limit",
      "spent": "Spent this month: {amount}",
      "usage": "{percent}% used",
      "statusOk": "On track",
      "statusWarn": "Over 80% of the limit",
      "statusBlock": "Limit reached - new spending is blocked"
    },
    "costPreview": {
      "heading": "Estimated cost",
      "estimated": "Estimated cost: {amount}",
      "walletLow": "Your wallet balance is not enough. Top up first.",
      "budgetWarn": "This will take you past 80% of your monthly budget.",
      "budgetBlock": "This would exceed your monthly budget. Raise the budget to continue.",
      "ok": "Within budget"
    },
    "reasons": {
      "ai_tokens": "AI usage",
      "waha_session": "QR session",
      "extra_contact": "Extra contacts",
      "extra_seat": "Extra seat",
      "voice_transcription": "Voice transcription",
      "broadcast_batch": "Broadcast recipients",
      "topup": "Wallet top-up",
      "refund": "Refund",
      "manual_adjustment": "Adjustment"
    },
    "aiHealth": {
      "title": "AI credits",
      "monthBurn": "Used this month: {percent}%",
      "today": "Today: {spent} of {cap}",
      "todayNoCap": "Today: {spent} (no daily cap)",
      "daysToEmpty": "About {days} days left at the current rate",
      "daysToEmptyNone": "No recent spend",
      "details": "View AI credits",
      "dailyCapBanner": "Daily AI cap reached. The assistant hands chats to your team until midnight.",
      "monthlyExhaustedBanner": "AI credits are used up for this month. The assistant hands chats to your team until you top up."
    },
    "metaFee": {
      "paidToMeta": "Paid to Meta",
      "platformMargin": "Platform margin ({percent}%)"
    },
    "account": {
      "trialEnds": "Free trial ends {date}",
      "plans": {
        "heading": "Plans",
        "current": "Current plan",
        "upgrade": "Upgrade",
        "downgrade": "Downgrade",
        "perMonth": "{amount} / month",
        "ownerOnly": "Only the workspace owner can change the plan.",
        "applied": "Your plan was updated.",
        "scheduled": "Your plan will change at the end of the current period.",
        "requiresAction": "Your bank needs you to confirm this payment.",
        "empty": "No plans are available.",
        "feature": {
          "ai_agent": "AI agent",
          "api_public": "Public programming interface",
          "api_write": "Programming interface write access",
          "bookings": "Bookings",
          "broadcasts": "Campaigns",
          "calling_enabled": "WhatsApp calling",
          "catalog_manager": "Meta catalog manager",
          "channels_whatsapp_cloud": "Official WhatsApp (Cloud API)",
          "channels_whatsapp_waha": "WhatsApp quick connect (QR)",
          "flows_builder": "Conversation flow builder",
          "forms_builder": "Form builder",
          "inbox_team": "Team inbox",
          "integrations_google": "Connections to Google services",
          "mobile_pwa": "Mobile app",
          "routing_sla": "Routing and service-level targets"
        }
      },
      "invoices": {
        "heading": "Invoices",
        "number": "Invoice",
        "date": "Date",
        "total": "Total",
        "vat": "VAT",
        "status": "Status",
        "download": "Download PDF",
        "caption": "Invoices",
        "empty": "No invoices yet. Your first invoice appears after your first paid billing period.",
        "noAccess": "You don't have access to invoices. Ask the workspace owner or an admin.",
        "paid": "Paid",
        "open": "Open"
      },
      "cards": {
        "heading": "Saved cards",
        "expires": "{brand} •••• {last4}",
        "expiry": "Expires {date}",
        "default": "Default",
        "makeDefault": "Make default",
        "remove": "Remove",
        "empty": "No saved cards yet. A card is saved when you pay for a plan.",
        "ownerOnly": "Only the workspace owner can manage cards.",
        "emptyHelp": "No saved card. Pay for the plan first to save a card, then top up. Or contact support to add credit."
      },
      "usage": {
        "heading": "Usage this month",
        "contacts": "Contacts",
        "messages": "Messages",
        "aiTokens": "AI tokens",
        "unlimited": "{used} used",
        "of": "{used} of {limit}",
        "label": "Usage",
        "ariaLabel": "Usage this month"
      }
    }
  },
  "team": {
    "permissions": {
      "button": "Permissions",
      "title": "Permissions for {email}",
      "description": "Start from the member's role, then allow or block individual actions for this person only.",
      "ownerNote": "The Owner always has full access. Their permissions cannot be restricted.",
      "inherit": "Same as role",
      "allow": "Allow",
      "deny": "Block",
      "stateRole": "Allowed by role",
      "stateNotInRole": "Not allowed by role",
      "stateExtra": "Extra permission",
      "stateRemoved": "Removed for this member",
      "item": "{module}: {action}",
      "save": "Save permissions",
      "saved": "Permissions updated.",
      "loadFailed": "Could not load this member's permissions."
    },
    "seats": {
      "label": "Seats",
      "usage": "{used} of {limit} seats used",
      "unlimited": "{used} seats used (unlimited plan)",
      "pending": "{count, plural, one {# pending invitation counts} other {# pending invitations count}} toward the limit.",
      "full": "All seats are in use. Remove a member or upgrade the plan to invite more.",
      "limitReached": "You have reached the maximum number of team members ({current} of {limit}).",
      "requestMore": "More seats",
      "requestTitle": "Request more seats",
      "requestDescription": "Tell us how many seats you need and our team will follow up.",
      "requestSeats": "Desired number of seats",
      "requestNote": "Note (optional)",
      "requestSubmit": "Send request",
      "requestDone": "Done",
      "requestSent": "We sent your request to support.",
      "requestFailed": "Could not send the request. Try again."
    },
    "transfer": {
      "button": "Make Owner",
      "title": "Transfer ownership to {email}",
      "body": "{email} becomes the Owner of this workspace and you become an Admin. This is recorded in the audit log.",
      "password": "Confirm with your password",
      "confirm": "Transfer ownership",
      "done": "Ownership transferred."
    },
    "approvals": {
      "nav": "Approvals",
      "title": "Approvals",
      "subtitle": "Requests held until a reviewer signs them off.",
      "empty": "No pending approvals.",
      "kind": "Request",
      "requested": "Requested",
      "actions": "Actions",
      "note": "Note",
      "noteHint": "Required when rejecting",
      "approve": "Approve",
      "reject": "Reject",
      "ownRequest": "You cannot approve your own request.",
      "noPermission": "You lack the permission needed to review this request.",
      "approved": "Request approved.",
      "rejected": "Request rejected.",
      "forbidden": "You do not have permission to view approvals."
    },
    "nav": "Team",
    "title": "Team",
    "subtitle": "Invite teammates, choose what each role can do and manage who has access.",
    "forbidden": "You do not have permission to view the team of this workspace.",
    "staff": {
      "title": "Add staff",
      "description": "They will only see the conversations page.",
      "name": "Name",
      "email": "Email",
      "channels": "Channels",
      "noChannels": "No channels connected yet.",
      "pickChannel": "Pick at least one channel.",
      "visibility": "They see",
      "visAll": "All conversations of their channels",
      "visAssigned": "Only conversations assigned to them",
      "visAllShort": "All",
      "visAssignedShort": "Assigned only",
      "allChannels": "All channels",
      "submit": "Send invite",
      "sent": "Invite sent to {email}",
      "access": "Access",
      "edit": "Edit access",
      "editTitle": "Access for {name}",
      "save": "Save",
      "saved": "Access updated.",
      "actions": "Staff actions",
      "pending": "Waiting to join",
      "preset": {
        "staff_all": "Staff",
        "staff_assigned": "Staff (assigned only)"
      },
      "mode": "How to add",
      "modePassword": "Set a password now",
      "modeInvite": "Send an invite",
      "password": "Password",
      "newPassword": "New password (leave empty to keep)",
      "showPassword": "Show",
      "hidePassword": "Hide",
      "generatePassword": "Generate",
      "passwordRequired": "Enter a name and a password.",
      "create": "Add",
      "created": "{name} was added. They can log in now."
    },
    "b29b": {
      "add": "+ Member",
      "modeLegend": "How to add",
      "modeInvite": "Invite",
      "modeStaff": "Staff"
    },
    "members": {
      "heading": "Members",
      "empty": "No members yet.",
      "email": "Email",
      "role": "Role",
      "joined": "Joined",
      "actions": "Actions",
      "you": "You",
      "changeRole": "Change role",
      "roleLabel": "Role for {email}",
      "roleChanged": "Role updated.",
      "remove": "Remove",
      "removeTitle": "Remove {email}?",
      "removeBody": "They lose access to this workspace on their next request. You can invite them again later.",
      "removed": "Member removed.",
      "leave": "Leave workspace",
      "leaveTitle": "Leave this workspace?",
      "leaveBody": "You will lose access immediately. An Owner or Admin can invite you again.",
      "status": "Status",
      "statusActive": "Active",
      "statusSuspended": "Suspended"
    },
    "invites": {
      "heading": "Invitations",
      "empty": "No invitations yet.",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "expires": "Expires",
      "actions": "Actions",
      "statusPending": "Pending",
      "statusExpired": "Expired",
      "statusAccepted": "Accepted",
      "statusRevoked": "Revoked",
      "resend": "Resend",
      "resent": "Invitation sent again.",
      "revoke": "Revoke",
      "revoked": "Invitation revoked.",
      "resendWait": "Please wait {seconds} seconds, then send again."
    },
    "inviteModal": {
      "title": "Invite a team member",
      "description": "They receive an email link that works once and expires in 7 days.",
      "email": "Email address",
      "role": "Role",
      "language": "Email language",
      "languageAr": "Arabic",
      "languageEn": "English",
      "submit": "Send invitation",
      "sent": "Invitation sent to {email}.",
      "sentNoEmail": "The invitation was created, but the email could not be sent. Use Resend.",
      "noAssignableRoles": "There is no role you are allowed to assign.",
      "emailInvalid": "Enter a valid email address, for example name@company.com."
    },
    "errors": {
      "validation": "Check the highlighted fields and try again.",
      "memberNotFound": "This member was not found in the workspace.",
      "lastOwner": "A workspace needs at least one Owner. Make someone else an Owner first.",
      "reauthFailed": "Password confirmation failed. Ownership was not transferred.",
      "transferInvalid": "Choose another active member to become the Owner.",
      "escalation": "You cannot grant or manage access beyond your own permissions.",
      "selfPermissions": "You cannot change your own permissions.",
      "seatLimit": "All seats of your plan are in use. Remove a member or upgrade the plan.",
      "seatRequestRecent": "You already sent a seat request in the last hour. Our team will get back to you soon.",
      "approvalNotFound": "Approval request not found.",
      "approvalAlreadyDecided": "This approval request has already been decided.",
      "approvalNotPermitted": "You do not have the permission required to review this request.",
      "approvalSelfReview": "You cannot review your own request.",
      "approvalNoteRequired": "A note explaining the rejection is required.",
      "alreadyMember": "This person is already a member of the workspace.",
      "invitePending": "An invitation to this address is already pending. Resend it instead.",
      "rateLimited": "Too many requests. Please wait a moment and try again.",
      "emailExists": "This email already has an account. Use “Send an invite”.",
      "notManaged": "You cannot change this account."
    },
    "channels": {
      "button": "Numbers",
      "title": "WhatsApp numbers for {email}",
      "description": "Choose which numbers this employee can see in the inbox. Leave all unticked to allow every number.",
      "all": "Every number (no restriction)",
      "none": "No numbers are connected yet.",
      "save": "Save numbers",
      "saved": "Number access updated."
    }
  },
  "roles": {
    "b29b": {
      "viewOnly": "View only",
      "allowed": "Allowed",
      "denied": "Not allowed",
      "showSame": "Show similar",
      "hideSame": "Hide similar",
      "customSummary": "{list} only"
    },
    "nav": "Roles & permissions",
    "title": "Roles & permissions",
    "subtitle": "Built-in roles cover common jobs. Create a custom role to choose exactly what a member can do.",
    "forbidden": "You do not have permission to view the roles of this workspace.",
    "builtinBadge": "Built-in",
    "customBadge": "Custom",
    "create": "New role",
    "view": "View permissions",
    "edit": "Edit",
    "delete": "Delete",
    "members": "{count, plural, one {# member} other {# members}}",
    "created": "Role created.",
    "updated": "Role updated. Members get the new permissions on their next request.",
    "deleted": "Role deleted.",
    "deleteTitle": "Delete the role {name}?",
    "deleteBody": "Only roles without members or pending invitations can be deleted.",
    "builtin": {
      "owner": "Owner",
      "admin": "Admin / Manager",
      "agent": "Agent",
      "builder": "Builder",
      "marketer": "Marketer",
      "developer": "Developer",
      "viewer": "Viewer / Analyst"
    },
    "builtinDescription": {
      "owner": "Billing, channels, team and every module.",
      "admin": "Every module except billing ownership, including approvals.",
      "agent": "Inbox, contacts and carts for the conversations they handle.",
      "builder": "Flows, templates and AI agents. No inbox by default.",
      "marketer": "Broadcasts, templates, contacts and analytics.",
      "developer": "API keys, webhooks, connectors and logs.",
      "viewer": "Read-only dashboards and reports."
    },
    "modules": {
      "workspace": "Workspace settings",
      "team": "Team",
      "roles": "Roles",
      "billing": "Billing",
      "channels": "Channels",
      "inbox": "Inbox",
      "contacts": "Contacts",
      "flows": "Chat flows",
      "templates": "Templates",
      "broadcasts": "Broadcasts",
      "sequences": "Sequences",
      "ai_agents": "AI agents",
      "copilot": "AI Copilot",
      "commerce": "Carts, quotes and orders",
      "analytics": "Analytics",
      "integrations": "Integrations and API",
      "audit": "Audit log",
      "trips": "Trips",
      "travel_documents": "Travel documents",
      "accounts": "Customer accounts",
      "prospector": "Prospector"
    },
    "actions": {
      "view": "View",
      "create": "Create",
      "edit": "Edit",
      "delete": "Delete",
      "publish": "Publish",
      "approve": "Approve",
      "export": "Export"
    },
    "editor": {
      "scope": "Data scope",
      "scopeHint": "Which conversations and contacts members of this role can see.",
      "scopeAll": "All",
      "scopeTeam": "Team",
      "scopeAssigned": "Own (assigned only)",
      "createTitle": "New custom role",
      "editTitle": "Edit {name}",
      "viewTitle": "{name} — permissions",
      "name": "Role name",
      "matrix": "Permissions by module",
      "module": "Module",
      "readOnly": "Built-in roles cannot be changed. Create a custom role to adjust permissions.",
      "baseline": "Every member can view the workspace.",
      "ownerOnly": "Reserved for the Owner",
      "notYours": "You can only grant permissions you have yourself.",
      "notApplicable": "Not applicable",
      "save": "Save role",
      "close": "Close"
    },
    "errors": {
      "notFound": "This role was not found.",
      "builtinImmutable": "Built-in roles cannot be changed or deleted.",
      "inUse": "This role is assigned to members or pending invitations. Reassign them first.",
      "nameTaken": "A role with this name already exists. Choose another name.",
      "invalidPermissions": "The permission list contains keys that do not exist or cannot be granted."
    }
  },
  "otp": {
    "nav": "OTP",
    "title": "OTP verification",
    "subtitle": "Send one-time codes to your customers over WhatsApp, with SMS fallback. Last {days} days.",
    "sent": "Codes sent",
    "verified": "Verified",
    "failed": "Failed",
    "smsFallbacks": "SMS fallbacks",
    "spend": "Spend",
    "howTo": "This page is for whoever builds your website or app: they send and check the code through the API with a key that has the verification-code permission. Share this page with them if you are not a developer.",
    "metricHeader": "Item",
    "valueHeader": "Count",
    "priceNote": "Priced per OTP: WhatsApp and SMS are billed at different rates."
  },
  "apiKeys": {
    "nav": "API keys",
    "title": "API keys",
    "subtitle": "Scoped keys for integrations. The full key is shown once, at creation.",
    "create": "New key",
    "empty": "No API keys yet. Select «New API key» to create the first one.",
    "revoke": "Revoke",
    "revokeTitle": "Revoke the key {name}?",
    "revokeBody": "Any integration using this key will stop working immediately.",
    "revoked": "API key revoked.",
    "createdOnce": "Copy this key now — you will not be able to see it again.",
    "lastUsed": "Last used",
    "neverUsed": "Never used",
    "noExpiry": "No expiry",
    "forbidden": "You do not have permission to view the API keys of this workspace.",
    "form": {
      "name": "Name",
      "scopes": "Scopes",
      "expiry": "Expiry (optional)",
      "create": "Create key",
      "moduleScopes": "API access by module",
      "moduleScopesHint": "Choose read or read & write per module. Write implies read."
    },
    "copy": "Copy",
    "copied": "Copied to clipboard",
    "playground": {
      "nav": "API playground",
      "developerAppsLink": "Building an app that connects to WATO? Open the developer console",
      "title": "API playground",
      "subtitle": "Build a request to the public API, send it and see the response. Your key is used for this request only and is never stored.",
      "open": "Open API playground",
      "method": "Method",
      "path": "Path",
      "pathHint": "Starts with /v1/",
      "apiKey": "API key (optional)",
      "apiKeyHint": "Leave empty to use your current sign-in. The key stays in this page only and is cleared when you leave.",
      "body": "JSON body",
      "send": "Send request",
      "sending": "Sending…",
      "invalidPath": "The path must start with /v1/.",
      "invalidBody": "The body is not valid JSON.",
      "networkError": "The request could not be sent. Check your connection and try again.",
      "request": "Request",
      "response": "Response",
      "status": "Status: {status}",
      "noResponse": "Send a request to see the response here.",
      "snippets": "Example code",
      "curl": "Command line (curl)",
      "js": "JavaScript",
      "keyPlaceholder": "YOUR_API_KEY",
      "copySnippet": "Copy code"
    },
    "done": "Done",
    "columnName": "Name",
    "columnPrefix": "Key",
    "columnScopes": "Scopes",
    "columnExpiry": "Expiry",
    "columnActions": "Actions",
    "errors": {
      "validation": "Check the key name, scopes and expiry date.",
      "notFound": "This API key was not found.",
      "alreadyRevoked": "This API key was already revoked.",
      "escalation": "A key can only be granted permissions you have yourself.",
      "limit": "This workspace has reached its API key limit.",
      "planRequired": "Your plan does not include this level of API access."
    },
    "rotate": "Rotate",
    "rotated": "Key rotated. The previous key keeps working during the grace window.",
    "graceUntil": "Old key valid until {date}",
    "modules": {
      "contacts": "Contacts",
      "conversations": "Conversations",
      "messages": "Messages",
      "crm": "CRM",
      "commerce": "Commerce",
      "catalog": "Catalog",
      "templates": "Templates",
      "broadcasts": "Broadcasts",
      "forms": "Forms",
      "webhooks": "Webhooks",
      "otp": "OTP verification"
    },
    "access": {
      "none": "No access",
      "read": "Read only",
      "write": "Read & write"
    },
    "keep": "Keep key",
    "revokedStatus": "Revoked"
  },
  "auditLog": {
    "nav": "Audit log",
    "title": "Audit log",
    "subtitle": "Every sensitive action in this workspace, newest first.",
    "filterAction": "Action",
    "filterAllActions": "All actions",
    "filterFrom": "From",
    "filterTo": "To",
    "filterActor": "Person",
    "filterEntity": "Item type",
    "export": "Export CSV",
    "exportFailed": "Could not export the audit log.",
    "retention": "Entries are append-only and are kept for the life of the workspace; they cannot be edited or deleted.",
    "apply": "Apply filters",
    "clear": "Clear filters",
    "columnAction": "Action",
    "columnActor": "Actor",
    "columnTarget": "Target",
    "columnIp": "IP address",
    "columnWhen": "When",
    "empty": "No matching audit entries.",
    "loadMore": "Load more",
    "systemActor": "System",
    "forbidden": "You do not have permission to view the audit log of this workspace.",
    "errors": {
      "validation": "Check the filters and try again.",
      "invalidCursor": "This page link has expired. Start from the first page.",
      "exportThrottled": "Exports are limited to one every 10 seconds. Try again shortly."
    },
    "teamMember": "Former or unlisted member",
    "actions": {
      "api_key_created": "API key created",
      "api_key_revoked": "API key revoked",
      "api_key_rotated": "API key rotated",
      "approval_requested": "Approval requested",
      "audit_exported": "Audit log exported",
      "auth_password_reset_completed": "Password reset completed",
      "auth_password_reset_requested": "Password reset requested",
      "auth_session_logout": "Signed out",
      "auth_sso_jit_provisioned": "Account created through SSO",
      "automation_ai_paused": "AI automation paused",
      "automation_ai_resumed": "AI automation resumed",
      "automation_paused": "Automation paused",
      "automation_resumed": "Automation resumed",
      "channel_automation_paused": "Channel automation paused",
      "channel_automation_resumed": "Channel automation resumed",
      "contacts_exported": "Contacts exported",
      "conversation_bot_pause": "Automation paused in a conversation",
      "flow_paused": "Flow paused",
      "flow_resumed": "Flow resumed",
      "membership_role_changed": "Member role changed",
      "oauth_grant_revoked": "App access revoked",
      "onboarding_gallery_pack_imported": "Template pack imported",
      "onboarding_starter_pack_applied": "Starter pack applied",
      "role_created": "Role created",
      "role_deleted": "Role deleted",
      "role_updated": "Role updated",
      "team_member_permissions_changed": "Member permissions changed",
      "team_invite_accepted": "Invitation accepted",
      "team_invite_created": "Invitation sent",
      "team_invite_resent": "Invitation resent",
      "team_invite_revoked": "Invitation cancelled",
      "workspace_business_hours_updated": "Business hours updated",
      "workspace_created": "Workspace created",
      "workspace_deletion_cancelled": "Workspace deletion cancelled",
      "workspace_deletion_requested": "Workspace deletion requested",
      "workspace_export_created": "Workspace export created",
      "workspace_export_downloaded": "Workspace export downloaded",
      "workspace_logo_updated": "Logo updated",
      "workspace_ownership_transferred": "Ownership transferred",
      "workspace_purge_held": "Workspace purge held",
      "workspace_purged": "Workspace purged",
      "workspace_sales_currency_changed": "Sales currency changed",
      "workspace_test_flag_changed": "Test-workspace flag changed",
      "workspace_sso_config_updated": "SSO settings updated",
      "workspace_sso_enforce_updated": "SSO enforcement updated",
      "workspace_sso_jit_updated": "SSO auto-provisioning updated",
      "workspace_sso_role_mapping_updated": "SSO role mapping updated",
      "workspace_sso_tested": "SSO connection tested",
      "workspace_updated": "Workspace settings updated",
      "ai_agent_deleted": "AI agent deleted",
      "ai_knowledge_deleted": "Knowledge source deleted",
      "catalog_item_deleted": "Catalog item deleted",
      "catalog_product_set_deleted": "Product set deleted",
      "channel_deleted": "Channel deleted",
      "contact_bulk_delete": "Contacts deleted",
      "contact_list_deleted": "Contact list deleted",
      "custom_field_deleted": "Custom field deleted",
      "deal_deleted": "Deal deleted",
      "flow_delete": "Flow deleted",
      "flow_folder_delete": "Flow folder deleted",
      "integration_credential_deleted": "Integration credential deleted",
      "label_deleted": "Label deleted",
      "media_deleted": "Media file moved to trash",
      "media_replaced": "Media file replaced",
      "media_uploaded": "Media file uploaded",
      "macro_deleted": "Macro deleted",
      "membership_removed": "Member removed",
      "pipeline_deleted": "Pipeline deleted",
      "segment_deleted": "Segment deleted",
      "template_deleted": "Template deleted",
      "template_preset_deleted": "Template preset deleted",
      "whatsapp_form_delete": "Form deleted",
      "workspace_menu_settings_updated": "Menu settings updated",
      "admin_abuse_flag_reviewed": "Abuse flag reviewed",
      "admin_announcement_created": "Announcement created",
      "admin_blocklist_added": "Added to blocklist",
      "admin_blocklist_removed": "Removed from blocklist",
      "admin_db_fix": "Data fix by admin",
      "admin_system_activity_note_saved": "System note saved",
      "admin_user_disable": "User disabled",
      "admin_user_force_logout": "User signed out by admin",
      "admin_user_force_password_reset": "Password reset forced",
      "agency_client_created": "Agency client created",
      "agency_detach_requested": "Agency detach requested",
      "agency_workspace_detached": "Workspace detached from agency",
      "ai_agent_bound": "AI agent linked to a channel",
      "ai_agent_created": "AI agent created",
      "ai_agent_published": "AI agent published",
      "ai_agent_unpublished": "AI agent unpublished",
      "ai_agent_updated": "AI agent updated",
      "ai_coaching_consent_accepted": "AI coaching consent accepted",
      "ai_coaching_visibility_changed": "AI coaching visibility changed",
      "ai_force_byok_agency": "Agency key enforced",
      "ai_force_byok_plan": "Own key enforced by plan",
      "ai_kill_switch_toggled": "AI kill switch toggled",
      "ai_knowledge_added": "Knowledge added",
      "ai_knowledge_updated": "Knowledge updated",
      "ai_qa_create": "Q&A added",
      "ai_qa_delete": "Q&A deleted",
      "ai_qa_update": "Q&A updated",
      "ai_agent_created_from_profile_template": "AI agent created from a template",
      "ai_agent_scope_flag_resolved": "AI scope flag resolved",
      "app_install_billing_mode_override": "App billing mode overridden",
      "approval_superseded": "Approval superseded",
      "auth_2fa_backup_code_used": "Backup code used",
      "auth_2fa_enrollment_started": "2FA setup started",
      "auth_2fa_locked": "2FA locked",
      "auth_2fa_challenge_failed": "2FA challenge failed",
      "auth_email_change_completed": "Email changed",
      "auth_email_change_requested": "Email change requested",
      "auth_sso_identity_linked": "SSO identity linked",
      "auth_sso_link_required": "SSO link required",
      "automation_create_from_template": "Automation created from a template",
      "automation_toggle": "Automation toggled",
      "booking_confirmation_sent": "Booking confirmation sent",
      "booking_created": "Booking created",
      "booking_rescheduled": "Booking rescheduled",
      "breach_incident_created": "Security incident logged",
      "breach_incident_updated": "Security incident updated",
      "broadcast_approval_rejected": "Broadcast approval rejected",
      "broadcast_cancelled": "Broadcast cancelled",
      "broadcast_completed": "Broadcast completed",
      "broadcast_created": "Broadcast created",
      "broadcast_rescheduled": "Broadcast rescheduled",
      "broadcast_resumed": "Broadcast resumed",
      "broadcast_retry_failed": "Broadcast failures retried",
      "broadcast_submitted": "Broadcast submitted",
      "broadcast_test_sent": "Broadcast test sent",
      "catalog_currency_detected": "Store currency detected",
      "catalog_restaurant_status_rule_toggled": "Restaurant status rule toggled",
      "channel_automation_auto_resumed": "Automation auto-resumed",
      "channel_force_disconnected_by_admin": "Channel disconnected by admin",
      "channel_number_released_by_admin": "Number released by admin",
      "channel_qr_groups_updated": "QR groups updated",
      "channel_qr_history_reimport": "QR history re-imported",
      "channel_qr_profile_updated": "QR profile updated",
      "channel_qr_settings_updated": "QR settings updated",
      "channel_send_pacing_updated": "Send pacing updated",
      "commerce_collision_resolved": "Store collision resolved",
      "commerce_connection_dead_letter_rerun": "Failed sync re-run",
      "commerce_connection_resync_requested": "Store resync requested",
      "commerce_connection_updated": "Store connection updated",
      "compliance_erasure_completed": "Data erasure completed",
      "compliance_legal_accepted": "Legal terms accepted",
      "compliance_qr_risk_acknowledged": "QR risk acknowledged",
      "contact_lifecycle_stages_updated": "Customer stages updated",
      "contact_merged": "Customers merged",
      "contact_phone_revealed": "Customer phone revealed",
      "contact_fact_add": "Customer fact added",
      "contact_fact_dismiss": "Customer fact dismissed",
      "contacts_import_queued": "Customer import queued",
      "contacts_imported": "Customers imported",
      "conversation_assign": "Conversation assigned",
      "conversation_at_risk": "Conversation flagged at risk",
      "conversation_at_risk_clear": "Conversation risk cleared",
      "conversation_auto_close": "Conversation auto-closed",
      "conversation_bot_resume": "Assistant resumed the conversation",
      "conversation_observe": "Conversation observed",
      "conversation_priority": "Conversation priority changed",
      "conversation_simulate_choice": "Choice simulated",
      "conversation_status": "Conversation status changed",
      "conversation_whisper": "Internal whisper added",
      "copilot_money_change_refused": "Copilot money change refused",
      "copilot_proposal_applied": "Copilot proposal applied",
      "copilot_proposal_undone": "Copilot proposal undone",
      "customer_account_entry_recorded": "Customer account entry recorded",
      "customer_account_entry_reversed": "Customer account entry reversed",
      "customer_account_payment_auto_recorded": "Payment recorded automatically",
      "customer_account_statement_generated": "Statement generated",
      "customer_accounts_balance_followups_updated": "Balance follow-ups updated",
      "deal_created": "Deal created",
      "deal_updated": "Deal updated",
      "dlq_discard": "Failed job discarded",
      "dlq_retry": "Failed job retried",
      "feature_flag_updated": "Feature flag updated",
      "feature_switch_changed": "Feature switch changed",
      "flow_approval_setting_changed": "Flow approval setting changed",
      "flow_clone": "Flow cloned",
      "flow_create": "Flow created",
      "flow_import": "Flow imported",
      "flow_import_block_resolved": "Imported block resolved",
      "flow_publish": "Flow published",
      "flow_publish_approved": "Flow publish approved",
      "flow_publish_rejected": "Flow publish rejected",
      "flow_publish_requested": "Flow publish requested",
      "flow_unpublish": "Flow unpublished",
      "flow_control_bulk": "Bulk flow control",
      "flow_control_set_channel": "Flow channel set",
      "flow_control_trigger_assign": "Trigger assigned",
      "flow_control_trigger_unassign": "Trigger unassigned",
      "flow_folder_create": "Flow folder created",
      "flow_folder_rename": "Flow folder renamed",
      "flows_starter_pack_installed": "Starter flows installed",
      "impersonation_blocked": "Impersonation blocked",
      "impersonation_started": "Impersonation started",
      "integration_credential_created": "Credential added",
      "integration_email_provider_changed": "Email provider changed",
      "integration_google_connected": "Google connected",
      "integration_google_disconnected": "Google disconnected",
      "integration_google_contacts_sync_toggled": "Google contacts sync toggled",
      "macro_created": "Macro created",
      "macro_run": "Macro run",
      "member_channel_access": "Member channel access changed",
      "member_created_with_password": "Staff member created with password",
      "meta_data_deletion_requested": "Meta data deletion requested",
      "meta_deauthorized": "Meta deauthorized",
      "migration_committed": "Migration committed",
      "migration_reimport_confirmed": "Re-import confirmed",
      "migration_rolled_back": "Migration rolled back",
      "migration_started": "Migration started",
      "monitoring_tool_call": "Monitoring tool called",
      "note_create": "Note added",
      "oauth2_client_created": "OAuth client created",
      "oauth2_client_revoked": "OAuth client revoked",
      "payment_reconciliation_resolved": "Payment reconciliation resolved",
      "payment_refund_rejected": "Refund rejected",
      "pipeline_created": "Pipeline created",
      "pipeline_updated": "Pipeline updated",
      "plan_created": "Plan created",
      "plan_edit_limit_type": "Plan limit type edited",
      "plan_updated": "Plan updated",
      "platform_staff_role_deleted": "Platform staff role deleted",
      "quote_edited": "Quote edited",
      "sequence_created": "Sequence created",
      "sequence_step_fired": "Sequence step sent",
      "sequence_updated": "Sequence updated",
      "setting_changed": "Setting changed",
      "staff_partner_assigned": "Partner assigned",
      "staff_partner_payout_posted": "Partner payout posted",
      "style_experiment_created": "Style experiment created",
      "style_experiment_extended": "Style experiment extended",
      "style_experiment_stopped": "Style experiment stopped",
      "style_experiment_winner_applied": "Style winner applied",
      "task_create": "Task created",
      "task_update": "Task updated",
      "template_admin_decision": "Template admin decision",
      "template_category_changed": "Template category changed",
      "template_category_reviewed": "Template category reviewed",
      "template_created": "Template created",
      "template_edited_on_meta": "Template edited on Meta",
      "template_library_imported": "Library template imported",
      "template_preset_created": "Preset created",
      "template_preset_updated": "Preset updated",
      "template_starter_set_created": "Starter template set created",
      "template_status_changed": "Template status changed",
      "template_submitted": "Template submitted",
      "template_synced_from_meta": "Template synced from Meta",
      "template_updated": "Template updated",
      "tenant_coupon_granted": "Coupon granted",
      "tenant_plan_overridden": "Plan overridden",
      "tenant_trial_extended": "Trial extended",
      "tenant_wallet_credited": "Wallet credited",
      "travel_document_opened": "Trip document opened",
      "travel_sheet_sync_interval_updated": "Trip sheet sync interval updated",
      "voucher_pool_create": "Voucher pool created",
      "voucher_pool_upload": "Vouchers uploaded",
      "whatsapp_form_create": "WhatsApp form created",
      "whatsapp_form_mapping": "Form mapping updated",
      "whatsapp_form_settings": "Form settings updated",
      "workspace_automation_settings_update": "Automation settings updated",
      "workspace_business_type_changed": "Business type changed",
      "workspace_enforce2fa_changed": "2FA enforcement changed",
      "workspace_limit_override_changed": "Limit override changed",
      "workspace_menu_refreshed": "Menu refreshed",
      "workspace_modules_updated": "Modules updated",
      "workspace_seat_override_changed": "Seat override changed",
      "workspace_show_all_lock_changed": "Show-all lock changed",
      "workspace_tenant_type_changed": "Workspace type changed",
      "workspace_member_role_changed_by_staff": "Member role changed by staff",
      "automation_unmatched_dismissed": "Unmatched message dismissed",
      "automation_unmatched_proposed": "Reply proposed for unmatched message",
      "broadcast_auto_stopped": "Broadcast auto-stopped",
      "broadcast_paused": "Broadcast paused",
      "catalog_auto_enabled": "Store enabled automatically",
      "catalog_category_renamed": "Category renamed",
      "catalog_item_created": "Item created",
      "catalog_item_updated": "Item updated",
      "catalog_linked": "Catalog linked",
      "catalog_message_templates_updated": "Order messages updated",
      "catalog_meta_repointed": "Meta catalog re-pointed",
      "catalog_order_settings_updated": "Order settings updated",
      "catalog_product_set_created": "Product set created",
      "catalog_product_set_items_updated": "Product set items updated",
      "catalog_product_set_renamed": "Product set renamed",
      "catalog_settings_updated": "Store settings updated",
      "catalog_source_mode_changed": "Catalog source changed",
      "feature_flag_override_cleared": "Feature override cleared",
      "feature_flag_override_set": "Feature override set",
      "flow_rollback": "Flow rolled back",
      "flow_control_archive": "Flow archived",
      "flow_control_unarchive": "Flow unarchived",
      "member_managed_updated": "Managed member updated",
      "member_password_changed": "Member password changed",
      "membership_left": "Member left",
      "payment_refund": "Refund recorded",
      "payment_refund_failed": "Refund failed",
      "plan_archived": "Plan archived",
      "plan_restored": "Plan restored",
      "platform_staff_deactivated": "Platform staff deactivated",
      "platform_staff_invited": "Platform staff invited",
      "platform_staff_reactivated": "Platform staff reactivated",
      "platform_staff_role_changed": "Platform staff role changed",
      "platform_staff_role_created": "Platform staff role created",
      "platform_staff_role_updated": "Platform staff role updated",
      "whatsapp_form_publish": "WhatsApp form published",
      "whatsapp_form_rollback": "WhatsApp form rolled back"
    },
    "targets": {
      "team_invite": "Invitation",
      "api_key": "API key",
      "membership": "Member",
      "role": "Role",
      "workspace": "Workspace",
      "user": "User",
      "channel": "Channel",
      "flow": "Flow",
      "conversation": "Conversation",
      "contact": "Contacts",
      "audit_log": "Audit log",
      "oauth_grant": "App access"
    },
    "targetUnknown": "Item",
    "filterAllPeople": "Everyone",
    "filterAllTargets": "All types"
  },
  "vouchers": {
    "nav": "Voucher pools",
    "title": "Voucher pools",
    "subtitle": "Pre-loaded codes handed out one per contact by flows.",
    "nameLabel": "Pool name",
    "create": "Create pool",
    "empty": "No voucher pools yet.",
    "counts": "{remaining} remaining, {issued} issued, {total} total",
    "uploadCsv": "Upload CSV of codes",
    "uploadFor": "Upload codes for {name}",
    "uploaded": "Added {added} codes, skipped {skipped}."
  },
  "automationPause": {
    "bannerTitle": "All automation is paused",
    "bannerBody": "Flows, system replies, broadcasts and sequences are on hold. Manual replies from agents still work and incoming messages still reach the inbox.",
    "bannerReason": "Reason: {reason}",
    "pauseAll": "Pause all",
    "resume": "Resume automation",
    "reasonLabel": "Reason (optional)",
    "confirmPause": "Pause now",
    "cancel": "Cancel",
    "pausedToast": "Automation paused.",
    "resumedToast": "Automation resumed.",
    "aiPause": "Pause AI",
    "aiBannerTitle": "The AI agent is paused",
    "aiBannerBody": "Flows keep running, but the AI agent will not reply until you resume it.",
    "aiResume": "Resume AI agent",
    "aiPausedToast": "AI agent paused.",
    "aiResumedToast": "AI agent resumed.",
    "channelPaused": "Automation paused on channel {channel}",
    "channelResume": "Resume channel",
    "channelPauseButton": "Pause automation",
    "channelResumeButton": "Resume automation",
    "channelPausedBadge": "Automation paused",
    "channelResumedToast": "Channel automation resumed.",
    "statusChip": "Automation: {status}",
    "statusMenu": "Automation status",
    "runningBody": "Flows, AI and broadcasts are running normally.",
    "status": {
      "running": "Running",
      "partial": "Partly paused",
      "paused": "Paused"
    }
  },
  "invites": {
    "b29b": {
      "errorTitle": "Link incomplete or expired",
      "requestNew": "Request a new invitation",
      "requestNewHint": "Ask your team admin to send a new invitation to your email."
    },
    "accept": {
      "loading": "Checking your invitation…",
      "title": "Join {workspace}",
      "subtitle": "You have been invited to join {workspace} as {role}.",
      "invitedAddress": "Invited address",
      "signedInAs": "Signed in as {email}.",
      "acceptButton": "Accept invitation",
      "signInToAccept": "Sign in",
      "wrongAccount": "This invitation is for {email}. Sign out, then sign in with that address.",
      "signOut": "Sign out",
      "createHeading": "Create your account",
      "password": "Choose a password",
      "passwordHint": "At least 10 characters. Avoid a password you use elsewhere.",
      "createAndJoin": "Create account",
      "accountCreated": "Your account is ready. Sign in to open {workspace}.",
      "accepted": "You joined {workspace}.",
      "alreadyMember": "You are already a member of {workspace}.",
      "openWorkspace": "Open workspace",
      "missingToken": "This invitation link is incomplete. Open the link from your email again."
    },
    "errors": {
      "notFound": "This invitation link is not valid.",
      "expired": "This invitation has expired. Ask the workspace admin to send a new one.",
      "alreadyAccepted": "This invitation was already accepted.",
      "revoked": "This invitation was cancelled by the workspace.",
      "emailMismatch": "This invitation was sent to a different email address than the one you are signed in with.",
      "loginRequired": "An account with this email already exists. Sign in to accept the invitation.",
      "accountDisabled": "This account is disabled. Contact support."
    }
  },
  "conversations": {
    "b29b": {
      "sla": {
        "wait": {
          "minutes": "{count} min",
          "hours": "{count} h",
          "days": "{count, plural, one {# day} other {# days}}"
        },
        "toastOrange": "{name} has been waiting {wait}",
        "toastRed": "Urgent: {name} has been waiting {wait}",
        "toastEscalated": "Escalation: {name} has been waiting {wait}",
        "grouped": "{count, plural, one {# late conversation} other {# late conversations}}",
        "open": "Open"
      },
      "panel": {
        "customerInfo": "Customer info",
        "switch": {
          "toggle": "{name}",
          "endSession": "End session",
          "menu": "Stop {name} for…"
        },
        "grid": {
          "transfer": "Hand the chat over to a teammate or a team",
          "requestHuman": "Ask a person to take over this chat",
          "star": "Star the chat so you can find it fast",
          "archive": "Move the chat to the archive",
          "block": "Stop this number from messaging you",
          "macros": "Run a ready-made set of actions in one tap",
          "flow": "Turn this chat into an automatic flow",
          "meet": "Creates a Google Meet link and sends it in the chat",
          "observe": "Watch the chat live without joining in",
          "clearAtRisk": "Remove the at-risk mark from this chat",
          "blockConfirmTitle": "Block this customer?",
          "blockConfirmMessage": "They will not be able to message you until you unblock them."
        },
        "customer": {
          "title": "Customer",
          "source": "Source",
          "subscriptionHint": "Whether the customer agreed to receive your messages",
          "windowHint": "Time left to reply freely; after that only a template can be sent",
          "channels": {
            "qr": "WhatsApp QR",
            "official": "WhatsApp official",
            "instagram": "Instagram"
          },
          "sources": {
            "direct": "Wrote to us first",
            "link": "Link",
            "qr": "QR code",
            "ad": "Ad",
            "import": "Import",
            "api": "Integration",
            "form": "Form",
            "manual": "Added by hand"
          }
        },
        "labels": {
          "hint": "Labels help you filter customers and send them bulk messages",
          "add": "Add label",
          "search": "Search labels",
          "create": "Create a new label"
        },
        "memory": {
          "hint": "What the AI assistant remembers about the customer and uses in its replies",
          "placeholder": "e.g. Prefers delivery after 5 pm",
          "aiBadge": "Noted by the assistant"
        },
        "flows": {
          "start": "Start flow",
          "stop": "Stop flow",
          "startTitle": "Start one of your published flows for this customer",
          "stopTitle": "End the flow this customer is in, e.g. when stuck on a question",
          "pickTitle": "Pick a flow to start",
          "empty": "You have no published flows yet."
        }
      },
      "tasks": {
        "button": "Tasks",
        "overdue": "Overdue",
        "followUp": "Follow up"
      },
      "window": {
        "clock": "{time} left",
        "hours": "{hours} h left"
      },
      "sender": {
        "staff": "Staff",
        "customer": "Customer",
        "ai": "🤖 Assistant",
        "flow": "⚙️ Flow",
        "delivered": "Delivered"
      },
      "addOrder": {
        "title": "Add order",
        "quoteTitle": "Add quote",
        "search": "Search products",
        "noResults": "No products found",
        "customName": "Custom item",
        "customPrice": "Price",
        "customAdd": "Add item",
        "customInvalid": "Enter an item name and a valid price",
        "currencyMismatch": "All order lines must use the same currency",
        "empty": "Pick a product to add it",
        "qtyMinus": "Decrease quantity",
        "qtyPlus": "Increase quantity",
        "remove": "Remove",
        "total": "Total",
        "payment": "Payment method",
        "pay": {
          "cod": "Cash on delivery",
          "link": "Payment link",
          "transfer": "Transfer"
        },
        "asQuote": "Save as quote",
        "sendToCustomer": "Send the order to the customer",
        "cancel": "Cancel",
        "create": "Create order",
        "createQuote": "Create quote",
        "created": "Order created",
        "quotePartial": "Quote {number} was created but not all lines were added. Open it in Quotes to finish or discard it.",
        "quoteCreated": "Quote created",
        "linkPending": "The payment link is waiting for approval",
        "draftTitle": "Your order:",
        "draftLine": "{qty} × {name} — {amount}",
        "draftTotal": "Total: {total}",
        "draftPay": {
          "cod": "Cash on delivery.",
          "transfer": "Pay by transfer; we will send you the account details."
        },
        "draftPayLink": "Pay here: {url}"
      },
      "sales": {
        "title": "Sales",
        "add": "Add",
        "tabs": {
          "orders": "Orders",
          "quotes": "Quotes",
          "appointments": "Appointments",
          "trips": "Trips",
          "viewings": "Viewings",
          "tables": "Tables"
        },
        "menu": {
          "order": "Order",
          "quote": "Quote",
          "appointment": "Appointment",
          "product": "Send a product",
          "paylink": "Payment link",
          "from-chat": "Order from chat"
        },
        "fromChat": {
          "working": "Preparing the order…",
          "incomplete": "Could not prepare the order from the chat; add it yourself",
          "unavailable": "The assistant is not available right now",
          "error": "Could not prepare the order, try again"
        }
      }
    },
    "receipt": {
      "b29": {
        "approved": "Approved",
        "approvedBy": "Approved by {name}",
        "viewReceipt": "View receipt",
        "receiptAlt": "Uploaded receipt",
        "ocrOff": "Automatic reading is off"
      }
    },
    "quote": {
      "you": "You",
      "contact": "Customer",
      "jump": "Jump to the original message",
      "cancel": "Cancel reply",
      "reply": "Reply",
      "replyingTo": "Replying to"
    },
    "testPhone": {
      "title": "Test phone",
      "hint": "Chat with your step-by-step chats as a fake customer. Nothing is sent to WhatsApp or real customers.",
      "flow": "Step-by-step chat",
      "noFlows": "Create a step-by-step chat first to try it on the test phone."
    },
    "copilot": {
      "label": "AI assistant",
      "suggest": "Suggest replies",
      "suggesting": "Thinking…",
      "summarize": "Summarize",
      "summary": "Conversation summary",
      "hideSummary": "Hide",
      "showSummary": "Show",
      "rephrase": "Rephrase",
      "toneFormal": "Formal",
      "toneFriendly": "Friendly",
      "toneShort": "Short",
      "toneDialect": "Gulf dialect",
      "toneMsa": "Standard Arabic",
      "translate": "Translate",
      "translateToAr": "To Arabic",
      "translateToEn": "To English",
      "translation": "Translation (not sent)",
      "hideTranslation": "Hide translation",
      "insert": "Insert",
      "draftCart": "Draft cart",
      "draftCartDone": "Draft cart created (AI-assisted). Review and send it from the cart panel.",
      "error": "The assistant is unavailable right now.",
      "insertOnly": "Inserted as a draft",
      "suggestedLabel": "Suggested replies",
      "suggestedLoading": "Preparing suggestions…",
      "suggestionsButton": "Suggestions",
      "closeSuggestions": "Hide suggestions",
      "suggestionsSetting": "Show reply suggestions",
      "groundedDraft": {
        "title": "Suggest reply from knowledge",
        "busy": "Drafting…",
        "insert": "Use draft",
        "sources": "Sources",
        "none": "No grounded answer found — reply yourself or hand off.",
        "rate": "Too many suggestions. Try again in a minute.",
        "credits": "AI credits are used up for now.",
        "noAgent": "Bind an AI Agent to this channel to get suggestions.",
        "error": "Could not draft a reply.",
        "note": "Draft only — nothing is sent until you press Send."
      }
    },
    "title": "Conversations",
    "views": {
      "all": "All",
      "mine": "Mine",
      "unassigned": "Unassigned",
      "bot_active": "Auto-reply on",
      "paused": "Paused",
      "waiting_human": "Waiting for a human",
      "waiting_on_customer": "Waiting on customer",
      "closed": "Closed",
      "snoozed": "Snoozed",
      "important": "Important",
      "blocked": "Blocked",
      "archived": "Archived",
      "at_risk": "At risk"
    },
    "sla": {
      "sortNeedsReply": "Unanswered",
      "counter": "{count} waiting",
      "badge": "Needs reply · {minutes} min",
      "open": "Open",
      "settingsTitle": "Alerts",
      "orangeMinutes": "Warn after (minutes)",
      "redMinutes": "Urgent after (minutes)",
      "sound": "Play a sound",
      "muted": "Mute alerts",
      "quietStart": "Quiet hours from",
      "quietEnd": "Quiet hours until",
      "smartTitle": "Smart alerts",
      "ruleComplaint": "Complaint or angry wording",
      "ruleVip": "VIP customer wrote",
      "ruleRepeated": "Repeated unanswered messages",
      "ruleHighValue": "High order or quote value",
      "repeatedCount": "Unanswered messages count",
      "highValueMinor": "Value threshold (minor units)",
      "reasonComplaint": "Complaint: {name}",
      "reasonVip": "VIP customer: {name}",
      "reasonRepeated": "Repeated messages: {name}",
      "reasonHighValue": "High-value conversation: {name}",
      "toastGrouped": "{count} more conversations need attention",
      "reasonComplaintMany": "{count} conversations look like complaints",
      "reasonVipMany": "{count} VIP customers are waiting",
      "reasonRepeatedMany": "{count} conversations have new repeated messages",
      "reasonHighValueMany": "{count} high-value conversations are waiting",
      "showGroups": "Groups"
    },
    "list": {
      "label": "Conversation list",
      "empty": "No conversations in this view.",
      "loadMore": "Load more",
      "loading": "Loading…",
      "error": "Could not load conversations.",
      "unread": "{count, plural, one {# unread message} other {# unread messages}}",
      "noPreview": "No messages yet",
      "lastMessageFailed": "Last message failed to send",
      "atRisk": "At risk",
      "redFlag": "Red flag",
      "waitingMinutes": "Waiting {minutes} min",
      "waitingHours": "Waiting {hours} h",
      "unknownContact": "Unknown contact",
      "starred": "Starred",
      "archived": "Archived",
      "blocked": "Blocked",
      "channelOfficial": "Official",
      "channelQr": "QR",
      "channelInstagram": "Instagram",
      "channelMessenger": "Messenger",
      "channelOther": "Account",
      "densityLabel": "Row density",
      "densityCompact": "Compact rows",
      "densityComfortable": "Comfortable rows",
      "waitingSince": "The customer is waiting for a reply"
    },
    "channelInstagram": "Instagram",
    "ai": {
      "replying": "AI is replying",
      "paused": "Paused",
      "assigned": "Assigned to a colleague",
      "returnToAi": "Return to AI",
      "tipReplying": "The AI agent answers new messages. Click to pause it.",
      "tipAssigned": "Assigned to a colleague — automation ignores assigned conversations.",
      "tipPausedHandoff": "Paused: the AI handed this conversation to a human.",
      "tipPausedManual": "Paused: a colleague replied or paused the AI manually. Click to resume.",
      "closed": "AI session closed",
      "tipClosed": "The AI session ended. Click to let the AI answer again.",
      "tipBlocked": "Blocked: the AI balance has run out. Top up to let it reply again.",
      "blocked": "Out of credit",
      "topUp": "Top up",
      "cloudReplying": "Auto-reply is on",
      "cloudPaused": "Auto-reply is paused",
      "cloudClosed": "Auto-reply session closed",
      "cloudTipReplying": "Auto-reply (buttons, lists and flows) answers new messages. Click to pause it.",
      "cloudTipPaused": "Paused: a colleague replied or paused auto-reply. Customer keywords and button replies still run; other messages get no auto-reply. Click to resume."
    },
    "actions": {
      "macros": "Macros",
      "macrosTitle": "Macros",
      "macrosDescription": "Run a saved set of actions on this conversation.",
      "macrosEmpty": "No macros yet. Create one below.",
      "macroRun": "Run",
      "macroDelete": "Delete",
      "macroRunConfirm": "Run macro \"{name}\" on this conversation?",
      "macroConfirmYes": "Yes, run it",
      "macroRan": "Macro \"{name}\" done",
      "macroPartial": "Macro \"{name}\" stopped at a failed step",
      "macroDeleted": "Macro deleted",
      "macroCreate": "New macro",
      "macroName": "Macro name",
      "macroAddStep": "Add step",
      "macroRemoveStep": "Remove step",
      "macroSave": "Save macro",
      "macroStepType": "Step",
      "macroStepResolve": "Resolve",
      "macroStepSnooze": "Snooze",
      "macroStepPriority": "Set priority",
      "macroStepLabel": "Add label",
      "macroStepAssign": "Assign",
      "macroStepCanned": "Send canned reply",
      "macroMinutes": "Minutes",
      "macroPickLabel": "Label",
      "macroPickMember": "Agent",
      "macroPickCanned": "Canned reply",
      "macroNoSteps": "Add at least one step.",
      "macroSaved": "Macro saved",
      "macroStepsCount": "{count} steps",
      "assign": "Assignee",
      "unassigned": "Unassigned",
      "transfer": "Transfer",
      "turnIntoFlow": "Turn into a flow",
      "turnIntoFlowBusy": "Building the flow…",
      "requestHuman": "Request a human",
      "humanRequested": "Waiting for a human",
      "transferTitle": "Transfer this conversation",
      "transferDescription": "Hand it to a specific employee or team. They will be notified.",
      "transferEmployee": "Employee",
      "transferTeam": "Team",
      "transferNone": "Choose…",
      "transferNote": "Note for the new owner (optional)",
      "transferConfirm": "Transfer conversation",
      "assignToMe": "Assign to me",
      "youSuffix": "(you)",
      "openCount": "{count, plural, =0 {no open conversations} one {# open conversation} other {# open conversations}}",
      "presenceOnline": "online",
      "status": "Status",
      "statusOpen": "Open",
      "statusPending": "Pending",
      "statusClosed": "Closed",
      "failed": "Action failed.",
      "star": "Star",
      "unstar": "Remove star",
      "archive": "Archive",
      "unarchive": "Unarchive",
      "block": "Block contact",
      "unblock": "Unblock contact",
      "clearAtRisk": "Clear at-risk",
      "createMeetLink": "Meet link",
      "meetLinkNotConnected": "Google is not connected — connect your calendar to create Meet links.",
      "meetLinkConnect": "Connect Google",
      "meetLinkFailed": "Could not create the Meet link.",
      "meetLinkWindowClosed": "The 24-hour reply window is closed; send an approved ready-made message instead.",
      "pauseBot": "Pause auto-reply",
      "resumeBot": "Resume auto-reply",
      "alreadyAssigned": "{name} took this conversation first. The inbox was refreshed.",
      "alreadyChanged": "Someone else changed this assignment. The inbox was refreshed.",
      "warnOffline": "{name} is offline right now; they will see it when they are back.",
      "warnOverCapacity": "{name} is already at their limit of open conversations.",
      "noInboxAccess": "This employee cannot open the inbox, so they cannot take conversations.",
      "noChannelAccess": "This employee has no access to the number this conversation is on.",
      "teamInvalid": "That team no longer exists.",
      "reassignedTo": "This conversation was reassigned to {name}.",
      "reassignedAway": "This conversation is no longer assigned to you.",
      "someone": "a colleague"
    },
    "memory": {
      "title": "Customer memory",
      "add": "Add fact",
      "wrong": "wrong",
      "wrongLabel": "Mark \"{text}\" as wrong",
      "source": "Open the source message",
      "showAll": "Show all ({count})",
      "showLess": "Show less",
      "save": "Save",
      "failed": "Could not update memory. Try again.",
      "kindLabel": "Kind",
      "textLabel": "Fact",
      "kinds": {
        "preference": "Preference",
        "complaint": "Complaint",
        "personal": "Personal",
        "commercial": "Commercial",
        "constraint": "Constraint"
      }
    },
    "snapshot": {
      "since": "Customer since {date}",
      "online": "Online now",
      "lastSeen": "Last seen {date}",
      "localTime": "{time} local",
      "email": "Email",
      "addEmail": "Add email",
      "editEmail": "Edit email",
      "emailInvalid": "Enter a valid email address.",
      "cancel": "Cancel",
      "channel": "Channel",
      "subscription": "Subscription",
      "window": "Messaging window",
      "windowClosed": "Closed, template needed",
      "closeBy": "Close by {date}",
      "optIn": {
        "opted_in": "Subscribed",
        "opted_out": "Unsubscribed",
        "unknown": "Not recorded"
      }
    },
    "panel": {
      "quick": {
        "assign": "Assign",
        "unassigned": "Unassigned",
        "assignedTo": "Assigned to {name}",
        "teamOption": "Team: {name}",
        "flows": "Chat flows",
        "ai": "AI agent",
        "running": "Running",
        "resume": "Resume",
        "pausedUntil": "Paused until {time}",
        "pausedIndefinitely": "Paused until you resume",
        "d30m": "30 minutes",
        "d1h": "1 hour",
        "d24h": "24 hours",
        "dUntilResume": "Until I resume"
      },
      "automation": {
        "title": "Automation",
        "list": "Add to list",
        "pickList": "Choose a list",
        "add": "Add",
        "listAdded": "Added to the list",
        "sequence": "Sequence",
        "pickSequence": "Choose a sequence",
        "sequenceActive": "{name} (subscribed)",
        "subscribe": "Subscribe",
        "unsubscribe": "Unsubscribe",
        "subscribed": "Subscribed to the sequence",
        "unsubscribed": "Unsubscribed from the sequence",
        "field": "Custom field",
        "pickField": "Choose a field",
        "value": "Value",
        "pickValue": "Choose a value",
        "save": "Save",
        "fieldSaved": "Field saved"
      },
      "nameLabel": "Contact name",
      "editName": "Edit name",
      "saveName": "Save",
      "cancelName": "Cancel",
      "label": "Customer panel",
      "labels": "Labels",
      "nameError": "Could not save the name.",
      "labelDetails": {
        "open": "Label details: {name}",
        "title": "Label details",
        "source": "Source",
        "flow": "Flow",
        "by": "Added by",
        "teamMember": "Team member",
        "at": "When",
        "history": "History",
        "noHistory": "No history yet.",
        "added": "Added",
        "removed": "Removed",
        "loading": "Loading…",
        "error": "Could not load label details.",
        "sources": {
          "flow": "Flow",
          "agent": "Agent",
          "ai": "AI agent",
          "api": "API",
          "broadcast": "Broadcast",
          "import": "Import",
          "form": "Form",
          "unknown": "Unknown"
        }
      },
      "channels": "Channels",
      "fields": "Extra details",
      "email": "Email",
      "commerce": "Cart and quotes",
      "commerceTools": {
        "bookedToast": "Booking created. You can send the confirmation to the customer.",
        "sendConfirmation": "Send confirmation to customer",
        "confirmationSent": "Confirmation sent to the customer.",
        "confirmationAlready": "The confirmation was already sent before.",
        "confirmationSkipped": "Nothing was sent: the booking is not confirmed, the 24-hour window is closed, or the channel is unavailable. If the window is closed, send an approved ready-made message instead.",
        "sendProduct": "Send a product",
        "productSent": "Product sent to the customer.",
        "productWindowClosed": "The 24-hour window is closed, so the product can't be sent now. Send an approved ready-made message instead.",
        "productCardText": "Here is the product you asked for:\n{name}\n{price}\n{link}",
        "skip": {
          "BOOKING_NOT_CONFIRMED": "The booking isn't confirmed yet, so nothing was sent.",
          "CONTACT_BLOCKED": "This customer is blocked, so nothing was sent.",
          "CHANNEL_OFFLINE": "The number or channel is disconnected, so nothing was sent.",
          "CHANNEL_CAPABILITY_MISSING": "This channel can't send this kind of message.",
          "WINDOW_CLOSED": "More than 24 hours have passed since the customer's last message, and there is no approved ready-made message for booking confirmation. Ask an admin to create and approve one.",
          "TEMPLATE_PARAMS_MISMATCH": "The approved booking confirmation ready-made message doesn't match the expected fields.",
          "SERVICE_NOT_FOUND": "The booking's service no longer exists."
        }
      },
      "aiSummary": "AI summary",
      "aiHandoffReason": "Handoff reason",
      "aiHandoffIntent": "What the customer wants",
      "aiHandoffLastQuestion": "Last question",
      "aiHandoffSummary": "Conversation summary",
      "aiHandoffCitations": "Sources",
      "error": "Could not load the customer.",
      "removeLabel": "Remove label {name}",
      "aiSummaryTitle": "AI summary",
      "aiSummaryHint": "Press Summarize to generate the conversation summary only when you need it.",
      "orders": "Orders",
      "totalSpent": "Total spent",
      "dealAmount": "Deal value",
      "pinnedNotes": "Pinned notes",
      "otherNumberOpen": "Open on {channel}",
      "handoffReasonLabels": {
        "ai_ungrounded_price": "Held for a human: the AI quoted a price that is not in your catalog or the customer's message",
        "ai_untrusted_link": "Held for a human: the AI included a link that is not yours or the customer's",
        "ai_payment_details": "Held for a human: the AI wrote bank or card details that are not yours or the customer's",
        "ai_unverified_stock": "Held for a human: the AI said an item is available but your store shows it out of stock",
        "ai_money_promise": "Held for a human: the AI promised a refund, free delivery or confirmed a payment",
        "ai_internal_leak": "Held for a human: the AI reply exposed internal instructions or a secret",
        "ai_regulated_advice": "Held for a human: the AI gave a medicine dose, a diagnosis or a legal ruling"
      },
      "handoffIntentLabels": {
        "price_unverified": "Price needs a person to confirm",
        "link_unverified": "Link needs a person to check",
        "payment_details_unverified": "Payment details must come from a person",
        "stock_unverified": "Availability needs a person to confirm",
        "money_promise_unverified": "Money commitment needs a person to decide",
        "internal_leak_unverified": "Reply to be written by a person",
        "regulated_advice_unverified": "Advice to be given by a qualified person"
      },
      "vertical": {
        "quotesList": {
          "title": "Quotes for this customer"
        },
        "title": "Business tabs",
        "loading": "Loading…",
        "quick": {
          "record_payment": "Add a payment",
          "send_statement": "Prepare a statement",
          "record_deposit": "Add a deposit",
          "send_similar_properties": "Send similar properties"
        },
        "tabs": {
          "account": "Account",
          "quotes": "Quotes",
          "trips": "Trips",
          "orders": "Orders",
          "tables": "Tables",
          "appointments": "Appointments",
          "viewings": "Viewings",
          "favorites": "Favorites",
          "past_services": "Past services",
          "interests": "Interests",
          "receipts": "Receipts",
          "deal": "Deal",
          "vehicle": "Vehicle and jobs"
        },
        "favorites": {
          "empty": "No orders yet, so no favorites to show.",
          "error": "Could not load the favorites.",
          "qty": "{n} ordered",
          "putDraft": "Draft a suggestion",
          "draft": "Would you like {name} again?"
        },
        "pastServices": {
          "staff": "Staff: {name}",
          "empty": "No completed visits for this contact yet.",
          "error": "Could not load the past services."
        },
        "interests": {
          "empty": "No tags or details saved for this contact yet. Add them from Contacts.",
          "error": "Could not load the interests."
        },
        "receipts": {
          "empty": "No bank transfer receipts in this chat yet.",
          "error": "Could not load the receipts.",
          "attached": "Receipt attached",
          "status": {
            "awaiting_receipt": "Waiting for the receipt",
            "awaiting_verification": "Waiting for your approval in the payment queue",
            "paid": "Paid",
            "rejected": "Rejected",
            "cancelled": "Cancelled"
          }
        },
        "trips": {
          "empty": "No trip bookings for this contact yet.",
          "error": "Could not load the trips.",
          "seats": "Seats",
          "open": "Travelers and documents",
          "addToAccount": "Add to customer account",
          "confirmCharge": "Add the remaining balance of {title} ({amount}) to this customer's account as a charge? This is not automatic.",
          "chargeDone": "Added to the customer account.",
          "chargeError": "Could not add to the account. The booking total may have changed; reload and try again.",
          "status": {
            "expired": "Expired",
            "inquiry": "Inquiry",
            "held": "Seats held",
            "deposit_pending": "Deposit awaiting approval",
            "deposit_paid": "Deposit paid",
            "paid": "Paid",
            "travelled": "Travelled",
            "cancelled": "Cancelled"
          },
          "docOk": "{n, plural, one {# document on file} other {# documents on file}}",
          "docMissing": "Document missing"
        },
        "account": {
          "quotesTitle": "Accepted quotes",
          "addToAccount": "Add to customer account",
          "confirmQuote": "Add quote {number} ({amount}) to this customer's account as a charge? This is not automatic.",
          "quoteAdded": "Quote added to the customer account.",
          "quoteError": "Could not add the quote to the account.",
          "noBalance": "No balance yet.",
          "owed": "Owed to you",
          "credit": "Credit for the customer",
          "recordPayment": "Record payment",
          "addCharge": "Add charge",
          "statement": "Account statement",
          "amount": "Amount",
          "currency": "Currency",
          "method": "Payment method",
          "noteField": "Note (optional)",
          "review": "Review",
          "confirm": "Confirm and save",
          "cancel": "Cancel",
          "recorded": "Saved to the account.",
          "sentForApproval": "Sent for approval.",
          "saveError": "Could not save. Check the amount and try again.",
          "error": "Could not load the account.",
          "noteApproval": "Sent for approval",
          "note": {
            "payment": "Payment recorded",
            "charge": "Charge added"
          },
          "methods": {
            "cash": "Cash",
            "transfer": "Bank transfer",
            "card": "Card",
            "payment_link": "Payment link",
            "other": "Other"
          },
          "kinds": {
            "charge": "Charge",
            "payment": "Payment",
            "credit": "Credit",
            "adjustment": "Adjustment",
            "refund": "Refund"
          },
          "statementHeading": "Account statement",
          "closing": "Balance",
          "sendToCustomer": "To reply box",
          "drafted": "Added to the reply box. Review it, then send.",
          "attachPdf": "Attach PDF",
          "pdfAttached": "PDF attached to the reply box. Review it, then press send.",
          "pdfFailed": "Could not create the PDF. Try again.",
          "pdfWindowClosed": "The 24-hour window is closed. Send an approved template first; the customer can then receive the statement once they reply."
        },
        "confirm": "Confirm",
        "back": "Back",
        "close": "Close",
        "orders": {
          "empty": "No orders or carts for this customer yet.",
          "error": "Could not load the orders.",
          "showLines": "Show items",
          "hideLines": "Hide items",
          "linesError": "Could not load the items.",
          "payment": {
            "prepaid": "Prepaid",
            "cod": "Cash on delivery"
          },
          "draftLink": "Cart link to reply box",
          "confirmLink": "Create the cart link and put it in the reply box? It is only a draft; you send it yourself.",
          "draft": "Here is your cart: {url}",
          "saveError": "Could not save. Try again.",
          "status": {
            "new": "New",
            "confirmed": "Confirmed",
            "paid": "Paid",
            "processing": "Preparing",
            "shipped": "Shipped",
            "delivered": "Delivered",
            "cancelled": "Cancelled",
            "refunded": "Refunded",
            "partially_refunded": "Partly refunded"
          },
          "cart": {
            "open": "Open cart",
            "sent": "Cart sent",
            "converted": "Became an order",
            "abandoned": "Abandoned cart"
          }
        },
        "tables": {
          "none": "No upcoming table reservations.",
          "error": "Could not load the reservations.",
          "new": "New table reservation",
          "service": "Table / area",
          "date": "Date",
          "notes": "Notes",
          "findSlots": "Show available times",
          "noSlots": "No times available that day.",
          "confirmNew": "Reserve a table on {when} for {n} guests?",
          "confirmMove": "Move the reservation to {when}?",
          "confirmCancel": "Cancel the reservation {what} on {when}?",
          "cancel": "Cancel reservation",
          "reschedule": "Change time",
          "saved": "Saved.",
          "saveError": "Could not save. Try again.",
          "putDraft": "Confirmation to reply box",
          "draft": "Your table is reserved: {when}.",
          "status": {
            "requested": "Requested",
            "confirmed": "Confirmed",
            "rescheduled": "Time changed",
            "cancelled": "Cancelled",
            "completed": "Done",
            "no_show": "Did not come"
          },
          "party": "Number of guests",
          "partyNote": "Guests: {n}",
          "next": "Next booking",
          "noShows": "{n, plural, =0 {No missed bookings} one {# missed booking} other {# missed bookings}}"
        },
        "appointments": {
          "contactFields": {
            "title": "Patient details",
            "birthDate": "Birth date",
            "allergies": "Allergies",
            "preferredStaff": "Preferred staff"
          },
          "none": "No upcoming appointment.",
          "error": "Could not load the appointments.",
          "new": "Book an appointment",
          "service": "Service",
          "date": "Date",
          "notes": "Notes",
          "findSlots": "Show available times",
          "noSlots": "No times available that day.",
          "confirmNew": "Book the appointment on {when}?",
          "confirmMove": "Move the appointment to {when}?",
          "confirmCancel": "Cancel the appointment {what} on {when}?",
          "cancel": "Cancel appointment",
          "reschedule": "Change time",
          "saved": "Saved.",
          "saveError": "Could not save. Try again.",
          "putDraft": "Confirmation to reply box",
          "draft": "Your appointment is booked: {when}.",
          "status": {
            "requested": "Requested",
            "confirmed": "Confirmed",
            "rescheduled": "Time changed",
            "cancelled": "Cancelled",
            "completed": "Done",
            "no_show": "Did not come"
          },
          "next": "Next appointment",
          "noShows": "{n, plural, =0 {No missed appointments} one {# missed appointment} other {# missed appointments}}",
          "party": "Number of guests",
          "partyNote": "Guests: {n}"
        },
        "flow": {
          "putDraft": "Insert",
          "product": {
            "search": "Search products",
            "none": "No approved products found.",
            "error": "Could not load the products.",
            "draft": "{name} {price}\n{image}"
          },
          "payLink": {
            "draft": "Here is your payment link for {description}: {url}"
          },
          "similar": {
            "error": "Could not load the listings.",
            "none": "No approved listing fits this customer.",
            "noCriteria": "No area, budget or property type saved: showing approved listings.",
            "windowClosed": "The 24-hour reply window is closed. Send an approved template instead.",
            "review": "Review",
            "confirm": "{n, plural, one {Put # listing in the reply box?} other {Put # listings in the reply box?}} Nothing is sent until you press Send.",
            "draft": "Properties that may suit you:\n{list}"
          }
        },
        "deal": {
          "empty": "No deals for this contact yet.",
          "error": "Could not load the deals.",
          "openValue": "Open deals value (per currency)",
          "stage": "Stage: {stage}",
          "total": "Open value by currency"
        },
        "vehicle": {
          "empty": "No jobs for this vehicle yet.",
          "error": "Could not load the vehicle.",
          "notSet": "Not set",
          "status": {
            "requested": "Requested",
            "confirmed": "Booked",
            "rescheduled": "Time changed",
            "cancelled": "Cancelled",
            "completed": "Done",
            "no_show": "Did not come"
          }
        }
      }
    },
    "bulk": {
      "label": "Bulk actions",
      "selected": "{count} selected",
      "assignTo": "Assign to",
      "close": "Close",
      "markRead": "Mark read",
      "addLabel": "Add label",
      "select": "Select conversation",
      "conflicts": "{count, plural, one {# conversation was} other {# conversations were}} already taken by someone else and left unchanged."
    },
    "search": {
      "label": "Search conversations",
      "placeholder": "Search…",
      "empty": "No matches.",
      "clear": "Clear"
    },
    "thread": {
      "label": "Message thread",
      "select": "Select a conversation to read it.",
      "empty": "No messages in this conversation yet.",
      "emptyHint": "Start the conversation by typing a reply below, or pick a ready template.",
      "loadOlder": "Load older messages",
      "back": "Back to conversations",
      "error": "Could not load messages.",
      "customer": "Customer",
      "backToThread": "Back",
      "noteLabel": "Internal note — the customer never sees this",
      "aiCreditsNote": "The AI did not reply because its balance ran out. Top up or reply manually.",
      "whisperLabel": "Internal whisper",
      "noteBy": "by {name}"
    },
    "window": {
      "open": "Reply window open",
      "closed": "Reply window closed"
    },
    "composer": {
      "sendOrderLink": "Order link",
      "sendBookingLink": "Booking link",
      "webLinkFailed": "Could not create the link.",
      "replyVia": "Replying via",
      "label": "Message composer",
      "product": "Product",
      "productTitle": "Send products",
      "productHeader": "Header (multi-product)",
      "productBody": "Message text (optional)",
      "productTemplate": "Carousel ready-made message",
      "productPickTemplate": "Choose an approved ready-made message",
      "productFailed": "Could not send the product message.",
      "productClose": "Close",
      "location": "Location",
      "locationTitle": "Send a location",
      "locationLat": "Latitude",
      "locationLng": "Longitude",
      "locationName": "Place name (optional)",
      "locationInvalid": "Enter a valid latitude (-90 to 90) and longitude (-180 to 180).",
      "locationFailed": "Could not send the location.",
      "contact": "Contact",
      "contactTitle": "Send a contact card",
      "contactName": "Contact name",
      "contactPhone": "Phone number (with country code)",
      "contactInvalid": "Enter a name and a phone number with country code.",
      "contactFailed": "Could not send the contact card.",
      "modeReply": "Reply to customer",
      "noteSave": "Save note",
      "noteInstead": "Internal note",
      "modeNote": "Internal note",
      "placeholder": "Type a message",
      "send": "Send",
      "sending": "Sending…",
      "sendFailed": "Could not send the message.",
      "closedNotice": "The 24-hour reply window is closed. Send an approved ready-made message to re-open the conversation.",
      "closedNoTemplates": "The 24-hour reply window is closed and this number cannot send ready-made messages.",
      "templatePicker": "Approved ready-made message",
      "templatePlaceholder": "Choose a message",
      "templateNone": "No approved ready-made messages for this number.",
      "templateCreate": "Create a quick ready-made message",
      "templateVariable": "Value {n}",
      "templatePreview": "Preview",
      "sendTemplate": "Send message",
      "windowRemaining": "Reply window closes in {time}",
      "windowExpired": "Reply window closed",
      "windowWarning": "Less than 5 minutes left in the 24-hour reply window.",
      "fmtLabel": "Formatting",
      "quickReplies": "Quick replies",
      "fmtBold": "Bold",
      "fmtItalic": "Italic",
      "fmtStrike": "Strikethrough",
      "fmtMono": "Monospace",
      "captionPlaceholder": "Add a caption (optional)",
      "attach": "Attach",
      "attachUploading": "Uploading…",
      "attachInput": "Attachment file",
      "attachRemove": "Remove",
      "attachTooLarge": "This file is too large for WhatsApp.",
      "attachUnsupported": "This file type is not supported. Use JPG, PNG, PDF or an Office document.",
      "attachUploadFailed": "Could not upload the file.",
      "voiceStart": "Record voice note",
      "voiceStop": "Send voice",
      "voiceCancel": "Cancel recording",
      "voiceDenied": "Microphone access was denied.",
      "voiceTooShort": "Recording too short.",
      "voiceTooLarge": "Voice note is too large.",
      "voiceQueued": "Voice note saved - it will send when you are back online.",
      "cannedLabel": "Canned replies",
      "cannedNone": "No matching canned replies.",
      "cannedVariable": "Value for {name}",
      "cannedInsert": "Insert",
      "cannedDismiss": "Dismiss",
      "blocked": "This contact is blocked. Unblock to send messages.",
      "tools": "Tools",
      "toolsLabel": "Composer tools",
      "more": "More tools",
      "schedule": "Send later",
      "scheduleTitle": "Send later",
      "scheduleHint": "The message is sent automatically at the chosen time if the 24-hour reply window is still open.",
      "scheduleAt": "Send at",
      "scheduleConfirm": "Schedule",
      "scheduleClose": "Close",
      "scheduleInvalid": "Choose a time in the future.",
      "scheduleFailed": "Could not schedule the message.",
      "scheduledList": "Scheduled messages",
      "scheduledTemplate": "Ready-made message",
      "scheduledCancel": "Cancel",
      "scheduledFailed": "Failed to send",
      "scheduledFailedWindow": "Reply window closed - an approved ready-made message is required",
      "includeSignature": "Signature",
      "numberOffline": "This WhatsApp number is offline. Reconnect it from Channels before replying.",
      "numberOfflineAction": "Open Channels",
      "quickTemplatesLabel": "Send in one click",
      "quickTemplateSend": "Send “{name}”",
      "windowBarLabel": "Time left to reply freely",
      "qrLimits": {
        "short": "This number (WhatsApp by QR scan) sends text, photos and files only.",
        "why": "Why?",
        "hide": "Hide",
        "noInteractive": "Buttons, lists, forms, ready messages and product cards need your official WhatsApp number.",
        "noWindow": "There is no 24-hour limit here, but only message customers who wrote to you first.",
        "official": "To send offers or reminders to new customers, connect your official WhatsApp number in Channels."
      },
      "productDraftRemove": "Remove product",
      "productSectionTitle": "Section title (optional)",
      "productSectionTitleTooLong": "The section title can be at most {max} characters.",
      "productTooManyItems": "At most {max} products can be sent in one message.",
      "productButtonTitle": "Button label (optional, max 20 characters)",
      "productErrors": {
        "PRODUCT_URL_MISSING": "A selected product has no page link. Add the product link in your store, then try again.",
        "PRODUCT_SECTION_TITLE_TOO_LONG": "A section title is longer than 24 characters. Shorten it.",
        "PRODUCT_LIST_TOO_MANY_ITEMS": "A product list can have at most 30 products.",
        "PRODUCT_LIST_TOO_MANY_SECTIONS": "A product list can have at most 10 sections.",
        "CATALOG_MESSAGE_BODY_REQUIRED": "A catalog message needs a message text.",
        "CATALOG_MESSAGE_BODY_TOO_LONG": "The catalog message text is too long. Shorten it.",
        "CATALOG_MESSAGE_FOOTER_TOO_LONG": "The catalog message footer is too long. Shorten it.",
        "CATALOG_MESSAGE_THUMBNAIL_INVALID": "The thumbnail product is not valid. Leave it empty or pick a product from the catalog.",
        "IG_PRODUCT_TITLE_REQUIRED": "The product needs a name to be sent on Instagram.",
        "IG_PRODUCT_URL_INVALID": "The product link is not valid. It must be a public link starting with https.",
        "IG_PRODUCT_IMAGE_REQUIRED": "The product needs an image to be sent on Instagram.",
        "IG_PRODUCT_IMAGE_INVALID": "The product image link is not valid. It must be a public link starting with https.",
        "IG_PRODUCT_BUTTON_TITLE_REQUIRED": "The button label is required.",
        "IG_PRODUCT_CAROUSEL_EMPTY": "There are no products to send on Instagram.",
        "IG_PRODUCT_CAROUSEL_TOO_MANY": "At most 10 products can be sent in one Instagram message.",
        "PRODUCT_CATALOG_NOT_LINKED": "This channel has no linked catalog. Link a catalog in Catalog settings, then try again.",
        "PRODUCT_SET_NOT_FOUND": "The selected product set was not found. Pick another set or refresh the list.",
        "PRODUCT_SET_TOO_FEW_ITEMS": "The selected product set has too few products to send as a list. Add more products to the set or pick products one by one.",
        "PRODUCT_NOT_IN_CATALOG": "A selected product is not in the linked catalog. Refresh the catalog and choose the product again.",
        "CHANNEL_CAPABILITY_MISSING": "This number can't send this kind of product message. Use your official WhatsApp number."
      },
      "toolsSheetTitle": "Tools",
      "interactiveTile": "Buttons & lists",
      "qrUnsupported": "Not available on this number",
      "sendHint": "Enter to send, Shift+Enter for a new line"
    },
    "bubble": {
      "image": "Image",
      "video": "Video",
      "audio": "Voice message",
      "document": "Document",
      "sticker": "Sticker",
      "location": "Location",
      "template": "Ready-made message",
      "interactive": "Message with buttons or a list",
      "unknown": "Unsupported message",
      "attachmentOpen": "Instagram attachment — open",
      "mediaUnavailable": "Media unavailable",
      "contact": "Contact card",
      "share": {
        "post": "Instagram post",
        "reel": "Reel",
        "story": "Reply to your story",
        "mention": "Story mention",
        "link": "Link",
        "open": "Open in Instagram",
        "thumbnail": "Preview of the shared content",
        "product": "Instagram product",
        "openProduct": "Open product"
      },
      "deleted": "This message was deleted",
      "reactions": "Reactions",
      "reactionCustomer": "Reaction from the customer",
      "reactionTeam": "Reaction from your team",
      "react": "React",
      "reactPicker": "Choose a reaction",
      "reactWith": "React with {emoji}",
      "reactRemove": "Remove my reaction",
      "reactFailed": "Could not send the reaction. Try again.",
      "edited": "edited",
      "editHistory": "Previous versions",
      "deletedOriginal": "Original before deletion",
      "botBadge": "Auto-reply",
      "aiBadge": "AI",
      "agentBadge": "Agent",
      "phoneAppBadge": "Sent from phone app",
      "failed": "Failed to send",
      "failedReason": "Failed: {reason}",
      "reasonWindowClosed": "The 24-hour window is closed, so a normal message cannot be sent; send an approved template.",
      "status": {
        "queued": "Queued",
        "sent": "Sent",
        "delivered": "Delivered",
        "read": "Read",
        "failed": "Failed",
        "dlq": "Failed",
        "blocked": "Blocked"
      },
      "openMedia": "Open {kind}",
      "closeLightbox": "Close",
      "interactiveOptions": "Options in this message",
      "readOnlyNote": "This is a read-only copy of what the customer received; buttons and options are tapped by the customer on their phone, not here.",
      "readOnlyListNote": "These options are for viewing only, as the customer saw them; the customer picks one on their phone, you cannot select them here.",
      "actionableNote": "Tap a button to send that choice on the customer's behalf.",
      "actionableListNote": "Tap an option to send it on the customer's behalf.",
      "chooseConfirmTitle": "Send a choice as the customer",
      "chooseConfirmMessage": "\"{title}\" will be recorded as the customer's reply and the automation will continue from it. Send it?",
      "chooseConfirm": "Send choice",
      "chooseFailed": "Could not send the choice. Try again.",
      "chooseWindowClosed": "The 24-hour window of this conversation is closed, so the choice cannot be sent.",
      "chooseOptedOut": "This customer opted out of messages, so the choice cannot be sent.",
      "viewOptions": "View options",
      "phoneOnly": "Opens on phone",
      "order": {
        "title": "Order from WhatsApp cart",
        "quantity": "×{count}",
        "noItems": "No items in this order",
        "total": "Total",
        "note": "Customer note:",
        "open": "Open orders"
      },
      "referredProduct": {
        "label": "Asked about this product"
      },
      "longPressHint": "Long-press to react or reply",
      "actions": "Message actions",
      "copy": "Copy",
      "details": "Details",
      "prospectorBadge": "Prospector"
    },
    "savedViews": {
      "title": "Saved views",
      "empty": "No views.",
      "filters": "Filters",
      "status": "Filter by status",
      "assignee": "Filter by assignee",
      "any": "Any",
      "me": "Me",
      "unassigned": "Unassigned",
      "unread": "Unread only",
      "nameLabel": "View name",
      "namePlaceholder": "Name this view",
      "shared": "Share with team",
      "save": "Save as view",
      "delete": "Delete view {name}",
      "sharedBadge": "Shared",
      "failed": "Could not save the view.",
      "waitingOver1h": "Waiting over 1 hour for a reply"
    },
    "presence": {
      "viewing": "{count, plural, one {Another agent is viewing this conversation} other {# other agents are viewing this conversation}}",
      "softLock": "Another agent is typing a reply. Check before you send.",
      "typing": "typing..."
    },
    "call": {
      "duration": "Call · {minutes}m {seconds}s",
      "play": "Play recording",
      "noRecording": "No recording",
      "transcript": "Written transcript",
      "showTranscript": "Show transcript",
      "hideTranscript": "Hide transcript",
      "disclaimer": "AI transcript, may contain errors",
      "recordingToggle": "Record calls",
      "recordingToggleHelp": "Off by default. Calls are recorded only when you turn this on and the feature is available for your account.",
      "legalDisclosure": "Recording laws differ by market. Customers are told calls may be recorded in the call-permission request. Enable only after confirming your obligations.",
      "legalPending": "Pending legal review in your market"
    },
    "voice": {
      "pending": "Turning the voice note into text…",
      "partial": "Turning into text…",
      "lowConfidence": "Low confidence",
      "corrected": "Corrected",
      "correct": "Correct",
      "save": "Save",
      "cancel": "Cancel",
      "sttOff": "Voice understanding is off.",
      "sttOffAction": "Turn it on"
    },
    "counters": {
      "label": "Counters",
      "unread": "Unread",
      "mine": "Mine",
      "unassigned": "Unassigned"
    },
    "channelTabs": {
      "label": "Channels",
      "all": "All",
      "qr": "QR",
      "official": "Official",
      "instagram": "Instagram",
      "messenger": "Messenger",
      "webchat": "Web chat",
      "groups": "Groups"
    },
    "preview": {
      "image": "Photo",
      "video": "Video",
      "audio": "Voice message",
      "document": "File",
      "sticker": "Sticker",
      "location": "Location",
      "contacts": "Contact",
      "share_post": "Instagram post",
      "share_reel": "Reel",
      "share_story": "Reply to your story",
      "share_mention": "Story mention",
      "share_link": "Link",
      "share": "Shared content",
      "template": "Ready-made message",
      "interactive": "Message with buttons or a list",
      "interactive_buttons": "Message with buttons",
      "interactive_list": "Choice list",
      "button": "Button reply",
      "reaction": "Reaction",
      "order": "Order",
      "unknown": "Message",
      "text": "Message",
      "generic": "Message",
      "share_product": "Instagram product"
    },
    "channelFilter": {
      "showDisconnected": "Show disconnected numbers",
      "label": "Channel",
      "all": "All channels",
      "listLabel": "Choose a channel",
      "chip": "Channel: {value}",
      "clear": "Clear channel filter",
      "empty": "No conversations on this channel yet",
      "emptyHint": "Try another channel.",
      "unnamed": "Unnamed account"
    },
    "groupsPage": {
      "title": "Groups",
      "subtitle": "WhatsApp groups your QR numbers receive. Replies are written by your team.",
      "receiveTitle": "Receive groups",
      "receiveOn": "On",
      "receiveOff": "Off",
      "offExplain": "Group messages are not reaching your inbox for this number.",
      "enable": "Turn on group messages",
      "enableNote": "After turning it on, new group messages arrive; older group history needs a re-import.",
      "saving": "Saving…",
      "noQrTitle": "Connect a QR number to receive groups",
      "noQrBody": "Groups work only on WhatsApp numbers linked by QR code.",
      "noQrCta": "Connect a QR number",
      "empty": "No group conversations yet",
      "emptyOn": "New group messages will appear here.",
      "emptyOff": "Turn on group messages for a number to start receiving them.",
      "loading": "Loading groups…",
      "error": "Could not load groups.",
      "lastMessage": "Last message",
      "members": "{count, plural, one {# member} other {# members}}",
      "open": "Open group: {name}",
      "openInbox": "Open in inbox",
      "unnamed": "Unnamed group",
      "loadMore": "Load more"
    },
    "group": {
      "badge": "Group",
      "replyNote": "Your reply goes to everyone in the group",
      "panelTitle": "Group info",
      "panelHint": "This is a WhatsApp group. Replies are manual only and reach every member."
    },
    "tasks": {
      "title": "Tasks",
      "add": "Add",
      "titleLabel": "Task title",
      "dueLabel": "Due (optional)",
      "save": "Save task",
      "cancel": "Cancel",
      "empty": "No open tasks for this customer.",
      "markDone": "Mark done: {name}",
      "error": "Could not save the task. Try again."
    },
    "linkPreview": {
      "open": "Open link preview"
    },
    "aiLabels": {
      "title": "Suggested labels",
      "confidence": "{value}%",
      "accept": "Apply label {name}",
      "dismiss": "Dismiss suggested label {name}"
    },
    "ownPanel": {
      "aiHelper": {
        "title": "AI helper",
        "analyze": "Analyze conversation",
        "reanalyze": "Re-analyze",
        "analyzing": "Analyzing…",
        "intent": "Intent",
        "sentiment": "Sentiment",
        "urgency": "Urgency",
        "nextAction": "Next action",
        "sentimentValues": {
          "positive": "Positive",
          "neutral": "Neutral",
          "negative": "Negative"
        },
        "urgencyValues": {
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "helpMeReply": "Help me reply",
        "askPlaceholder": "Ask about this customer or chat…",
        "ask": "Ask",
        "asking": "Thinking…",
        "insert": "Insert",
        "draftNote": "Draft only. Review it before you send.",
        "off": "AI suggestions are turned off for this workspace.",
        "budget": "The AI budget for this workspace is used up.",
        "failed": "Could not get an AI answer. Try again."
      },
      "tasksHint": "Follow-ups, e.g. \"call tomorrow\".",
      "tasksCount": "Tasks ({count})",
      "addTaskShort": "+ Task",
      "showAll": "Show all",
      "summary": {
        "refresh": "Refresh",
        "more": "More",
        "less": "Less",
        "updatedAt": "Updated {time}",
        "stale": "new messages since",
        "failed": "Could not summarise this chat. Try again.",
        "details": "Handoff details and sources"
      },
      "order": {
        "qtyMinus": "Decrease quantity",
        "qtyPlus": "Increase quantity",
        "quoteTitle": "Quote {number}",
        "quoteLine": "{qty} × {name} — {amount}",
        "quoteTotal": "Total: {total} (VAT {tax}) — subject to approval"
      }
    },
    "shortcuts": {
      "title": "Keyboard shortcuts",
      "move": "Next / previous conversation",
      "open": "Open the conversation / focus the composer",
      "resolve": "Mark as done",
      "assign": "Assign to me",
      "note": "Internal note",
      "reply": "Focus the composer",
      "snooze": "Follow-up task tomorrow at 9:00",
      "quick": "Send the matching quick reply",
      "send": "Send the message",
      "back": "Back to the list",
      "help": "This cheat sheet",
      "disable": "Turn off keyboard shortcuts",
      "close": "Close",
      "tip": "Press ? for shortcuts",
      "dismiss": "Dismiss",
      "snoozed": "Follow-up task added for tomorrow at 9:00",
      "snoozeFailed": "The task could not be added. Try again."
    },
    "triage": {
      "resolved": "Conversation marked as done",
      "assigned": "Conversation assigned to you",
      "failed": "That did not work. Try again from the conversation menu.",
      "hintTitle": "Shortcuts:",
      "hintMove": "next / previous",
      "hintResolve": "mark as done",
      "hintAssign": "assign to me"
    },
    "viewTabs": {
      "savedLabel": "Your saved views",
      "unreadBadge": "{count} unread"
    },
    "takeover": {
      "title": "AI paused",
      "cloudTitle": "Auto-reply paused",
      "cloudManualResume": "Auto-reply stays off until you give the chat back.",
      "cloudAutoResume": "{minutes, plural, one {Auto-reply resumes after # more minute} other {Auto-reply resumes after # more minutes}} if the customer writes again.",
      "cloudGiveBack": "Resume",
      "elapsed": "{minutes, plural, one {# minute} other {# minutes}} ago",
      "manualResume": "The AI stays off until you give the chat back.",
      "cloudHint": "Auto-reply is paused: customer keywords and button replies still run; other messages get no automatic answer.",
      "autoResume": "{minutes, plural, one {AI resumes after # more minute} other {AI resumes after # more minutes}} if the customer writes again.",
      "giveBack": "Resume",
      "giveBackLabel": "Give back to AI",
      "cloudGiveBackLabel": "Give back to auto-reply",
      "resumeInfo": "Resume details",
      "elapsedHours": "{hours, plural, one {# hour} other {# hours}} ago",
      "elapsedDays": "{days, plural, one {# day} other {# days}} ago",
      "elapsedNow": "Just now"
    },
    "priority": {
      "label": "Priority",
      "chip": "Priority: {value}",
      "none": "No priority",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "urgent": "Urgent"
    },
    "filters": {
      "unattended": "Unattended (customer waiting)",
      "longestWaiting": "Longest waiting first",
      "labels": "Labels"
    },
    "b29": {
      "panel": {
        "controlTitle": "Control",
        "actionsTitle": "Actions"
      },
      "reminder": {
        "inWeek": "In a week",
        "notePlaceholder": "e.g. Talk to him about the December trip"
      },
      "otherNumbers": {
        "title": "The same customer also wrote to you on:"
      },
      "search": {
        "hint": "Search name, phone or message"
      }
    }
  },
  "pwa": {
    "install": {
      "title": "Install Wato",
      "body": "Add Wato to your home screen for quick, full-screen access.",
      "action": "Install the app",
      "iosTitle": "Add to Home Screen",
      "iosStepShare": "Tap the Share button in Safari",
      "iosStepAdd": "Choose “Add to Home Screen”, then “Add”",
      "dismiss": "Dismiss"
    },
    "push": {
      "enable": "Turn on notifications",
      "enabled": "Notifications are on",
      "deniedTitle": "Notifications are blocked",
      "deniedBody": "We will show an unread badge in the app instead. You can allow notifications in your browser settings.",
      "ok": "Got it",
      "disable": "Turn off notifications",
      "assignedTitle": "Conversation assigned to you",
      "inboundTitle": "New message from a customer",
      "testTitle": "Test notification",
      "testBody": "Notifications work on this device.",
      "mentionedTitle": "You were mentioned",
      "createdTitle": "New conversation",
      "slaBreachedTitle": "Reply time exceeded",
      "slaFirstResponseBody": "{name}: the first reply is overdue",
      "slaResolutionBody": "{name}: the resolution target was missed",
      "eventBody": "{name}",
      "unknownContact": "A customer",
      "unsupported": "Notifications are not supported on this device."
    },
    "device": {
      "title": "Notifications on this device",
      "test": "Send a test notification",
      "testSent": "Test notification sent.",
      "testNone": "Nothing was delivered. Turn notifications off and on again.",
      "denied": "Notifications are blocked in this browser. Allow them in the site settings, then come back and turn them on.",
      "error": "Something went wrong. Please try again.",
      "serverOff": "Phone notifications aren't switched on for this account yet. You will still see new messages in the bell and the inbox.",
      "hideHint": "Hide",
      "installHint": "On iPhone, add the app to your Home Screen first, then turn notifications on."
    },
    "offline": {
      "pendingSend": "Pending send",
      "approvalPendingSync": "Approval pending sync",
      "synced": "Synced",
      "failed": "Couldn't sync",
      "conflictTitle": "Already resolved",
      "conflictBody": "Another manager already decided this quote. Your screen now shows the current state.",
      "dismiss": "Dismiss"
    },
    "ownerSummary": {
      "title": "Yesterday at a glance",
      "open": "Open yesterday's summary",
      "conversations": "New conversations",
      "messagesSent": "Messages sent",
      "messagesReceived": "Messages received",
      "automationRate": "Automation rate",
      "revenue": "Revenue"
    },
    "updateRequired": {
      "title": "Update required",
      "body": "This version of the app is no longer supported. Please update from the store to continue.",
      "action": "Update now"
    }
  },
  "flows": {
    "b29nodes": {
      "form": {
        "edit": "Edit form",
        "waitLabel": "Wait for the answer",
        "waitHour": "1 hour",
        "waitDay": "1 day",
        "waitThreeDays": "3 days"
      },
      "clicks": {
        "tooltip": "{window}: {percent}% of visitors chose this"
      },
      "goto": {
        "scope": "Where to go",
        "sameFlow": "Same flow",
        "otherFlow": "Another flow",
        "search": "Search steps",
        "pickCanvas": "Pick from canvas",
        "picking": "Click a step…",
        "missing": "The target step was deleted. Pick another."
      },
      "labelByOption": "🏷 Label the customer with the button they choose",
      "editLabel": "Edit label",
      "labelColor": "Label colour",
      "createLabel": "＋ New label",
      "ownLabel": "Label",
      "unsupportedStep": "⚠ A step from the old platform isn't supported: {type}"
    },
    "nodeTypes": {
      "trigger": "Flow trigger",
      "travel_booking_status": "Travel booking status",
      "keyword": "Starts on keyword",
      "welcome": "Starts on first message",
      "button_payload": "Starts on button tap",
      "unknown": "Step",
      "ai_agent_session": "Hand to AI agent",
      "ai_classify_intent": "AI intent router",
      "ai_extract": "AI extract",
      "ai_reply": "AI reply",
      "ask_question": "Ask question",
      "assign_handoff": "Assign / handoff",
      "booking_actions": "Booking actions",
      "cart_actions": "Cart actions",
      "close_snooze": "Close / snooze",
      "condition": "Condition",
      "contact_card": "Contact card",
      "create_task": "Create task",
      "cta_url": "CTA URL button",
      "end": "End",
      "generate_voucher": "Generate voucher",
      "go_to": "Go to",
      "google_doc_pdf": "Send Google Doc as PDF",
      "google_doc_write": "Write to Google Doc",
      "google_sheets_row": "Google Sheets row",
      "google_sheets_find_row": "Google Sheets: find row",
      "http_request": "HTTP request",
      "interactive_buttons": "Reply buttons",
      "interactive_list": "List",
      "location_request": "Request location",
      "location_send": "Send location",
      "manual_rebuild_needed": "Manual rebuild needed",
      "media": "Media",
      "media_image": "Image",
      "media_audio": "Audio",
      "media_video": "Video",
      "media_document": "File",
      "media_carousel": "Media carousel",
      "notify_team": "Notify team",
      "product_message": "Product / Catalog",
      "question_group": "Question group",
      "quote_actions": "Quote actions",
      "randomizer": "Randomizer",
      "reaction": "Emoji reaction",
      "send_webhook": "Send to an external system",
      "sequence_subscribe": "Sequence subscribe",
      "split_test": "Split test",
      "store_products_card": "Store product card",
      "sub_flow": "Sub-flow",
      "switch": "Switch",
      "template_message": "Template message",
      "text": "Text",
      "label": "Label",
      "update_contact": "Update customer data",
      "wait_delay": "Wait / Delay",
      "wait_for_event": "Wait for event",
      "whatsapp_form": "WhatsApp form"
    },
    "nav": "Chat flows",
    "page": {
      "title": "Chat flow builder",
      "subtitle": "Design automated conversations on the canvas. Every node comes from the node registry.",
      "loadError": "Couldn't load the node catalog."
    },
    "channel": {
      "label": "Preview for channel",
      "whatsapp_cloud": "WhatsApp Official (Cloud API)",
      "whatsapp_waha": "WhatsApp QR",
      "instagram": "Instagram"
    },
    "category": {
      "message": "Messages",
      "logic": "Logic",
      "action": "Actions",
      "ai": "AI"
    },
    "editor": {
      "back": "All flows",
      "backTitle": "Back to the flow list",
      "tryTitle": "Try the flow as a customer before publishing",
      "nameLabel": "Flow name",
      "nameHint": "Click to rename",
      "renameFailed": "Could not rename. Try again.",
      "statusDraft": "Draft",
      "statusPublished": "Published",
      "statusDraftTitle": "Not published yet; customers do not receive it",
      "statusPublishedTitle": "Published and running for customers",
      "toolsGroup": "Canvas tools",
      "actionsGroup": "Flow actions",
      "more": "More",
      "openNewTab": "Open in new tab",
      "showPanels": "Show panels",
      "hidePanels": "Hide panels",
      "untitled": "Untitled flow",
      "unsaved": "You have unsaved changes. Leave anyway?",
      "channel": "WhatsApp Cloud API",
      "leaveTitle": "Leave editor",
      "leave": "Leave",
      "previewInstagram": "Instagram",
      "previewInstagramNote": "Previewing for Instagram: steps Instagram cannot show are flagged in the flow check.",
      "instagramToo": "This flow is for Instagram too",
      "previewChannel": "Preview channel",
      "previewCloud": "Cloud API",
      "previewQr": "QR",
      "previewCloudNote": "Flows run on the official WhatsApp Cloud API.",
      "previewQrNote": "Flows do not run on WhatsApp QR — only the AI Agent answers there.",
      "qrBlockedTitle": "These steps can't run on WhatsApp QR:",
      "qrBlockedHint": "A flow aimed at WhatsApp QR can't be saved while it has them.",
      "channelWhatsapp": "WhatsApp (official)",
      "channelInstagram": "Instagram",
      "channelMixed": "WhatsApp + Instagram",
      "mixedNotice": "This flow mixes two channels and some steps cannot run on one of them. Each flow should serve a single channel.",
      "cloneToInstagram": "Copy to Instagram",
      "cloneToWhatsapp": "Copy to WhatsApp",
      "mixedDismiss": "Later",
      "cloneFailed": "Could not copy. Try again."
    },
    "mobile": {
      "listLabel": "Flow steps",
      "step": "Step {n}",
      "backTo": "Back to step {n}",
      "add": "+ Step",
      "addTitle": "Add a step",
      "addHere": "Add a step here",
      "branchEmpty": "Nothing after this yet",
      "deleteTitle": "Delete this step?",
      "deleteConfirm": "“{name}” will be removed and its neighbours reconnected.",
      "readOnly": "Edit this step on a larger screen.",
      "detached": "Not connected",
      "branch": "If: {name}"
    },
    "palette": {
      "title": "Nodes",
      "search": "Search",
      "empty": "No results",
      "hint": "Click or drag to add a step.",
      "igHint": "Templates, product catalog, forms, location and files are WhatsApp only and stay disabled here. Lists and buttons are sent as Instagram quick replies.",
      "igFlowHint": "Buttons and lists are sent as Instagram quick replies (up to 13).",
      "whatsappOnly": "WhatsApp only",
      "group": {
        "essentials": "Essentials",
        "messages": "Messages",
        "collect": "Collect data",
        "interactive": "Interactive",
        "logic": "Logic",
        "ai": "AI",
        "actions": "Actions",
        "google": "Google",
        "developers": "For developers"
      },
      "collapse": "Hide nodes",
      "expand": "Show nodes",
      "igInfo": "Instagram",
      "tile": {
        "trigger": "Start",
        "text": "Text",
        "media_image": "Image",
        "media_audio": "Audio",
        "media_video": "Video",
        "media_document": "File",
        "interactive_buttons": "Buttons",
        "ask_question": "Question",
        "end": "End",
        "template_message": "Template",
        "contact_card": "Contact",
        "location_send": "Location",
        "cta_url": "Link",
        "reaction": "Reaction",
        "media_carousel": "Carousel",
        "question_group": "Questions",
        "whatsapp_form": "Form",
        "location_request": "Ask location",
        "interactive_list": "List",
        "product_message": "Product",
        "store_products_card": "Product card",
        "condition": "Condition",
        "switch": "Switch",
        "wait_delay": "Wait",
        "wait_for_event": "Event",
        "go_to": "Go to",
        "sub_flow": "Sub-flow",
        "randomizer": "Random",
        "split_test": "A/B",
        "ai_reply": "AI reply",
        "ai_classify_intent": "Intent",
        "ai_extract": "Extract",
        "ai_agent_session": "Assistant",
        "update_contact": "Update customer",
        "label": "Label",
        "sequence_subscribe": "Sequence",
        "close_snooze": "Close",
        "notify_team": "Notify",
        "assign_handoff": "Handoff",
        "create_task": "Task",
        "generate_voucher": "Voucher",
        "cart_actions": "Cart",
        "quote_actions": "Quote",
        "booking_actions": "Booking",
        "http_request": "Request",
        "send_webhook": "External system",
        "google_sheets_row": "Row",
        "google_sheets_find_row": "Find row",
        "google_doc_write": "Document",
        "google_doc_pdf": "PDF"
      }
    },
    "support": {
      "blocked": "Not available on this channel",
      "degraded": "Reduced on this channel",
      "missing": "Needs: {capabilities}"
    },
    "canvas": {
      "label": "Flow canvas",
      "deleteEdge": "Remove connection",
      "startWith": "Or start with a step:",
      "empty": "The canvas is empty. Add a node from the palette or press / to search.",
      "nodeCount": "{count, plural, one {# node} other {# nodes}}",
      "deleteNode": "Delete step",
      "fillStep": "Click to fill in this step",
      "otherOutput": "Anything else",
      "unnamedOutput": "Option {n}",
      "copyNode": "Duplicate step",
      "copy": "Copy",
      "paste": "Paste",
      "pasteSkippedTrigger": "Some steps were not pasted: a flow has only one start card.",
      "deleteConfirm": "This step contains other steps. Delete it anyway?"
    },
    "heatmap": {
      "insight": "{percent} of customers leave at {node}.",
      "hover": "{entered} entered → {continued} continued ({percent})",
      "badge": "{percent} continue",
      "tip_ask": "Try making this question optional or adding an example answer.",
      "tip_buttons": "Try shortening the message.",
      "tip_wait": "Try sending a reminder while waiting.",
      "tip_generic": "Review the message and what comes next."
    },
    "b29layout": {
      "arrange": "Arrange",
      "horizontal": "Horizontal layout",
      "vertical": "Vertical layout"
    },
    "toolbar": {
      "fitTitle": "Show the whole flow on screen",
      "layoutTitle": "Arrange the steps automatically",
      "fit": "Fit to screen",
      "minimap": "Minimap"
    },
    "picker": {
      "nextTitle": "Add next step",
      "hereTitle": "Add node here",
      "search": "Search nodes",
      "empty": "No node can follow here",
      "close": "Close"
    },
    "command": {
      "title": "Add a node",
      "placeholder": "Type to search nodes",
      "recent": "Recent",
      "empty": "No matching nodes"
    },
    "list": {
      "title": "Chat flows",
      "subtitle": "Create, organise and open your chatbot flows.",
      "back": "All flows",
      "create": "New chat flow",
      "nameLabel": "Flow name",
      "folderLabel": "Folder",
      "folderAll": "All folders",
      "searchLabel": "Search",
      "statusLabel": "Status",
      "statusAll": "Any status",
      "status_draft": "Draft",
      "status_published": "Published",
      "colName": "Name",
      "colFolder": "Folder",
      "colStatus": "Status",
      "colRuns": "Runs",
      "colUpdated": "Updated",
      "open": "Open",
      "rename": "Rename",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteConfirm": "Delete the flow \"{name}\"? It can be restored by support for 30 days.",
      "empty": "No flows yet.",
      "noFolder": "No folder",
      "tagLabel": "Tag",
      "tagAll": "All tags",
      "colTags": "Tags",
      "noTags": "No tags",
      "renameFolder": "Rename…",
      "createFolder": "Create",
      "removeFolder": "Delete folder",
      "folderName": "New folder name",
      "exportJson": "Export",
      "copyId": "Copy ID",
      "idCopied": "ID copied",
      "selectRow": "Select {name}",
      "selectAll": "Select all",
      "selected": "{count} selected",
      "bulkEnable": "Enable",
      "bulkDisable": "Disable",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "colEnabled": "On",
      "exportFailed": "Could not export the flow.",
      "clone": "Clone",
      "cloneName": "{name} (copy)",
      "moveToFolder": "Move to…",
      "deleteFolder": "Delete empty folder",
      "newFolder": "New folder…",
      "unpublish": "Unpublish",
      "unpublishTitle": "Unpublish flow",
      "unpublishConfirm": "Unpublish \"{name}\"? It stops running now; the draft and its history are kept.",
      "deleteTitle": "Delete flow",
      "filter": "Filter",
      "folders": "Folders",
      "folderDeleteBody": "Delete this folder? Its flows move to Uncategorised.",
      "removeFilter": "Remove {label}",
      "colRunsTip": "Last 7 days",
      "conflictTip": "Trigger conflict",
      "moveTitle": "Move to folder",
      "folderDialogName": "Folder name"
    },
    "nodes": {
      "text": {
        "body": "Message text",
        "delaySeconds": "Delay (seconds)",
        "typingIndicator": "Show typing indicator",
        "linkPreview": "Link preview",
        "quickReplies": "Quick replies (optional, max 10; 3 or fewer as buttons)",
        "quickRepliesIg": "Quick replies (optional, Instagram: max 13, title max 20 characters)"
      },
      "reaction": {
        "emoji": "Emoji"
      },
      "randomizer": {
        "variants": "Weighted variants"
      },
      "condition": {
        "mode": "Match",
        "rules": "Rules"
      },
      "switch": {
        "field": "Field",
        "branches": "Branches"
      },
      "split_test": {
        "variants": "Weighted variants",
        "saveToField": "Save variant to contact field"
      },
      "wait_delay": {
        "mode": "Mode",
        "amount": "Amount",
        "unit": "Unit",
        "field": "Date-time field"
      },
      "wait_for_event": {
        "event": "Event",
        "timeoutMinutes": "Timeout (minutes)"
      },
      "travel_booking_status": {
        "maxBookings": "Bookings to show"
      },
      "go_to": {
        "targetFlowId": "Target flow",
        "targetNodeId": "Target node"
      },
      "sub_flow": {
        "targetFlowId": "Target flow",
        "returnToCaller": "Return to caller"
      },
      "end": {
        "closeConversation": "Close conversation"
      },
      "manual_rebuild_needed": {
        "originalConfigText": "Original source configuration (read-only)"
      },
      "media": {
        "mediaType": "Media type",
        "sourceMode": "Source",
        "source": "Media id or URL",
        "caption": "Caption",
        "filename": "Filename",
        "limitHint": "Max {size} MB · {formats}"
      },
      "interactive_buttons": {
        "header": "Header",
        "body": "Body",
        "footer": "Footer",
        "buttons": "Buttons (max 3)",
        "buttonsIg": "Quick replies (Instagram: max 13, title max 20 characters)"
      },
      "interactive_list": {
        "header": "Header",
        "body": "Body",
        "footer": "Footer",
        "buttonLabel": "Button label",
        "sections": "Sections and rows (max 10 rows)",
        "saveSelectionTo": "Save selection to variable"
      },
      "cta_url": {
        "header": "Header",
        "body": "Body",
        "footer": "Footer",
        "buttonLabel": "Button label",
        "url": "URL",
        "trackedLink": "Tracked short link",
        "whatsappHandoff": "Continue on WhatsApp (Instagram)"
      },
      "media_carousel": {
        "body": "Intro text",
        "cards": "Cards (2-10)"
      },
      "product_message": {
        "linkLead": "Browse our products and order here:",
        "linkUnavailable": "The order link is not available on this channel",
        "channelFallbackHint": "On QR and Instagram channels the order link is sent instead of a product message.",
        "variant": "Variant",
        "catalogId": "Catalog id",
        "header": "Header",
        "body": "Body",
        "footer": "Footer",
        "productId": "Product id (single product)",
        "sections": "Sections (max 10, 30 products)",
        "thumbnailProductId": "Thumbnail product id",
        "productSetId": "Product set id (multi-product / carousel)",
        "templateName": "Carousel template name",
        "templateLanguage": "Carousel template language"
      },
      "store_products_card": {
        "productRef": "Product reference",
        "title": "Title",
        "imageUrl": "Image URL",
        "price": "Price",
        "body": "Description",
        "buttonLabel": "Button label",
        "buttonUrl": "Button URL"
      },
      "location_send": {
        "latitude": "Latitude",
        "longitude": "Longitude",
        "name": "Place name",
        "address": "Address"
      },
      "location_request": {
        "saveTo": "Save location to",
        "saveToField": "Customer field to save to",
        "prompt": "Prompt",
        "timeoutSeconds": "Timeout (seconds)"
      },
      "contact_card": {
        "formattedName": "Display name",
        "firstName": "First name",
        "lastName": "Last name",
        "phone": "Phone (with country code)",
        "email": "Email",
        "company": "Company",
        "title": "Job title"
      },
      "whatsapp_form": {
        "saveTo": "Save answers to",
        "mappings": "Answer mapping",
        "formId": "Form (its id in Meta)",
        "header": "Header",
        "body": "Body",
        "footer": "Footer",
        "cta": "Button label",
        "screen": "First screen id",
        "timeoutSeconds": "Timeout (seconds)"
      },
      "template_message": {
        "templateId": "Template",
        "templateName": "Template name",
        "language": "Language",
        "category": "Category",
        "variables": "Variable mapping"
      },
      "ask_question": {
        "prompt": "Question",
        "answerType": "Expected answer",
        "min": "Min",
        "max": "Max",
        "choices": "Choices",
        "pattern": "Regex pattern",
        "retryMessage": "Retry message",
        "maxRetries": "Max retries",
        "timeoutSeconds": "Timeout (seconds)",
        "skipKeyword": "Skip keyword",
        "saveTo": "Save to variable",
        "saveToField": "Save to contact field"
      },
      "question_group": {
        "questions": "Questions (ordered)"
      },
      "http_request": {
        "method": "Method",
        "url": "URL",
        "query": "Query parameters",
        "headers": "Headers",
        "body": "Request content (JSON)",
        "auth": "Authentication",
        "timeoutMs": "Timeout (ms)",
        "mappings": "Response mapping"
      },
      "send_webhook": {
        "url": "URL",
        "headers": "Headers",
        "body": "Alert content (JSON)",
        "secretRef": "Signing secret name",
        "timeoutMs": "Timeout (ms)"
      },
      "label": {
        "action": "Action",
        "labelIds": "Labels",
        "createIfMissing": "Create label if missing"
      },
      "update_contact": {
        "setFields": "Set fields",
        "clearFields": "Clear fields",
        "addLabels": "Add labels",
        "removeLabels": "Remove labels",
        "language": "Language",
        "optIn": "Opt-in"
      },
      "sequence_subscribe": {
        "sequenceId": "Sequence",
        "action": "Action"
      },
      "assign_handoff": {
        "target": "Assign to",
        "userId": "User",
        "teamId": "Team",
        "pauseBot": "Pause automation",
        "handoffMessage": "Handoff message"
      },
      "close_snooze": {
        "mode": "Mode",
        "snoozeUntil": "Snooze until (date and time)",
        "snoozeHours": "Snooze for (hours)"
      },
      "notify_team": {
        "channel": "Channel",
        "teamId": "Team",
        "message": "Message"
      },
      "create_task": {
        "title": "Title",
        "dueInHours": "Due in (hours)",
        "assigneeUserId": "Assignee"
      },
      "google_sheets_row": {
        "operation": "Operation",
        "sheetRef": "Sheet",
        "values": "Column values",
        "matchColumn": "Match column",
        "matchValue": "Match value",
        "saveTo": "Save to variables"
      },
      "google_sheets_find_row": {
        "sheetRef": "Sheet",
        "lookupColumn": "Lookup column",
        "lookupValue": "Lookup value",
        "toContactFields": "Save to contact fields",
        "toVariables": "Save to variables"
      },
      "generate_voucher": {
        "campaign": "Campaign",
        "saveTo": "Save code to variable"
      },
      "ai_reply": {
        "prompt": "Instruction",
        "kbSourceIds": "Knowledge sources",
        "confidenceThreshold": "Confidence threshold"
      },
      "ai_classify_intent": {
        "input": "Text to classify",
        "intents": "Intents",
        "confidenceThreshold": "Confidence threshold"
      },
      "ai_extract": {
        "input": "Text to read",
        "fields": "Fields to extract",
        "confidenceThreshold": "Confidence threshold"
      },
      "ai_agent_session": {
        "mode": "Mode",
        "agentId": "AI agent",
        "timeoutMinutes": "End after silence (min)",
        "endKeywords": "End words (comma-separated)",
        "goal": "Goal (what the agent should achieve in this chat)",
        "requiredFields": "Fields to collect (variable: description)",
        "maxTurns": "Max turns (then continue on «Max turns»)",
        "exitKeywords": "Exit words (exact message)",
        "exits": "AI outcomes (name: when it applies)",
        "fallbackMessage": "Message when the AI is unavailable"
      },
      "cart_actions": {
        "action": "Action",
        "params": "Parameters"
      },
      "quote_actions": {
        "action": "Action",
        "params": "Parameters"
      },
      "booking_actions": {
        "action": "Action",
        "params": "Parameters"
      },
      "google_doc_write": {
        "operation": "Operation",
        "folderId": "Folder",
        "namingPattern": "Naming pattern",
        "docId": "Document",
        "content": "Content",
        "saveDocIdTo": "Save document id to variable"
      },
      "google_doc_pdf": {
        "templateId": "Template",
        "caption": "Caption"
      }
    },
    "panel": {
      "title": "Edit node: {name}",
      "pin": "Pin",
      "unpin": "Unpin",
      "close": "Close",
      "noFields": "This node has no editable settings yet.",
      "language": "Content language",
      "lang": {
        "ar": "العربية",
        "en": "English"
      },
      "addItem": "Add item",
      "removeItem": "Remove item",
      "options": {
        "addSection": "Add section",
        "removeSection": "Remove section",
        "sectionTitle": "Section title",
        "sectionN": "Section {n}",
        "addRow": "Add row",
        "removeRow": "Remove row",
        "rowTitle": "Row title",
        "rowDescription": "Row description (optional)",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "moveToSection": "Move to section",
        "maxRows": "Limit reached: {max} rows in the list.",
        "sectionsHint": "Split the list into sections, such as trips of a given month. WhatsApp allows up to ten rows in the whole list; Instagram shows them without section titles.",
        "addButton": "Add button",
        "removeButton": "Remove button",
        "buttonLabel": "Button text",
        "addLabel": "Add label",
        "removeLabel": "Remove label",
        "pickLabel": "Pick an existing label",
        "newLabel": "Or type a new label",
        "labelsTitle": "Labels added to the customer when this option is chosen",
        "labelsMax": "Limit reached: five labels."
      },
      "saveTarget": {
        "variableTitle": "Save the answer to a variable",
        "pickVariable": "Pick an existing variable",
        "newVariable": "New variable…",
        "newVariableName": "New variable name",
        "newVariableHint": "English letters, digits and underscore only, starting with a letter.",
        "none": "Do not save",
        "fieldTitle": "Save the answer to a contact field",
        "pickField": "Pick a field",
        "savesTo": "Answer saved to: {name}",
        "invalidName": "Invalid variable name."
      },
      "preview": "WhatsApp preview",
      "errors": {
        "required": "This field is required.",
        "number": "Enter a valid number.",
        "min": "The value is too small.",
        "max": "The value is too large."
      },
      "vars": {
        "title": "Insert variable",
        "contact": "Customer",
        "contactName": "Name",
        "contactPhone": "Number",
        "custom": "Custom fields",
        "flow": "Flow variables",
        "lastInput": "Last reply",
        "date": "Date",
        "time": "Time",
        "businessHours": "Inside/outside hours",
        "insert": "Insert"
      },
      "rules": {
        "add": "Add rule",
        "remove": "Remove rule",
        "field": "Variable name",
        "fieldPlaceholder": "e.g. last_answer",
        "operator": "Condition",
        "value": "Value",
        "valuePlaceholder": "Value",
        "valueInPlaceholder": "Values separated by commas",
        "ops": {
          "eq": "equals",
          "neq": "not equals",
          "gt": "greater than",
          "gte": "at least",
          "lt": "less than",
          "lte": "at most",
          "contains": "contains",
          "not_contains": "does not contain",
          "starts_with": "starts with",
          "in": "is one of",
          "exists": "has a value",
          "not_exists": "is empty"
        }
      },
      "branches": {
        "add": "Add branch",
        "remove": "Remove branch",
        "valuePlaceholder": "Value for this branch"
      },
      "variants": {
        "add": "Add variant",
        "remove": "Remove variant",
        "weight": "Variant percentage",
        "total": "Total",
        "hint": "Weights are relative; a total of 100 is easier to read"
      },
      "template": {
        "label": "Message template",
        "placeholder": "Choose a template",
        "loading": "Loading your templates…",
        "loadFailed": "Your templates could not be loaded. The saved choice is kept.",
        "savedUnknown": "Saved template (not in the list)",
        "bodyLabel": "Template text",
        "noApproved": "You have no approved templates yet. Create one and wait for WhatsApp to approve it.",
        "manage": "Go to templates",
        "status": {
          "draft": "draft",
          "pending": "waiting for approval",
          "rejected": "rejected",
          "paused": "paused",
          "disabled": "disabled"
        },
        "headerVariable": "Header value (text or media link)",
        "buttonUrl": "Button {n} link ending",
        "buttonCode": "Button {n} copy code",
        "variableNamed": "Variable {name}",
        "variableN": "Variable {n}",
        "variablesHint": "You can use flow variables like '{{'flow.name'}}' in each value."
      },
      "commerce": {
        "service": "Service",
        "servicePlaceholder": "Choose a service",
        "product": "Product",
        "productPlaceholder": "Choose a product",
        "date": "Date",
        "dateHint": "Type the date like 2026-10-20, or leave it empty for tomorrow. You can also insert a variable from the variables list.",
        "time": "Time",
        "timeHint": "Type the time in 24-hour format like 14:30. You can also insert a variable.",
        "staff": "Staff member (optional)",
        "staffAny": "Any available",
        "quantity": "Quantity",
        "quantityHint": "A number, or a variable.",
        "noParams": "This action needs no settings.",
        "discountSoon": "Discounts need a person to approve them, so this step cannot apply one automatically. It continues through \"Not available\".",
        "outputsHint": "After this step the flow continues through \"Done\" when it worked, or \"Not available\" when it could not.",
        "saved": "Saved (no longer in the list)",
        "action": {
          "check_availability": "Check availability",
          "book": "Book",
          "create": "Create cart",
          "add_item": "Add item",
          "apply_discount": "Apply discount"
        }
      },
      "agent": {
        "label": "AI agent",
        "placeholder": "Choose an agent",
        "loading": "Loading your agents…",
        "loadFailed": "Your agents could not be loaded. The saved choice is kept.",
        "savedId": "Saved agent (not in the list)",
        "draft": "draft",
        "none": "You have no AI agent yet. Create and publish one first.",
        "manage": "Go to AI agents",
        "hint": "The agent answers inside its own scope and knowledge base. It keeps replying until it hands over to your team, the customer is silent, a turn limit or outcome is reached, or an end word is sent. Unconnected exits end the flow (Max turns and Goal continue on the plain next step)."
      },
      "form": {
        "label": "Form",
        "placeholder": "Choose a form",
        "loading": "Loading your forms…",
        "loadFailed": "Your forms could not be loaded. The saved choice is kept.",
        "savedId": "Saved id (not in the list)",
        "noPublished": "You have no published form yet. Create a form and publish it first.",
        "manage": "Go to forms",
        "enterManually": "Enter an id manually",
        "pickFromList": "Pick from the list",
        "status": {
          "draft": "not published yet",
          "archived": "archived",
          "notSynced": "not ready on WhatsApp yet"
        }
      },
      "previewInstagram": "Instagram preview"
    },
    "collab": {
      "saving": "Saving…",
      "saved": "All changes saved",
      "saveError": "Couldn't save the latest changes. Retrying.",
      "conflict": "Someone else saved this flow. Your changes replaced theirs.",
      "alsoEditing": "{name} is also editing this flow.",
      "undo": "Undo",
      "redo": "Redo",
      "multiSelectHint": "Drag on the canvas to select several nodes. Ctrl/Cmd+C, V and D copy, paste and duplicate.",
      "loadError": "Couldn't load this flow."
    },
    "validation": {
      "generic": {
        "empty": "This field is empty. Open the step and fill it in.",
        "too_long": "This text is too long. Shorten it.",
        "missing": "A required choice is missing. Open the step and complete it.",
        "incomplete": "This step is incomplete. Open it and fill in the required fields."
      },
      "buttons": {
        "body": {
          "empty": "The message text is empty.",
          "too_long": "The message text is too long (max 1024 characters)."
        },
        "header": {
          "too_long": "The header is too long (max 60 characters)."
        },
        "footer": {
          "too_long": "The footer is too long (max 60 characters)."
        },
        "label": {
          "empty": "A button has no label.",
          "too_long": "A button label is too long (max 20 characters)."
        },
        "no_buttons": "Add at least one button.",
        "max_exceeded": "WhatsApp allows at most 3 buttons. Remove extra buttons or use a list.",
        "bad_id": "Button ids must be unique and non-empty.",
        "field_missing": "Pick the field this button should set.",
        "sequence_missing": "Pick a sequence for this button.",
        "ig_max_quick_replies": "Instagram allows fewer quick replies than this. Remove some buttons."
      },
      "list": {
        "body": {
          "empty": "The message text is empty.",
          "too_long": "The message text is too long (max 1024 characters)."
        },
        "header": {
          "too_long": "The header is too long (max 60 characters)."
        },
        "footer": {
          "too_long": "The footer is too long (max 60 characters)."
        },
        "button": {
          "empty": "The list button has no label.",
          "too_long": "The list button label is too long."
        },
        "section": {
          "empty": "A section has no title.",
          "too_long": "A section title is too long (max 24 characters)."
        },
        "row_title": {
          "empty": "A row has no title.",
          "too_long": "A row title is too long (max 24 characters)."
        },
        "row_description": {
          "too_long": "A row description is too long (max 72 characters)."
        },
        "no_rows": "Add at least one row.",
        "max_rows_exceeded": "A list allows at most 10 rows.",
        "bad_id": "Row ids must be unique and non-empty."
      },
      "FLOW_VALIDATION_FAILED": "The flow has errors that block publishing.",
      "FLOW_WARNINGS_UNCONFIRMED": "The flow has warnings. Confirm to publish anyway.",
      "FLOW_VERSION_NOT_FOUND": "Version not found.",
      "NODE_MALFORMED": "A node is missing its id or type.",
      "EDGE_MALFORMED": "A connection is missing its start or end.",
      "GRAPH_EMPTY": "The flow is empty: it has no steps. Add a “Starts when” step from the step menu, then connect the rest of your steps to it.",
      "NODE_UNKNOWN_TYPE": "This node type is not available.",
      "NODE_DATA_INVALID": "This step is incomplete. Open it and fill in the required fields.",
      "NODE_NOT_ALLOWED_ON_SURFACE": "This node type is not allowed here.",
      "NODE_UNSUPPORTED_ON_CHANNEL": "This node is not supported on the target channel.",
      "NODE_DEGRADED_ON_CHANNEL": "This node runs in a reduced form on the target channel.",
      "EDGE_DANGLING": "A connection points to a node that no longer exists.",
      "NO_TRIGGER": "This flow has no start step, so it can never begin. Add a “Starts when” step (a keyword or a first message), connect it to your first step, then save or publish.",
      "NODE_UNREACHABLE": "This node cannot be reached from any trigger.",
      "LOOP_WITHOUT_WAIT": "The flow loops without a wait step.",
      "TEMPLATE_NOT_APPROVED": "This message template is not approved yet.",
      "PRODUCT_CATALOG_NOT_FOUND": "The selected catalog no longer exists.",
      "PRODUCT_CATALOG_NOT_LINKED": "The selected catalog is not linked to a WhatsApp number.",
      "PRODUCT_ITEM_NOT_IN_CATALOG": "A referenced product is not in the catalog.",
      "PRODUCT_ITEM_REJECTED": "A referenced product was rejected by Meta. Remove or fix it.",
      "PRODUCT_ITEM_NOT_APPROVED": "A referenced product is not approved yet.",
      "PRODUCT_SET_NOT_FOUND": "The product set is missing from the selected catalog.",
      "PRODUCT_SET_TOO_FEW_APPROVED": "The product set has too few approved products.",
      "QR_UNSUPPORTED_NODE": "This step can't run on WhatsApp QR. QR flows can only send text, media and AI replies — use the official WhatsApp channel for buttons, lists, templates, forms and products."
    },
    "annot": {
      "addFrame": "Add frame",
      "addNote": "Add note",
      "frameTitle": "Frame title",
      "frameDefault": "Group",
      "deleteFrame": "Delete frame",
      "noteText": "Note text",
      "notePlaceholder": "Write a note…",
      "noteColor": "Note colour",
      "deleteNote": "Delete note",
      "color_yellow": "Yellow",
      "color_green": "Green",
      "color_blue": "Blue",
      "color_pink": "Pink"
    },
    "search": {
      "open": "Search",
      "label": "Search the canvas",
      "placeholder": "Search nodes and notes",
      "none": "No matches",
      "count": "{current} of {total}",
      "prev": "Previous",
      "next": "Next",
      "close": "Close search"
    },
    "shortcuts": {
      "open": "Shortcuts",
      "title": "Keyboard shortcuts",
      "close": "Close",
      "undo": "Undo",
      "redo": "Redo",
      "copy": "Copy selection",
      "paste": "Paste",
      "duplicate": "Duplicate selection",
      "search": "Search the canvas",
      "commandPalette": "Open the node command palette",
      "cheatSheet": "Show this cheat sheet",
      "multiSelect": "Add to selection",
      "delete": "Delete selection"
    },
    "publish": {
      "button": "Publish",
      "publishing": "Publishing…",
      "saveFailed": "Could not save your latest changes, so the flow was not published. Try again.",
      "noPermission": "You need the publish permission.",
      "success": "Published as version {version}.",
      "errorsTitle": "Fix these problems before publishing",
      "warningsTitle": "Publish with warnings?",
      "warningsBody": "The flow has warnings. You can still publish.",
      "confirm": "Publish anyway",
      "cancel": "Cancel",
      "jump": "Go",
      "flowLevel": "Whole flow",
      "unknownNode": "Missing step",
      "badgeError": "Errors on this node",
      "badgeWarning": "Warnings on this node",
      "failed": "Couldn't publish this flow.",
      "versionsTitle": "Versions",
      "versionsEmpty": "No published versions yet.",
      "versionLabel": "v{version}",
      "current": "Current",
      "publishedAt": "Published {date}",
      "by": "by {user}",
      "rollback": "Roll back",
      "rolledBack": "Rolled back: new version {version} created.",
      "rollbackConfirmTitle": "Roll back to version {version}?",
      "rollbackConfirmMessage": "This publishes a new version with the content of version {version} right away, so customers will see it immediately. Your current draft is replaced by it.",
      "rollbackConfirm": "Roll back and publish",
      "compare": "Compare with previous",
      "diffTitle": "Changes v{a} to v{b}",
      "diffEmpty": "No changes between these versions.",
      "diffClose": "Close",
      "legendAdded": "Added",
      "legendRemoved": "Removed",
      "legendChanged": "Changed",
      "diffSummary": "{added} added, {removed} removed, {changed} changed (nodes)"
    },
    "funnel": {
      "title": "Customer funnel",
      "entered": "Started the flow",
      "completed": "Completed",
      "dropOff": "{percent}% dropped"
    },
    "counters": {
      "window": "Window",
      "window_24h": "Last 24 hours",
      "window_7d": "Last 7 days",
      "window_30d": "Last 30 days",
      "window_all": "All time",
      "sent": "Sent",
      "delivered": "Delivered",
      "sentHelp": "Messages sent from this step",
      "deliveredHelp": "Share of sent messages that reached the customer",
      "handleClicks": "Branch / button count"
    },
    "gallery": {
      "import": "From file",
      "importFile": "Flow JSON file",
      "export": "Export"
    },
    "testPhone": {
      "title": "Test on my phone",
      "hint": "Add your number, enter the code we send you, then run the current draft on your phone. Test runs are not counted in analytics.",
      "phone": "Phone number",
      "channel": "Channel",
      "add": "Add number",
      "code": "Confirmation code",
      "confirm": "Confirm",
      "confirmed": "Confirmed",
      "send": "Send test",
      "sent": "Test started on your phone.",
      "remove": "Remove"
    },
    "sim": {
      "noTrigger": "Add a start step to begin the test.",
      "channelNotConnected": "No WhatsApp number is connected, so customers cannot reach it yet.",
      "templatesNotApproved": "{count, plural, one {# template used in this flow is} other {# templates used in this flow are}} not approved by Meta yet. The simulation still runs, but real sending stops at those steps until approval.",
      "noApprovedTemplates": "No approved template, so template steps are held outside the reply window.",
      "goToStartCard": "Start card",
      "title": "Simulator",
      "backToEditor": "Back to editor",
      "tabTitle": "Test flow",
      "channel": "Channel",
      "channelCloud": "WhatsApp Cloud API",
      "channelQr": "WhatsApp QR",
      "channelInstagram": "Instagram",
      "window": "Window",
      "windowOpen": "Open",
      "windowClosed": "Closed",
      "windowFep": "Free entry point",
      "start": "Start",
      "restart": "Restart",
      "fastForward": "Skip wait",
      "failed": "Run stopped: {reason}",
      "errors": {
        "no_trigger": "This auto-reply has no start step, so nothing starts it. How to fix: add a «Starts when» step on the canvas (for example «Customer sends a message») and connect it to your first step, then test again.",
        "loop_protection": "The test stopped because the conversation loops forever at the step «{node}». Open the connections after that step and add an exit that ends the conversation.",
        "node_not_found": "A connection points to a step that was deleted. Reconnect the previous step to an existing step or remove the connection.",
        "node_type_unregistered": "The step «{node}» is not supported in this version. Contact support and mention the step name, or delete it and test again.",
        "capability_blocked": "The step «{node}» can't run on the «{channel}» channel. How to fix: switch the test channel to «Official WhatsApp» (under For developers), or replace this step with a plain text step.",
        "invalid_node_data": "The step «{node}» is not fully set up. Open it, fill in the missing fields and test again.",
        "unknown": "The run stopped unexpectedly. Check the flow and try again.",
        "channel_flows_blocked": "Auto-replies with steps only run on Official WhatsApp, not on «{channel}». How to fix: pick «Official WhatsApp» as the test channel.",
        "window_blocked": "The 24-hour window is closed, so a free message can't be sent. How to fix: set the test window to «Open», or use an approved template step.",
        "goto_target_not_found": "The jump step «{node}» points to a step that no longer exists. Open it and pick an existing step.",
        "no_edge_for_handle": "The step «{node}» has an exit that is not connected. Connect every exit to a next step or to an «End» step, then test again.",
        "node_error": "The step «{node}» could not run in the test. Open it, check its settings and test again."
      },
      "completed": "The flow finished.",
      "reply": "Your reply",
      "send": "Send",
      "variables": "Variables",
      "contactFields": "Customer details",
      "toggle": "Preview as chat",
      "sampleMessage": "Hello",
      "liveNote": "This flow is published and reaches your customers.",
      "notLiveNote": "This is a draft. Customers will not see it before you publish.",
      "export": "Export as file",
      "avatar": "B",
      "businessName": "Your business",
      "online": "online",
      "typing": "typing…",
      "empty": "Press Start to chat with your flow as a customer would.",
      "placeholder": "Type a message",
      "developers": "For developers",
      "close": "Close",
      "customer": "Test as customer",
      "listTitle": "Options",
      "customerNone": "No customer data",
      "customers": {
        "s1": "Sara Al-Otaibi +966500000001",
        "s2": "Mohammed Al-Ghamdi +966500000002",
        "s3": "Noura Al-Shammari +966500000003"
      },
      "readiness": "Notes ({count})",
      "notes": {
        "title": "About this test",
        "real": "Messages, buttons, lists and conditions really run.",
        "pretend": "Cart, booking and webhooks are only simulated.",
        "noSend": "Nothing is sent to any phone.",
        "commerce": "Cart, quote and booking steps are not executed in the test and behave as unavailable.",
        "http": "Automatic-link (webhook) requests and contact updates are recorded, never sent anywhere.",
        "wait": "Waits do not really elapse; press «Skip wait» to get past them."
      },
      "trail": "Steps this customer went through",
      "composerHint": "Type a message to start the conversation again",
      "noReply": "The flow did not reply to this message",
      "statusDraft": "Draft: customers cannot see it",
      "statusLive": "Published",
      "details": "Details",
      "notesSummary": "What is simulated?",
      "listButton": "View list",
      "draftNote": "The test runs on the current draft and needs no publishing. Publish only when you want your customers to see it.",
      "bubble": {
        "contact": "Contact card",
        "template": "Template: {name}",
        "media": "{kind} (placeholder)"
      },
      "branchNote": "Branch taken: {branch}",
      "aiSampleNote": "Sample AI reply - no real AI was called and nothing was charged.",
      "realPrefix": "In the real run:",
      "real": {
        "http": "a web request is sent (not sent here)",
        "crm": "this is saved ({action}) - not saved here",
        "event": "this happens ({action}) - not done here"
      },
      "limits": {
        "title": "What this test does and doesn't do",
        "cloud": "Official WhatsApp: all steps can be tried.",
        "other": "Other channels: some steps can't run (buttons, lists, templates).",
        "sample": "Cart, quote, booking, web-request and customer-data steps run on sample data only; nothing real is created or sent.",
        "ai": "AI steps show a sample reply; no AI is called."
      },
      "badges": {
        "sample": "Sample data",
        "notHere": "Real customers only",
        "sampleLine": "🧪 Sample data: {area} ran with demo values. «{node}» will use real data with real customers.",
        "notHereLine": "This step isn't tried here, it will run with real customers.",
        "http": "Simulated",
        "crm": "Not saved"
      },
      "areas": {
        "cart": "cart",
        "quote": "quote",
        "booking": "booking"
      }
    },
    "instagramLimits": {
      "quickReplies": "Instagram allows at most {max} quick replies on this node ({count} used).",
      "cards": "Instagram allows at most {max} cards on this node ({count} used).",
      "cardButtons": "Instagram allows at most {max} buttons per card."
    },
    "trigger": {
      "title": "Starts when",
      "field": "What starts this flow?",
      "keyword": "Keywords (separate with commas)",
      "kinds": {
        "intent": "Customer writes anything, AI understands",
        "keyword": "A keyword",
        "first_message": "First message from a new customer",
        "link_qr": "Link or QR code",
        "template_button": "Button in a template",
        "event": "An event (order, booking…)",
        "manual": "Manually from the inbox",
        "ig_comment": "A comment on your post or reel",
        "ig_story_mention": "Someone mentions you in a story",
        "ig_story_reply": "A reply to your story",
        "ig_postback": "Ice-breaker or menu tap (Instagram)"
      },
      "examples": {
        "intent": "e.g. “how much is delivery?” goes to the Prices branch",
        "keyword": "e.g. the customer writes “price”",
        "first_message": "e.g. someone writes to you for the first time",
        "link_qr": "e.g. the customer scans the QR on your shop door",
        "template_button": "e.g. the customer taps “Track my order”",
        "event": "e.g. a new order is placed",
        "manual": "e.g. an agent starts it from the conversation",
        "ig_comment": "e.g. a customer comments “info” on a reel",
        "ig_story_mention": "e.g. a customer tags your account in their story",
        "ig_story_reply": "e.g. a customer replies to your story",
        "ig_postback": "e.g. the customer taps an ice-breaker question"
      },
      "linkLive": "Saved as a live start when you publish: customers who match it enter this flow.",
      "linkElsewhere": {
        "link_qr": "Create the link or QR code in Channels; it opens this flow. Nothing starts it until you do.",
        "template_button": "Set the button in the message template; tapping it opens this flow.",
        "event": "Pick the event in Automations; it opens this flow when it happens."
      },
      "payloads": "Postback payloads (separate with commas)"
    },
    "b29start": {
      "removedNote": "This start is no longer offered — convert it to a keyword.",
      "convert": "Convert to keyword",
      "intentHint": "Each first message uses AI credit. Anything that matches no intent leaves through “Other”.",
      "intentName": "Intent (e.g. prices)",
      "intentDescription": "What the customer means (optional)"
    },
    "b29ai": {
      "mode": "How should the assistant answer?",
      "mode_once": "Reply once, then go back to the flow",
      "mode_continue": "Keep chatting with the customer"
    },
    "importReview": {
      "title": "Imported — rebuild these steps by hand",
      "body": "These steps from your previous platform have no match here, so they were left out. Rebuild them on the canvas, then hide this note.",
      "item": "{type} (step {id})",
      "showConfig": "Original settings",
      "dismiss": "Done"
    },
    "runs": {
      "toggle": "Run log",
      "title": "Recent runs",
      "empty": "No runs yet. They appear here once customers start this flow.",
      "loadError": "Couldn't load the run log. Check your connection and try again.",
      "retry": "Try again",
      "close": "Close",
      "started": "Started",
      "status": "Status",
      "version": "Version",
      "details": "Details",
      "versionValue": "v{version}",
      "waitingAt": "Waiting at {node}"
    },
    "qrAiNotice": "Flows do not run on WhatsApp QR, so this AI step is skipped there. On QR, the AI agent bound to the channel answers instead (Channels → Bind to AI Agent).",
    "checks": {
      "msg": {
        "start_unlinked": "The start step is not connected to anything, so the flow never runs.",
        "dead_end": "The customer answers here and nothing happens next.",
        "button_unlinked": "The button “{name}” leads nowhere.",
        "unreachable": "No path reaches this step, so customers never see it.",
        "ai_without_handoff": "The AI replies, but there is no step that hands the chat to a person.",
        "ai_cloud_text": "AI free-text replies cannot run on the official WhatsApp number; it answers with buttons, lists and forms only.",
        "no_handoff": "There is no step that hands the chat to a person.",
        "template_missing": "No ready message is chosen, or the chosen one was deleted.",
        "template_unapproved": "This ready message is {status}; WhatsApp only sends approved ones.",
        "qr_blocked": "WhatsApp by QR scan cannot show this step (buttons, lists, forms, ready messages and products need official WhatsApp).",
        "qr_degraded": "On WhatsApp by QR scan this step is sent as plain text.",
        "ig_unsupported": "Instagram cannot show this step.",
        "ig_buttons_many": "This step has {count} buttons; Instagram shows only {max}.",
        "ig_button_title_long": "A button title is longer than {max} characters; Instagram cuts it.",
        "ig_cards_many": "This carousel has {count} cards; Instagram shows only {max}."
      },
      "status": {
        "draft": "still a draft",
        "pending": "waiting for WhatsApp’s review",
        "rejected": "rejected by WhatsApp",
        "paused": "paused by WhatsApp",
        "disabled": "disabled by WhatsApp",
        "approved": "approved"
      }
    },
    "lint": {
      "empty": "No problems found.",
      "label_removed_then_checked": "The label “{label}” is removed earlier on this path, so this condition never finds it and the branch never runs.",
      "condition_branch_unreachable": "This condition has no rules, so its “false” branch never runs.",
      "carousel_card_routes_instagram_only": "Carousel card buttons only route on Instagram. On WhatsApp the flow ends after the carousel.",
      "button_node_no_outgoing": "This step offers choices but nothing comes after it.",
      "choice_no_target": "The choice “{choice}” leads nowhere.",
      "wait_without_timeout": "This step waits for the customer with no time limit. Add a timeout so the flow can continue.",
      "keyword_wrong_layout": "“{keyword}” looks typed on the wrong keyboard layout. Did you mean “{suggestion}”?",
      "keyword_noise": "“{keyword}” looks like random digits or symbols, not a word customers would type.",
      "duplicate_keyword": "“{keyword}” is also an exact keyword of the flow “{flowName}”. Only one will run.",
      "system_reply_language": "A system reply still uses the default text in a different language from your workspace.",
      "trigger_unpublished": "This flow has a trigger but is not published, so it never starts."
    },
    "menuFunnel": {
      "title": "Menu click funnel",
      "window": "Time window",
      "window7d": "Last 7 days",
      "window30d": "Last 30 days",
      "unpublished": "Publish this flow to see how contacts use this menu.",
      "empty": "This menu was not sent in this period.",
      "sent": "Menu sent",
      "clicked": "Clicked",
      "reachedEnd": "Reached end",
      "handedOff": "Handed to a person",
      "noClick": "Sent, no click",
      "optionLine": "{clicks} clicks · {end} reached end · {handoff} handed off"
    },
    "outputs": {
      "true": "Yes",
      "false": "No",
      "answered": "Answered",
      "invalid": "Invalid answer",
      "timeout": "Timed out",
      "default": "Other",
      "success": "Done",
      "notAvailable": "Not available",
      "submitted": "Submitted",
      "failure": "Failed",
      "found": "Found",
      "notFound": "Not found",
      "none": "None found",
      "event": "Happened",
      "received": "Received",
      "goalReached": "Goal reached",
      "handedOff": "Handed off",
      "maxTurns": "Max turns reached",
      "exit": "Exit word"
    },
    "menuSuggestions": {
      "chip": "{count, plural, one {# other message} other {# other messages}}",
      "title": "Customers typed something else",
      "empty": "No repeated free-text replies yet.",
      "samples": "Examples",
      "addButton": "Add as button",
      "route": "Route",
      "dismiss": "Dismiss",
      "routeTarget": "Existing branch",
      "convertList": "To list",
      "limitReached": "Cloud API allows 3 buttons. Convert this menu to a list to add more.",
      "close": "Close",
      "added": "Added to the menu.",
      "routed": "Routed to the existing branch.",
      "dismissed": "Dismissed for 30 days.",
      "loadFailed": "Could not load suggestions."
    },
    "b29stress": {
      "button": "Flow check",
      "title": "Flow check",
      "intro": "Fake customers walk your draft flow. Nothing is sent to real customers.",
      "close": "Close",
      "count": "Number of fake customers",
      "start": "Start check",
      "restart": "Check again",
      "stop": "Stop",
      "progress": "{done}/{total}",
      "ok": "All good",
      "problems": "{count, plural, one {# problem} other {# problems}}",
      "customer": "Test customer {n}",
      "steps": "{count, plural, one {# step} other {# steps}}",
      "from": {
        "customer": "Customer",
        "bot": "Flow"
      },
      "emptyLine": "(empty)",
      "stoppedAt": "Stopped at: {step}",
      "focus": "Show step",
      "noPermission": "You need the edit permission.",
      "failure": {
        "rateLimited": "One check per minute. Try again in a moment.",
        "noCredits": "AI credits are unavailable.",
        "saveFailed": "Could not save the flow first.",
        "failed": "The check failed. Try again."
      },
      "kind": {
        "dead_end": "Dead end",
        "loop": "Loop (more than 5 visits)",
        "unanswered_free_text": "Free text not answered",
        "cloud_api_violation": "Cloud API rule broken"
      },
      "detail": {
        "too_many_buttons": "More than 3 buttons",
        "button_label_too_long": "Button label over 20 characters",
        "too_many_rows": "More than 10 list rows",
        "row_title_too_long": "Row title over 24 characters",
        "no_next_step": "The flow stops here without an end or handoff",
        "no_outgoing_edge": "Nothing follows this step",
        "loop_protection": "Loop protection stopped the run"
      }
    },
    "b29errors": {
      "b29b": {
        "reason": {
          "auth": "The service refused access",
          "not_found": "The link was not found",
          "rate_limited": "The service says too many requests, wait a bit",
          "timeout": "The service took too long to answer",
          "server_error": "The external service has a fault",
          "template": "The template has a problem"
        }
      },
      "nav": "Errors",
      "title": "Errors",
      "help": "Steps that failed for a customer. The same problem repeating is one row.",
      "filters": "Filters",
      "status": {
        "unresolved": "Unresolved",
        "all": "All"
      },
      "byFlow": "Flow",
      "allFlows": "All flows",
      "loadFailed": "Could not load the errors.",
      "empty": "No errors. Everything is running fine.",
      "repeated": "{count, plural, one {repeated # time} other {repeated # times}}",
      "openConversation": "Open conversation",
      "openStep": "Open the step in the editor",
      "resolve": "Mark solved",
      "detailFailed": "Could not load the details.",
      "loading": "Loading…",
      "howToFix": "How to fix",
      "trail": "Steps before the error",
      "attempted": "What the step tried to send",
      "response": "Response received",
      "technical": "Technical details",
      "openRun": "Open the run",
      "homeTitle": "Errors that need your attention ({count})",
      "viewAll": "View all",
      "reason": {
        "window_closed": "24-hour window closed — the customer can't be messaged freely",
        "invalid_number": "The phone number is not valid on WhatsApp",
        "external_unreachable": "The external link didn't respond",
        "meta_rejected": "WhatsApp (Meta) rejected the message",
        "ai_quota": "AI credits ran out",
        "opted_out": "The customer opted out of automated messages",
        "channel_blocked": "This channel can't run flows",
        "loop": "The flow went in circles and was stopped",
        "invalid_step": "The step settings are incomplete",
        "unknown": "Something went wrong in this step"
      },
      "fix": {
        "window_closed": "Use an approved template to reopen the conversation, or wait for the customer to write first.",
        "invalid_number": "Check the customer's number. It may not have WhatsApp.",
        "external_unreachable": "Check that the link in the step is correct and the service is online. The flow continued without it.",
        "meta_rejected": "Open the technical details for Meta's message. Often the template or media needs a change.",
        "ai_quota": "Top up AI credits or raise the monthly limit.",
        "opted_out": "Nothing to fix. Respect the customer's choice.",
        "channel_blocked": "Run this flow on the official WhatsApp or Instagram channel.",
        "loop": "Add an end or a handoff so the flow doesn't return to the same step.",
        "invalid_step": "Open the step and complete its required fields.",
        "unknown": "Open the technical details and the run for more information."
      }
    },
    "b29list": {
      "startBlank": "From scratch",
      "startAi": "Describe it, AI builds it",
      "startImport": "Import a file",
      "duplicated": "Copy created: {name}. It is a draft.",
      "open": "Open",
      "runs": "Run log"
    },
    "b29runs": {
      "title": "Run log",
      "tile": {
        "entered": "Entered",
        "completed": "Finished",
        "stopped": "Stopped",
        "failed": "Errors"
      },
      "period": {
        "today": "Today",
        "7": "7 days",
        "30": "30 days"
      },
      "status": {
        "all": "All",
        "completed": "Finished",
        "waiting": "Waiting for reply",
        "handoff": "Handed to staff",
        "failed": "Error",
        "stopped": "Stopped"
      },
      "phase": {
        "done": "Finished",
        "waiting": "Waiting for reply",
        "handoff": "Handed to staff",
        "error": "Error",
        "stopped": "Stopped"
      },
      "tests": "Tests",
      "testBadge": "Test",
      "searchPlaceholder": "Search name or number",
      "unknownCustomer": "Customer",
      "empty": "No runs for these filters.",
      "loadMore": "Show more",
      "steps": "{count} steps",
      "pick": "Pick a run to see its path.",
      "sent": "Sent",
      "answer": "Customer replied",
      "changed": "Changed",
      "openChat": "Open chat",
      "stop": "Stop run",
      "stopTitle": "Stop this run?",
      "stopBody": "The customer will not get any more messages from this run.",
      "error": {
        "generic": "Something went wrong in this step.",
        "window_blocked": "The 24-hour window was closed, so the message could not be sent.",
        "contact_opted_out": "The customer opted out of messages.",
        "contact_do_not_automate": "This customer is set to “no automation”.",
        "loop_protection": "The flow looped too many times and was stopped.",
        "max_age_30d": "The run was cancelled after 30 days.",
        "flow_paused": "The flow was paused.",
        "superseded_by_trigger": "A newer run replaced this one.",
        "stopped_by_user": "Stopped by a team member.",
        "transient_retry": "Temporary problem; the step was retried."
      }
    },
    "b29": {
      "menu": {
        "versions": "Previous versions",
        "counters": "Visit numbers",
        "countersEmpty": "No visits yet — publish the flow and try it",
        "runs": "Run log",
        "phone": "Try on my phone",
        "export": "Export flow",
        "unpublish": "Unpublish"
      },
      "history": {
        "undoWith": "Undo: {action}",
        "redoWith": "Redo: {action}",
        "add": "add step",
        "delete": "delete step",
        "move": "move step",
        "connect": "connect steps",
        "disconnect": "remove link",
        "edit": "edit step",
        "paste": "paste",
        "layout": "auto layout",
        "ai": "AI edit",
        "note": "edit note"
      },
      "save": {
        "retry": "Retry"
      },
      "publishCheck": {
        "jump": "Go to step",
        "blocked": "Publishing is blocked until these are fixed.",
        "close": "Close"
      },
      "note": {
        "label": "Note to self",
        "hint": "Only your team sees this. It is never sent to customers.",
        "placeholder": "e.g. waiting for the new price list"
      },
      "sentence": {
        "open": "Describe a change (AI)"
      },
      "shortcuts": {
        "toolbarTitle": "From the toolbar",
        "layout": "Arrange the steps automatically",
        "fit": "Show the whole flow on screen"
      },
      "palette": {
        "desc": {
          "ai_classify_intent": "Understands what the customer wants. E.g. «I want to book» → booking",
          "ai_extract": "Pulls details out of the message. E.g. date and people from «Friday for 4»",
          "ai_agent_session": "Hands the chat to your AI assistant; you can take over any time",
          "booking_actions": "Books or cancels an appointment. E.g. holds Saturday 5 pm",
          "cart_actions": "Adds or removes products in the cart. E.g. add 2 coffees",
          "generate_voucher": "Creates a discount code. E.g. 10% off, valid 7 days",
          "create_task": "Creates a to-do for your team. E.g. «call the customer tomorrow»",
          "close_snooze": "Closes the chat or snoozes it. E.g. remind me in 2 days",
          "quote_actions": "Prepares a price quote for a person to approve. E.g. 3 items + delivery",
          "send_webhook": "Sends the customer's data to another system. E.g. your CRM",
          "http_request": "Call any web address and use the reply",
          "google_sheets_row": "Add or update a row in Google Sheets",
          "google_sheets_find_row": "Look up a row in Google Sheets",
          "google_doc_write": "Fill a Google Doc from a template",
          "google_doc_pdf": "Send a Google Doc as a PDF"
        }
      }
    },
    "b29b": {
      "header": {
        "title": "Header",
        "text": "Text",
        "media": "File",
        "kind": "File type",
        "kinds": {
          "image": "Image",
          "video": "Video",
          "document": "File"
        },
        "link": "File link",
        "badLink": "The link must start with https://",
        "filename": "File name",
        "remove": "Remove file",
        "mediaHint": "Image up to 5 MB · video 16 · file 100",
        "listHint": "The file is sent as a message before the list",
        "tooBig": "The file is too big",
        "missing": "Add the file link"
      },
      "action": {
        "title": "On tap",
        "kinds": {
          "next": "Next step",
          "run_flow": "Run another flow",
          "handoff": "Hand to a teammate",
          "subscribe_sequence": "Join a sequence",
          "main_menu": "Back to main menu",
          "set_field": "Save a value"
        },
        "pickFlow": "Choose the flow",
        "pickSequence": "Choose the sequence",
        "returnToCaller": "Come back here after it ends",
        "note": "Note for the team (optional)",
        "loadFailed": "Could not load the list"
      },
      "mainMenu": {
        "add": "Back to main menu",
        "option": "Main menu",
        "chip": "Main menu",
        "toggle": "Make it the main menu",
        "on": "This is the main menu",
        "failed": "Could not update the main menu"
      },
      "rows": {
        "descriptionHint": "e.g. 📅 20/11/2026"
      },
      "counters": {
        "contacts": "Customers",
        "failedHelp": "Some customers stopped here because of an error"
      },
      "start": {
        "matchLabel": "How it matches",
        "match": {
          "contains": "Contains",
          "exact": "Matches exactly",
          "starts_with": "Starts with"
        },
        "labels": "Add a label when it starts"
      },
      "listSource": {
        "title": "Choices from",
        "kinds": {
          "static": "Typed here",
          "services": "Services",
          "products": "Products"
        },
        "hint": "Read when the message is sent — first {count} only",
        "choice": "Picked one"
      },
      "booking": {
        "name": {
          "appointment": "📅 Appointment booking",
          "seats": "📅 Seat booking",
          "rental": "📅 Day rental booking"
        },
        "starter": "📅 Booking",
        "starterHelp": "Ready booking steps: pick the booking type, then choose the service in the booking step.",
        "askDay": "Which day suits you?",
        "pickDay": "Pick a day",
        "days": "Days",
        "day": {
          "today": "Today",
          "tomorrow": "Tomorrow",
          "after_tomorrow": "Day after tomorrow"
        },
        "askSeats": "How many seats?",
        "askTime": "Free times: '{{'booking_result.slots'}}'\nType the time that suits you (e.g. 10:00)",
        "askCheckIn": "Check-in date?",
        "askCheckOut": "Check-out date?",
        "received": "We received your request; it is waiting for confirmation",
        "unavailable": "Sorry, nothing is free. Try another time.",
        "partySize": "Seats",
        "partySizeHint": "A number or a variable, e.g. '{{'booking_seats'}}'",
        "checkIn": "Check-in",
        "checkOut": "Check-out",
        "stayHint": "A date or a variable, e.g. '{{'booking_check_in'}}'",
        "pattern": {
          "appointment": "Appointment",
          "seats": "Dated seats",
          "rental": "Day rental"
        }
      }
    }
  },
  "contacts": {
    "b29b": {
      "duplicates": {
        "confirm": "{count, plural, one {# customer} other {# customers}} will be merged into one. This cannot be undone."
      }
    },
    "nav": "Customers",
    "list": {
      "title": "Customers",
      "subtitle": "Everyone who has messaged you or been added by your team.",
      "search": "Search customers",
      "searchPlaceholder": "Name, phone or email",
      "filters": {
        "sequence": "Sequence",
        "sequenceAny": "Any sequence",
        "sequenceNone": "Not in a sequence",
        "subscription": "Subscription",
        "subscriptionAny": "Any status",
        "subscribed": "Subscribed",
        "unsubscribed": "Unsubscribed",
        "optedOut": "Opted out",
        "channel": "Channel",
        "channelAny": "Any channel",
        "channelWhatsappCloud": "WhatsApp Cloud",
        "channelWhatsappQr": "WhatsApp QR",
        "channelInstagram": "Instagram",
        "channelMessenger": "Messenger",
        "channelWebchat": "Web chat",
        "clear": "Clear"
      },
      "summary": {
        "label": "Customer totals",
        "total": "Total",
        "subscribed": "Subscribed",
        "unsubscribed": "Unsubscribed",
        "new7d": "New 7d"
      },
      "labelModeAny": "Any of these",
      "labelModeAll": "All of these",
      "labelExclude": "Exclude {name}",
      "empty": "No customers found.",
      "loadMore": "Load more",
      "selectAll": "Select all loaded customers",
      "selectRow": "Select {name}",
      "selected": "{count, plural, one {# selected} other {# selected}}",
      "noName": "Unnamed",
      "whatsappNumber": "WhatsApp number",
      "columns": {
        "name": "Name",
        "phone": "Phone",
        "consent": "Consent",
        "labels": "Labels"
      },
      "bulkLabel": "Bulk label",
      "bulkAdd": "Add label",
      "bulkRemove": "Remove label",
      "bulkApply": "Apply",
      "bulkChoose": "Label",
      "bulkDone": "{count, plural, one {# customer updated} other {# customers updated}}",
      "created": "Customer added",
      "cancel": "Cancel",
      "save": "Save",
      "form": {
        "phone": "WhatsApp number",
        "phoneHint": "Include the country code, for example 966",
        "name": "Name",
        "email": "Email"
      },
      "bulkAction": "Action",
      "exportSelected": "Export selected",
      "deleteSelected": "Delete selected",
      "deleteTitle": "Delete customers",
      "deleteBody": "{count, plural, one {Delete # customer?} other {Delete # customers?}}",
      "confirmDelete": "Delete",
      "deleteDone": "{count, plural, one {# customer deleted} other {# customers deleted}}"
    },
    "consent": {
      "opted_in": "Opted in",
      "opted_out": "Opted out",
      "unknown": "Not confirmed"
    },
    "profile": {
      "tabs": {
        "overview": "Overview",
        "conversations": "Conversations",
        "orders": "Orders",
        "labelsHistory": "Labels history",
        "notes": "Notes",
        "noConversations": "No conversations yet.",
        "convStatus": {
          "open": "Open",
          "pending": "Pending",
          "snoozed": "Snoozed",
          "closed": "Closed"
        },
        "noOrders": "No orders yet.",
        "noLabelHistory": "No label changes yet.",
        "labelAdded": "Added",
        "labelRemoved": "Removed",
        "tablist": "Customer sections"
      },
      "title": "Customer",
      "block": "Block customer",
      "unblock": "Unblock customer",
      "sourceValue": {
        "manual": "Added manually",
        "inbound": "Inbound message",
        "import": "File import",
        "api": "Linked app",
        "form": "Form",
        "link": "Link",
        "qr": "QR code",
        "ad": "Ad",
        "widget": "Widget",
        "direct_message": "Direct message",
        "other": "Other"
      },
      "blockTitle": "Block this customer?",
      "blockBody": "No outbound messages will be sent to this customer until you unblock them.",
      "confirmBlock": "Block",
      "blockedToast": "Customer blocked",
      "unblockedToast": "Customer unblocked",
      "mergeWith": "Merge with another customer…",
      "blockedBadge": "Blocked",
      "consent": "Consent status",
      "back": "Back to customers",
      "edit": "Edit",
      "save": "Save changes",
      "cancel": "Cancel",
      "saved": "Customer updated",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "source": "Source",
      "details": "Details",
      "customFields": "Extra details",
      "noCustomFields": "No extra details have been added yet.",
      "labels": "Labels",
      "addLabel": "Add label",
      "noLabels": "No labels",
      "removeLabel": "Remove label {name}",
      "newLabel": "New label name",
      "createLabel": "Create and add",
      "labelCreated": "Label created and added.",
      "deleteLabel": "Delete label {name} for everyone",
      "deleteLabelTitle": "Delete this label?",
      "deleteLabelBody": "The label {name} will be removed from every customer that has it. This cannot be undone.",
      "deleteLabelConfirm": "Delete label",
      "labelDeleted": "Label deleted.",
      "identities": "Number and accounts",
      "noIdentities": "No linked accounts.",
      "sequences": "Sequences",
      "flowAnswers": "Saved answers",
      "flowAnswersError": "Could not load the saved answers.",
      "flowAnswersEmpty": "No saved answers from this customer yet.",
      "flowAnswerSourceForm": "Form",
      "flowAnswerSourceQuestion": "Saved answers",
      "sequencesEmpty": "Not enrolled in any sequence.",
      "sequencesError": "Could not load the sequences.",
      "sequenceActive": "Active",
      "sequenceCompleted": "Completed",
      "sequenceExited": "Exited",
      "sequenceEnrolledOn": "Enrolled on",
      "ctwa": "Ad that opens a WhatsApp chat",
      "ctwaAd": "Ad",
      "ctwaClid": "Click number",
      "firstTouch": "First customer",
      "lastTouch": "Last customer",
      "touchSource": {
        "widget": "Widget",
        "short_link": "Short link",
        "qr": "QR code",
        "ctwa": "Ad that opens a WhatsApp chat"
      },
      "ctwaSource": "Source",
      "none": "Not set",
      "clear": "Clear",
      "yes": "Yes",
      "no": "No",
      "choose": "Choose…",
      "jsonHint": "Enter valid JSON text"
    },
    "labels": {
      "system": {
        "deliveryFailed": "Delivery failed"
      },
      "create": "Create label",
      "name": "Name",
      "color": "Color",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "created": "Label created",
      "updated": "Label updated",
      "deleted": "Label deleted"
    },
    "fields": {
      "title": "Extra customer details",
      "subtitle": "Boxes you add to the customer card, such as birthday or city.",
      "create": "Add a box",
      "key": "Technical name",
      "keyHint": "Lowercase letters, digits and underscores. Cannot be changed later.",
      "label": "Display name",
      "type": "Type",
      "choices": "Choices",
      "choicesHint": "One choice per line",
      "empty": "No extra details yet. Add your first box.",
      "edit": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete the box {name}? Its values are removed from all customers.",
      "save": "Save",
      "cancel": "Cancel",
      "created": "Box added",
      "updated": "Box updated",
      "deleted": "Box deleted",
      "editTitle": "Edit box",
      "createTitle": "Add a box",
      "types": {
        "text": "Text",
        "number": "Number",
        "decimal": "Decimal",
        "date": "Date",
        "datetime": "Date and time",
        "boolean": "Yes / No",
        "single_select": "Single choice",
        "multi_select": "Multiple choice",
        "email": "Email",
        "phone": "Phone",
        "url": "URL",
        "json": "JSON"
      }
    },
    "forbidden": "You do not have permission to view customers.",
    "errors": {
      "CONTACT_PHONE_INVALID": "Enter a valid phone number with the country code.",
      "CONTACT_VALIDATION_FAILED": "Some customer details are not valid.",
      "CONTACT_FIELD_INVALID": "An extra detail value is not valid.",
      "CONTACT_FIELD_UNKNOWN": "An extra detail box does not exist.",
      "CONTACT_NOT_FOUND": "This customer was not found.",
      "LABEL_NOT_FOUND": "This label was not found.",
      "CUSTOM_FIELD_NOT_FOUND": "This box was not found.",
      "CONTACT_PHONE_EXISTS": "A customer with this phone number already exists.",
      "LABEL_NAME_TAKEN": "A label with this name already exists.",
      "CUSTOM_FIELD_KEY_TAKEN": "A box with this technical name already exists."
    },
    "segments": {
      "addCondition": "Add condition",
      "empty": "No groups yet."
    },
    "import": {
      "title": "Add customers from a file",
      "stepUpload": "Upload file",
      "stepMap": "Map columns",
      "stepDryRun": "Test first",
      "stepRun": "Add",
      "chooseFile": "Spreadsheet file (CSV)",
      "phoneColumn": "Phone column",
      "nameColumn": "Name column",
      "emailColumn": "Email column",
      "none": "None",
      "duplicatePolicy": "If the number is already added",
      "policySkip": "Skip",
      "policyUpdate": "Update",
      "policyCreate": "Add anyway",
      "optInSource": "Opt-in source",
      "optInProof": "Proof they agreed to messages (reference or note)",
      "optInRequired": "Say how these customers agreed to receive messages, and add proof, to continue.",
      "next": "Next",
      "back": "Back",
      "runDryRun": "Dry run",
      "startImport": "Start adding",
      "reportSummary": "{total} rows: {created} new, {updated} updated, {skipped} skipped, {failed} could not be added",
      "errors": {
        "PHONE_MISSING": "Phone number is empty",
        "PHONE_INVALID": "Phone number is not valid",
        "EMAIL_INVALID": "Email address is not valid",
        "FIELD_INVALID": "An extra detail value is not valid"
      },
      "sources": {
        "direct_message": "Direct message from the customer",
        "link": "Sign-up link",
        "qr": "QR code",
        "ad": "Ad",
        "import": "List from a file with prior consent",
        "api": "Linked app",
        "form": "Form"
      },
      "rowError": "Row {row}: {message}",
      "done": "Adding finished",
      "forbidden": "You do not have permission to add customers from a file."
    },
    "duplicates": {
      "reason": {
        "email": "Same email",
        "phone_suffix": "Similar phone",
        "name": "Same name"
      },
      "noValue": "—"
    },
    "merge": {
      "suggest": {
        "banner": "Looks like the same person as {name}",
        "merge": "Merge",
        "notSame": "Not same",
        "confirmTitle": "Merge with {name}?",
        "confirmIntro": "The older customer is kept. This moves:",
        "moves": {
          "conversations": "Conversations and messages",
          "notes": "Notes",
          "tasks": "Tasks",
          "orders": "Orders, quotes and deals",
          "labels": "Labels",
          "fields": "Custom fields (if both have a value, the kept customer's value stays and the other is saved in the audit log)"
        },
        "undoNote": "You can undo this for 24 hours.",
        "confirm": "Merge",
        "done": "Customers merged.",
        "undo": "Undo",
        "undone": "Merge undone.",
        "reason": {
          "phone": "Same phone number",
          "instagram": "Same Instagram handle",
          "name_city": "Same name and city"
        }
      },
      "title": "Merge customers",
      "intro": "Choose the customer to keep. The other one is merged into it.",
      "keepLegend": "Customer to keep",
      "keepOption": "Keep {name}",
      "suggested": "Suggested: the oldest customer",
      "oldest": "Oldest",
      "fieldsTitle": "Details to use",
      "field": {
        "name": "Name",
        "email": "Email",
        "language": "Language",
        "timezone": "Time zone"
      },
      "pickKeep": "Kept customer",
      "pickOther": "Other customer",
      "pickLabel": "{field}: which value to use",
      "extrasNote": "Language and time zone come from the chosen customer when it has one; the other is used if it is empty.",
      "previewTitle": "Result",
      "previewName": "Name: {value}",
      "previewEmail": "Email: {value}",
      "previewPhone": "Phone: {value}",
      "warning": "The other customer is archived, and its conversations, orders and notes move to the kept customer. This cannot be undone from here.",
      "optOut": "If either customer opted out of messages, the merged customer stays opted out.",
      "confirm": "Merge",
      "merging": "Merging…",
      "cancel": "Cancel",
      "success": "Customers merged",
      "movedTotal": "{count, plural, one {# item moved} other {# items moved}} to the kept customer.",
      "movedNone": "Nothing needed to move.",
      "alreadyMerged": "These customers were already merged.",
      "errors": {
        "CONTACT_VALIDATION_FAILED": "These customers cannot be merged. Choose two different customers.",
        "CONTACT_NOT_FOUND": "One of the customers no longer exists. It may have been merged or archived already.",
        "conflict": "These customers changed while you were merging. Refresh and try again.",
        "generic": "The merge did not go through. Try again."
      },
      "search": {
        "title": "Merge {name} with another customer",
        "label": "Find the other customer",
        "placeholder": "Search by name or phone",
        "hint": "Type at least 2 characters.",
        "none": "No matching customers",
        "choose": "Choose"
      }
    },
    "importNav": "Add customers from a file",
    "export": {
      "started": "Export started. We will download it when it is ready.",
      "done": "Exported {count} customers.",
      "failed": "The export did not finish. Try again."
    },
    "b29": {
      "add": "New customer",
      "importBtn": "Import",
      "fieldsBtn": "Extra data",
      "fieldsTitle": "Extra customer data",
      "fieldMenu": "Options for {name}",
      "sendToThese": "Send to these",
      "exportBtn": "Export",
      "chipWithCount": "{name} · {count}",
      "labelMenu": "Options for {name}",
      "labelNew": "New label",
      "labelNewTitle": "New label",
      "labelEditTitle": "Edit label",
      "labelDeleteConfirm": "Delete the label «{name}»? It is removed from every customer.",
      "duplicateTitle": "🔁 {name} is registered twice — merge them?",
      "duplicateMerge": "Merge",
      "duplicateNext": "Next"
    }
  },
  "broadcasts": {
    "b29b30": {
      "check": {
        "title": "Before you send",
        "template": {
          "ok": "Template approved",
          "warn": "Choose an approved template"
        },
        "official": {
          "ok": "Official number",
          "warn": "Unofficial number: only customers who wrote to you before"
        },
        "consent": {
          "ok": "Customers who agreed to receive",
          "warn": "No customer can receive this message"
        },
        "cost": {
          "ok": "Balance covers the cost",
          "warn": "Balance is not enough"
        }
      }
    },
    "pacing": {
      "title": "Daily send quota",
      "disabled": "Send pacing is off for this number.",
      "remaining": "{remaining} of {cap} messages left today",
      "coldRemaining": "{remaining} new chats left today",
      "breakerOpen": "Sending is paused until {time} after repeated failures.",
      "breakerClosed": "Sending is healthy",
      "short": "{remaining}/{cap} left today"
    },
    "nav": "Broadcasts",
    "title": "Broadcasts",
    "subtitle": "Send a message to a segment or list, with a pre-flight check and cost preview.",
    "new": "New broadcast",
    "empty": "No broadcasts yet.",
    "forbidden": "You don't have permission to view broadcasts.",
    "forbiddenCreate": "You don't have permission to create broadcasts.",
    "col": {
      "name": "Name",
      "status": "Status",
      "audience": "Audience",
      "created": "Created"
    },
    "status": {
      "draft": "Draft",
      "other": "Other"
    },
    "audience": {
      "label": "Audience",
      "all": "All customers",
      "segment": "Segment",
      "list": "Customer list",
      "pickSegment": "Choose a segment",
      "pickList": "Choose a list",
      "groupsNote": "Only individual customers are included. WhatsApp groups are never sent a broadcast.",
      "noSegments": "You have no segments yet.",
      "createSegment": "Create a segment",
      "noLists": "You have no customer lists yet.",
      "createList": "Create a list in Customers",
      "csv": "Upload a CSV",
      "csvFile": "CSV file",
      "csvHint": "One row per recipient. Pick the phone column; any other column can fill a variable.",
      "csvPhoneColumn": "Phone column",
      "csvCountry": "Country for local numbers",
      "csvCountrySA": "Saudi Arabia",
      "csvCountryBH": "Bahrain",
      "csvPreview": "Check the file",
      "csvUse": "Use audience",
      "csvSummary": "{valid} valid, {invalid} invalid, {duplicates} duplicates, out of {total} rows.",
      "csvInvalidTitle": "Invalid numbers",
      "csvDuplicateTitle": "Duplicate numbers",
      "csvRow": "Row {row}: {value}",
      "csvRowDuplicate": "Row {row}: {value} (same as row {first})",
      "csvReady": "{count} customers added from the CSV. Customers who opted out or are blocked were left out.",
      "csvConsent": "Template messages still go only to customers who opted in.",
      "csvErrorEmpty": "Choose a CSV file with a phone column.",
      "labels": "Customers by label",
      "labelsNote": "{count, plural, one {# label} other {# labels}} chosen from the customers page."
    },
    "composer": {
      "title": "New broadcast",
      "step": "Step {step} of {total}"
    },
    "step": {
      "1": "Audience",
      "2": "Message",
      "3": "Preview"
    },
    "name": "Broadcast name",
    "channel": "Send from",
    "createTemplateLink": "New template",
    "choose": "Choose…",
    "exclusions": "Exclusions",
    "exclude": {
      "segment": "Exclude segment {name}",
      "list": "Exclude list {name}"
    },
    "marketingApi": {
      "label": "Send via Meta Marketing Messages API",
      "hint": "Available for your WhatsApp number. Opt-outs, quiet hours, frequency caps and limits apply exactly as on the standard path."
    },
    "modeLabel": "Message mode",
    "mode": {
      "template": "Template (any opted-in contact)",
      "open_window": "Open window (24-hour window only)"
    },
    "template": "Approved template",
    "noApprovedTemplates": "This number has no approved templates yet.",
    "variable": "Variable {n}",
    "variableSource": "Value source for variable",
    "variableField": "Contact or order field",
    "variableLiteral": "Fixed text",
    "variableFieldPick": "Field for variable",
    "variableLiteralValue": "Text for variable",
    "openText": "Message text",
    "openTextHint": "Contacts outside the 24-hour window are excluded, never attempted.",
    "previewHint": "This is how the message will look.",
    "review": "Check audience",
    "next": "Next",
    "back": "Back",
    "saveDraft": "Save draft",
    "submit": "Submit broadcast",
    "draftSaved": "Draft saved.",
    "submitted": "Broadcast submitted.",
    "duplicate": "Duplicate",
    "duplicated": "Copied to a new draft.",
    "testSendPhone": "Test number",
    "testSendHint": "Approved test numbers or team phones only; not counted in the report.",
    "testSendButton": "Send test",
    "testSendDone": "Test message sent.",
    "suggestedMode": "Suggested mode for this audience: {name}.",
    "exceedsLimit": "The audience is larger than this number's messaging limit ({limit}).",
    "blockers": {
      "title": "This broadcast can't be sent yet:"
    },
    "blocker": {
      "ZERO_ELIGIBLE": "No eligible recipients remain after exclusions.",
      "CONTENT_REQUIRED": "Message text is required.",
      "TEMPLATE_REQUIRED": "Choose a template.",
      "TEMPLATE_NOT_APPROVED": "The template is not approved.",
      "TEMPLATE_PAUSED": "The template is paused by WhatsApp. Wait until it is active again or choose another template.",
      "TEMPLATE_DISABLED": "The template is disabled by WhatsApp. Create a new template.",
      "TEMPLATES_NOT_SUPPORTED": "This channel does not support templates.",
      "CHANNEL_NOT_CONNECTED": "The channel is not connected.",
      "INSUFFICIENT_BALANCE": "The wallet balance does not cover the estimated cost."
    },
    "qrRisk": {
      "title": "WhatsApp QR channel risk",
      "body": "Broadcasts on a QR channel only reach contacts who have messaged you before, at a lower hourly pace. Sending unsolicited bulk messages can get the number banned.",
      "count": "{eligible} of {total} contacts are eligible to receive this broadcast.",
      "excluded": "{count} contacts are skipped: no prior inbound message."
    },
    "funnel": {
      "title": "Pre-flight funnel",
      "total": "Total audience",
      "eligible": "Eligible recipients"
    },
    "reason": {
      "duplicates": "Duplicates",
      "invalidNumbers": "Invalid numbers",
      "optedOut": "Opted out",
      "notOptedIn": "Not opted in",
      "noPriorInbound": "No prior inbound message",
      "outsideWindow": "Outside the 24-hour window",
      "recentlyMessaged": "Recently messaged",
      "frequencyCapped": "Frequency capped"
    },
    "cost": {
      "title": "Cost preview",
      "estimate": "Estimated cost: {amount}",
      "balance": "Wallet balance: {amount}",
      "insufficient": "The wallet is short by {amount}. Top up or reduce the audience.",
      "line": "{country}: {count} × {unit} = {amount} ({source})",
      "source": {
        "observed": "your wallet average",
        "default": "Meta rate card"
      },
      "noRecipients": "No eligible recipients, so nothing will be charged."
    },
    "schedule": {
      "title": "When to send",
      "label": "Schedule for (optional)",
      "hint": "Leave empty to send as soon as the campaign is approved.",
      "timeZone": "Time zone: {zone}. The time you pick uses your device's time zone.",
      "pastError": "Choose a date and time in the future, or leave it empty to send now."
    },
    "rules": {
      "quietHours": "Quiet hours apply: messages that would arrive during your quiet hours wait until they end.",
      "optOut": "Customers who opted out, or never opted in, are skipped automatically.",
      "pauseHint": "After sending starts you can pause or resume it from the broadcasts list."
    },
    "controls": {
      "title": "Sending limits",
      "hint": "Optional. Leave empty to use the channel limits only.",
      "dailyCap": "Daily cap (messages per 24 hours)",
      "batchSize": "Batch size (messages per batch)",
      "batchInterval": "Wait between batches (minutes)",
      "batchPair": "Set the batch size and the wait together."
    },
    "report": {
      "subtitle": "Campaign results",
      "export": "Export CSV",
      "retry": {
        "button": "Retry failed",
        "hint": "Creates a new draft for the failed recipients. Opted-out and invalid numbers are skipped.",
        "done": "Draft created for {count} recipients ({skipped} skipped).",
        "error": "Could not create the retry draft."
      },
      "engagement": {
        "title": "Engagement",
        "delivered": "Delivered rate",
        "read": "Read rate",
        "replied": "Reply rate",
        "buttonClick": "Button click rate"
      },
      "failureReasons": {
        "title": "Failure reasons",
        "all": "All reasons",
        "filter": "Filter failed recipients by reason"
      },
      "back": "Back to campaigns",
      "total": "Audience",
      "queued": "Queued",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "failed": "Failed",
      "skipped": "Skipped",
      "statusLabel": "Status",
      "status": {
        "draft": "Draft",
        "pending_approval": "Awaiting approval",
        "scheduled": "Scheduled",
        "sending": "Sending",
        "paused": "Paused",
        "completed": "Done",
        "cancelled": "Cancelled",
        "failed": "Failed"
      },
      "statusHint": {
        "draft": "This campaign is a draft and has not been sent yet.",
        "pending_approval": "Waiting for approval before it can be sent.",
        "scheduled": "Scheduled and waiting to be sent.",
        "sending": "Sending now. The numbers below grow with every batch.",
        "paused": "Paused. No messages go out until you resume it.",
        "completed": "Sending is finished.",
        "cancelled": "Cancelled. The remaining messages were not sent.",
        "failed": "The campaign failed and was not sent. See the reasons in the table below."
      },
      "scheduledFor": "Scheduled for {when}",
      "startedAt": "Started {when}",
      "completedAt": "Finished {when}",
      "recipients": {
        "title": "Recipients",
        "caption": "Recipients of this campaign and what happened to each message",
        "empty": "No recipients yet.",
        "emptyHint": "The list of recipients is built when sending starts. It will show up here after that.",
        "name": "Recipient",
        "status": "Status",
        "time": "Time",
        "reason": "Reason",
        "noNumber": "No number available",
        "loadMore": "Show more",
        "loadError": "Could not load the recipients."
      },
      "reasons": {
        "contact_deleted": "The contact was deleted",
        "opted_out": "The customer opted out",
        "not_opted_in": "The customer has not opted in",
        "no_prior_inbound": "The customer never messaged this number",
        "frequency_capped": "Too many campaign messages recently",
        "failed": "WhatsApp could not deliver the message"
      }
    },
    "row": {
      "resume": "Continue editing",
      "report": "View report"
    },
    "stats": {
      "title": "Sending stats",
      "range": "Date range",
      "days": "{days} days",
      "broadcasts": "Broadcasts sent",
      "messages": "Messages sent",
      "deliveredRate": "Delivered",
      "readRate": "Read",
      "failed": "Failed",
      "replies": "Replies",
      "clicks": "Clicks",
      "trend": "Daily sent, delivered and read",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "empty": "No messages were sent in this period."
    },
    "overview": {
      "title": "Last 30 days",
      "campaigns": "Campaigns",
      "completed": "Completed",
      "readRate": "Read rate",
      "sent": "Messages sent",
      "failedRate": "Failed"
    },
    "col2": {
      "scheduled": "Scheduled",
      "processed": "Processed",
      "delivered": "Delivered",
      "read": "Read",
      "failed": "Failed",
      "actions": "Actions",
      "followUp": "Follow-up flow"
    },
    "status2": {
      "pending": "Pending",
      "processing": "Processing",
      "paused": "Paused",
      "on_hold": "On hold",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "failed": "Failed"
    },
    "pause": "Pause",
    "resume": "Resume",
    "hasFollowUp": "Mini-flow",
    "sequences": {
      "title": "Sequences",
      "hint": "Drip sequences run alongside broadcasts.",
      "empty": "No sequences yet.",
      "open": "Open sequences"
    },
    "followUp": {
      "label": "Continue with a flow",
      "none": "No follow-up (single message)",
      "hint": "Replies and buttons on the template continue in this flow (Cloud API only)."
    },
    "livePreview": {
      "title": "What your customer will see",
      "caption": "Updates as you type. Sample values only, nothing is sent.",
      "emptyText": "Type your message to see it here.",
      "emptyTemplate": "Pick a template to see it here.",
      "customerHi": "Hi",
      "qrRule": "QR channel: this broadcast only reaches contacts who already messaged you (prior inbound history). Everyone else is skipped.",
      "cloudTemplateRule": "Official channel: an approved template can be sent at any time, inside or outside the 24-hour window.",
      "cloudOpenRule": "Official channel: free text reaches only contacts inside the 24-hour window. Outside it you need an approved template."
    },
    "channelNote": {
      "cloud": "Official WhatsApp number: you can send approved templates to contacts who opted in, or free text inside the 24-hour window.",
      "qr": "WhatsApp number linked with a QR code: text and media only, and only to contacts who have messaged you before. Templates, buttons and flows are not available."
    },
    "qrStep": {
      "title": "Sending with a QR-linked number",
      "limits": "Plain text only. Messages go out slowly, one at a time, and your plan sets an hourly limit. Contacts who never messaged this number are skipped.",
      "risk": "Warning: WhatsApp can ban a number that sends many unwanted messages. Keep the audience small and relevant, and only people who expect to hear from you."
    },
    "openTextHintQr": "Only contacts who messaged this number before receive it. Everyone else is skipped.",
    "previewSampleNote": "Sample values: each person gets their own data. Nothing has been sent yet.",
    "variableHeader": "Header value",
    "variableButtonUrl": "Button {n} link ending",
    "variableButtonCode": "Button {n} copy code",
    "variableNamed": "Variable {name}",
    "variableCsv": "CSV column",
    "variableCsvPick": "CSV column for",
    "variableCsvFallback": "Fallback if empty",
    "b29b": {
      "firstCampaign": "First campaign?"
    }
  },
  "templates": {
    "categoryReview": {
      "title": "Review category before submitting",
      "description": "Meta bills and policy-checks by category. Confirm this template is correctly classified as {category}.",
      "cancel": "Cancel",
      "confirm": "Confirm and submit",
      "items": {
        "content_matches_category": "The message content matches the declared category",
        "marketing_vs_utility_confirmed": "I confirmed the marketing-vs-utility classification",
        "no_promotional_content_in_utility": "A utility template contains no promotional content"
      }
    },
    "nav": "Templates",
    "title": "Message templates",
    "forbidden": "You don't have permission to view templates.",
    "new": "New template",
    "channel": "WhatsApp Cloud number",
    "noCloudChannel": "Connect a WhatsApp Cloud number first — templates are not available on QR channels.",
    "filterStatus": "Status",
    "filterCategory": "Category",
    "all": "All",
    "empty": "No templates yet.",
    "loadFailed": "Could not load templates.",
    "rejectionReason": "Rejection reason: {reason}",
    "rejectionCode": {
      "INVALID_FORMAT": "The template format is invalid (check the name and the variables).",
      "ABUSIVE_CONTENT": "The wording was flagged as abusive or threatening.",
      "TAG_CONTENT_MISMATCH": "Meta found the content and the category out of sync.",
      "INCORRECT_CATEGORY": "The category does not match the content.",
      "PROMOTIONAL": "The message reads as promotional.",
      "SCAM": "The message looks like it requests sensitive information.",
      "NONE": "Meta did not give a specific reason.",
      "OTHER": "Meta rejected the template — review the wording and category."
    },
    "fixSuggestion": "Suggested fix",
    "edit": "Edit",
    "duplicate": "Duplicate",
    "duplicated": "Template duplicated",
    "delete": "Delete",
    "deleted": "Template deleted",
    "col": {
      "name": "Name",
      "category": "Category",
      "language": "Language",
      "status": "Status",
      "quality": "Quality"
    },
    "status": {
      "draft": "Draft",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "paused": "Paused",
      "disabled": "Disabled"
    },
    "category": {
      "marketing": "Marketing",
      "utility": "Utility",
      "authentication": "Authentication"
    },
    "language": {
      "en": "English",
      "ar": "Arabic"
    },
    "editor": {
      "titleNew": "New template",
      "titleEdit": "Edit template",
      "name": "Template name",
      "nameHint": "Lowercase letters, digits and underscores only.",
      "category": "Category",
      "language": "Language",
      "header": "Header (optional)",
      "body": "Body",
      "bodyHint": "Use '{{'1'}}', '{{'2'}}' … for variables.",
      "example": "Example value for variable {n}",
      "footer": "Footer (optional)",
      "buttons": "Buttons",
      "addButton": "Add button",
      "removeButton": "Remove button",
      "buttonText": "Button text",
      "buttonUrl": "URL",
      "buttonPhone": "Phone number",
      "buttonExample": "Example value",
      "save": "Save draft",
      "saved": "Template saved",
      "submit": "Submit",
      "submitted": "Submitted — waiting for Meta review",
      "notEditable": "This template can no longer be edited because it was already submitted.",
      "duplicate": "A template with this name and language already exists.",
      "notSupported": "Templates are only available on WhatsApp Cloud channels.",
      "readOnly": "Read-only",
      "errorsTitle": "Fix these before submitting",
      "hintsTitle": "Suggestions",
      "validating": "Checking…",
      "cancel": "Back to templates",
      "headerFormat": "Header type",
      "headerNone": "None",
      "headerText": "Text",
      "headerImage": "Image",
      "headerVideo": "Video",
      "headerDocument": "Document",
      "headerLocation": "Location",
      "headerMedia": "Sample media URL or handle",
      "uploadSample": "Upload a sample file",
      "sampleUploaded": "Sample uploaded to WhatsApp.",
      "sampleHint": "Image JPG/PNG up to 5 MB, video MP4 up to 16 MB, document PDF up to 100 MB.",
      "sampleErrors": {
        "unsupported_type": "This file type is not allowed for this header. Use JPG/PNG, MP4 or PDF to match the header type.",
        "too_large": "The file is too large for this header type.",
        "empty": "The file is empty.",
        "failed": "Could not upload the sample. Try again."
      },
      "exampleRequired": "Enter an example value for variable {n} — WhatsApp requires it before review.",
      "type": "Template type",
      "typeStandard": "Standard",
      "typeCarouselMedia": "Carousel (media)",
      "typeCarouselProduct": "Carousel (products)",
      "typeLimitedTimeOffer": "Limited-time offer",
      "typeAuth": "Authentication (OTP)",
      "typeAuthentication": "Authentication (OTP)",
      "typeAuthHint": "Category is set to Authentication and a copy-code button is added.",
      "cards": "Carousel cards",
      "addCard": "Add card",
      "removeCard": "Remove card",
      "cardMedia": "Card media URL or handle",
      "cardBody": "Card text",
      "cardProduct": "Product retailer ID",
      "cardButtonsHint": "Card buttons: every card gets these buttons (Meta requires the same buttons on all cards).",
      "ltoText": "Offer text (max 16 characters)",
      "ltoHasExpiration": "Show an expiry countdown",
      "codeExpiration": "Code expires after (minutes)",
      "securityRecommendation": "Add the security recommendation (\"Do not share this code\")",
      "buttonFlowId": "WhatsApp Flow ID",
      "insertVariable": "Insert variable",
      "pickField": "Choose a contact field…",
      "improve": "Improve",
      "improveRewrite": "Rewrite",
      "improveShorten": "Shorten",
      "improveTranslate": "Translate",
      "improveSuggestion": "Suggestion (nothing is saved until you apply it)",
      "improveApply": "Apply",
      "improveDiscard": "Discard",
      "improveFailed": "Could not get a suggestion.",
      "tabContent": "Content",
      "tabVariables": "Variables",
      "variablesHint": "Map each '{{'n'}}' to a contact, order or booking field once; every flow, sequence and broadcast reuses it.",
      "variablesSaveFirst": "Save the template first to map its variables.",
      "parameterFormat": "Variable style",
      "parameterPositional": "Numbers ('{{'1'}}', '{{'2'}}')",
      "parameterNamed": "Names ('{{'customer_name'}}')",
      "parameterNamedHint": "Use lowercase letters, numbers and underscores, for example '{{'customer_name'}}'. Each name needs a sample value.",
      "exampleNamed": "Sample for {name}",
      "editOnMeta": "Send edit",
      "editOnMetaHint": "This template is already on Meta. Edits go back to review. The category cannot change.",
      "editRemaining": "Edits left in 30 days: {n} of 10 (one edit every 24 hours).",
      "editLimitDaily": "You edited this template less than 24 hours ago. You can edit again on {when}.",
      "editLimitMonthly": "You used all 10 edits for 30 days. You can edit again on {when}.",
      "editCategoryLocked": "The category of an approved template cannot be changed.",
      "editFailed": "Meta did not accept the edit. Check the text and try again.",
      "editSent": "Edit sent to Meta for review"
    },
    "buttonType": {
      "quick_reply": "Quick reply",
      "url": "URL",
      "phone": "Phone call",
      "copy_code": "Copy code",
      "otp": "One-time password",
      "flow": "Flow",
      "catalog": "Catalog",
      "mpm": "Multi-product",
      "spm": "View product"
    },
    "preview": {
      "title": "Preview",
      "counter": "{count} characters",
      "header": "Header",
      "body": "Body",
      "footer": "Footer",
      "noSample": "Add a sample for every variable to see the final message."
    },
    "starter": {
      "button": "＋ Start with ready templates",
      "hint": "Adds 20 ready-made Arabic and English drafts.",
      "created": "Starter set created: {created} of {total} templates added as drafts.",
      "partial": "Some starter templates were created ({created} of {total}). Try again to add the rest.",
      "alreadyExist": "The starter set already exists — nothing was added."
    },
    "library": {
      "title": "Template library",
      "subtitle": "Browse Meta's ready-made templates and import one as a draft.",
      "import": "Import",
      "imported": "Imported as a draft",
      "empty": "The library is empty.",
      "loadFailed": "Could not load the library."
    },
    "presets": {
      "title": "Variable mapping presets",
      "subtitle": "Choose what fills each variable when this template is sent.",
      "name": "Preset name",
      "variable": "Variable {n}",
      "source": "Source",
      "sourceField": "Contact / order field",
      "sourceLiteral": "Fixed text",
      "field": "Field",
      "fallback": "Fallback text",
      "literal": "Text",
      "add": "Save preset",
      "delete": "Delete preset",
      "empty": "No presets yet.",
      "noVariables": "This template has no variables.",
      "invalid": "The mapping is incomplete: map every variable in the body.",
      "saved": "Preset saved"
    },
    "error": {
      "invalid_shape": "The template structure is invalid.",
      "invalid_name": "Use only lowercase letters, digits and underscores in the name.",
      "invalid_language": "The language code is not valid.",
      "invalid_category": "Choose a valid category.",
      "body_required": "The body text is required.",
      "body_too_long": "The body is too long (max 1024 characters).",
      "header_too_long": "The header is too long (max 60 characters).",
      "header_text_required": "The header needs text.",
      "header_too_many_variables": "The header can contain at most one variable.",
      "footer_too_long": "The footer is too long (max 60 characters).",
      "footer_has_variable": "The footer cannot contain variables.",
      "too_many_buttons": "Too many buttons (max 10).",
      "button_text_required": "Every button needs text.",
      "button_text_too_long": "Button text is too long (max 25 characters).",
      "button_invalid": "This button has an invalid or missing value.",
      "variables_not_sequential": "Variables must be numbered '{{'1'}}', '{{'2'}}', '{{'3'}}' … without gaps.",
      "examples_missing": "Add an example value for every variable.",
      "promotional_in_utility": "Promotional wording is not allowed in a Utility template — rephrase it or switch to Marketing.",
      "otp_requires_authentication": "One-time-password buttons require the Authentication category.",
      "authentication_only_otp_buttons": "Authentication templates can only use one-time-password buttons.",
      "carousel_invalid": "The carousel is invalid.",
      "limited_time_offer_invalid": "The limited-time offer needs Marketing, offer text of up to 16 characters, a URL button and no footer.",
      "authentication_header_not_allowed": "Authentication templates cannot have a header.",
      "code_expiration_invalid": "The code expiry must be a whole number of minutes between 1 and 90."
    },
    "hint": {
      "variable_at_start": "Meta often rejects bodies that start with a variable — add some text before it.",
      "variable_at_end": "Meta often rejects bodies that end with a variable — add some text after it.",
      "variable_density": "Too many variables for the amount of text — add more wording around them."
    },
    "fix": {
      "invalid_format": "Check the variable format and remove unsupported characters or line breaks around variables.",
      "abusive_content": "Remove offensive or threatening wording and resubmit.",
      "category_mismatch": "The content does not match the chosen category — change the category or rewrite the message.",
      "promotional_content": "The message reads as promotional — move it to Marketing or remove the promotional wording.",
      "scam_content": "Remove requests for sensitive information such as passwords or card numbers.",
      "unknown": "Meta did not give a specific reason — review the wording and category, then resubmit."
    },
    "quality": {
      "green": "High quality",
      "yellow": "Medium quality",
      "red": "Low quality",
      "unknown": "No rating yet"
    },
    "sync": "Sync from Meta",
    "syncing": "Syncing…",
    "synced": "Synced: {created} new, {updated} updated, {unchanged} unchanged",
    "syncEmpty": "Meta has no templates for this WhatsApp Business account yet. Create one here or in Meta WhatsApp Manager, then sync again.",
    "syncSkipped": "{skipped, plural, one {# template was skipped.} other {# templates were skipped.}}",
    "syncFailed": "Could not sync with Meta.",
    "b29b": {
      "tabs": {
        "own": "Mine",
        "gallery": "Gallery",
        "market": "Marketplace"
      },
      "statusHint": {
        "draft": "Draft: saved here only, not sent to Meta. Finish it, then submit for review.",
        "pending": "Pending: Meta is reviewing it, usually within minutes. Wait.",
        "approved": "Approved: you can send it after the 24-hour window ends.",
        "rejected": "Rejected: the reason is under the name. Open it, fix it and submit again."
      },
      "var": {
        "contact_firstName": "First name",
        "contact_name": "Customer name",
        "contact_phone": "Customer phone",
        "order_number": "Order number",
        "order_total": "Order total",
        "booking_date": "Booking date"
      }
    }
  },
  "crm": {
    "b29": {
      "stage": {
        "add": "＋ New stage",
        "addTitle": "New stage",
        "renameTitle": "Edit stage",
        "name": "Stage name",
        "nameRequired": "Write a stage name",
        "color": "Colour",
        "save": "Save",
        "menu": "Stage {name} options",
        "rename": "Rename / colour",
        "delete": "Delete stage",
        "deleteHint": "Move its deals to another stage first"
      },
      "deal": {
        "menu": "Deal {name} options"
      }
    },
    "notes": {
      "title": "Internal notes",
      "label": "Internal note",
      "placeholder": "Write a note for your team. Type @ to mention a teammate.",
      "mentions": "Mention a teammate",
      "add": "Add note"
    },
    "tasks": {
      "title": "Tasks",
      "view": {
        "mine": "My tasks",
        "team": "Team tasks"
      },
      "empty": "No tasks yet.",
      "due": "Due {date}",
      "overdue": "Overdue",
      "recurring": "Repeats",
      "complete": "Complete",
      "newTitle": "New task",
      "dueAt": "Due date (YYYY-MM-DD)",
      "invalidDate": "Enter the due date as YYYY-MM-DD.",
      "add": "Add task"
    },
    "timeline": {
      "title": "Activity",
      "all": "All",
      "empty": "No activity yet.",
      "loadMore": "Load more",
      "firstContact": "First contact on {channel}",
      "igComment": "Commented on Instagram: {text}",
      "groupJoin": "Joined group {name}",
      "labelAdded": "Label added: {name}",
      "task": {
        "created": "Task created: {name}",
        "completed": "Task completed: {name}"
      },
      "type": {
        "note": "Notes",
        "task": "Tasks",
        "label": "Labels",
        "message": "Messages",
        "flow_run": "Flow runs",
        "commerce": "Commerce",
        "booking": "Bookings"
      },
      "message": {
        "inbound": "Customer message: {text}",
        "outbound": "Message to customer: {text}"
      },
      "channelDot": "Channel: {channel}"
    }
  },
  "pipeline": {
    "nav": "Pipeline",
    "title": "Sales pipeline",
    "select": "Deals board",
    "moveTo": "Move to stage",
    "lostReasonPrompt": "Reason for losing this deal?",
    "stageChip": "Stage",
    "strip": {
      "title": "Deals pipeline",
      "show": "Show deals pipeline",
      "hide": "Hide deals pipeline",
      "loading": "Loading deals",
      "emptyStage": "No deals here",
      "moveTo": "Move to",
      "moveToFor": "Move deal {name} to",
      "open": "Open {name}",
      "moveError": "Could not move the deal. Nothing changed.",
      "chipsLabel": "Deal stage",
      "channel": "Channel: {channel}",
      "emptyTitle": "No deals yet",
      "emptyHint": "Deals you create from a chat appear here by stage.",
      "stageTotal": "Total {amount}",
      "pipelineLabel": "Deals board"
    },
    "deal": {
      "new": "New deal",
      "editTitle": "Edit deal",
      "edit": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Delete this deal permanently?",
      "fieldTitle": "Deal title",
      "fieldAmount": "Amount",
      "fieldCurrency": "Currency",
      "fieldStage": "Stage",
      "fieldContact": "Contact",
      "contactSearch": "Search a contact by name or phone",
      "contactNone": "No matching contacts. Add a contact first.",
      "addContact": "Add a contact",
      "save": "Save",
      "cancel": "Cancel",
      "invalid": "Enter a title and a valid amount, and pick a contact."
    },
    "lostReason": {
      "title": "Mark deal as lost",
      "confirm": "Mark lost",
      "required": "Enter a reason to continue."
    },
    "b29b": {
      "help": "A board to follow your deals from the first message to payment. Each column is a stage; drag a deal between them.",
      "emptyTitle": "Follow your deals from the first message to payment",
      "newDeal": "➕ Deal",
      "useTemplates": "🧩 Use ready stages",
      "templatesTitle": "Ready stages",
      "apply": "Apply",
      "openChat": "Open conversation",
      "openChatFailed": "Could not open the conversation.",
      "templates": {
        "generic": "General",
        "realEstate": "Real estate",
        "services": "Services",
        "travel": "Travel"
      }
    }
  },
  "sequences": {
    "nav": "Message sequences",
    "noChannel": "Connect a channel first.",
    "nameLabel": "Sequence name",
    "create": "Create",
    "save": "Save steps",
    "markReady": "Mark ready",
    "stepCount": "{n} steps",
    "page": {
      "title": "Message sequences",
      "subtitle": "Drip messages that send automatically, inside or outside the 24-hour window."
    },
    "status": {
      "draft": "Draft",
      "ready": "Ready",
      "paused": "Paused",
      "archived": "Archived"
    },
    "step": {
      "title": "Step {n}",
      "moveUp": "Move step up",
      "moveDown": "Move step down",
      "remove": "Remove",
      "add": "Add step",
      "typeLabel": "Type",
      "typeText": "Text",
      "typeMedia": "Media",
      "typeInteractive": "Interactive",
      "delay": "Delay (minutes)",
      "text": "Message",
      "template": "Template fallback",
      "templateNone": "No template",
      "templateHint": "Approved templates only; used automatically when the 24-hour window is closed.",
      "windowEnable": "Preferred delivery window",
      "windowStart": "From",
      "windowEnd": "To",
      "windowTimezone": "Timezone",
      "noFallback": "This step needs an approved template fallback before the sequence can be ready."
    },
    "exit": {
      "title": "Exit conditions",
      "reply": "Contact replies",
      "optOut": "Contact opts out (marketing sequences)",
      "labelIds": "Label IDs that end the sequence (comma separated)",
      "goalEvents": "Goal events that end the sequence (comma separated, e.g. order.paid)"
    },
    "stats": {
      "title": "Analytics",
      "enrolled": "Enrolled",
      "active": "Active",
      "completed": "Completed",
      "exited": "Exited",
      "step": "Step",
      "sent": "Sent",
      "read": "Read",
      "replied": "Replied",
      "exitedAfter": "Exited",
      "converted": "Converted",
      "dropoff": "Drop-off",
      "totals": "Delivery summary",
      "processed": "Processed",
      "delivered": "Delivered",
      "failedTotal": "Failed / unreached",
      "lastSent": "Last sent",
      "never": "Not yet"
    },
    "intro": {
      "title": "How sequences work",
      "what": "Messages sent automatically over several days after an event, such as a purchase.",
      "when": "Use them to follow up after a purchase or to send reminders: a welcome on day 0, a reminder on day 2, an offer on day 7.",
      "step1": "Create a new sequence with the name you want.",
      "step2": "Add the messages and set the delay between each one and the next.",
      "step3": "Press “Mark ready” to start sending.",
      "businessName": "Rose Garden",
      "caption": "Example: a post-purchase follow-up with three messages over seven days.",
      "day0": "Day 0",
      "day2": "Day 2",
      "day7": "Day 7",
      "msg1": "Hi Sara! Thanks for your order from Rose Garden. We hope you love the bouquet.",
      "msg2": "How did the bouquet arrive? We would love to hear what you think.",
      "msg3": "A gift from us: 10% off your next order.",
      "msg3Button": "Shop now"
    },
    "bulk": {
      "title": "Add contacts to this sequence",
      "bySelection": "Pick contacts",
      "byLabel": "By label",
      "search": "Search contacts",
      "label": "Label",
      "choose": "Choose a label",
      "assign": "Add",
      "none": "Pick at least one contact or a label.",
      "result": "{enrolled} added, {skipped} skipped (already in, opted out or not eligible)"
    }
  },
  "aiAgents": {
    "styleConflict": {
      "title": "Your instructions ask for a style that the style settings override:",
      "greeting": {
        "warm": "The instructions ask for a greeting, but the greeting setting is off. Suggested: warm greeting."
      },
      "emoji": {
        "many": "The instructions ask for more emojis than the setting allows. Suggested: many emojis.",
        "few": "The instructions ask for an emoji, but emojis are off. Suggested: a few emojis.",
        "none": "The instructions say no emojis, but emojis are on. Suggested: no emojis."
      },
      "format": {
        "list": "The instructions ask for one item per line, but the format setting is different. Suggested: list."
      },
      "closing": {
        "question": "The instructions ask to end with a question, but the closing setting is off. Suggested: end with a question.",
        "thanks": "The instructions ask to end with thanks, but the closing setting is different. Suggested: end with thanks."
      },
      "apply": "Match"
    },
    "model": {
      "provider": "AI provider",
      "model": "Model",
      "workspaceDefault": "Workspace default",
      "providerDefault": "Provider default model",
      "cost": "Approx. cost per 1M tokens: input {input}, output {output}",
      "fallbackList": "Showing the built-in model list (the live list could not be loaded).",
      "hint": "Only providers connected in AI settings appear here. If the chosen one fails, the assistant falls back to the workspace default."
    },
    "console": {
      "fakeWhyMode": "Why: the platform runs in demo AI mode and no provider key is connected for this workspace. Connect a provider (e.g. OpenRouter) in AI settings.",
      "fakeWhyByok": "Why: demo replies are forced by the AI_BYOK_FAKE setting even though a provider key is connected. Ask the platform admin to turn it off.",
      "title": "Agent test console",
      "sandboxNote": "Practice area: nothing reaches customers, no conversation is opened and no credits are deducted.",
      "fakeBanner": "Demo mode: the AI here is a stand-in, so replies are fixed placeholder text, not real answers.",
      "runProbes": "Run adversarial probes",
      "probeExpected": "Expected",
      "probeObserved": "Observed",
      "pass": "Pass",
      "fail": "Fail",
      "noProbes": "No probes have been run yet.",
      "diverged": "Diverged from template (informational)",
      "inSync": "Matches template defaults",
      "behavior": {
        "grounded": "Grounded answer",
        "refusal": "Refusal",
        "handoff": "Handoff to a human"
      }
    },
    "unpublished": {
      "banner": "Not published: customers get no AI replies. Finish the items below, then publish."
    },
    "publish": "Publish agent",
    "published": "Published",
    "dataUse": "I acknowledge how customer data is used",
    "checklist": {
      "title": "Publish compliance checklist",
      "agent_type": "Agent scope is set",
      "persona": "Persona is written",
      "language": "Reply language is set",
      "handoff_rule": "Handoff rule to a human",
      "data_use_disclosure": "Data-use disclosure acknowledged",
      "kb_sources": "Knowledge sources bound, or strict sources off"
    },
    "title": "AI agent editor",
    "empty": "No AI agents yet.",
    "pick": "Agent",
    "persona": "Persona",
    "instructions": "Instructions",
    "language": "Reply language",
    "lang": {
      "auto": "Match the customer",
      "ar": "Arabic",
      "en": "English"
    },
    "guardrails": "Guardrails",
    "strict": "Answer only from sources (otherwise hand off)",
    "fallbackMode": "When the knowledge base has no answer",
    "fallbackOffer": "Offer to connect a person (recommended)",
    "fallbackHandoff": "Hand off to a person immediately",
    "smallTalk": "Reply to greetings and thanks",
    "suggestRelated": "Offer one related product after answering",
    "interactiveReplies": "Buttons & lists",
    "interactiveRepliesHint": "Official WhatsApp and Instagram only",
    "injection": "Prompt-injection protection",
    "pii": "Redact personal data in prompts",
    "testModeTitle": "Test mode",
    "testModeEnable": "Turn on test mode",
    "testModeHelp": "When on, the agent replies only to the numbers below. Everyone else is ignored by the AI (your team still sees the chat in the inbox) and no AI credits are spent.",
    "testModePhones": "Allowed numbers (comma separated, with country code)",
    "testModeBadge": "Test mode",
    "offTopic": "When off-topic",
    "offTopicRefuse": "Politely refuse",
    "offTopicHandoff": "Hand off to a person",
    "scopeTopics": "Allowed topics (comma separated)",
    "handoff": "Handoff rules",
    "maxTurns": "Max AI turns before handoff",
    "keywords": "Handoff keywords (comma separated)",
    "save": "Save",
    "saved": "Saved",
    "test": {
      "title": "Test chat",
      "message": "Test message",
      "send": "Send",
      "sources": "Sources",
      "reason": "Handoff reason",
      "handoff": "(handed off to a person)",
      "tools": "Tools called",
      "noTools": "No tool called",
      "channel": "Channel",
      "channels": {
        "whatsapp_cloud": "Official WhatsApp",
        "instagram": "Instagram",
        "whatsapp_waha": "QR number"
      },
      "answeredBy": "Answered by {name}",
      "transferredTo": "Handed over to {name}",
      "returnedToMain": "Back to the main agent",
      "startedFlow": "Started a flow",
      "listOpen": "Choose",
      "sim": {
        "toolbar": "Chat settings",
        "thread": "Chat messages",
        "customer": "Customer",
        "assistant": "Assistant",
        "typing": "Typing…",
        "newChat": "New chat",
        "emptyHint": "Type a message the way your customer would, or try a suggestion.",
        "suggestions": {
          "hours": "What are your opening hours?",
          "price": "How much does it cost?",
          "human": "I want to talk to a person"
        },
        "handoffChip": "Handed to a person",
        "toolChip": "Tool",
        "sourcesChip": "Sources",
        "composer": "Type a message"
      }
    },
    "voiceSettings": {
      "title": "Voice transcription",
      "toggle": "Transcribe inbound voice notes",
      "budget": "Daily budget (minutes)",
      "usage": "Used today: {used} of {budget} minutes",
      "save": "Save"
    },
    "create": "Create agent",
    "newAgentName": "New AI agent",
    "openConsole": "Open test console",
    "setupWizard": "AI setup guide",
    "livePreview": {
      "title": "Greeting and sample answer",
      "caption": "Illustration: canned sample text for the chosen tone. No model is called.",
      "badge": "Illustration",
      "tone": "Tone",
      "tone_auto": "Detect from persona",
      "tone_friendly": "Friendly",
      "tone_formal": "Formal",
      "tone_concise": "Concise",
      "customerQuestion": "What are your opening hours?",
      "greeting_friendly": "Hi there! I'm {name}, happy to help. What can I do for you?",
      "greeting_formal": "Good day. I am {name}, the virtual assistant. How may I assist you?",
      "greeting_concise": "{name} here. How can I help?",
      "answer_friendly": "Great question! We're open every day from 9 am to 9 pm. Anything else I can help with?",
      "answer_formal": "Our opening hours are 9:00 to 21:00, every day. Please let me know if you require further assistance.",
      "answer_concise": "Open daily, 9 am to 9 pm."
    },
    "liveTable": {
      "title": "Live table (Google Sheet)",
      "hint": "Connect a Google Sheet with your trips, seats, stock or prices. The agent answers availability and price questions only from this table (refreshed every 5 minutes) and hands off to your team when no row matches.",
      "sheet": "Sheet link or ID",
      "loadTabs": "Load tabs",
      "tab": "Tab",
      "preview": "Column mapping preview",
      "remove": "Remove live table",
      "field": {
        "item": "Item (required)",
        "date": "Date",
        "price": "Price",
        "seats": "Seats / stock",
        "link": "Link"
      }
    },
    "businessInfo": {
      "title": "Business location and files",
      "hint": "Used by the send location and send file tools. Turn those tools on in the tools list. Files must be https links.",
      "name": "Place name",
      "address": "Address",
      "lat": "Latitude",
      "lng": "Longitude",
      "mapsUrl": "Map link (optional)",
      "filesTitle": "Files the AI can send (up to 10)",
      "filesHint": "The AI only picks a file by its short key; it never invents links.",
      "fileKey": "Key (letters, numbers, - _)",
      "fileTitle": "Title",
      "fileUrl": "File link (https)",
      "fileKind": "Type",
      "kindImage": "Image",
      "remove": "Remove",
      "add": "Add a file"
    },
    "sheetRows": {
      "title": "Google Sheets for reading and writing rows",
      "hint": "Up to 5 sheets. Give each a short name the AI uses to pick it, then choose read only or read and write. Turn the sheet tools on in the tools list.",
      "sheet": "Spreadsheet link or ID",
      "tab": "Tab name",
      "name": "Sheet name (label)",
      "access": "Access",
      "accessRead": "Read only",
      "accessWrite": "Read and write",
      "add": "Add a sheet",
      "remove": "Remove sheet"
    },
    "leadSheet": {
      "title": "Lead capture (Google Sheet)",
      "hint": "Let the agent save qualified leads to a Google Sheet. Pick the tab and map each lead field to a column. The customer's phone number is taken from the chat, never from the model.",
      "sheet": "Lead sheet link or ID",
      "loadTabs": "Load lead tabs",
      "tab": "Lead tab",
      "preview": "Lead column mapping preview",
      "remove": "Remove lead sheet",
      "field": {
        "name": "Name",
        "phone": "Phone",
        "request": "Request",
        "label": "Label",
        "capturedAt": "Captured at"
      }
    },
    "sellFromStore": "Sell from my store (search products and share links)",
    "followupNudge": "Follow up once if a customer goes quiet after asking about a product or trip (QR number only)",
    "followupNudgeHint": "Sent once, after the delay below. Skipped during quiet hours, after opt-out, or when a human takes over.",
    "followupNudgeHours": "Hours of silence before the follow-up",
    "team": {
      "title": "Team",
      "explain": "The main agent hands the customer to the right member in the same reply, and the member hands them back when done.",
      "qrHint": "Flows do not run on QR numbers; on QR the agent answers by itself.",
      "kindAgent": "AI assistant",
      "kindFlow": "Flow",
      "kind": "Type",
      "pick": "Member",
      "pickPlaceholder": "Choose a member",
      "whenToUse": "When to use",
      "whenPlaceholder": "Example: when the customer asks about prices or wants to buy",
      "unpublished": "Not published",
      "remove": "Remove member",
      "max": "A team has at most 8 members.",
      "overview": "Team overview"
    }
  },
  "knowledge": {
    "error": {
      "file_missing": "The uploaded file could not be found. Upload it again.",
      "KB_FILE_TYPE_UNSUPPORTED": "This file type is not supported.",
      "KB_FILE_PARSE_FAILED": "The file could not be read.",
      "KB_FILE_TOO_LARGE": "The file is too large.",
      "generic": "Indexing failed. Try again or upload it again."
    },
    "nav": "Knowledge base",
    "title": "Knowledge base",
    "titleLabel": "Title",
    "kindLabel": "Source type",
    "kind": {
      "text": "Text",
      "faq": "FAQ pairs",
      "url": "URL",
      "site": "Website (crawl)"
    },
    "contentLabel": "Content",
    "siteLabel": "Website URL (same-site pages, up to 50)",
    "siteAdded": "{n} website added: pages are being crawled and indexed, then re-synced weekly.",
    "siteNone": "No new pages found in the sitemap.",
    "urlLabel": "URL",
    "questionLabel": "Question",
    "answerLabel": "Answer",
    "add": "Add source",
    "empty": "No information added yet. Add your prices, opening hours and policies so the assistant can answer from them.",
    "status": {
      "queued": "Queued",
      "chunking": "Chunking",
      "embedding": "Embedding",
      "ready": "Ready",
      "error": "Failed"
    },
    "chunks": "{n} chunks",
    "retry": "Retry",
    "delete": "Delete",
    "usage": "{sources} of {max} sources",
    "searchTitle": "Test search",
    "searchLabel": "Question",
    "searchAction": "Search",
    "noHits": "No matching passages.",
    "score": "Score {score}",
    "limit": "Plan limit reached.",
    "lastSynced": "Last synced {time}",
    "save": "Save source",
    "cancel": "Cancel",
    "reindex": "Re-index",
    "chooseFile": "Choose files",
    "fileTooLarge": "{name} is larger than 20 MB. Choose a smaller file.",
    "uploading": "Uploading…",
    "dropHint": "Drag and drop files here to add them to your knowledge base",
    "dropFormats": "PDF, DOCX, TXT, MD or CSV, up to 20 MB each",
    "emptyCta": "Get started",
    "citationOpen": "View passage",
    "citationTitle": "Source passage",
    "citationSource": "Source: {name} (passage {n})",
    "citationClose": "Close",
    "deleteTitle": "Delete source",
    "deleteMessage": "Delete \"{name}\"? AI agents will no longer answer from it.",
    "deleteConfirm": "Delete source",
    "website": {
      "b29b": {
        "readMore": "Read more pages",
        "upgrade": "Upgrade"
      },
      "addButton": "Add website",
      "wizardTitle": "Add a website",
      "wizardIntro": "We read your website's pages, including product prices and links, so your AI agents can answer from them.",
      "step": "Step {n} of 2",
      "urlLabel": "Website address",
      "urlHint": "For example https://yourstore.com",
      "titleLabel": "Name (optional)",
      "languageLabel": "Main language of the website",
      "language": {
        "ar": "Arabic",
        "en": "English"
      },
      "maxPagesLabel": "Maximum pages",
      "maxPagesHint": "Up to {max} pages on your plan.",
      "resyncLabel": "Read the website again",
      "resync": {
        "daily": "Every day",
        "weekly": "Every week",
        "off": "Only when I ask"
      },
      "start": "Start reading",
      "close": "Close",
      "done": "Done",
      "backgroundNote": "You can close this window. Reading continues in the background.",
      "state": {
        "queued": "Waiting to start",
        "running": "Reading pages",
        "done": "Finished",
        "error": "Stopped"
      },
      "progress": {
        "pages": "{done} of {total} pages read",
        "indexed": "{n} added",
        "unchanged": "{n} unchanged",
        "failed": "{n} failed",
        "label": "Reading progress"
      },
      "limitReached": "The page limit was reached.",
      "crawlError": "We could not finish reading this website. Check the address and try again.",
      "recrawl": "Read again",
      "pagesShow": "Show pages",
      "pagesHide": "Hide pages",
      "pagesTitle": "Pages from {name}",
      "pagesEmpty": "No pages read yet.",
      "pagesLoading": "Loading pages…",
      "enabledLabel": "Use in answers",
      "edit": "Edit",
      "editTitle": "Edit page",
      "contentLabel": "Page text",
      "contentHint": "Leave empty to keep the text read from the website. Text you enter replaces it.",
      "saveEdit": "Save changes",
      "remove": "Remove",
      "removeTitle": "Remove page",
      "removeMessage": "Remove \"{name}\"? AI agents will no longer answer from it.",
      "removeConfirm": "Remove page",
      "deleteMessage": "Delete \"{name}\" and all of its pages? AI agents will no longer answer from them.",
      "product": "Product",
      "availability": {
        "in_stock": "In stock",
        "out_of_stock": "Out of stock",
        "preorder": "Pre-order",
        "unknown": "Availability unknown"
      },
      "error": {
        "KB_VALIDATION_FAILED": "Enter a valid public website address that starts with https://.",
        "KB_LIMIT_EXCEEDED": "Your plan's limit for business information is reached. Remove sources or upgrade to add this website."
      }
    },
    "crawlPartial": "Part of the site was not reached in the last sync (time limit). Those pages keep their previous content and will refresh on the next sync."
  },
  "automation": {
    "nav": "Automation",
    "title": "System replies",
    "intro": "Automatic replies for common customer messages. Override any reply per channel.",
    "enabled": "Enabled",
    "contentAr": "Arabic text",
    "contentEn": "English text",
    "frequency": "Frequency",
    "freq": {
      "every_time": "Every time",
      "once_per_hour": "Once per hour",
      "once_per_day": "Once per day",
      "once_per_month": "Once per month",
      "custom": "Custom: every {count} hours"
    },
    "capHours": "Send at most once every N hours (empty = every time)",
    "scope": "Applies to",
    "scopeDefault": "All channels (default)",
    "save": "Save",
    "saved": "Saved",
    "modeTitle": "Automation mode per channel",
    "mode": {
      "none": "No automation",
      "ai_agent": "AI Agent",
      "flow": "Chat flows"
    },
    "agent": "AI Agent",
    "agentNone": "Select an agent",
    "qrNote": "QR channels support the AI Agent only.",
    "kinds": {
      "welcome": "Welcome message",
      "away_message": "Out of hours",
      "get_started": "Get-started message",
      "location_received": "Location-received reply",
      "no_match": "No-match reply",
      "main_menu": "Main menu",
      "back_to_bot": "Back to automation",
      "language_switch": "Language switch",
      "talk_to_human": "Talk to a human (in hours)",
      "talk_to_human_off_hours": "Talk to a human (out of hours)",
      "unsubscribe": "Unsubscribe",
      "resubscribe": "Resubscribe",
      "order_confirm": "Order confirm",
      "order_cancel": "Order cancel"
    },
    "mainMenu": {
      "body": "Need anything else? Tap below to return to the main menu.",
      "button": "Main menu"
    }
  },
  "kbFix": {
    "nav": "Fix assistant answers",
    "mark": {
      "action": "Mark wrong",
      "title": "Correct this AI reply",
      "correctionLabel": "What should the reply have said?",
      "submit": "Submit correction",
      "cancel": "Cancel",
      "submitted": "Correction sent for review"
    },
    "queue": {
      "newCandidates": "New Q&A candidates",
      "wrongReply": "Wrong reply",
      "correction": "Correction",
      "approve": "Approve",
      "reject": "Reject"
    }
  },
  "notifications": {
    "b29b": {
      "typeLabel": "Notification type",
      "viewErrors": "Open the errors page",
      "flowFailuresToday": "{count, plural, one {# flow error today} other {# flow errors today}}",
      "taskDue": {
        "title": "Task due: {title}",
        "body": "Customer: {name}"
      }
    },
    "bell": {
      "label": "Notifications",
      "empty": "You're all caught up.",
      "markAllRead": "Mark all as read",
      "unread": "{count, plural, one {# unread notification} other {# unread notifications}}",
      "markRead": "Mark as read",
      "tabs": {
        "all": "All",
        "inbox": "Inbox",
        "billing": "Billing",
        "compliance": "Compliance",
        "system": "System"
      },
      "seeAll": "See all"
    },
    "generic": {
      "title": "New notification"
    },
    "kbFixApproved": {
      "title": "Your knowledge-base correction was approved"
    },
    "kbFixRejected": {
      "title": "Your knowledge-base correction was rejected"
    },
    "atRisk": {
      "title": "Conversation at risk",
      "body": "Reason: {reason}"
    },
    "slaBreached": {
      "title": "SLA breached",
      "bodyFirstResponse": "A conversation missed its first-response target.",
      "bodyResolution": "A conversation missed its resolution target."
    },
    "handover": {
      "title": "A colleague handed over their shift",
      "body": "{open, plural, one {# open conversation} other {# open conversations}}, {slaAtRisk} with SLA at risk. Each thread has a pinned note."
    },
    "assigned": {
      "title": "A conversation was assigned to you",
      "body": "A conversation was assigned to you."
    },
    "mentioned": {
      "title": "You were mentioned in a note",
      "body": "You were mentioned in an internal note."
    },
    "faqDigest": {
      "title": "Unanswered questions this week",
      "body": "{count, plural, one {# customer question} other {# customer questions}} your AI could not answer. Review the drafted answers and add them to the knowledge base in one click."
    },
    "automationSummary": {
      "title": "Your weekly automation summary",
      "body": "{from} to {to}: {flowRuns} flow runs, {replies} customer replies, {broadcasts} broadcasts, {aiHandoffs} AI handoffs to your team. {topFailing}",
      "topFailingNone": "No failing steps this week.",
      "topFailing": "Top failing step: {step} ({count} failures)."
    },
    "weeklyReport": {
      "title": "Weekly automation report",
      "body": "Last 7 days: {pauses} pauses and {resumes} resumes of automation."
    },
    "dunningReminder": {
      "title": "Subscription payment failed",
      "body": "We couldn't renew your subscription. Next automatic retry: {date}."
    },
    "suspended": {
      "title": "Subscription suspended",
      "body": "Your workspace is read-only and your data is kept until {date}. Pay now to restore access."
    },
    "reactivated": {
      "title": "Subscription restored",
      "body": "Your payment went through and full access is back."
    },
    "autoRechargeOk": {
      "title": "Wallet recharged automatically",
      "body": "Your wallet was topped up with {amount}."
    },
    "autoRechargeFailed": {
      "title": "Automatic wallet recharge failed",
      "body": "We couldn't charge your card for {amount}. Top up manually or update your card."
    },
    "aiBudgetSoft": {
      "title": "AI budget is at {pct}%",
      "body": "{spent} of {cap} AI credits used this month. AI keeps running until the limit."
    },
    "aiBudgetHard": {
      "title": "AI budget limit reached",
      "body": "{spent} of {cap} AI credits used this month. AI replies are paused until next period or a higher limit."
    },
    "sttBudget": {
      "title": "Voice transcription is at 80% of today's budget",
      "body": "{used} of {budget} minutes used today. Transcription continues until the limit."
    },
    "webhookPaused": {
      "title": "Automatic link to another service paused",
      "body": "Every delivery to {url} failed for 24 hours, so it was paused. Fix the endpoint and acknowledge to resume."
    },
    "aiHandoff": {
      "title": "AI agent handed off a conversation",
      "body": "The AI agent escalated a conversation to a human."
    },
    "quotePending": {
      "title": "Quote awaiting your approval",
      "body": "A quote needs your approval before it is sent."
    },
    "discountPending": {
      "title": "Discount awaiting your approval",
      "body": "A discount above the threshold needs your approval."
    },
    "broadcastCompleted": {
      "title": "Broadcast completed",
      "body": "Your broadcast finished sending."
    },
    "broadcastFailed": {
      "title": "Broadcast failed",
      "body": "Your broadcast failed. Open it to see why."
    },
    "transferReceipt": {
      "title": "Transfer receipt received",
      "body": "A customer uploaded a bank-transfer receipt. Review it in Orders."
    },
    "paymentReceived": {
      "title": "Payment received",
      "body": "A customer payment was received."
    },
    "paymentFailed": {
      "title": "Payment failed",
      "body": "A payment failed. Please review it."
    },
    "qrSessionAttention": {
      "title": "WhatsApp number needs attention",
      "body": "The connection of a WhatsApp QR number keeps dropping or the number is restricted. Open Channels to check it."
    },
    "instagramTokenExpiring": {
      "title": "Instagram connection expires soon",
      "body": "Your Instagram connection will expire soon. Reconnect it from Channels to keep receiving messages."
    },
    "instagramNeedsReauth": {
      "title": "Instagram needs to be reconnected",
      "body": "Instagram rejected our access. Reconnect the account from Channels; incoming messages are kept until then."
    },
    "whatsappCloudNeedsReauth": {
      "title": "WhatsApp needs to be reconnected",
      "body": "WhatsApp rejected our access to this number. Reconnect it from Channels to keep messages and media flowing."
    },
    "channelDown": {
      "title": "WhatsApp channel disconnected",
      "body": "A channel is disconnected or degraded. Reconnect it to keep messaging."
    },
    "walletLow": {
      "title": "Wallet balance is low",
      "body": "Your wallet reached its budget threshold."
    },
    "usageThreshold": {
      "title": "Plan usage limit reached",
      "body": "A plan limit (contacts, messages or AI tokens) reached 80% or 100% of its allowance. Review your plan in Billing."
    },
    "trialEnding": {
      "title": "Your trial ends soon",
      "body": "Your free trial ends within 3 days. Pick a plan to keep your channels and automations running."
    },
    "templateRejected": {
      "title": "Template rejected or paused by Meta",
      "body": "A message template was rejected, paused or disabled by Meta. Open Templates to review it."
    },
    "contactOptedOut": {
      "title": "Contact opted out",
      "body": "A contact opted out of messages."
    },
    "email": {
      "category": {
        "inbox": "Inbox",
        "billing": "Billing",
        "compliance": "Compliance",
        "system": "System"
      },
      "footer": "You receive this email because of your notification settings.",
      "managePreferences": "Manage notification preferences"
    },
    "digest": {
      "title": "{count, plural, one {# new update} other {# new updates}}",
      "body": "Bundled {category} notifications from the last few minutes."
    },
    "dailyDigest": {
      "title": "Your daily digest",
      "body": "New conversations: {newConversations}. Unanswered: {unanswered}. Pending approvals: {pendingApprovals}. AI budget: {aiBudgetStatus}."
    },
    "prefs": {
      "b29b": {
        "eventsHeading": "Events",
        "digestShort": "Digest",
        "quietShort": "Quiet",
        "quietTitle": "Quiet hours",
        "quietHint": "Non-critical alerts wait until the quiet hours end. Critical ones always reach you.",
        "quietFrom": "From",
        "quietTo": "To"
      },
      "nav": "Notifications",
      "title": "Notification preferences",
      "intro": "Choose where each kind of notification reaches you.",
      "category": "Category",
      "digest": "Bundle into a digest",
      "quietHours": "Quiet hours (non-critical only)",
      "device": {
        "title": "This browser",
        "showHint": "Show the phone-notification note in the account menu"
      },
      "channels": {
        "in_app": "In-app",
        "email": "Email",
        "push": "Browser push"
      },
      "categories": {
        "inbox": "Inbox",
        "billing": "Billing",
        "compliance": "Compliance",
        "system": "System"
      },
      "locked": "Critical alerts keep the in-app channel for your role.",
      "save": "Save preferences",
      "saved": "Preferences saved.",
      "errors": {
        "invalid": "Some values are not valid.",
        "criticalLocked": "Critical alerts cannot be muted for your role.",
        "lastChannel": "This would leave no way to reach you with critical alerts. Add another channel first.",
        "generic": "Could not save. Try again."
      },
      "owner": {
        "title": "Owner alerts",
        "whatsapp": "Send critical alerts and the daily digest to my WhatsApp",
        "phone": "WhatsApp number (E.164)",
        "sendTime": "Daily digest time",
        "timezone": "Timezone",
        "digestOff": "Off",
        "save": "Save",
        "hint": "Sent from an approved utility template; falls back to email if WhatsApp fails."
      }
    },
    "ownerDigest": {
      "title": "Your daily digest",
      "body": "New conversations: {newConversations}. AI answered: {aiAnswered}. Handed to a human: {aiHandedOff}. Unanswered: {unanswered}. Pending approvals: {pendingApprovals}. AI budget: {aiBudgetStatus}.\n\nTop unanswered questions:\n{topQuestions}\n\nAdd to knowledge: {knowledgeUrl}"
    },
    "weeklyQuestions": {
      "title": "Your weekly report is ready",
      "body": "{questions} customer messages and {unanswered} questions to review."
    },
    "flowFailureRate": {
      "title": "A flow step is failing",
      "body": "Step “{node}” in flow “{flow}” fails often today ({rate}%)."
    },
    "flowClickDrop": {
      "title": "Clicks dropped on a flow step",
      "body": "Clicks on step “{node}” in flow “{flow}” are down {rate}% compared with the previous week’s daily average."
    },
    "flowError": {
      "title": "A flow step failed",
      "body": "A new error in the flow «{flow}». Open the errors page to see it."
    }
  },
  "forms": {
    "builder": {
      "title": "WhatsApp form builder",
      "saveDraft": "Save draft",
      "saved": "Draft saved",
      "loading": "Loading…",
      "conflict": "The draft changed elsewhere. Reload to continue.",
      "screens": "Screens",
      "addScreen": "Add screen",
      "newScreenTitle": "New screen",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "deleteScreen": "Delete screen",
      "deleteField": "Delete field",
      "editor": "Screen editor",
      "issues": "Fix these issues before publishing",
      "screenTitle": "Screen title",
      "screenBody": "Screen text",
      "footerLabel": "Button label",
      "palette": "Field palette",
      "verify": "verify",
      "fieldLabel": "Field label",
      "required": "Required",
      "preview": "Preview",
      "fieldTypes": {
        "text": "Text",
        "number": "Number",
        "email": "Email",
        "phone": "Phone",
        "date": "Date picker",
        "dropdown": "Dropdown",
        "radio": "Radio buttons",
        "checkbox": "Checkboxes",
        "optin": "Opt-in",
        "photo": "Photo picker",
        "document": "Document picker",
        "textblock": "Text",
        "display_image": "Picture"
      },
      "validation": {
        "minLength": "Minimum length",
        "maxLength": "Maximum length",
        "pattern": "Regex pattern",
        "patternInvalid": "Invalid regular expression",
        "min": "Minimum value",
        "max": "Maximum value",
        "minDate": "Earliest date",
        "maxDate": "Latest date",
        "minSelected": "Minimum selections",
        "maxSelected": "Maximum selections",
        "minFiles": "Minimum files",
        "maxFiles": "Maximum files"
      },
      "options": {
        "title": "Options",
        "option": "Option text",
        "add": "Add option",
        "remove": "Remove"
      },
      "optin": {
        "linkUrl": "Read-more link (HTTPS)"
      },
      "terms": {
        "title": "Terms link",
        "label": "Link text",
        "url": "Link URL"
      },
      "nav": {
        "title": "Navigation",
        "kind": "After this screen",
        "end": "Submit the form",
        "linear": "Go to a screen",
        "conditional": "Branch on an answer",
        "target": "Target screen",
        "field": "Field",
        "op": "Condition",
        "eq": "equals",
        "neq": "does not equal",
        "value": "Value",
        "addBranch": "Add branch",
        "default": "Otherwise go to"
      },
      "issue": {
        "DUPLICATE_SCREEN_ID": "Duplicate screen id",
        "DUPLICATE_FIELD_ID": "Duplicate field id",
        "TOO_MANY_DISPLAY_IMAGES": "A screen can show at most 3 pictures.",
        "NAVIGATION_TARGET_MISSING": "Navigation points to a missing screen",
        "NAVIGATION_SELF_LOOP": "A screen points to itself",
        "NAVIGATION_CYCLE": "Navigation contains a cycle",
        "BRANCH_FIELD_MISSING": "Branch uses a field not on this screen",
        "SCREEN_UNREACHABLE": "A screen cannot be reached",
        "NO_TERMINAL_SCREEN": "At least one screen must submit the form",
        "SCHEMA_INVALID": "A value is invalid"
      },
      "duplicateField": "Duplicate question",
      "moveToScreen": "Move to screen",
      "editQuestionNamed": "Edit question: {value}",
      "previewHint": "Tap a question in the preview to edit it.",
      "screenAuto": "Screen {n}",
      "footerNext": "Next",
      "footerSubmit": "Submit",
      "add": {
        "title": "Add a question",
        "textLabel": "Question text",
        "textPlaceholder": "e.g. What is your name?",
        "pick": "Now pick the kind of answer:",
        "kind": {
          "short_text": {
            "label": "Short text",
            "example": "A name or a short answer"
          },
          "long_text": {
            "label": "Long text",
            "example": "A message or detailed notes"
          },
          "number": {
            "label": "Number",
            "example": "Quantity, age, order number"
          },
          "phone": {
            "label": "Mobile number",
            "example": "+973 3600 0000"
          },
          "email": {
            "label": "Email",
            "example": "name@company.com"
          },
          "date": {
            "label": "Date",
            "example": "Pick a day from a calendar"
          },
          "single": {
            "label": "Choose one",
            "example": "Male or female, yes or no"
          },
          "multi": {
            "label": "Choose several",
            "example": "Tick everything that applies"
          },
          "list": {
            "label": "Dropdown list",
            "example": "Pick an area from a long list"
          },
          "photo": {
            "label": "Photo",
            "example": "A picture of the item"
          },
          "file": {
            "label": "File",
            "example": "A CV, invoice or PDF"
          },
          "consent": {
            "label": "Consent",
            "example": "I agree to the terms"
          },
          "textblock": {
            "label": "Text block",
            "example": "A heading or short note"
          },
          "display_image": {
            "label": "Picture",
            "example": "A photo of the hotel or the trip"
          },
          "button": {
            "label": "Button",
            "example": "Edit the screen button"
          }
        }
      },
      "problems": {
        "title": "Questions to fix before publishing",
        "labelEmpty": "A question has no text.",
        "labelTooLong": "«{value}» is longer than {max} characters.",
        "helperTooLong": "The hint under «{value}» is longer than {max} characters.",
        "noOptions": "«{value}» needs at least one option.",
        "tooManyOptions": "«{value}» has more than {max} options.",
        "optionEmpty": "«{value}» has an empty option.",
        "optionTooLong": "An option of «{value}» is longer than {max} characters (WhatsApp limit).",
        "textTooLong": "\"{value}\" is too long: up to {max} characters.",
        "imageMissing": "Add a picture to “{value}”."
      },
      "blockStyle": "Text style",
      "blockStyles": {
        "heading": "Heading",
        "body": "Paragraph",
        "caption": "Small note"
      },
      "settingsTitle": "Question settings"
    },
    "list": {
      "title": "Data forms",
      "deleteConfirmTitle": "Delete this form?",
      "deleteConfirmBody": "The form will be deactivated in WhatsApp, then deleted.",
      "fromTemplate": "From template",
      "needsRepublish": "Needs republish",
      "update": "Update",
      "archive": "Archive",
      "unarchive": "Unarchive",
      "archivedFilter": "Archived",
      "archivedToast": "Form archived",
      "unarchivedToast": "Form restored",
      "responsesCount": "{count} responses",
      "publish": "Publish",
      "published": "Form published",
      "status": {
        "draft": "Draft",
        "published": "Published",
        "deprecated": "Deprecated",
        "archived": "Archived"
      },
      "meta": {
        "sync": "Sync",
        "syncing": "Syncing…",
        "synced": "Sync done: {imported} imported, {updated} updated.",
        "deprecate": "Deprecate",
        "deprecated": "Form deprecated",
        "preview": "Preview",
        "categories": "Form type",
        "categoriesSaved": "✓ Saved",
        "imported": "Imported from Meta",
        "category": {
          "APPOINTMENT_BOOKING": "Appointment booking",
          "SHOPPING": "Shopping",
          "CONTACT_US": "Contact us",
          "SIGN_UP": "Sign up",
          "SIGN_IN": "Sign in",
          "LEAD_GENERATION": "Lead generation",
          "CUSTOMER_SUPPORT": "Customer support",
          "SURVEY": "Survey",
          "OTHER": "Other"
        }
      },
      "empty": "No forms yet",
      "versions": "Version history",
      "rollback": "Restore",
      "versionLabel": "Version {version}",
      "responses": "Responses",
      "responsesEmpty": "No responses yet",
      "exportCsv": "Export CSV",
      "loadMore": "Load more",
      "open": "Open builder",
      "delete": "Delete",
      "count": "{count, plural, one {# response} other {# responses}}",
      "clone": "Duplicate",
      "exportJson": "Export JSON",
      "importJson": "Import JSON",
      "importFailed": "This file is not a valid form export.",
      "cloned": "Form duplicated",
      "imported": "Form imported"
    },
    "studio": {
      "tabs": "Form studio sections",
      "tab": {
        "studio": "Studio",
        "settings": "Settings",
        "json": "JSON"
      },
      "phoneTitle": "Form preview",
      "phoneReset": "Restart",
      "json": {
        "label": "Form JSON",
        "import": "Import JSON",
        "export": "Export JSON",
        "notJson": "This is not valid JSON.",
        "invalid": "The JSON does not match the form schema ({count} issues)."
      },
      "settings": {
        "name": "Form name",
        "category": "Meta category",
        "reply": "Reply message after submit",
        "webhook": "Send answers to HTTPS endpoint",
        "sheet": "Google Sheet ID",
        "mapping": "Save answers to contact fields",
        "noFields": "Add fields in the Studio first.",
        "customField": "contact field key",
        "save": "Save settings",
        "saved": "Settings saved",
        "sync": "Sync",
        "labelOnSubmit": "Label added when answered"
      },
      "category": {
        "sign_up": "Sign up",
        "sign_in": "Sign in",
        "booking": "Appointment booking",
        "lead": "Lead generation",
        "contact": "Contact us",
        "support": "Customer support",
        "survey": "Survey",
        "other": "Other"
      }
    },
    "intro": {
      "title": "How forms work",
      "what": "A form the customer fills in inside WhatsApp without leaving the conversation.",
      "when": "Use it to collect a delivery address, booking details or a rating.",
      "step1": "Create a form and add the fields you need.",
      "step2": "Publish the form when it is complete.",
      "step3": "Send it from a conversation flow so it opens inside the chat.",
      "businessName": "Nada Clinic",
      "caption": "Example: an appointment booking form filled in inside the conversation.",
      "msg1": "To confirm your appointment, please fill in the booking form.",
      "msg1Button": "Open form",
      "msg2": "Form sent: name Sara, appointment Sunday evening.",
      "msg3": "Thank you Sara! We received your details and will confirm your appointment soon."
    },
    "livePreview": {
      "title": "Question flow preview",
      "caption": "Each question as the customer sees it in the chat.",
      "channelNote": "Forms run only on the official Cloud API channel. QR channels do not run forms.",
      "listButton": "Choose",
      "required": "(required)",
      "photo": "Please send a photo.",
      "document": "Please send a document.",
      "empty": "Add a screen with a field to see the questions."
    },
    "responses": {
      "title": "Form responses",
      "back": "Back to forms",
      "contact": "Contact",
      "submittedAt": "Submitted",
      "from": "From",
      "to": "To",
      "apply": "Apply",
      "clear": "Clear",
      "empty": "No responses in this period",
      "exportCsv": "Export CSV",
      "openContact": "Open contact profile",
      "unknownContact": "Contact",
      "loadMore": "Load more"
    },
    "order": {
      "title": "Product order",
      "currency": "Currency",
      "scope": {
        "label": "Products",
        "all": "All products",
        "categories": "Chosen categories",
        "products": "Hand-picked products"
      },
      "fulfilment": {
        "delivery": "Delivery",
        "pickup": "Pickup"
      },
      "fee": {
        "mode": "Delivery fee",
        "perArea": "Fixed fee per area",
        "freeAbove": "Free above an amount",
        "threshold": "Free from",
        "else": "Otherwise fee",
        "amount": "Fee"
      },
      "area": "Area",
      "addArea": "New area",
      "add": "Add",
      "payment": {
        "cod": "Cash on delivery",
        "link": "Payment link",
        "bank_transfer": "Bank transfer",
        "benefit": "BenefitPay (by phone)"
      },
      "notes": "Notes field",
      "vatIncluded": "Prices include VAT"
    },
    "smart": {
      "note": "This is a smart form that reads from the catalog — edit products/trips from the Catalog page.",
      "openCatalog": "Open catalog",
      "noSample": "There is no data to show yet: pick the catalog in the Settings tab, or add trips or products on the Catalog page, to see the real screens here.",
      "screens": "Form screens",
      "trip": {
        "title": "Trip booking content",
        "categories": "Trip categories to show",
        "categoriesHint": "Leave all unchecked to show every category.",
        "passport": "Passport details",
        "passportDefault": "Follow the travel default",
        "passportAtBooking": "Ask at booking",
        "passportAfter": "Ask after confirmation",
        "intro": "Intro text (shown on the trip details screen)",
        "deposit": "Deposit instructions (manual deposit, shown on the summary)"
      }
    },
    "dest": {
      "title": "Where do the answers go?",
      "contacts": "Save in contact fields",
      "contactsHint": "Match each question to a contact field below.",
      "webhook": "Send to a webhook",
      "webhookUrl": "Webhook URL (https)",
      "webhookUrlInvalid": "The link must start with https:// — clear anything your browser auto-filled.",
      "secret": "Secret (signs every request)",
      "secretSet": "A secret is saved. Type a new one to replace it.",
      "secretRemove": "Remove secret",
      "secretGenerate": "Generate",
      "test": "Send test",
      "testing": "Sending…",
      "webhookOk": "Test sent ({status}).",
      "webhookFail": "The test failed. Check the URL and that your server answers 200.",
      "sheet": "Add to Google Sheet",
      "sheetPick": "Pick the sheet and tab",
      "sheetColumns": "Column for each question",
      "sheetColumnFor": "Column for: {value}",
      "sheetColumnHint": "Leave empty to use the question text as the column title.",
      "testRow": "Add test row",
      "sheetOk": "Test row added.",
      "sheetFail": "Could not add a row. Check that the sheet is shared with your Google account and the column titles exist.",
      "saveFirst": "Save settings first, then test."
    },
    "b29": {
      "edit": {
        "copy": "✏ Edit a copy",
        "copied": "Draft copy created",
        "reload": "Load latest",
        "banner": {
          "published": "This form is published. Edit the questions, save, then re-publish so customers get the change.",
          "deprecated": "This form is deprecated and can't be edited. Create a draft copy and edit that.",
          "imported": "This form was imported from Meta, so its questions can't be edited here. Create a new copy to start from.",
          "readOnly": "You don't have permission to edit forms. View only."
        }
      },
      "new": {
        "cta": "New form",
        "title": "New form",
        "blank": "Blank",
        "blankHint": "Start from scratch and add your questions.",
        "fromTemplate": "From a template",
        "fromTemplateHint": "Pick the closest one and edit its questions.",
        "back": "Back",
        "search": "Search forms",
        "noMatch": "No form matches that name.",
        "defaultName": "New form"
      },
      "screens": {
        "add": "Screen",
        "rename": "Rename",
        "duplicate": "Duplicate",
        "welcome": "Welcome",
        "copySuffix": "(copy)"
      },
      "saveTo": {
        "label": "Save to",
        "none": "Don't save",
        "name": "Customer name",
        "email": "Email",
        "preset": {
          "city": "City",
          "birthday": "Birthday"
        },
        "new": "New variable",
        "create": "Create",
        "varName": "Variable name",
        "varType": "Type",
        "type": {
          "text": "Text",
          "number": "Number",
          "date": "Date",
          "single_select": "Choice"
        },
        "choices": "Choices",
        "choicesHint": "Separate with commas",
        "suggest": "Suggestion: save to “{value}”"
      },
      "dest": {
        "saveToMoved": "Saving answers to the customer is set on each question in the builder: open a question and pick “Save to”."
      }
    },
    "b29b": {
      "afterSubmit": {
        "title": "After submit",
        "help": "What happens when the customer sends the form. It works even if the form was sent from the chat or a broadcast. If the form runs inside a flow, that flow continues by itself.",
        "message": "Thank you",
        "flow": "Start a flow",
        "none": "Nothing",
        "flowLabel": "Flow",
        "flowPlaceholder": "Choose a flow",
        "flowsFailed": "Could not load your flows."
      },
      "displayImage": {
        "upload": "Choose a picture",
        "replace": "Change the picture",
        "alt": "Short description",
        "tooBig": "This picture is too large to send. Choose a smaller one.",
        "unreadable": "Could not read this picture."
      },
      "optionsSource": {
        "title": "Options",
        "help": "Fixed: you type the options. From data: the options are read from your Google Sheet or your services each time the form opens, so they update by themselves.",
        "fixed": "Fixed",
        "fromData": "From data",
        "needsDynamic": "Needs a dynamic form",
        "otherBound": "Another question of this form already reads its options from data.",
        "source": "Source",
        "sheet": "Google Sheet",
        "services": "Services",
        "column": "Column",
        "chooseColumn": "Choose a column",
        "descriptionColumn": "Description column",
        "noDescription": "No description",
        "save": "Save",
        "saved": "Saved"
      },
      "metaImport": {
        "imported": "{count, plural, one {Imported # form} other {Imported # forms}}",
        "questions": "{count, plural, one {# question} other {# questions}}",
        "note": "These are copies. Your forms on Meta were not changed. Open each form and choose “Save to” for its questions.",
        "suggestion": "“{label}” looks like the contact field {field} (suggestion only — choose “Save to” in the form to confirm)"
      },
      "preview": {
        "open": "Preview",
        "copy": "Copy link",
        "copied": "Copied",
        "needsChannel": "Link the form to a WhatsApp number first"
      }
    }
  },
  "commerce": {
    "nav": "Store connections",
    "title": "Store connections",
    "subtitle": "Connect your store to sync products, orders and customers.",
    "connectSalla": "Connect Salla",
    "connectMenu": "Other stores",
    "connectZid": "Connect Zid",
    "empty": "No store connected yet. Pick your platform above (Salla, Zid and others) to connect your store and see your products and orders here.",
    "unlabeled": "Salla store",
    "lastSynced": "Last synced: {time}",
    "neverSynced": "Never synced",
    "openHealth": "Sync health",
    "openMapping": "Mapping",
    "openCollisions": "SKU collisions",
    "status": {
      "connecting": "Connecting",
      "active": "Active",
      "degraded": "Degraded",
      "disabled": "Disabled"
    },
    "entity": {
      "products": "Products",
      "orders": "Orders",
      "customers": "Customers"
    },
    "entityStatus": {
      "healthy": "Healthy",
      "syncing": "Syncing",
      "degraded": "Degraded",
      "error": "Error"
    },
    "entityCount": "{count, plural, one {# item} other {# items}}",
    "health": {
      "title": "Sync health",
      "lastSync": "Last successful sync: {time}",
      "errors": "{count, plural, =0 {No errors} one {# error} other {# errors}}",
      "lastError": "Last error: {error}",
      "progressTotal": "Syncing ({phase}): {done} of {total}",
      "progress": "Syncing ({phase}): {done} items",
      "forceResync": "Resync",
      "resyncQueued": "Resync queued.",
      "resyncDeduplicated": "A resync is already queued.",
      "enabled": "Sync enabled",
      "frequency": "Sync frequency",
      "modeWebhook": "Webhooks only",
      "modePolling": "Polling",
      "interval": "Interval (minutes)",
      "saveFrequency": "Save frequency",
      "saved": "Saved.",
      "deadLetters": "Failed sync jobs",
      "noDeadLetters": "No failed jobs.",
      "rerun": "Re-run",
      "rerunQueued": "Job queued again.",
      "mode": {
        "full": "Full sync",
        "incremental": "Incremental sync",
        "poll": "Poll"
      },
      "failedAt": "Failed {time}"
    },
    "collisions": {
      "title": "SKU collisions",
      "subtitle": "The same SKU exists in more than one connection. Choose which product to keep.",
      "empty": "No SKU collisions.",
      "sku": "SKU {sku}",
      "keep": "Keep this one",
      "kept": "Kept",
      "resolved": "Collision resolved."
    },
    "mapping": {
      "title": "Mapping and pricing",
      "currency": "Currency",
      "taxMode": "Prices",
      "taxInclusive": "Include VAT",
      "taxExclusive": "Exclude VAT",
      "variants": "Variant attributes",
      "sourceField": "Source field",
      "ourField": "Our field",
      "addRow": "Add mapping",
      "removeRow": "Remove mapping",
      "save": "Save mapping",
      "saved": "Mapping saved.",
      "confirmTitle": "Change the tax mode?",
      "confirmBody": "This may reclassify existing products and triggers a full resync of this store.",
      "confirm": "Change & resync"
    },
    "connect": {
      "zid": {
        "title": "Connect a Zid store",
        "intro": "You will sign in to Zid and approve access to products, orders and customers. Nothing is sent to your customers.",
        "authorize": "Continue",
        "authorized": "Zid approved access. The first sync has started.",
        "required": "Run a successful test to finish setup.",
        "finish": "Finish and view sync status",
        "errors": {
          "generic": "Zid could not be connected. Try again.",
          "OAUTH_EXCHANGE_FAILED": "Zid rejected the connection. Try again.",
          "OAUTH_STATE_INVALID": "The connection attempt expired. Start again.",
          "OAUTH_ACCESS_DENIED": "Access was not approved in Zid."
        }
      },
      "openApi": "Connect custom API",
      "openCsv": "Import from CSV",
      "back": "Back",
      "next": "Next",
      "test": {
        "title": "Test the connection",
        "hint": "We fetch a small sample first. Nothing is synced until you activate.",
        "run": "Run test",
        "retry": "Retry test",
        "running": "Testing...",
        "passed": "Connection works.",
        "sample": "Sample of {count} products",
        "sampleList": "Sample products",
        "empty": "The store answered but returned no products.",
        "required": "Run a successful test to enable activation.",
        "failed": "The test failed.",
        "codes": {
          "UNAUTHORIZED": "The API key was rejected by the store.",
          "UNREACHABLE": "The store could not be reached or answered with an error.",
          "RATE_LIMITED": "The store is rate limiting requests. Try again shortly.",
          "URL_BLOCKED": "This address is not allowed. Use a public https URL."
        }
      },
      "api": {
        "title": "Connect a custom REST store",
        "baseUrl": "Store API base URL",
        "apiKey": "API key",
        "authHeader": "Auth header name (optional)",
        "authHeaderHint": "Defaults to Authorization: Bearer <key>.",
        "activate": "Activate connection",
        "activated": "Connection activated. The first sync has started.",
        "webhookTitle": "Webhook settings",
        "webhookHint": "Sign events with HMAC-SHA256 of the raw body in x-wato-signature and send x-wato-store. Save the secret now, it is shown once.",
        "storeId": "Store id (x-wato-store)",
        "webhookSecret": "Signing secret"
      },
      "csv": {
        "title": "Import products from CSV",
        "chooseFile": "Choose a CSV file",
        "currency": "Price currency",
        "mode": "When re-uploading",
        "modeMerge": "Merge by SKU (keep other products)",
        "modeReplace": "Replace (remove products missing from the file)",
        "mapTitle": "Match your columns",
        "notMapped": "Not mapped",
        "fields": {
          "sku": "SKU (required)",
          "name": "Name (required)",
          "nameAr": "Arabic name",
          "price": "Price (required)",
          "salePrice": "Sale price",
          "stock": "Stock",
          "category": "Category",
          "image": "Image URL",
          "variants": "Variants (separated by |)",
          "url": "Product page link (https, optional)"
        },
        "previewTitle": "Preview",
        "summary": "{count} of {total} rows are valid.",
        "diffAdded": "Added: {count}",
        "diffChanged": "Changed: {count}",
        "diffRemoved": "Removed: {count}",
        "diffUnchanged": "Unchanged: {count}",
        "errorsTitle": "Rows with problems (skipped)",
        "rowError": "Row {row}: {message}",
        "errors": {
          "MISSING_SKU": "SKU is empty.",
          "DUPLICATE_SKU": "SKU appears earlier in the file.",
          "MISSING_NAME": "Name is empty.",
          "INVALID_PRICE": "Price is not a valid amount.",
          "INVALID_SALE_PRICE": "Sale price is not a valid amount.",
          "INVALID_STOCK": "Stock must be a whole number.",
          "INVALID_IMAGE": "Image must be an http(s) URL.",
          "COLUMN_COUNT": "The row has a different number of columns than the header.",
          "INVALID_URL": "Product link is not allowed (https only, no shorteners)."
        },
        "import": "Import products",
        "imported": "Imported {count} products.",
        "manualHint": "CSV stores have no live sync. Mark orders as fulfilled yourself."
      },
      "openShopify": "Connect Shopify",
      "shopify": {
        "title": "Connect your Shopify store",
        "hint": "Enter your store's myshopify.com address. You will approve access on Shopify, then we verify the connection before the first sync.",
        "shopLabel": "Store address",
        "shopPlaceholder": "your-store.myshopify.com",
        "invalidShop": "Enter an address like your-store.myshopify.com.",
        "start": "Continue",
        "connected": "Shopify is connected. Test it below; the first catalog sync is already running.",
        "noConnection": "No Shopify store is connected yet.",
        "errors": {
          "OAUTH_STATE_INVALID": "The approval could not be verified. Please try again.",
          "OAUTH_EXCHANGE_FAILED": "Shopify could not be connected. Please try again."
        }
      },
      "woocommerce": {
        "title": "Connect your WooCommerce store",
        "hint": "Paste your store link and we read your products from the public store catalog. No keys needed.",
        "siteUrl": "Store address",
        "siteUrlPlaceholder": "https://your-store.com",
        "consumerKey": "Consumer key",
        "consumerSecret": "Consumer secret",
        "test": "Test connection",
        "connect": "Connect store",
        "connected": "WooCommerce is connected; the first catalog sync is running.",
        "previewTitle": "Sample products",
        "errors": {
          "INVALID_SITE_URL": "Enter a secure https:// store address.",
          "INVALID_CREDENTIALS": "The key or secret looks wrong. Keys start with ck_ and cs_.",
          "CONNECTION_TEST_FAILED": "We could not reach the store with these credentials.",
          "NOT_A_WOOCOMMERCE_STORE": "This address does not look like a WooCommerce store. Check the link or ask your web developer to enable the Store API.",
          "STORE_UNAVAILABLE": "The store is busy or unreachable right now. Please try again in a few minutes."
        },
        "advanced": "Advanced: API keys",
        "advancedHint": "Optional. Add WooCommerce REST keys only if you also want orders sent to the store.",
        "card": {
          "title": "Your store",
          "lastSync": "Last synced: {time}",
          "neverSynced": "Not synced yet. The first sync can take a few minutes.",
          "products": "{count} products found",
          "syncNow": "Sync now",
          "syncStarted": "Sync started. Refresh in a minute to see the new numbers.",
          "syncFailed": "We could not start the sync. Please try again."
        }
      },
      "openWoo": "Connect WooCommerce"
    }
  },
  "catalog": {
    "multiCatalog": {
      "title": "Catalog per WhatsApp number",
      "hint": "Map each WhatsApp number to its own Meta catalog. Numbers without a row use their linked catalog.",
      "phoneNumberId": "WhatsApp number ID",
      "metaCatalogId": "Meta catalog ID",
      "add": "Add mapping",
      "remove": "Remove",
      "empty": "No mappings yet."
    },
    "productMessage": {
      "variant": "Message type",
      "variantSpm": "Single product",
      "variantMpm": "Multiple products",
      "variantCatalog": "Catalog message",
      "variantCarousel": "Product carousel",
      "catalog": "Catalog",
      "pickCatalog": "Choose a catalog",
      "noCatalog": "No linked catalog yet. Link one in Catalog settings.",
      "product": "Product",
      "pickProduct": "Choose a product",
      "sourceSet": "Use a product set",
      "set": "Product set",
      "pickSet": "Choose a set",
      "noSets": "No product sets yet.",
      "pickItems": "Choose products",
      "itemsLimit": "Up to {max} products. Rejected products cannot be sent.",
      "carouselNeedsSet": "A carousel needs a product set with at least 2 approved products.",
      "loadError": "Could not load the catalog."
    },
    "nav": "Catalog",
    "title": "Meta catalog",
    "empty": "No catalog linked yet. Link one to a WhatsApp number below.",
    "connect": {
      "title": "Link a catalog to a number",
      "channel": "WhatsApp number",
      "pickChannel": "Choose a number",
      "metaCatalog": "Catalogs available in Meta",
      "pickCatalog": "Choose a catalog",
      "manualId": "Or enter a catalog ID",
      "submit": "Link catalog",
      "nameLabel": "Catalog name (optional)",
      "unnamed": "Unnamed catalog"
    },
    "settings": {
      "visible": "Show the shop icon in the chat header",
      "cart": "Enable the cart",
      "saved": "Saved"
    },
    "mode": {
      "label": "Product source",
      "synced_connector": "Synced from my store connector",
      "meta_managed": "Managed in Meta (read-only here)",
      "manual": "Manual products",
      "metaOverwriteWarning": "Edits made directly in Meta will be overwritten on the next sync.",
      "supersedeTitle": "Confirm source change",
      "supersedeBody": "{count, plural, one {# manual product} other {# manual products}} will be superseded by the newly selected source. Continue?",
      "confirm": "Switch source",
      "cancel": "Keep current"
    },
    "manual": {
      "title": "Manual products",
      "name": "Name",
      "price": "Price",
      "currency": "Currency",
      "image": "Image URL",
      "available": "In stock",
      "add": "Add product",
      "remove": "Remove",
      "edit": "Edit",
      "editTitle": "Edit product",
      "save": "Save changes",
      "cancel": "Cancel",
      "nameRequired": "Enter the product name.",
      "priceRequired": "Enter the product price.",
      "priceInvalid": "The price is not valid. Enter a positive number such as 25 or 25.50."
    },
    "review": {
      "approved": "Approved",
      "pending": "Pending review",
      "rejected": "Rejected"
    },
    "health": {
      "unlinked": "This catalog was unlinked in Meta. Product messages will fall back until you link it again."
    },
    "errors": {
      "CATALOG_ONE_PER_NUMBER": "Each WhatsApp number can have only one catalog. Unlink the current one first.",
      "CATALOG_SCOPE_MISSING": "Your Meta connection is missing the catalog management permission. Reconnect the number and grant it.",
      "CATALOG_CREATE_DENIED": "Meta did not allow creating a new catalog automatically. Pick one of your existing catalogs below.",
      "CATALOG_BUSINESS_NOT_FOUND": "We could not find the Meta business that owns this number. Reconnect the number and pick your business.",
      "CATALOG_NOT_FOUND_IN_META": "Meta could not find that catalog ID.",
      "CATALOG_CHANNEL_NOT_CAPABLE": "This number does not support catalogs. Catalogs need the official WhatsApp Cloud API.",
      "CATALOG_UNAVAILABLE": "The catalog manager needs an official WhatsApp Cloud API number.",
      "CATALOG_META_ERROR": "Meta returned an error. Try again shortly.",
      "CATALOG_MODE_NOT_SYNCED": "Only catalogs fed by a store connector can be synced.",
      "CATALOG_SYNC_NOT_FOUND": "That sync run was not found.",
      "CATALOG_SET_NOT_FOUND": "That product set no longer exists.",
      "CATALOG_CURRENCY_MISMATCH": "The catalog currency does not match your billing currency. Confirm to link it anyway.",
      "CATALOG_ITEM_NOT_FOUND": "That product no longer exists.",
      "CATALOG_VALIDATION": "Some fields are invalid. Check the values and try again."
    },
    "currency": {
      "mismatchTitle": "Currency mismatch",
      "mismatchBody": "This catalog is priced in {catalog} but your billing currency is {billing}. Payment links are charged in {billing}, so prices are shown as a conversion.",
      "linkAnyway": "Link anyway",
      "cancel": "Cancel",
      "conversionNotice": "Conversion shown: catalog prices are in {catalog}, payments are charged in {billing}.",
      "unknown": "The catalog currency will be detected on the first sync."
    },
    "sync": {
      "title": "Sync with Meta",
      "now": "Sync now",
      "refreshReview": "Refresh Meta review status",
      "running": "Syncing…",
      "lastRun": "Last sync: {status}",
      "summary": "{synced, plural, one {# item pushed} other {# items pushed}}, {failed, plural, one {# failed} other {# failed}}",
      "status": {
        "queued": "Queued",
        "running": "Running",
        "completed": "Completed",
        "failed": "Failed"
      },
      "never": "Never synced",
      "notSynced": "Only catalogs fed by a store connector can be synced.",
      "failedRun": "The last sync failed: {error}"
    },
    "products": {
      "title": "Products",
      "empty": "No products yet.",
      "searchLabel": "Search products",
      "filterLabel": "Review status",
      "filterAll": "All",
      "columns": {
        "image": "Image",
        "name": "Name",
        "retailerId": "Retailer ID / SKU",
        "price": "Price",
        "salePrice": "Sale price",
        "availability": "Availability",
        "variants": "Variants",
        "category": "Category",
        "review": "Meta review",
        "lastSync": "Last sync",
        "actions": "Actions"
      },
      "inStock": "In stock",
      "outOfStock": "Hidden (out of stock)",
      "never": "Never",
      "resync": "Force resync",
      "resyncDone": "Re-pushed to Meta",
      "rejectedBecause": "Meta rejected this item: {reason}",
      "detailsToggle": "Details",
      "fromConnector": "From your store"
    },
    "sets": {
      "title": "Product sets",
      "intro": "Group products into named sets (for example Offers or New arrivals) for multi-product messages.",
      "empty": "No product sets yet.",
      "nameAr": "Set name (Arabic)",
      "nameEn": "Set name (English)",
      "items": "{count, plural, one {# product} other {# products}}",
      "pick": "Choose products",
      "create": "Create set",
      "save": "Save set",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "noProducts": "Add products to the catalog first.",
      "syncError": "Not mirrored to Meta yet. It retries automatically on the next sync.",
      "synced": "Mirrored to Meta"
    },
    "templates": {
      "title": "Order messages",
      "intro": "Customize the messages sent for orders from this catalog. Anything you leave untouched uses the platform default.",
      "placeholders": "Placeholders you can use: {list}",
      "types": {
        "order_received": "Order received",
        "checkout_link": "Checkout link",
        "checkout_choice": "Payment choice link",
        "payment_success": "Payment success",
        "status_update": "Status update",
        "cart_reminder": "Cart reminder"
      },
      "ar": "Arabic",
      "en": "English",
      "customized": "Customized",
      "usingDefault": "Platform default",
      "save": "Save messages",
      "saved": "Messages saved",
      "useDefault": "Use default"
    },
    "orderSettings": {
      "title": "Order automations",
      "saved": "Saved.",
      "cartReminder": "Cart reminder",
      "paymentReminder": "Payment reminder (unpaid orders)",
      "hours": "after {hours} h",
      "delay": {
        "0": "Off",
        "30": "After 30 minutes",
        "60": "After 1 hour",
        "120": "After 2 hours",
        "180": "After 3 hours",
        "360": "After 6 hours",
        "720": "After 12 hours"
      },
      "adminEmail": "Email me on each new order",
      "adminEmailAddress": "Admin email address",
      "checkoutLabel": "Label ID to assign on checkout",
      "introText": "Intro text on the order form (optional)",
      "minOrder": "Minimum order amount (optional)",
      "sheetAppend": "Append each order to a Google Sheet",
      "sheetId": "Spreadsheet ID",
      "save": "Save",
      "payments": {
        "title": "Payment methods offered to customers",
        "cod": "Cash on delivery",
        "cardLink": "Card payment link",
        "testLink": "Try the payment link",
        "bankTransfer": "Bank transfer",
        "bankName": "Bank name",
        "accountHolder": "Account holder",
        "iban": "IBAN",
        "bankInstructions": "Extra instructions (optional)",
        "benefit": "BenefitPay transfer by phone number",
        "benefitPhone": "Benefit mobile number (+973)",
        "benefitName": "Display name",
        "benefitInstructions": "Extra instructions (optional)"
      },
      "reset": "Reset to default"
    },
    "summary": {
      "linkedCatalog": "Linked Meta catalog",
      "productCount": "Products",
      "lastSync": "Last sync",
      "syncStatus": "Sync status"
    },
    "b29b": {
      "storeLink": {
        "enabled": "Store link for chat customers"
      },
      "strip": {
        "never": "Not synced yet",
        "synced": "Last sync {time}",
        "error": "Last sync failed",
        "syncDone": "Sync started",
        "failed": "Couldn't reach the catalog. Try again.",
        "publish": "Publish all to catalog",
        "publishBody": "All your products will be sent to the WhatsApp catalog. Meta reviews them before customers see them.",
        "publishGo": "Publish",
        "publishDone": "Publishing started"
      },
      "reject": {
        "image": {
          "reason": "Meta rejected the photo.",
          "fix": "Use a clear, uncropped product photo without added text."
        },
        "policy": {
          "reason": "This product isn't allowed by Meta's commerce rules.",
          "fix": "Remove it from the catalog or change it to an allowed product."
        },
        "price": {
          "reason": "The price is missing or wrong.",
          "fix": "Set a correct price, then publish again."
        },
        "details": {
          "reason": "The name or description is missing or unclear.",
          "fix": "Write a clear name and a short description."
        },
        "link": {
          "reason": "The product link doesn't open.",
          "fix": "Check the link, or remove it."
        },
        "generic": {
          "reason": "Meta rejected this product.",
          "fix": "Check the photo, name and price, then publish again."
        }
      },
      "inbox": {
        "add": "+ Add to order",
        "added": "Added to the draft order",
        "addFailed": "Couldn't add it. Try again.",
        "out": "Out of stock",
        "left": "{count, plural, one {# left} other {# left}}"
      },
      "campaign": {
        "kind": "Type",
        "all": "All templates",
        "catalog": "📗 Catalog",
        "mpm": "🛍️ Several products",
        "carousel": "🎠 Product carousel"
      },
      "postLink": {
        "menu": "Link to a post",
        "title": "Link to an Instagram post",
        "loading": "Loading posts…",
        "noChannel": "Connect Instagram first.",
        "empty": "No posts yet.",
        "post": "Post",
        "saved": "Linked. Price comments get this product in a DM.",
        "failed": "Couldn't link. Try again."
      },
      "stats": {
        "menu": "Numbers",
        "title": "Product numbers",
        "loading": "Loading…",
        "failed": "Couldn't load the numbers.",
        "period": "{count, plural, one {Last day} other {Last # days}}",
        "empty": "Not sent yet.",
        "channel": "Channel",
        "sent": "Sent",
        "ordered": "Ordered",
        "conversion": "Conversion",
        "kind": {
          "whatsapp": "WhatsApp",
          "instagram": "Instagram",
          "ai": "AI",
          "web": "Store link"
        }
      }
    }
  },
  "cart": {
    "picker": {
      "title": "Cart",
      "searchLabel": "Search products by name or SKU",
      "searchPlaceholder": "Search name or SKU",
      "categoryLabel": "Category",
      "allCategories": "All categories",
      "variantLabel": "Variant",
      "loading": "Loading products…",
      "noResults": "No products match",
      "stock": "{count, plural, one {# in stock} other {# in stock}}",
      "untracked": "Stock not tracked",
      "outOfStock": "Out of stock",
      "backorderToggle": "Allow backorder",
      "add": "Add",
      "price": "Price",
      "empty": "The cart is empty",
      "items": "{count, plural, one {# item} other {# items}}",
      "total": "Total",
      "remove": "Remove",
      "backorderTag": "Backorder",
      "qtyLabel": "Quantity"
    },
    "custom": {
      "title": "Custom or service line",
      "lineType": "Line type",
      "custom": "Custom item",
      "service": "Service",
      "serviceId": "Service ID",
      "description": "Description",
      "price": "Unit price",
      "add": "Add line"
    },
    "errors": {
      "CART_NOT_FOUND": "This cart no longer exists.",
      "CART_ITEM_NOT_FOUND": "This cart line no longer exists.",
      "CART_PRODUCT_NOT_FOUND": "This product is no longer available.",
      "CART_NOT_OPEN": "This cart was already sent and can no longer be edited.",
      "CART_OUT_OF_STOCK": "This product is out of stock.",
      "CART_CURRENCY_MISMATCH": "This product uses a different currency than the cart.",
      "CART_VALIDATION_FAILED": "Check the values you entered.",
      "generic": "Could not update the cart. Try again."
    },
    "live": {
      "title": "Cart",
      "loading": "Loading cart...",
      "error": "Could not load the cart.",
      "empty": "The cart is empty.",
      "line": "{qty, number} x {unit}",
      "discount": "Discount",
      "total": "Total",
      "vat": "VAT",
      "gross": "Total incl. VAT",
      "blockedPending": "A discount above the limit is waiting for manager approval. The cart cannot be sent yet.",
      "blockedRejected": "The discount was rejected. Change it before sending the cart.",
      "blockedCoupon": "The coupon code is invalid or expired. Remove it or enter a valid code before sending.",
      "none": "No open cart for this customer.",
      "start": "Start a cart"
    },
    "coupon": {
      "label": "Coupon code",
      "apply": "Apply coupon",
      "remove": "Remove coupon",
      "applied": "Coupon discount: {amount}",
      "expired": "This coupon has expired.",
      "invalid": "This coupon code is invalid."
    },
    "upsellRow": {
      "dismiss": "Dismiss"
    },
    "discountForm": {
      "percentLabel": "Cart discount (%)",
      "apply": "Apply discount"
    },
    "entry": {
      "open": "Cart"
    },
    "queue": {
      "title": "Approval queue",
      "loading": "Loading approvals...",
      "empty": "Nothing is waiting for approval.",
      "summary": "Discount of {percent, number}% ({amount})",
      "typeCart": "Cart",
      "typeQuote": "Quote",
      "reasonLabel": "Reason (required to reject)",
      "approve": "Approve",
      "reject": "Reject"
    },
    "lock": {
      "editing": "Being edited by {user}. You can view but not save changes."
    },
    "notes": {
      "label": "Team note (internal)",
      "include": "Include this note in the message to the customer",
      "save": "Save note",
      "error": "Could not save the note."
    },
    "audit": {
      "title": "Cart history",
      "system": "System",
      "action": {
        "item_added": "Item added",
        "item_updated": "Item changed",
        "item_removed": "Item removed",
        "discount_changed": "Discount changed",
        "notes_changed": "Note changed",
        "sent": "Cart sent"
      },
      "surface": {
        "chat": "Chat",
        "inbox_list": "Inbox list",
        "crm_profile": "CRM profile"
      }
    },
    "send": {
      "action": "Send cart",
      "sent": "Cart sent. Customer link:",
      "already": "Already sent. Existing link:",
      "qr": "Download QR code",
      "stockBlocked": "Some items are no longer available. Remove them or allow backorder, then send again.",
      "stockLine": "{name}: requested {requested}, available {available}",
      "inProgress": "This cart is already being sent.",
      "error": "Could not send the cart. Try again."
    },
    "convert": {
      "toPaymentLink": "Payment link",
      "toQuote": "Quotation",
      "linkCreated": "Payment link created:",
      "quoteCreated": "Draft quotation created from this cart.",
      "error": "Could not convert the cart. Try again."
    },
    "saved": {
      "title": "Saved for later",
      "save": "Save later",
      "restore": "Move to active cart"
    }
  },
  "quotes": {
    "b29b": {
      "pdf": "PDF",
      "link": "Link",
      "linkCopied": "Link copied",
      "linkFailed": "Couldn't create the link",
      "orderTitle": "Order",
      "orderPay": "Pay",
      "orderPdf": "Download PDF",
      "orderSubtotal": "Subtotal",
      "orderDiscount": "Discount",
      "orderVat": "VAT"
    },
    "builder": {
      "title": "Quote",
      "new": "New quote",
      "numbered": "Quote {number}",
      "linesTitle": "Quote lines",
      "lineDetails": "Line details",
      "lineDiscount": "Line discount",
      "lineNote": "Line note",
      "saveLine": "Save line",
      "priceInclusive": "Prices include VAT",
      "shipping": "Shipping",
      "setShipping": "Set shipping",
      "validityDays": "Valid for (days)",
      "setValidity": "Set validity",
      "notes": "Notes to customer",
      "subtotal": "Subtotal",
      "tax": "VAT",
      "total": "Total"
    },
    "settings": {
      "title": "Quote settings",
      "prefix": "Numbering prefix",
      "prefixHint": "Only affects new quotes; existing numbers never change. Next sequence: {next}",
      "validityDays": "Default validity (days)",
      "reminderDays": "Reminder before expiry (days)",
      "terms": "Terms and conditions",
      "save": "Save",
      "saved": "Saved"
    },
    "errors": {
      "generic": "Something went wrong with the quote",
      "QUOTE_NOT_FOUND": "Quote not found",
      "QUOTE_ITEM_NOT_FOUND": "Line not found",
      "QUOTE_NOT_DRAFT": "Only a draft quote can be edited",
      "QUOTE_PRODUCT_NOT_FOUND": "Product not found",
      "QUOTE_CART_NOT_FOUND": "Cart not found",
      "QUOTE_CURRENCY_MISMATCH": "Product currency differs from the quote",
      "QUOTE_VALIDATION_FAILED": "Please check the entered values"
    },
    "message": {
      "body": "Quotation {number}\nTotal: {amount}\nValid until: {date}\nPlease choose an option below.",
      "bodyNoExpiry": "Quotation {number}\nTotal: {amount}\nPlease choose an option below.",
      "caption": "Quotation {number}",
      "accept": "Accept",
      "reject": "Reject",
      "ask": "Ask a question"
    }
  },
  "bookings": {
    "b29b30": {
      "linkMessage": "I'd like to book {service}",
      "linkTitle": "Booking link · {service}",
      "number": "Number",
      "copy": "Copy",
      "copied": "Link copied",
      "shorten": "Shorten link",
      "done": "Done",
      "link": "Booking link"
    },
    "b29b": {
      "emptyWithServices": "No bookings yet. Your customers' appointments appear here when they book.",
      "customHours": "Different hours for bookings",
      "followWorkspace": "Bookings follow your business hours.",
      "editInBusiness": "Edit in Business",
      "holdLabel": "Hold the slot for the customer until you confirm",
      "holdMinutes": "{minutes, plural, one {# minute} other {# minutes}}",
      "connectCalendar": "Connect your calendar",
      "removeImage": "Remove image",
      "closed": "Closed",
      "overnightSkipped": "{day}: {open}–{close} runs past midnight, so bookings skip it",
      "calendarFor": "Staff calendar",
      "image": "Booking image",
      "pattern": {
        "title": "Booking type",
        "help": "Appointment: a visit or session at a set time. Dated seats: a trip, course or event with a seat count. Day rental: a chalet, room or car by the night.",
        "appointment": "Appointment",
        "seats": "Dated seats",
        "rental": "Day rental"
      },
      "seatsCount": "Seats",
      "units": "Units",
      "minNights": "Min nights",
      "maxNights": "Max nights",
      "pricePerNight": "Price per night",
      "nightsInvalid": "Nights must be 1 to 365, and min cannot exceed max",
      "detail": {
        "seats": "{n, plural, one {# seat} other {# seats}}",
        "nights": "{n, plural, one {# night} other {# nights}}"
      },
      "new": {
        "seats": "Seats",
        "checkIn": "Check-in",
        "checkOut": "Check-out",
        "stayInvalid": "Check-out must be after check-in",
        "stayTotal": "{nights, plural, one {# night} other {# nights}} · {total}"
      }
    },
    "nav": {
      "services": "Services",
      "staff": "Staff",
      "settings": "Booking settings",
      "waitlist": "Waitlist",
      "bookings": "Bookings"
    },
    "errors": {
      "generic": "Something went wrong. Check the fields and try again.",
      "loadFailed": "Could not load this list. Check your connection, then select Try again."
    },
    "weekday": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "services": {
      "title": "Services",
      "new": "New service",
      "empty": "No services yet.",
      "name": "Name",
      "price": "Price",
      "duration": "Duration",
      "minutes": "{minutes} min",
      "category": "Category",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "drawer": "Service details",
      "nameAr": "Name (Arabic)",
      "nameEn": "Name (English)",
      "descAr": "Description (Arabic)",
      "descEn": "Description (English)",
      "durationMinutes": "Duration (minutes)",
      "capacity": "Capacity (customers per slot)",
      "buffer": "Buffer after (minutes)",
      "currency": "Currency",
      "sellable": "Can be sold in carts and quotes",
      "save": "Save service",
      "cancel": "Cancel",
      "categories": {
        "restaurant": "Restaurant",
        "clinic": "Clinic",
        "salon": "Salon",
        "retail": "Retail",
        "real_estate": "Real estate",
        "car_services": "Car services",
        "choose": "Choose a category"
      },
      "nameRequired": "Enter a service name in Arabic or English.",
      "durationInvalid": "The duration is not valid. Enter a whole number of minutes such as 30 or 90.",
      "priceInvalid": "The price is not valid. Enter zero or a positive number such as 120 or 120.50.",
      "wholeNumberInvalid": "The number is not valid. Enter a positive whole number.",
      "seatCapacity": "Seats (tables only, optional, 1–50)"
    },
    "staff": {
      "title": "Staff",
      "new": "New staff member",
      "empty": "No staff members yet.",
      "serviceCount": "{count, plural, one {# service} other {# services}}",
      "edit": "Edit",
      "delete": "Delete",
      "drawer": "Staff details",
      "nameAr": "Name (Arabic)",
      "nameEn": "Name (English)",
      "hours": "Weekly working hours",
      "unavailable": "Unavailable",
      "start": "{day}: start time",
      "end": "{day}: end time",
      "addRange": "Add hours",
      "removeRange": "Remove",
      "removeRangeTitle": "Remove these hours?",
      "nameRequired": "Enter a name in Arabic or English.",
      "removeRangeBody": "This day will have one working period fewer after you save.",
      "services": "Services this person can deliver",
      "noServices": "Create a service first.",
      "save": "Save staff member",
      "cancel": "Cancel"
    },
    "settings": {
      "title": "Booking settings",
      "hint": "Workspace defaults. Each service can override them.",
      "hours": "Business hours (used when a staff member has none)",
      "maxAdvance": "Max days ahead customers can book",
      "buffer": "Buffer between bookings (minutes)",
      "capacity": "Default capacity per slot",
      "save": "Save settings",
      "saved": "Settings saved.",
      "overrides": "Per-service overrides",
      "override": "Override workspace defaults",
      "noServices": "No services yet.",
      "overrideMax": "Max days ahead",
      "overrideBuffer": "Buffer (minutes)",
      "overrideCapacity": "Capacity",
      "location": "Location",
      "minAdvance": "Minimum notice (minutes)",
      "cutoff": "Cancellation cut-off (minutes before start)",
      "maxPerDay": "Max bookings per day (empty = unlimited)",
      "allowOverlap": "Allow overlapping bookings",
      "autoMeet": "Create a Google Meet link automatically",
      "active": "Active (bookable)",
      "availability": "Availability",
      "extraDates": "Extra available dates (replace the weekly hours on that date)",
      "unavailableDates": "Unavailable dates (holidays)",
      "addDate": "Add date",
      "removeDate": "Remove",
      "date": "Date",
      "addRange": "Add range",
      "dateStart": "Start",
      "dateEnd": "End",
      "none": "None yet.",
      "bookingRules": "Booking rules",
      "details": "Details",
      "refundHours": "Full refund if cancelled at least this many hours before start (empty = never)"
    },
    "calendar": {
      "title": "Google Calendar",
      "status": {
        "connected": "Connected",
        "disconnected": "Not connected",
        "error": "Needs attention"
      },
      "empty": "Connect this staff member's Google Calendar so confirmed bookings appear there and outside events block new slots. Sync does not work until you connect.",
      "lastSync": "Last sync: {time}",
      "neverSynced": "Waiting for the first sync",
      "errorHint": "Google access ended or expired. Reconnect to resume syncing.",
      "connect": "Connect Google Calendar",
      "reconnect": "Reconnect",
      "disconnect": "Disconnect",
      "conflict": {
        "title": "Conflicts with a Google Calendar event",
        "body": "An event added outside the app overlaps this booking. It has not been cancelled — keep it, or reschedule/cancel it yourself.",
        "keep": "Keep booking"
      }
    },
    "waitlist": {
      "title": "Booking waitlist",
      "empty": "No one is on the waitlist.",
      "service": "Service",
      "slot": "Requested slot",
      "status": "Status",
      "notifiedAt": "Notified",
      "respondBy": "Respond by",
      "error": "Could not load the waitlist.",
      "filter": "Status",
      "all": "All",
      "st": {
        "waiting": "Waiting",
        "notified": "Notified",
        "confirmed": "Confirmed",
        "expired": "Expired",
        "cancelled": "Cancelled"
      }
    },
    "list": {
      "title": "Bookings",
      "table": "Table",
      "calendar": "Calendar",
      "day": "Day",
      "week": "Week",
      "prev": "Previous",
      "next": "Next",
      "today": "Today",
      "export": "Export CSV",
      "all": "All statuses",
      "empty": "No bookings in this range.",
      "service": "Service",
      "staff": "Staff",
      "contact": "Contact",
      "start": "Start",
      "status": "Status",
      "dragHint": "Drag a confirmed booking to another slot to reschedule. The customer is told.",
      "moved": "Booking rescheduled.",
      "slotTaken": "That slot is already full.",
      "invalidTransition": "That status change is not allowed.",
      "setStatus": "Change status of booking",
      "serviceFilter": "Service",
      "allServices": "All services",
      "displayStatus": "Request status",
      "paymentStatus": "Payment",
      "paymentMethod": "Payment method",
      "reminder": "Reminder",
      "noReminder": "No reminder",
      "display": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "paid": "Paid",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "refunded": "Refunded",
        "rescheduled": "Rescheduled",
        "no_show": "No-show"
      },
      "payment": {
        "none": "No payment",
        "pending": "Pending",
        "deposit_paid": "Deposit paid",
        "paid": "Paid",
        "pay_on_arrival": "Pay on arrival",
        "refunded": "Refunded",
        "partially_refunded": "Partially refunded"
      },
      "paymentLabel": "Payment",
      "allPayments": "All payment states",
      "payments": "Payment details",
      "paymentFilter": "Filter by payment state"
    },
    "new": {
      "open": "New booking",
      "title": "New booking",
      "step": "Step {current} of {total}",
      "customer": {
        "heading": "Customer",
        "search": "Search by name or phone",
        "searching": "Searching…",
        "none": "No matching customers.",
        "newTab": "New customer",
        "existingTab": "Existing customer",
        "selected": "Selected customer",
        "change": "Change",
        "noName": "No name",
        "name": "Customer name (optional)",
        "phone": "Phone number",
        "phoneHint": "International format with country code, e.g. +966501234567",
        "required": "Choose a customer or enter a new one."
      },
      "service": {
        "heading": "Service",
        "label": "Service",
        "placeholder": "Choose a service",
        "none": "No active services. Add a service first.",
        "staff": "Staff member",
        "anyStaff": "Any staff member",
        "option": "{name} · {duration} min · {price}"
      },
      "date": {
        "heading": "Date and time",
        "label": "Date",
        "loading": "Loading available times…",
        "empty": "No available times on this day.",
        "nextDay": "Try the next day",
        "slotsLabel": "Available times",
        "slotWith": "{time} · {staff}",
        "pick": "Choose a time."
      },
      "notes": {
        "label": "Notes (optional)",
        "hint": "Shown to your team only."
      },
      "review": "{service} for {customer} on {when}",
      "errors": {
        "phoneInvalid": "Enter a valid international phone number, e.g. +966501234567.",
        "serviceRequired": "Choose a service.",
        "slotRequired": "Choose a time.",
        "slotGone": "This time is no longer available. Pick another one.",
        "serviceNotFound": "This service no longer exists.",
        "contactNotFound": "This customer no longer exists.",
        "invalid": "Some details are not valid. Check the form and try again.",
        "generic": "Could not create the booking. Try again.",
        "slotsFailed": "Could not load available times."
      },
      "back": "Back",
      "next": "Next",
      "confirm": "Create booking",
      "cancel": "Cancel",
      "created": "Booking created",
      "createdBody": "{service} for {customer} on {when}",
      "highlight": "New booking added for {when}."
    },
    "status": {
      "requested": "Pending",
      "confirmed": "Approved",
      "rescheduled": "Rescheduled",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "no_show": "No-show"
    },
    "agentRequested": "Requested by AI — needs staff confirmation",
    "agentRequestedNotice": {
      "title": "AI booking request",
      "body": "An AI agent requested a booking for {when}. Confirm or decline it."
    },
    "payment": {
      "title": "Payment",
      "close": "Close",
      "total": "Total",
      "paid": "Paid",
      "refunded": "Refunded",
      "history": "Payment history",
      "noHistory": "No payment activity yet.",
      "requestRefund": "Request refund",
      "amount": "Refund amount",
      "reason": "Reason",
      "submit": "Send for approval",
      "approve": "Approve",
      "reject": "Reject",
      "approveNote": "Only people allowed to approve amounts can approve; refunds go through the payment provider.",
      "requested": "Refund request sent for approval.",
      "done": "Done.",
      "failed": "Could not complete the action.",
      "exceeds": "The amount is higher than what was paid.",
      "state": {
        "none": "No payment",
        "pending": "Awaiting payment",
        "deposit_paid": "Deposit paid",
        "paid": "Paid",
        "pay_on_arrival": "Pay on arrival",
        "partially_refunded": "Partly refunded",
        "refunded": "Refunded"
      },
      "kind": {
        "payment": "Payment received",
        "refund_request": "Refund",
        "topup_link": "Top-up payment link",
        "adjustment": "Moved with the booking"
      },
      "eventStatus": {
        "pending": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "completed": "Completed",
        "failed": "Failed"
      }
    }
  },
  "sallaApp": {
    "title": "Set up your WhatsApp assistant",
    "welcome": "Welcome, {name}. Your workspace is ready and your 14-day free trial has started.",
    "stepOf": "Step {step} of {total}",
    "provisioningFailed": "Some automatic setup steps did not finish. Our team can re-run them; you can keep going meanwhile.",
    "loadFailed": "Could not load your setup progress. Refresh to try again.",
    "back": "Back",
    "next": "Next",
    "whatsapp": {
      "title": "Connect your WhatsApp number",
      "body": "Connect the number your customers already message. Your Salla store is already linked, so this is the only credential step.",
      "check": "Done",
      "connected": "WhatsApp number connected",
      "notYet": "No connected number yet. Finish the WhatsApp popup, then check again."
    },
    "starter": {
      "title": "Pick a starter flow",
      "body": "Choose an industry pack. We will turn on its welcome flow so your assistant answers straight away.",
      "pickFirst": "Choose a starter pack and apply it first.",
      "activated": "Your starter flow is live."
    },
    "finish": {
      "title": "You are all set",
      "body": "Your WhatsApp number is connected and a starter flow is live. Open the full dashboard to keep building.",
      "open": "Open my dashboard"
    },
    "link": {
      "title": "This store already has a workspace",
      "body": "We found a workspace that matches {name}. Connect the store to it instead of creating a duplicate?",
      "loadFailed": "This link expired. Start the install again from the Salla App Store.",
      "matchedBy": {
        "merchant_id": "Same Salla store",
        "domain": "Same store domain"
      },
      "connect": "Connect",
      "createNew": "New workspace",
      "failed": "Could not complete the connection. Try again."
    },
    "error": {
      "title": "We could not finish the install",
      "body": "Nothing was changed on your store. Start the install again from the Salla App Store, or contact support with this code.",
      "code": "Error code: {code}"
    },
    "listing": {
      "title": "Salla app: data handling & support",
      "intro": "How our Salla app handles your store data, and where to get help.",
      "dataTitle": "Data we access",
      "dataBody": "We read your products, orders and customers to keep your catalog and chat context in sync, and never sell or share them. Access tokens are stored encrypted.",
      "scopeTitle": "Why each permission is requested",
      "scopeBody": "Products and orders (read) power the catalog, carts and order updates in chat. Customer details (read) link store customers to WhatsApp contacts. We request nothing beyond this.",
      "uninstallTitle": "If you uninstall",
      "uninstallBody": "Uninstalling never deletes your data immediately. Your workspace enters a grace period, then is suspended and retained under our standard retention schedule before any deletion.",
      "privacyLink": "Privacy policy",
      "supportLink": "Contact support",
      "supportMailSubject": "Salla app support"
    }
  },
  "manualPayment": {
    "title": "Bank transfer receipt",
    "loading": "Loading payment…",
    "status": {
      "awaiting_receipt": "Waiting for receipt",
      "awaiting_verification": "Awaiting verification",
      "paid": "Paid",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "expected": "Expected amount",
    "reference": "Transfer reference",
    "noReceipt": "No receipt uploaded yet",
    "ocr": {
      "title": "Receipt reading (suggestion)",
      "advisory": "Automatic reading is only a suggestion. A person must approve the payment.",
      "amount": "Amount read",
      "reference": "Reference read",
      "confidence": "{percent}% confidence",
      "none": "The receipt could not be read automatically",
      "matchAmount": "Amount matches the order",
      "mismatchAmount": "Amount does not match the order",
      "matchReference": "Reference matches",
      "mismatchReference": "Reference not found"
    },
    "approve": "Approve payment",
    "reject": "Reject",
    "reasonLabel": "Rejection reason",
    "reasonPlaceholder": "Why is the receipt rejected?",
    "reasonRequired": "Enter a reason to reject",
    "decisionNote": "Decision note",
    "errors": {
      "generic": "Something went wrong. Try again.",
      "MANUAL_PAYMENT_NOT_FOUND": "Payment not found",
      "MANUAL_PAYMENT_INVALID_STATE": "The payment is no longer waiting for verification",
      "MANUAL_PAYMENT_VALIDATION_FAILED": "Please check the entered values",
      "MANUAL_PAYMENT_CARD_DATA_REJECTED": "Never enter card numbers",
      "APPROVAL_SELF_DECISION": "You cannot approve a receipt you submitted",
      "APPROVAL_ALREADY_DECIDED": "Already decided",
      "APPROVAL_NOTE_REQUIRED": "Enter a reason to reject"
    }
  },
  "migration": {
    "imported": {
      "badge": "Imported — needs review"
    },
    "reconnect": {
      "title": "Reconnect your WhatsApp number",
      "open": "Need to reconnect the same number? Open the reconnection guide",
      "intro": "Your number stays registered to your own WhatsApp Business account the whole time. We only connect this workspace to it.",
      "launch": "Start signup",
      "connected": "Number connected.",
      "failedTitle": "Meta rejected the connection",
      "metaError": "Meta said: {message}",
      "pendingStep": "Still pending on your previous platform:",
      "step": {
        "own_waba": "Confirm the number is registered to your own WhatsApp Business account.",
        "backup": "Export the chat history you want to keep from your previous platform.",
        "launch_signup": "Launch Embedded Signup below and pick the same number."
      },
      "release": {
        "wato_botsailor": "In Wato/BotSailor, disconnect the number from the old workspace (Settings, WhatsApp, Disconnect) and wait for the confirmation email.",
        "wa_to": "In wa-to, disconnect the number from the old workspace and wait for the confirmation.",
        "wati": "In Wati, remove the number from the WhatsApp API connection and wait for the release to finish.",
        "generic": "In your previous platform, release or disconnect the number from its WhatsApp API connection."
      }
    },
    "rollback": {
      "button": "Rollback until {until}",
      "title": "Roll back this import?",
      "body": "This removes exactly the records this import created, and nothing else. It cannot be undone.",
      "contacts": "{count} contacts",
      "labels": "{count} labels",
      "lists": "{count} lists",
      "customFields": "{count} custom fields",
      "mergedKept": "{count} existing contacts that were merged are kept as they are.",
      "confirm": "Yes, roll back",
      "cancel": "Cancel"
    },
    "reportPanel": {
      "title": "Migration report",
      "downloadPdf": "Download PDF",
      "downloadCsv": "Download CSV",
      "templatesSynced": "Templates synced",
      "templatesLive": "Status is read live from Meta.",
      "templatesNone": "Templates have not been synced yet.",
      "reimport": "Re-import",
      "reimportTitle": "Re-import this migration?",
      "reimportBody": "This migration already completed. Re-importing runs the whole pipeline again against the file you upload.",
      "reimportConfirm": "Confirm",
      "reimportCancel": "Cancel",
      "lockedMapping": "Columns were mapped automatically for this platform.",
      "advancedMapping": "Edit mapping"
    },
    "adminHistory": {
      "title": "Migration history",
      "empty": "This workspace has no migrations.",
      "readOnly": "Read-only support view.",
      "open": "Open report",
      "reimports": "Re-imports: {count}",
      "workspaceId": "Workspace ID"
    },
    "title": "Switch from another platform",
    "forbidden": "You do not have permission to import contacts.",
    "entry": {
      "signup": "I'm switching from another platform",
      "settings": "Import from another platform"
    },
    "step": {
      "source": "Source",
      "upload": "Upload",
      "mapping": "Mapping",
      "dryRun": "Dry-run",
      "commit": "Commit",
      "report": "Report"
    },
    "source": {
      "pick": "Where are you coming from?",
      "wato_botsailor": "Wato / BotSailor export",
      "wa_to": "wa-to export",
      "generic_csv": "Generic CSV",
      "wati": "Wati",
      "manychat": "ManyChat",
      "desc": {
        "wati": "Contacts and tags from a Wati contact export.",
        "manychat": "Subscribers and tags only. ManyChat flows are not imported.",
        "respond_io": "Contacts and tags from a respond.io contact export.",
        "other_platform": "Contacts from any platform that exports a CSV or Excel file. You map the columns yourself."
      },
      "respond_io": "Respond.io",
      "other_platform": "Other platform",
      "api_connect": "Connect by API",
      "unavailable": "Not available",
      "reason": {
        "needs_api_credential": "Live import needs your API credential on the other platform. Export a CSV or Excel file instead."
      },
      "comingSoon": "Coming soon"
    },
    "upload": {
      "file": "CSV or Excel file",
      "country": "Default country for local numbers",
      "template": "Saved mapping",
      "noTemplate": "Suggest automatically",
      "start": "Upload and continue",
      "failed": "Could not read the file: {message}"
    },
    "country": {
      "SA": "Saudi Arabia",
      "BH": "Bahrain"
    },
    "mapping": {
      "title": "Map your columns",
      "column": "Source column",
      "field": "Wato field",
      "type": "Value type",
      "customKey": "Custom field key",
      "phoneRequired": "Map one column to Phone to continue.",
      "templateName": "Template name",
      "saveTemplate": "Save as template",
      "saved": "Mapping template saved.",
      "continue": "Dry run",
      "unmappedHint": "Unmapped columns are imported as a text field flagged for cleanup."
    },
    "field": {
      "phone": "Phone",
      "name": "Name",
      "email": "Email",
      "labels": "Labels",
      "lists": "Lists",
      "opt_in_status": "Opt-in status",
      "opt_in_at": "Opt-in date",
      "opt_in_source": "Opt-in source",
      "custom": "Custom field",
      "unmapped": "Import as generic text",
      "ignore": "Ignore"
    },
    "type": {
      "text": "Text",
      "number": "Number",
      "date": "Date",
      "boolean": "Yes / No"
    },
    "dryRun": {
      "title": "Dry-run preview",
      "hint": "Nothing is written until you confirm.",
      "run": "Run dry-run",
      "total": "Rows",
      "valid": "Valid",
      "invalid": "Invalid",
      "needsManualFix": "Needs manual fix",
      "duplicate": "Duplicates",
      "toCreate": "To create",
      "toMerge": "To merge",
      "toSkip": "To skip",
      "labels": "Labels to create",
      "lists": "Lists to snapshot",
      "fields": "Custom fields to create",
      "preserved": "Opt-in preserved",
      "unverified": "Unverified opt-in",
      "optedOut": "Opted out",
      "age": "Dry-run is {hours} hours old.",
      "stale": "This dry-run is stale. Re-validate it before committing.",
      "revalidate": "Re-validate",
      "changed": "The preview changed since the last dry-run.",
      "unchanged": "The preview is unchanged.",
      "truncated": "Showing the first rows only.",
      "unverifiedNote": "Unverified contacts are excluded from marketing and can be served within the 24h window."
    },
    "row": {
      "row": "Row",
      "status": "Status",
      "phone": "Phone",
      "decision": "Decision"
    },
    "rowStatus": {
      "valid": "Valid",
      "invalid": "Invalid",
      "needs_manual_fix": "Needs manual fix",
      "duplicate": "Duplicate"
    },
    "decision": {
      "create": "Create",
      "merge": "Merge",
      "skip": "Skip",
      "create_duplicate": "Create duplicate"
    },
    "commit": {
      "title": "Commit import",
      "confirm": "Import {count} contacts now",
      "button": "Commit import",
      "done": "Import complete: {created} created, {merged} merged, {skipped} skipped.",
      "note": "Source lists were saved as static snapshots (migrated, not dynamic).",
      "failed": "The import failed: {message}",
      "notReady": "Run a dry-run first."
    },
    "report": {
      "title": "Import report",
      "labels": "Labels created",
      "lists": "Lists created",
      "fields": "Custom fields created",
      "cleanup": "Fields to clean up: {fields}"
    },
    "error": {
      "generic": "Something went wrong: {message}"
    },
    "concierge": {
      "runbook": {
        "contacts_imported": "Contacts imported",
        "templates_synced": "Templates synced",
        "number_reconnected": "Number reconnected",
        "cutover_verified": "Cutover verified",
        "handover_walkthrough": "Handover walkthrough done"
      },
      "cta": {
        "title": "Switch in an hour — with our team",
        "body": "BotSailor moves to Flex billing on 1 December 2026. Book a live concierge session and we import your contacts, sync your templates and reconnect your number in one sitting.",
        "book": "Book a concierge session"
      },
      "state": {
        "scheduled": "Scheduled",
        "in_progress": "In progress",
        "paused": "Paused — follow-up slot offered",
        "completed": "Completed"
      }
    },
    "autoReply": {
      "title": "Import a single auto-reply",
      "intro": "One JSON file. Preview first; always created as a draft.",
      "drop": "Drop the file here or click to choose",
      "keywords": "Keywords",
      "steps": "Steps",
      "draftNote": "It will be created as a draft and not published automatically.",
      "error": "Could not read the file. Make sure it is a JSON file exported from the auto-reply.",
      "empty": "No auto-replies found in this file.",
      "mapped": "Ready",
      "disabled": "Disabled",
      "unsupported": "Needs rebuild"
    },
    "xitfb": {
      "title": "Move from another platform",
      "intro": "Up to 50 JSON files. We show a report first; nothing is created until you confirm.",
      "howTo": "In old Wato: click the \"Export flow data\" icon next to each automation, then upload the files here.",
      "cloudOnly": "Imported flows are drafts for the official WhatsApp Cloud API. They are never published automatically and never attached to a QR number.",
      "drop": "Drag flow files here, or choose files",
      "choose": "Choose files",
      "fileCount": "{count} file(s) selected",
      "preview": "Preview report",
      "import": "Import as drafts",
      "importing": "Working…",
      "imported": "{count} draft flow(s) created. Review each one before publishing.",
      "summary": "Imported: {imported} · Approximated: {approximated} · Needs manual work: {manual} · Skipped: {invalid}",
      "keywords": "Keywords",
      "nodes": "Nodes: {count}",
      "collision": "Keyword already used by another flow: {keywords}",
      "doctorTitle": "Flow doctor warnings",
      "notesTitle": "What changed",
      "blocksSummary": "Blocks: {imported} imported fully · {partial} imported partly · {needsRebuild} need rebuilding by hand",
      "blocksReasonsTitle": "Blocks that need your attention",
      "blockPartial": "Partly imported",
      "blockNeedsRebuild": "Rebuild by hand",
      "status": {
        "imported": "Imported",
        "approximated": "Approximated",
        "needs_manual": "Needs manual work",
        "invalid": "Skipped"
      },
      "error": "The import failed. Check the files and try again."
    }
  },
  "analyticsPlus": {
    "csat": {
      "byAgent": "By agent (average, ratings)",
      "noAgent": "No assigned agent",
      "title": "Customer satisfaction",
      "average": "Average rating (out of 5)",
      "count": "Ratings received",
      "empty": "No ratings yet. Turn on the closing survey in Settings → Workspace → Automation.",
      "error": "Could not load customer satisfaction."
    },
    "title": "Sales, campaigns and team",
    "subtitle": "Commerce funnel, template performance and the agent leaderboard.",
    "tabs": {
      "sales": "Sales",
      "templates": "Templates",
      "leaderboard": "Leaderboard"
    },
    "funnel": {
      "empty": "No carts, quotes or paid orders in this period.",
      "title": "Sales funnel",
      "carts": "Carts created",
      "quotes": "Quotes sent",
      "paid": "Orders paid",
      "rate": "{rate} conversion"
    },
    "gmv": {
      "title": "GMV, AOV and LTV",
      "day": "Day",
      "gmv": "GMV",
      "aov": "AOV",
      "ltv": "LTV",
      "orders": "Orders",
      "empty": "No paid orders in this period."
    },
    "templates": {
      "title": "Template performance",
      "category": "Category",
      "allCategories": "All categories",
      "name": "Template",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "replied": "Replied",
      "clicked": "Clicked",
      "converted": "Converted",
      "cost": "Cost",
      "empty": "No template sends in this period."
    },
    "leaderboard": {
      "title": "Agent leaderboard",
      "rank": "Rank",
      "agent": "Agent",
      "frt": "First response",
      "resolution": "Resolution time",
      "csat": "CSAT",
      "quotesSent": "Quotes sent",
      "quotesAccepted": "Quotes accepted",
      "revenue": "Revenue attributed",
      "empty": "No agent activity in this period.",
      "disabledTitle": "Leaderboard is off",
      "disabledBody": "Turn it on to rank agents by response time, quotes and revenue.",
      "enable": "Enable",
      "disable": "Disable leaderboard"
    }
  },
  "analytics": {
    "b29b": {
      "weeklyCsv": {
        "conversations": "New conversations",
        "closed": "Closed",
        "open": "Still open",
        "automation": "Handled by automation",
        "revenue": "Sales"
      },
      "delivery": {
        "chartLabel": "Messages by day: {sent} sent, {delivered} delivered, {read} read, {failed} failed.",
        "showTable": "Show table",
        "empty": "No messages in this period"
      },
      "period": {
        "lastDays": "Last {days, plural, one {day} other {# days}}",
        "range": "From {from} to {to}"
      },
      "export": "Export"
    },
    "empty": {
      "title": "No data yet",
      "hint": "Numbers appear here once conversations or messages arrive in the selected period. Try a wider date range.",
      "ctaConnect": "Connect a channel",
      "ctaInbox": "Open the inbox"
    },
    "nav": "Analytics",
    "overview": {
      "title": "Analytics overview",
      "subtitle": "Conversations, messages, automation and cost for the selected period."
    },
    "filters": {
      "from": "From",
      "to": "To",
      "channel": "Channel",
      "allChannels": "All channels",
      "invalidRange": "Choose a start date that is on or before the end date."
    },
    "kpi": {
      "conversationsNew": "New conversations",
      "conversationsOpen": "Still open",
      "conversationsClosed": "Closed",
      "messagesSent": "Messages sent",
      "messagesReceived": "Messages received",
      "activeContacts": "Active contacts (per day)",
      "automationRate": "Automation rate",
      "aiCost": "AI cost",
      "metaCost": "Meta cost (estimate)",
      "revenue": "Revenue via chat",
      "costBasis": "Cost basis — AI: {ai}, Meta estimate: {meta}",
      "perDay": "About {value} per day",
      "mixedCurrency": "This period spans more than one billing currency; amounts are shown per currency and never converted."
    },
    "daily": {
      "caption": "Daily activity",
      "day": "Day"
    },
    "buttonDistribution": {
      "title": "Button click distribution",
      "window7d": "Last 7 days",
      "window30d": "Last 30 days",
      "window": "Time window",
      "clicks": "{count} clicks",
      "empty": "No clicks recorded in this period.",
      "entered": "Entered",
      "dropOff": "Drop-off"
    },
    "delivery": {
      "title": "Message delivery",
      "subtitle": "Sent, delivered, read and failed messages by day for each channel, the most common failure codes, template versus session messages and an estimated Meta cost.",
      "byDay": "By day",
      "day": "Day",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "failed": "Failed",
      "failureCodes": "Top failure codes",
      "noFailures": "No failed messages in this period.",
      "kinds": "Template vs session",
      "template": "Template messages",
      "session": "Session messages",
      "cost": "Estimated cost by Meta category",
      "categoryCol": "Category",
      "messages": "Messages",
      "estimate": "Estimated cost",
      "noEstimate": "No pricing data",
      "noCost": "No template messages in this period.",
      "costNote": "Estimate = template messages x the average price Meta reported for the category in this period.",
      "category": {
        "marketing": "Marketing",
        "utility": "Utility",
        "authentication": "Authentication",
        "service": "Service"
      }
    },
    "entryPoints": {
      "title": "Entry points",
      "subtitle": "Where your contacts come from — Click-to-WhatsApp ads by campaign, ad set and ad, and other sources — and the paid revenue that follows.",
      "groupBy": "Group by",
      "groupCampaign": "Campaign",
      "groupSource": "Source",
      "empty": "No contacts in this period.",
      "sourceAd": "Click-to-WhatsApp ad",
      "col": {
        "source": "Source",
        "campaign": "Campaign",
        "adSet": "Ad set",
        "ad": "Ad",
        "contacts": "Contacts",
        "paidOrders": "Paid orders",
        "revenue": "Revenue"
      },
      "sourceType": {
        "manual": "Added manually",
        "inbound": "Inbound message",
        "import": "Import",
        "widget": "Website widget",
        "qr": "QR code",
        "link": "Short link",
        "other": "Other source"
      }
    },
    "payments": {
      "title": "Payment links",
      "subtitle": "Created, opened and paid links, time to pay and failure reasons for the selected period.",
      "funnel": {
        "created": "Created",
        "opened": "Opened",
        "paid": "Paid"
      },
      "openRate": "Open rate",
      "paidRate": "Paid rate",
      "openToPaid": "Opened to paid",
      "avgTimeToPay": "Average time to pay",
      "minutes": "{minutes} min",
      "failures": "Failure reasons",
      "reason": "Reason",
      "count": "Count",
      "noFailures": "No failed payments in this period.",
      "unknownReason": "Unknown"
    },
    "kpiHelp": {
      "conversationsNew": "Conversations that started in the selected period.",
      "conversationsOpen": "Conversations still waiting for a reply or resolution right now.",
      "conversationsClosed": "Conversations marked resolved in the period.",
      "messagesSent": "Messages sent by your team, automations and AI to customers.",
      "messagesReceived": "Messages customers sent to you.",
      "activeContacts": "Sum over days of the distinct customers who messaged on that day.",
      "automationRate": "Share of finished conversations resolved by automation or AI without a human agent.",
      "firstResponse": "Average time from a customer’s first message until the first reply from your team or AI. Lower is better.",
      "resolution": "Average time from a conversation starting until it is marked resolved.",
      "reopen": "Share of resolved conversations that customers reopened by writing again.",
      "aiResolution": "Share of finished conversations resolved by automation or AI without a human agent."
    },
    "channels": {
      "title": "By channel",
      "firstResponse": "First response",
      "resolution": "Resolution time",
      "reopen": "Reopened",
      "minutes": "{value} min",
      "hours": "{value} h",
      "deleted": "Removed channel"
    },
    "export": {
      "csv": "Export CSV"
    }
  },
  "setup": {
    "checklist": {
      "title": "Getting started",
      "progress": "{done} of {total} steps complete",
      "allDone": "You're all set — your workspace is live.",
      "publishNote": "Only a published flow counts. A draft does not complete this step.",
      "dismiss": "Hide checklist",
      "show": "Show checklist",
      "link": "Start",
      "helpLink": "Open the Help Center",
      "loadError": "Could not load the setup checklist.",
      "done": "Done",
      "steps": {
        "tryDemo": {
          "title": "Try a demo conversation",
          "body": "See how your assistant answers a customer — no WhatsApp number needed.",
          "cta": "Try demo"
        },
        "channelConnected": {
          "title": "Connect a WhatsApp number",
          "body": "Link your WhatsApp Business number so you can send and receive messages.",
          "cta": "Connect a channel"
        },
        "flowPublished": {
          "title": "Publish your first flow",
          "body": "Build an automated conversation and publish it so customers can use it.",
          "cta": "Open flows"
        },
        "templateAdded": {
          "title": "Add your first message template",
          "body": "Templates let you message customers outside the 24-hour window.",
          "cta": "Open templates"
        },
        "teammateInvited": {
          "title": "Invite a teammate",
          "body": "Bring in a colleague to help answer conversations.",
          "cta": "Invite a teammate"
        }
      }
    },
    "demo": {
      "title": "Demo conversation",
      "badge": "Simulation",
      "note": "This is a simulation. A made-up customer chats with your assistant here — nothing is sent to WhatsApp and no one is charged.",
      "agentLabel": "Assistant: {name}",
      "customer": "Sample customer",
      "inputLabel": "Type as the customer",
      "send": "Send",
      "sending": "Thinking…",
      "close": "Close demo",
      "handoff": "The assistant would hand this chat to a human here.",
      "error": "The simulation could not reply. Try again.",
      "suggestions": {
        "hours": "What are your opening hours?",
        "price": "How much does it cost?",
        "order": "I want to place an order"
      },
      "blocked": {
        "reason": "There is no assistant to simulate yet, so the demo has nobody to answer.",
        "cta": "Create an assistant"
      }
    },
    "tour": {
      "help": "Help",
      "menu": "Product tours",
      "start": "Take the tour",
      "next": "Next",
      "back": "Back",
      "skip": "Skip tour",
      "finish": "Finish",
      "stepOf": "Step {step} of {total}",
      "flows": {
        "1": {
          "title": "All your flows in one place",
          "body": "Create a new flow or start from the template gallery, then open it to edit on the canvas."
        },
        "2": {
          "title": "Save, then publish",
          "body": "Saving keeps a draft. Only publishing from inside the editor makes the flow live for customers."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» next to the title for a short guide."
        },
        "name": "Flow Builder"
      },
      "inbox": {
        "1": {
          "title": "All conversations in one place",
          "body": "Open a conversation to reply, assign it, or hand it to a teammate."
        },
        "2": {
          "title": "Mind the 24-hour window",
          "body": "Outside 24 hours since the customer's last message, only approved templates can be sent."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» next to the title to see how the inbox works."
        },
        "name": "Inbox"
      },
      "broadcasts": {
        "1": {
          "title": "Reach an audience",
          "body": "Pick a template and an audience, then review the cost before sending."
        },
        "2": {
          "title": "Opt-outs are respected",
          "body": "Contacts who opted out are excluded automatically."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» next to the title for a short guide."
        },
        "name": "Broadcasts"
      },
      "home": {
        "1": {
          "title": "Your next step",
          "body": "This card shows the one thing to do next. Finish it, then the next one appears."
        },
        "2": {
          "title": "Your numbers",
          "body": "See how many conversations and customers you have today."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» on any page for a short guide."
        },
        "name": "Home"
      },
      "contacts": {
        "1": {
          "title": "All your customers",
          "body": "Everyone who messaged you is saved here with their name and number."
        },
        "2": {
          "title": "Find and sort them",
          "body": "Search by name or number, and add labels to group customers."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» next to the title for a short guide."
        },
        "name": "Contacts"
      },
      "sell": {
        "1": {
          "title": "Selling in a few steps",
          "body": "Each card is one step: connect your store, add products, then follow orders and payments."
        },
        "2": {
          "title": "See where you are",
          "body": "The status on each card tells you if the step is done or still waiting."
        },
        "3": {
          "title": "Need a hand?",
          "body": "Open «How does it work?» next to the title for a short guide."
        },
        "name": "Selling"
      }
    },
    "empty": {
      "flows": {
        "title": "No flows yet",
        "what": "Flows are automated conversations that answer customers for you.",
        "how": "Start from an industry template in the gallery, or build one from scratch.",
        "cta": "Browse templates"
      },
      "broadcasts": {
        "title": "No broadcasts yet",
        "what": "Broadcasts send one approved template to many contacts at once.",
        "how": "Create a template first, then choose an audience and schedule the send.",
        "cta": "Open templates"
      },
      "contacts": {
        "title": "No contacts yet",
        "what": "Contacts are the customers you talk to. They are added automatically when someone messages you.",
        "how": "You can also import a CSV of existing customers.",
        "cta": "Import contacts"
      },
      "analytics": {
        "title": "No analytics yet",
        "what": "Charts appear here once your channels start handling conversations.",
        "how": "Connect a number and publish a flow to start collecting data.",
        "cta": "Open Getting Started"
      },
      "catalog": {
        "title": "No products yet",
        "what": "Products are what you show customers inside WhatsApp so they can order.",
        "how": "Run a sync to pull your products from your Meta catalog, or add them there first.",
        "cta": "Sync now"
      },
      "apiKeys": {
        "title": "No API keys yet",
        "what": "A key lets your app or store talk to your account securely.",
        "how": "Create the first key and copy it right away, it is not shown again.",
        "cta": "New API key"
      },
      "webhooks": {
        "title": "No webhooks yet",
        "what": "A webhook tells your system as soon as something happens, such as a new message.",
        "how": "Add your system's address to start receiving events.",
        "cta": "Add a webhook"
      },
      "team": {
        "title": "No invitations yet",
        "what": "Invite teammates to answer customers with you from the same account.",
        "how": "Send the first invitation and choose each person's role.",
        "cta": "Invite a teammate"
      },
      "integrations": {
        "title": "No integration templates available",
        "what": "Integration templates connect your account to other apps without code.",
        "how": "They will appear here when your plan includes them.",
        "cta": "View plans"
      },
      "channels": {
        "title": "No numbers connected yet",
        "what": "Channels are the WhatsApp and Instagram numbers your customers message.",
        "how": "Connect your first number to start receiving conversations.",
        "cta": "Connect a number"
      },
      "tasks": {
        "title": "No tasks yet",
        "what": "Tasks are follow-ups you or your team need to do for a customer.",
        "how": "Add the first task so nothing gets forgotten.",
        "cta": "Add a task"
      },
      "inboxSelect": {
        "title": "Select a conversation to read it.",
        "what": "Every customer message lands here, shared with your whole team.",
        "how": "Pick one from the list to reply, assign it or add a note.",
        "cta": "Open chat"
      }
    },
    "typeSteps": {
      "title": "Next steps for your business",
      "titleFor": "Next steps for your business: {type}",
      "progress": "{done} of {total} ticked off",
      "markDone": "Mark as done",
      "undo": "Not done yet",
      "products": {
        "title": "Add your products",
        "body": "Customers can browse and order them right inside WhatsApp.",
        "cta": "Add products"
      },
      "orderNotifications": {
        "title": "Turn on order updates",
        "body": "Tell customers automatically when an order is confirmed, shipped and delivered.",
        "cta": "Set up updates"
      },
      "abandonedCarts": {
        "title": "Remind customers about unfinished carts",
        "body": "See carts that were not paid and send a friendly reminder.",
        "cta": "Open carts"
      },
      "menu": {
        "title": "Add your menu",
        "body": "Put your dishes and prices in one place so customers can order by chat.",
        "cta": "Add the menu"
      },
      "autoReplies": {
        "title": "Set your automatic replies",
        "body": "Welcome message, working hours and an away message — set once, sent for you.",
        "cta": "Set replies"
      },
      "services": {
        "title": "Add your services",
        "body": "List what customers can book, with duration and price.",
        "cta": "Add services"
      },
      "staff": {
        "title": "Add your team’s schedules",
        "body": "Who works when, so customers only see free times.",
        "cta": "Add staff"
      },
      "bookingSettings": {
        "title": "Set booking reminders",
        "body": "Remind customers before the appointment so fewer people miss it.",
        "cta": "Set reminders"
      },
      "quotes": {
        "title": "Prepare your quotes",
        "body": "Set your quote number, validity and terms once.",
        "cta": "Set up quotes"
      },
      "importContacts": {
        "title": "Bring in your customer list",
        "body": "Upload a spreadsheet of customers who agreed to hear from you.",
        "cta": "Import customers"
      },
      "broadcast": {
        "title": "Send your first offer",
        "body": "Send one message to many customers who agreed to receive offers.",
        "cta": "Create an offer"
      }
    }
  },
  "gallery": {
    "nav": "Ready-made reply templates",
    "title": "Ready-made reply templates",
    "subtitle": "Ready-made flows and message templates for your industry, written in Arabic first.",
    "filter": "Industry",
    "all": "All industries",
    "fallback": "No pack for your industry yet — showing the general business pack.",
    "flowsCount": "{count, plural, one {# flow} other {# flows}}",
    "templatesCount": "{count, plural, one {# message template} other {# message templates}}",
    "import": "Import pack",
    "importing": "Importing…",
    "imported": "Imported as drafts: {count, plural, one {# flow} other {# flows}}. Nothing is published.",
    "draftsNote": "Imports are always drafts. Review and publish them yourself.",
    "loadError": "Could not load the gallery.",
    "importError": "Could not import this pack."
  },
  "helpCenter": {
    "nav": "Help Center",
    "title": "Help Center",
    "subtitle": "Guides for connecting a number, building flows, selling in chat, billing and compliance.",
    "search": "Search guides",
    "searchPlaceholder": "Search, e.g. connect a number",
    "noResults": "No guides match your search.",
    "back": "Back to all guides",
    "notFound": "This guide does not exist.",
    "openPage": "Open this page",
    "status": "Service status",
    "videos": {
      "title": "Video library",
      "all": "All videos",
      "duration": "{minutes} min",
      "unavailable": "This video is not published in your language yet.",
      "notFound": "This video does not exist.",
      "helpLink": "Watch the walkthrough",
      "items": {
        "flow-builder": "Building flows",
        "broadcast-composer": "Sending a broadcast",
        "booking-settings": "Setting up bookings"
      }
    },
    "changelog": {
      "title": "What's new",
      "empty": "No updates yet.",
      "loadError": "Could not load the changelog.",
      "category": {
        "feature": "New feature",
        "improvement": "Improvement",
        "fix": "Fix",
        "announcement": "Announcement"
      }
    },
    "supportWidget": {
      "open": "Chat with support",
      "title": "Support",
      "close": "Close",
      "intro": "Tell us what you need help with — our team will reply here.",
      "placeholder": "Write your message",
      "send": "Send",
      "error": "Could not send your message. Try again."
    },
    "sampleData": {
      "offer": "Want to explore first? Load sample contacts and conversations.",
      "seeded": "You are viewing sample data. It is clearly marked and never counts toward your setup progress.",
      "seed": "Sample data",
      "remove": "Remove sample",
      "error": "Something went wrong. Try again.",
      "dismiss": "Dismiss"
    }
  },
  "widget": {
    "nav": "Website widget",
    "title": "Website chat widget",
    "subtitle": "A launcher for your website that opens a real WhatsApp conversation with your business.",
    "forbidden": "You don't have access to the widget settings.",
    "saved": "Widget saved",
    "save": "Save changes",
    "form": {
      "phoneNumber": "WhatsApp number",
      "displayName": "Display name",
      "accentColor": "Accent color",
      "position": "Position",
      "triggerDelay": "Show after (seconds)",
      "desktopMode": "On desktop",
      "greetingAr": "Greeting (Arabic)",
      "greetingEn": "Greeting (English)",
      "offHoursAr": "Out-of-hours greeting (Arabic)",
      "offHoursEn": "Out-of-hours greeting (English)",
      "hoursAware": "Use the out-of-hours greeting when the business is closed",
      "hoursAwareHint": "Follows your business hours and holidays."
    },
    "positions": {
      "bottom-left": "Bottom start (left)",
      "bottom-right": "Bottom end (right)"
    },
    "desktopModes": {
      "qr": "Show a QR code",
      "iframe": "Open WhatsApp Web inside the page"
    },
    "embed": {
      "title": "Embed snippet",
      "hint": "Paste this single tag before the closing body tag of your website.",
      "copy": "Copy snippet",
      "copied": "Snippet copied"
    },
    "preview": {
      "title": "Live preview",
      "hint": "This is how the launcher looks on your site. Save your changes to refresh it."
    },
    "chat": {
      "title": "Live chat on your website",
      "hint": "Let visitors type messages that land in your inbox. Replies appear in the chat on your site.",
      "enable": "Enable live chat",
      "enableHint": "Creates the Website chat channel the first time you save.",
      "origins": "Allowed websites",
      "originsHint": "One address per line, like https://shop.example.com. Only these sites can chat.",
      "originsEmpty": "Add at least one website, or no one can chat.",
      "originsInvalid": "Use full addresses starting with https:// and no path.",
      "prechat": {
        "enable": "Ask visitors for their details before chatting",
        "field": {
          "name": "Name",
          "phone": "Mobile number",
          "email": "Email"
        },
        "mode": {
          "off": "Hidden",
          "optional": "Optional",
          "required": "Required"
        }
      },
      "launcherIcon": "Launcher icon",
      "icons": {
        "chat": "Chat bubble",
        "message": "Envelope",
        "help": "Help",
        "whatsapp": "Phone"
      },
      "launcherTextAr": "Launcher text (Arabic)",
      "launcherTextEn": "Launcher text (English)",
      "avatarUrl": "Avatar image URL (https)",
      "language": "Widget language",
      "languages": {
        "auto": "Match the visitor's browser",
        "ar": "Arabic",
        "en": "English"
      },
      "sound": "Play a sound on new messages",
      "uploads": "Let visitors send images and files",
      "uploadsHint": "Up to 5 MB; images, PDF and plain text only. Files are scanned before they reach your team.",
      "continueOnWhatsApp": "Show \"Continue on WhatsApp\"",
      "continueOnWhatsAppHint": "Links to your WhatsApp number with a reference code so the conversation can be matched.",
      "offlineForm": "Offline message form",
      "offlineFormHint": "Outside business hours visitors leave a message that opens a conversation.",
      "offlineEmail": "Email the team about offline messages",
      "offlineEmailHint": "Never shown to visitors."
    },
    "b29b": {
      "logoSource": "Widget logo",
      "logoWorkspace": "Business logo",
      "logoUpload": "Upload an image",
      "logoPick": "Choose image",
      "logoAlt": "Logo preview",
      "logoNone": "No logo yet"
    },
    "picker": {
      "label": "Widget",
      "default": "Main widget",
      "newName": "New widget name",
      "add": "Add widget"
    }
  },
  "orderLifecycle": {
    "title": "Order notifications",
    "b29b": {
      "watoStore": "Your Wato store"
    },
    "templateNotApproved": {
      "reason": "This status uses a template that Meta has not approved yet, so it was not saved. Pick an approved template or wait for approval.",
      "cta": "Open templates"
    },
    "saved": "Saved",
    "error": "Something went wrong. Please try again.",
    "save": "Save",
    "windowHint": "Free-form text is sent inside the 24-hour window; outside it the bound template is used automatically.",
    "freeform": "Message text (use [reference] for the order number, [customer_name] for the customer's name and [status] for the status)",
    "templateId": "Template ID (used outside the 24-hour window)",
    "status": {
      "confirmed": "Order confirmed",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "refunded": "Refunded",
      "cod_confirmation": "Cash-on-delivery confirmation"
    },
    "cod": {
      "confirmationEnabled": "Send a Confirm / Cancel message for new cash-on-delivery orders",
      "title": "Cash on delivery",
      "timeoutMinutes": "Minutes to wait for the customer to confirm",
      "policy": "If the customer does not respond",
      "autoCancel": "Cancel the order",
      "stayPending": "Keep it pending for my team",
      "incentiveEn": "Pay-online incentive (English)",
      "incentiveAr": "Pay-online incentive (Arabic)",
      "incentiveHint": "Plain text only, up to 200 characters."
    },
    "intro": {
      "title": "How order notifications work",
      "what": "A message sent to the customer automatically each time their order changes status.",
      "when": "Use it once your store is connected, so customers see where their order is without asking you.",
      "step1": "Turn on the statuses you want to notify the customer about.",
      "step2": "Write the message text, and link an approved template for use outside the 24-hour window.",
      "step3": "Save your changes.",
      "businessName": "Rose Garden",
      "caption": "Example: messages the customer receives automatically when an order is confirmed and shipped.",
      "msg1": "Your order #123 is confirmed and we have started preparing it.",
      "msg2": "Your order #123 has shipped and will arrive within 2 to 3 days.",
      "msg2Button": "Track shipment",
      "msg3": "Thank you!"
    }
  },
  "routing": {
    "b29b": {
      "upgrade": "Upgrade"
    },
    "nav": {
      "teams": "Teams & routing"
    },
    "presence": {
      "busy": "Busy",
      "availabilityLabel": "Presence",
      "setAvailable": "Available",
      "setBusy": "I'm busy",
      "online": "Online",
      "mobile": "Mobile only",
      "away": "Away",
      "offline": "Offline",
      "lastActive": "last active {time}"
    },
    "strategy": {
      "manual": "Manual",
      "round_robin": "Round-robin",
      "least_open": "Least open conversations"
    },
    "afterHours": {
      "assign_anyway": "Assign anyway",
      "hold": "Hold until business hours"
    },
    "locked": {
      "title": "Teams & routing is available on higher plans",
      "body": "Upgrade your plan to create teams, business hours and automatic assignment."
    },
    "teams": {
      "routingRules": {
        "title": "Routing rules",
        "description": "Rules run top to bottom; the first match wins.",
        "add": "Add rule",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "enabled": "Enabled",
        "target": "Send to team",
        "field": {
          "channel": "Channel / number",
          "language": "Language",
          "label": "Label",
          "segment": "Segment",
          "intent": "Intent",
          "entry_source": "Entry source"
        },
        "op": {
          "is": "is",
          "is_not": "is not"
        },
        "empty": "No routing rules yet."
      },
      "sla": {
        "timer": {
          "remaining": "SLA running",
          "overdue": "SLA breached"
        },
        "report": {
          "title": "SLA breaches",
          "team": "Team",
          "total": "Conversations",
          "breached": "Breached",
          "rate": "Breach rate",
          "empty": "No SLA data in this period."
        }
      },
      "title": "Teams",
      "create": "New team",
      "edit": "Edit",
      "delete": "Delete",
      "empty": "No teams yet."
    },
    "team": {
      "name": "Team name",
      "strategy": "Assignment strategy",
      "afterHours": "Outside business hours",
      "members": "Members",
      "capacity": "Capacity cap for {name}",
      "unlimited": "Unlimited",
      "save": "Save team",
      "saveFailed": "Could not save the team.",
      "botContinuation": "Automation keeps replying while the agent is away",
      "botContinuationHelp": "When the assigned agent is away or only on mobile, the AI Agent keeps answering. Off by default.",
      "botContinuationSaveFailed": "Could not save the setting."
    },
    "hours": {
      "title": "Business hours",
      "open": "{day} opens",
      "close": "{day} closes",
      "closed": "Closed",
      "markClosed": "Close",
      "markOpen": "Open",
      "day": {
        "sun": "Sunday",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday"
      }
    }
  },
  "aiRouting": {
    "editor": {
      "label": "Instructions",
      "hint": "Type @ to insert an allowed action.",
      "disallowed": "@{name} is not in this agent's allowlist — remove it or allow it before publishing."
    },
    "badge": {
      "static": "Static (chunked)",
      "live": "Live lookup"
    },
    "forceByok": {
      "title": "Force BYOK",
      "description": "When on, workspaces must use their own AI key. The platform key is never used as a fallback.",
      "toggle": "Force BYOK for {name}",
      "confirm": "Turn this on? Workspaces without their own AI key will have AI disabled immediately.",
      "confirmAction": "Confirm",
      "cancel": "Cancel",
      "failed": "Could not update the setting. Try again."
    },
    "banner": {
      "aiDisabledForceByok": "AI is off: your plan requires your own provider key. Add a key to turn it on."
    }
  },
  "command": {
    "title": "Quick search",
    "placeholder": "Search pages, contacts, flows, templates…",
    "empty": "Nothing found.",
    "hint": "Enter to open · Esc to close · Ctrl+K toggles",
    "notEnabled": "Not enabled for your business",
    "open": "What do you need? (Ctrl+K)",
    "kind": {
      "page": "Page",
      "contact": "Contact",
      "conversation": "Conversation",
      "product": "Product",
      "flow": "Flow",
      "template": "Template",
      "action": "Action"
    },
    "action": {
      "channelHealth": "Check channel health",
      "weeklyReport": "Weekly summary",
      "connectChannel": "Connect a WhatsApp number"
    }
  },
  "agency": {
    "branding": {
      "title": "Branding",
      "logoUrl": "Logo URL (https)",
      "primaryColor": "Primary colour (#RRGGBB)",
      "accentColor": "Accent colour (#RRGGBB)",
      "senderName": "Email sender name",
      "save": "Save branding",
      "saved": "Saved.",
      "error": "Could not save. Check the values and that you are the agency owner."
    },
    "pricing": {
      "title": "Client pricing",
      "hint": "Set the price your clients pay as a percent markup over the platform cost. It can never go below the platform cost.",
      "columns": {
        "plan": "Plan",
        "base": "Platform cost",
        "price": "Client price",
        "markup": "Markup %",
        "margin": "Your margin"
      },
      "markupFor": "Markup percent for {plan}",
      "apply": "Apply"
    },
    "console": {
      "title": "Agency console",
      "empty": "No client workspaces yet. Create your first one.",
      "loadError": "Could not load your client workspaces.",
      "createClient": "New client",
      "quickSwitch": "Open",
      "switching": "Switching…",
      "switchError": "Could not switch into this workspace.",
      "columns": {
        "name": "Client",
        "market": "Market",
        "status": "Status",
        "plan": "Plan",
        "members": "Members",
        "contacts": "Contacts"
      },
      "noPlan": "No plan"
    },
    "wizard": {
      "title": "Create client workspace",
      "name": "Client name",
      "market": "Market",
      "marketSA": "Saudi Arabia",
      "marketBH": "Bahrain",
      "plan": "Starter plan",
      "planStarter": "Starter",
      "planGrowth": "Growth",
      "planBusiness": "Business",
      "cloneTemplate": "Clone from template (optional)",
      "cloneHint": "Template workspace ID. Leave empty to start blank.",
      "submit": "Create",
      "submitting": "Creating…",
      "cancel": "Cancel",
      "error": "Could not create the workspace. Check the details and try again.",
      "cloneFailed": "The workspace was created, but cloning the template failed."
    },
    "bulkMigration": {
      "title": "Bulk migration",
      "pickTemplate": "Mapping template",
      "templateId": "Agency mapping template ID",
      "source": "Source",
      "market": "Market",
      "addFiles": "Add client source files (one per client)",
      "clientLabel": "Client name",
      "removeFile": "Remove",
      "review": "Review dry-run",
      "commitAll": "Commit all",
      "submitting": "Preparing…",
      "loadError": "Could not load the batch.",
      "reviewNote": "Review each client's dry-run before committing. Rollback stays per client job.",
      "col": {
        "client": "Client",
        "status": "Status",
        "rows": "Rows",
        "rollback": "Rollback until",
        "open": "Open job"
      },
      "status": {
        "queued": "Queued",
        "importing": "Importing",
        "needs_review": "Needs review",
        "complete": "Complete",
        "failed": "Failed"
      },
      "batch": {
        "running": "Running",
        "completed": "Completed",
        "completed_with_errors": "Completed with errors"
      }
    },
    "detach": {
      "action": "Detach",
      "confirmTitle": "Detach {name} from your agency?",
      "confirmBody": "Ownership and billing move to the client once they confirm. All data stays intact.",
      "agencyPaysNotice": "This client is on Agency-Pays: they must add their own payment method before they can accept.",
      "send": "Send request",
      "sent": "Detach request sent. Waiting for the client to confirm.",
      "error": "Could not send the detach request."
    },
    "incomingDetach": {
      "title": "Your agency wants to detach this workspace",
      "body": "Your workspace will be billed directly to you and will no longer be managed by the agency. No data is changed.",
      "paymentRequired": "Add your own payment method first, then accept.",
      "addPayment": "Add payment method",
      "accept": "Accept",
      "accepting": "Accepting…",
      "accepted": "Workspace detached. You now manage billing directly.",
      "error": "Could not complete the detach."
    },
    "overrides": {
      "title": "Feature overrides",
      "enabled": "Enabled",
      "notOnPlan": "Not available on your agency plan",
      "error": "Could not update this feature."
    }
  },
  "byok": {
    "b29b": {
      "model": {
        "deepseek_deepseek_v4_flash": "DeepSeek fast",
        "deepseek_deepseek_v4_pro": "DeepSeek advanced",
        "deepseek_deepseek_chat": "DeepSeek chat",
        "anthropic_claude_sonnet_4_5": "Claude balanced",
        "anthropic_claude_3_5_haiku": "Claude fast",
        "google_gemini_2_0_flash_001": "Gemini fast",
        "openai_gpt_4o": "GPT advanced",
        "openai_gpt_4o_mini": "GPT fast"
      }
    },
    "title": "Your own AI key",
    "intro": "Use your own account with the AI company instead of Wato's subscription (called BYOK). Add your key; it is stored encrypted and never shown again.",
    "meteringNote": "While your own key is active for a provider, platform wallet billing no longer applies to that provider's calls. Usage is still recorded for visibility.",
    "provider": {
      "anthropic": "Anthropic",
      "openai": "OpenAI",
      "gemini": "Gemini",
      "openrouter": "OpenRouter"
    },
    "status": {
      "none": "No key",
      "active": "Active",
      "rotating": "Being replaced",
      "revoked": "Revoked"
    },
    "apiKey": "API key",
    "openrouterHelp": "Use any model through OpenRouter with your own key (for example anthropic/claude-sonnet-4.5 or openai/gpt-4o-mini).",
    "openrouterLink": "Get a key from openrouter.ai",
    "keyHint": "Paste the full key from your provider. It is stored encrypted and never shown again.",
    "added": "Added",
    "lastUsed": "Last used",
    "never": "Never",
    "add": "Add key",
    "rotate": "Replace key",
    "revoke": "Revoke key",
    "save": "Save key",
    "cancel": "Cancel",
    "confirmRevoke": "Revoke this key? AI calls will fall back to the platform key, or stop if your plan requires your own key.",
    "confirmYes": "Yes, revoke",
    "aiDisabled": "AI is disabled: your plan requires your own key and none is active.",
    "test": {
      "button": "Test key",
      "ok": "Key accepted by the provider.",
      "savedNext": "Key saved. Next step: create or open an AI agent and it will answer using this key."
    },
    "model": {
      "label": "Preferred model",
      "default": "Default",
      "hint": "Optional. Leave empty to use Wato's default model. For OpenRouter use a full name such as anthropic/claude-sonnet-4.5.",
      "change": "Change model"
    },
    "errors": {
      "invalidKey": "This key looks invalid. Paste the full key from your provider (8 to 512 characters, no spaces or line breaks).",
      "alreadyExists": "This provider already has an active key. Use “Replace key” to change it.",
      "notFound": "No active key exists for this provider. Add a new key instead.",
      "keyRejected": "Your key was not accepted by the provider. Check that you copied the whole key and that it is still active, then try again.",
      "invalidModel": "The model name looks invalid. Use letters, numbers and these symbols only: . _ : / -"
    },
    "next": {
      "any": {
        "invalid": "Next step: copy the full key again from your provider’s keys page, with no spaces, and paste it here.",
        "rejected": "Next step: open your provider’s keys page, check the key is still active, create a new one if not, then paste it here and press Test again.",
        "offline": "Next step: check your internet connection and press Test again. Nothing was saved and your key was not lost.",
        "credit": "Next step: add credit or a payment method at your provider, then press Test again.",
        "other": "Next step: press Test again in a minute. If it keeps failing, contact support and mention the time."
      },
      "openrouter": {
        "invalid": "Next step: on openrouter.ai open Keys, create a new key (it starts with sk-or-) and paste the full key here.",
        "rejected": "Next step: on openrouter.ai open Keys and check the key is enabled and has credit. Then confirm the model is written as vendor/model, for example openai/gpt-4o-mini.",
        "offline": "Next step: check your internet connection and press Test again. OpenRouter was not reached and nothing was saved.",
        "credit": "Next step: on openrouter.ai open Credits and add balance, then press Test again.",
        "other": "Next step: press Test again in a minute. If it keeps failing, check status on openrouter.ai, then contact support."
      }
    }
  },
  "webhooks": {
    "eventNames": {
      "message_created": "Message received",
      "message_failed": "Message failed",
      "conversation_assigned": "Conversation assigned",
      "commerce_order_created": "Order created",
      "payment_paid": "Payment received",
      "quote_accepted": "Quote accepted",
      "contact_created": "Contact created",
      "subscriber_opted_out": "Contact opted out"
    },
    "title": "Webhooks",
    "subtitle": "Receive signed events into a Flow, and send platform events to your own systems.",
    "forbidden": "You don't have permission to view webhooks.",
    "secretOnce": "Copy this secret now — it is shown only once.",
    "done": "Done",
    "actions": "Actions",
    "delete": "Delete",
    "never": "Never",
    "resumed": "Endpoint resumed",
    "testSent": "Test event sent",
    "replayed": "Delivery replayed",
    "mode": {
      "enforce": "Enforce",
      "logOnly": "Log only"
    },
    "usage": {
      "calls": "Calls",
      "last": "Last called",
      "summary": "{calls} calls, {errors} errors",
      "full": "{calls} calls · {successes} ok · {errors} errors"
    },
    "incoming": {
      "title": "Incoming webhooks",
      "name": "Name",
      "url": "Signed URL",
      "mode": "Mode",
      "flowId": "Target flow ID",
      "create": "Create webhook",
      "toggleMode": "Switch mode"
    },
    "outgoing": {
      "title": "Outgoing webhooks",
      "url": "Endpoint URL",
      "status": "Status",
      "paused": "Paused since {date}",
      "verified": "Verified",
      "unverified": "Not verified",
      "acknowledgeResume": "Acknowledge and resume",
      "test": "Send test event",
      "rotate": "Rotate secret",
      "log": "Delivery log",
      "events": "Events",
      "create": "Create outgoing webhook",
      "edit": "Edit",
      "save": "Save changes",
      "cancelEdit": "Cancel",
      "saved": "Endpoint updated",
      "enable": "Enable",
      "disable": "Disable",
      "enabled": "Endpoint enabled",
      "disabled": "Endpoint disabled"
    },
    "log": {
      "title": "Delivery log",
      "event": "Event",
      "attempt": "Attempt",
      "code": "HTTP status",
      "latency": "Latency",
      "success": "Delivered",
      "failed": "Failed, will retry",
      "exhausted": "Failed",
      "replay": "Replay"
    },
    "channel": {
      "whatsapp_cloud": "Cloud API",
      "whatsapp_waha": "QR"
    }
  },
  "compliance": {
    "ladder": {
      "warning": {
        "title": "Heads up: your messaging quality needs attention",
        "body": "Some recipients are blocking or reporting your messages. Nothing is restricted yet.",
        "fix": "Send only to people who opted in and review your recent message content."
      },
      "throttled": {
        "title": "Some features are temporarily limited",
        "body": "Broadcasts are capped and AI replies are paused while we check your account.",
        "fix": "Stop bulk sends, remove unopted contacts and appeal if you think this is a mistake."
      },
      "suspended": {
        "title": "Your WhatsApp channel is suspended",
        "body": "The channel is disabled. Your data is kept safe.",
        "fix": "Review our policies and submit an appeal explaining what you will change."
      },
      "terminated": {
        "title": "Your account has been terminated",
        "body": "This workspace can no longer use messaging.",
        "fix": "Contact support if you believe this was an error."
      }
    },
    "industry": {
      "title": "What does your business do?",
      "intro": "We use this to keep WhatsApp safe for everyone.",
      "category": "Industry",
      "submit": "Continue",
      "prohibited": "This industry cannot be connected to WhatsApp on our platform.",
      "restricted": "This industry needs documentation and a manual review before you can connect.",
      "uploadDocs": "Upload licence or documentation",
      "pending": "Your documents are under review.",
      "categories": {
        "adult_content": "Adult content",
        "gambling": "Gambling",
        "weapons": "Weapons",
        "illegal_drugs": "Illegal drugs",
        "tobacco_vaping": "Tobacco and vaping",
        "alcohol": "Alcohol",
        "pharmacy": "Pharmacy",
        "financial_services": "Financial services",
        "crypto_assets": "Crypto assets",
        "medical_clinic": "Medical clinic",
        "debt_collection": "Debt collection",
        "retail": "Retail",
        "restaurant": "Restaurant",
        "salon": "Salon",
        "real_estate": "Real estate",
        "education": "Education",
        "professional_services": "Professional services",
        "other_general": "Other"
      }
    },
    "appeal": {
      "title": "Appeal this decision",
      "message": "Tell us what happened and what you will change",
      "submit": "Submit appeal",
      "submitted": "Appeal received. A person will review it.",
      "duplicate": "You already have an appeal for this issue; we linked it to the original."
    },
    "admin": {
      "industriesTitle": "Industry review queue",
      "appealsTitle": "Appeals queue",
      "expedited": "Expedited",
      "dueAt": "Target turnaround",
      "ladderTitle": "Enforcement status",
      "reverse": "Reverse automatic action",
      "assign": "Assign reviewer"
    }
  },
  "socialPosts": {
    "nav": "Social posts",
    "title": "Social posts",
    "subtitle": "Compose, schedule and publish posts to your Instagram and Facebook Page.",
    "forbidden": "You don't have access to social posts.",
    "noAccounts": "Connect an Instagram account in Channels to start posting.",
    "account": "Account",
    "empty": "No posts yet.",
    "unscheduled": "Drafts (no date)",
    "targets": {
      "instagram": "Instagram",
      "facebook_page": "Facebook Page"
    },
    "kinds": {
      "text": "Text",
      "link": "Link",
      "image": "Image",
      "video": "Video",
      "carousel": "Carousel"
    },
    "status": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "publishing": "Publishing",
      "published": "Published",
      "failed": "Failed"
    },
    "modes": {
      "draft": "Save as draft",
      "schedule": "Schedule",
      "now": "Post now"
    },
    "submit": {
      "draft": "Save draft",
      "schedule": "Schedule post",
      "now": "Publish now"
    },
    "created": {
      "draft": "Draft saved",
      "scheduled": "Post scheduled",
      "publishing": "Publishing…",
      "published": "Post published",
      "failed": "Publishing failed. See the error and retry."
    },
    "compose": {
      "title": "New post",
      "target": "Publish to",
      "kind": "Post type",
      "caption": "Caption",
      "topic": "Topic for AI caption",
      "topicHint": "Describe the post in a few words; you review and edit the result.",
      "suggest": "Suggest captions",
      "suggestions": "Caption suggestions",
      "link": "Link",
      "media": "Media URLs (https, one per line)",
      "mediaHint": {
        "image": "One image URL.",
        "video": "One video URL (mp4 or mov).",
        "carousel": "2 to 10 image or video URLs."
      },
      "mode": "When",
      "when": "Date and time"
    },
    "errors": {
      "whenRequired": "Choose a date and time to schedule."
    },
    "actions": {
      "publish": "Publish now",
      "retry": "Retry",
      "unschedule": "To drafts",
      "delete": "Delete"
    }
  },
  "shortLinks": {
    "nav": "Links & QR",
    "title": "Short links & QR codes",
    "subtitle": "Share a short link or QR code that opens a WhatsApp chat with a pre-filled message and tracks where the customer came from.",
    "forbidden": "You don't have access to short links.",
    "created": "Short link created",
    "empty": "No short links yet.",
    "delete": "Delete",
    "create": {
      "title": "New short link",
      "number": "WhatsApp number",
      "message": "Pre-filled message",
      "slug": "Custom slug (optional)",
      "slugHint": "3-40 characters: a-z, 0-9 and hyphens. Leave empty for a random one.",
      "expires": "Expires at (optional)",
      "expiresHint": "Pick the date and time from the calendar. Leave it empty if the link should never expire.",
      "submit": "Create link"
    },
    "columns": {
      "link": "Link",
      "clicks": "Clicks",
      "expires": "Expires",
      "active": "Active",
      "actions": "Actions"
    },
    "errors": {
      "numberRequired": "Enter the WhatsApp number with the country code, at least 7 digits.",
      "slugInvalid": "Use only English letters, digits and hyphens in the link name.",
      "slugTaken": "This slug is already taken. Choose another."
    },
    "bulk": {
      "title": "Bulk import (CSV)",
      "hint": "CSV column names (type them exactly as written): slug (optional), targetWaNumber (WhatsApp number), prefilledMessage (ready message), refTag (source tag). Every row is checked first; if any row is invalid, no links are created.",
      "submit": "Import links",
      "done": "{count} short links created",
      "rejected": "Nothing was imported. Fix these rows and try again:",
      "rowError": "Row {row} ({field}): {message}"
    },
    "qr": {
      "open": "QR code",
      "title": "QR code for {slug}",
      "format": "Format",
      "size": "Size",
      "sizes": {
        "small": "Screen, small (256 px)",
        "medium": "Screen, medium (512 px)",
        "large": "Screen, large (1024 px)",
        "print": "Print-ready (10 cm at 300 DPI)"
      },
      "source": "Source tag (optional)",
      "sourceHint": "Added to this QR only, so scans can be attributed, e.g. poster or table-tent.",
      "frame": "Branded frame (logo and call to action)",
      "frameVectorOnly": "The branded frame is available for SVG and PDF.",
      "cta": "Call-to-action text",
      "ctaPdfHint": "PDF supports Latin text only; use SVG for Arabic.",
      "download": "Download QR"
    }
  },
  "photoMatch": {
    "title": "Looks like",
    "sendCard": "Send",
    "notIt": "Not it",
    "sent": "Sent",
    "failed": "Could not send the product."
  },
  "receiptOcr": {
    "markAsPaid": "Mark as paid",
    "manualReview": "Low confidence or unreadable — review this image manually.",
    "amount": "Amount",
    "date": "Date",
    "reference": "Reference",
    "bank": "Sender bank",
    "confidence": "Confidence",
    "chooseOrder": "Order this receipt pays",
    "chooseOrderPlaceholder": "Select an order…",
    "class": {
      "payment_proof": "Payment proof",
      "product_photo": "Product photo",
      "id_document": "ID document",
      "other": "Other image"
    },
    "status": {
      "pending_review": "Pending review",
      "approved": "Marked as paid",
      "rejected": "Rejected"
    },
    "errors": {
      "generic": "Could not mark as paid. Try again.",
      "APPROVAL_SELF_DECISION": "A different team member must approve this payment."
    }
  },
  "marketplace": {
    "nav": {
      "browse": "Marketplace",
      "submit": "Sell on marketplace"
    },
    "browse": {
      "title": "Template marketplace",
      "filterAll": "All",
      "filterOfficial": "Official",
      "filterPartner": "Partner",
      "free": "Free",
      "install": "Install",
      "installed": "Installed as a draft for your review",
      "empty": "No listings yet.",
      "metaApproval": "Templates in this listing still need your own Meta approval after install — installing does not bypass it.",
      "nonDestructive": "Installing never overwrites your existing flows: the new version arrives as a separate draft to review and merge.",
      "error": "Could not load the marketplace."
    },
    "submit": {
      "title": "Submit a listing",
      "titleAr": "Title (Arabic)",
      "titleEn": "Title (English)",
      "descAr": "Description (Arabic)",
      "descEn": "Description (English)",
      "category": "Category",
      "type": "Type",
      "typeFlow": "Flow",
      "typePack": "Pack",
      "typeBundle": "Template bundle",
      "price": "Price (minor units, empty = free)",
      "currency": "Currency",
      "version": "Version",
      "export": "Export JSON",
      "submit": "Save draft",
      "sendForReview": "Send for review",
      "checkStatus": "Automated checks: {status}",
      "notesFromReviewer": "Reviewer feedback: {notes}",
      "error": "Could not save the listing."
    },
    "status": {
      "draft": "Draft",
      "in_review": "In review",
      "published": "Published",
      "rejected": "Rejected",
      "delisted": "Delisted",
      "none": "Not run",
      "pending": "Queued",
      "running": "Running",
      "passed": "Passed",
      "failed": "Failed"
    },
    "checks": {
      "secrets_pii": "Secrets and personal data",
      "flow_structure": "Flow structure",
      "template_compliance": "Meta template compliance",
      "skipped": "Skipped"
    },
    "review": {
      "title": "Marketplace review queue",
      "empty": "Nothing waiting for review.",
      "approve": "Approve",
      "reject": "Reject",
      "notes": "Feedback for the seller (required to reject)",
      "report": "Check report",
      "error": "Could not load the review queue."
    },
    "reviews": {
      "title": "Reviews",
      "empty": "No reviews yet.",
      "rating": "Rating",
      "comment": "Your comment",
      "submit": "Submit review",
      "error": "Could not save your review.",
      "notAllowed": "Only workspaces that installed this listing can review it.",
      "sellerReply": "Seller reply",
      "replyPlaceholder": "Reply to this review",
      "reply": "Send reply",
      "stars": "out of 5"
    },
    "refund": {
      "title": "Report a defective listing",
      "eligibility": "You can request a refund within {days} days of installing. A platform administrator approves every refund.",
      "reason": "What is wrong?",
      "request": "Request refund",
      "requested": "Refund requested — we will review it.",
      "windowClosed": "The {days}-day refund window for this install has closed.",
      "error": "Could not send the refund request."
    },
    "settings": {
      "title": "Marketplace revenue and refunds",
      "platformShare": "Platform share (%)",
      "sellerShare": "Seller share (%)",
      "minPayout": "Minimum payout ({currency}, minor units)",
      "refundWindow": "Refund window (days)",
      "ratingBelow": "Re-review when average rating is below",
      "minReviews": "Minimum reviews before flagging",
      "save": "Save settings",
      "saved": "Settings saved.",
      "error": "Could not save the settings."
    },
    "delist": {
      "title": "Delist listing",
      "listingId": "Listing ID",
      "reason": "Reason (shown to installers)",
      "confirm": "Delist",
      "note": "Existing installs keep working; installers are notified with this reason.",
      "done": "Listing delisted.",
      "error": "Could not delist the listing."
    },
    "guarantee": {
      "title": "Results guarantee",
      "progress": "Auto-handled rate: {rate}% of {threshold}% target",
      "daysLeft": "{days} days left in your 30-day window",
      "paused": "{days} paused days excluded",
      "choose": "Choose your refund",
      "original": "Refund",
      "wallet": "Wallet credit",
      "refundOffer": "You're eligible for a refund of {amount}.",
      "adminTitle": "Guarantee liability forecast",
      "adminExposure": "Exposure ({currency}): {amount}",
      "adminWorkspace": "Workspace",
      "adminRate": "Auto-handled rate",
      "adminEmpty": "No workspaces below threshold.",
      "adminDisabled": "The guarantee is switched off."
    }
  },
  "branches": {
    "nav": "Branches",
    "title": "Branches",
    "subtitle": "Manage the branches of your business. Catalog, bookings and routing can be scoped per branch.",
    "forbidden": "You don't have access to branch settings.",
    "default": "Default",
    "inactive": "Inactive",
    "empty": "No branches yet.",
    "form": {
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "address": "Address"
    },
    "actions": {
      "add": "Add branch",
      "save": "Save",
      "deactivate": "Deactivate",
      "activate": "Activate"
    },
    "created": "Branch created",
    "saved": "Branch saved",
    "errors": {
      "notEntitled": "Your plan does not include multiple branches.",
      "defaultProtected": "The default branch cannot be deactivated."
    }
  },
  "supervisor": {
    "observe": "Observe",
    "liveOpenInbox": "Open in inbox",
    "liveTitle": "Live conversations",
    "liveEmpty": "No live conversations right now.",
    "liveAssignee": "Agent",
    "liveDuration": "{minutes} min",
    "liveCount": "{count} live conversations",
    "liveDurationHours": "{hours} h {minutes} min",
    "liveLastMessage": "Last message",
    "liveRefresh": "Refresh",
    "liveColumnConversation": "Conversation",
    "liveColumnDuration": "Duration",
    "observing": "Observing (read-only)",
    "notAssigned": "Assign the conversation to an agent first to observe it.",
    "whisper": {
      "title": "Whisper (internal)",
      "internalOnly": "Only the assigned agent and supervisors see this. It is never sent to the customer.",
      "inputLabel": "Whisper to the assigned agent",
      "send": "Send whisper"
    }
  },
  "faqMining": {
    "nav": "Frequent customer questions",
    "candidates": {
      "clusterSize": "{count} similar questions",
      "draft": "Draft answer (Arabic)",
      "draftEn": "Draft answer (English)",
      "needsManual": "Needs a manual answer — no knowledge-base content covers this topic.",
      "approve": "Approve & publish",
      "reject": "Reject",
      "approveHint": "Approving publishes this answer to your knowledge base."
    },
    "report": {
      "title": "Top unanswered topics",
      "notEnough": "Not enough data yet. Mining needs at least {required} unanswered questions (currently {volume}).",
      "estimateNote": "Estimated deflection value is a rough estimate, not a precise financial figure.",
      "value": "Est. deflection value: {value}",
      "empty": "No topics yet.",
      "needsManual": "Needs manual answer"
    }
  },
  "connectedApps": {
    "title": "Connected apps",
    "empty": "No third-party apps are connected to this workspace.",
    "revoke": "Revoke access",
    "revoked": "Access revoked. The app can no longer call your workspace.",
    "consent": {
      "title": "{app} wants access to your workspace",
      "intro": "Review what this app will be able to do on your behalf. You can revoke access at any time.",
      "scopes": "Requested permissions",
      "workspace": "Workspace",
      "approve": "Allow access",
      "deny": "Deny",
      "unsafeRedirect": "This app's return address is not a secure web address, so you were not sent there."
    },
    "developer": {
      "title": "Developer console",
      "name": "App name",
      "redirectUris": "Redirect URIs (comma separated)",
      "scopes": "Requested scopes",
      "register": "Register app",
      "created": "App registered. Copy the secret now, it is shown once:"
    }
  },
  "sell": {
    "disabled": {
      "noConnector": "Connect a store to enable this.",
      "sparseCatalog": "Your catalog is too small for reliable suggestions yet."
    },
    "upsell": {
      "title": "Suggested add-ons",
      "reason": "Bought together {percent}% of the time",
      "add": "Add to cart",
      "added": "Added",
      "none": "No suggestions for this cart yet.",
      "error": "We could not load suggestions."
    },
    "boosters": {
      "title": "Revenue Boosters",
      "window": "Time window",
      "days": "Last {days} days",
      "mechanism": "Mechanism",
      "revenue": "Revenue",
      "sends": "Sends",
      "conversion": "Conversion",
      "error": "We could not load this summary."
    },
    "mechanism": {
      "upsell": "Up-sell",
      "winback": "Win-back",
      "occasion": "Occasions",
      "bnpl": "Buy now, pay later",
      "cod_conversion": "COD to prepaid",
      "reorder": "Reorder reminders"
    }
  },
  "smsFallback": {
    "title": "SMS fallback",
    "intro": "Send a plain utility SMS when a WhatsApp message cannot be delivered because the number is not on WhatsApp. Never used for marketing. A STOP on any channel suppresses SMS too.",
    "enable": "Enable SMS fallback",
    "aggregator": "SMS aggregator",
    "credential": "Aggregator API key",
    "credentialPlaceholder": "Stored encrypted — enter a new key to replace it",
    "credentialSaved": "A credential is saved",
    "save": "Save",
    "saved": "Saved",
    "errors": {
      "SMS_AGGREGATOR_INVALID": "Choose a supported aggregator.",
      "SMS_CREDENTIAL_INVALID": "The credential looks invalid.",
      "SMS_CREDENTIAL_REQUIRED": "Choose an aggregator and enter its credential before enabling."
    }
  },
  "automationAdmin": {
    "noTemplateWarning": "Without an approved template this message is skipped for customers who have not written to you in the last 24 hours. Choose an approved template above.",
    "settings": {
      "title": "Chat flows settings"
    },
    "error": "Something went wrong. Please try again.",
    "saved": "Saved",
    "save": "Save",
    "configure": "Configure",
    "thresholdHours": "Hours after sending before the first reminder",
    "stepDelayHours": "Hours between reminders",
    "maxSteps": "Maximum number of reminders",
    "disableHint": "Turning this off cancels reminders that are already scheduled.",
    "freeform": "Message text (sent inside the 24-hour window)",
    "templateId": "Template ID (used outside the 24-hour window)",
    "reviewDelayMinutes": "Minutes after delivery before asking for a review",
    "reviewLink": "Review or feedback link",
    "reviewCoupon": "Reward coupon code (optional)",
    "reviewPlaceholders": "Use [reference], [link] and [coupon] in the message.",
    "lowStockHint": "Alerts go to the workspace owner once each time stock drops to a product's low-stock threshold. Set thresholds on each product.",
    "replenishment": {
      "manual": "Replenishment cycle (days)",
      "suggested": "Suggested: {days} days based on order history",
      "accept": "Accept suggestion",
      "override": "Save my value",
      "none": "Not enough repeat purchases yet"
    },
    "type": {
      "orderNotifications": "Order notifications",
      "codConfirm": "COD confirmation",
      "codToPrepaid": "COD to prepaid offer",
      "abandoned_cart": "Abandoned-cart reminders",
      "failed_payment_retry": "Failed-payment retry",
      "review_request": "Post-delivery review request",
      "low_stock_alert": "Low-stock alert to owner"
    },
    "analytics": {
      "title": "Chat flows stats",
      "empty": "No automated messages yet.",
      "type": "Automation"
    },
    "stage": {
      "triggered": "Triggered",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "clicked": "Clicked",
      "converted": "Converted"
    },
    "abTest": {
      "title": "A/B test message copy",
      "automationType": "Automation",
      "variantA": "Variant A message",
      "variantB": "Variant B message",
      "splitRatio": "Share of contacts who get variant A (%)",
      "minSample": "Minimum sends per variant",
      "start": "Start test",
      "started": "Test started.",
      "complianceNote": "Both variants follow the same opt-out, quiet-hours and frequency rules.",
      "resultsTitle": "A/B test results",
      "variant": "Variant",
      "sent": "Sent",
      "clickRate": "Click rate",
      "conversionRate": "Conversion rate",
      "leader": "Leading: {value}",
      "sampleWarning": "Fewer than {value} sends per variant so far. The result may not be reliable.",
      "declare": "Declare {value}",
      "promoted": "Winner promoted. The automation now uses this message."
    },
    "ecommerce": {
      "title": "Saudi e-commerce automations",
      "intro": "Ready-made automations for online stores. Turn each one on or off — templates and timing stay editable in the settings screens.",
      "items": {
        "abandoned_cart": {
          "title": "Abandoned cart recovery",
          "description": "Reminds customers who left items in their Salla or Zid cart."
        },
        "cod_confirmation": {
          "title": "Cash-on-delivery confirmation",
          "description": "Asks the customer to confirm a COD order with buttons."
        },
        "order_status": {
          "title": "Order status updates",
          "description": "Tells customers when their order is confirmed, shipped, out for delivery and delivered."
        },
        "post_delivery_rating": {
          "title": "Post-delivery rating request",
          "description": "Asks for a rating after the order is delivered."
        },
        "back_in_stock": {
          "title": "Back-in-stock alerts",
          "description": "Messages customers who asked to be told when an item returns."
        }
      }
    }
  },
  "automations": {
    "nav": "Automations",
    "title": "Automations",
    "subtitle": "Start from a ready-made n8n workflow. Zapier and Make connect through webhooks (an automatic alert sent to another service) — see the help center.",
    "forbidden": "You don't have permission to view automations.",
    "scopes": "Required access: {scopes}",
    "credentials": "You will also need your own {credentials} credential in n8n.",
    "imports": "Imported {count} times",
    "import": "Import to n8n",
    "imported": "Template imported into n8n.",
    "importFailed": "n8n could not import this template. Try again shortly.",
    "templates": {
      "sheets-sync": {
        "title": "Google Sheets contact sync",
        "description": "Appends your Wato contacts to a Google Sheet every hour."
      },
      "order-to-whatsapp": {
        "title": "Order → WhatsApp",
        "description": "Sends an approved WhatsApp template when your store creates an order."
      },
      "crm-sync": {
        "title": "CRM contact sync",
        "description": "Pushes updated Wato contacts to your external CRM."
      },
      "email-digest": {
        "title": "Daily email digest",
        "description": "Emails a morning summary of recent conversations."
      }
    }
  },
  "sheetPicker": {
    "sheet": "Google Sheet",
    "search": "Search your sheets",
    "searchPlaceholder": "Type a name to search",
    "choose": "Choose a spreadsheet…",
    "tab": "Tab",
    "chooseTab": "Choose a tab…",
    "loading": "Loading your sheets…",
    "empty": "No spreadsheets found in your Google account.",
    "newSheet": "New spreadsheet",
    "pasteLink": "Paste link",
    "link": "Sheet link or ID",
    "loadTabs": "Load tabs",
    "reconnect": "Reconnect Google to list your sheets. You can still paste a link.",
    "reconnectLink": "Open Google Sheets settings",
    "notConnected": "Connect Google Sheets first (Settings → Integrations).",
    "error": "Could not load your sheets. Try again or paste a link.",
    "create": {
      "title": "New spreadsheet",
      "name": "Spreadsheet name",
      "columns": "Column names (optional, comma-separated)",
      "columnsHint": "Example: name, phone, request",
      "submit": "Create",
      "cancel": "Cancel",
      "busy": "Creating…",
      "tooMany": "Up to 26 columns, each up to 100 characters.",
      "failed": "Could not create the spreadsheet. Please try again."
    }
  },
  "googleSheets": {
    "nav": "Google Sheets",
    "title": "Google Sheets",
    "subtitle": "Connect a Google account so Flows can append, update and look up spreadsheet rows. This grants Sheets access only — Calendar and Docs are connected separately.",
    "connect": "Connect Google Sheets",
    "reconnect": "Reconnect",
    "disconnect": "Disconnect",
    "confirmDisconnect": "Disconnect anyway",
    "status": {
      "connected": "Connected",
      "disconnected": "Not connected",
      "error": "Needs attention"
    },
    "empty": "Connect Google Sheets to use the Google Sheets step in your Flows.",
    "lastUsed": "Last used {time}",
    "neverUsed": "Not used yet",
    "errorHint": "Google rejected the saved access. Reconnect to restore your Flows.",
    "error": "Something went wrong. Please try again.",
    "inUse": "These published Flows use a Google Sheets step and will take their error branch if you disconnect:",
    "node": {
      "mode": "Action",
      "modes": {
        "append": "Append row",
        "update": "Update row",
        "lookup": "Look up row"
      },
      "matchColumn": "Match column (header name)",
      "matchValue": "Match value",
      "mapping": "Column values",
      "saveTo": "Save row values to variables",
      "column": "Column",
      "valueOrVariable": "Value or variable",
      "variable": "Variable",
      "findRow": {
        "account": "Google account",
        "connected": "Connected",
        "notConnected": "Google Sheets is not connected. Connect it in Settings > Integrations.",
        "lookupColumn": "Lookup column (header name)",
        "lookupValue": "Lookup value",
        "toContactFields": "Save to contact fields",
        "contactField": "Contact field",
        "toVariables": "Save to variables",
        "hint": "Returns the first matching row. Use the Found and Not found outputs to continue."
      },
      "autoMap": {
        "form": "Map a form’s questions",
        "pick": "Choose a form",
        "apply": "Map all questions automatically"
      }
    }
  },
  "drivePicker": {
    "link": {
      "spreadsheet": "Spreadsheet link or ID",
      "generic": "Google Drive link or ID"
    },
    "load": "Load",
    "tab": "Sheet tab",
    "invalid": "Enter a valid Google link or ID.",
    "error": "Couldn't open that file. Check the link and that Google is connected."
  },
  "verticalTemplates": {
    "demandTitle": "Vertical template demand",
    "industry": "Industry",
    "signups": "Signups",
    "empty": "No unmatched industries",
    "error": "Could not load template demand",
    "subtitle": "Industries that signed up without a matching template, ranked by signups.",
    "retry": "Try again",
    "loading": "Loading demand…"
  },
  "aiOutbound": {
    "catalog": {
      "title": "AI outbound scenarios",
      "scope": "Scope",
      "weeklyCap": "Weekly cap per contact",
      "category": "Template category",
      "businessHours": "Business hours only",
      "enabled": "Enabled",
      "enable": "Enable scenario",
      "disable": "Disable scenario",
      "rolloutNote": "Each scenario needs its own Meta template category approval on your WhatsApp account before sending."
    },
    "scenario": {
      "abandoned_cart": "Abandoned cart",
      "win_back": "Win-back",
      "browse_abandonment": "Browse abandonment",
      "post_purchase_upsell_timing": "Post-purchase upsell",
      "seasonal_reengagement": "Seasonal re-engagement"
    },
    "report": {
      "title": "AI outbound campaign report",
      "drafted": "Drafted",
      "sent": "Sent",
      "delivered": "Delivered",
      "replied": "Replied",
      "quoteApproved": "Quote approved",
      "paid": "Paid",
      "cost": "Cost",
      "revenue": "Revenue",
      "roi": "ROI",
      "roiNone": "Not available (no cost yet)"
    },
    "queue": {
      "title": "AI outbound drafts",
      "empty": "No AI outbound drafts waiting for review.",
      "approve": "Approve and send",
      "decline": "Decline",
      "edit": "Edit draft",
      "stopped": "AI outbound is halted by Emergency Stop."
    },
    "stop": {
      "title": "Emergency Stop",
      "description": "Instantly halts all AI outbound sends, including any batch in progress.",
      "activate": "Stop all AI outbound",
      "release": "Resume AI outbound",
      "active": "Emergency Stop is active.",
      "confirmTitle": "Stop all AI outbound now?",
      "confirmBody": "No further AI outbound messages will be sent until the Owner resumes them.",
      "confirm": "Yes, stop everything",
      "cancel": "Cancel"
    },
    "roiReport": {
      "title": "Outbound ROI by scenario",
      "scenario": "Scenario",
      "sent": "Sent",
      "delivered": "Delivered",
      "replied": "Replied",
      "quoteApproved": "Quote approved",
      "paid": "Paid",
      "cost": "Cost",
      "revenue": "Revenue",
      "roi": "ROI",
      "conversion": "Conversion",
      "totals": "Total",
      "sortBy": "Sort by",
      "sortRoi": "ROI",
      "sortConversion": "Conversion rate",
      "sortVolume": "Volume",
      "roiNone": "—",
      "empty": "No outbound sends in this period."
    }
  },
  "docTemplates": {
    "b29b": {
      "var": {
        "customer_name": "Customer name",
        "name": "Name",
        "email": "Customer email",
        "customer_email": "Customer email",
        "phone": "Customer phone",
        "customer_phone": "Customer phone",
        "total": "Total",
        "quote_total": "Quote total",
        "quote_number": "Quote number",
        "cart_total": "Cart total",
        "date": "Date",
        "booking_date": "Booking date",
        "booking_service": "Booking service"
      }
    },
    "nav": "Doc templates",
    "title": "Doc templates",
    "subtitle": "Use a Google Doc containing double-brace placeholders as a template. Each placeholder must be mapped to a data source before the template can generate a PDF for a customer.",
    "docLabel": "Google Doc link or ID",
    "add": "Add template",
    "create": "Create new template",
    "newTitle": "Wato template",
    "sampleText": "Write the template text here, with variables in double braces like:",
    "createHint": "Wato creates the Doc in your Google account and opens it. Edit the text, then press Refresh.",
    "open": "Open in Google",
    "refresh": "Refresh",
    "empty": "No doc templates yet.",
    "ready": "Ready to use",
    "unmapped": "{n} placeholders need mapping",
    "noPlaceholders": "No placeholders found in this document.",
    "sourceType": "Data source",
    "sourceField": "Field",
    "confirm": "Confirm",
    "mapped": "Mapped",
    "suggested": "Suggested — confirm to use",
    "needsMapping": "Needs mapping",
    "error": "Something went wrong. Check the Google connection and try again.",
    "source": {
      "contact": "Contact",
      "cart": "Cart",
      "quote": "Quote",
      "booking": "Booking",
      "custom_field": "Custom field"
    }
  },
  "capiConfig": {
    "heading": "Conversions API (CAPI)",
    "description": "Send conversion events from WhatsApp conversations back to Meta so your ads can optimise for real results.",
    "connectFirst": "Connect your ad account first to enable event forwarding.",
    "connectButton": "Connect Meta ad account",
    "connected": "Connected: {account}",
    "disconnect": "Disconnect",
    "colEvent": "Platform event",
    "colCapi": "Meta event",
    "colEnabled": "Enabled",
    "saved": "Mappings saved",
    "quality": {
      "heading": "Event match quality",
      "score": "Score: {score} / 10",
      "refreshedAt": "Refreshed at {time}",
      "never": "Not measured yet",
      "refresh": "Refresh now"
    },
    "delivery": {
      "header": "CAPI delivery",
      "delivered": "CAPI delivered",
      "failed": "CAPI failed",
      "retrying": "CAPI retrying",
      "failedHint": "Meta response code: {code}",
      "noCode": "No response from Meta"
    },
    "events": {
      "firstReply": "First reply to an ad click",
      "orderPaid": "Order paid",
      "cartItemAdded": "Item added to cart",
      "cartSent": "Cart sent to customer",
      "bookingConfirmed": "Booking confirmed"
    }
  },
  "settingsReadiness": {
    "b29b": {
      "title": "Your setup is {percent} ready",
      "dismiss": "Hide",
      "items": {
        "logo": "Add logo",
        "hours": "Set working hours",
        "channel": "Connect official number",
        "google": "Connect Google",
        "team": "Invite your team"
      }
    }
  },
  "settingsHub": {
    "b29b30": {
      "history": "Last change"
    },
    "title": "Settings",
    "subtitle": "Choose the section you want to change.",
    "navLabel": "Settings sections",
    "back": "All settings",
    "pickHint": "Pick a section from the list to see its settings.",
    "b29b": {
      "docs": {
        "nav": "Document look",
        "title": "Document look",
        "hint": "The logo, colours and footer appear on quotes, invoices and customer links.",
        "logo": "Logo",
        "colors": "Colours",
        "primary": "Main colour",
        "secondary": "Second colour",
        "resetColor": "Default",
        "footer": "Footer",
        "address": "Address",
        "crNumber": "Commercial registration",
        "vatNumber": "VAT number",
        "contact": "Contact",
        "terms": "Default quote terms",
        "saved": "Saved",
        "previewPdf": "PDF",
        "previewLink": "Link page"
      },
      "groups": {
        "business": "Business",
        "team": "Team",
        "ai": "AI",
        "integrations": "Connections",
        "billing": "Billing",
        "security": "Security and log"
      },
      "groupDesc": {
        "business": "Business details, hours, modules, branches and alerts.",
        "team": "Members, roles, teams and approvals.",
        "ai": "Features, assistant behaviour and your own AI key.",
        "integrations": "Channels, Google, stores, webhooks and API keys.",
        "billing": "Plan, wallet and invoices.",
        "security": "Sign-in safety, verification codes and the activity log."
      },
      "nav": {
        "hours": "Hours and holidays",
        "modules": "Modules",
        "aiBehavior": "Assistant behaviour",
        "google": "Google",
        "security": "Security",
        "otp": "Verification codes"
      },
      "saveBar": {
        "unsaved": "You have unsaved changes",
        "save": "Save",
        "reset": "Undo"
      },
      "google": {
        "tabsLabel": "Google sections",
        "tabs": {
          "connect": "Connect",
          "sheets": "Google Sheets",
          "docs": "Documents"
        }
      },
      "security": {
        "title": "Security"
      },
      "aiBehavior": {
        "title": "Assistant behaviour"
      }
    },
    "groups": {
      "account": "My account",
      "team": "Team",
      "channels": "Channels",
      "ai": "AI and keys",
      "billing": "Billing",
      "integrations": "Integrations",
      "advanced": "Advanced"
    },
    "groupDesc": {
      "account": "Your profile and business details.",
      "team": "Members, roles, teams and approvals.",
      "channels": "WhatsApp, Instagram and other connections.",
      "ai": "Your own AI keys and API access.",
      "billing": "Plan, wallet and invoices.",
      "integrations": "Google Sheets, credentials, templates and links to other systems.",
      "advanced": "Branches, labels, fields, commerce and audit log."
    },
    "general": "Business details",
    "quotes": "Quotes",
    "search": "Search settings",
    "searchEmpty": "No settings match your search."
  },
  "store": {
    "nav": "Store",
    "title": "Store",
    "b29b": {
      "help": "Orders, products, carts, payments and price quotes in one place. Connect your store or add products by hand, then follow each order until it is paid and delivered.",
      "newOrder": "Order",
      "tabsLabel": "Store sections",
      "tabs": {
        "orders": "Orders",
        "products": "Products",
        "carts": "Carts",
        "payments": "Payments",
        "quotes": "Quotes",
        "settings": "Settings"
      },
      "payments": {
        "all": "All",
        "approvals": "Waiting for you ({count})",
        "reconciliation": "Payment check",
        "queue": "Bank transfers"
      },
      "quotes": {
        "settings": "Quote settings"
      },
      "settings": {
        "connections": "Store connection",
        "catalog": "WhatsApp catalog",
        "messages": "Order messages"
      },
      "products": {
        "help": "Products you add by hand are listed here and can be sent in chats. Sending products and carts inside chats needs the official WhatsApp channel and a linked catalog. Products from your connected store appear here too and are read-only.",
        "add": "Product",
        "newTitle": "New product",
        "editTitle": "Edit product",
        "fields": {
          "name": "Name",
          "price": "Price ({currency})",
          "category": "Category",
          "description": "Description (optional)",
          "stock": "Stock (optional)",
          "stockHint": "Leave empty if you do not count stock.",
          "imageUrl": "Image link",
          "imageUpload": "Drop an image or click to upload",
          "imageOrLink": "or paste a link",
          "imageUploading": "Uploading…",
          "imageRemove": "Remove image",
          "available": "Available"
        },
        "save": "Save",
        "saved": "Product saved",
        "deleted": "Product deleted",
        "copied": "Product copied",
        "refreshed": "Meta status updated",
        "menu": "Product actions",
        "menuDelete": "Delete",
        "menuCopy": "Copy",
        "menuRefresh": "Update Meta status",
        "deleteTitle": "Delete this product?",
        "deleteBody": "“{name}” will be removed from your products and the WhatsApp catalog.",
        "copySuffix": " (copy)",
        "stockLeft": "{count, plural, one {# left} other {# left}}",
        "soldOut": "Sold out",
        "badge": {
          "approved": "Meta ✓",
          "pending": "In review",
          "rejected": "Rejected",
          "store": "From your connected store"
        },
        "errors": {
          "nameRequired": "Enter the product name.",
          "priceRequired": "Enter the price.",
          "priceInvalid": "Enter a valid price.",
          "stockInvalid": "Enter a whole number.",
          "imageInvalid": "The link must start with https://",
          "imageType": "Image must be PNG, JPG or WebP, up to 5 MB.",
          "imageUploadFailed": "Could not upload the image."
        },
        "strip": {
          "linked": "Linked to your WhatsApp catalog",
          "refresh": "Refresh"
        }
      }
    },
    "tabs": {
      "products": "Products"
    },
    "products": {
      "addProductNeedsManual": "To add products by hand, open the catalog settings and choose “Manual products” as the product source.",
      "addProductNeedsCatalog": "Connect a WhatsApp catalog first, then choose “Manual products” as its source. After that you can add and edit products here.",
      "addProductConnect": "Connect a catalog",
      "addProductSettings": "Open catalog settings",
      "search": "Search products",
      "empty": "No products yet. Connect a store or import a CSV first.",
      "emptyCta": "Connect a store"
    },
    "orders": {
      "title": "Orders"
    }
  },
  "aiSetup": {
    "title": "AI setup",
    "intro": "Five steps from zero to an AI Agent answering your customers from your own content.",
    "fakeNote": "Without an AI provider key, replies are simulated (fake mode) — add your key in step 1 for real answers.",
    "step": "Step {n}",
    "done": "Done",
    "ragLink": "How the assistant answers from your info",
    "steps": {
      "provider": {
        "title": "Choose provider / bring your key",
        "body": "Add your own AI provider key or use Wato's.",
        "action": "Manage AI keys"
      },
      "knowledge": {
        "title": "Build your knowledge base",
        "body": "Upload PDF/DOCX files or add text, FAQ or a URL. Wait until sources show Ready.",
        "action": "Open knowledge base"
      },
      "agent": {
        "title": "Create the agent",
        "body": "Set its scope, tone and the handoff keywords for a human.",
        "action": "Open AI agents"
      },
      "test": {
        "title": "Test in the console",
        "body": "Chat in the practice area and run tricky questions to test the assistant. Nothing is sent or charged.",
        "action": "Open test console"
      },
      "channel": {
        "title": "Attach to a channel",
        "body": "Publish the agent and enable it on a WhatsApp channel.",
        "action": "Open channels"
      }
    }
  },
  "automationHub": {
    "nav": "Automation",
    "title": "Automation",
    "loading": "Loading…",
    "intro": "Automations answer customers or follow up for you. Each one has a trigger (\"when\") and an action (\"then\"). Start from a template, review the message, then publish and switch it on.",
    "help": "How automations work",
    "whenLabel": "When",
    "thenLabel": "then",
    "draft": "Not published yet",
    "enable": "Turn on",
    "disable": "Turn off",
    "stats": "Last 7 days: {runs} runs, {failed} failed",
    "when": {
      "customer_silent": "the customer has been silent for {minutes} min",
      "agent_no_reply": "nobody replied to the customer for {minutes} min",
      "keyword": "a customer sends a keyword",
      "welcome": "a customer writes for the first time",
      "no_match": "no other automation matches the message",
      "incoming_webhook": "your system sends an alert to the connection link",
      "other": "the trigger fires"
    },
    "event": {
      "commerce_order_created": "an order is created",
      "commerce_order_paid": "an order is paid",
      "commerce_order_shipped": "an order is shipped",
      "commerce_order_delivered": "an order is delivered",
      "commerce_order_cancelled": "an order is cancelled",
      "commerce_cart_abandoned": "a cart is abandoned",
      "commerce_stock_back_in_stock": "a product is back in stock",
      "payment_paid": "a payment succeeds",
      "payment_failed": "a payment fails",
      "booking_created": "a booking is created",
      "booking_cancelled": "a booking is cancelled",
      "contact_created": "a new contact is created",
      "contact_label_added": "a label is added to a contact",
      "contact_label_removed": "a label is removed from a contact",
      "contact_field_changed": "a contact field changes"
    },
    "then": {
      "runFlow": "run the flow \"{name}\""
    },
    "family": {
      "flow": {
        "title": "Chat flows",
        "desc": "Multi-step conversations you design on the canvas."
      },
      "keyword_reply": {
        "title": "Keyword & welcome replies",
        "desc": "Automatic answers to keywords, first messages and unmatched messages."
      },
      "event": {
        "title": "Event automations",
        "desc": "Start a flow when something happens: payment, booking, contact changes."
      },
      "inactivity": {
        "title": "Follow-ups (inactivity)",
        "desc": "Nudge customers who went quiet, or alert when nobody replied."
      },
      "order_lifecycle": {
        "title": "Order automations",
        "desc": "Messages that follow an order or cart through its lifecycle."
      }
    },
    "templates": {
      "title": "Start from a template",
      "use": "Use template",
      "created": "Automation added from the template. You can review and edit it here.",
      "welcome": {
        "title": "Welcome message",
        "desc": "Greet customers the first time they write."
      },
      "abandoned_cart": {
        "title": "Abandoned cart",
        "desc": "Remind customers who left items in the cart."
      },
      "order_shipped": {
        "title": "Order shipped",
        "desc": "Tell customers their order is on its way."
      },
      "booking_created": {
        "title": "Booking confirmed",
        "desc": "Confirm a booking as soon as it is created."
      },
      "payment_failed": {
        "title": "Payment failed",
        "desc": "Help customers whose payment did not go through."
      },
      "silent_followup": {
        "title": "Silent customer follow-up",
        "desc": "Follow up after 24 hours without a reply."
      }
    },
    "runs": {
      "toggle": "Run history",
      "empty": "No runs yet.",
      "status": {
        "running": "Running",
        "waiting": "Waiting",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Cancelled"
      }
    }
  },
  "blocked": {
    "b29b": {
      "moduleOff": {
        "title": "{module} is turned off",
        "cta": "🔌 Turn it on",
        "ask": "Ask the owner to turn it on.",
        "hidden": "This feature isn't available for your workspace."
      }
    },
    "noAccess": {
      "title": "You don't have access to this page",
      "cta": "See who can grant access",
      "page": "You do not have permission to view this page",
      "moduleOff": "This feature is turned off for this workspace. An owner can turn it on in Settings → Modules."
    },
    "connectCloud": "Connect WhatsApp Cloud",
    "templates": {
      "title": "Templates need a WhatsApp Cloud number"
    },
    "nextAudience": "Choose an audience name and a send-from number to continue.",
    "nextMessage": "Write the message or pick a template to continue.",
    "broadcasts": {
      "title": "Broadcasts need a connected number",
      "reason": "Connect a WhatsApp Cloud number to choose where broadcasts are sent from. Until then you can only preview this page."
    }
  },
  "orders": {
    "nav": "Orders",
    "title": "Orders",
    "tabs": {
      "orders": "Orders",
      "manual": "Bank transfers"
    },
    "status": {
      "new": "New",
      "confirmed": "Confirmed",
      "paid": "Paid",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "refunded": "Refunded",
      "partially_refunded": "Partially refunded"
    },
    "paymentMethod": {
      "prepaid": "💳 Pay before delivery",
      "cod": "💵 Cash on delivery"
    },
    "codConfirmation": {
      "label": "Cash-on-delivery confirmation",
      "pending": "Awaiting confirmation",
      "reminded": "Reminder sent",
      "confirmed": "Confirmed",
      "cancelled": "Cancelled"
    },
    "col": {
      "order": "Order",
      "amount": "Amount",
      "status": "Status",
      "payment": "Payment",
      "ordered": "Ordered"
    },
    "filter": {
      "status": "Status",
      "all": "All",
      "search": "Search by order or customer ID",
      "fromForm": "From order form only"
    },
    "view": {
      "table": "Table view",
      "kanban": "Board view"
    },
    "export": "Export CSV",
    "empty": "No orders yet.",
    "kanban": {
      "moveTo": "To {status}"
    },
    "new": {
      "cta": "New order",
      "contact": "Customer",
      "itemName": "Item",
      "qty": "Quantity",
      "unitPrice": "Unit price",
      "source": "Create from",
      "sourceManual": "Manual entry",
      "sourceCart": "{name} · {total}",
      "contactSearch": "Search by name or phone",
      "contactSearching": "Searching…",
      "contactSearchError": "Search failed. Type again to retry.",
      "contactNone": "No matching customers."
    },
    "page": {
      "title": "Order",
      "subtitle": "Placed {date}",
      "back": "Back to orders",
      "timeline": "Order status",
      "notifyHint": "The customer is notified on WhatsApp when the status changes.",
      "lineTotal": "Line total",
      "net": "Subtotal (before VAT)",
      "vat": "VAT included",
      "messages": "Messages sent to the customer",
      "paymentLink": "Payment link",
      "shipping": "Shipping address",
      "shippingNone": "No shipping address yet.",
      "shippingEdit": "Edit address",
      "shippingSave": "Save address",
      "shippingSaved": "Shipping address saved.",
      "shipName": "Recipient name",
      "shipPhone": "Phone",
      "shipLine1": "Address line 1",
      "shipLine2": "Address line 2 (optional)",
      "shipCity": "City",
      "shipRegion": "Region (optional)",
      "shipPostal": "Postal code (optional)",
      "shipCountry": "Country code (SA, BH)",
      "receipt": "Bank transfer receipt",
      "receiptNone": "No bank-transfer receipt for this order.",
      "remind": "Nudge",
      "reminderSent": "Payment reminder sent.",
      "reminderSentAt": "Reminder sent {date}",
      "reminderNotUnpaid": "This order is not awaiting payment.",
      "refundsHint": "Refunds are requested here and approved by a permitted person; the order moves to Refunded only after approval.",
      "customerNotes": "Customer notes"
    },
    "drawer": {
      "title": "Order",
      "close": "Close",
      "buyer": "Open customer",
      "items": "Items",
      "outOfStock": "out of stock",
      "payment": "Payment",
      "noManualPayment": "No bank-transfer payment"
    },
    "manual": {
      "empty": "No receipts waiting for review.",
      "status": {
        "awaiting_receipt": "Awaiting receipt",
        "awaiting_verification": "Receipt awaiting review",
        "paid": "Paid",
        "rejected": "Rejected",
        "cancelled": "Cancelled"
      }
    },
    "source": {
      "form": "From form"
    },
    "b29b": {
      "noChannel": "No official WhatsApp number is connected; the order will be created without sending.",
      "chat": "Chat",
      "more": "More",
      "recordPayment": "Record payment",
      "paymentRecorded": "Payment recorded. It now waits for a receipt and approval.",
      "unpaid": "Unpaid",
      "paid": "Paid",
      "noPayments": "No payments yet.",
      "stepNext": "Move order to {status}",
      "statusChanged": "Status is now {status}.",
      "channels": {
        "cart": "From WhatsApp cart"
      }
    }
  },
  "credentialVault": {
    "nav": "Credentials",
    "title": "Credentials & integrations",
    "subtitle": "Every stored key and connection, and what uses it. Secrets are never shown.",
    "forbidden": "You don't have permission to view integrations.",
    "vault": {
      "title": "Credential vault",
      "empty": "No credentials stored yet.",
      "usedBy": "Used by",
      "unused": "Not used by anything",
      "lastUsed": "Last used {date}",
      "never": "Never used",
      "delete": "Revoke",
      "forceConfirm": "This credential is still used by: {consumers}. Revoke it anyway?",
      "deleted": "Credential revoked.",
      "managedElsewhere": "Managed in its own integration"
    },
    "email": {
      "title": "Notification email provider",
      "hint": "Notification emails are sent through this provider. Without a selection the platform default is used.",
      "provider": "Provider",
      "from": "From address",
      "domain": "Mailgun domain",
      "region": "Region",
      "secret": "API key / credential",
      "secretHint": "SMTP: URL (smtps://user:pass@host:465). Mailgun: API key. Postmark: server token. SES: accessKeyId:secretAccessKey.",
      "secretKept": "Leave empty to keep the stored credential.",
      "save": "Save provider",
      "saved": "Email provider saved.",
      "testTo": "Send test email to",
      "sendTest": "Send test",
      "testSent": "Test email sent.",
      "providers": {
        "smtp": "SMTP (generic)",
        "mailgun": "Mailgun",
        "ses": "Amazon SES",
        "postmark": "Postmark"
      }
    },
    "google": {
      "title": "Google Contacts sync",
      "hint": "Push new and updated contacts to your Google Contacts. One-way: nothing is read back. Off by default.",
      "connect": "Connect Google",
      "status": "Connection: {status}",
      "enabled": "Sync contacts to Google Contacts",
      "toggleFailed": "Connect Google Contacts first.",
      "connected": "Google Contacts connected.",
      "denied": "Google connection was cancelled or failed."
    },
    "autoresponder": {
      "title": "Autoresponder & email-marketing sync",
      "hint": "Push contacts and their labels as list members and tags. One-way: nothing is pulled back.",
      "provider": "Tool",
      "apiKey": "API key",
      "listId": "List / audience ID",
      "tagPrefix": "Tag prefix (optional)",
      "connect": "Connect",
      "connected": "Autoresponder connected.",
      "disconnect": "Disconnect",
      "empty": "No tools connected.",
      "list": "List {listId}",
      "providers": {
        "mailchimp": "Mailchimp",
        "brevo": "Brevo",
        "activecampaign": "ActiveCampaign"
      }
    }
  },
  "adsManager": {
    "campaignList": {
      "heading": "Ad campaigns",
      "empty": "No campaigns yet.",
      "colName": "Campaign",
      "colStatus": "Status",
      "colSpend": "Spend",
      "colReach": "Reach",
      "colClicks": "Clicks",
      "colActions": "Actions",
      "pause": "Pause",
      "lastSynced": "Last synced {at}",
      "neverSynced": "Not synced yet",
      "status": {
        "draft": "Draft",
        "active": "Active",
        "paused": "Paused",
        "ended": "Ended"
      },
      "activate": "Activate (starts spending)"
    },
    "roiReport": {
      "heading": "Campaign ROI: {name}",
      "stepSent": "Events sent",
      "stepDelivered": "Delivered to Meta",
      "stepConversations": "Conversations",
      "stepConversions": "Conversions",
      "stepRevenue": "Revenue",
      "spend": "Ad spend",
      "revenue": "Attributed revenue",
      "roas": "Return on ad spend",
      "roasNone": "No spend yet",
      "costPerConversation": "Cost per conversation",
      "note": "Revenue comes from the same CTWA attribution as your Analytics dashboard."
    },
    "guardrails": {
      "heading": "Ad spend guardrails",
      "explain": "Wato pauses ads automatically to protect your budget. If total spend in a day passes the daily cap, or a campaign spends faster than its plan by more than the overrun percentage, it is paused on Meta and the workspace owner is notified.",
      "maxDaily": "Maximum daily ad spend ({currency})",
      "overrun": "Pause when pace exceeds plan by (%)",
      "overrunHelp": "150 means pause at 1.5 times the planned daily spend.",
      "save": "Save guardrails",
      "saved": "Guardrails saved."
    },
    "accounts": {
      "heading": "Meta ad account",
      "empty": "No ad accounts found for your Meta login.",
      "select": "Use",
      "selected": "Selected"
    },
    "adSets": {
      "heading": "Ad sets",
      "empty": "No ad sets yet.",
      "colName": "Ad set",
      "colCampaign": "Campaign",
      "colStatus": "Status",
      "colBudget": "Daily budget",
      "colSpend": "Campaign spend",
      "colAudience": "Audience"
    },
    "create": {
      "heading": "New Click-to-WhatsApp campaign",
      "pausedNote": "The campaign is created paused. Nothing is spent until you press Activate.",
      "name": "Campaign name",
      "number": "WhatsApp number (digits only)",
      "flow": "Flow that answers the ad click",
      "channel": "WhatsApp channel",
      "totalBudget": "Total budget (minor units)",
      "dailyBudget": "Daily budget (minor units)",
      "currency": "Currency",
      "startDate": "Start date",
      "endDate": "End date",
      "countries": "Countries",
      "sa": "Saudi Arabia",
      "bh": "Bahrain",
      "ageMin": "Minimum age",
      "ageMax": "Maximum age",
      "genders": "Gender",
      "male": "Men",
      "female": "Women",
      "image": "Image URL",
      "primaryText": "Primary text",
      "headline": "Headline",
      "welcome": "Welcome message",
      "iceBreakers": "Ice breakers (one per line, up to 4)",
      "submit": "Create campaign",
      "errorRequired": "Fill in all required fields."
    }
  },
  "featureIntro": {
    "mark": "?",
    "hide": "Hide explanation",
    "show": "How does it work?",
    "whatLabel": "What is it?",
    "whenLabel": "When to use it",
    "stepsLabel": "Steps",
    "learnMore": "Learn more"
  },
  "chatPreview": {
    "badge": "Illustrative example",
    "conversation": "Example conversation",
    "customer": "Customer",
    "outsideToggle": "Preview outside the 24-hour window",
    "outsideNotice": "Outside the 24-hour window free text cannot be sent. Only an approved template reaches the customer, and none is chosen here."
  },
  "adminShell": {
    "nav": {
      "label": "Admin sections",
      "open": "Open menu",
      "close": "Close menu"
    },
    "user": {
      "loading": "Loading account…",
      "unavailable": "Account unavailable",
      "signOut": "Sign out",
      "signingOut": "Signing out…"
    },
    "state": {
      "loading": "Loading…",
      "error": "This section failed to load.",
      "retry": "Try again",
      "unavailable": "This section is not connected to its API in this build."
    },
    "notFound": {
      "title": "Page not found",
      "explainer": "This admin page does not exist.",
      "back": "Back to the dashboard"
    },
    "section": {
      "tenants": {
        "title": "Tenants",
        "explainer": "Browse, suspend, reinstate or terminate customer workspaces."
      },
      "install-sources": {
        "title": "Install sources",
        "explainer": "See where each workspace installed from, such as Salla or direct signup."
      },
      "migrations": {
        "title": "Migration history",
        "explainer": "Review data migrations that ran for each tenant."
      },
      "meta-rates": {
        "title": "Meta rates",
        "explainer": "Maintain the per-category WhatsApp conversation rates."
      },
      "reconciliation": {
        "title": "Reconciliation",
        "explainer": "Compare billed amounts with Meta charges and spot gaps."
      },
      "services": {
        "title": "Services",
        "explainer": "Track professional-service requests and their revenue."
      },
      "support": {
        "title": "Support inbox",
        "explainer": "Answer and escalate tickets from workspace owners."
      },
      "changelog": {
        "title": "Changelog",
        "explainer": "Write the release notes customers see in the app."
      },
      "review-queue": {
        "title": "Review queue",
        "explainer": "Approve or reject marketplace listings."
      },
      "marketplace-settings": {
        "title": "Marketplace settings",
        "explainer": "Configure marketplace commission and rules."
      },
      "listing-performance": {
        "title": "Listing performance",
        "explainer": "See which listings get views and installs."
      },
      "feature-flags": {
        "title": "Feature flags",
        "explainer": "Turn platform features on or off."
      },
      "ai-monitoring": {
        "title": "AI monitoring",
        "explainer": "Watch AI usage metrics and engine latency."
      },
      "compliance": {
        "title": "Compliance",
        "explainer": "Log breach incidents and track the regulator notification window."
      },
      "pricing": {
        "title": "Pricing & plans",
        "explainer": "Create and edit plans and prices, give one customer a special price, and review every change."
      },
      "staff": {
        "title": "Platform staff",
        "explainer": "Who works on the platform, with which role. Invite, change or deactivate staff."
      },
      "member-roles": {
        "title": "Tenant member roles",
        "explainer": "Review and change the roles of a workspace's members as an audited support action."
      },
      "users": {
        "title": "Users",
        "explainer": "Find a user by name, phone or email, then reset, sign out or disable them."
      },
      "revenue": {
        "title": "Revenue",
        "explainer": "See monthly income, plan mix and customer churn."
      },
      "cost-monitor": {
        "title": "Cost monitor",
        "explainer": "Watch what messages and AI cost us against what we earn."
      },
      "queues": {
        "title": "Queues",
        "explainer": "Check background jobs and retry or discard the ones that failed."
      },
      "channels": {
        "title": "Channels & QR sessions",
        "explainer": "Health of every connected number, and WhatsApp QR sessions, in one place."
      },
      "maintenance": {
        "title": "Maintenance",
        "explainer": "Show a maintenance message to everyone or to one workspace."
      },
      "audit-explorer": {
        "title": "Audit log",
        "explainer": "Search who did what and when across the platform."
      },
      "blocklists": {
        "title": "Blocklists",
        "explainer": "Block phone numbers or domains on every workspace."
      },
      "announcements": {
        "title": "Announcements",
        "explainer": "Write a banner message and choose who sees it."
      },
      "vertical-templates": {
        "title": "Industry templates",
        "explainer": "See which industries customers ask for most and have no template yet."
      },
      "settings": {
        "title": "Settings",
        "explainer": "Every configurable setting in one list: platform-wide and per workspace, with who may change it."
      },
      "template-review": {
        "title": "Template review",
        "explainer": "Templates waiting at Meta or flagged for review. Reject, take down or send back to draft. Meta stays the approver."
      },
      "system-log": {
        "title": "System log",
        "explainer": "Read warnings and errors from all services. Filter, search and follow live."
      },
      "system-activity": {
        "title": "System activity",
        "explainer": "See how each kind of background work is doing, what failed last and who is affected."
      },
      "monitoring-reports": {
        "title": "Monitoring reports",
        "explainer": "Read the automatic health checks: what they found, the likely cause and what to do."
      },
      "command": {
        "title": "Command dashboard",
        "explainer": "One screen for platform health, today's numbers and what needs your attention."
      },
      "scans": {
        "title": "Periodic scan",
        "explainer": "Full system checks that run on a schedule and report what is wrong."
      },
      "assistant": {
        "title": "AI assistant",
        "explainer": "Chat with an assistant that sees the whole platform and proposes actions for you to approve."
      }
    },
    "brand": {
      "name": "Wato · Admin console",
      "mark": "W"
    },
    "b29b": {
      "group": {
        "home": "Home",
        "customers": "Customers",
        "support": "Support",
        "health": "Health",
        "money": "Money",
        "safety": "Safety & review",
        "platform": "Platform"
      },
      "assistant": "Ask the assistant",
      "channels": {
        "label": "Channel type",
        "official": "Channels",
        "qr": "QR sessions"
      },
      "theme": {
        "toDark": "Dark mode",
        "toLight": "Light mode"
      },
      "notifications": {
        "label": "Notifications",
        "empty": "No new notifications",
        "support": "{count, plural, one {# open support ticket} other {# open support tickets}}",
        "safety": "{count, plural, one {# template waiting for review} other {# templates waiting for review}}"
      },
      "account": {
        "label": "Account"
      },
      "home": {
        "greeting": "Welcome back",
        "live": "Live · {count}s ago",
        "paused": "Paused",
        "fix": "Fix it",
        "severity": {
          "critical": "Critical",
          "warning": "Warning",
          "info": "Info"
        },
        "trafficTip": "{official} official · {qr} QR"
      },
      "activity": {
        "sendFailed": "A message failed to send for good",
        "pricingPull": "Could not pull the prices of a number",
        "imageDescription": "Could not describe an incoming image",
        "avatar": "Could not fetch a customer photo",
        "backupDone": "Backup finished",
        "technical": "Technical event"
      }
    }
  },
  "adminPricing": {
    "nav": {
      "plans": "Plans",
      "override": "Per-workspace override",
      "log": "Change log"
    },
    "loading": "Loading…",
    "forbidden": "Only platform admins can manage pricing.",
    "error": "Something went wrong. Nothing was changed.",
    "plans": {
      "explainer": "Here you create and edit the packages we sell. Each package has a price in Saudi riyal and Bahraini dinar, the features it includes and its limits. You always see a before-and-after check before anything is saved.",
      "new": "New plan",
      "edit": "Edit",
      "archive": "Archive",
      "restore": "Restore",
      "archived": "Archived",
      "none": "No plans yet.",
      "tier": "Plan key (letters, digits, _)",
      "name": "Plan name",
      "priceSar": "Price in SAR (per month)",
      "priceBhd": "Price in BHD (per month)",
      "features": "Included features (comma separated)",
      "limits": "Limits (one per line: key=max, blank max = unlimited)",
      "hard": "Block at the limit (hard)",
      "review": "Review changes",
      "cancel": "Cancel",
      "reason": "Reason",
      "limitsHeading": "Limits",
      "featuresHeading": "Features",
      "priceInvalid": "Enter a valid amount: SAR up to 2 decimals, BHD up to 3 decimals.",
      "limitsInvalid": "Each limit line must look like key=number."
    },
    "confirm": {
      "heading": "Please confirm",
      "explainer": "Check the before and after below. Nothing is saved until you press Confirm.",
      "before": "Before",
      "after": "After",
      "new": "(new)",
      "unlimited": "unlimited",
      "confirm": "Confirm and save",
      "back": "Back",
      "saved": "Saved and added to the change log.",
      "nochange": "No changes."
    },
    "fields": {
      "name": "Name",
      "priceSar": "Price SAR",
      "priceBhd": "Price BHD",
      "features": "Features",
      "limits": "Limits",
      "archived": "Archived",
      "priceOverride": "Override price",
      "limitOverride": "Override limits",
      "reason": "Reason"
    },
    "override": {
      "explainer": "Give one customer a special price or special limits without changing the package for everyone. A reason is required and is kept in the change log.",
      "workspaceId": "Workspace ID",
      "load": "Load current override",
      "currency": "Currency",
      "price": "Override price (major units)",
      "limitsInput": "Override limits (key=max per line)",
      "reason": "Reason (required)",
      "current": "Current override",
      "noneSet": "No override set for this workspace.",
      "review": "Review override",
      "notFound": "Workspace not found.",
      "reasonRequired": "Enter a reason of at least 3 characters.",
      "nothing": "Enter a price or at least one limit."
    },
    "log": {
      "explainer": "Every change to a plan, a price or a customer override is recorded here and can never be edited or deleted: who did it, when, and the before and after.",
      "empty": "No changes recorded yet.",
      "when": "When",
      "who": "Who",
      "what": "Change",
      "target": "Target",
      "details": "Before → after",
      "actions": {
        "plan.created": "Plan created",
        "plan.updated": "Plan edited",
        "plan.archived": "Plan archived",
        "plan.restored": "Plan restored",
        "plan.override_set": "Workspace override set"
      }
    }
  },
  "adminStaff": {
    "loading": "Loading…",
    "error": "Something went wrong. Try again.",
    "forbidden": "Your role does not allow this.",
    "role": {
      "owner": "Owner",
      "support": "Support",
      "finance": "Finance",
      "read_only": "Read-only"
    },
    "roleHint": {
      "owner": "Full access, including staff and billing.",
      "support": "Helps tenants: sees and acts on workspaces and members. Cannot see billing.",
      "finance": "Sees and manages billing and plans. Cannot take support actions on tenants.",
      "read_only": "Can look, never change anything."
    },
    "perm": {
      "staff.read": "See the staff list",
      "staff.manage": "Invite, change and deactivate staff",
      "tenants.read": "See workspaces",
      "tenants.write": "Act on workspaces (suspend, reinstate)",
      "members.read": "See a workspace's members",
      "members.write": "Change a workspace member's role",
      "billing.read": "See billing and plans",
      "billing.write": "Change billing and plans",
      "audit.read": "Read the audit log",
      "roles": {
        "manage": "Create, edit and delete custom staff roles"
      },
      "users": {
        "write": "Force sign-out, password reset or disable a user"
      },
      "support": {
        "write": "Open support sessions and answer tickets"
      },
      "plans": {
        "write": "Edit plans, prices and add-ons"
      },
      "flags": {
        "write": "Change feature flags and per-workspace overrides"
      },
      "ai": {
        "control": "Control AI: kill switch, BYOK and AI caps"
      },
      "channels": {
        "write": "Force-disconnect channels and release numbers"
      },
      "templates": {
        "review": "Review templates: reject, disable, reinstate"
      },
      "settings": {
        "read": "See platform and workspace settings",
        "write": "Change platform settings"
      },
      "ops": {
        "write": "Operations: queues, maintenance, residency"
      },
      "compliance": {
        "write": "Act on compliance, abuse and blocklists"
      },
      "content": {
        "write": "Publish announcements, changelog and marketplace reviews"
      }
    },
    "matrix": {
      "heading": "What each role can do",
      "permission": "Permission",
      "yes": "Allowed",
      "no": "Not allowed"
    },
    "roster": {
      "heading": "Staff",
      "empty": "No staff yet.",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "active": "Active",
      "inactive": "Deactivated",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "you": "(you)",
      "hidden": "Only owners can see the staff list."
    },
    "invite": {
      "heading": "Invite or change a role",
      "email": "Staff email (must already have an account)",
      "role": "Role",
      "submit": "Save",
      "done": "Saved."
    },
    "members": {
      "heading": "Members of a workspace",
      "workspaceId": "Workspace ID",
      "load": "Show members",
      "empty": "No members.",
      "email": "Member",
      "role": "Role",
      "change": "Change role",
      "save": "Save",
      "saved": "Role changed and recorded in the audit log.",
      "audit": "Every change is recorded with who changed it, the old role and the new role."
    },
    "err": {
      "INVALID_INPUT": "Check the email and role.",
      "FORBIDDEN": "Your role does not allow this.",
      "ESCALATION": "You cannot grant a role above your own.",
      "LAST_OWNER": "This is the only owner. Make someone else an owner first.",
      "USER_NOT_FOUND": "No account exists for this email.",
      "STAFF_NOT_FOUND": "Staff member not found.",
      "MEMBER_NOT_FOUND": "Member not found.",
      "ROLE_NOT_FOUND": "Role not found.",
      "default": "Something went wrong. Try again.",
      "ROLE_IN_USE": "Move every staff member off this role before deleting it."
    },
    "customRoles": {
      "heading": "Custom roles",
      "explainer": "Build a role from exact permissions. You can only grant permissions you hold yourself. Saving or deleting a role asks for your authentication code.",
      "key": "Role key (lowercase letters, digits, _)",
      "name": "Display name",
      "permissions": "Permissions",
      "save": "Save role",
      "edit": "Edit",
      "delete": "Delete",
      "empty": "No custom roles yet.",
      "saved": "Role saved and recorded in the audit log.",
      "deleted": "Role deleted.",
      "ownerLevel": "Owner-level: needs a fresh authentication code"
    }
  },
  "reports": {
    "weekly": {
      "b29b30": {
        "title": "What changed this week?",
        "newCustomers": {
          "up": "New customers are up {pct} on last week.",
          "down": "New customers are down {pct} on last week."
        },
        "orders": {
          "up": "Orders are up {pct} on last week.",
          "down": "Orders are down {pct} on last week."
        },
        "conversations": {
          "up": "Conversations are up {pct} on last week.",
          "down": "Conversations are down {pct} on last week."
        }
      },
      "title": "This week in your business",
      "subtitle": "The last 7 days in plain words, from your real conversations and sales.",
      "loading": "Preparing your summary…",
      "loadError": "Couldn't prepare your summary. Try again in a moment.",
      "conversations": "{count, plural, one {# new conversation} other {# new conversations}} started this week.",
      "trend": {
        "up": "That is more than last week.",
        "down": "That is fewer than last week.",
        "same": "Same as last week."
      },
      "closed": "Your team closed {closed, plural, one {# conversation} other {# conversations}} and {open} are still open.",
      "automation": "Automation handled {count, plural, one {# conversation} other {# conversations}} without your team.",
      "revenue": "Sales recorded this week: {amount}.",
      "csat": "Customers rated you {average} out of 5 ({count} ratings).",
      "empty": {
        "title": "Nothing to report yet",
        "body": "Once customers message your WhatsApp number, your weekly summary appears here.",
        "cta": "Connect a channel"
      }
    }
  },
  "aiHub": {
    "nav": "AI assistant",
    "title": "AI assistant",
    "subtitle": "Everything about your AI assistant in one place.",
    "advanced": "Advanced options",
    "try": {
      "chat": "Test chat"
    },
    "log": {
      "unanswered": "Unanswered questions"
    },
    "sections": {
      "setup": {
        "label": "Setup",
        "description": "Turn the assistant on or off, pick its channels, and write its instructions and business info."
      },
      "try": {
        "label": "Try it",
        "description": "Chat with the assistant as a customer would, and run the quality test before you publish."
      },
      "log": {
        "label": "Log",
        "description": "Review the assistant's replies and fix the questions it could not answer."
      },
      "overview": {
        "label": "Overview",
        "description": "Start here and check how the assistant is doing."
      },
      "agent": {
        "label": "Assistant",
        "description": "Edit the assistant's instructions and publish it."
      },
      "qualityTests": {
        "label": "Quality tests",
        "description": "Try the assistant with ready questions before publishing."
      },
      "runLog": {
        "label": "Assistant reply log",
        "description": "See why the assistant replied or handed over to a person."
      },
      "usage": {
        "label": "Usage",
        "description": "Track what the assistant used from your plan."
      }
    },
    "start": {
      "title": "Start here",
      "progress": "{done} of {total} steps done.",
      "published": "Publish at least one assistant",
      "publishedCta": "Open assistant",
      "information": "Add business information",
      "informationCta": "Add information",
      "channel": "Link the assistant to a WhatsApp number",
      "channelCta": "Open channels",
      "rag": "The assistant reads the business information you added and answers customers only from it. If it cannot find the answer it offers to hand the chat to a person."
    },
    "overview": {
      "running": "The AI assistant is running.",
      "paused": "The AI assistant is paused.",
      "stoppedNoBalance": "Stopped: your AI balance has run out.",
      "pause": "Pause the assistant",
      "resume": "Resume the assistant",
      "wizard": "5-minute quick start"
    },
    "runLog": {
      "empty": "No assistant yet.",
      "pick": "Choose the assistant"
    },
    "usage": {
      "used": "Used: {used} of {limit}",
      "none": "No usage data yet.",
      "billing": "Open billing"
    },
    "addAnswer": {
      "button": "Add this answer to business information",
      "done": "Added",
      "error": "Could not add it"
    },
    "quick": {
      "title": "Assistant setup",
      "intro": "Four simple steps and the assistant is ready to reply to your customers.",
      "progress": "{done} of {total}",
      "step": "Step {n}",
      "done": "Done",
      "ragLink": "How the assistant answers from your information",
      "steps": {
        "channel": {
          "title": "Connect a WhatsApp number",
          "body": "Connect the number your customers message.",
          "action": "Open channels"
        },
        "information": {
          "title": "Add your business information",
          "body": "Add a file or text with prices, hours and common questions.",
          "action": "Add information"
        },
        "test": {
          "title": "Try a question",
          "body": "Ask the assistant a customer question to check its answer. Nothing is sent to anyone.",
          "action": "Open test"
        },
        "publish": {
          "title": "Publish the assistant",
          "body": "When you like the answers, publish it so it starts replying.",
          "action": "Publish assistant"
        }
      }
    },
    "more": "More",
    "runLogShort": "Log",
    "allWorking": "Everything is working",
    "details": "Details",
    "hideDetails": "Hide details",
    "peakHours": "Peak hours",
    "insights": "Handoffs and top questions",
    "hubTidy": {
      "qa": {
        "hint": "Frequent customer questions with their approved answers"
      },
      "guidance": {
        "hint": "Rules the assistant follows in every reply"
      },
      "unanswered": {
        "hint": "Customer questions the assistant could not answer"
      },
      "knowledge": {
        "title": "Sources and files",
        "hint": "Files, links and text the assistant answers from"
      },
      "results": {
        "hint": "Answered rate, handoffs and cost per chat"
      },
      "eval": {
        "options": "More options"
      },
      "channels": {
        "title": "AI channels",
        "hint": "Where the assistant replies, one row per channel"
      },
      "usage": {
        "hint": "Usage by assistant and month"
      }
    },
    "b29": {
      "info": {
        "usedBy": "Used by",
        "scope": {
          "this": "This agent only",
          "all": "All agents"
        },
        "allAgents": "👥 All agents",
        "actions": "Actions",
        "linkOther": "Link to another agent…",
        "unbind": "Unlink from this agent",
        "edit": "Edit",
        "delete": "Delete",
        "save": "Save",
        "add": "Add",
        "intro": "Everything this agent knows: sources, ready answers and guidelines.",
        "loadError": "Could not load the information.",
        "error": "That did not work, please try again.",
        "suggested": "Suggested",
        "approve": "Approve",
        "reject": "Reject",
        "copy": "📋 Copy information from another agent",
        "copyConfirm": "Copy",
        "copyFrom": "Copy from",
        "copyPick": "Choose an agent",
        "linkTitle": "Link to agents",
        "qa": {
          "title": "Ready answers",
          "empty": "No ready answers yet.",
          "add": "Ready answer",
          "question": "Question",
          "answer": "Answer"
        },
        "rules": {
          "title": "Guidelines",
          "empty": "No guidelines yet.",
          "add": "New guideline",
          "text": "Guideline text"
        },
        "sources": {
          "title": "Sources and files",
          "empty": "No sources yet.",
          "add": "Add a source",
          "file": "Upload a file",
          "kindLabel": "Type",
          "kinds": {
            "text": "Text",
            "url": "Link"
          },
          "name": "Name",
          "url": "Link",
          "text": "Text"
        }
      },
      "test": {
        "active": "🟢 Active",
        "draft": "⚪ Draft",
        "editAgent": "✏️ Edit agent"
      }
    }
  },
  "aiInfoHub": {
    "unanswered": {
      "title": "Questions your assistant could not answer",
      "empty": "No unanswered questions. Great!",
      "count": "Asked {count} times",
      "lastSeen": "Last asked {date}",
      "answer": "Add the answer",
      "ignore": "Ignore",
      "answerLabel": "Your answer",
      "save": "Save answer",
      "cancel": "Cancel",
      "saved": "Saved to your business information",
      "forbidden": "You do not have permission to view this",
      "loading": "Loading…",
      "error": "Could not load. Try again.",
      "retry": "Retry"
    },
    "health": {
      "title": "Service status",
      "fix": "Fix",
      "level": {
        "green": "Working",
        "orange": "Needs attention",
        "red": "Problem"
      },
      "alert": "Stopped for more than 2 minutes",
      "whatsapp": {
        "label": "WhatsApp line",
        "ok": "Your WhatsApp line is connected.",
        "partial": "Some of your WhatsApp lines are disconnected.",
        "disconnected": "Your WhatsApp line is disconnected. Reconnect it.",
        "none": "No WhatsApp line is connected yet."
      },
      "ai_provider": {
        "label": "AI service",
        "ok": "The AI service is replying normally.",
        "idle": "The AI service is ready.",
        "recent_error": "The AI service had a problem recently.",
        "failing": "The AI service is not responding right now."
      },
      "balance": {
        "label": "Balance",
        "ok": "Your balance is enough.",
        "low": "Your balance is running low. Top it up.",
        "empty": "Your balance is finished. The assistant has stopped."
      },
      "queue": {
        "label": "Background work",
        "ok": "Everything is running on time.",
        "slow": "Some tasks are delayed.",
        "stuck": "Background tasks are stuck."
      },
      "loading": "Checking…",
      "error": "Could not check the status."
    },
    "usage": {
      "title": "Usage and balance",
      "month": "This month",
      "agent": "Agent",
      "calls": "Calls",
      "tokens": "Tokens",
      "credits": "Credits",
      "noAgent": "Other AI work",
      "task": {
        "copilot_suggested_replies": "Suggested replies",
        "copilot_summarize": "Conversation summaries",
        "copilot_rephrase": "Message rephrasing",
        "copilot_translate": "Message translation",
        "copilot_draft_commerce": "Quote and order drafting",
        "agent_test_console": "Agent test console",
        "inbox_auto_label": "Automatic labelling",
        "inbox_draft_order": "Order drafting",
        "inbox_at_risk": "Sensitive chat detection",
        "inbox_image_ocr": "Receipt image reading",
        "inbox_image_understanding": "Image understanding",
        "kb_embed": "Knowledge base indexing",
        "faq_mining": "FAQ discovery",
        "flow_ai_node": "Flow AI steps",
        "copilot_workspace_builder": "Workspace builder"
      },
      "empty": "No AI usage yet this month.",
      "remaining": "{pct}% of your AI budget is left",
      "noBudget": "No monthly AI budget is set.",
      "lowLabel": "Alert me when this much is left (%)",
      "lowSave": "Save",
      "lowSaved": "Saved",
      "low": "Your AI balance is running low.",
      "exhausted": "Your AI balance is finished. Customers get a polite message and a team member takes over.",
      "loading": "Loading…",
      "error": "Could not load usage.",
      "saveError": "Could not save. Set a monthly budget first.",
      "walletBalance": "Wallet balance: {amount}",
      "topUp": "Top up"
    },
    "results": {
      "title": "This week's results",
      "allAgents": "All agents",
      "agentFilter": "Agent",
      "answered": "Answered by the assistant",
      "handoffs": "Handed to the team",
      "perChat": "Credits per conversation",
      "tokensPerChat": "Tokens per conversation",
      "vsLast": "{delta} points vs last week",
      "same": "Same as last week",
      "noData": "No data yet",
      "noPrevious": "No earlier period to compare",
      "handoffReasons": "Why chats were handed over",
      "topQuestions": "Most repeated questions",
      "times": "{count} times",
      "trend": "Last 14 days",
      "trendAnswered": "Answered",
      "trendHandoffs": "Handed over",
      "none": "Nothing to show yet.",
      "loading": "Loading…",
      "error": "Could not load results.",
      "reason": {
        "customer_requested_human": "Customer asked for a person",
        "no_source": "No answer in your business information",
        "max_turns": "Reached the reply limit",
        "ai_budget_exceeded": "AI balance finished",
        "other": "Other"
      }
    }
  },
  "winBack": {
    "title": "Win back silent customers",
    "enabled": "Send one follow-up after 24h of silence",
    "text": "Follow-up text",
    "textHint": "Use '{topic}' for what the customer asked about. Sent once per conversation, never during quiet hours or to customers who opted out.",
    "mode": "Text source",
    "modeStatic": "My text (no AI cost)",
    "modeAi": "Written by AI from the last topic",
    "template": "Template when the 24h window is closed"
  },
  "customerClass": {
    "filter": "Customer type",
    "all": "All customers",
    "serious_buyer": "Serious buyer",
    "just_asking": "Just asking",
    "complaint": "Complaint",
    "vip": "VIP"
  },
  "ownerReport": {
    "title": "Weekly report to the owner",
    "on": "Sent every week to the owner's WhatsApp number.",
    "off": "Turned off. Turn it on to receive a weekly summary.",
    "note": "Preview of the next report. Sent only within WhatsApp rules (template when the chat window is closed, never during quiet hours).",
    "enable": "Turn on the weekly report",
    "saved": "Saved",
    "loading": "Loading…"
  },
  "peakHours": {
    "title": "Peak hours",
    "hint": "Incoming messages, last {days} days ({timezone}). Darker means busier.",
    "empty": "No messages in the last 30 days.",
    "loading": "Loading…",
    "error": "Could not load peak hours.",
    "cell": "{count} messages at {hour}:00",
    "day": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    }
  },
  "opsOwn": {
    "handover": {
      "button": "Hand over my shift",
      "receiver": "Hand over to",
      "noReceiver": "No specific colleague",
      "reassign": "Also reassign my open conversations to them",
      "send": "Send handover",
      "done": "{open, plural, one {Handover sent for # conversation} other {Handover sent for # conversations}}",
      "failed": "Could not send the handover. Try again.",
      "noteLabel": "Shift handover",
      "waited": "Customer waiting {waited} min",
      "notWaiting": "Waiting on the customer",
      "promise": "Promised: {promise}",
      "slaRisk": "SLA at risk",
      "next": "Next: {next}",
      "action": {
        "fulfil_promise": "keep the promise made to the customer",
        "reply_now": "reply to the customer now",
        "follow_up": "follow up with the customer",
        "monitor": "monitor"
      }
    },
    "transferTimeline": "Transferred to {name}",
    "transferWithSummary": "Include a summary of the conversation",
    "transferStaffOnline": "Online",
    "transferStaffOffline": "Offline",
    "voiceRecord": "Record",
    "voiceStop": "Stop recording",
    "voiceDictate": "Dictate",
    "voiceDictating": "Listening… tap to stop",
    "voiceUnsupported": "Voice recording is not supported in this browser.",
    "voiceDictationUnsupported": "Dictation is not supported here; record an audio note instead.",
    "voiceDenied": "Microphone access was denied.",
    "voiceAudioLabel": "Voice note (internal)",
    "voiceDiscard": "Discard",
    "voiceNoCost": "Voice notes are free: no AI credits are used.",
    "auditTab": "Activity log",
    "auditTitle": "Who changed what",
    "auditUser": "User",
    "auditDate": "Date",
    "auditFrom": "From",
    "auditTo": "To",
    "auditAllUsers": "All users",
    "auditBefore": "Before",
    "auditAfter": "After",
    "auditEmpty": "No changes recorded yet.",
    "auditError": "Could not load the activity log.",
    "auditAction": "Change",
    "auditWhen": "When",
    "actionAgentCreated": "Created an AI agent",
    "actionAgentUpdated": "Edited an AI agent",
    "actionAgentDeleted": "Deleted an AI agent",
    "actionAgentPublished": "Published an AI agent",
    "actionAgentUnpublished": "Paused an AI agent",
    "actionAgentBound": "Linked an AI agent to a number",
    "actionKnowledgeAdded": "Added business information",
    "actionKnowledgeUpdated": "Updated business information",
    "actionKnowledgeDeleted": "Deleted business information",
    "auditLoadMore": "Load more"
  },
  "adminTenant360": {
    "open": "Open 360 view",
    "back": "Back to tenants",
    "loading": "Loading workspace…",
    "notFound": "Workspace not found.",
    "audited": "Every change here is recorded in the audit log with your reason.",
    "plan": {
      "heading": "Plan",
      "none": "No subscription.",
      "summary": "{name} ({plan}) — {status}, renews {when}",
      "priceOverride": "Custom price: {price} {currency} — {reason}"
    },
    "b29b": {
      "tab": {
        "summary": "Summary",
        "channels": "Channels",
        "usage": "Usage",
        "invoices": "Invoices",
        "members": "Members",
        "tickets": "Tickets",
        "errors": "Errors",
        "features": "🧩 Features",
        "settings": "Settings"
      },
      "summary": {
        "owner": "Owner",
        "created": "Created",
        "seats": "Members",
        "mrr": "Monthly revenue"
      },
      "usage": {
        "messages": "Messages this month",
        "aiRuns": "AI replies this month",
        "aiCredits": "AI credits used",
        "wallet": "Wallet balance",
        "notCounted": "Not counted",
        "notCountedHelp": "This limit has no counter yet."
      },
      "invoice": {
        "empty": "No invoices.",
        "open": "Open",
        "paid": "Paid",
        "void": "Void"
      },
      "members": {
        "empty": "No members.",
        "lastSeen": "Last seen"
      },
      "tickets": {
        "empty": "No support tickets."
      },
      "errors": {
        "empty": "No recent errors."
      },
      "label": {
        "limit": {
          "seats": "Seats",
          "contacts": "Customers",
          "channelsConnected": "Connected channels",
          "cloudNumbers": "Official WhatsApp numbers",
          "wahaSessions": "WhatsApp QR numbers",
          "flows": "Automation flows",
          "broadcastsMonthly": "Monthly broadcasts",
          "templates": "Templates",
          "aiCredits": "Included AI credits",
          "kbStorage": "Knowledge base storage (MB)",
          "commerceConnectors": "Store connections",
          "qrHourlyCap": "QR sends per hour cap",
          "custom": "Custom limit"
        },
        "flag": {
          "custom": "Experimental feature"
        },
        "status": {
          "trialing": "Trial",
          "active": "Active",
          "past_due": "Past due",
          "canceled": "Canceled",
          "paused": "Paused",
          "other": "Other status"
        }
      },
      "module": {
        "accounts": "Accounts",
        "travel": "Travel",
        "store": "Store",
        "quotes": "Quotes",
        "tables": "Tables",
        "bookings": "Bookings",
        "products": "Products",
        "services": "Services",
        "documents": "Documents"
      },
      "group": {
        "chats": "Conversations",
        "sales": "Sales",
        "marketing": "Marketing",
        "automation": "Automation & AI",
        "channels": "Channels & integrations",
        "other": "Other"
      },
      "state": {
        "on": "On: the owner cannot turn it off",
        "hidden": "Hidden: gone everywhere",
        "owner": "Owner decides (default)"
      },
      "ownerChoice": "Owner's current choice: {choice}",
      "choice": {
        "on": "on",
        "off": "off"
      },
      "dependency": "Hiding “{feature}” also turns off “{dependents}”.",
      "saved": "Saved",
      "save": "Save changes ({count})",
      "reason": "Reason (shown in the audit log)",
      "preset": {
        "servicesNoBooking": "Services company, no booking",
        "storeNoQuotes": "Store, no quotes",
        "supportOnly": "Support only (chats)"
      },
      "bulk": {
        "title": "Apply features",
        "count": "{count, plural, one {# customer selected} other {# customers selected}}",
        "preset": "Template",
        "apply": "Apply",
        "cancel": "Cancel",
        "close": "Close",
        "summary": "Applied to {done} of {total}",
        "failed": "Could not apply. Try again."
      },
      "trial": {
        "extend": "Extend trial",
        "title": "Extend trial",
        "daysLabel": "Days",
        "reason": "Reason (shown in the audit log)",
        "confirm": "Extend",
        "cancel": "Cancel"
      }
    },
    "limits": {
      "heading": "Limits and quotas",
      "key": "Limit",
      "plan": "Plan",
      "override": "Override",
      "usage": "Used",
      "unlimited": "Unlimited",
      "none": "—",
      "edit": "Change limit",
      "max": "New maximum (empty = unlimited)",
      "blockMode": "When reached",
      "hard": "Block",
      "soft": "Warn only",
      "reason": "Reason (shown in the audit log)",
      "save": "Save override",
      "clear": "Back to plan",
      "saved": "Limit saved."
    },
    "ai": {
      "heading": "AI",
      "budget": "Monthly credit cap: {max}",
      "noBudget": "No monthly credit cap.",
      "byok": "Own provider keys: {count}"
    },
    "channels": {
      "empty": "No channels connected."
    },
    "templates": {
      "heading": "Templates",
      "empty": "No templates."
    },
    "flags": {
      "heading": "Feature-flag overrides",
      "empty": "No overrides: this workspace follows the platform defaults.",
      "key": "Flag key",
      "on": "On",
      "off": "Off",
      "remove": "Remove override",
      "add": "Add override"
    },
    "settings": {
      "heading": "Workspace settings"
    }
  },
  "adminAction": {
    "reason": "Reason",
    "done": "Done. Recorded in the audit log.",
    "err": {
      "INVALID_STATE": "That action is not possible in the current state.",
      "INVALID_INPUT": "Check the values and give a reason of at least 3 characters.",
      "NOT_FOUND": "Not found.",
      "STAFF_PERMISSION_REQUIRED": "Your staff role does not allow this.",
      "STEP_UP_REQUIRED": "Confirm with your authentication code to continue.",
      "default": "Something went wrong. Try again."
    }
  },
  "adminChannelAdmin": {
    "heading": "Channel actions",
    "explainer": "Force-disconnect a number (credentials are revoked) or release a disconnected number so another workspace can connect it. History stays with the original workspace.",
    "search": "Search number, reference or workspace",
    "load": "Search",
    "empty": "No channels match.",
    "workspace": "Workspace",
    "number": "Number",
    "provider": "Type",
    "status": "Status",
    "disconnect": "Force disconnect",
    "release": "Release number",
    "target": "Target workspace ID (optional)"
  },
  "adminTemplateReview": {
    "status": "Status",
    "empty": "Nothing in this queue.",
    "workspace": "Workspace",
    "name": "Template",
    "category": "Category",
    "language": "Language",
    "reject": "Reject",
    "disable": "Take down",
    "reinstate": "Back to draft",
    "rejection": "Reason: {reason}",
    "statusName": {
      "pending": "Waiting at Meta",
      "approved": "Approved",
      "rejected": "Rejected",
      "paused": "Paused",
      "disabled": "Taken down",
      "draft": "Draft"
    }
  },
  "adminSettings": {
    "b29b": {
      "pickerLabel": "Search a customer by name",
      "pickerEmpty": "No customer with this name.",
      "pickerError": "Search failed. Try again.",
      "revert": "Undo this change",
      "revertAll": "Undo all",
      "reason": "Reason (shown in the audit log)",
      "save": "Save changes ({count})"
    },
    "platformHeading": "Platform settings",
    "workspaceHeading": "Workspace settings",
    "search": "Filter settings",
    "default": "Default: {value}",
    "custom": "Changed",
    "storage": "Stored in {source}",
    "permission": "Editable with: {required}",
    "readOnly": "Your role can view but not change this.",
    "reset": "Restore default",
    "saved": "Saved and recorded in the audit log.",
    "on": "On",
    "off": "Off",
    "none": "Not set",
    "listHint": "One entry per line",
    "empty": "No settings match.",
    "group": {
      "security": "Security",
      "ai": "AI",
      "channels": "Channels",
      "workspace": "Workspace",
      "alerts": "Owner alerts"
    },
    "key": {
      "admin": {
        "ip_allowlist": "Admin console IP allowlist (addresses or CIDR ranges; empty = any network)"
      },
      "ai": {
        "platform_enabled": "AI features on for the whole platform",
        "enabled": "AI features on for this workspace",
        "per_conversation_cap": "AI credits per conversation (empty = no cap)",
        "per_day_cap": "AI credits per day (empty = no cap)",
        "monthly_credit_cap": "Monthly AI credit cap (empty = no cap)"
      },
      "channels": {
        "qr_new_tenants_enabled": "New workspaces may connect WhatsApp by QR"
      },
      "workspace": {
        "timezone": "Workspace time zone",
        "enforce_2fa": "Require two-factor sign-in for every member",
        "show_all_locked": "Lock the “show all features” switch"
      },
      "owner_alerts_whatsapp_enabled": "WhatsApp alert to the owner",
      "owner_alerts_email_enabled": "Email alert to the owner",
      "owner_alerts_phone": "Owner's WhatsApp number for alerts",
      "owner_alerts_email": "Owner's email for alerts",
      "owner_alerts_repeat_threshold": "Alert when the same error repeats this many times in an hour",
      "morning_summary_enabled": "Morning summary",
      "assistant_use_real_ai": "Assistant uses real AI"
    },
    "err": {
      "INVALID_VALUE": "That value is not valid for this setting.",
      "FORBIDDEN": "Your staff role cannot change this setting.",
      "UNKNOWN_SETTING": "Unknown setting.",
      "WRONG_SCOPE": "This setting belongs to another scope.",
      "NOT_FOUND": "Workspace not found."
    }
  },
  "featureSwitches": {
    "nav": "Features",
    "title": "Features",
    "intro": "Turn a feature off in one click. It stops on the next live message and nothing is deleted. A switch can only turn a feature off; it cannot add a feature your plan does not include.",
    "readOnly": "Only owners and admins can change feature switches.",
    "pauseAll": "Pause all AI replies",
    "resumeAll": "Resume AI replies",
    "pausedBanner": "All AI replies are paused in this workspace.",
    "pausedTitle": "Pause all AI replies?",
    "pausedMessage": "Every AI Agent stops replying on the next message. Conversations go to your team. Nothing is deleted.",
    "resumeTitle": "Resume AI replies?",
    "resumeMessage": "AI Agents start replying again on the next message.",
    "offTitle": "Turn off {name}?",
    "offMessage": "This feature stops working on the next live message. No data is deleted.",
    "onTitle": "Turn on {name}?",
    "onMessage": "This feature returns to your plan default.",
    "confirmOff": "Turn off",
    "confirmOn": "Turn on",
    "stateOn": "On",
    "stateOff": "Off",
    "changedBy": "Changed by {who}, {when}",
    "unknownUser": "a team member",
    "error": "Could not change the switch. Try again.",
    "features": {
      "manager_console": {
        "name": "Manager Console",
        "desc": "Ask the assistant about your business and get reports."
      },
      "reply_style": {
        "name": "Reply style",
        "desc": "Tone and wording rules applied to AI replies."
      },
      "experiments": {
        "name": "Experiments",
        "desc": "A/B tests on AI Agent settings."
      },
      "tool_calculator": {
        "name": "Calculator tool",
        "desc": "Lets AI Agents calculate quantities and prices from your tables."
      },
      "tool_estimator": {
        "name": "Estimator tool",
        "desc": "Lets AI Agents prepare job estimates."
      },
      "tool_quote_draft": {
        "name": "Quote draft tool",
        "desc": "Lets AI Agents draft quotes for a person to approve."
      },
      "weekly_report": {
        "name": "Weekly report",
        "desc": "The weekly summary sent to the owner."
      },
      "practice_mode": {
        "name": "Practice mode",
        "desc": "Train the AI Agent with practice customer chats."
      },
      "voice": {
        "name": "Voice",
        "desc": "Understand and answer voice notes."
      },
      "handoff_waiting_message": {
        "name": "Handoff waiting message",
        "desc": "Sends the customer a waiting message after a chat is passed to the team."
      },
      "flow_performance_alerts": {
        "name": "Flow performance alerts",
        "desc": "Alerts you when a step in a published flow fails often or its button clicks drop."
      }
    }
  },
  "balanceFollowUps": {
    "nav": "Balance follow-ups",
    "title": "Balance follow-ups",
    "intro": "Every morning we create a task for each customer whose outstanding balance is older than the number of days below, with a ready-to-send message. Nothing is ever sent automatically: you open the task and send it yourself.",
    "enabled": "Create follow-up tasks",
    "days": "Days overdue before a reminder",
    "draftAr": "Draft text (Arabic)",
    "draftEn": "Draft text (English)",
    "placeholders": "Placeholders you can use:",
    "rules": "On the official WhatsApp channel outside the 24-hour window the task points to an approved template; on a QR channel it is plain text. Opted-out customers are flagged, not drafted.",
    "save": "Save",
    "saved": "Settings saved",
    "readOnly": "Only people who can adjust customer accounts can change these settings.",
    "error": "Could not save. Check the values and try again."
  },
  "restaurantStatus": {
    "nav": "Order status messages",
    "title": "Order status messages",
    "intro": "Restaurants: tell the customer on WhatsApp when the order changes status. Sent only on the official WhatsApp channel (never QR); outside the 24-hour window an approved template is used, otherwise nothing is sent.",
    "notRestaurant": "This workspace is not set up as a restaurant, so these messages are off.",
    "empty": "No rules yet. They are created automatically when the account type is set to restaurant.",
    "preparing": "Order is being prepared",
    "out_for_delivery": "Order is out for delivery",
    "delivered": "Order was delivered",
    "enabled": "On",
    "readOnly": "Only people who can edit workspace settings can change these.",
    "error": "Could not save. Try again."
  },
  "menuSettings": {
    "nav": "Restaurant menu",
    "title": "Restaurant menu",
    "intro": "The WhatsApp \"Menu\" option sends your menu on the official Cloud channel: a link button and/or an image or PDF. QR numbers never send it.",
    "notRestaurant": "This workspace is not set up as a restaurant; the menu is only used by the restaurant starter menu.",
    "readOnly": "Only people who can edit workspace settings can change these.",
    "linkTitle": "Menu link",
    "linkLabel": "Public menu link",
    "linkHint": "Must start with https:// and be on your own website or a Wato page. Leave empty for no link.",
    "save": "Save",
    "clear": "Remove link",
    "saved": "Saved.",
    "cleared": "Link removed.",
    "removed": "File removed.",
    "urlUntrusted": "This link is not on your website or a Wato host. Set your website in workspace settings first.",
    "fileTitle": "Menu image or PDF",
    "fileHint": "PNG or JPEG up to {kb} KB, or a PDF up to {mb} MB.",
    "fileCurrent": "Current file: {name} ({kb} KB)",
    "fileNone": "No file uploaded.",
    "upload": "Upload menu file",
    "remove": "Remove file",
    "invalidType": "Only PNG, JPEG or PDF files are accepted.",
    "tooLarge": "Images must be {kb} KB or smaller.",
    "pdfTooLarge": "PDF files must be {mb} MB or smaller.",
    "refreshTitle": "Apply to the installed menu",
    "refreshHint": "Menus installed earlier do not change by themselves. This rebuilds the installed restaurant menu with the link and file above. Changes you made to that menu's flow are replaced.",
    "refresh": "Refresh menu",
    "refreshDone": "Done.",
    "refreshed": "{installed, plural, =0 {No installed restaurant menu found.} one {# menu found, {changed} updated.} other {# menus found, {changed} updated.}}"
  },
  "flowControl": {
    "nav": "Turn replies on or off",
    "title": "Turn replies on or off",
    "subtitle": "Every automation flow and WhatsApp Flow in one place: switch them on or off, test them and see where customers drop off.",
    "filters": {
      "search": "Search by name or keyword",
      "kind": "Type",
      "status": "Status",
      "all": "All",
      "apply": "Search"
    },
    "kind": {
      "automation": "Automation flow",
      "meta_flow": "WhatsApp Flow"
    },
    "status": {
      "draft": "Draft",
      "published": "Live",
      "paused": "Paused",
      "deprecated": "Deprecated"
    },
    "triggerKind": {
      "keyword": "Keyword",
      "button": "Button",
      "menu": "Menu",
      "event": "Event",
      "none": "No trigger"
    },
    "tabs": {
      "flows": "All chat flows",
      "test": "Test console",
      "health": "WhatsApp Flows health",
      "responses": "Responses",
      "answers": "Collected answers"
    },
    "summary": {
      "total": "{count} flows",
      "published": "{count} live",
      "paused": "{count} paused"
    },
    "table": {
      "label": "All flows",
      "name": "Name",
      "kind": "Type",
      "status": "Status",
      "runs": "Runs (7 days)",
      "completion": "Completed",
      "actions": "Actions",
      "none": "—",
      "empty": "No flows match. Create a flow from the flows page.",
      "dropoffAt": "{node} ({count})",
      "anyChannel": "Any channel",
      "qrChannel": "QR"
    },
    "switch": {
      "label": "Run {name}",
      "on": "On",
      "off": "Off",
      "metaNote": "Managed from the Forms page"
    },
    "confirm": {
      "pauseTitle": "Pause this flow?",
      "pauseBody": "Customers will stop getting replies from “{name}” until you turn it back on.",
      "reason": "Reason (optional)",
      "pause": "Pause flow",
      "resume": "Turn on",
      "cancel": "Cancel",
      "archiveTitle": "Archive this flow?",
      "archiveBody": "“{name}” will be marked deprecated and its triggers switched off. You can restore it later.",
      "archive": "Archive",
      "rollbackTitle": "Go back to this version?",
      "rollbackBody": "Version {version} becomes the live version. Newer versions stay in the history.",
      "rollback": "Restore"
    },
    "action": {
      "duplicate": "Duplicate",
      "archive": "Archive",
      "restore": "Restore",
      "versions": "Versions",
      "trigger": "Triggers",
      "channel": "Channel",
      "open": "Open editor"
    },
    "toast": {
      "paused": "Flow paused",
      "resumed": "Flow is on",
      "duplicated": "Copy created as a draft",
      "archived": "Flow archived",
      "restored": "Flow restored",
      "rolledBack": "Previous version is live again",
      "triggerAdded": "Trigger added (switched off until you turn the flow on)",
      "triggerRemoved": "Trigger removed",
      "channelSet": "Channel updated",
      "emergencyOn": "Auto-replies paused on this channel",
      "emergencyOff": "Auto-replies resumed"
    },
    "versions": {
      "title": "Versions of {name}",
      "empty": "No published versions yet.",
      "current": "Live now",
      "version": "Version {version}",
      "published": "Published {at}"
    },
    "triggers": {
      "title": "Triggers for {name}",
      "empty": "No trigger assigned.",
      "type": "Trigger type",
      "keywords": "Keywords (comma separated)",
      "add": "Add trigger",
      "remove": "Remove",
      "off": "Off",
      "on": "On",
      "readOnly": "Button and menu triggers are managed in the flow editor.",
      "openEditor": "Editor",
      "readOnlyTag": "Read-only"
    },
    "channelDialog": {
      "title": "Channel for {name}",
      "label": "Channel",
      "hint": "Flows, buttons and lists run on the official WhatsApp API only. QR numbers are for the AI agent.",
      "save": "Save channel",
      "unset": "No channel"
    },
    "emergency": {
      "title": "Emergency switch",
      "subtitle": "Stop all automatic replies on a channel right now. People can still reply by hand.",
      "pauseAll": "Pause all",
      "resumeNow": "Resume now",
      "state": {
        "on": "Auto-replies are on",
        "paused": "Auto-replies paused"
      },
      "reason": "Reason (shown to your team)",
      "timer": "Resume automatically after",
      "timerNone": "Stay paused until I resume",
      "m30": "30 minutes",
      "h2": "2 hours",
      "h8": "8 hours",
      "h24": "24 hours",
      "resumesAt": "Resumes at {at}",
      "channel": "Channel",
      "noChannels": "No channels connected yet.",
      "confirmTitle": "Pause all auto-replies?",
      "confirmBody": "No flow, button reply or AI reply will be sent on this channel until it is resumed."
    },
    "test": {
      "title": "Test console",
      "subtitle": "Walk through a flow like a customer. Nothing is sent to anyone.",
      "noSend": "Simulation only: no message leaves Wato.",
      "pick": "Pick a flow",
      "start": "Start test",
      "reset": "Reset",
      "replies": "Replies",
      "empty": "Press Start to see the first reply.",
      "from": "from step {node}",
      "button": "Tap: {name}",
      "free": "Type a reply",
      "send": "Send reply",
      "final": "Final action",
      "done": "The flow finished.",
      "waiting": "Waiting for the customer to reply.",
      "failed": "The flow stopped: {reason}",
      "blocked": "Blocked: {reason}",
      "crmAction": "Updates the contact ({node})",
      "httpAction": "Would call a web service (not called)",
      "eventAction": "Raises an event ({node})",
      "noFlows": "No automation flows to test yet.",
      "cloudOnly": "Tests run as the official WhatsApp API channel."
    },
    "health": {
      "title": "WhatsApp Flows health",
      "subtitle": "Is each WhatsApp Flow ready to be used by customers?",
      "empty": "No WhatsApp Flows yet.",
      "status": {
        "draft": "Draft",
        "published": "Published",
        "throttled": "Throttled by Meta",
        "deprecated": "Deprecated"
      },
      "endpoint": "Data endpoint",
      "endpointOk": "Responding ({count} ms)",
      "endpointFail": "Not responding",
      "endpointNa": "Not needed (static form)",
      "approval": "Number approval",
      "name": "Display name: {value}",
      "phone": "Number: {value}",
      "quality": "Quality: {value}",
      "okay": "No problems found.",
      "issues": {
        "no_channel": "This flow is not linked to a WhatsApp number. Pick a channel in the Forms page.",
        "channel_not_cloud": "WhatsApp Flows only work on the official WhatsApp API, not on a QR number.",
        "channel_disconnected": "The linked WhatsApp number is disconnected. Reconnect it in Channels.",
        "channel_throttled": "Meta has limited this number because of its quality rating, so sending may be restricted.",
        "display_name_pending": "The business display name is still waiting for Meta approval.",
        "not_published": "This flow has not been published yet, so customers cannot open it.",
        "no_meta_flow_id": "The published version has no Meta flow id. Publish it again.",
        "endpoint_missing": "This dynamic flow has no data endpoint address.",
        "endpoint_not_https": "The data endpoint must start with https://.",
        "endpoint_unreachable": "The data endpoint did not answer the health check.",
        "no_active_key": "No encryption key is set up for this number. Create one in the Forms settings.",
        "key_not_registered": "The encryption key has not been registered with Meta yet.",
        "after_submit_flow_missing": "The flow chosen to start after submit is not published any more. Pick another flow in the form settings."
      }
    },
    "answers": {
      "title": "Collected answers",
      "subtitle": "What customers answered in your question steps: one row per conversation, one column per question.",
      "pick": "Flow",
      "from": "From",
      "to": "To",
      "contact": "Contact",
      "time": "Answered",
      "export": "Export CSV",
      "empty": "No answers collected yet.",
      "noFlows": "No flows yet."
    },
    "responses": {
      "title": "Responses",
      "subtitle": "Answers submitted through your WhatsApp Flows.",
      "pick": "WhatsApp Flow",
      "empty": "No responses yet.",
      "contact": "Contact",
      "time": "Submitted",
      "answers": "Answers",
      "export": "Export CSV",
      "masked": "Answers are hidden for your role. Ask an admin for contact access to see them.",
      "noForms": "No WhatsApp Flows yet."
    },
    "error": {
      "load": "Could not load the control center."
    },
    "bulk": {
      "selected": "{count} selected",
      "selectAll": "Select all flows",
      "selectRow": "Select {name}",
      "pause": "Pause selected",
      "resume": "Resume selected",
      "archive": "Archive selected",
      "clear": "Clear selection",
      "confirmTitle": "{count} flows",
      "confirmPause": "Pause {count} flows? Customers stop getting their auto-replies until you resume them.",
      "confirmResume": "Resume {count} flows?",
      "confirmArchive": "Archive {count} flows? They go offline and can be restored from the table.",
      "confirm": "Confirm",
      "done": "{done} done",
      "partial": "{done} done, {failed} could not be changed"
    },
    "conflicts": {
      "title": "Two live flows react to the same keyword",
      "item": "“{keyword}” — {winner} answers first; also matched by: {others}.",
      "hint": "Equal match type: the lower priority number wins, then the older trigger. Change a keyword or pause one flow to remove the overlap."
    }
  },
  "adminAssistant": {
    "title": "AI assistant",
    "conversations": "Conversations",
    "newConversation": "New conversation",
    "pinned": "Pinned",
    "unread": "Unread",
    "thread": "Conversation",
    "composerLabel": "Type your question or command",
    "placeholder": "Ask about the platform or request an action…",
    "send": "Send",
    "sending": "Thinking…",
    "empty": "Start a conversation: ask anything about the platform and I will fetch the real numbers.",
    "loadError": "Could not load the assistant.",
    "sendError": "Could not send the message.",
    "actionError": "Could not run the action.",
    "you": "You",
    "assistant": "Assistant",
    "fakeMode": "Demo mode: no real AI key is set, replies are scripted.",
    "capReached": "The assistant's daily usage cap was reached.",
    "chips": {
      "lastHour": "What happened in the last hour?",
      "scanNow": "Run a full scan now",
      "topCustomers": "Top spending customers",
      "disconnected": "Disconnected channels"
    },
    "action": {
      "proposed": "Proposed action",
      "sensitive": "Sensitive action: needs your authentication code",
      "approve": "Approve and run",
      "ignore": "Ignore",
      "status": {
        "pending": "Waiting for your approval",
        "approved": "Running",
        "executed": "Done",
        "rejected": "Ignored",
        "failed": "Failed"
      }
    },
    "tool": {
      "dlq_retry": "Retry a failed job",
      "dlq_discard": "Discard a failed job",
      "waha_restart": "Restart a WhatsApp session",
      "feature_flag_toggle": "Toggle a feature flag",
      "run_scan_now": "Run the scan now",
      "announcement_post": "Post a platform announcement",
      "workspace_suspend": "Suspend a workspace",
      "workspace_reactivate": "Reactivate a workspace"
    },
    "panel": {
      "capabilities": "What the assistant can do",
      "canRead": "Reads: overview, scan reports, logs, queues, WhatsApp fleet, channels, cost, revenue, customers, flags.",
      "canPropose": "Only proposes: retry or discard failed jobs, restart a session, toggle a flag, run a scan, post an announcement, suspend or reactivate a workspace. Nothing runs before you approve.",
      "auto": "Automatic updates",
      "morningSummary": "Morning summary (08:00 Bahrain time)",
      "weeklyReport": "Weekly report",
      "usage": "Usage today",
      "usageOf": "of",
      "tokens": "tokens",
      "remaining": "remaining"
    }
  },
  "adminOps": {
    "log": {
      "heading": "System log",
      "subtitle": "Follow platform events and filter by service, level or request.",
      "error": "Could not load the log.",
      "level": "Level",
      "service": "Service",
      "all": "All",
      "workspace": "Workspace ID",
      "requestId": "Request ID",
      "text": "Search text",
      "from": "From",
      "to": "To",
      "search": "Search",
      "liveOn": "Live: on (every 5 s)",
      "liveOff": "Live: off",
      "empty": "No log entries match.",
      "results": "Log entries",
      "sameRequest": "Same request",
      "auditLink": "Open audit log",
      "more": "Load older"
    },
    "activity": {
      "heading": "System activity",
      "subtitle": "Background job success and failures over the last hour and 24 hours.",
      "error": "Could not load the activity.",
      "h1": "Last hour",
      "h24": "Last 24 hours",
      "failed": "failed",
      "rate": "success",
      "tenants": "affected workspaces",
      "lastError": "Last error",
      "none": "none",
      "note": "Owner note",
      "saveNote": "Save note",
      "saved": "Saved",
      "job": {
        "inbound_message": "Incoming messages",
        "outbound_send": "Outgoing messages",
        "ai_reply": "AI replies",
        "avatar_fetch": "Profile photo fetch",
        "broadcast": "Bulk sends",
        "webhook_delivery": "Automatic link deliveries"
      }
    },
    "monitoring": {
      "heading": "Monitoring reports",
      "readOnly": "The monitor only reads data. It never changes anything; a person decides what to do.",
      "error": "Could not load the reports.",
      "runNow": "Run a check now",
      "empty": "No reports yet.",
      "cause": "Likely cause",
      "fix": "Suggested fix",
      "markRead": "Mark as read",
      "severity": {
        "ok": "All good",
        "info": "Note",
        "warning": "Warning",
        "critical": "Critical"
      },
      "kind": {
        "hourly": "Hourly",
        "daily": "Daily summary"
      },
      "mode": {
        "rule_based": "Rule-based check (no AI)",
        "ai": "AI-assisted"
      }
    },
    "scans": {
      "heading": "Periodic scan",
      "subtitle": "The assistant scans the whole system automatically and tells you about any problem",
      "interval": "Frequency",
      "intervals": {
        "hourly": "Every hour",
        "every_6h": "Every 6 hours",
        "daily": "Once a day",
        "off": "Off"
      },
      "runNow": "Scan now",
      "running": "Scanning…",
      "error": "Could not load scan data.",
      "cards": {
        "ok": "Healthy",
        "warning": "Warnings",
        "critical": "Critical",
        "lastRun": "Last scan",
        "nextRun": "Next scan"
      },
      "status": {
        "ok": "Everything is healthy",
        "warning": "There are warnings",
        "critical": "There are critical problems",
        "never": "The system has not been scanned yet"
      },
      "seconds": "s",
      "findings": "Findings",
      "never": "Run the first scan with «Scan now».",
      "allGood": "No problems found.",
      "fix": "Suggested fix",
      "askAssistant": "Let the assistant fix it",
      "ignore": "Ignore for 7 days",
      "groups": "Check groups",
      "passed": "passed",
      "skipped": "skipped",
      "group": {
        "services": "Servers and services",
        "database": "Database",
        "queues": "Queues",
        "channels": "WhatsApp channels",
        "ai": "AI",
        "money": "Money",
        "security": "Security",
        "backups": "Backups"
      },
      "history": "Scan history",
      "trigger": {
        "manual": "Manual",
        "schedule": "Scheduled"
      },
      "b29b": {
        "groupWorkers": "Workers",
        "linkChannels": "Open channel",
        "linkAiMonitoring": "AI monitoring",
        "linkReconciliation": "Review",
        "skippedHelp": "The service address is not set on the server"
      }
    },
    "channels": {
      "b29b": {
        "connectedOf": "{value} of {total} connected",
        "archived": "Archived ({value})",
        "col": {
          "workspace": "Workspace",
          "channel": "Channel",
          "kind": "Type",
          "status": "Status",
          "lastActivity": "Last activity"
        },
        "kind": {
          "qr": "WhatsApp QR",
          "official": "WhatsApp official",
          "instagram": "Instagram"
        },
        "reason": {
          "needs_rescan": "Needs re-scan",
          "disconnected_by_meta": "Disconnected by Meta",
          "paused": "Paused",
          "token_invalid": "Link expired",
          "webhook_silent": "No events arriving",
          "ok": "Working"
        }
      }
    },
    "b29b": {
      "paymentIssues": {
        "title": "Open payment issues",
        "empty": "No open payment issues",
        "error": "Could not load payment issues.",
        "kind": {
          "paid_but_not_recorded": "Paid, not recorded",
          "recorded_but_not_paid": "Recorded, not paid",
          "amount_mismatch": "Amount mismatch"
        }
      },
      "assistantDemo": "Demo mode",
      "danger": {
        "effects": "What will happen",
        "failed": "The action failed. Nothing was changed on our side; try again.",
        "tryTest": "🧪 Try on a test workspace",
        "target": "Target: {name} (test)",
        "realWorkspace": "This is a real customer. Type the name to confirm."
      },
      "queues": {
        "showEmpty": "Show empty queues",
        "menu": "Queue actions",
        "retryAll": "Retry all failed ({count})",
        "clean": "Clean failed ({count})",
        "effect": {
          "retryAll": "{count, plural, one {# failed job} other {# failed jobs}} in {queue} go back to waiting and run again.",
          "clean": "{count, plural, one {# failed job} other {# failed jobs}} in {queue} are deleted for good."
        },
        "done": {
          "retryAll": "{count, plural, one {# job retried} other {# jobs retried}}",
          "clean": "{count, plural, one {# job cleaned} other {# jobs cleaned}}"
        }
      },
      "maintenance": {
        "effect": {
          "platform": "Every customer sees the maintenance message until you turn it off.",
          "tenant": "This customer sees the maintenance message until you turn it off."
        }
      },
      "testFlag": {
        "mark": "🧪 Mark as test workspace",
        "unmark": "Remove test mark",
        "markHint": "{name} will no longer count in revenue, costs or the dashboard numbers.",
        "unmarkHint": "{name} will count again in revenue, costs and the dashboard numbers.",
        "save": "Save",
        "failed": "Could not save. Try again."
      },
      "errors": {
        "grouped": "Grouped",
        "rawMode": "Raw",
        "loading": "Loading…",
        "loadError": "Could not load the errors.",
        "empty": "No repeated errors in the last 24 hours.",
        "raw": "Original text",
        "seen": "First {first} · last {last}",
        "workspaces": "{count, plural, =0 {no customer affected} one {# customer} other {# customers}}",
        "why": "What's the cause?",
        "explain": {
          "database": {
            "title": "Could not reach the database",
            "why": "The app could not talk to the database (down, restarting or out of connections). Check the database server and its connections."
          },
          "storage": {
            "title": "Storage refused (403)",
            "why": "File storage refused the request: the access key or bucket permissions are wrong or expired."
          },
          "sendPermanent": {
            "title": "Permanent send failure",
            "why": "WhatsApp refused the message for good (outside the 24-hour window, blocked number or template issue). Retrying will not help."
          },
          "redis": {
            "title": "Queue server unreachable",
            "why": "The queue server (Redis) did not answer, so background jobs pile up. Check that it is running."
          },
          "metaToken": {
            "title": "Meta access expired",
            "why": "A channel's Meta access is invalid or expired. The customer has to reconnect the channel."
          },
          "timeout": {
            "title": "Timed out",
            "why": "An outside service took too long to answer. Usually temporary; if it repeats, check that service."
          },
          "rateLimit": {
            "title": "Too many requests",
            "why": "An outside service asked us to slow down. Jobs retry later on their own."
          },
          "unknown": {
            "title": "Technical error",
            "why": "No known cause for this error yet. Open the original text with «?» and share it with the developer."
          }
        }
      },
      "search": {
        "open": "Search",
        "title": "Search",
        "placeholder": "Customer, user, number…",
        "empty": "Nothing found.",
        "error": "Search failed. Try again.",
        "group": {
          "tenants": "Customers",
          "users": "Users",
          "channels": "Channels"
        }
      },
      "fixes": {
        "action": {
          "retry_all_failed": "Retry every failed job in the {queue} queue",
          "clean_failed": "Delete the failed jobs in the {queue} queue"
        },
        "button": "🛠️ Fix it",
        "title": "Fix it",
        "effect": {
          "retry_all_failed": "{count, plural, one {# failed job goes} other {# failed jobs go}} back to waiting and run again.",
          "clean_failed": "{count, plural, one {# failed job is} other {# failed jobs are}} deleted for good."
        },
        "reason": "Why (for the audit log)",
        "done": "{count, plural, one {Done: # job} other {Done: # jobs}}",
        "pick": "Choose a fix"
      },
      "audit": {
        "supportChip": "🔑 Support access"
      },
      "readiness": {
        "run": "🩺 Check readiness",
        "failed": "The check could not run. Try again.",
        "status": {
          "ok": "healthy",
          "warning": "needs a look",
          "critical": "not ready"
        },
        "card": "Last readiness check: {status} · {minutes, plural, =0 {just now} one {# minute ago} other {# minutes ago}}"
      },
      "profit": {
        "title": "Profit per client (this month)",
        "client": "Client",
        "revenue": "Subscription",
        "meta": "Meta cost",
        "ai": "AI cost",
        "profit": "Profit",
        "losing": "Losing us money",
        "unavailable": "Not available",
        "empty": "No revenue or costs this month yet.",
        "error": "Could not load the profit table."
      },
      "announcements": {
        "reach": "{count, plural, =0 {Reaches no customer} one {Reaches # customer} other {Reaches # customers}}"
      }
    }
  },
  "own91": {
    "signupMissingNamed": "Missing server settings: {keys}.",
    "signupMissingKeys": "Official WhatsApp sign-up can't start because the Meta app settings are missing or not enabled on the server. Ask the platform owner to finish the Meta sign-up setup.",
    "signupMissingKeysManual": "Official sign-up through Meta isn't set up here yet, so connect with your own details below.",
    "instagramMissingKeys": "Missing server setting: {keys}."
  },
  "own111": {
    "groups": {
      "channels": "Channels",
      "ai": "AI providers",
      "billing": "Billing",
      "integrations": "Integrations"
    }
  },
  "own108": {
    "expectedAnswer": "Expected answer (optional)",
    "group": "Set (test set name)",
    "match": "Match with expected: {score}%",
    "lowMatch": "Reply is far from the expected answer",
    "auditHint": "Who changed the assistant settings, and when",
    "bulk": {
      "importCsv": "Import CSV",
      "generate": "Generate with AI",
      "importTitle": "Import test cases from CSV",
      "importHint": "Columns: {columns}. Up to {max} rows.",
      "file": "CSV file",
      "paste": "Or paste CSV text",
      "validate": "Check file",
      "generateTitle": "Test cases drafted from your knowledge base",
      "generateHint": "Uses your saved Q&A and knowledge base. This is an AI call and is charged to your AI wallet like other AI calls. Nothing is saved until you add the cases.",
      "count": "How many cases",
      "start": "Generate",
      "working": "Working…",
      "ready": "{count} cases ready to add",
      "none": "No valid cases found",
      "rowError": "Line {row}: {reason}",
      "select": "Include this case",
      "add": "Add selected ({count})",
      "close": "Close",
      "added": "Cases added",
      "full": "The list is full ({max} cases)",
      "failed": "Could not complete this. Try again.",
      "noSources": "Add Q&A or knowledge sources first, then generate.",
      "noCredits": "Not enough AI credit. Top up your AI wallet and try again.",
      "error": {
        "missing_columns": "The first row must contain the columns {columns}",
        "too_many_rows": "Too many rows (the list holds {max} cases in total)",
        "empty_file": "The file is empty",
        "question_required": "Question is empty",
        "question_too_long": "Question is longer than 300 characters",
        "answer_too_long": "Expected answer is longer than 600 characters",
        "duplicate_question": "This question already exists"
      }
    }
  },
  "own101": {
    "nav": "My tasks",
    "subtitle": "Tasks assigned to you and the customers to contact, with bookings on the same calendar.",
    "views": {
      "list": "List",
      "day": "Day",
      "week": "Week",
      "month": "Month"
    },
    "scope": {
      "mine": "Mine",
      "all": "Everyone"
    },
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "overdue": "Overdue",
    "empty": "Nothing scheduled in this period.",
    "openChat": "Open conversation",
    "done": "Done",
    "doneAria": "Mark done: {title}",
    "noCustomer": "No customer",
    "error": "Could not load or update tasks. Try again.",
    "noTime": "No time",
    "dueLabel": "Due date and time",
    "pickDate": "Pick date and time",
    "calendarNav": "Calendar",
    "calendarTitle": "Calendar",
    "calendarSubtitle": "Tasks, reminders, bookings and scheduled broadcasts in one place.",
    "types": {
      "task": "Tasks",
      "booking": "Bookings",
      "broadcast": "Broadcasts",
      "deal": "Deal follow-ups"
    },
    "picker": {
      "open": "Open calendar",
      "invalid": "Use the format YYYY-MM-DD HH:mm.",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next week",
      "time": "Time",
      "zone": "Time zone: {zone}",
      "done": "Done"
    }
  },
  "own96": {
    "coaching": {
      "up": "Good reply",
      "down": "Bad reply",
      "rated": "Your rating was saved.",
      "suggestionCreated": "Similar questions kept getting thumbs-down, so we suggested a ready answer in Assistant guidance for you to review.",
      "advice": "Write advice",
      "adviceLabel": "Advice for the assistant (saved as a rule)",
      "adviceSave": "Save as rule",
      "adviceSaved": "Advice saved as a rule in Assistant guidance.",
      "error": "Could not complete the request."
    },
    "fromRun": {
      "action": "Turn into Q&A",
      "sectionLabel": "Section",
      "answerLabel": "Correct answer",
      "save": "Save as Q&A",
      "cancel": "Cancel",
      "saved": "Saved to ready questions and answers.",
      "error": "Could not save."
    }
  },
  "own99": {
    "button": "New chat",
    "title": "New chat",
    "intro": "Enter the customer's number to open a chat. The contact is created automatically if new.",
    "channel": "From which number?",
    "dialCode": "Country code",
    "phone": "Mobile number",
    "phonePlaceholder": "5XXXXXXXX",
    "name": "Name (optional)",
    "start": "Open chat",
    "starting": "Opening…",
    "cancel": "Cancel",
    "noChannels": "No connected WhatsApp number to start a chat. Connect one on the Channels page.",
    "errPhone": "The phone number is not valid. Check the country code and the number.",
    "errOffline": "This number is currently disconnected. Reconnect it on the Channels page.",
    "errGeneric": "Could not open the chat. Please try again.",
    "errSend": "The message could not be sent. The chat is open, so you can retry from the inbox.",
    "qrFree": "QR channel: you can write a free-text message to any number.",
    "messageLabel": "Message",
    "send": "Send",
    "openOnly": "Open only",
    "qrNotice": "This number has never messaged you. Individual messages are fine, but messaging many new numbers can get your number banned.",
    "qrCounter": "New-number chats today: {count} of {limit}",
    "qrStrong": "You went past the recommended daily limit ({count} of {limit}) for messaging new numbers. Continuing may get your number banned.",
    "qrStrongConfirm": "Send anyway",
    "cloudTemplate": "Official channel: to start a chat with a new number pick a Meta-approved template. Free text is only possible within 24 hours of the customer's reply.",
    "cloudWindowOpen": "The customer wrote within the last 24 hours, so you can reply with free text or a template.",
    "cloudOrTemplate": "Or send an approved template",
    "opened": "Chat opened"
  },
  "own102b": {
    "hours": {
      "title": "Working hours",
      "desc": "Choose when the assistant answers and what it does outside those hours."
    }
  },
  "own102": {
    "hours": {
      "modeLabel": "When does the assistant answer?",
      "mode": {
        "always": "All day, every day (24/7)",
        "daily": "Same hours every day",
        "per_day": "Different hours for each day",
        "split": "Two periods a day (split shift)"
      },
      "modeDesc": {
        "always": "Always on, no breaks.",
        "daily": "One period repeated every day.",
        "per_day": "Set hours for each day, or close it.",
        "split": "For example morning and evening with a break."
      },
      "secondPeriod": "Second period",
      "daysOff": "Weekly days off",
      "day": {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      },
      "holidays": "Holiday dates",
      "holidaysHint": "Format YYYY-MM-DD, separated by commas. Example: 2026-12-18",
      "outLabel": "Outside working hours",
      "out": {
        "reply_message": "Reply with a message",
        "ai_answers": "The assistant keeps answering",
        "handoff_next_day": "Hand off to the team next day"
      },
      "outDesc": {
        "reply_message": "Sends a message with the working hours.",
        "ai_answers": "The assistant keeps answering even after hours.",
        "handoff_next_day": "Tells the customer the team follows up next working day and hands the chat over."
      },
      "outMessage": "Out-of-hours message",
      "outMessageHint": "Leave empty to use the default message."
    },
    "info": {
      "title": "Business information",
      "refresh": "Refresh information",
      "refreshed": "Information refreshed.",
      "add": "Add information"
    }
  },
  "own105": {
    "tabs": {
      "channels": {
        "label": "Channels",
        "description": "See what the assistant and automation can do on each channel."
      }
    },
    "channels": {
      "connect": "Connect",
      "manage": "Manage",
      "state": {
        "connected": "Connected",
        "attention": "Needs attention",
        "notConnected": "Not connected",
        "soon": "Coming soon"
      },
      "whatsappCloud": {
        "name": "WhatsApp (official)",
        "note": "AI replies through buttons and lists, plus automation: auto replies and message flows."
      },
      "whatsappQr": {
        "name": "WhatsApp via QR code",
        "note": "AI assistant only, with free-text replies. Auto replies and buttons run only on the official channel."
      },
      "instagram": {
        "name": "Instagram",
        "note": "AI assistant and automation on direct messages."
      },
      "tiktok": {
        "name": "TikTok",
        "note": "AI assistant for your TikTok messages."
      }
    }
  },
  "own106": {
    "tabsLabel": "Assistant settings groups",
    "unsaved": "You have unsaved changes.",
    "tabs": {
      "setup": "Setup",
      "try": "Try it",
      "basics": "Basics",
      "knowledge": "Business info",
      "behavior": "Behavior",
      "channels": "Channels & model",
      "quality": "Quality test",
      "logs": "Log",
      "practice": "Try the assistant",
      "team": "Team",
      "info": "📚 Information"
    },
    "desc": {
      "basics": "Name the personality, language, instructions and tools of this assistant.",
      "knowledge": "Choose the sources and business information the assistant answers from.",
      "behavior": "Set how the assistant replies, what it refuses and when it hands over to a person.",
      "channels": "See where the assistant is connected and pick the AI provider and model.",
      "quality": "Check readiness, publish, and try the assistant in a test chat.",
      "logs": "Review what the assistant did in recent conversations.",
      "practice": "Chat with the assistant and turn each wrong answer into a rule in one tap.",
      "team": "Add other assistants and flows the main assistant can hand customers to."
    }
  },
  "own107sheets": {
    "live": {
      "what": "What it does: the agent reads your sheet rows and uses them to answer customer questions about price and availability. It never invents a number, and hands the chat to your team when no row matches.",
      "example": "Example: a customer asks \"How much is the AlUla trip in October?\". The agent finds the row \"AlUla trip | 2026-10-05 | 900 | 4\" and replies with the price and the seats left.",
      "connect": "How to connect in 3 steps: 1) Connect Google in Settings > Integrations > Google Sheets and share the sheet with that account. 2) Paste the sheet link here and press \"Test connection\". 3) Pick the tab and map the columns.",
      "columns": "Sheet columns: row 1 holds headers. One column for the item (such as the trip name) is required; date, price, seats or stock, and link are optional."
    },
    "lead": {
      "what": "What it does: when a customer shows real interest, the agent adds a new row to your sheet with the name, request, label and capture time. The phone number is taken from the chat.",
      "example": "Example: a customer writes \"I want to book AlUla for my family\". The agent adds a row: \"Sara | +966… | AlUla trip for a family | interested | 2026-10-17 10:30\".",
      "connect": "How to connect in 3 steps: 1) Connect Google in Settings > Integrations > Google Sheets and share the sheet with that account. 2) Paste the sheet link here (row 1 = headers) and press \"Test connection\". 3) Map each field to a column.",
      "columns": "Sheet columns: row 1 holds headers such as name, phone, request, label and captured at. Only fields you map to a column are written."
    },
    "test": "Test connection",
    "testing": "Testing…",
    "ok": "Connected successfully. Tabs found: {count}.",
    "okMapped": "Connected successfully. Headers read: {count}.",
    "missingColumn": "Connection works but the column \"{fields}\" is not in row 1 of the tab.",
    "error": {
      "GOOGLE_NOT_CONNECTED": "Google is not connected. Connect it in Settings > Integrations > Google Sheets.",
      "auth_expired": "The Google connection expired or has no access to this sheet. Reconnect and share the sheet with the connected account.",
      "missing_scope": "Google needs to be reconnected to access this. Open Settings → Integrations → Google Sheets and press Reconnect.",
      "sheet_not_found": "Sheet not found. Check the link and that it is shared with the connected Google account.",
      "INVALID_SPREADSHEET_ID": "The sheet link is not valid.",
      "rate_limited": "Google is limiting requests right now. Wait a minute and test again.",
      "failed": "Could not reach Google right now. Try again shortly.",
      "unknown": "Connection test failed. Check the link and try again."
    }
  },
  "own113": {
    "title": "TikTok",
    "description": "Let the assistant answer messages sent to your TikTok business account.",
    "limits": "Needs a TikTok business account and approval from TikTok. Customers must write first, and you can reply for 48 hours. Text and one image only.",
    "simulationBanner": "Simulation mode: no real TikTok account is used.",
    "notConfiguredTitle": "TikTok is not set up yet",
    "missingKeys": "Missing settings: {keys}",
    "connect": "Connect",
    "connected": "TikTok account connected.",
    "failed": "Could not connect TikTok.",
    "reasons": {
      "declined": "You cancelled the connection.",
      "not_business": "Only TikTok business accounts can be connected.",
      "token_failed": "TikTok did not accept the connection. Try again.",
      "not_configured": "TikTok is not set up on the server yet.",
      "already_connected": "This account is already connected.",
      "unknown": "Something went wrong. Try again."
    }
  },
  "pm01": {
    "title": "Practice",
    "intro": "Chat with the assistant like a customer would. When a reply is wrong, fix it right here and it will answer correctly next time.",
    "message": "Customer message",
    "send": "Send",
    "good": "Good",
    "wrong": "Wrong: fix it",
    "handoff": "Should hand off",
    "fixTitle": "Fix this answer",
    "question": "Question",
    "wrongReply": "Assistant reply",
    "correct": "The correct answer",
    "applyNow": "Apply now (it goes live for customers right away). Untick to send it for approval in Assistant guidance.",
    "save": "Save",
    "cancel": "Cancel",
    "replaceOld": "Replace the old answer",
    "conflict": "A saved answer for a similar question already exists. Review it, then replace it if the new answer is right.",
    "conflictList": "Saved answers for similar questions:",
    "goodSaved": "Saved as a quality-test case.",
    "handoffSaved": "Saved: questions like this will be handed to your team.",
    "fixApplied": "Saved and applied. The assistant's new reply is below. You can undo it from Assistant guidance.",
    "fixSuggested": "Saved for approval in Assistant guidance. Nothing changed for customers yet.",
    "verdict": {
      "good": "Marked good",
      "fixed": "Fixed",
      "handoff": "Marked for handoff"
    },
    "off": "Practice mode is switched off for this workspace. Turn it on in Features.",
    "rulesHint": "Every fix keeps who made it and when. See and undo them in Assistant guidance.",
    "error": "Could not complete the request."
  },
  "weeklyQuestions": {
    "b29b": {
      "linkPost": "🔗 Shared post link"
    },
    "title": "What customers asked this week",
    "subtitle": "Top questions, what your assistant could not answer, and when customers write. Personal details are removed before grouping.",
    "period": "{from} to {to}",
    "archive": "Past weeks",
    "open": "Open",
    "totalQuestions": "Customer messages",
    "conversations": "Conversations",
    "newCustomers": "New customers",
    "topQuestions": "Most asked topics",
    "count": "Asked",
    "change": "Vs last week",
    "changeNew": "New",
    "changeSame": "No change",
    "unanswered": "Not answered or handed to the team",
    "unansweredNone": "Nothing was left unanswered this week.",
    "answerIt": "Answer it",
    "handedOff": "Handed to the team",
    "busiestHours": "Busiest hours",
    "busiestDays": "Busiest days",
    "hourLabel": "{hour}:00",
    "firstResponse": "Average first response",
    "firstResponseNone": "Not enough replies to measure",
    "seconds": "{value} sec",
    "minutes": "{value} min",
    "share": "Who replied",
    "shareAi": "AI assistant",
    "shareHuman": "Team",
    "shareBot": "Automation",
    "empty": {
      "title": "No report yet",
      "body": "The first report appears after a full week with customer messages. It is created automatically on your chosen day."
    },
    "emptyWeek": "No customer messages this week.",
    "off": "The weekly report is turned off in Features.",
    "settings": {
      "title": "Delivery",
      "day": "Day",
      "hour": "Hour",
      "save": "Save",
      "saved": "Saved"
    },
    "weekdays": {
      "d0": "Sunday",
      "d1": "Monday",
      "d2": "Tuesday",
      "d3": "Wednesday",
      "d4": "Thursday",
      "d5": "Friday",
      "d6": "Saturday"
    }
  },
  "styleExperiment": {
    "title": "Reply style experiment",
    "intro": "Compare two reply styles on real conversations. Each conversation keeps the same style for its whole life. Only the style changes; knowledge, prices and rules stay identical. It runs on QR conversations of the AI Agent only.",
    "readOnly": "Only owners and admins can change experiments.",
    "create": "Create experiment",
    "name": "Experiment name",
    "goal": "Goal metric",
    "styleB": "Style B (style A is the current one)",
    "split": "Split: {a}% style A / {b}% style B",
    "minSample": "Minimum conversations per style",
    "start": "Start experiment",
    "empty": "No experiments yet.",
    "variantA": "Style A",
    "variantB": "Style B",
    "threshold": "A winner needs the minimum sample and a two-proportion test below 5% (95% confidence).",
    "stop": "Stop",
    "stopTitle": "Stop this experiment?",
    "stopMessage": "Every conversation returns to style A. Results are kept.",
    "stopped": "Experiment stopped",
    "makeWinner": "Make winner the default",
    "winnerTitle": "Apply the winning style?",
    "winnerMessage": "The winning style becomes the agent's reply style and the experiment ends. This is recorded in the audit log.",
    "winnerApplied": "Winning style applied",
    "extend": "Extend",
    "extended": "Experiment extended",
    "created": "Experiment started",
    "status": {
      "running": "Running",
      "stopped": "Stopped",
      "completed": "Completed"
    },
    "goals": {
      "reply": "Customer replied",
      "booking": "Booking created",
      "payment": "Payment link paid",
      "fewer_handoffs": "Fewer handoffs"
    },
    "metrics": {
      "conversations": "Conversations",
      "replyRate": "Reply rate",
      "conversionRate": "Conversion rate",
      "handoffRate": "Handoff rate",
      "avgLength": "Average reply length (characters)"
    },
    "verdict": {
      "notEnough": "Not enough data yet (at least {n} conversations per style).",
      "none": "No clear difference between the styles.",
      "bBetter": "Style B is better, {pct}% confident.",
      "aBetter": "Style A is better, {pct}% confident."
    },
    "fields": {
      "emoji": "Emojis",
      "format": "Format",
      "greeting": "Greeting",
      "closing": "Closing",
      "length": "Length"
    },
    "values": {
      "emoji": {
        "none": "None",
        "few": "Few",
        "many": "Many"
      },
      "format": {
        "short_lines": "Short lines",
        "list": "List",
        "paragraph": "Paragraph"
      },
      "greeting": {
        "none": "None",
        "short": "Short",
        "warm": "Warm"
      },
      "closing": {
        "none": "None",
        "question": "Question",
        "thanks": "Thank you"
      },
      "length": {
        "brief": "Brief",
        "normal": "Normal",
        "detailed": "Detailed"
      }
    }
  },
  "adminCommand": {
    "search": {
      "label": "Search tenants",
      "placeholder": "Search a tenant by name or slug…",
      "go": "Search"
    },
    "refresh": "Refresh",
    "loading": "Loading the dashboard…",
    "error": "Could not load the dashboard.",
    "retry": "Try again",
    "partial": "Some data is unavailable right now: {value}",
    "status": {
      "heading": "System status",
      "ok": "All systems healthy",
      "warning": "Warnings found",
      "critical": "Critical problems found",
      "never": "No scan has run yet",
      "unknown": "Status unknown",
      "lastRun": "Last check: {value}",
      "details": "Open scans"
    },
    "kpi": {
      "workspaces": "Active workspaces",
      "workspacesNew": "+{count} in 7 days",
      "messages": "Messages (24 h)",
      "messagesFailed": "{count} failed sends",
      "conversations": "Open conversations",
      "conversationsWaiting": "{count} waiting for a human",
      "revenue": "Monthly recurring revenue",
      "revenueEmpty": "No paying subscriptions",
      "aiCost": "AI cost today",
      "aiCostCap": "of {value} cap",
      "aiCostEmpty": "No AI cost today",
      "channels": "Channels connected",
      "channelsOf": "of {total}",
      "channelsDown": "{count} disconnected"
    },
    "traffic": {
      "heading": "Messages, last 24 hours",
      "official": "Official API",
      "qr": "QR",
      "empty": "No messages in the last 24 hours."
    },
    "attention": {
      "heading": "Needs your attention",
      "empty": "Nothing needs attention right now.",
      "fix": "Open",
      "qr_disconnected": "{count} WhatsApp QR channels are disconnected",
      "queues_delayed": "{count} queues have waiting jobs and no worker",
      "dlq": "{count} failed jobs in the dead-letter queue",
      "token_failing": "{count} channel tokens are expiring or invalid",
      "templates_pending": "{count} templates waiting for Meta review over 24 h"
    },
    "services": {
      "heading": "Services",
      "latency": "{value} ms",
      "api": "API",
      "workers": "Workers and queues",
      "db": "Database",
      "qr-gateway": "QR gateway",
      "meta-webhooks": "Meta webhooks",
      "ai-provider": "AI provider",
      "email": "Email",
      "backups": "Backups",
      "state": {
        "ok": "Healthy",
        "degraded": "Degraded",
        "down": "Down",
        "unknown": "No signal"
      }
    },
    "activity": {
      "heading": "Live activity",
      "empty": "No recent events.",
      "all": "All events"
    },
    "b29b": {
      "deltaUp": "↑ {pct}% vs last week",
      "deltaDown": "↓ {pct}% vs last week",
      "withoutTests": "without test workspaces",
      "tenantHealth": "{name} — health {score}/100"
    }
  },
  "siteForms": {
    "nav": "Website forms",
    "title": "Website forms → WhatsApp",
    "subtitle": "Turn a form on your own website into a WhatsApp conversation. Visitors who agree to WhatsApp messages get your approved template or chat flow.",
    "forbidden": "You don't have access to website forms.",
    "picker": "Form connection",
    "new": "New form connection",
    "saved": "Form connection saved",
    "name": "Connection name",
    "enabled": "Accept submissions",
    "fieldsHint": "Type the field names used in your website form. Only the phone is required.",
    "field": {
      "phone": "Phone field name",
      "name": "Name field name (optional)",
      "email": "Email field name (optional)",
      "optIn": "Opt-in checkbox field name"
    },
    "channel": "WhatsApp Cloud channel",
    "choose": "Choose…",
    "modeLabel": "When someone submits",
    "mode": {
      "template": "Send an approved template",
      "flow": "Start a chat flow"
    },
    "template": "Approved template",
    "variables": "Template variables",
    "variablesHint": "One per line: 1=field:full_name, 2=contact.name or 2=text:Hello",
    "flow": "Chat flow to start",
    "label": "Label to add",
    "noLabel": "No label",
    "requireOptIn": "Require the opt-in checkbox",
    "optInNote": "We never message someone who hasn't agreed. Without the ticked checkbox the contact is saved as a lead only.",
    "origins": "Allowed website origins",
    "originsHint": "One per line, e.g. https://www.example.com. Submissions from other sites are refused.",
    "originsInvalid": "Invalid origin:",
    "rateLimit": "Max submissions per minute (per visitor)",
    "save": "Save",
    "delete": "Delete connection",
    "snippet": "Copy-paste snippet",
    "snippetHint": "Paste this into your website page. Keep the hidden field - it blocks spam.",
    "submissions": "Recent submissions",
    "noSubmissions": "No submissions yet.",
    "col": {
      "when": "When",
      "phone": "Phone",
      "status": "Status"
    },
    "status": {
      "queued": "Queued to send",
      "sent": "Message sent",
      "flow_started": "Chat flow started",
      "saved_no_opt_in": "Saved, not messaged",
      "failed": "Failed"
    },
    "reason": {
      "no_opt_in": "no opt-in",
      "opted_out": "opted out",
      "invalid_phone": "invalid phone",
      "channel_unavailable": "channel unavailable",
      "template_not_approved": "template not approved"
    },
    "b29b": {
      "extraTitle": "Extra customer details",
      "formField": "Field name in your form",
      "customerField": "Customer field",
      "addField": "＋ Add field",
      "removeField": "Remove field"
    }
  },
  "prospector": {
    "nav": "Prospects",
    "banner": "This is an experimental feature. A message is only sent after a person approves it, and the kill switch stops all sending.",
    "tabs": {
      "targets": "Search targets",
      "leads": "Leads",
      "campaigns": "Campaigns",
      "messages": "Message review",
      "sources": "Sources"
    },
    "killSwitch": {
      "stop": "Stop sending",
      "confirmTitle": "Stop all sending?",
      "confirmBody": "No message from Prospects will be sent until you resume sending.",
      "confirm": "Yes, stop",
      "activeTitle": "Sending is stopped",
      "activeSince": "Stopped at {date}",
      "activeBody": "No messages from Prospects are being sent right now.",
      "resume": "Resume sending",
      "turnedOn": "Sending stopped",
      "turnedOff": "Sending resumed"
    },
    "targets": {
      "title": "Search targets",
      "subtitle": "Choose what to look for and where, then run the search to find leads.",
      "create": "New target",
      "edit": "Edit",
      "delete": "Delete",
      "keep": "Keep",
      "empty": "No targets yet. Create one to get started.",
      "saved": "Target saved",
      "deleted": "Target deleted",
      "deleteTitle": "Delete “{name}”?",
      "deleteBody": "This target will disappear from the list and can no longer be run.",
      "listSeparator": ", ",
      "columns": {
        "name": "Name",
        "query": "Search term",
        "city": "City",
        "country": "Country",
        "sources": "Sources",
        "maxResults": "Max results",
        "status": "Status",
        "runs": "Latest run",
        "actions": "Actions"
      },
      "status": {
        "draft": "Draft",
        "active": "Active",
        "paused": "Paused",
        "archived": "Archived"
      },
      "form": {
        "createTitle": "New search target",
        "editTitle": "Edit search target",
        "save": "Save",
        "query": "Search term",
        "queryHint": "For example: restaurants, salons, flower shops",
        "queryError": "Enter a search term of 2 to 200 characters",
        "name": "Name (optional)",
        "city": "City (optional)",
        "country": "Country",
        "sources": "Sources",
        "sourcesError": "Choose at least one source",
        "maxResults": "Max results (optional)",
        "maxResultsHint": "Leave empty to use the default limit. Maximum 500",
        "maxResultsError": "Enter a whole number from 1 to 500",
        "status": "Status"
      }
    },
    "countries": {
      "SA": "Saudi Arabia",
      "BH": "Bahrain"
    },
    "sources": {
      "google_maps": "Google Maps",
      "instagram": "Instagram",
      "google_places": "Google Places",
      "import": "Excel / CSV upload",
      "tiktok": "TikTok",
      "directory": "Business directories"
    },
    "runs": {
      "run": "Run search",
      "capped": "Monthly limit reached",
      "failed": "The search could not finish for one of the sources. Please try again later.",
      "found": "Found {count}",
      "new": "New {count}",
      "status": {
        "queued": "Queued",
        "running": "Running",
        "succeeded": "Done",
        "failed": "Failed",
        "capped": "Limit reached"
      }
    },
    "spend": {
      "line": "This month's spend: {spent} of {cap}"
    },
    "errors": {
      "INVALID_INPUT": "Some details are not valid. Check the fields and try again.",
      "TARGET_NOT_FOUND": "We could not find this target. It may have been deleted.",
      "TARGET_NOT_ACTIVE": "This target is not active. Activate it first, then run the search.",
      "LEAD_STATUS_LOCKED": "This lead's status cannot be changed right now.",
      "LEAD_NOT_FOUND": "We could not find this lead. It may have been deleted.",
      "CAMPAIGN_NOT_FOUND": "We could not find this campaign. It may have been deleted.",
      "MESSAGE_NOT_FOUND": "We could not find this message. It may have been deleted.",
      "CAMPAIGN_ARCHIVED": "This campaign is archived and can no longer be edited.",
      "INVALID_TRANSITION": "This message's status cannot be changed right now.",
      "LEAD_NOT_ELIGIBLE": "This lead is not eligible for this campaign.",
      "PRICE_IN_TEMPLATE": "The message text mentions a price or discount. Remove it, or ask a manager to approve the price.",
      "WORKSPACE_FORBIDDEN": "You don't have permission to do this."
    },
    "leads": {
      "title": "Leads",
      "subtitle": "The results the search found, ordered by fit score. Review and sort them.",
      "columns": {
        "name": "Name",
        "sources": "Sources",
        "phone": "Phone",
        "website": "Website",
        "score": "Score",
        "reasons": "Score reasons",
        "status": "Status",
        "actions": "Actions"
      },
      "filters": {
        "status": "Status",
        "statusAll": "All statuses",
        "minScore": "Minimum score",
        "minScoreHint": "Enter a number from 0 to 100",
        "minScoreError": "That number is not valid, so this filter is ignored. Enter a number from 0 to 100.",
        "source": "Source",
        "sourceAll": "All sources"
      },
      "empty": "No leads yet. Run a search from the search targets page.",
      "emptyFiltered": "No leads match the current filters.",
      "loadMore": "Load more",
      "loadMoreError": "Could not load more. Please try again.",
      "details": "Details",
      "loading": "Loading details…",
      "doNotContact": "Do not contact",
      "separator": ", ",
      "panel": {
        "category": "Category",
        "address": "Address",
        "city": "City",
        "country": "Country",
        "rating": "Rating",
        "score": "Score",
        "reasons": "Score reasons",
        "noReasons": "No reasons recorded.",
        "reasonPoints": "{reason}: {points} points",
        "status": "Status",
        "identities": "Contact details",
        "noIdentities": "No contact details.",
        "provenance": "Where the data came from",
        "noProvenance": "No source recorded.",
        "externalId": "ID at the source",
        "fetchedAt": "Fetched on",
        "openLink": "Open link",
        "openLinkFor": "Open link: {source}"
      },
      "identityKinds": {
        "phone": "Phone",
        "email": "Email",
        "website": "Website",
        "instagram": "Instagram",
        "tiktok": "TikTok",
        "place_id": "Place ID"
      },
      "actions": {
        "setStatus": "Change status",
        "markNew": "New",
        "markQualified": "Qualified",
        "markRejected": "Rejected",
        "lockedHint": "The status can no longer be changed once this lead has been contacted.",
        "statusUpdated": "Status updated",
        "forLead": "{action}: {name}"
      },
      "suppress": "Do not contact",
      "suppressTitle": "Add “{name}” to the do-not-contact list?",
      "suppressBody": "These details will never be contacted again, and every lead that carries them is affected.",
      "suppressIdentity": "Details to add",
      "suppressNoIdentity": "This lead has no contact details that can be added.",
      "suppressAlready": "This lead is already on the do-not-contact list.",
      "suppressDone": "Added to the do-not-contact list. Leads affected: {count}",
      "close": "Close"
    },
    "status": {
      "new": "New",
      "qualified": "Qualified",
      "rejected": "Rejected",
      "contacted": "Contacted",
      "replied": "Replied",
      "promoted": "Promoted",
      "lost": "Lost",
      "interested": "Interested",
      "not_interested": "Not interested",
      "handed_off": "Handed to team"
    },
    "reasons": {
      "category_match": "Category matches the search",
      "has_phone": "Has a phone number",
      "has_website": "Has a website",
      "rating": "Good rating"
    },
    "campaigns": {
      "title": "Campaigns",
      "subtitle": "A campaign is a message template with name and city variables, sent to qualified leads. Every drafted message needs a person's approval before it is sent.",
      "create": "New campaign",
      "empty": "No campaigns yet. Create one to get started.",
      "saved": "Campaign saved",
      "archived": "Campaign archived",
      "addLeads": "Add leads",
      "pause": "Pause",
      "resume": "Resume",
      "archive": "Archive",
      "archiveTitle": "Archive “{name}”?",
      "archiveBody": "Every message in this campaign that has not been sent yet will be rejected.",
      "actionFor": "{action}: {name}",
      "columns": {
        "name": "Name",
        "target": "Target",
        "status": "Status",
        "leads": "Leads",
        "approved": "Approved",
        "sent": "Sent",
        "replied": "Replied",
        "optedOut": "Opted out",
        "actions": "Actions"
      },
      "status": {
        "active": "Active",
        "paused": "Paused",
        "archived": "Archived"
      },
      "form": {
        "createTitle": "New campaign",
        "editTitle": "Edit campaign",
        "save": "Save",
        "name": "Campaign name",
        "nameError": "Enter a name for the campaign",
        "target": "Target",
        "targetPlaceholder": "Choose a target",
        "targetError": "Choose a target for the campaign",
        "targetArchived": "Archived target",
        "template": "Message template",
        "templateHint": "Write the message text and use the name or city to fill it in for each lead. Every message drafted from this text needs a person's approval before it is sent.",
        "templateError": "Write the message text",
        "templateUnknownVariable": "The variable {variable} is not supported. Only name and city are available.",
        "variables": "Variables",
        "variable": {
          "name": "Name",
          "city": "City"
        },
        "insertVariable": "Insert the {variable} variable",
        "channel": "Sending channel",
        "channelHint": "Messages are sent only from this official WhatsApp channel.",
        "channelNone": "No channel",
        "priceApproved": "This template has an approved price",
        "priceApprovedHint": "Only managers can approve a price. Otherwise, any message with a price or discount in the text is refused.",
        "approvalClears": "Editing the text removes the price approval.",
        "status": "Status",
        "sendMode": "Sending method",
        "sendModeQr": "WhatsApp QR (with protection)",
        "sendModeOfficial": "Official number (templates)",
        "protectionsTitle": "Fixed protections",
        "protection": {
          "cap": "At most 30 messages a day",
          "gap": "At least 90 seconds between messages",
          "hours": "Only between 09:00 and 21:00",
          "optOut": "Every message ends with an opt-out line",
          "approval": "A person approves every message"
        },
        "dailyCap": "Daily limit",
        "dailyCapHint": "From 1 to 30 messages a day.",
        "templateRequired": "Choose an approved template",
        "approvedTemplate": "Approved template",
        "templateNone": "Choose a template",
        "templateEmpty": "This channel has no approved templates yet.",
        "templateChannelFirst": "Choose an official channel first.",
        "templateVars": "Fill the template variables",
        "templateVarLead": "Variable {variable}",
        "agent": "AI agent (optional)",
        "agentNone": "No AI agent",
        "agentHint": "Answers leads who reply to this campaign.",
        "agentCreate": "Create a prospector agent"
      }
    },
    "addLeads": {
      "title": "Add leads to “{name}”",
      "description": "Choose the qualified leads you want to add. Nothing is sent until you approve each message.",
      "caption": "Qualified leads",
      "empty": "No qualified leads to add. Run a search or review your leads.",
      "selectAll": "Select all",
      "selectLead": "Select {name}",
      "submit": "Add ({count})",
      "done": "Done",
      "summary": "Leads added: {added}. Skipped: {skipped}.",
      "skippedTitle": "Why leads were skipped",
      "skippedSeparator": ": "
    },
    "messages": {
      "title": "Message review",
      "subtitle": "Every message drafted for a lead waits for your approval here. No message is sent before you approve it.",
      "empty": "No messages to review yet. Messages appear here after you add leads to a campaign.",
      "emptyFiltered": "No messages match the current filters.",
      "selected": "Selected: {count}",
      "selectAll": "Select all",
      "selectMessage": "Select message for {name}",
      "approve": "Approve",
      "reject": "Reject",
      "approveFor": "Approve the message for {name}",
      "rejectFor": "Reject the message for {name}",
      "approved": "Message approved",
      "rejected": "Message rejected",
      "bulkApprove": "Approve",
      "bulkReject": "Reject selected",
      "bulkApproved": "Approved: {updated}. Skipped: {skipped}.",
      "bulkRejected": "Rejected: {updated}. Skipped: {skipped}.",
      "skippedReason": "{reason}: {count}",
      "campaignUnknown": "Archived campaign",
      "filters": {
        "campaign": "Campaign",
        "campaignAll": "All campaigns",
        "status": "Status",
        "statusAll": "All statuses"
      },
      "columns": {
        "lead": "Lead",
        "campaign": "Campaign",
        "body": "Message text",
        "status": "Status",
        "actions": "Actions"
      },
      "status": {
        "draft": "Draft",
        "pending_approval": "Awaiting approval",
        "approved": "Approved",
        "rejected": "Rejected",
        "queued": "Queued to send",
        "sent": "Sent",
        "delivered": "Delivered",
        "failed": "Failed to send",
        "blocked": "Held back"
      },
      "skipReasons": {
        "not_found": "Message not found",
        "invalid_transition": "This message's status cannot be changed right now",
        "campaign_archived": "The campaign is archived",
        "price_in_message": "The message mentions a price or discount",
        "unknown": "Skipped for an unknown reason"
      }
    },
    "blockReasons": {
      "suppressed": "This lead is on the do-not-contact list, so no message will be sent to them.",
      "do_not_contact": "This lead asked not to be contacted, so no message will be sent to them.",
      "opt_out": "This lead opted out of messages, so no message will be sent to them.",
      "kill_switch_workspace": "Sending is stopped for your workspace, so the message was not sent.",
      "kill_switch_platform": "The platform has paused sending for now, so the message was not sent.",
      "flag_off": "This feature is not turned on for your workspace yet, so the message was not sent.",
      "quiet_hours": "It is outside the allowed sending hours right now. We will try again later.",
      "lead_replied": "This lead has already replied, so they do not need a first message.",
      "lead_not_eligible": "This lead is no longer eligible for this campaign.",
      "first_touch_exists": "This lead already received a first message, so no other first message will be sent.",
      "daily_cap": "The daily sending limit has been reached, so the message was not sent.",
      "throttle": "The allowed sending rate was exceeded, so the message was not sent right now.",
      "campaign_inactive": "The campaign is not active, so the message was not sent.",
      "campaign_paused": "The campaign is paused, so the message was not sent.",
      "campaign_archived": "The campaign is archived, so the message was not sent.",
      "not_approved": "This message has not been approved yet, and it will not be sent until a person approves it.",
      "no_channel": "No official WhatsApp channel is linked to this campaign.",
      "no_phone": "This lead has no phone number.",
      "price_in_message": "The message mentions a price or discount that was not approved, so it was not sent.",
      "send_mode_mismatch": "The campaign's sending method does not match its WhatsApp channel, so the message was not sent.",
      "template_not_approved": "The approved WhatsApp template for this campaign is not available, so the message was not sent.",
      "link_in_first_message": "A first message to a new lead cannot contain a link on a WhatsApp QR channel.",
      "channel_busy": "Another message is being sent on this channel. We will try again in a moment.",
      "not_on_whatsapp": "This number is not on WhatsApp, so the message was not sent.",
      "auto_paused_failures": "The campaign was paused automatically after 3 failed sends in a row. Check the channel, then resume.",
      "provider_error": "The message could not be sent through WhatsApp. Please try again later.",
      "unknown": "The message was not sent for an unknown reason. Review the campaign or contact support."
    },
    "skipReasons": {
      "not_found": "Lead not found",
      "suppressed": "Lead is on the do-not-contact list",
      "not_qualified": "Lead is not qualified yet",
      "no_phone": "No phone number",
      "already_added": "Already added to this campaign",
      "already_contacted": "Already contacted",
      "empty_message": "The message text is empty",
      "price_in_message": "The message mentions a price or discount",
      "unknown": "Skipped for an unknown reason"
    },
    "import": {
      "button": "Upload Excel / CSV",
      "title": "Upload leads from a file",
      "hint": "Choose a .csv or .xlsx file. The first row must hold the column names.",
      "file": "File",
      "fileError": "Could not read this file. Use a valid .csv or .xlsx file.",
      "noRows": "The file has no rows to import.",
      "mapping": "Match the columns",
      "columnNone": "Not in the file",
      "field": {
        "name": "Name",
        "phone": "Phone",
        "city": "City",
        "category": "Category",
        "website": "Website",
        "instagram": "Instagram"
      },
      "nameRequired": "Choose the column that holds the name.",
      "preview": "Preview of the first 5 rows",
      "rowsCount": "Rows in the file: {count}",
      "submit": "Import ({count})",
      "done": "Done",
      "result": {
        "created": "New leads: {count}",
        "merged": "Merged with existing leads: {count}",
        "suppressed": "On the do-not-contact list: {count}",
        "skipped": "Skipped: {count}",
        "invalid": "Invalid rows: {count}"
      }
    }
  },
  "catalogHub": {
    "field": {
      "category": "Category"
    },
    "categories": {
      "none": "Uncategorised"
    }
  },
  "integrationsHub": {
    "b29b": {
      "scope": {
        "contacts_read": "Read customers",
        "contacts_write": "Manage customers",
        "conversations_read": "Read conversations",
        "conversations_write": "Manage conversations",
        "messages_read": "Read messages",
        "messages_write": "Manage messages",
        "crm_read": "Read deals and follow-up",
        "crm_write": "Manage deals and follow-up",
        "commerce_read": "Read orders",
        "commerce_write": "Manage orders",
        "catalog_read": "Read products",
        "catalog_write": "Manage products",
        "templates_read": "Read templates",
        "templates_write": "Manage templates",
        "broadcasts_read": "Read broadcasts",
        "broadcasts_write": "Manage broadcasts",
        "forms_read": "Read forms",
        "forms_write": "Manage forms",
        "webhooks_read": "Read webhooks",
        "webhooks_write": "Manage webhooks",
        "otp_read": "Read verification codes",
        "otp_write": "Manage verification codes"
      }
    },
    "nav": "Connections hub",
    "title": "Integrations",
    "subtitle": "Connect Google, n8n and webhooks, then use them as steps in your flows.",
    "status": {
      "connected": "Connected",
      "disconnected": "Not connected",
      "error": "Needs attention",
      "needs_admin_setup": "Needs admin setup"
    },
    "adminSetup": "This connection is not enabled on this server yet. Ask the platform administrator to finish the setup.",
    "connect": "Connect",
    "reconnect": "Reconnect",
    "google": {
      "title": "Google (Sheets and Docs)",
      "desc": "Add rows, look up rows and write documents from your flows.",
      "sheets": "Google Sheets",
      "docs": "Google Docs",
      "manageSheets": "Sheets settings",
      "manageDocs": "Document templates"
    },
    "n8n": {
      "title": "n8n",
      "desc": "Run your own automations. Save your n8n address and key to import ready-made workflows.",
      "url": "n8n address",
      "key": "API key",
      "keyHint": "The key is stored encrypted and is never shown again.",
      "save": "Save",
      "remove": "Remove",
      "saved": "n8n details saved",
      "templates": "Ready-made workflows",
      "urlBlocked": "This address is not allowed. Use the public https address of your n8n instance."
    },
    "webhooks": {
      "title": "Webhooks and HTTP",
      "desc": "Send events to other services and call any API from a flow step.",
      "manage": "Manage webhooks"
    },
    "nodeHint": "This step needs a connected Google account.",
    "openHub": "Open Integrations"
  },
  "integrations": {
    "b29google": {
      "connected": "✅ Connected",
      "denied": "⚠ Not connected — permissions were not approved",
      "error": "⚠ Not connected — the session expired or something failed",
      "retry": "🔁 Try again",
      "rootFlag": "⚠ Google was not connected — try again from Settings"
    }
  },
  "calendar": {
    "b29": {
      "openDeal": "Open deals"
    },
    "b29b": {
      "more": "+{count} more",
      "filter": "Filter",
      "add": "Add",
      "addOnDay": "Add on this day",
      "addTask": "➕ Task",
      "addBooking": "➕ Booking",
      "newTask": "New task",
      "taskTitle": "Task title",
      "save": "Save",
      "moveTitle": "Move booking",
      "moveBooking": "The customer will get a notice of the new time. Confirm?",
      "moveConfirm": "Confirm"
    }
  },
  "media": {
    "nav": "Gallery",
    "title": "Gallery",
    "subtitle": "Images and files for your messages and flows",
    "help": "Upload your images and files once, then pick them from any flow or button. The link stays the same even if you replace the file. Limits: image 5 MB, MP4 video and audio 16 MB, PDF 100 MB. Deleted files stay in the trash for 30 days.",
    "upload": "Upload",
    "uploading": "Uploading…",
    "search": "Search",
    "kindFilter": "File type",
    "kinds": {
      "all": "All",
      "image": "Images",
      "document": "PDF",
      "video": "Video",
      "audio": "Audio"
    },
    "sort": {
      "label": "Sort",
      "newest": "Newest",
      "largest": "Largest"
    },
    "folder": {
      "label": "Folder",
      "all": "All folders",
      "placeholder": "Folder"
    },
    "trash": "Trash",
    "trashed": "Deleted",
    "emptyTrash": "Trash is empty",
    "empty": {
      "hint": "No files yet. Drag files here or upload them (menu, PDF catalog, offer image).",
      "cta": "Upload your first file"
    },
    "storage": "{used} used of {limit}",
    "dismiss": "Close",
    "name": "Name",
    "usedIn": "Used in",
    "unused": "Not used anywhere",
    "usage": {
      "flow": "Flow",
      "broadcast": "Broadcast",
      "template": "Template"
    },
    "copyLink": "Copy link",
    "copied": "Link copied",
    "download": "Download",
    "replace": "Replace",
    "replaced": "File replaced",
    "delete": "Delete",
    "deleted": "Moved to trash",
    "deleteTitle": "Delete this file?",
    "deleteMessage": "\"{name}\" will move to the trash for 30 days.",
    "deleteInUse": "This file is used in {count} places. If you delete it, it will stop showing there. Delete anyway?",
    "restore": "Restore",
    "restored": "Restored",
    "move": "Move",
    "moved": "Moved",
    "pick": {
      "title": "Pick from the gallery",
      "button": "From gallery"
    },
    "errors": {
      "invalidType": "This file type is not supported",
      "tooLarge": "The file is larger than the allowed limit",
      "quota": "Storage is full. Delete files or upgrade your plan"
    }
  }
}
